
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("djmKw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $23c487fbdabb1bfd$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");

/* RendererComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $3yh4a = parcelRequire("3yh4a");


var $9wGTI = parcelRequire("9wGTI");


var $dOBRD = parcelRequire("dOBRD");





var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $1i7uI = parcelRequire("1i7uI");


var $itU2t = parcelRequire("itU2t");


var $One0S = parcelRequire("One0S");


var $b6fxF = parcelRequire("b6fxF");


var $eNbr2 = parcelRequire("eNbr2");


var $kwzZh = parcelRequire("kwzZh");


var $9jb19 = parcelRequire("9jb19");


var $6t2Zs = parcelRequire("6t2Zs");


var $4o0zT = parcelRequire("4o0zT");


var $lTECB = parcelRequire("lTECB");


var $i6Ps3 = parcelRequire("i6Ps3");


var $fgQGl = parcelRequire("fgQGl");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $kLzei = parcelRequire("kLzei");


var $6M71K = parcelRequire("6M71K");


var $6GQtz = parcelRequire("6GQtz");


var $04e9M = parcelRequire("04e9M");


var $lmNXu = parcelRequire("lmNXu");


var $edEsl = parcelRequire("edEsl");


var $fyKZ5 = parcelRequire("fyKZ5");


var $1a6Dn = parcelRequire("1a6Dn");


var $beAFO = parcelRequire("beAFO");


var $jmjWc = parcelRequire("jmjWc");


var $kBU5m = parcelRequire("kBU5m");


var $3WO8q = parcelRequire("3WO8q");

var $eXfot = parcelRequire("eXfot");

var $gxhb8 = parcelRequire("gxhb8");


var $9UKrO = parcelRequire("9UKrO");


var $bumSD = parcelRequire("bumSD");


var $dtVue = parcelRequire("dtVue");


var $c4QoG = parcelRequire("c4QoG");


var $4IoVL = parcelRequire("4IoVL");


var $32x2E = parcelRequire("32x2E");


var $lqVBP = parcelRequire("lqVBP");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");





var $ge2sX = parcelRequire("ge2sX");


var $lEf66 = parcelRequire("lEf66");

/**
 * @generated SignedSource<<b5a4dd941d120420d75e69b29ad22e08>>
 * @relayHash 06bc7ae3e2e497941f8d1738171f8bb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5ef6663bccf7015c3707545cb7bee1684c03826006312c2775240be1421634d
const $0878b4ab72f17c58$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "GlobalOperationsUserPermissionTypeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "GlobalOperationsUserPermissionTypeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "06bc7ae3e2e497941f8d1738171f8bb4",
            "id": "f5ef6663bccf7015c3707545cb7bee1684c03826006312c2775240be1421634d",
            "metadata": {},
            "name": "GlobalOperationsUserPermissionTypeQuery",
            "operationKind": "query",
            "text": "query GlobalOperationsUserPermissionTypeQuery{user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$0878b4ab72f17c58$var$node.hash = "b07108af76c48e11bbcd733ba0612fcf";
var $0878b4ab72f17c58$export$2e2bcd8739ae039 = $0878b4ab72f17c58$var$node;


var $5OVTZ = parcelRequire("5OVTZ");


var $c0rhi = parcelRequire("c0rhi");

const $2d2df6655155416b$export$60b2889c65284218 = async ()=>{
    await (0, $ge2sX.getSessionData)();
    // External Collaborators should not have access to view user profile
    const { data: userPermissionData } = await (0, $c0rhi.queryInterop)({
        query: (0, $0878b4ab72f17c58$export$2e2bcd8739ae039),
        errorPolicy: 'all',
        __callerPackage__: "global-operations"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return new Error('PERMISSION ERROR');
    });
    const isExternalCollaborator = (0, $lEf66.getUserPermissionFromQuery)(userPermissionData) === (0, $5OVTZ.SitePermissionType).EXTERNAL;
    return !isExternalCollaborator;
};



var $habRv = parcelRequire("habRv");


var $5dnlf = parcelRequire("5dnlf");


var $jlIaF = parcelRequire("jlIaF");


var $4qzKl = parcelRequire("4qzKl");


var $gXsSh = parcelRequire("gXsSh");


var $3Btfb = parcelRequire("3Btfb");





var $hSHWm = parcelRequire("hSHWm");

function $2e0df58e89030dfc$export$c5356dc8cba0700d(WrappedComponent) {
    function WithCoreInvitesContext(props) {
        const coreInvitesContext = (0, $cozmU.useContext)((0, $hSHWm.CoreInvitesContext));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...coreInvitesContext,
            ...props
        });
    }
    WithCoreInvitesContext.displayName = `withCoreInvitesContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithCoreInvitesContext;
}






var $gXrHX = parcelRequire("gXrHX");

function $134fa45286a9b1d7$export$adde0c9097009696(WrappedComponent) {
    function WithExternalShareContext(props) {
        const externalShareContext = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...externalShareContext,
            ...props
        });
    }
    WithExternalShareContext.displayName = `withExternalShareContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithExternalShareContext;
}



var $d9tcB = parcelRequire("d9tcB");


var $f0NfR = parcelRequire("f0NfR");


var $gqqjz = parcelRequire("gqqjz");


var $1SPMi = parcelRequire("1SPMi");


var $fySJw = parcelRequire("fySJw");


var $6mKj3 = parcelRequire("6mKj3");


var $iP9x4 = parcelRequire("iP9x4");


var $7okiz = parcelRequire("7okiz");







const $1312f8b4a0711d1a$export$58eac04eb6213951 = ()=>// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('platform_renderer_unsupported_content_tracking') ? (0, $fyKZ5.UNSUPPORTED_CONTENT_THRESHOLDS) : undefined;



var $69aHU = parcelRequire("69aHU");


var $6s78L = parcelRequire("6s78L");

function $fea184a73c848235$var$_defineProperty(e, r, t) {
    return (r = $fea184a73c848235$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fea184a73c848235$var$_toPropertyKey(t) {
    var i = $fea184a73c848235$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fea184a73c848235$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fea184a73c848235$var$borderWidthYellowToken = "var(--ds-border-width-selected, 2px)";
const $fea184a73c848235$var$inlineCommentStylesCompiledTokenized = null;
const $fea184a73c848235$var$inlineCommentStylesCompiledLegacy = null; // ADS migration: wrapper gated by confluence_frontend_tokenize_border (COMMENTS-6463)
const $fea184a73c848235$var$InlineCommentWrapperLegacy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            "_3MgwP7B4sa _3gUKhD7dHp _1iW3TMnQyn _0u2CcxnQyn _22nVZCnQyn _3DUxdmnQyn _3Sxtmmo0UC _3ICS1wo0UC _3S62DGdEFh _1ziM3FdEFh _0XDU9QHZdu _29DdFaHZdu _2stEpBWVPG _31oa40WVPG _2wOALQLRg7 _0uFV1uLRg7 _0yEOJvHZdu _3tVBZXHZdu _3fwf530fjo _0NW3qr0fjo _0fnvsDC29w _2LyRe2Gk8v _07PAZc7zJH _4yrzlNLv9B _1KTxlAu4dn _4cgBq1LWba _1mzwvk0fjo _1dxh8EC29w _1pJiEtGk8v"
        ])
    }));
$fea184a73c848235$var$InlineCommentWrapperLegacy.displayName = 'InlineCommentWrapperLegacy';
const $fea184a73c848235$var$InlineCommentWrapperTokenized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            "_3MgwP7B4sa _3gUKhD7dHp _1iW3TMnQyn _0u2CcxnQyn _22nVZCnQyn _3DUxdmnQyn _3Sxtmmo0UC _3ICS1wo0UC _3S62DGdEFh _1ziM3FdEFh _0XDU9QHZdu _29DdFaHZdu _2stEpBWVPG _31oa40WVPG _2wOALQLRg7 _0uFV1uLRg7 _0yEOJvHZdu _3tVBZXHZdu _3fwf538Atc _0NW3qr8Atc _0fnvsDC29w _2LyRe2Gk8v _07PAZc7zJH _4yrzlNLv9B _1KTxlAu4dn _4cgBq1LWba _1mzwvk8Atc _1dxh8EC29w _1pJiEtGk8v"
        ])
    }));
$fea184a73c848235$var$InlineCommentWrapperTokenized.displayName = 'InlineCommentWrapperTokenized'; // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
const $fea184a73c848235$var$InlineCommentWrapper = (0, $3yh4a.componentWithFG)('confluence_frontend_tokenize_border', $fea184a73c848235$var$InlineCommentWrapperTokenized, $fea184a73c848235$var$InlineCommentWrapperLegacy);
const $fea184a73c848235$var$_RERENDER_STATE_NONE = '';
const $fea184a73c848235$var$_RERENDER_STATE_REQUESTED = 'requested';

const $fea184a73c848235$var$LazyAgentProfileCardWithTrigger = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "of1Ek",
    name: "LazyAgentProfileCardWithTrigger",
    loader: async ()=>(await (parcelRequire("3QmmH"))).AgentProfileCardWithTrigger,
    loading: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
});
const $fea184a73c848235$var$RemixTrackedAkRenderer = ({ remixContentId: remixContentId, ...props })=>{
    const { onMediaRenderEvent: onMediaRenderEvent } = (0, $One0S.useRemixViewMediaExperience)({
        contentId: remixContentId,
        enabled: (0, $6mKj3.expValEquals)('cc-maui-remix-media-view-tracking', 'isEnabled', true),
        pageMode: 'view'
    });
    const Renderer = (0, $6mKj3.expValEquals)('platform_editor_confluence_use_default_renderer', 'isEnabled', true) ? (0, $9jb19.Renderer) : (0, $6t2Zs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Renderer, {
        ...props,
        media: {
            ...props.media,
            onMediaRenderEvent: onMediaRenderEvent
        }
    });
};
class $fea184a73c848235$var$RendererComponent extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { adf: adf, sessionData: sessionData, contentType: contentType } = this.props;
        if (adf && sessionData?.isLicensed) (0, $edEsl.registerGlobalMediaViewedListener)({
            contentType: contentType
        });
        (0, $fySJw.getConnectDataListener)().init({
            emit: (localId, data)=>this.state.referentialityDataSourceProvider.createOrUpdate(localId, data)
        });
        const taskBatcher = new (0, $gxhb8.TaskBatcher)((0, $6mKj3.expVal)('confluence_frontend_task_batching_interval', 'value', 3000));
        taskBatcher.onFlush(this._onBatchTaskUpdate);
        this.setState({
            taskBatcher: taskBatcher
        });
    }
    /**
   * Needed to force an update of Atlaskit Renderer to wake-up TWP code inside that opens expand based on hash in the case where it hasn't changed.
   * The alternative of using getDerivedStateFromProps required multiple steps which didn't work with RTL testing.
   * Settled on normally discouraged setState inside of componentDidUpdate with an eslint-disable to get through Bamboo.
   */ /**
   * When the objectId of the renderer changes, we want to reset the `shouldFetchContent` state variable so we don't
   * cause unnecessary refetches; Calling setState behind a condition that will only happen on page transitions
   */ componentDidUpdate(prevProps) {
        const { objectId: objectId } = this.props;
        const { rerender: rerender } = this.state;
        if (rerender === $fea184a73c848235$var$_RERENDER_STATE_REQUESTED) // eslint-disable-next-line
        this.setState({
            rerender: $fea184a73c848235$var$_RERENDER_STATE_NONE
        });
        if (objectId !== prevProps.objectId) // eslint-disable-next-line
        this.setState({
            shouldRefetchContent: false
        });
    }
    componentWillUnmount() {
        const { adf: adf, sessionData: sessionData } = this.props;
        if (adf && sessionData?.isLicensed) (0, $edEsl.removeGlobalMediaViewedListener)();
    }
    render() {
        // oxlint-disable-next-line compat/compat
        (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance.mark('CFP-63.view.page.classic.renderer.rendered');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            const dataProviders = this.getProviders(flags);
            return this.renderRenderer(this.getExtensionHandlers(false), dataProviders);
        });
    }
    constructor(...args){
        super(...args);
        $fea184a73c848235$var$_defineProperty(this, "mentionNodeDataProvider", (0, $lqVBP.createMentionNodeDataProvider)());
        $fea184a73c848235$var$_defineProperty(this, "state", {
            _root: undefined,
            rerender: $fea184a73c848235$var$_RERENDER_STATE_NONE,
            referentialityDataSourceProvider: new (0, $itU2t.DataSourceProvider)(),
            taskBatcher: undefined,
            shouldRefetchContent: false
        });
        $fea184a73c848235$var$_defineProperty(this, "_handleActionToggle", (objectKey, state)=>{
            // add the task action to be batched/updated in the batch before firing the request
            this.state.taskBatcher?.add({
                objectKey: objectKey,
                state: state
            });
        });
        $fea184a73c848235$var$_defineProperty(this, "_onBatchTaskUpdate", (batch)=>{
            const { objectId: objectId, isPreviewMode: isPreviewMode } = this.props;
            const updateBatch = batch.map((update)=>{
                const { objectKey: objectKey, state: state } = update;
                const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';
                return {
                    taskId: objectKey.localId,
                    status: status
                };
            });
            const taskBatch = {
                contentId: objectId,
                tasks: updateBatch,
                trigger: 'VIEW_PAGE'
            };
            if (!isPreviewMode) (0, $6s78L.mutateInterop)({
                mutation: (0, $eXfot.SetBatchedTaskStatusMutation),
                variables: taskBatch,
                __callerPackage__: "confluence-fabric-editor"
            }).then(()=>{
                this.setState({
                    shouldRefetchContent: true
                });
            }).catch((error)=>{
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        source: 'page',
                        action: 'batchTaskUpdate',
                        actionSubject: 'checkbox',
                        attributes: {
                            error: error.message || String(error),
                            stack: error.stack
                        }
                    });
                });
            });
        });
        $fea184a73c848235$var$_defineProperty(this, "_handleProfileCardActions", (userId)=>{
            const { push: push } = this.props;
            const atlassianPeopleProfileUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, null, (0, $jlIaF.CONTEXT_PATH));
            return [
                {
                    label: this.props.intl.formatMessage({
                        id: "view.profile"
                    }),
                    link: atlassianPeopleProfileUrl,
                    callback: ()=>{
                        push((0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, null, (0, $jlIaF.CONTEXT_PATH)));
                    }
                }
            ];
        });
        $fea184a73c848235$var$_defineProperty(this, "getExpandHash", ()=>{
            if (this.state.rerender === $fea184a73c848235$var$_RERENDER_STATE_REQUESTED) return '';
            else return this.props.getHash();
        });
        $fea184a73c848235$var$_defineProperty(this, "getExtensionHandlers", (shouldIncludeMacroHandlers)=>{
            const { adf: adf, objectId: objectId, spaceKey: spaceKey, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, appearance: appearance, isPreviewMode: isPreviewMode = false } = this.props;
            const { referentialityDataSourceProvider: referentialityDataSourceProvider } = this.state;
            return (0, $7okiz.getExtensionHandlers)({
                adf: adf,
                contentId: objectId,
                appearance: appearance,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview,
                showTemplateInputInPreview: showTemplateInputInPreview,
                spaceKey: spaceKey,
                shouldIncludeMacroHandlers: shouldIncludeMacroHandlers,
                shouldIncludeMacroWithReferencesHandlers: true,
                referentialityDataSourceProvider: referentialityDataSourceProvider,
                fromFabricEditor: true,
                isPreviewMode: isPreviewMode
            });
        });
        $fea184a73c848235$var$_defineProperty(this, "getEventHandlers", ()=>{
            const { matchRoute: matchRoute, push: push } = this.props;
            return {
                ...(0, $lmNXu.createSmartCardEventHandler)({
                    matchRoute: matchRoute,
                    push: push
                })
            };
        });
        $fea184a73c848235$var$_defineProperty(this, "_setRoot", (ref)=>this.setState({
                _root: ref
            })); /* getting type issues with ProfilecardProvider in atlaskit with ProfileCardProvider from next.
           This helps resolve the type errors */ 
        $fea184a73c848235$var$_defineProperty(this, "getProfilecardProvider", (cloudId, getActions, featureFlags)=>{
            const providerPromise = (0, $9UKrO.getProfileCardProvider)(cloudId, getActions, featureFlags);
            const shouldRenderUserMentionCard = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            (0, $9wGTI.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true);
            const shouldRenderAgentMentionCard = (0, $4o0zT.isExperimentEnabled)('jira_browse_agent_modal_update');
            if (!shouldRenderUserMentionCard && !shouldRenderAgentMentionCard) return providerPromise;
            const { accountId: accountId, sessionData: sessionData } = this.props;
            const orgId = sessionData?.orgId ?? '';
            return providerPromise.then((provider)=>({
                    ...provider,
                    ...shouldRenderUserMentionCard && {
                        renderUserMentionCard: ({ userId: mentionUserId, cloudId: mentionCloudId, children: children, prefilledProfileData: prefilledProfileData, referenceElement: referenceElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6fxF.UserProfileCardForMention), {
                                userId: mentionUserId,
                                cloudId: mentionCloudId,
                                orgId: orgId,
                                viewerId: accountId ?? '',
                                referenceElement: referenceElement,
                                prefilledProfileData: (0, $6mKj3.expVal)('cc_comments_accessible_mention_profilecard_names', 'isEnabled', false) ? prefilledProfileData : undefined,
                                agent: {
                                    resourceClient: (0, $bumSD.getProfileClient)(mentionCloudId, featureFlags ?? {})
                                }
                            }, children)
                    },
                    ...shouldRenderAgentMentionCard && {
                        renderAgentMentionCard: ({ accountId: mentionAccountId, children: children, cloudId: mentionCloudId, isReadOnly: isReadOnly, onChatClick: onChatClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fea184a73c848235$var$LazyAgentProfileCardWithTrigger, {
                                identityAccountId: mentionAccountId,
                                cloudId: mentionCloudId,
                                trigger: "click",
                                hideConversationStarters: isReadOnly,
                                hideStarButton: isReadOnly,
                                onChatClick: onChatClick
                            }, children)
                    }
                }));
        });
        $fea184a73c848235$var$_defineProperty(this, "getProviders", (0, $dOBRD.default)((flags)=>{
            const { intl: intl, accountId: accountId, contentType: contentType, cloudId: cloudId, environment: environment, objectId: objectId, spaceKey: spaceKey, isExternalShareRequest: isExternalShareRequest, sessionData: sessionData, showTemplateInputInPreview: showTemplateInputInPreview, showTemplateVariablesInPreview: showTemplateVariablesInPreview, openCoreInvites: openCoreInvites, userRole: userRole, mediaToken: mediaToken, shareToken: shareToken } = this.props;
            const { featureFlags: featureFlags, activationId: activationId } = sessionData;
            const isTemplateMedia = showTemplateVariablesInPreview || showTemplateInputInPreview;
            const mediaProvider = isTemplateMedia ? (0, $c4QoG.createRendererTemplateMediaProvider)({
                spaceKey: spaceKey,
                templateIds: [
                    objectId
                ]
            }) : (0, $4IoVL.createRendererMediaProvider)({
                contentId: objectId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShareRequest,
                mediaToken: mediaToken,
                shareToken: shareToken
            });
            const providerFactory = (0, $eNbr2.default).create({
                mediaProvider: mediaProvider,
                // oxlint-disable-next-line compat/compat
                taskDecisionProvider: Promise.resolve(new (0, $3WO8q.ConfluenceTaskDecisionProvider)(intl, flags, objectId, this._handleActionToggle)),
                // oxlint-disable-next-line compat/compat
                cardProvider: Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)())
            });
            if (cloudId && accountId) providerFactory.setProvider('mentionProvider', (0, $dtVue.createMentionsConfig)(cloudId, accountId, undefined, undefined, openCoreInvites, userRole).then((config)=>config.mentionResource).catch((err)=>{
                return Promise.reject();
            }));
            const hasAccess = sessionData?.accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || sessionData?.accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
            if (cloudId) providerFactory.setProvider('emojiProvider', (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
                cloudId: cloudId,
                userId: accountId,
                allowAnonymousAccess: true
            }));
            if (cloudId && hasAccess) // If global view user profile is enabled then user can view profile card
            // Making promise void as in the worst case the
            (0, $2d2df6655155416b$export$60b2889c65284218)().then((hasViewUserProfilePermission)=>{
                if (hasViewUserProfilePermission) providerFactory.setProvider('profilecardProvider', this.getProfilecardProvider(cloudId, this._handleProfileCardActions, featureFlags));
            });
            if (isTemplateMedia) {
                const contextIdentifierProvider = async ()=>{
                    const templateObjectId = JSON.stringify({
                        templateId: objectId,
                        spaceKey: spaceKey
                    });
                    return Promise.resolve({
                        containerId: spaceKey || '',
                        objectId: templateObjectId,
                        product: 'confluence'
                    });
                };
                providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider());
            } else if (spaceKey) providerFactory.setProvider('contextIdentifierProvider', Promise.resolve({
                containerId: spaceKey,
                objectId: objectId,
                product: 'confluence'
            }));
            (0, $69aHU.populateExtensionProviders)(providerFactory, {
                intl: intl,
                contentId: objectId,
                containerId: spaceKey || '',
                accountId: accountId,
                cloudId: cloudId,
                spaceKey: spaceKey,
                contentType: contentType,
                environment: environment,
                featureFlags: featureFlags,
                extensionHandlers: this.getExtensionHandlers(true),
                showTemplateInputInPreview: showTemplateInputInPreview,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview,
                activationId: activationId
            });
            return providerFactory;
        }));
        $fea184a73c848235$var$_defineProperty(this, "decodeHash", (hash)=>{
            let decodedHash = '';
            try {
                // try to decode the hash
                decodedHash = decodeURIComponent(hash);
            } catch  {
                // if hash is not encoded, it will throw a URI Malformed error,
                // which we will then return the original hash
                decodedHash = hash;
            }
            return decodedHash;
        });
        $fea184a73c848235$var$_defineProperty(this, "handleClicksInRenderer", (event)=>{
            /**
       * Covering a corner case:
       * If the user
       * - has followed a deep link to a header inside an expand
       * - then closes that expand
       * - then clicks a TOC link to the same header
       * the renderer code will not see a change in the deep link has, so it won't run which leaves the user scrolled
       * to a closed expand element.
       * This code detects the above situation and sets the rerender state property to begin a double re-render of the
       * renderer (once with no hash and once with the original hash). This lets the renderer code see a change so it
       * opens the expand.
       */ const deepLinkHash = event.target.hash;
            if (deepLinkHash === `#${this.getExpandHash()}`) {
                if (typeof document !== 'undefined') {
                    const tocTarget = document.getElementById(this.decodeHash(this.getExpandHash()));
                    if (tocTarget) {
                        const expandParent = tocTarget.closest("[data-node-type='expand']"); // If the TOC link points to a header inside a closed expand
                        if (expandParent && expandParent.getAttribute('data-expanded') === 'false') this.setState({
                            rerender: $fea184a73c848235$var$_RERENDER_STATE_REQUESTED
                        });
                    }
                }
            }
        });
        $fea184a73c848235$var$_defineProperty(this, "renderRenderer", (extensionHandlers, dataProviders)=>{
            const { adf: adf, id: id, className: className, style: style, allowInlineComments: allowInlineComments, ignoreHeadingAnchorLinksFeatureFlag: ignoreHeadingAnchorLinksFeatureFlag, renderWhenReady: renderWhenReady, onComplete: onComplete, onRendered: onRendered, objectId: objectId, sessionData: sessionData, allowPlaceholderText: allowPlaceholderText = false, annotationProvider: annotationProvider, allowAnnotations: allowAnnotations = false, UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment = true, UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing = true, spaceKey: spaceKey, isExternalShareRequest: isExternalShareRequest, mediaToken: mediaToken } = this.props;
            const { shouldRefetchContent: shouldRefetchContent } = this.state;
            if (!adf) return null;
             // Allow disabling the feature for previews.
            const allowHeadingAnchorLinks = !ignoreHeadingAnchorLinksFeatureFlag;
            const { offsetTop: offsetTop } = this.props;
            const stickyHeaders = offsetTop !== undefined && {
                offsetTop: offsetTop
            };
            const { featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled } = sessionData; // used for renderer's annotation provider
            const localRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
            const shouldSSRsmartLinks = (0, $i6Ps3.isPageSSRd)() && !(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
            const mediaSSR = (0, $iP9x4.getMediaSSRModeAndAuthConfigMemoized)({
                contentId: objectId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShareRequest,
                mediaToken: mediaToken
            });
            const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1SPMi.RendererAnalyticsListener), {
                objectId: objectId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $habRv.WithAnnotationsWrapper), {
                annotationProvider: annotationProvider,
                rendererRef: localRef,
                adfDocument: this.props.navigationPolicy?.shimAdfUrls(adf) ?? adf,
                updateDocument: ()=>{},
                isNestedRender: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fea184a73c848235$var$RemixTrackedAkRenderer, {
                remixContentId: objectId,
                appearance: this.props.appearance,
                allowRendererContainerStyles: this.props.allowRendererContainerStyles,
                contentMode: this.props.contentMode,
                document: this.props.navigationPolicy?.shimAdfUrls(adf) ?? adf,
                adfStage: "stage0",
                dataProviders: dataProviders,
                mentionNodeDataProvider: this.mentionNodeDataProvider,
                eventHandlers: this.getEventHandlers(),
                extensionHandlers: extensionHandlers,
                featureFlags: {},
                portal: this.state._root,
                onComplete: onComplete,
                onRendered: onRendered,
                allowColumnSorting: true,
                allowHeadingAnchorLinks: {
                    allowNestedHeaderLinks: allowHeadingAnchorLinks,
                    activeHeadingId: this.decodeHash(this.getExpandHash())
                },
                allowAltTextOnImages: true,
                media: {
                    allowLinking: true,
                    allowCaptions: true,
                    featureFlags: (0, $kBU5m.getMediaFeatureFlags)(featureFlags),
                    ssr: mediaSSR
                },
                stickyHeaders: stickyHeaders,
                allowCopyToClipboard: true,
                allowWrapCodeBlock: true,
                analyticsEventSeverityTracking: (0, $fyKZ5.ANALYTICS_EVENT_SEVERITY_TRACKING),
                allowSelectAllTrap: true,
                unsupportedContentLevelsTracking: (0, $1312f8b4a0711d1a$export$58eac04eb6213951)(),
                allowPlaceholderText: allowPlaceholderText,
                allowCustomPanels: true,
                smartLinks: {
                    hideHoverPreview: false,
                    ssr: shouldSSRsmartLinks
                },
                allowAnnotations: allowAnnotations,
                annotationProvider: annotationProvider,
                UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment,
                UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing
            })));
            const rendererContent = // eslint-disable-next-line
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                onClick: this.handleClicksInRenderer
            }, content);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fea184a73c848235$var$InlineCommentWrapper, {
                id: id,
                "data-inline-comments-target": allowInlineComments ? 'true' : 'false',
                className: className,
                ref: this._setRoot,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    ...style,
                    '--content-renderer-inline-comment-marker-start': this.props.intl.formatMessage(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $5dnlf.messages).contentRendererInlineCommentMarkerStart),
                    '--content-renderer-inline-comment-marker-end': this.props.intl.formatMessage(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $5dnlf.messages).contentRendererInlineCommentMarkerEnd)
                },
                "data-test-appearance": this.props.appearance
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
                ...(0, $kLzei.getSmartCardRenderers)(),
                isAdminHubAIEnabled: isAdminHubAIEnabled
            }, rendererContent), renderWhenReady && renderWhenReady(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fgQGl.ContentRefetchHandler), {
                contentId: objectId,
                shouldRefetch: shouldRefetchContent
            }));
        });
    }
}
const $fea184a73c848235$export$7a850de5bcc76388 = (0, $kSwu1.injectIntl)((0, $3Btfb.withNavigationPolicy)($fea184a73c848235$var$RendererComponent));
class $fea184a73c848235$var$RendererComponentWithBanner extends (0, $cozmU.PureComponent) {
    render() {
        const { allowStickyHeaders: allowStickyHeaders } = this.props;
        if (allowStickyHeaders === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fea184a73c848235$export$7a850de5bcc76388, this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beAFO.BannerHeightReader), null, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $1a6Dn.FloatingBannerStateContainer)
                ]
            }, (floatingBanners)=>{
                const offsetTop = bannerState.getTotalHeight() + floatingBanners.getFloatingHeight();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fea184a73c848235$export$7a850de5bcc76388, {
                    offsetTop: offsetTop,
                    ...this.props
                });
            }));
    }
}
const $fea184a73c848235$var$_default_1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})((0, $2e0df58e89030dfc$export$c5356dc8cba0700d)((0, $134fa45286a9b1d7$export$adde0c9097009696)((0, $f0NfR.withSessionData)((0, $gXsSh.withRoutesContext)($fea184a73c848235$var$RendererComponentWithBanner)))));
var $fea184a73c848235$export$2e2bcd8739ae039 = $fea184a73c848235$var$_default_1;


var $23c487fbdabb1bfd$export$2e2bcd8739ae039 = (props)=>{
    const { userId: userId, cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fea184a73c848235$export$2e2bcd8739ae039), {
        ...props,
        accountId: userId,
        cloudId: cloudId,
        environment: environment
    });
};

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>// oxlint-disable-next-line confluence-feature-gating/static-feature-gates, confluence-feature-gating/no-new-feature-gates
    (0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("8YePs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("One0S", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fULE8 = parcelRequire("fULE8");


var $bjY3F = parcelRequire("bjY3F");


var $g4HOu = parcelRequire("g4HOu");


var $g6xOF = parcelRequire("g6xOF");

const $82e36c9e8880fb36$export$e08420a3ae887adb = 35000;
/** Parses the persistent ADF dataConsumer marker written for Remix-generated media. */ const $82e36c9e8880fb36$var$parseRemixMediaSource = (source)=>{
    if (source === 'remix') return {};
    if (!source) return undefined;
    const [prefix, remixType, remixSubtype, ...rest] = source.split(':');
    if (prefix !== 'remix' || remixType !== 'image' && remixType !== 'infographic' || !remixSubtype || rest.length > 0) return undefined;
    return {
        remixSubtype: remixSubtype,
        remixType: remixType
    };
};
const $82e36c9e8880fb36$export$944b3b5b52f3c9ea = ({ contentId: contentId, enabled: enabled, insertEnabled: insertEnabled = false, pageMode: pageMode })=>{
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const pageSessionKey = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    const trackedMediaRef = (0, $cozmU.useRef)(new Map());
    const pendingOutcomesRef = (0, $cozmU.useRef)(new Map());
    const retiredMediaRef = (0, $cozmU.useRef)(new WeakMap());
    const nextRegistrationIdRef = (0, $cozmU.useRef)(0);
    const lifecycle = (0, $cozmU.useMemo)(()=>({
            contentId: contentId,
            enabled: enabled,
            insertEnabled: insertEnabled,
            experienceTracker: experienceTracker,
            pageMode: pageMode,
            pageSessionKey: pageSessionKey
        }), [
        contentId,
        enabled,
        insertEnabled,
        experienceTracker,
        pageMode,
        pageSessionKey
    ]);
    const lifecycleRef = (0, $cozmU.useRef)(lifecycle);
    lifecycleRef.current = lifecycle;
    const release = (0, $cozmU.useCallback)((mediaInstance, expectedLifecycle)=>{
        const pendingOutcome = pendingOutcomesRef.current.get(mediaInstance);
        if (!expectedLifecycle || pendingOutcome?.lifecycle === expectedLifecycle) pendingOutcomesRef.current.delete(mediaInstance);
        const trackedMedia = trackedMediaRef.current.get(mediaInstance);
        if (!trackedMedia || expectedLifecycle && trackedMedia.lifecycle !== expectedLifecycle) return;
        clearTimeout(trackedMedia.timeout);
        trackedMediaRef.current.delete(mediaInstance);
        if (trackedMedia.lifecycle.enabled) (0, $g6xOF.releaseRemixEmbedRender)({
            embedId: trackedMedia.registrationId,
            experienceTracker: trackedMedia.lifecycle.experienceTracker,
            pageSessionId: trackedMedia.lifecycle.contentId,
            pageSessionKey: trackedMedia.lifecycle.pageSessionKey
        });
    }, []);
    const succeed = (0, $cozmU.useCallback)((mediaInstance_0, renderedMediaId, mediaId)=>{
        const trackedMedia_0 = trackedMediaRef.current.get(mediaInstance_0);
        if (!trackedMedia_0) {
            const retiredMediaId = retiredMediaRef.current.get(mediaInstance_0);
            if (retiredMediaId && (!mediaId || retiredMediaId === mediaId)) return;
            pendingOutcomesRef.current.set(mediaInstance_0, {
                lifecycle: lifecycleRef.current,
                mediaId: mediaId,
                renderedMediaId: renderedMediaId,
                type: 'success'
            });
            return;
        }
        if (trackedMedia_0.settled && !trackedMedia_0.loadPending || mediaId !== undefined && mediaId !== trackedMedia_0.mediaId || renderedMediaId !== undefined && renderedMediaId !== trackedMedia_0.mediaId) return;
        trackedMedia_0.settled = true;
        trackedMedia_0.loadPending = false;
        clearTimeout(trackedMedia_0.timeout);
        if (trackedMedia_0.lifecycle.insertEnabled && !trackedMedia_0.insertSettled) {
            trackedMedia_0.insertSettled = true;
            (0, $g4HOu.completeRemixInsertRenderVerification)({
                type: 'mediaId',
                value: trackedMedia_0.mediaId
            });
        }
        if (trackedMedia_0.lifecycle.enabled) (0, $g6xOF.completeRemixEmbedRender)({
            embedId: trackedMedia_0.registrationId,
            experienceTracker: trackedMedia_0.lifecycle.experienceTracker,
            pageSessionId: trackedMedia_0.lifecycle.contentId,
            pageSessionKey: trackedMedia_0.lifecycle.pageSessionKey
        });
    }, []);
    const fail = (0, $cozmU.useCallback)((mediaInstance_1, reason, isTimeout = false, mediaId_0)=>{
        const trackedMedia_1 = trackedMediaRef.current.get(mediaInstance_1);
        if (!trackedMedia_1) {
            const retiredMediaId_0 = retiredMediaRef.current.get(mediaInstance_1);
            if (retiredMediaId_0 && (!mediaId_0 || retiredMediaId_0 === mediaId_0)) return;
            pendingOutcomesRef.current.set(mediaInstance_1, {
                lifecycle: lifecycleRef.current,
                mediaId: mediaId_0,
                reason: reason,
                type: 'failure'
            });
            return;
        }
        if (trackedMedia_1.settled && !trackedMedia_1.loadPending || mediaId_0 !== undefined && mediaId_0 !== trackedMedia_1.mediaId) return;
        trackedMedia_1.settled = true;
        if (!isTimeout) trackedMedia_1.loadPending = false;
        clearTimeout(trackedMedia_1.timeout);
        if (!isTimeout && trackedMedia_1.lifecycle.insertEnabled && !trackedMedia_1.insertSettled) {
            trackedMedia_1.insertSettled = true;
            (0, $g4HOu.failRemixInsertRenderVerification)({
                error: new Error(reason),
                identity: {
                    type: 'mediaId',
                    value: trackedMedia_1.mediaId
                },
                reason: 'media_render_error'
            });
        }
        const errorType = isTimeout ? 'render_timeout' : 'media_render_error';
        if (trackedMedia_1.lifecycle.enabled) (0, $g6xOF.failRemixEmbedRender)({
            attributes: {
                failedRemixSubtype: trackedMedia_1.remixSubtype,
                failedRemixType: trackedMedia_1.remixType,
                renderFailureReason: errorType
            },
            embedId: trackedMedia_1.registrationId,
            error: new Error(reason),
            errorType: errorType,
            experienceTracker: trackedMedia_1.lifecycle.experienceTracker,
            pageSessionId: trackedMedia_1.lifecycle.contentId,
            pageSessionKey: trackedMedia_1.lifecycle.pageSessionKey
        });
    }, []);
    const trackMediaRenderEvent = (0, $cozmU.useCallback)((event)=>{
        if (event.type === 'unmounted') {
            const trackedMedia_2 = trackedMediaRef.current.get(event.mediaInstance);
            if (event.mediaId !== undefined && trackedMedia_2?.mediaId !== event.mediaId) return;
            release(event.mediaInstance);
            return;
        }
        if (event.type === 'preview-rendered') {
            succeed(event.mediaInstance, event.renderedMediaId, event.mediaId);
            return;
        }
        if (event.type === 'error') {
            fail(event.mediaInstance, event.reason, false, event.mediaId);
            return;
        }
        const currentLifecycle = lifecycleRef.current;
        const remixMetadata = $82e36c9e8880fb36$var$parseRemixMediaSource(event.dataConsumerSource);
        if (!event.mediaId || !remixMetadata) {
            const pendingOutcome_0 = pendingOutcomesRef.current.get(event.mediaInstance);
            if (pendingOutcome_0?.lifecycle === currentLifecycle) pendingOutcomesRef.current.delete(event.mediaInstance);
            return;
        }
        const retiredMediaId_1 = retiredMediaRef.current.get(event.mediaInstance);
        if (retiredMediaId_1 === event.mediaId) return;
        retiredMediaRef.current.delete(event.mediaInstance);
        const existingMedia = trackedMediaRef.current.get(event.mediaInstance);
        if (existingMedia) {
            if (existingMedia.lifecycle === currentLifecycle && existingMedia.mediaId === event.mediaId) return;
            release(event.mediaInstance, existingMedia.lifecycle);
        }
        const registrationId = `media:${event.mediaId}:${nextRegistrationIdRef.current++}`;
        if (currentLifecycle.enabled) (0, $g6xOF.beginRemixEmbedRender)({
            attributes: {
                contentType: currentLifecycle.pageMode === 'live' ? 'live-doc' : currentLifecycle.pageMode === 'edit' ? 'classic-page-edit' : 'classic-page-view',
                pageMode: currentLifecycle.pageMode,
                product: 'confluence',
                remixSubtype: remixMetadata.remixSubtype,
                remixType: remixMetadata.remixType
            },
            embedId: registrationId,
            renderIdentity: event.mediaId,
            experienceTracker: currentLifecycle.experienceTracker,
            pageSessionId: currentLifecycle.contentId,
            pageSessionKey: currentLifecycle.pageSessionKey
        });
        const timeout = currentLifecycle.enabled ? setTimeout(()=>{
            fail(event.mediaInstance, 'Remix media did not render within the expected time', true);
        }, $82e36c9e8880fb36$export$e08420a3ae887adb) : undefined;
        trackedMediaRef.current.set(event.mediaInstance, {
            ...remixMetadata,
            insertSettled: false,
            lifecycle: currentLifecycle,
            mediaId: event.mediaId,
            registrationId: registrationId,
            settled: false,
            loadPending: true,
            timeout: timeout
        });
        const pendingOutcome_1 = pendingOutcomesRef.current.get(event.mediaInstance);
        if (pendingOutcome_1?.lifecycle !== currentLifecycle || pendingOutcome_1.mediaId !== undefined && pendingOutcome_1.mediaId !== event.mediaId) {
            if (pendingOutcome_1) pendingOutcomesRef.current.delete(event.mediaInstance);
            return;
        }
        pendingOutcomesRef.current.delete(event.mediaInstance);
        if (pendingOutcome_1.type === 'success') succeed(event.mediaInstance, pendingOutcome_1.renderedMediaId, pendingOutcome_1.mediaId);
        else fail(event.mediaInstance, pendingOutcome_1.reason, false, pendingOutcome_1.mediaId);
    }, [
        fail,
        release,
        succeed
    ]);
    const onMediaRenderEvent = (0, $cozmU.useCallback)((event_0)=>{
        if (!lifecycleRef.current.enabled && !lifecycleRef.current.insertEnabled) return;
        try {
            trackMediaRenderEvent(event_0);
        } catch  {
            // Reliability instrumentation must never interrupt the media rendering lifecycle.
            return;
        }
    }, [
        trackMediaRenderEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled && !insertEnabled) return;
        const trackedMedia_3 = trackedMediaRef.current;
        const pendingOutcomes = pendingOutcomesRef.current;
        const retiredMedia = retiredMediaRef.current;
        return ()=>{
            for (const [mediaInstance_2, media] of [
                ...trackedMedia_3.entries()
            ])if (media.lifecycle === lifecycle) {
                retiredMedia.set(mediaInstance_2, media.mediaId);
                release(mediaInstance_2, lifecycle);
            }
            for (const [mediaInstance_3, pendingOutcome_2] of pendingOutcomes)if (pendingOutcome_2.lifecycle === lifecycle) pendingOutcomes.delete(mediaInstance_3);
            const currentLifecycle_0 = lifecycleRef.current;
            const leftTrackedDocument = lifecycle.enabled && (!currentLifecycle_0.enabled || currentLifecycle_0.contentId !== lifecycle.contentId);
            if (leftTrackedDocument) (0, $g6xOF.retireRemixViewPageSession)({
                experienceTracker: lifecycle.experienceTracker,
                pageSessionId: lifecycle.contentId,
                pageSessionKey: lifecycle.pageSessionKey
            });
        };
    }, [
        enabled,
        insertEnabled,
        lifecycle,
        release
    ]);
    return {
        onMediaRenderEvent: enabled || insertEnabled ? onMediaRenderEvent : undefined
    };
};
module.exports["useRemixViewMediaExperience"] = $82e36c9e8880fb36$export$944b3b5b52f3c9ea;

});

parcelRegister("fULE8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1ab2dc8fa18785f7$export$a7b0697657ed8bd0 = (0, $cozmU.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    updateAttributes () {}
});
module.exports["ExperienceTrackerContext"] = $1ab2dc8fa18785f7$export$a7b0697657ed8bd0;

});

parcelRegister("g4HOu", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $cvQra = parcelRequire("cvQra");

const $760ec44f5d7a903a$export$969834d2009eb355 = 35000;
const $760ec44f5d7a903a$export$cae7671aa07fcfca = 45000;
const $760ec44f5d7a903a$export$41da3848ad98b6db = 120000;
const $760ec44f5d7a903a$var$RETAINED_RENDER_OUTCOME_TIMEOUT_MS = 300000;
const $760ec44f5d7a903a$var$pendingVerifications = new Map();
const $760ec44f5d7a903a$var$recentOutcomes = new Map();
const $760ec44f5d7a903a$var$retainedRenderIdentities = new Map();
const $760ec44f5d7a903a$var$toKey = ({ type: type, value: value })=>`${type}:${value}`;
const $760ec44f5d7a903a$var$clearRetainedIdentity = (key)=>{
    const timeout = $760ec44f5d7a903a$var$retainedRenderIdentities.get(key);
    if (timeout !== undefined) {
        clearTimeout(timeout);
        $760ec44f5d7a903a$var$retainedRenderIdentities.delete(key);
    }
};
const $760ec44f5d7a903a$export$e974a05c14cbc0b0 = (identity)=>{
    const key = $760ec44f5d7a903a$var$toKey(identity);
    $760ec44f5d7a903a$var$clearRetainedIdentity(key);
    const recent = $760ec44f5d7a903a$var$recentOutcomes.get(key);
    if (recent?.timeout !== undefined && recent.outcome.type === 'succeeded') {
        clearTimeout(recent.timeout);
        $760ec44f5d7a903a$var$recentOutcomes.set(key, {
            outcome: recent.outcome
        });
    }
    $760ec44f5d7a903a$var$retainedRenderIdentities.set(key, setTimeout(()=>{
        $760ec44f5d7a903a$var$retainedRenderIdentities.delete(key);
        $760ec44f5d7a903a$var$recentOutcomes.delete(key);
    }, $760ec44f5d7a903a$var$RETAINED_RENDER_OUTCOME_TIMEOUT_MS));
};
const $760ec44f5d7a903a$export$3402840a38c3009c = (identity)=>{
    const key = $760ec44f5d7a903a$var$toKey(identity);
    $760ec44f5d7a903a$var$clearRetainedIdentity(key);
    const recent = $760ec44f5d7a903a$var$recentOutcomes.get(key);
    if (recent?.timeout !== undefined) clearTimeout(recent.timeout);
    $760ec44f5d7a903a$var$recentOutcomes.delete(key);
};
const $760ec44f5d7a903a$var$stopObserving = (pending)=>{
    clearTimeout(pending.timeout);
    clearTimeout(pending.observationTimeout);
    pending.unsubscribe?.();
};
const $760ec44f5d7a903a$export$b8b85fb36047af62 = (identity)=>$760ec44f5d7a903a$var$pendingVerifications.has($760ec44f5d7a903a$var$toKey(identity));
const $760ec44f5d7a903a$var$settle = (pending, outcome)=>{
    $760ec44f5d7a903a$var$stopObserving(pending);
    if (!pending.deadlineExceeded) try {
        if (outcome.type === 'succeeded') pending.experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_INSERT_LIMITED,
            attributes: {
                ...pending.attributes,
                renderDeadlineMs: pending.renderTimeoutMs
            }
        });
        else pending.experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).REMIX_INSERT_LIMITED,
            error: outcome.error,
            attributes: {
                ...pending.attributes,
                renderDeadlineMs: pending.renderTimeoutMs,
                renderFailureReason: outcome.reason
            }
        });
    } catch  {}
    try {
        const attributes = {
            ...pending.attributes,
            renderDeadlineMs: pending.renderTimeoutMs,
            deadlineExceeded: !!pending.deadlineExceeded
        };
        if (outcome.type === 'succeeded') {
            pending.experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).REMIX_INSERT,
                attributes: attributes
            });
            return;
        }
        pending.experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).REMIX_INSERT,
            error: outcome.error,
            attributes: {
                ...attributes,
                renderFailureReason: outcome.reason
            }
        });
    } catch  {
    // Reliability telemetry must never affect the inserted content's render path.
    }
};
const $760ec44f5d7a903a$var$retireVerification = (key, pending)=>{
    if ($760ec44f5d7a903a$var$pendingVerifications.get(key) !== pending) return;
    $760ec44f5d7a903a$var$pendingVerifications.delete(key);
    $760ec44f5d7a903a$var$stopObserving(pending);
    if (!pending.deadlineExceeded) try {
        pending.experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_INSERT_LIMITED,
            reason: 'render_verification_replaced'
        });
    } catch  {}
};
const $760ec44f5d7a903a$var$recordOutcome = (identity, outcome)=>{
    const key = $760ec44f5d7a903a$var$toKey(identity);
    const pending = $760ec44f5d7a903a$var$pendingVerifications.get(key);
    if (pending) {
        $760ec44f5d7a903a$var$pendingVerifications.delete(key);
        $760ec44f5d7a903a$var$settle(pending, outcome);
        return;
    }
    const previous = $760ec44f5d7a903a$var$recentOutcomes.get(key);
    if (previous?.timeout !== undefined) clearTimeout(previous.timeout);
    const timeout = $760ec44f5d7a903a$var$retainedRenderIdentities.has(key) && outcome.type === 'succeeded' ? undefined : setTimeout(()=>$760ec44f5d7a903a$var$recentOutcomes.delete(key), $760ec44f5d7a903a$export$969834d2009eb355);
    $760ec44f5d7a903a$var$recentOutcomes.set(key, {
        outcome: outcome,
        timeout: timeout
    });
};
const $760ec44f5d7a903a$export$72ca1938e429de2f = ({ attributes: attributes, experienceTracker: experienceTracker, identity: identity, renderTimeoutMs: renderTimeoutMs = $760ec44f5d7a903a$export$969834d2009eb355 })=>{
    const remixCreateId = attributes?.remixCreateId;
    if (typeof remixCreateId === 'string') (0, $cvQra.remixCreateTerminalOwnership).commit(remixCreateId);
    const key = $760ec44f5d7a903a$var$toKey(identity);
    for (const [previousKey, previous] of $760ec44f5d7a903a$var$pendingVerifications)$760ec44f5d7a903a$var$retireVerification(previousKey, previous);
    const renderAttemptId = crypto.randomUUID();
    const trackingAttributes = {
        ...attributes,
        renderAttemptId: renderAttemptId
    };
    const pending = {
        attributes: trackingAttributes,
        experienceTracker: experienceTracker,
        renderTimeoutMs: renderTimeoutMs
    };
    try {
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_INSERT_LIMITED,
            id: renderAttemptId,
            attributes: {
                ...trackingAttributes,
                renderDeadlineMs: renderTimeoutMs
            }
        });
    } catch  {}
    const recent = $760ec44f5d7a903a$var$recentOutcomes.get(key);
    if (recent) {
        if (recent.timeout !== undefined) clearTimeout(recent.timeout);
        $760ec44f5d7a903a$var$recentOutcomes.delete(key);
        $760ec44f5d7a903a$var$clearRetainedIdentity(key);
        $760ec44f5d7a903a$var$settle(pending, recent.outcome);
        return;
    }
    $760ec44f5d7a903a$var$clearRetainedIdentity(key);
    try {
        pending.unsubscribe = experienceTracker.subscribe((event)=>{
            if (event.action === 'taskStart' && event.name === (0, $irnO2.ExperienceName).REMIX_INSERT) $760ec44f5d7a903a$var$retireVerification(key, pending);
        });
    } catch  {}
    pending.timeout = setTimeout(()=>{
        if ($760ec44f5d7a903a$var$pendingVerifications.get(key) !== pending) return;
        const error = new Error('Inserted Remix content did not render within the expected time');
        pending.deadlineExceeded = true;
        try {
            pending.experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_INSERT_LIMITED,
                error: error,
                attributes: {
                    ...pending.attributes,
                    renderDeadlineMs: renderTimeoutMs,
                    renderFailureReason: 'render_timeout'
                }
            });
        } catch  {}
    }, renderTimeoutMs);
    pending.observationTimeout = setTimeout(()=>{
        if ($760ec44f5d7a903a$var$pendingVerifications.get(key) !== pending) return;
        $760ec44f5d7a903a$var$pendingVerifications.delete(key);
        $760ec44f5d7a903a$var$settle(pending, {
            type: 'failed',
            reason: 'render_observation_limit',
            error: new Error('Inserted Remix content did not render within the observation limit')
        });
    }, Math.max($760ec44f5d7a903a$export$41da3848ad98b6db, renderTimeoutMs));
    $760ec44f5d7a903a$var$pendingVerifications.set(key, pending);
};
const $760ec44f5d7a903a$export$dd7e9012156633f5 = (identity)=>$760ec44f5d7a903a$var$recordOutcome(identity, {
        type: 'succeeded'
    });
const $760ec44f5d7a903a$export$82124ccaa18932b1 = ({ error: error, identity: identity, reason: reason })=>{
    if (reason === 'render_timeout') return;
    $760ec44f5d7a903a$var$recordOutcome(identity, {
        error: error,
        reason: reason,
        type: 'failed'
    });
};
const $760ec44f5d7a903a$export$50c65b1ff03da44d = ()=>{
    for (const pending of $760ec44f5d7a903a$var$pendingVerifications.values())$760ec44f5d7a903a$var$stopObserving(pending);
    for (const recent of $760ec44f5d7a903a$var$recentOutcomes.values())if (recent.timeout !== undefined) clearTimeout(recent.timeout);
    for (const timeout of $760ec44f5d7a903a$var$retainedRenderIdentities.values())clearTimeout(timeout);
    $760ec44f5d7a903a$var$pendingVerifications.clear();
    $760ec44f5d7a903a$var$recentOutcomes.clear();
    $760ec44f5d7a903a$var$retainedRenderIdentities.clear();
    (0, $cvQra.remixCreateTerminalOwnership).reset();
};
module.exports["REMIX_DIAGRAM_RENDER_TIMEOUT_MS"] = $760ec44f5d7a903a$export$cae7671aa07fcfca;
module.exports["retainRemixInsertRenderOutcome"] = $760ec44f5d7a903a$export$e974a05c14cbc0b0;
module.exports["releaseRemixInsertRenderOutcome"] = $760ec44f5d7a903a$export$3402840a38c3009c;
module.exports["beginRemixInsertRenderVerification"] = $760ec44f5d7a903a$export$72ca1938e429de2f;
module.exports["completeRemixInsertRenderVerification"] = $760ec44f5d7a903a$export$dd7e9012156633f5;
module.exports["failRemixInsertRenderVerification"] = $760ec44f5d7a903a$export$82124ccaa18932b1;

});

parcelRegister("cvQra", function(module, exports) {
const $ea4cf4ccfd984408$var$committedRemixCreateIds = new Set();
const $ea4cf4ccfd984408$export$76401a56620523ea = {
    commit (remixCreateId) {
        $ea4cf4ccfd984408$var$committedRemixCreateIds.add(remixCreateId);
    },
    isOwnedByTerminal (remixCreateId) {
        return remixCreateId !== undefined && $ea4cf4ccfd984408$var$committedRemixCreateIds.has(remixCreateId);
    },
    release (remixCreateId) {
        if (remixCreateId !== undefined) $ea4cf4ccfd984408$var$committedRemixCreateIds.delete(remixCreateId);
    },
    reset () {
        $ea4cf4ccfd984408$var$committedRemixCreateIds.clear();
    }
};
module.exports["remixCreateTerminalOwnership"] = $ea4cf4ccfd984408$export$76401a56620523ea;

});

parcelRegister("g6xOF", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $iBsvI = parcelRequire("iBsvI");

const $5b226df072c0ec4b$export$7a32db6356bb4e42 = 100;
const $5b226df072c0ec4b$export$9e0b5888c5f4a026 = 1000;
/**
 * The page session key is supplied by the host's shared experience-tracker
 * context. `useAIMateExperienceTracker()` returns a distinct Proxy per hook, so
 * using the reporting tracker itself as this key would incorrectly create one
 * session per embed.
 */ const $5b226df072c0ec4b$var$sessions = new Map();
const $5b226df072c0ec4b$var$getPageSessionKey = (experienceTracker, pageSessionKey)=>pageSessionKey ?? experienceTracker;
const $5b226df072c0ec4b$var$clearSettleTimer = (session)=>{
    if (session.settleTimer !== undefined) {
        clearTimeout(session.settleTimer);
        session.settleTimer = undefined;
    }
};
const $5b226df072c0ec4b$var$clearRetentionTimer = (session)=>{
    if (session.retentionTimer !== undefined) {
        clearTimeout(session.retentionTimer);
        session.retentionTimer = undefined;
    }
};
const $5b226df072c0ec4b$var$deleteSession = (session)=>{
    $5b226df072c0ec4b$var$clearRetentionTimer(session);
    $5b226df072c0ec4b$var$clearSettleTimer(session);
    clearTimeout(session.loadTiming.settleTimer);
    session.embeds.forEach(({ releaseTimer: releaseTimer })=>clearTimeout(releaseTimer));
    if ($5b226df072c0ec4b$var$sessions.get(session.pageSessionKey) === session) $5b226df072c0ec4b$var$sessions.delete(session.pageSessionKey);
    if ($5b226df072c0ec4b$var$sessions.size === 0 && typeof window !== 'undefined') window.removeEventListener('pagehide', $5b226df072c0ec4b$var$onBrowserPageHide);
};
const $5b226df072c0ec4b$var$distinctStrings = (values)=>[
        ...new Set(values.filter((value)=>typeof value === 'string' && value.length > 0))
    ];
const $5b226df072c0ec4b$var$buildPageAttributes = (session, terminalAttributes)=>{
    const registrations = [
        ...session.embeds.values()
    ];
    const remixTypes = $5b226df072c0ec4b$var$distinctStrings(registrations.map(({ attributes: attributes })=>attributes.remixType));
    const contentTypes = $5b226df072c0ec4b$var$distinctStrings(registrations.map(({ attributes: attributes })=>attributes.contentType));
    const pageModes = $5b226df072c0ec4b$var$distinctStrings(registrations.map(({ attributes: attributes })=>attributes.pageMode));
    const product = registrations.find(({ attributes: attributes })=>attributes.product)?.attributes.product;
    const existingFeatureArea = registrations.find(({ attributes: attributes })=>attributes.featureArea)?.attributes.featureArea;
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: remixTypes.length === 1 ? remixTypes[0] : remixTypes.length > 1 ? 'mixed' : undefined,
        existingFeatureArea: terminalAttributes?.featureArea ?? existingFeatureArea
    });
    return {
        ...terminalAttributes,
        ...product ? {
            product: product
        } : {},
        ...contentTypes.length === 1 ? {
            contentType: contentTypes[0]
        } : {},
        ...contentTypes.length > 1 ? {
            contentType: 'mixed',
            contentTypes: contentTypes
        } : {},
        ...pageModes.length === 1 ? {
            pageMode: pageModes[0]
        } : {},
        ...pageModes.length > 1 ? {
            pageMode: 'mixed',
            pageModes: pageModes
        } : {},
        ...remixTypes.length === 1 ? {
            remixType: remixTypes[0]
        } : {},
        ...remixTypes.length > 1 ? {
            remixType: 'mixed',
            remixTypes: remixTypes
        } : {},
        featureArea: featureArea,
        embedCount: registrations.length,
        loadAttemptId: session.loadTiming.id,
        viewTrackingMode: 'deadline'
    };
};
const $5b226df072c0ec4b$var$maybeDeleteSession = (session)=>{
    if ([
        ...session.embeds.values()
    ].every(({ mounted: mounted })=>!mounted)) {
        if (!session.loadTiming.stopped) return;
        if (!session.stopped && session.settleTimer !== undefined) return;
        if (session.stopped && session.pageSessionId !== undefined) {
            if (session.retentionTimer === undefined) session.retentionTimer = setTimeout(()=>{
                session.retentionTimer = undefined;
                $5b226df072c0ec4b$var$deleteSession(session);
            }, $5b226df072c0ec4b$export$9e0b5888c5f4a026);
            return;
        }
        $5b226df072c0ec4b$var$deleteSession(session);
    }
};
const $5b226df072c0ec4b$var$abortForNavigation = (session, abortReason = 'navigation')=>{
    $5b226df072c0ec4b$var$finishLoad(session, 'abort', {
        abortReason: abortReason
    });
    if (session.stopped) return;
    $5b226df072c0ec4b$var$clearSettleTimer(session);
    session.stopped = true;
    try {
        session.experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_VIEW_LIMITED,
            reason: abortReason === 'navigation' ? 'User navigated away before Remix embeds finished rendering' : 'Remix embed lifecycle ended before rendering completed',
            attributes: $5b226df072c0ec4b$var$buildPageAttributes(session, {
                abortReason: abortReason
            })
        });
    } catch  {
    // Reliability instrumentation must never surface errors into the host product.
    }
};
const $5b226df072c0ec4b$var$buildLoadAttributes = (session, attributes)=>{
    const timing = session.loadTiming;
    const elapsedMs = Math.round((timing.readyAt ?? performance.now()) - timing.startedAt);
    return {
        ...$5b226df072c0ec4b$var$buildPageAttributes(session, attributes),
        loadAttemptId: timing.id,
        viewTrackingMode: 'eventual',
        loadStartedAtEpochMs: timing.startedAtEpochMs,
        loadElapsedMs: elapsedMs,
        timingOrigin: 'first-embed-registration',
        timedOutEmbedCount: [
            ...session.embeds.values()
        ].filter(({ timedOut: timedOut })=>timedOut).length,
        pendingEmbedCount: [
            ...session.embeds.values()
        ].filter(({ loadOutcome: loadOutcome })=>loadOutcome === 'pending').length
    };
};
const $5b226df072c0ec4b$var$LOAD_TIME_BUCKETS = [
    [
        15000,
        '0-15s'
    ],
    [
        30000,
        '15-30s'
    ],
    [
        45000,
        '30-45s'
    ],
    [
        60000,
        '45-60s'
    ]
];
const $5b226df072c0ec4b$var$getLoadTimeBucket = (elapsedMs)=>$5b226df072c0ec4b$var$LOAD_TIME_BUCKETS.find(([upperBoundMs])=>elapsedMs < upperBoundMs)?.[1] ?? '60s+';
// This parallel experience has no deadline: timeout failures go to REMIX_VIEW_LIMITED,
// while this one measures the existing readiness signals until the lifecycle ends.
const $5b226df072c0ec4b$var$finishLoad = (session, outcome, attributes, error)=>{
    const timing = session.loadTiming;
    if (timing.stopped) return;
    timing.stopped = true;
    clearTimeout(timing.settleTimer);
    const options = {
        name: (0, $irnO2.ExperienceName).REMIX_VIEW,
        attributes: $5b226df072c0ec4b$var$buildLoadAttributes(session, attributes)
    };
    try {
        if (outcome === 'success') {
            const elapsedMs = options.attributes.loadElapsedMs;
            session.experienceTracker.succeed({
                ...options,
                attributes: {
                    ...options.attributes,
                    loadTimeBucket: $5b226df072c0ec4b$var$getLoadTimeBucket(elapsedMs)
                }
            });
        } else if (outcome === 'failure') session.experienceTracker.fail({
            ...options,
            error: error
        });
        else session.experienceTracker.abort({
            ...options,
            reason: 'Remix load lifecycle ended before all readiness signals were received'
        });
    } catch  {
    // Timing instrumentation must never interrupt rendering or the existing SLI.
    }
    $5b226df072c0ec4b$var$maybeDeleteSession(session);
};
const $5b226df072c0ec4b$var$scheduleLoadSuccess = (session)=>{
    const timing = session.loadTiming;
    if (timing.stopped) return;
    clearTimeout(timing.settleTimer);
    if ([
        ...session.embeds.values()
    ].some(({ loadOutcome: loadOutcome })=>loadOutcome !== 'success')) return;
    timing.readyAt = performance.now();
    timing.settleTimer = setTimeout(()=>$5b226df072c0ec4b$var$finishLoad(session, 'success'), $5b226df072c0ec4b$export$7a32db6356bb4e42);
};
const $5b226df072c0ec4b$var$getMatchingSession = (experienceTracker, pageSessionKey, pageSessionId)=>{
    const session = $5b226df072c0ec4b$var$sessions.get($5b226df072c0ec4b$var$getPageSessionKey(experienceTracker, pageSessionKey));
    if (pageSessionId !== undefined && session?.pageSessionId !== undefined && session.pageSessionId !== pageSessionId) return undefined;
    return session;
};
const $5b226df072c0ec4b$var$emitPageSuccess = (session)=>{
    session.stopped = true;
    $5b226df072c0ec4b$var$clearSettleTimer(session);
    try {
        session.experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_VIEW_LIMITED,
            attributes: $5b226df072c0ec4b$var$buildPageAttributes(session)
        });
    } catch  {
    // Reliability instrumentation must never surface errors into the host product.
    } finally{
        $5b226df072c0ec4b$var$maybeDeleteSession(session);
    }
};
const $5b226df072c0ec4b$var$schedulePageSuccess = (session)=>{
    $5b226df072c0ec4b$var$clearSettleTimer(session);
    if (session.stopped || session.embeds.size === 0 || [
        ...session.embeds.values()
    ].some(({ outcome: outcome })=>outcome === 'pending')) return;
    session.settleTimer = setTimeout(()=>{
        session.settleTimer = undefined;
        if (session.stopped || [
            ...session.embeds.values()
        ].some(({ outcome: outcome })=>outcome === 'pending')) return;
        $5b226df072c0ec4b$var$emitPageSuccess(session);
    }, $5b226df072c0ec4b$export$7a32db6356bb4e42);
};
const $5b226df072c0ec4b$export$d4399fd288b2f776 = ({ experienceTracker: experienceTracker, pageSessionKey: pageSessionKey, pageSessionId: pageSessionId })=>{
    const session = $5b226df072c0ec4b$var$getMatchingSession(experienceTracker, pageSessionKey, pageSessionId);
    if (!session) return;
    if (!session.loadTiming.stopped) {
        if ([
            ...session.embeds.values()
        ].every(({ loadOutcome: loadOutcome })=>loadOutcome === 'success')) $5b226df072c0ec4b$var$finishLoad(session, 'success');
        else $5b226df072c0ec4b$var$finishLoad(session, 'abort', {
            abortReason: 'navigation'
        });
    }
    if (!session.stopped) {
        const hasPendingEmbed = [
            ...session.embeds.values()
        ].some(({ outcome: outcome })=>outcome === 'pending');
        if (hasPendingEmbed) $5b226df072c0ec4b$var$abortForNavigation(session);
        else $5b226df072c0ec4b$var$emitPageSuccess(session);
    }
    $5b226df072c0ec4b$var$deleteSession(session);
};
const $5b226df072c0ec4b$var$onBrowserPageHide = (event)=>{
    // A cached document can resume with its existing mounted embeds and callbacks.
    if (event.persisted) return;
    for (const session of [
        ...$5b226df072c0ec4b$var$sessions.values()
    ])$5b226df072c0ec4b$export$d4399fd288b2f776({
        experienceTracker: session.experienceTracker,
        pageSessionId: session.pageSessionId,
        pageSessionKey: session.pageSessionKey
    });
};
const $5b226df072c0ec4b$export$cb3020a9073d498 = ()=>{
    $5b226df072c0ec4b$var$sessions.forEach((session)=>{
        $5b226df072c0ec4b$var$clearRetentionTimer(session);
        $5b226df072c0ec4b$var$clearSettleTimer(session);
        clearTimeout(session.loadTiming.settleTimer);
        session.embeds.forEach(({ releaseTimer: releaseTimer })=>clearTimeout(releaseTimer));
    });
    $5b226df072c0ec4b$var$sessions.clear();
    if (typeof window !== 'undefined') window.removeEventListener('pagehide', $5b226df072c0ec4b$var$onBrowserPageHide);
};
const $5b226df072c0ec4b$export$ef65af575653d375 = ({ attributes: attributes = {}, embedId: embedId, experienceTracker: experienceTracker, pageSessionKey: pageSessionKey, pageSessionId: pageSessionId, renderIdentity: renderIdentity })=>{
    const resolvedPageSessionKey = $5b226df072c0ec4b$var$getPageSessionKey(experienceTracker, pageSessionKey);
    let session = $5b226df072c0ec4b$var$sessions.get(resolvedPageSessionKey);
    if (session && pageSessionId !== undefined && session.pageSessionId !== undefined && session.pageSessionId !== pageSessionId) {
        $5b226df072c0ec4b$var$abortForNavigation(session);
        $5b226df072c0ec4b$var$deleteSession(session);
        session = undefined;
    }
    if (!session) {
        session = {
            embeds: new Map(),
            experienceTracker: experienceTracker,
            pageSessionId: pageSessionId,
            pageSessionKey: resolvedPageSessionKey,
            stopped: false,
            loadTiming: {
                id: crypto.randomUUID(),
                startedAt: performance.now(),
                startedAtEpochMs: Date.now(),
                stopped: false
            }
        };
        $5b226df072c0ec4b$var$sessions.set(resolvedPageSessionKey, session);
        if (typeof window !== 'undefined') window.addEventListener('pagehide', $5b226df072c0ec4b$var$onBrowserPageHide);
    } else if (session.pageSessionId === undefined && pageSessionId !== undefined) session.pageSessionId = pageSessionId;
    if (session.stopped && session.loadTiming.stopped) return;
    let existing = session.embeds.get(embedId);
    // Media instances and registration order can change when the renderer is replaced.
    if (!existing && renderIdentity !== undefined) {
        const released = [
            ...session.embeds.entries()
        ].find(([, registration])=>!registration.mounted && registration.renderIdentity === renderIdentity);
        if (released) {
            const [releasedId, registration] = released;
            session.embeds.delete(releasedId);
            existing = registration;
        }
    }
    $5b226df072c0ec4b$var$clearRetentionTimer(session);
    clearTimeout(existing?.releaseTimer);
    if (!existing) {
        $5b226df072c0ec4b$var$clearSettleTimer(session);
        clearTimeout(session.loadTiming.settleTimer);
        session.loadTiming.readyAt = undefined;
    }
    session.embeds.set(embedId, {
        attributes: {
            ...existing?.attributes,
            ...attributes
        },
        mounted: true,
        outcome: existing?.outcome ?? 'pending',
        loadOutcome: existing?.loadOutcome ?? 'pending',
        renderIdentity: renderIdentity,
        timedOut: existing?.timedOut
    });
    if (!session.loadTiming.stopped) {
        const options = {
            name: (0, $irnO2.ExperienceName).REMIX_VIEW,
            attributes: $5b226df072c0ec4b$var$buildLoadAttributes(session)
        };
        try {
            if (session.embeds.size === 1 && !existing) experienceTracker.start({
                ...options,
                id: session.loadTiming.id
            });
            else experienceTracker.updateAttributes(options);
        } catch  {
        // Timing instrumentation must not prevent the existing SLI from starting.
        }
    }
    if (session.stopped) return;
    if (session.embeds.size === 1 && !existing) {
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_VIEW_LIMITED,
            id: `${session.loadTiming.id}:limited`,
            attributes: $5b226df072c0ec4b$var$buildPageAttributes(session)
        });
        return;
    }
    experienceTracker.updateAttributes({
        name: (0, $irnO2.ExperienceName).REMIX_VIEW_LIMITED,
        attributes: $5b226df072c0ec4b$var$buildPageAttributes(session)
    });
};
const $5b226df072c0ec4b$export$b95e3dc3d266ee01 = ({ embedId: embedId, experienceTracker: experienceTracker, pageSessionKey: pageSessionKey, pageSessionId: pageSessionId })=>{
    const session = $5b226df072c0ec4b$var$getMatchingSession(experienceTracker, pageSessionKey, pageSessionId);
    const registration = session?.embeds.get(embedId);
    if (!registration?.mounted) return;
    if (session && !session.loadTiming.stopped && registration?.loadOutcome === 'pending') {
        registration.loadOutcome = 'success';
        $5b226df072c0ec4b$var$scheduleLoadSuccess(session);
    }
    if (!session || session.stopped || !registration || registration.outcome !== 'pending') return;
    registration.outcome = 'success';
    $5b226df072c0ec4b$var$schedulePageSuccess(session);
};
const $5b226df072c0ec4b$export$e32d8bad21307b6b = ({ attributes: attributes, embedId: embedId, error: error, errorType: errorType, experienceTracker: experienceTracker, pageSessionKey: pageSessionKey, pageSessionId: pageSessionId })=>{
    const session = $5b226df072c0ec4b$var$getMatchingSession(experienceTracker, pageSessionKey, pageSessionId);
    const registration = session?.embeds.get(embedId);
    if (!registration?.mounted) return;
    if (session && !session.loadTiming.stopped && registration?.loadOutcome === 'pending') {
        if (errorType === 'render_timeout') registration.timedOut = true;
        else {
            registration.loadOutcome = 'fail';
            $5b226df072c0ec4b$var$finishLoad(session, 'failure', {
                ...attributes,
                errorType: errorType
            }, error);
        }
    }
    if (!session || session.stopped || !registration || registration.outcome !== 'pending') return;
    $5b226df072c0ec4b$var$clearSettleTimer(session);
    registration.attributes = {
        ...registration.attributes,
        ...attributes,
        ...errorType ? {
            errorType: errorType
        } : {}
    };
    registration.outcome = 'fail';
    session.stopped = true;
    try {
        experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).REMIX_VIEW_LIMITED,
            error: error,
            attributes: $5b226df072c0ec4b$var$buildPageAttributes(session, registration.attributes)
        });
    } catch  {
    // Reliability instrumentation must never surface errors into the host product.
    } finally{
        $5b226df072c0ec4b$var$maybeDeleteSession(session);
    }
};
const $5b226df072c0ec4b$export$3b54b805af8cd1ae = ({ embedId: embedId, experienceTracker: experienceTracker, pageSessionKey: pageSessionKey, pageSessionId: pageSessionId })=>{
    const session = $5b226df072c0ec4b$var$getMatchingSession(experienceTracker, pageSessionKey, pageSessionId);
    const registration = session?.embeds.get(embedId);
    if (!session || !registration) return;
    registration.mounted = false;
    const hasPendingOutcome = !session.loadTiming.stopped && registration.loadOutcome === 'pending' || !session.stopped && registration.outcome === 'pending';
    if (hasPendingOutcome) {
        if (session.pageSessionId === undefined) $5b226df072c0ec4b$var$abortForNavigation(session);
        else if (registration.releaseTimer === undefined) registration.releaseTimer = setTimeout(()=>{
            registration.releaseTimer = undefined;
            if (!registration.mounted && $5b226df072c0ec4b$var$sessions.get(session.pageSessionKey) === session) {
                $5b226df072c0ec4b$var$abortForNavigation(session, 'lifecycle_ended');
                $5b226df072c0ec4b$var$maybeDeleteSession(session);
            }
        }, $5b226df072c0ec4b$export$9e0b5888c5f4a026);
    }
    $5b226df072c0ec4b$var$maybeDeleteSession(session);
};
module.exports["retireRemixViewPageSession"] = $5b226df072c0ec4b$export$d4399fd288b2f776;
module.exports["beginRemixEmbedRender"] = $5b226df072c0ec4b$export$ef65af575653d375;
module.exports["completeRemixEmbedRender"] = $5b226df072c0ec4b$export$b95e3dc3d266ee01;
module.exports["failRemixEmbedRender"] = $5b226df072c0ec4b$export$e32d8bad21307b6b;
module.exports["releaseRemixEmbedRender"] = $5b226df072c0ec4b$export$3b54b805af8cd1ae;

});

parcelRegister("iBsvI", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

function $a0b10823d5792e1c$export$63b2cbfa1855c730({ remixType: remixType, existingFeatureArea: existingFeatureArea }) {
    if (!(0, $4o0zT.isExperimentEnabled)('maui_remix_feature_area_by_type_exp_gate')) return existingFeatureArea;
    return remixType ? `remix-${remixType}` : existingFeatureArea ?? 'remix';
}
module.exports["getRemixFeatureArea"] = $a0b10823d5792e1c$export$63b2cbfa1855c730;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("b6fxF", function(module, exports) {
/* UserProfileCardForMention.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
const $0b67b0fc1e6d3033$var$mentionPopupStyles = {
    hidden: "_0fKRyPnQyn _1pp6NdYbGa"
};
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
            isReduced: isReduced
        }),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent,
            customerCardDataLoader: customerCardDataLoader,
            isReduced: isReduced
        }
    });
} /**
   * Props common to both render paths.
   */ 
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, {
            ...props
        })
    });
} /** Inner implementation of {@link UserProfileCardForMention}. */ 
function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', shouldFitViewport: shouldFitViewport = false, trigger: trigger, testId: testId, agent: agent, isReduced: isReduced, analyticsAttributes: analyticsAttributes, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, onOpen: onOpen }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            isReduced: isReduced
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        isReduced,
        environmentProvider
    ]); // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    if (!referenceElement) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        shouldFitViewport: shouldFitViewport,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        isReduced: isReduced,
        analyticsAttributes: analyticsAttributes,
        prefilledProfileData: prefilledProfileData,
        customerCardDataLoader: customerCardDataLoader,
        onOpen: onOpen,
        shouldRenderToParent: false,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
                onError: onErrorBoundary,
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cK21K.default), {
                    zIndex: (0, $jp2Q3.layers).modal(),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                        referenceElement: referenceElement,
                        placement: placement,
                        children: ({ ref: ref, style: style, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                ref: ref,
                                style: style,
                                xcss: isReferenceHidden ? $0b67b0fc1e6d3033$var$mentionPopupStyles.hidden : undefined,
                                testId: testId ? `${testId}--mention-popup` : undefined,
                                children: entryPointReference ? /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$PopperContent, {
                                    entryPointReference: entryPointReference,
                                    entryPointErrorFallback: entryPointErrorFallback,
                                    cloudId: cloudId,
                                    testId: testId,
                                    agent: agent,
                                    customerCardDataLoader: customerCardDataLoader,
                                    isReduced: isReduced
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
                                    isReduced: isReduced
                                })
                            })
                    })
                })
            })
        ]
    });
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("6GQtz", function(module, exports) {

var $6RwwD = parcelRequire("6RwwD");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $6RwwD.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if (this.shouldDisplayAsEmbed(url)) return 'embed';
        if (this.shouldDisplayAsCard(url)) return 'block';
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow. Both active
   * cohorts of the quick-insert embeds experiment (`prioritizeLinkInQIM` and
   * `prioritizeEmbedInQIM`) enable this — they differ only in quick-insert menu
   * ordering, not in embedding behaviour. Only `control` and unenrolled users keep
   * the existing behaviour.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference, so the exposure here is
   * scoped to the quick-insert embed insertion path.
   */ shouldHonorRequestedEmbedAsDefault() {
        return (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("6RwwD", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $6Q8Dd = parcelRequire("6Q8Dd");


var $8OcYi = parcelRequire("8OcYi");


var $3ewaO = parcelRequire("3ewaO");


var $4yccB = parcelRequire("4yccB");


var $kzwaO = parcelRequire("kzwaO");


var $cXJjm = parcelRequire("cXJjm");


var $ggGdk = parcelRequire("ggGdk");


var $drRzc = parcelRequire("drRzc");


var $iDrrr = parcelRequire("iDrrr");


var $biKbJ = parcelRequire("biKbJ");


var $iyuxZ = parcelRequire("iyuxZ");


var $koAyx = parcelRequire("koAyx");


var $8kONW = parcelRequire("8kONW");

const $d4521f0694a3bb0e$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $d4521f0694a3bb0e$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $d4521f0694a3bb0e$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX = /^https:\/\/(.*?\.)?loom\..*?\/(?:playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/view)?|embed\/playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\?|$)/i;
const $d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $d4521f0694a3bb0e$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
const $d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $d4521f0694a3bb0e$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $d4521f0694a3bb0e$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$ARTIFACT_UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
// Keep in sync with ARTIFACT_URL_PATTERNS in @atlassian/native-embeds-artifacts-experience
const $d4521f0694a3bb0e$var$ARTIFACT_SHARE_REGEX = [
    new RegExp(`/artifacts/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}(?:[/?#].*)?$`),
    new RegExp(`/apps/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}/[^?#]*\\?(?:[^#]*&)?smartlink=artifact`)
];
const $d4521f0694a3bb0e$var$DASHBOARDS_CHART_VIEW_REGEX = /^https:\/\/.*?\/dashboards\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX = /^https:\/\/[^/?#]+\/wiki\/x\/[A-Za-z0-9_-]+\/?(?:[?#].*)?$/;
const $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX);
const $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $d4521f0694a3bb0e$var$isPolarisView = (url)=>url.match($d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJwmView = (url)=>url.match($d4521f0694a3bb0e$var$JWM_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJiraList = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_LIST_REGEX);
const $d4521f0694a3bb0e$var$isGiphyMedia = (url)=>url.match($d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX);
const $d4521f0694a3bb0e$var$isProformaView = (url)=>url.match($d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceWhiteboard = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceDatabase = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX);
const $d4521f0694a3bb0e$var$isYoutubeVideo = (url)=>url.match($d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX);
const $d4521f0694a3bb0e$var$isLoomVideoUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomPlaylistUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomScreenshotUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraDashboard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBacklog = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBoard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraPlan = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_PLAN_REGEX) || url.match($d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraVersion = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_VERSION_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraForm = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_FORM_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraSummary = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX);
};
const $d4521f0694a3bb0e$var$isRovoAgentProfilePage = (url)=>{
    return url.match($d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $d4521f0694a3bb0e$var$isCustomer360LandingPage = (url)=>url.match($d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceTeamCalendars = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $d4521f0694a3bb0e$var$isJiraIssueNavigator = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $d4521f0694a3bb0e$var$isAvpVisualizationView = (url)=>url.match($d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX) || ((0, $iDrrr.fg)('platform_avp_viz_dashboard_link_embed') ? url.match($d4521f0694a3bb0e$var$DASHBOARDS_CHART_VIEW_REGEX) : null);
const $d4521f0694a3bb0e$var$isArtifactsShareView = (url)=>{
    for (const pattern of $d4521f0694a3bb0e$var$ARTIFACT_SHARE_REGEX){
        const match = url.match(pattern);
        if (match) return match;
    }
    return null;
};
const $d4521f0694a3bb0e$export$6a9668b99d8a1708 = (url)=>$d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $d4521f0694a3bb0e$var$isConfluenceSlide = (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $d4521f0694a3bb0e$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline,
    isPolarisView: $d4521f0694a3bb0e$var$isPolarisView,
    isJwmView: $d4521f0694a3bb0e$var$isJwmView,
    isJiraList: $d4521f0694a3bb0e$var$isJiraList,
    isConfluenceWhiteboard: $d4521f0694a3bb0e$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $d4521f0694a3bb0e$var$isConfluenceDatabase,
    isConfluenceSlide: $d4521f0694a3bb0e$var$isConfluenceSlide,
    isJiraDashboard: $d4521f0694a3bb0e$var$isJiraDashboard,
    isJiraBacklog: $d4521f0694a3bb0e$var$isJiraBacklog,
    isJiraBoard: $d4521f0694a3bb0e$var$isJiraBoard,
    isJiraPlan: $d4521f0694a3bb0e$var$isJiraPlan,
    isJiraVersion: $d4521f0694a3bb0e$var$isJiraVersion,
    isJiraForm: $d4521f0694a3bb0e$var$isJiraForm,
    isJiraSummary: $d4521f0694a3bb0e$var$isJiraSummary,
    isRovoAgentProfilePage: $d4521f0694a3bb0e$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $d4521f0694a3bb0e$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $d4521f0694a3bb0e$var$isJiraIssueNavigator
};
function $d4521f0694a3bb0e$export$4006295459a20a0(url) {
    return Object.values($d4521f0694a3bb0e$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $d4521f0694a3bb0e$export$78234eee43b97e81(url) {
    return !$d4521f0694a3bb0e$export$4006295459a20a0(url);
}
function $d4521f0694a3bb0e$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $d4521f0694a3bb0e$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $d4521f0694a3bb0e$export$e4635c0135e1a519 extends (0, $drRzc.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $ggGdk.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $ggGdk.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$d4521f0694a3bb0e$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? $d4521f0694a3bb0e$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$d4521f0694a3bb0e$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $biKbJ.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $d4521f0694a3bb0e$var$isJiraPlan(url);
        const isJiraFormEvaluated = $d4521f0694a3bb0e$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $d4521f0694a3bb0e$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $iDrrr.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $d4521f0694a3bb0e$var$isConfluenceTeamCalendars(url);
        if ($d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline(url) || $d4521f0694a3bb0e$var$isPolarisView(url) || $d4521f0694a3bb0e$var$isJwmView(url) || $d4521f0694a3bb0e$var$isJiraList(url) || $d4521f0694a3bb0e$var$isGiphyMedia(url) || $d4521f0694a3bb0e$var$isProformaView(url) || $d4521f0694a3bb0e$var$isConfluenceWhiteboard(url) || $d4521f0694a3bb0e$var$isConfluenceDatabase(url) || (0, $8kONW.isConfluenceSlideUrl)(url) || $d4521f0694a3bb0e$var$isYoutubeVideo(url) || $d4521f0694a3bb0e$var$isLoomVideoUrl(url) || $d4521f0694a3bb0e$var$isLoomPlaylistUrl(url) && (0, $iDrrr.fg)('loom-playlist-smartlink-embed-default') || $d4521f0694a3bb0e$var$isLoomScreenshotUrl(url) && (0, $iDrrr.fg)('loom-support-screenshot-sl-resolution') || $d4521f0694a3bb0e$var$isJiraDashboard(url) || $d4521f0694a3bb0e$var$isJiraBacklog(url) || $d4521f0694a3bb0e$var$isJiraBoard(url) || $d4521f0694a3bb0e$var$isRovoAgentProfilePage(url) || $d4521f0694a3bb0e$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $d4521f0694a3bb0e$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $d4521f0694a3bb0e$var$isJiraIssueNavigator(url) || $d4521f0694a3bb0e$var$isAvpVisualizationView(url) || $d4521f0694a3bb0e$var$isArtifactsShareView(url) && (0, $iDrrr.fg)('platform_forge_ui_artifact_confluence_integration')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    async resolvesToHardCodedEmbed(url) {
        try {
            const response = await this.fetchData(url);
            const resolvedUrl = (0, $3ewaO.extractSmartLinkUrl)(response);
            return resolvedUrl !== undefined && this.getHardCodedAppearance(resolvedUrl) === 'embed';
        } catch  {
            return false;
        }
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $ggGdk.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $8OcYi.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $iDrrr.fg)('issue-link-suggestions-in-comments')) {
                if ($d4521f0694a3bb0e$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                const isNativeEmbedShortlinkResolutionEnabled = (0, $iDrrr.fg)('platform_native_embeds_enable_shortlink_resolution');
                const shouldResolveShortLinkForEmbed = isNativeEmbedShortlinkResolutionEnabled && matchedProviderPattern !== undefined && $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl(url) && userPreference === undefined && isEmbedFriendlyLocationEvaluated;
                // Confluence shortlinks do not identify their content type. Resolve the URL before
                // deciding whether it should use one of the existing hardcoded embed appearances.
                if (shouldResolveShortLinkForEmbed && await this.resolvesToHardCodedEmbed(url)) preferredAppearance = 'embed';
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $koAyx.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $d4521f0694a3bb0e$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $4yccB.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $d4521f0694a3bb0e$export$b7c3c9a99f7959f5 = new $d4521f0694a3bb0e$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $d4521f0694a3bb0e$export$4006295459a20a0;
module.exports["isExternalUrl"] = $d4521f0694a3bb0e$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $d4521f0694a3bb0e$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $d4521f0694a3bb0e$export$b7c3c9a99f7959f5;

});

parcelRegister("6Q8Dd", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $4fae4b715d22864c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $4fae4b715d22864c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $4fae4b715d22864c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $4fae4b715d22864c$var$getValidCacheKeyFn(options);
        this._cacheMap = $4fae4b715d22864c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $4fae4b715d22864c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $4fae4b715d22864c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$4fae4b715d22864c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $4fae4b715d22864c$var$enqueuePostPromiseJob = typeof $1P2f3 === 'object' && typeof $1P2f3.nextTick === 'function' ? function(fn) {
    if (!$4fae4b715d22864c$var$resolvedPromise) $4fae4b715d22864c$var$resolvedPromise = Promise.resolve();
    $4fae4b715d22864c$var$resolvedPromise.then(function() {
        $1P2f3.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $4fae4b715d22864c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $4fae4b715d22864c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $4fae4b715d22864c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $4fae4b715d22864c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $4fae4b715d22864c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$4fae4b715d22864c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $4fae4b715d22864c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $4fae4b715d22864c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $4fae4b715d22864c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $4fae4b715d22864c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $4fae4b715d22864c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $4fae4b715d22864c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $4fae4b715d22864c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $4fae4b715d22864c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $4fae4b715d22864c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $4fae4b715d22864c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $4fae4b715d22864c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $4fae4b715d22864c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $4fae4b715d22864c$var$DataLoader;

});

parcelRegister("4yccB", function(module, exports) {

var $QO4PV = parcelRequire("QO4PV");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $iKWdo = parcelRequire("iKWdo");


var $lPEt0 = parcelRequire("lPEt0");


var $axuex = parcelRequire("axuex");


var $j39Hd = parcelRequire("j39Hd");


var $ixC10 = parcelRequire("ixC10");


var $cXJjm = parcelRequire("cXJjm");


var $grief = parcelRequire("grief");


var $2g31M = parcelRequire("2g31M");


var $ggGdk = parcelRequire("ggGdk");


var $iDrrr = parcelRequire("iDrrr");


var $c2kDy = parcelRequire("c2kDy");


var $44Sj0 = parcelRequire("44Sj0");

const $614b823604b25d0c$var$MAX_BATCH_SIZE = 50;
const $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE = 100;
const $614b823604b25d0c$export$d6a66073b5d79eb3 = new (0, $lPEt0.LRUMap)($614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE);
const $614b823604b25d0c$var$urlResponseInFlightCache = new Map();
class $614b823604b25d0c$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($axuex)))({
            limit: 1,
            interval: $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $614b823604b25d0c$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $grief.InvalidUrlError)(error);
        }
    }
    async resolveUrlWithoutInlineOptimization(url, hostname, force) {
        let responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined
            });
            $614b823604b25d0c$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async resolveUrlWithInlineOptimization(url, hostname, force, appearance) {
        const cacheKey = `${url}|${appearance}`;
        const inFlightCacheKey = JSON.stringify([
            url,
            appearance,
            force
        ]);
        let responsePromise = $614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey);
        if (!responsePromise) {
            responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(cacheKey);
            if (!responsePromise || force) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    appearance: appearance
                });
                $614b823604b25d0c$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
                $614b823604b25d0c$var$urlResponseInFlightCache.set(inFlightCacheKey, responsePromise);
            }
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
            throw e;
        } finally{
            if ($614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey) === responsePromise) $614b823604b25d0c$var$urlResponseInFlightCache.delete(inFlightCacheKey);
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        if (appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return this.resolveUrlWithInlineOptimization(url, hostname, force, appearance);
        return this.resolveUrlWithoutInlineOptimization(url, hostname, force);
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $44Sj0.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $44Sj0.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $c2kDy.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $44Sj0.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $c2kDy.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $2g31M.NetworkError)) return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $ixC10.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $ixC10.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $ixC10.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $ixC10.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>{
                // Appearance is only added to the payload when the inline resolve optimization gate is on.
                // Preserve differently shaped requests for the same URL so a reduced inline response cannot
                // be returned to a block request from the same batch.
                if (resource.appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return JSON.stringify([
                    resource.resourceUrl,
                    resource.appearance,
                    resource.ignoreCachedValue === true
                ]);
                return resource.resourceUrl;
            });
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $614b823604b25d0c$export$2e2bcd8739ae039;

});

parcelRegister("QO4PV", function(module, exports) {
// Packages

var $lbZ9z = parcelRequire("lbZ9z");

function $09ebb3b1b19cd625$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $lbZ9z.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $09ebb3b1b19cd625$var$retry;

});

parcelRegister("lbZ9z", function(module, exports) {

module.exports = (parcelRequire("4co4r"));

});

parcelRegister("4co4r", function(module, exports) {

var $8xi9I = parcelRequire("8xi9I");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8xi9I(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("8xi9I", function(module, exports) {
function $636f7d2929f63478$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $636f7d2929f63478$var$RetryOperation;
$636f7d2929f63478$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$636f7d2929f63478$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$636f7d2929f63478$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$636f7d2929f63478$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = $636f7d2929f63478$var$RetryOperation.prototype.try;
$636f7d2929f63478$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$636f7d2929f63478$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("lPEt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
}); //# sourceMappingURL=lru.js.map

});

parcelRegister("axuex", function(module, exports) {
'use strict';
class $7ac4702e317338af$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $7ac4702e317338af$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $7ac4702e317338af$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $7ac4702e317338af$var$pThrottle;
module.exports.AbortError = $7ac4702e317338af$var$AbortError;

});

parcelRegister("j39Hd", function(module, exports) {

var $2g31M = parcelRequire("2g31M");

const $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $53f448a1a60c9e76$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $2g31M.NetworkError)(error);
        throw error;
    }
}
module.exports["request"] = $53f448a1a60c9e76$export$b5fe3f66a567bec0;

});

parcelRegister("2g31M", function(module, exports) {
class $70283a430bb4f4fe$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
module.exports["NetworkError"] = $70283a430bb4f4fe$export$bae979e68e4dc802;

});

parcelRegister("ixC10", function(module, exports) {
class $5661a24319617f8d$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $5661a24319617f8d$export$3e5b797e39668f84;

});

parcelRegister("cXJjm", function(module, exports) {

var $kzwaO = parcelRequire("kzwaO");

const $aee62c7b870e0d6a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
module.exports["getResolverUrl"] = $aee62c7b870e0d6a$export$dc37652c1696f231;

});

parcelRegister("kzwaO", function(module, exports) {

var $4B79C = parcelRequire("4B79C");

const $445f8294ba7508fe$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $4B79C.prodBaseUrl);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $4B79C.BaseUrls) ? (0, $4B79C.BaseUrls)[envKey] : (0, $4B79C.prodBaseUrl);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
module.exports["getBaseUrl"] = $445f8294ba7508fe$export$f654b28f82155665;

});

parcelRegister("4B79C", function(module, exports) {
const $ef9de7657ea9d2d2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $ef9de7657ea9d2d2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $ef9de7657ea9d2d2$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $ef9de7657ea9d2d2$export$e2b040f052407032 = {
    dev: $ef9de7657ea9d2d2$var$devBaseUrl,
    development: $ef9de7657ea9d2d2$var$devBaseUrl,
    stg: $ef9de7657ea9d2d2$var$stgBaseUrl,
    staging: $ef9de7657ea9d2d2$var$stgBaseUrl,
    prd: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    prod: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    production: $ef9de7657ea9d2d2$export$7469f9cd9cda802c
};
var $ef9de7657ea9d2d2$export$2e2bcd8739ae039 = $ef9de7657ea9d2d2$export$e2b040f052407032;
module.exports["prodBaseUrl"] = $ef9de7657ea9d2d2$export$7469f9cd9cda802c;
module.exports["BaseUrls"] = $ef9de7657ea9d2d2$export$e2b040f052407032;

});

parcelRegister("grief", function(module, exports) {
class $8165f67089b396cb$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
module.exports["InvalidUrlError"] = $8165f67089b396cb$export$19fa02dd69bd4efd;

});

parcelRegister("ggGdk", function(module, exports) {
const $b75c372cb2906748$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $b75c372cb2906748$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $b75c372cb2906748$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $b75c372cb2906748$export$b70265791d2079d4;

});

parcelRegister("c2kDy", function(module, exports) {
const $3cbc4520680d3a92$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isErrorResponse"] = $3cbc4520680d3a92$export$bea7bee8a87e7c52;

});

parcelRegister("44Sj0", function(module, exports) {
const $d86f0936ed92dc7f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
module.exports["isSuccessfulResponse"] = $d86f0936ed92dc7f$export$1b59fe731a28a49d;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("biKbJ", function(module, exports) {
const $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $57ceb58159fd0951$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $57ceb58159fd0951$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $57ceb58159fd0951$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $57ceb58159fd0951$export$b5fe3f66a567bec0;

});

parcelRegister("iyuxZ", function(module, exports) {

var $f9XbP = parcelRequire("f9XbP");


var $iDrrr = parcelRequire("iDrrr");

var $842937149a04b8ba$var$_SmartCardLocalCacheClient;
const $842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $842937149a04b8ba$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $842937149a04b8ba$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$842937149a04b8ba$export$1987ad1ab31f2528.instance) $842937149a04b8ba$export$1987ad1ab31f2528.instance = new $842937149a04b8ba$export$1987ad1ab31f2528(maxItems);
        return $842937149a04b8ba$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $f9XbP.StorageClient)($842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.documentCache = {};
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) // Keep restored session data out of this cache if the gate changes after initialization.
            return this.documentCache;
            else return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached
     */ this.setItem = (url, response)=>{
            if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) {
                this.documentCache[url] = {
                    data: response,
                    timestamp: Date.now()
                };
                const cacheKeys = Object.keys(this.documentCache);
                if (cacheKeys.length > this.maxItems) {
                    const sortedKeys = cacheKeys.sort((a, b)=>this.documentCache[a].timestamp - this.documentCache[b].timestamp);
                    const itemsToRemove = cacheKeys.length - this.maxItems;
                    const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                    keysToRemove.forEach((key)=>{
                        delete this.documentCache[key];
                    });
                }
            } else {
                // Add or update the item in the cache with current timestamp
                this.memoryCache[url] = {
                    data: response,
                    timestamp: Date.now()
                };
                // Apply FIFO behavior if cache exceeds maxItems
                const cacheKeys = Object.keys(this.memoryCache);
                if (cacheKeys.length > this.maxItems) {
                    // Sort keys by timestamp (oldest first) and remove the oldest items
                    const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                    const itemsToRemove = cacheKeys.length - this.maxItems;
                    const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                    keysToRemove.forEach((key)=>{
                        delete this.memoryCache[key];
                    });
                }
                // Write through to storage asynchronously (non-blocking)
                // Debounced to batch multiple rapid calls into a single write
                if (!this.pendingWrite) {
                    this.pendingWrite = true;
                    queueMicrotask(()=>{
                        try {
                            this.storageClient.setItemWithExpiry($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                        } catch (_) {
                        // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                        // Cache will still function in-memory for the session, but won't persist
                        } finally{
                            this.pendingWrite = false;
                        }
                    });
                }
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) return this.documentCache[url]?.data;
            else {
                const response = this.memoryCache?.[url]?.data;
                return response;
            }
        };
        /**
     * Checks if a cached entry exists for the provided url
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) return url in this.documentCache;
            else return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) this.memoryCache = {};
        else {
            // Load cache from storage into memory on instantiation
            const stored = this.storageClient.getItem($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, {
                useExpiredItem: true
            });
            this.memoryCache = stored ? JSON.parse(stored) : {};
        }
    }
}
$842937149a04b8ba$var$_SmartCardLocalCacheClient = $842937149a04b8ba$export$1987ad1ab31f2528;
$842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $842937149a04b8ba$export$1987ad1ab31f2528;

});

parcelRegister("koAyx", function(module, exports) {
class $b7cac00c977cfcad$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b7cac00c977cfcad$export$f993aef960936087;

});

parcelRegister("8kONW", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $025d94307c54f6b4$export$4091d55e0211d2e1 = (url)=>$025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $025d94307c54f6b4$export$4091d55e0211d2e1;

});

parcelRegister("lmNXu", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $vLw8x = parcelRequire("vLw8x");

const $cdf0b5cb977c302e$export$f996105bf70a5c25 = (0, $dOBRD.default)((routesContext, handleLinks)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        },
        ...handleLinks ? {
            link: {
                onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
            }
        } : {}
    } : undefined);
module.exports["createSmartCardEventHandler"] = $cdf0b5cb977c302e$export$f996105bf70a5c25;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("jibmA", function(module, exports) {

var $60cDW = parcelRequire("60cDW");

const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = typeof window !== 'undefined' && window.location ? window.location.hostname : (0, $60cDW.getSSRRenderInputs)().host;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        // Resolve against the current host so relative URLs (e.g. /browse/ABC-1) parse correctly.
        urlObject = url && new URL(url, windowHostname ? `https://${windowHostname}` : undefined);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("1a6Dn", function(module, exports) {

var $hrAmX = parcelRequire("hrAmX");


var $a4dgs = parcelRequire("a4dgs");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $a4dgs.BaseStateContainer) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            // The lookup has to happen inside the updater: updates queued in the same microtask are
            // applied in sequence, so an index resolved beforehand would already be stale.
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index === -1) return {
                    ...state,
                    floatingBanners: [
                        ...state.floatingBanners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                if (state.floatingBanners[index].height !== height) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    // Replace rather than mutate, so the previous state keeps the old height.
                    newArray[index] = {
                        name: name,
                        height: height
                    };
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.hideFloating = (name)=>{
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index > -1) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("hrAmX", function(module, exports) {

var $a4dgs = parcelRequire("a4dgs");


var $8zRYE = parcelRequire("8zRYE");


var $jecot = parcelRequire("jecot");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.findIndex((banner)=>banner.name === name);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $a4dgs.BaseStateContainer) {
    constructor(props = {}){
        super();
        // Resolved unconditionally, even when it is about to be discarded, so that exposure for the
        // nav-height flags is unchanged from before this was extracted into a helper.
        /** Frozen at construction: a mid-session flag flip must not change an instance's arithmetic. */ this.topNavHeight = void 0;
        this.suppressed = void 0;
        this.pendingNotify = null;
        this.unsubscribeFromStore = null;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height.
     * Applied on the next microtask; a suppressed container drops the write entirely.
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if (this.suppressed) return;
            (0, $8zRYE.showBanner)(name, height);
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            if (this.suppressed) return;
            (0, $8zRYE.hideBanner)(name);
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        /**
     * Detaches from the store. unstated gives containers no teardown hook, so any caller that creates
     * short-lived containers — fixtures, tests, anything mounted more than once — must call this, or
     * the store keeps the listener and with it this instance alive for the lifetime of the module.
     */ this.destroy = ()=>{
            this.unsubscribeFromStore?.();
            this.unsubscribeFromStore = null;
        };
        this.scheduleNotify = ()=>{
            if (this.pendingNotify) return;
            this.pendingNotify = Promise.resolve().then(()=>{
                this.pendingNotify = null;
                return this.notifyListeners();
            });
        };
        const navHeight = (0, $jecot.resolveTopNavHeight)();
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.suppressed = props.suppressed === true;
        if (this.suppressed) return;
        (0, $8zRYE.seedBanners)(props.initialState?.banners ?? []);
        this.state = {
            banners: (0, $8zRYE.getBanners)()
        };
        // The mirror is synchronous so a read straight after a flush is fresh; the notification is
        // coalesced, so a tick's worth of store changes costs one round no matter which container
        // (or hook) wrote them.
        this.unsubscribeFromStore = (0, $8zRYE.subscribeToBanners)(()=>{
            this.state = {
                banners: (0, $8zRYE.getBanners)()
            };
            this.scheduleNotify();
        });
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("a4dgs", function(module, exports) {
// unstated is deprecated; new banner state belongs in src/bannerStore.ts
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $5ed4587dbe3a0e20$export$5db0f71585d91cd4 extends (0, $kNIYN.Container) {
    subscribe(fn) {
        this.listeners.add(fn);
    }
    unsubscribe(fn) {
        this.listeners.delete(fn);
    }
    setState(updater, callback) {
        return Promise.resolve().then(()=>{
            const next = typeof updater === 'function' ? updater(this.state) : updater;
            if (next == null) {
                callback?.();
                return;
            }
            this.state = Object.assign({}, this.state, next);
            return this.notifyListeners().then(()=>{
                callback?.();
            });
        });
    }
    notifyListeners() {
        // Snapshot before notifying: a listener's re-render makes unstated's Subscribe unsubscribe
        // and resubscribe, which would mutate the Set mid-iteration.
        const snapshot = Array.from(this.listeners);
        return Promise.all(snapshot.map((listener)=>listener())).then(()=>undefined);
    }
    constructor(...args){
        super(...args);
        this.listeners = new Set();
    }
}
module.exports["BaseStateContainer"] = $5ed4587dbe3a0e20$export$5db0f71585d91cd4;

});

parcelRegister("8zRYE", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");

/**
 * Module store for the page-top banner stack, read through `useSyncExternalStore`.
 *
 * A module store, not a library: see `docs/llm/agent-instructions/common/state-management.md`.
 *
 * Writes are deferred to a microtask and coalesced here rather than in any caller, so every writer —
 * the container shim and the `useBannerState` hooks — inherits it. Notification is synchronous and
 * several banners still call `show`/`hide` from a render body, so an undeferred write would update
 * other components mid-render.
 *
 * Global and unscoped: only three production containers exist — the client root, the SSR root
 * (mutually exclusive with it), and `WithoutBanners`, which is write-free and read-once.
 *
 * SSR: Tesseract isolates each request, so module state is per-request. `handleReactRender.tsx`
 * serialises the server's list into `window.__SSR_BANNERS__`, which this store reads at module init,
 * so the first render — including the hydrating one — matches the server without waiting on a
 * container. The server has no such global, so its seed is an explicit `seedBanners` call from the
 * SSR entry point; that keeps `ssrBannerManager` out of this module.
 *
 * `stableUI=1` (E2E/VR runs) is honoured here, at all three entry points that can change `banners`,
 * rather than in each writer: `ssrBannerManager` registers banners regardless of the URL param, so
 * an unguarded hydration seed would give a hydrating render banners the SSR render dropped, and the
 * `useBannerState` hooks never see the param at all.
 */ /** Frozen so a consumer cannot mutate it, and stable so `getSnapshot` never triggers a re-render. */ const $827d62b6188a5818$var$NO_BANNERS = Object.freeze([]);
/**
 * Read at module init rather than from a component, so the store is populated before anything
 * renders. Entries are validated because the value is deserialised from the page.
 *
 * No `typeof window` guard: the build substitutes `globalThis`, so `window` is always defined in both
 * environments. On the server the property simply is not set, which the `Array.isArray` check already
 * covers — the server seed comes from `seedBanners` instead.
 */ const $827d62b6188a5818$var$readHydrationBanners = ()=>{
    // `Array.isArray` is deliberately first: it short-circuits on the server, where the global is
    // never set, so the request URI — not available this early in module evaluation — is never read.
    if (!Array.isArray(window.__SSR_BANNERS__) || (0, $i3jcY.isStableUIEnabledForTests)()) return $827d62b6188a5818$var$NO_BANNERS;
    const parsed = window.__SSR_BANNERS__.filter((banner)=>typeof banner?.name === 'string' && typeof banner?.height === 'number');
    return parsed.length > 0 ? parsed : $827d62b6188a5818$var$NO_BANNERS;
};
let $827d62b6188a5818$var$banners = $827d62b6188a5818$var$readHydrationBanners();
const $827d62b6188a5818$var$listeners = new Set();
const $827d62b6188a5818$export$49fd326b255f6ddb = ()=>$827d62b6188a5818$var$banners;
const $827d62b6188a5818$export$7cfac2c025b473e4 = (listener)=>{
    $827d62b6188a5818$var$listeners.add(listener);
    return ()=>{
        $827d62b6188a5818$var$listeners.delete(listener);
    };
};
const $827d62b6188a5818$var$commit = (next)=>{
    $827d62b6188a5818$var$banners = next;
    // Snapshot first: a listener may unsubscribe while being notified.
    Array.from($827d62b6188a5818$var$listeners).forEach((listener)=>listener());
};
let $827d62b6188a5818$var$pending = [];
let $827d62b6188a5818$var$pendingFlush = null;
const $827d62b6188a5818$var$enqueue = (mutate)=>{
    // Evaluated per call rather than memoised at module init: an SPA transition changes
    // `window.location.search`, so the param is not a session constant.
    // Hides are dropped along with shows, which is safe because nothing can enter the store.
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    $827d62b6188a5818$var$pending.push(mutate);
    if ($827d62b6188a5818$var$pendingFlush) return;
    $827d62b6188a5818$var$pendingFlush = Promise.resolve().then(()=>{
        $827d62b6188a5818$var$pendingFlush = null;
        const queued = $827d62b6188a5818$var$pending;
        $827d62b6188a5818$var$pending = [];
        let next = $827d62b6188a5818$var$banners;
        let changed = false;
        for (const run of queued){
            // Applied against the running value, not the pre-flush one, so a name shown twice in a tick
            // resolves against the first write rather than duplicating.
            const result = run(next);
            if (result === undefined) continue;
            next = result;
            changed = true;
        }
        if (changed) $827d62b6188a5818$var$commit(next);
    });
};
const $827d62b6188a5818$export$f5c0eb035ef26e87 = (name, height)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return [
            ...current,
            {
                name: name,
                height: height
            }
        ];
        if (current[index].height !== height) {
            const next = [
                ...current
            ];
            // Replace rather than mutate, so the previous array keeps the old height.
            next[index] = {
                name: name,
                height: height
            };
            return next;
        }
        return undefined;
    });
};
const $827d62b6188a5818$export$11fa8b7d26b756a8 = (name)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return undefined;
        const next = [
            ...current
        ];
        next.splice(index, 1);
        return next;
    });
};
const $827d62b6188a5818$export$468156c225d4c0f9 = (initial)=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    if ($827d62b6188a5818$var$banners.length === 0 && initial.length > 0) $827d62b6188a5818$var$commit([
        ...initial
    ]);
};
const $827d62b6188a5818$export$b3f5cfd1906442cb = ()=>{
    $827d62b6188a5818$var$banners = $827d62b6188a5818$var$NO_BANNERS;
    $827d62b6188a5818$var$listeners.clear();
    $827d62b6188a5818$var$pending = [];
    $827d62b6188a5818$var$pendingFlush = null;
};
module.exports["getBanners"] = $827d62b6188a5818$export$49fd326b255f6ddb;
module.exports["subscribeToBanners"] = $827d62b6188a5818$export$7cfac2c025b473e4;
module.exports["showBanner"] = $827d62b6188a5818$export$f5c0eb035ef26e87;
module.exports["hideBanner"] = $827d62b6188a5818$export$11fa8b7d26b756a8;
module.exports["seedBanners"] = $827d62b6188a5818$export$468156c225d4c0f9;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("jecot", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $ff48e00b2c36a911$export$756e5b68ec79d923 = ()=>{
    if (// The increased height change is applied when FHS or app switcher improvements are enabled.
    // Ideally we could check `useIsFhsEnabled()` but this has to work outside React too.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false) || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('platform_dst_ads_appswitcher_improvements')) return 56;
    return 48;
};
module.exports["resolveTopNavHeight"] = $ff48e00b2c36a911$export$756e5b68ec79d923;

});

parcelRegister("beAFO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $hrAmX = parcelRequire("hrAmX");


var $2F82N = parcelRequire("2F82N");

const $9bb8acac4581c215$var$BANNER_CONTAINERS = [
    (0, $hrAmX.BannerStateContainer)
];
const $9bb8acac4581c215$var$BannerHeightReaderWithHooks = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const { bannerHeight: bannerHeight, totalHeight: totalHeight } = (0, $2F82N.useBannerHeights)();
    let t1;
    if ($[0] !== bannerHeight || $[1] !== totalHeight) {
        t1 = {
            getTotalHeight: (t2)=>{
                const includeTopNav = t2 === undefined ? true : t2;
                return includeTopNav ? totalHeight : bannerHeight;
            }
        };
        $[0] = bannerHeight;
        $[1] = totalHeight;
        $[2] = t1;
    } else t1 = $[2];
    const state = t1;
    let t2;
    if ($[3] !== children || $[4] !== state) {
        t2 = children(state);
        $[3] = children;
        $[4] = state;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $9bb8acac4581c215$export$a9369c27159364 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $6mKj3.expValEquals)("confluence_banner_store_migration", "isEnabled", true)) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bb8acac4581c215$var$BannerHeightReaderWithHooks, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: $9bb8acac4581c215$var$BANNER_CONTAINERS
        }, (state)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state)));
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["BannerHeightReader"] = $9bb8acac4581c215$export$a9369c27159364;

});

parcelRegister("2F82N", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jxpvN = parcelRequire("jxpvN");


var $8zRYE = parcelRequire("8zRYE");


var $jecot = parcelRequire("jecot");

function $17b7cc64b70c04e4$export$586efad75f302d4(t0) {
    const includeTopNav = t0 === undefined ? true : t0;
    const { bannerHeight: bannerHeight, totalHeight: totalHeight } = $17b7cc64b70c04e4$export$c01f3c55efd76078();
    return includeTopNav ? totalHeight : bannerHeight;
}
function $17b7cc64b70c04e4$export$c01f3c55efd76078() {
    const $ = (0, $bDgLe.c)(4);
    const { suppressed: suppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    const getHeight = $17b7cc64b70c04e4$var$_temp2;
    const bannerHeight = (0, $cozmU.useSyncExternalStore)((0, $8zRYE.subscribeToBanners), getHeight, getHeight);
    const topNavHeight = (0, $jecot.resolveTopNavHeight)();
    if (suppressed) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                bannerHeight: 0,
                totalHeight: 0
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    const t0 = bannerHeight + topNavHeight;
    let t1;
    if ($[1] !== bannerHeight || $[2] !== t0) {
        t1 = {
            bannerHeight: bannerHeight,
            totalHeight: t0
        };
        $[1] = bannerHeight;
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
}
/**
 * Visible banner names joined with "-", replacing `bannerState.getBannerList()`.
 */ function $17b7cc64b70c04e4$var$_temp2() {
    return (0, $8zRYE.getBanners)().reduce($17b7cc64b70c04e4$var$_temp, 0);
}
function $17b7cc64b70c04e4$var$_temp(total, banner) {
    return total + banner.height;
}
function $17b7cc64b70c04e4$export$578d6eba67d6ef8e() {
    const { suppressed: suppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    const getList = $17b7cc64b70c04e4$var$_temp4;
    const bannerList = (0, $cozmU.useSyncExternalStore)((0, $8zRYE.subscribeToBanners), getList, getList);
    return suppressed ? "" : bannerList;
}
/**
 * Whether any banner other than `name` is currently visible — the check a banner makes to decide
 * whether it is blocked by a higher-priority one.
 */ function $17b7cc64b70c04e4$var$_temp4() {
    return (0, $8zRYE.getBanners)().map($17b7cc64b70c04e4$var$_temp3).join("-");
}
function $17b7cc64b70c04e4$var$_temp3(banner) {
    return banner.name;
}
function $17b7cc64b70c04e4$export$6961e0c10749cc5d(name) {
    const $ = (0, $bDgLe.c)(2);
    const { suppressed: suppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    let t0;
    if ($[0] !== name) {
        t0 = ()=>(0, $8zRYE.getBanners)().some((banner)=>banner.name !== name);
        $[0] = name;
        $[1] = t0;
    } else t0 = $[1];
    const getSnapshot = t0;
    const hasOthers = (0, $cozmU.useSyncExternalStore)((0, $8zRYE.subscribeToBanners), getSnapshot, getSnapshot);
    return suppressed ? false : hasOthers;
}
function $17b7cc64b70c04e4$export$664f3e2467f0f5af() {
    const $ = (0, $bDgLe.c)(2);
    const { suppressed: suppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    let t0;
    if ($[0] !== suppressed) {
        t0 = {
            show: (name, height)=>{
                if (suppressed) return;
                (0, $8zRYE.showBanner)(name, height);
            },
            hide: (name_0)=>{
                if (suppressed) return;
                (0, $8zRYE.hideBanner)(name_0);
            }
        };
        $[0] = suppressed;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}
module.exports["useBannerTotalHeight"] = $17b7cc64b70c04e4$export$586efad75f302d4;
module.exports["useBannerHeights"] = $17b7cc64b70c04e4$export$c01f3c55efd76078;
module.exports["useBannerList"] = $17b7cc64b70c04e4$export$578d6eba67d6ef8e;
module.exports["useBannerActions"] = $17b7cc64b70c04e4$export$664f3e2467f0f5af;

});

parcelRegister("jxpvN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $cozmU.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("kBU5m", function(module, exports) {
// featureFlags should come from getSessionData in @confluence/session-data
// IMPORTANT: If you change the code below, please also update the
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
function $d887a76516ca8f8c$export$88f94a4dc797781a(featureFlags) {
    return featureFlags ? {
        mediaInline: true
    } : {};
}
module.exports["getMediaFeatureFlags"] = $d887a76516ca8f8c$export$88f94a4dc797781a;

});

parcelRegister("9UKrO", function(module, exports) {

var $bumSD = parcelRequire("bumSD");

function $88671cc112964e63$export$ecc18d1a90c31bf8(cloudId, getActions, /**
	 * @deprecated This is no longer used we should remove in a future version
	 */ featureFlags) {
    return Promise.resolve({
        cloudId: cloudId,
        resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
        getActions: getActions
    });
}
module.exports["getProfileCardProvider"] = $88671cc112964e63$export$ecc18d1a90c31bf8;

});

parcelRegister("bumSD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5hJlu = parcelRequire("5hJlu");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $dOBRD.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $5hJlu.ProfileClient)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $34knR = parcelRequire("34knR");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $34knR.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).HOME.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");


var $8W4Gr = parcelRequire("8W4Gr");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        const binding = (0, $8W4Gr.bindPageSegmentToUFO)(metric, key, args[0]?.startTime);
        if (binding) {
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`, [], binding.startTime);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        const binding = (0, $8W4Gr.bindPageSegmentToUFO)(metric, key, 'page-load');
        if (binding) {
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`, [], binding.startTime);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, args[0]);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            // This is a legacy marker, not a native interaction cancellation/completion.
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`, [], performance.now());
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            const [name, timestamp] = args;
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', name, [], timestamp ?? performance.now());
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            const [timestamp] = args;
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `fmp:${key}`, [], timestamp ?? performance.now());
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("8W4Gr", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");


var $9wGTI = parcelRequire("9wGTI");


var $iJ7Px = parcelRequire("iJ7Px");


var $3YpC9 = parcelRequire("3YpC9");

// Dispatch information only: UFO still owns holds, completion and reporting.
// Object identity keeps separate metric instances with the same key independent.
const $06e453a80b18c305$var$bindings = new WeakMap();
// Deduplicate end telemetry per captured start without changing UFO completion or holds.
const $06e453a80b18c305$var$reportedEnds = new WeakSet();
function $06e453a80b18c305$export$658d1540acda6146(metric, key = metric.key, startTime) {
    $06e453a80b18c305$var$bindings.delete(metric);
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction && (0, $iJ7Px.BM3_MIGRATION_SCOPES).some(({ ufoNames: ufoNames, segmentKeys: segmentKeys })=>ufoNames.includes(interaction.ufoName) && segmentKeys.some((segment)=>segment === key)) && // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing phase-2 guard shared by React and imperative segment starts.
    (0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
        const binding = {
            interactionId: interaction.id,
            key: key,
            startTime: startTime === 'page-load' ? interaction.start : startTime ?? performance.now()
        };
        $06e453a80b18c305$var$bindings.set(metric, binding);
        return binding;
    }
    return undefined;
}
function $06e453a80b18c305$export$23d3c6fa6a541f1c(metric) {
    return $06e453a80b18c305$var$bindings.get(metric);
}
function $06e453a80b18c305$export$de99dc22751ce5a4(binding, options) {
    const { interactionId: interactionId, key: key, startTime: startTime } = binding;
    if (!$06e453a80b18c305$var$reportedEnds.has(binding)) {
        $06e453a80b18c305$var$reportedEnds.add(binding);
        const endTime = options?.stopTime ?? performance.now();
        (0, $a33Aa.addMark)(interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`, [], endTime);
        (0, $a33Aa.addCustomTiming)(interactionId, [], {
            [`wf/react/${key}`]: {
                startTime: startTime,
                endTime: endTime
            }
        });
    }
    // Later React/imperative callbacks can still supply attributes to the same owner.
    if (options?.customData) (0, $a33Aa.addCustomData)(interactionId, [], typeof globalThis.structuredClone === 'function' ? globalThis.structuredClone(options.customData) : options.customData);
}
module.exports["bindPageSegmentToUFO"] = $06e453a80b18c305$export$658d1540acda6146;
module.exports["getPageSegmentUFOBinding"] = $06e453a80b18c305$export$23d3c6fa6a541f1c;
module.exports["reportPageSegmentEndToUFO"] = $06e453a80b18c305$export$de99dc22751ce5a4;

});

parcelRegister("iJ7Px", function(module, exports) {

var $1UCmC = parcelRequire("1UCmC");


var $jX1qB = parcelRequire("jX1qB");

const $9f5a9554b14e3be2$export$59f08ddb222dbbda = [
    {
        pageLoadKey: (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
        ufoNames: [
            'view_page'
        ],
        segmentKeys: [
            // View Page's initial/transition segments, plus its header and content UI.
            (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
            (0, $jX1qB.BYLINE_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_RENDERER_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
            (0, $jX1qB.CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY),
            (0, $jX1qB.END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY),
            (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
            (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
            (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
            (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
            (0, $jX1qB.READ_TIME_SEGMENT_KEY),
            (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
            (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
            (0, $jX1qB.VIEW_PAGE_LABELS_METRIC_KEY),
            (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY)
        ]
    }
];
module.exports["BM3_MIGRATION_SCOPES"] = $9f5a9554b14e3be2$export$59f08ddb222dbbda;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$803e647119e41cc = 'embedded-store';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$2b4bf316b2f90e51 = 'folder-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$87f484dad415164c = 'admin-storage-management';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["EMBEDDED_STORE_LOAD_KEY"] = $00aca2e58bbddd9e$export$803e647119e41cc;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["FOLDER_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2b4bf316b2f90e51;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_STORAGE_MANAGEMENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$87f484dad415164c;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $51W2Z = parcelRequire("51W2Z");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    if (cloudId && userId && (0, $6mKj3.expValEquals)('confluence_on_demand_emoji_repository', 'isEnabled', true)) return new (0, $51W2Z.OnDemandEmojiResource)({
        ...emojiConfig,
        options: {
            onlyFetchOnDemand: true
        },
        singleEmojiApi: {
            getUrl: ({ id: id, shortName: shortName })=>`${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/${encodeURIComponent(id ?? shortName)}`
        }
    });
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $drRzc = parcelRequire("drRzc");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("51W2Z", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");

const $20b5b351e69bef6e$var$isMediaRepresentation = (representation)=>!!representation && 'mediaPath' in representation;
class $20b5b351e69bef6e$export$cfbb91621ad16c67 extends (0, $kwzZh.default) {
    // filter() reports "not ready" without waiting, so it has to start the fetch itself. The fetch
    // re-runs the last filter when it completes.
    filter(query, options) {
        this.startRepositoryFetch();
        super.filter(query, options);
    }
    async fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder) {
        if (!this.emojiProviderConfig.singleEmojiApi || !emojiId.id || this.isRepositoryLoaded()) return super.fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder);
        // Emoji ids never contain a slash, but page icons can be URLs, such as a favicon. No emoji list
        // has them, and the single-emoji endpoint rejects them, which would download the repository.
        if (emojiId.id.includes('/')) return undefined;
        // With `optimistic` true, the base class requests just this emoji from singleEmojiApi instead of
        // waiting for the repository. ResourcedEmoji passes its `optimistic` prop, which
        // @atlaskit/reactions leaves off, so force it on until the repository has loaded.
        const emoji = await super.fetchByEmojiId(emojiId, true, emojiProviderLookupOrder);
        // The single-emoji request falls back to the repository when it fails, but not when it finds
        // nothing. With `optimistic` false, the base class waits for the repository, and
        // retryIfLoading starts downloading it.
        return emoji ?? super.fetchByEmojiId(emojiId, false, emojiProviderLookupOrder);
    }
    findById(id) {
        if (!this.emojiProviderConfig.singleEmojiApi || this.isRepositoryLoaded()) return super.findById(id);
        return this.fetchByEmojiId({
            id: id,
            shortName: ''
        }, true);
    }
    retryIfLoading(retry, defaultResponse) {
        this.startRepositoryFetch();
        return super.retryIfLoading(retry, defaultResponse);
    }
    // The single-emoji response can be the first to carry a media token. SiteEmojiResource keeps the
    // URL it is created with for uploads, deletes and token refreshes, so it must get the site provider
    // rather than the single-emoji URL. The base class primes the resource with the first emoji, which
    // throws for a standard or Atlassian emoji and makes the lookup fall back to the repository, so only
    // media emoji are passed on.
    initSiteEmojiResource(emojiResponse, provider) {
        const siteProvider = this.emojiProviderConfig.providers.find(({ url: url })=>url.endsWith('/site'));
        return super.initSiteEmojiResource({
            ...emojiResponse,
            emojis: emojiResponse.emojis.filter(({ representation: representation })=>$20b5b351e69bef6e$var$isMediaRepresentation(representation))
        }, siteProvider ?? provider);
    }
    isRepositoryLoaded() {
        return !!this.emojiRepository && this.initialLoaders !== 0 && this.activeLoaders === 0;
    }
    startRepositoryFetch() {
        if (!this.isInitialised) // Failures are reported through notifyError and the pending retries.
        this.fetchEmojiProvider().catch(()=>{});
    }
}
module.exports["OnDemandEmojiResource"] = $20b5b351e69bef6e$export$cfbb91621ad16c67;

});

parcelRegister("lqVBP", function(module, exports) {

var $k9SFD = parcelRequire("k9SFD");


var $6mKj3 = parcelRequire("6mKj3");


var $ge2sX = parcelRequire("ge2sX");


var $1Zrg0 = parcelRequire("1Zrg0");

const $9e664374a2d44de5$var$resolveMentionNodeData = ({ id: accountId, userType: userType })=>{
    const avatarData = {
        avatarUrl: `/wiki/aa-avatar/${encodeURIComponent(accountId)}`,
        isAvatarImagePreShaped: userType !== 'APP' && userType !== 'AGENT' ? true : !(0, $6mKj3.expVal)('platform_editor_drop3_hexagon_agent_avatar', 'isEnabled', false)
    };
    if ((0, $6mKj3.expValEquals)('platform_editor_mention_rovo', 'isEnabled', true)) {
        const cloudId = (0, $ge2sX.getCloudId)();
        return {
            ...avatarData,
            isRovoChat: !!cloudId && (0, $1Zrg0.getRovoChatIdentityFromCache)(cloudId) === accountId
        };
    }
    return avatarData;
};
const $9e664374a2d44de5$export$38ae2a33ee19fe82 = ()=>new (0, $k9SFD.MentionNodeDataProvider)(()=>Promise.resolve({}), $9e664374a2d44de5$var$resolveMentionNodeData);
module.exports["createMentionNodeDataProvider"] = $9e664374a2d44de5$export$38ae2a33ee19fe82;

});

parcelRegister("k9SFD", function(module, exports) {

var $drRzc = parcelRequire("drRzc");

const $00f984e1ee672b7a$var$getAppType = (userType)=>userType === 'APP' || userType === 'AGENT' ? 'agent' : 'user';
const $00f984e1ee672b7a$var$enrichMentionNodeData = (mention, data)=>({
        ...data,
        appType: data?.appType ?? $00f984e1ee672b7a$var$getAppType(mention.userType)
    });
const $00f984e1ee672b7a$var$toMentionNode = ({ id: id, userType: userType })=>({
        attrs: {
            id: id,
            // NodeDataProvider uses an ADF node internally, so normalize the runtime-only value.
            userType: userType === 'AGENT' ? 'APP' : userType
        },
        type: 'mention'
    });
const $00f984e1ee672b7a$var$isMentionNode = (node)=>node.type === 'mention' && node.attrs !== undefined && 'id' in node.attrs && typeof node.attrs.id === 'string';
const $00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX = 'mention-node-data-provider';
let $00f984e1ee672b7a$var$subscriptionKeyCounter = 0;
const $00f984e1ee672b7a$var$cacheMentionData = (cache, mentions)=>{
    mentions.forEach((mention)=>{
        if (mention.isPlaceholder || !mention.avatarUrl) {
            cache.delete(mention.id);
            return;
        }
        cache.set(mention.id, {
            avatarUrl: mention.avatarUrl,
            appType: mention.appType
        });
    });
};
class $00f984e1ee672b7a$export$d2331d8e30b7662 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return $00f984e1ee672b7a$var$isMentionNode(node) && node.attrs.userType !== 'SPECIAL';
    }
    nodeDataKey(node) {
        return node.attrs.id;
    }
    async fetchNodesData(nodes) {
        const accountIds = Array.from(new Set(nodes.map(({ attrs: attrs })=>attrs.id)));
        const dataByAccountId = await this.enqueueFetch(accountIds);
        return nodes.map(({ attrs: attrs })=>$00f984e1ee672b7a$var$enrichMentionNodeData(attrs, dataByAccountId[attrs.id]));
    }
    getMentionData(mention, callback) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) {
            callback({
                data: $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData)
            });
            return;
        }
        this.getData($00f984e1ee672b7a$var$toMentionNode(mention), callback);
    }
    getMentionDataFromCache(mention) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) return $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData);
        const data = this.getNodeDataFromCache($00f984e1ee672b7a$var$toMentionNode(mention))?.data;
        return data ? $00f984e1ee672b7a$var$enrichMentionNodeData(mention, data) : undefined;
    }
    connect(mentionResource) {
        if (this.lastMentionResource && this.lastMentionResource !== mentionResource) {
            this.emittedMentionCache.clear();
            this.resetCache();
        }
        this.lastMentionResource = mentionResource;
        if (this.abortControllerRef.current.signal.aborted) this.abortControllerRef.current = new AbortController();
        let isDisconnected = false;
        let subscribedMentionProvider;
        mentionResource.then((mentionProvider)=>{
            if (isDisconnected) return;
            subscribedMentionProvider = mentionProvider;
            mentionProvider.subscribe(this.subscriptionKey, (mentions)=>{
                $00f984e1ee672b7a$var$cacheMentionData(this.emittedMentionCache, mentions);
            });
        }).catch(()=>undefined);
        return ()=>{
            isDisconnected = true;
            this.abortControllerRef.current.abort();
            subscribedMentionProvider?.unsubscribe(this.subscriptionKey);
            subscribedMentionProvider = undefined;
        };
    }
    resolveMentionNodeDataFromCache(mention) {
        return this.resolveMentionNodeData?.(mention) ?? this.emittedMentionCache.get(mention.id);
    }
    enqueueFetch(accountIds) {
        const result = new Promise((resolve, reject)=>{
            this.queuedFetches.push({
                accountIds: accountIds,
                reject: reject,
                resolve: resolve
            });
        });
        if (!this.isFlushScheduled) {
            this.isFlushScheduled = true;
            Promise.resolve().then(()=>this.flushFetches());
        }
        return result;
    }
    async flushFetches() {
        this.isFlushScheduled = false;
        const queuedFetches = this.queuedFetches;
        this.queuedFetches = [];
        const accountIds = Array.from(new Set(queuedFetches.flatMap((request)=>request.accountIds)));
        try {
            const data = await this.fetchMentionNodeData(accountIds, this.abortControllerRef.current.signal);
            queuedFetches.forEach(({ resolve: resolve })=>resolve(data));
        } catch (error) {
            queuedFetches.forEach(({ reject: reject })=>reject(error));
        }
    }
    constructor(fetchMentionNodeData, resolveMentionNodeData){
        super(), this.fetchMentionNodeData = fetchMentionNodeData, this.resolveMentionNodeData = resolveMentionNodeData;
        this.name = 'mentionNodeDataProvider';
        this.abortControllerRef = {
            current: new AbortController()
        };
        this.emittedMentionCache = new Map();
        this.subscriptionKey = `${$00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX}:${++$00f984e1ee672b7a$var$subscriptionKeyCounter}`;
        this.lastMentionResource = void 0;
        this.queuedFetches = [];
        this.isFlushScheduled = false;
    }
}
module.exports["MentionNodeDataProvider"] = $00f984e1ee672b7a$export$d2331d8e30b7662;

});

parcelRegister("lEf66", function(module, exports) {
const $0892e7364b81f0d9$export$256d0139ed1b4d96 = (queryData)=>{
    return queryData?.user?.confluence?.permissionType;
};
module.exports["getUserPermissionFromQuery"] = $0892e7364b81f0d9$export$256d0139ed1b4d96;

});

parcelRegister("5OVTZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $9d9b34902cc040ae$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $9d9b34902cc040ae$export$8995abb8169b2cb8;

});

parcelRegister("habRv", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $WNsSX = parcelRequire("WNsSX");


var $hRnS5 = parcelRequire("hRnS5");


var $fke0y = parcelRequire("fke0y");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $6UYek = parcelRequire("6UYek");


var $5GXIg = parcelRequire("5GXIg");


var $jmjWc = parcelRequire("jmjWc");


var $gJoPj = parcelRequire("gJoPj");


var $cZa7r = parcelRequire("cZa7r");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $apfIM = parcelRequire("apfIM");


var $ep3mz = parcelRequire("ep3mz");


var $804Ue = parcelRequire("804Ue");

var $hi2PR = parcelRequire("hi2PR");


var $fgQGl = parcelRequire("fgQGl");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $k8e76 = parcelRequire("k8e76");


var $9jl6v = parcelRequire("9jl6v");


var $fHAwL = parcelRequire("fHAwL");


var $bQm3c = parcelRequire("bQm3c");


var $7boqA = parcelRequire("7boqA");


var $a3q17 = parcelRequire("a3q17");


var $8i27m = parcelRequire("8i27m");


var $WheoQ = parcelRequire("WheoQ");


var $NYiei = parcelRequire("NYiei");


var $3D6uL = parcelRequire("3D6uL");


var $fFRTr = parcelRequire("fFRTr");


const $24269a0cd7d91594$var$SelectionComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GK726",
    name: "SelectionComponentLoader",
    loader: async ()=>(await (parcelRequire("gHDPx"))).SelectionComponent
});

const $24269a0cd7d91594$var$HoverComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8tl48",
    name: "HoverComponentLoader",
    loader: async ()=>(await (parcelRequire("kxrtD"))).HoverComponent
});

const $24269a0cd7d91594$var$ViewComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HAh0o",
    name: "ViewComponentLoader",
    loader: async ()=>(await (parcelRequire("3BQbc"))).ViewComponent
});

const $24269a0cd7d91594$var$InlineCommentLinkHandlerLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0Ufwq",
    name: "InlineCommentLinkHandlerLoader",
    loader: async ()=>(await (parcelRequire("3EC4N"))).InlineCommentLinkHandler
});
const $24269a0cd7d91594$var$InlineCommentsPubSubHandler = ({ contentId: contentId, contentType: contentType, updateDocument: updateDocument, rendererActions: rendererActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setDocumentUpdated: setDocumentUpdated } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $cozmU.useRef)([]);
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnresolvedInlineComment: updateUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const { setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment } = (0, $8i27m.useCommentsDataActions)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)() || {};
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const updateUnresolvedInlineCommentFn = (0, $WheoQ.useUpdateAnnotations)([
        updateUnresolvedInlineComment,
        setOrderedActiveAnnotationIdList
    ]);
    const unsubscribeFromPubSub = (0, $cozmU.useCallback)(()=>{
        if (subscriptions.current.length === 0) return;
        (0, $hi2PR.removeRendererInlineCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current
        });
        subscriptions.current = [];
    }, [
        contentId,
        contentType,
        removeSubscriber
    ]);
    const subscribeToPubSub = (0, $cozmU.useCallback)(()=>{
        if (subscriptions.current.length > 0) // Multiple active subscriptions will cause multiple cache-writes, which we don't want.
        // Instead of returning early here, we unsub + resub so that values in setUpRendererInlineCommentsPubSub stay up to date.
        unsubscribeFromPubSub();
        subscriptions.current = (0, $hi2PR.setUpRendererInlineCommentsPubSub)({
            contentId: contentId,
            currentUserId: userId,
            contentType: contentType,
            rendererActions: rendererActions,
            updateDocument: updateDocument,
            updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn,
            setContentNeedsUpdate: setDocumentNeedsUpdate,
            needsContentUpdate: Boolean(documentNeedsUpdate),
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            publishedDocumentVersion: publishedDocumentVersion,
            createAnalyticsEvent: createAnalyticsEvent,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            setActiveHighlight: setActiveHighlight,
            setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList
        }) || [];
        return subscriptions.current;
    // We only need to respond to values that CAN change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        userId,
        contentType,
        rendererActions,
        documentNeedsUpdate,
        publishedDocumentVersion,
        addSubscriber,
        setContentType,
        setContentId,
        addCommentInCache,
        deleteCommentInCache,
        unsubscribeFromPubSub
    ]);
    const handleFetchContentVersionEvent = (0, $cozmU.useCallback)(()=>{
        setDocumentNeedsUpdate(true);
    }, [
        setDocumentNeedsUpdate
    ]);
    const handleEventFetchSuccess = (0, $cozmU.useCallback)((res)=>{
        // TODO: Parse the events returned for 'resolved', 'unresolved', and 'delete' when they are added
        //       for now we just reload the content when the user comes back
        // For now all we have is create events, which means we will miss things, but only update if a new ones were created
        if (res.commentEvents.length > 0) {
            setDocumentUpdated(true);
            setRefetchContent(true);
        }
    }, [
        setRefetchContent,
        setDocumentUpdated
    ]);
    if (!userId) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).INLINE,
        subscribeToPubSubEvents: subscribeToPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onFetchContentVersionEvent: handleFetchContentVersionEvent,
        inactiveInterval: 0,
        returnInterval: 0
    });
};
const $24269a0cd7d91594$var$WithAnnotationsWrapperComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { flags: flags, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, updateDocument: updateDocument, isNestedRender: t1, children: children, lastModifiedDate: lastModifiedDate, isArchived: t2, preloadedCanAddComments: preloadedCanAddComments } = t0;
    const isNestedRender = t1 === undefined ? false : t1;
    const isArchived = t2 === undefined ? false : t2;
    const { setDocumentUpdated: setDocumentUpdated, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { refetchContent: refetchContent } = (0, $5pQ1Y.useContentRefetch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const [t3] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, contentType: contentType } = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { selectionProps: selectionProps, viewProps: viewProps, hoverProps: hoverProps, isOffline: isOffline } = (0, $cZa7r.useAnnotations)();
    const { isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled } = (0, $3D6uL.useIsHighlightOptionPanelEnabled)();
    const handleAnnotationsLoaded = $24269a0cd7d91594$var$_temp;
    let t4;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== createAnalyticsEvent || $[3] !== flags || $[4] !== setDocumentNeedsUpdate || $[5] !== setDocumentUpdated || $[6] !== setPublishedDocumentVersion || $[7] !== setRefetchContent) {
        t4 = (versionNumber)=>{
            setRefetchContent(false);
            setDocumentUpdated(true);
            setDocumentNeedsUpdate(false);
            flags.hideAllFlags();
            if (versionNumber) setPublishedDocumentVersion(versionNumber);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "refetched",
                    actionSubject: "content",
                    objectId: contentId,
                    contentType: contentType,
                    source: "viewPageScreen"
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = flags;
        $[4] = setDocumentNeedsUpdate;
        $[5] = setDocumentUpdated;
        $[6] = setPublishedDocumentVersion;
        $[7] = setRefetchContent;
        $[8] = t4;
    } else t4 = $[8];
    const handleOnRefetchComplete = t4;
    let t5;
    if ($[9] !== adfDocument || $[10] !== annotationProvider || $[11] !== children || $[12] !== contentId || $[13] !== contentType || $[14] !== handleOnRefetchComplete || $[15] !== hoverProps || $[16] !== isArchived || $[17] !== isHighlightOptionPanelEnabled || $[18] !== isNestedRender || $[19] !== isOffline || $[20] !== lastModifiedDate || $[21] !== preloadedCanAddComments || $[22] !== refetchContent || $[23] !== rendererRef || $[24] !== selectionProps || $[25] !== updateDocument || $[26] !== viewProps) {
        t5 = annotationProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fke0y.WithRendererActions), {
            render: (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                    key: contentId,
                    metric: (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $WNsSX.AnnotationsWrapper), {
                    rendererRef: rendererRef,
                    adfDocument: adfDocument,
                    annotationProvider: annotationProvider,
                    isNestedRender: isNestedRender,
                    onLoadComplete: handleAnnotationsLoaded
                }, !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5GXIg.RendererAnnotationProviderComponents), null), selectionProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$SelectionComponentLoader, {
                    ...selectionProps,
                    isOffline: isOffline,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    adfDocument: adfDocument,
                    getSelectionContext: ()=>actions.getSelectionContext(),
                    isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled,
                    preloadedCanAddComments: preloadedCanAddComments
                }), hoverProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$HoverComponentLoader, {
                    ...hoverProps,
                    isOffline: isOffline,
                    preloadedCanAddComments: preloadedCanAddComments
                }), viewProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$ViewComponentLoader, {
                    ...viewProps,
                    isOffline: isOffline,
                    preloadedCanAddComments: preloadedCanAddComments
                }), children), !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gJoPj.InlineCommentQueryParamsListener), {
                    isArchived: isArchived,
                    rendererRef: rendererRef
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $apfIM.RendererActionsListener), {
                    actions: actions,
                    pageId: contentId
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$InlineCommentsPubSubHandler, {
                    contentId: contentId,
                    contentType: contentType,
                    updateDocument: updateDocument,
                    rendererActions: actions
                }), contentId && (0, $6mKj3.expValEquals)("confluence_inline_reactions", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fFRTr.InlineReactionsPubSubHandler), {
                    contentId: contentId,
                    contentType: contentType === "blogpost" ? "blogpost" : "page",
                    rendererActions: actions,
                    updateDocument: updateDocument
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fgQGl.ContentRefetchHandler), {
                    contentId: contentId,
                    shouldRefetch: refetchContent,
                    refetchImmediately: true,
                    onRefetchComplete: handleOnRefetchComplete
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24269a0cd7d91594$var$InlineCommentLinkHandlerLoader, null))
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children));
        $[9] = adfDocument;
        $[10] = annotationProvider;
        $[11] = children;
        $[12] = contentId;
        $[13] = contentType;
        $[14] = handleOnRefetchComplete;
        $[15] = hoverProps;
        $[16] = isArchived;
        $[17] = isHighlightOptionPanelEnabled;
        $[18] = isNestedRender;
        $[19] = isOffline;
        $[20] = lastModifiedDate;
        $[21] = preloadedCanAddComments;
        $[22] = refetchContent;
        $[23] = rendererRef;
        $[24] = selectionProps;
        $[25] = updateDocument;
        $[26] = viewProps;
        $[27] = t5;
    } else t5 = $[27];
    return t5;
};
const $24269a0cd7d91594$export$548dda15276d1592 = (0, $7aRa9.withFlags)($24269a0cd7d91594$var$WithAnnotationsWrapperComponent);
function $24269a0cd7d91594$var$_temp(t0) {
    const { numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments } = t0;
    const options = {
        customData: {
            isFabricPage: true,
            numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments
        }
    };
    (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC).stop(options);
}
module.exports["WithAnnotationsWrapper"] = $24269a0cd7d91594$export$548dda15276d1592;

});

parcelRegister("fke0y", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");

function $35beb435b76f50f4$export$f9718e664221d42a({ render: render }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hRnS5.RendererActionsContextConsumer), {
        children: (actions)=>render(actions)
    });
}
module.exports["WithRendererActions"] = $35beb435b76f50f4$export$f9718e664221d42a;

});

parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $1xpoY = parcelRequire("1xpoY");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $cozmU.useState)(null);
    const [contentId, setContentId] = (0, $cozmU.useState)(null);
    const [contentType, setContentType] = (0, $cozmU.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $cozmU.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $cozmU.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $cozmU.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        interopApolloAggClient: true,
        __callerPackage__: "graphql"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            //
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<3cf833e1f6abdc09f087918a71bd7b3c>>
 * @relayHash 4d9c4dda69ee8b46bd92a73752662f5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae6197b56d1c72324ae9b35ab7dcfe615ea279ca89945374aba5e31f3e95fba6
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "version"
    }, v6 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v10 = [
        v9 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v12 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v15 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v16 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v17 = {
        "kind": "ScalarField",
        "name": "from"
    }, v18 = {
        "kind": "ScalarField",
        "name": "to"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pos"
    }, v20 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v3 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v24 = [
        v3 /*: any*/ ,
        v12 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "emojiId"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "originTabId"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v5 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v15 /*: any*/ ,
                        v22 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v11 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionAdded",
                    "kind": "LinkedField",
                    "name": "inlineReactionAdded",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "newHighlight"
                        },
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stepType"
                                }
                            ]
                        },
                        v16 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionRemoved",
                    "kind": "LinkedField",
                    "name": "inlineReactionRemoved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionHighlightDeleted",
                    "kind": "LinkedField",
                    "name": "inlineReactionHighlightDeleted",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "4d9c4dda69ee8b46bd92a73752662f5a",
            "id": "ae6197b56d1c72324ae9b35ab7dcfe615ea279ca89945374aba5e31f3e95fba6",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,originTabId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "4da79f5b2cb3c0981af10a69c23b74a8";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $7m1pr = parcelRequire("7m1pr");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = true;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        phase: 'subscription'
    });
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables,
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $7EPz1.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $7m1pr.RelayError)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(!options?.skip);
    const disposableRef = (0, $cozmU.useRef)(null);
    const callbacksRef = (0, $cozmU.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        phase: 'subscription'
    });
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__, {
        phase: 'subscription'
    });
    (0, $cozmU.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $cozmU.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $cozmU.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $cozmU.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $cozmU.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        const subscriptionField = Object.keys(result?.subscriptionData?.data ?? {}).find((field)=>field !== '__typename');
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || '',
                    ...subscriptionField && ((0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) || // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Rollout gate for the platformised subset of suggested edits, independent of the experiment.
                    (0, $9wGTI.fg)('platform_editor_ai_suggested_edits')) ? {
                        subscriptionField: subscriptionField
                    } : {}
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $cozmU.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("5GXIg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cZa7r = parcelRequire("cZa7r");


var $4gEXU = parcelRequire("4gEXU");

function $0779e224f4e996ea$export$6f846e47e87c2a09() {
    const { handleClose: handleClose } = (0, $cZa7r.useAnnotationsDispatch)();
    const onConfirm = (0, $cozmU.useCallback)(()=>{
        handleClose();
    }, [
        handleClose
    ]);
    (0, $4gEXU.usePreemptiveGate)({
        onConfirm: onConfirm
    });
    return null;
}
module.exports["RendererAnnotationProviderComponents"] = $0779e224f4e996ea$export$6f846e47e87c2a09;

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $cozmU = parcelRequire("cozmU");


var $cz6eP = parcelRequire("cz6eP");


var $fJCU9 = parcelRequire("fJCU9");


var $epbW8 = parcelRequire("epbW8");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$4162754b616020bc = 2000;
const $d99a6317060f344e$export$a428e87cc7038c56 = 3500;
const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $cozmU.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    commentSidebarContext: null,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $cozmU.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $cozmU.createContext)({
    requestCloseEditorComment: ()=>Promise.resolve(true),
    setEditorCommentCloseGuard: ()=>{},
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    setCommentSidebarContext: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{},
    waitForAnnotationElementAndEmit: ()=>{},
    applyDraftModeRef: {
        current: null
    }
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const editorCommentCloseGuardRef = (0, $cozmU.useRef)(()=>Promise.resolve(true));
    const setEditorCommentCloseGuard = (0, $cozmU.useCallback)((guard)=>{
        editorCommentCloseGuardRef.current = guard;
    }, []);
    const [selectionProps, setSelectionProps] = (0, $cozmU.useState)(null);
    const selectionPropsRef = (0, $cozmU.useRef)(null);
    /** Stable ref to applyDraftMode — never cleared, so nudge click can call it synchronously
   *  without waiting for the 100ms selectionchange debounce. */ const applyDraftModeRef = (0, $cozmU.useRef)(null);
    // Keep refs in sync with state — useEffect so it never runs during render
    (0, $cozmU.useEffect)(()=>{
        selectionPropsRef.current = selectionProps;
        if (selectionProps?.applyDraftMode) applyDraftModeRef.current = selectionProps.applyDraftMode;
    }, [
        selectionProps
    ]);
    const [hoverProps, setHoverProps] = (0, $cozmU.useState)(null);
    const [viewProps, setViewProps] = (0, $cozmU.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $cozmU.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $cozmU.useState)(null);
    const editorCreatePropsRef = (0, $cozmU.useRef)(null);
    editorCreatePropsRef.current = editorCreateProps;
    const requestCloseEditorComment = (0, $cozmU.useCallback)(async ()=>{
        const editorCreatePropsAtRequest = editorCreatePropsRef.current;
        const canClose = await editorCommentCloseGuardRef.current();
        if (!canClose) return false;
        if (editorCreatePropsAtRequest) {
            if (!editorCreatePropsAtRequest.onClose) return false;
            editorCreatePropsAtRequest.onClose();
        } else setEditorViewProps(null);
        return true;
    }, []);
    const [showCreateComponent, setShowCreateComponent] = (0, $cozmU.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $cozmU.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $cozmU.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $cozmU.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $cozmU.useState)();
    const [commentSidebarContext, setCommentSidebarContext] = (0, $cozmU.useState)(null);
    const [prevContentId, setPrevContentId] = (0, $cozmU.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const annotationManager = (0, $cozmU.useMemo)(// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    ()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cz6eP.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $cozmU.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $cozmU.useState)(null);
    // Track active MutationObserver and timeout for cleanup on unmount
    const activeObserverRef = (0, $cozmU.useRef)(null);
    const activeTimeoutRef = (0, $cozmU.useRef)(null);
    /**
   * Waits for an annotation element to appear in the DOM using MutationObserver,
   * then emits annotation selection events. If element doesn't appear within the wait
   * timeout, fails the VIEW_INLINE_COMMENT_EXPERIENCE.
   */ const waitForAnnotationElementAndEmit = (0, $cozmU.useCallback)((annotationId, emitter)=>{
        const waitTimeoutMs = (0, $6mKj3.expValEquals)('cc_comments_fix_annotation_element_timeout', 'isEnabled', true) ? $d99a6317060f344e$export$a428e87cc7038c56 : $d99a6317060f344e$export$4162754b616020bc;
        // Clean up any existing observer/timeout before creating new ones
        if (activeObserverRef.current) activeObserverRef.current.disconnect();
        if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
        // Use MutationObserver to wait for element to appear in DOM
        activeObserverRef.current = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(annotationId);
            if (element) {
                if (activeObserverRef.current) activeObserverRef.current.disconnect();
                if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
                activeObserverRef.current = null;
                activeTimeoutRef.current = null;
                // Emit annotation events and check if listeners exist
                if (emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: element
                })) {
                    emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    setNewlyCreatedAnnotationId(annotationId);
                } else // No listeners registered - fail the experience
                experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Failed to emit annotation click')
                });
            }
        });
        // Observe the renderer wrapper for child additions (fallback to document.body for safety)
        const rendererWrapper = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('#content .ak-renderer-wrapper') || document.body;
        activeObserverRef.current.observe(rendererWrapper, {
            childList: true,
            subtree: true
        });
        // Fallback: If element doesn't appear within timeout, fail the experience
        // This almost always happens due to super slow re-renders (slow client on large page)
        activeTimeoutRef.current = setTimeout(()=>{
            if (activeObserverRef.current) activeObserverRef.current.disconnect();
            activeObserverRef.current = null;
            activeTimeoutRef.current = null;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`Annotation element not found in DOM after ${waitTimeoutMs}ms`)
            });
        }, waitTimeoutMs);
    }, [
        experienceTracker,
        setNewlyCreatedAnnotationId
    ]);
    // Cleanup observer and timeout on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (activeObserverRef.current) {
                activeObserverRef.current.disconnect();
                activeObserverRef.current = null;
            }
            if (activeTimeoutRef.current) {
                clearTimeout(activeTimeoutRef.current);
                activeTimeoutRef.current = null;
            }
        };
    }, []);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $cozmU.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $cozmU.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setCommentSidebarContext(null);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) {
            resetProviderState();
            // Deselect any currently selected annotations
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        }
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Stable ref for selectionOptions — updated synchronously alongside every setSelectionOptions call
    // so handleSaveSuccess always reads the latest step even when its useCallback closure is stale.
    const selectionOptionsRef = (0, $cozmU.useRef)(undefined);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        if ((0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false)) selectionOptionsRef.current = undefined;
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
   * NOTE: This function will not be calling setShowCreateComponent because it's
   *       consumers will not be refreshing themselves with new selectionOptions.
   *       It will now be the responsibility of the consumers of this function to call
   *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
   */ const setSelectionOptionsForCreateEditor = (0, $cozmU.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, $9HkI0.v4)();
        // Narrow pageClass to 'renderer' | 'editor' for the experience attributes
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: pageClassAttr,
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            /* selectionPropsRef fallback: selectionProps (React state) may be null immediately
         after a sidebar close due to a render-cycle gap, while the ref holds the last-known
         value. Prefer the ref (updated synchronously) so nudge click always gets the freshest
         value. For experiment-OFF callers, selectionProps is non-null so ref vs state is moot. */ const currentSelectionProps = selectionPropsRef.current ?? selectionProps;
            if (!currentSelectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            // Reset ref before applyDraftMode so handleSaveSuccess reads the fresh step (COMMENTS-6594).
            if ((0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false)) selectionOptionsRef.current = undefined;
            result = currentSelectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            const newSelectionOptions = {
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            };
            // Update ref synchronously BEFORE setSelectionOptions so handleSaveSuccess
            // always reads the latest step even if its closure captured a stale value.
            selectionOptionsRef.current = newSelectionOptions;
            setSelectionOptions(newSelectionOptions);
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $cozmU.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        setCommentSidebarContext('create');
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // When the experiment is on, read from ref to get the latest selectionOptions regardless of
            // closure staleness — the create panel may hold an old handleSaveSuccess reference from before
            // setSelectionOptions was called for the new selection, causing the stale step to be used.
            const currentSelectionOptions = selectionOptions && (0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false) ? selectionOptionsRef.current ?? selectionOptions : selectionOptions;
            // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
            // This provides more reliable annotation application, matching the editor implementation
            if (rendererActions && currentSelectionOptions?.step) {
                const step = currentSelectionOptions.step;
                // Extract position from step - use pos if available, otherwise use from/to
                const position = currentSelectionOptions.pos ? {
                    to: currentSelectionOptions.pos,
                    from: currentSelectionOptions.pos
                } : {
                    to: step.to,
                    from: step.from
                };
                const annotationResult = rendererActions.applyAnnotation(position, {
                    annotationId: annotationId,
                    annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                });
                if (annotationResult && annotationResult.doc) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    if (!storedCommentData) selectionProps.removeDraftMode();
                    selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                    waitForAnnotationElementAndEmit(annotationId, emitter);
                } else throw new Error('Error ocurred when applying the step to the active document');
            } else {
                // Fallback to original onCreate method
                // Since we generated the uuid ourselves, we need to replace the document generated with
                // the annotationId that we received from the backend so things line up correctly
                result = selectionProps.onCreate(annotationId);
                if (result) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    if (!storedCommentData) selectionProps.removeDraftMode();
                    selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                    waitForAnnotationElementAndEmit(annotationId, emitter);
                } else throw new Error('Error ocurred when applying the step to the active document');
            }
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions,
        waitForAnnotationElementAndEmit
    ]);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            commentSidebarContext: commentSidebarContext,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        commentSidebarContext,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            requestCloseEditorComment: requestCloseEditorComment,
            setEditorCommentCloseGuard: setEditorCommentCloseGuard,
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            setCommentSidebarContext: setCommentSidebarContext,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null),
            waitForAnnotationElementAndEmit: waitForAnnotationElementAndEmit,
            applyDraftModeRef: applyDraftModeRef
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        requestCloseEditorComment,
        setEditorCommentCloseGuard,
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        setCommentSidebarContext,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData,
        waitForAnnotationElementAndEmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("cz6eP", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");


var $5uEm7 = parcelRequire("5uEm7");

class $91ffffc20e95f4c4$export$7cc60aa9ef845515 extends (0, $eSa5t.EventEmitter) {
    on(event, listener) {
        return super.on(event, listener);
    }
    off(event, listener) {
        return super.removeListener(event, listener);
    }
}
function $91ffffc20e95f4c4$export$3238f27f6e07aed2() {
    return new (0, $5uEm7.SharedAnnotationManager)();
}
module.exports["AnnotationUpdateEmitter"] = $91ffffc20e95f4c4$export$7cc60aa9ef845515;
module.exports["createAnnotationManager"] = $91ffffc20e95f4c4$export$3238f27f6e07aed2;

});

parcelRegister("5uEm7", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");

class $ca65321d79324be4$export$c7aecf09b7cf478f {
    setPreemptiveGate(handler) {
        this.preemptiveGate = handler;
        return this;
    }
    checkPreemptiveGate() {
        if (this.activePreemptiveGate) // If the preemptive gate check already in flight then just return the promise
        // and don't call the preemptive gate again.
        // This is to prevent multiple calls to the preemptive gate creating multiple
        // promises that will resolve at different times.
        return Promise.resolve(this.activePreemptiveGate);
        const gate = this.activePreemptiveGate = this.preemptiveGate().then((result)=>{
            this.activePreemptiveGate = undefined;
            return result;
        });
        return gate;
    }
    onDraftAnnotationStarted(handler) {
        this.emitter.on('draftAnnotationStarted', handler);
        return this;
    }
    offDraftAnnotationStarted(handler) {
        this.emitter.off('draftAnnotationStarted', handler);
        return this;
    }
    onAnnotationSelectionChange(handler) {
        this.emitter.on('annotationSelectionChanged', handler);
        return this;
    }
    offAnnotationSelectionChange(handler) {
        this.emitter.off('annotationSelectionChanged', handler);
        return this;
    }
    onDraftAnnotationCleared(handler) {
        this.emitter.on('draftAnnotationCleared', handler);
        return this;
    }
    offDraftAnnotationCleared(handler) {
        this.emitter.off('draftAnnotationCleared', handler);
        return this;
    }
    emit(event) {
        this.emitter.emit(event.name, 'data' in event ? event.data : undefined);
        return this;
    }
    hook(method, handler) {
        this.hooks.set(method, handler);
        return this;
    }
    unhook(method, handler) {
        if (!this.hooks.has(method) || this.hooks.get(method) !== handler) return this;
        this.hooks.delete(method);
        return this;
    }
    allowAnnotation() {
        const fn = this.hooks.get('allowAnnotation');
        if (!fn) return false;
        try {
            return fn();
        } catch  {
            return false;
        }
    }
    startDraft(localId) {
        const fn = this.hooks.get('startDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(localId);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearDraft() {
        const fn = this.hooks.get('clearDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    applyDraft(id) {
        const fn = this.hooks.get('applyDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    getDraft() {
        const fn = this.hooks.get('getDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationSelected(id, isSelected) {
        const fn = this.hooks.get('setIsAnnotationSelected');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            // NOTE: The hook needs to manage the firing the annotationSelectionChanged event when a change is made. This is
            // because the hook is responsible for the state of the selection. The manager is not responsible for the state of
            // the selection.
            return fn(id, isSelected);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationHovered(id, isHovered) {
        const fn = this.hooks.get('setIsAnnotationHovered');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id, isHovered);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearAnnotation(id) {
        const fn = this.hooks.get('clearAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearSelectedAnnotation() {
        const fn = this.hooks.get('clearSelectedAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearHoveredAnnotation() {
        const fn = this.hooks.get('clearHoveredAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    constructor(){
        /**
     * This is the event emitter that is used to emit events from the manager. It is used to communicate with
     * other parts of the application.
     */ this.emitter = new (0, $eSa5t.EventEmitter)();
        /**
     * This is the map of hooks that can be added to the manager. Hooks are a 1:1 mapping of methods that can be
     * called on the manager. They are used to extend the functionality of the manager.
     */ this.hooks = new Map();
        this.preemptiveGate = ()=>Promise.resolve(true);
        this.activePreemptiveGate = undefined;
    }
}
module.exports["SharedAnnotationManager"] = $ca65321d79324be4$export$c7aecf09b7cf478f;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;
module.exports["ContentRepresentation"] = $f8b43d46712cd783$export$f4016897b165b6d5;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'tinyMCE';
    // Pass routeName to isDatabase/isWhiteboard - they will use it to avoid race conditions during SPA transitions
    if ((0, $gEtAQ.isDatabase)(routeName)) return 'database';
    if ((0, $gEtAQ.isWhiteboard)(routeName)) return 'whiteboard';
    if ((0, $gEtAQ.isSlides)(routeName)) return 'slide';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    (selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("gczDe", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d31fe98ca852fa54$var$rendererEmitter = undefined;
const $d31fe98ca852fa54$export$894d051c63add88c = ()=>{
    if (!$d31fe98ca852fa54$var$rendererEmitter) $d31fe98ca852fa54$var$rendererEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d31fe98ca852fa54$var$rendererEmitter;
};
module.exports["getRendererAnnotationEventEmitter"] = $d31fe98ca852fa54$export$894d051c63add88c;

});

parcelRegister("4EKKB", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $gykrH = parcelRequire("gykrH");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $6nryz = parcelRequire("6nryz");


var $8Ss4E = parcelRequire("8Ss4E");

let $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
function $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug(_experienceName, experienceStage) {
    function createInlineCommentExperienceDebug({ error: error, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Legacy select debug message: ${error.message || String(error)}`,
            attributes: {
                ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                ...extraAttributes,
                experienceStage: experienceStage
            }
        });
    }
    return createInlineCommentExperienceDebug;
}
var $d671aa981fcb4da6$var$ExperienceType = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["DOCUMENT"] = "document";
    ExperienceType["DOCUMENT_WITH_PANEL"] = "documentWithPanel";
    ExperienceType["PANEL"] = "panel";
    return ExperienceType;
}($d671aa981fcb4da6$var$ExperienceType || {});
function $d671aa981fcb4da6$var$getExperienceType(entryPoint, sidebarOpenAtStart) {
    switch(entryPoint){
        case 'create-comment':
        case 'comment-navigation':
        case 'unknown:InlineComment':
            return "document";
        case 'annotation-change':
        case 'keyboard-navigation':
        case 'unknown:RendererFocus':
            return sidebarOpenAtStart ? "documentWithPanel" : "document";
        case 'sidebar':
        case 'unknown:CommentsPanelList':
            return "panel";
        default:
            return "document";
    }
}
const $d671aa981fcb4da6$export$e2b3aff7888f2745 = {
    _start: (startAttributes, _options)=>{
        if (startAttributes.pageClass === 'tinyMCE' || startAttributes.pageClass === 'database' || startAttributes.pageClass === 'whiteboard' || startAttributes.pageClass === 'slide') return;
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        const runningExperienceAttributes = experienceState?.attributes;
        const context = (0, $6nryz.getInlineCommentExperienceContext)(startAttributes.annotationId, startAttributes.pageMode ?? (startAttributes.pageClass === 'renderer' ? 'view' : undefined));
        if (startAttributes.commentTargetType) context.commentTargetType = startAttributes.commentTargetType;
        if (!experienceState?.hasStopped && runningExperienceAttributes?.annotationId !== undefined && runningExperienceAttributes?.annotationId === startAttributes.annotationId) {
            // Later signals can supply page mode or a previously unavailable target.
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                ...context.commentTargetType !== 'unknown' ? {
                    commentTargetType: context.commentTargetType
                } : {},
                ...context.pageMode ? {
                    pageMode: context.pageMode
                } : {}
            });
            // If there is an existing (unstopped) experience
            // - and that experience has an annotationId
            //   - keyboard and comment navigation will start experiences without an annotationId -- and these should be restarted on an new start
            // - and that annotationId matches the one in the startAttributes
            // we assume the experience is still active, and don't start a new one.
            // the reason we can hit this is because the selectInlineCommentCompoundExperience._start is called when there is a "select inline comment"
            // signal, and individual signals fire in different orders (sometimes they are the first signal, sometimes they are later).
            // However -- if the second signal has a clearer entry point
            // we update the entry point attribute of the existing experience.
            if (runningExperienceAttributes?.entryPoint?.startsWith('unknown') && !startAttributes.entryPoint.startsWith('unknown')) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                    entryPoint: startAttributes.entryPoint
                });
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint}`
                });
            }
            return;
        }
        if (// When the side bar is open, and the user selects a comment using the keyboard,
        // the keyboard navigation triggers a select annotation first (without an annotationId),
        // followed by the show comment start or select annotation complete (with an annotationId.
        startAttributes.entryPoint === 'unknown:CommentsPanelList' && runningExperienceAttributes?.entryPoint === 'keyboard-navigation' && runningExperienceAttributes?.annotationId === undefined) {
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                annotationId: startAttributes.annotationId,
                ...context
            });
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
            });
            return;
        }
        // First prepare the new attributes without modifying the global state
        // This ensures that any abort of current experiences will use their original attributes
        const newAttributes = {
            ...context,
            pageClass: startAttributes.pageClass,
            commentType: startAttributes.commentType,
            annotationId: 'annotationId' in startAttributes ? startAttributes.annotationId : undefined,
            entryPoint: startAttributes.entryPoint,
            version: 'single-experience'
        };
        // We check if there is a dom element with a testId of "object-sidebar-panel-body" and if so mark the
        // experience as being during a sidebar open experience.
        newAttributes.sidebarOpenAtStart = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('[data-testid="object-sidebar-panel-body"]') !== null;
        newAttributes.experienceType = $d671aa981fcb4da6$var$getExperienceType(startAttributes.entryPoint, newAttributes.sidebarOpenAtStart);
        // If the create inline comment experience is running, we want to link the two experiences
        const createInlineCommentExperienceState = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        if (createInlineCommentExperienceState && !createInlineCommentExperienceState.hasStopped) newAttributes.linkedCompoundTaskId = createInlineCommentExperienceState.attributes?.compoundTaskId;
        // Adds a debug point to the last running experience (debug points are only added if there is a running experience)
        // Note:
        // A new experience is followed after this is fired -- so this should always be the last debug point (as the new experience will trigger a fail or abort).
        // In the case there is no running experience, the experience tracker will discard the debugPoint.
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Restarted from ${startAttributes.entryPoint} with annotationId: ${startAttributes.annotationId} (sidebarOpenAtStart: ${newAttributes.sidebarOpenAtStart})`
        });
        // Start press trace if no trace is currently active
        (0, $8Ss4E.startUFOPressTrace)((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        // Then start a new compound experience with the new attributes
        // This will abort any running experiences with the same name, but they'll keep their original attributes
        experienceTracker.start({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...newAttributes
            },
            // If the annotation is not selected and comment shown to the user within 12 seconds -- we assume there has been a failure to select the inline comment
            timeout: (0, $aJPUt.ExperienceTimeout).SELECT_INLINE_COMMMENT,
            collect: (events)=>{
                const isThisCommentBeingResolved = (event)=>{
                    return event.name === (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) && event.action === 'taskStart' && (0, $gykrH.hasAttribute)(event, 'annotationId', $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId);
                };
                events.forEach((event)=>{
                    if (isThisCommentBeingResolved(event)) $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                        abortReason: 'Comment being resolved'
                    });
                });
            }
        });
        if (startAttributes.annotationId === undefined) experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with unknown annotationId`
        });
        else experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
        });
        // Now it's safe to update the global state since any aborts have already happened
        // We reset experience state if we are starting a new experience
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...newAttributes
        };
        // By the time we get a task fail (particularly for timeout aborts) -- the contentId may have changed
        const originalContentId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.attributes?.contentId;
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.originalContentId = originalContentId;
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                originalContentId: originalContentId
            }
        });
    },
    debugPoint: (message, attributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
    },
    addCommonAttributes: (additionalCommonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
            ...additionalCommonAttributes
        };
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: additionalCommonAttributes
        });
    },
    abort: ({ abortReason: abortReason })=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.abort({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            reason: abortReason,
            checkForTimeout: true
        });
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
    },
    selectAnnotation: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'selectAnnotation'),
        /**
     * This is currently used to start from
     * - annotationId unknown
     *   - comment navigation
     *   - keyboard navigation
     * - annotationId known
     *   - create comment
     *   - comment sidebar comment selection
     *
     * These should be separate signals once the multi experience is deprecated.
     */ start: (startAttributes)=>{
            function isUnknownAnnotationId(startAttributes) {
                return startAttributes.entryPoint === 'keyboard-navigation' || startAttributes.entryPoint === 'comment-navigation';
            }
            if (isUnknownAnnotationId(startAttributes)) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes, {
                    annotationUnknown: true
                });
                return;
            }
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
        },
        abort: ({ abortReason: abortReason })=>{
            $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                abortReason: // @ts-ignore the abort reasons have mismatch due to type from the old multi experience. and once that is removed we can remove this cast
                abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        /**
     * Note -- the selectAnnotation does not trigger a completion of the selectInlineComment experience.
     * Instead -- the selectInlineComment experience is completed when the showComment experience completes
     * (which looks for the selected annotation as part of its completion logic).
     *
     * With the single experience -- this is less a complete and rather just an indirect signal that a selection has been made (in case it's not detected by the showComment experience).
     * When the multi selectInlineCommentCompoundExperience is deprecated, this can be renamed to indicate it's a "annotationSelection" signal rather than a "completed" signal.
     */ complete: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
            // There can be cases where no start has been called for the select experience.
            // - When a product consumer of the editor setselectedannotation api calls the select experience
            //   and has not been instrumented.
            // - When the annotation selection is via editor logic (ie. editor selection being moved onto
            //   an annotation).
            if (experienceState === null) {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: 'selectAnnotation completed from no experience - no explicit start point',
                    attributes: startAttributes
                });
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            }
        }
    },
    showComment: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'showComment'),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        },
        start: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: 'showComment start triggered',
                attributes: startAttributes
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                reason: abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        fail: (error, extraAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                    ...extraAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        complete: (completedFrom)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: completedFrom,
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        standaloneSidebarComplete: (commentUIVerticalDistanceFromAnnotation)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `standaloneSidebarComplete triggered`
            });
            if (commentUIVerticalDistanceFromAnnotation > 40) experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `Comment UI is misaligned by >40px pixels`,
                attributes: {
                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                }
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.standaloneSidebarComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`selectInlineCommentCompoundExperience.standaloneSidebarComplete ended without a focused and in viewport annotation.`),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Standalone sidebar inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        },
        sidePanelComplete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `sidePanelComplete triggered`
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete did not result in a visible and focused annotation'),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Side Panel inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        }
    }
};
/**
 *
 * Checks if there is an annotation currently visible in the document.
 *
 * The comment UI is currently opinionated about the comment UI being attached to the first instance of the focused annotation element.
 *
 * So we can safely skip checking if the initial focused annotation is not visible
 *
 * Note: this method causes reflow, and should not be used in performance sensitive code.
 *
 */ function $d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused(annotationId) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const possibleFocusedAnnotationElements = document.querySelectorAll(// This will match the annotation id in either the Editor or Renderer
    `[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"][data-has-focus="true"],
		[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"] .ak-editor-annotation-focus`);
    if (possibleFocusedAnnotationElements.length === 0) {
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `No annotation element found`
        });
        return false;
    }
    /**
   * Annotations can have multiple elements in the dom, with each of the elements having the focus state set to true.
   * Ie. Comments spanning multiple lines will have multiple elements with the focus state set to true.
   *
   * In addition to this -- sometimes there will be "hidden" focused annotation elements where the dom is duplicated
   * such as for annotations on table header cells in the renderer.
   *
   * If the first element is not visible due to being hidden, we continue checking until we reach a visible element, and then check whether it is in the viewport.
   *
   */ for(let i = 0; i < possibleFocusedAnnotationElements.length; i++){
        const element = possibleFocusedAnnotationElements[i];
        if (element instanceof HTMLElement) {
            if (!element.checkVisibility()) {
                // Skip to the next element if the current one is not visible
                // This can happen in scenarios where the dom is duplicated, such as for annotations on table header cells in the renderer.
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element had a hidden focused element, skipping to next element`
                });
                continue;
            }
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.left >= 0 && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            // This is the first visible element -- which should be focused and
            // in the viewport
            if (isVisible) return true;
            else {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element found - but not in viewport`
                });
                return false;
            }
        }
    }
    return false;
}
const $d671aa981fcb4da6$export$b65d55854b7eb069 = {
    debug: $d671aa981fcb4da6$export$e2b3aff7888f2745.debugPoint
};
module.exports["selectInlineCommentCompoundExperience"] = $d671aa981fcb4da6$export$e2b3aff7888f2745;
module.exports["selectInlineComment"] = $d671aa981fcb4da6$export$b65d55854b7eb069;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("6nryz", function(module, exports) {
function $244e2cac5c7985f0$export$232fd3e2eca7a829(annotationId, pageMode) {
    const context = {
        commentTargetType: 'unknown',
        ...pageMode ? {
            pageMode: pageMode
        } : {}
    };
    if (!annotationId) return context;
    const annotation = Array.from(typeof document !== 'undefined' ? document.querySelectorAll('[data-mark-annotation-type="inlineComment"][data-id]') : []).find((element)=>element.getAttribute('data-id') === annotationId);
    if (!annotation) return context;
    const blockSelector = '[data-node-type="extension"], [data-prosemirror-node-name="extension"], [data-node-type="media"], [data-node-type="mediaSingle"], [data-prosemirror-node-name="mediaSingle"]';
    // Renderer anchors sit inside the block; editor annotation marks can wrap it.
    const block = annotation.closest(blockSelector) ?? annotation.querySelector(blockSelector);
    if (!block) return {
        ...context,
        commentTargetType: 'text'
    };
    const nodeType = block.getAttribute('data-node-type') ?? block.getAttribute('data-prosemirror-node-name');
    if (nodeType !== 'extension') return {
        ...context,
        commentTargetType: 'media'
    };
    const embed = block.querySelector('[data-native-embed-experience="maui"]');
    return {
        ...context,
        commentTargetType: block.getAttribute('extensionkey') === 'native-embed:maui' || embed?.closest(blockSelector) === block ? 'remixEmbed' : 'other'
    };
}
module.exports["getInlineCommentExperienceContext"] = $244e2cac5c7985f0$export$232fd3e2eca7a829;

});

parcelRegister("8Ss4E", function(module, exports) {

var $3AVOh = parcelRequire("3AVOh");


var $kyKWe = parcelRequire("kyKWe");


var $34MZN = parcelRequire("34MZN");


var $eYg5X = parcelRequire("eYg5X");


var $lTECB = parcelRequire("lTECB");


var $hukUK = parcelRequire("hukUK");


var $c3Qwv = parcelRequire("c3Qwv");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $7v9li = parcelRequire("7v9li");


var $949zl = parcelRequire("949zl");


var $h10mo = parcelRequire("h10mo");

const $8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences = [
    (0, $irVI7.NOT_FOUND_EXPERIENCE),
    (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
];
const $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound = (0, $1A7bE.collectAny)($8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences);
const $8c50530bac3b9ba1$var$stopOnConnectAddon = (0, $1A7bE.collectAny)([
    (0, $irVI7.CONNECT_ADDON_EXPERIENCE)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $8c50530bac3b9ba1$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $8c50530bac3b9ba1$var$redirectRoutesForExperiences = {
    [(0, $irVI7.CREATE_PAGE_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    // Same redirect routes as CREATE_PAGE_EXPERIENCE — the link-creation flow also succeeds when it leads to edit-page (a page was created from an Undefined Link).
    [(0, $irVI7.CREATE_PAGE_FROM_LINK_CREATION_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name
    ],
    [(0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)]: [
        (0, $1NBp8.WHITEBOARD_BOARD).name
    ],
    [(0, $irVI7.CREATE_SLIDE_EXPERIENCE)]: [
        (0, $1NBp8.SLIDES_VIEW).name
    ],
    [(0, $irVI7.CREATE_DATABASE_EXPERIENCE)]: [
        (0, $1NBp8.DATABASE_VIEW).name
    ],
    [(0, $irVI7.CREATE_EMBED_EXPERIENCE)]: [
        (0, $1NBp8.EMBED_VIEW).name
    ]
};
const $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
];
const $8c50530bac3b9ba1$export$3fe90f303be4225a = 'Aborted due to SPA started a new experience';
const $8c50530bac3b9ba1$export$4b786e0ae0cc0857 = {
    [(0, $1NBp8.SPACE_OVERVIEW).name]: 'space',
    [(0, $1NBp8.COMPANY_HUB).name]: 'space',
    [(0, $1NBp8.EDIT_PAGE_EMBED).name]: 'page',
    [(0, $1NBp8.EDIT_PAGE_V2).name]: 'page',
    [(0, $1NBp8.EDIT_BLOG_V2).name]: 'blog',
    [(0, $1NBp8.VIEW_PAGE).name]: 'page',
    [(0, $1NBp8.VIEW_BLOG).name]: 'blog',
    [(0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name]: 'blog'
};
const $8c50530bac3b9ba1$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.CREATE_PAGE).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $8c50530bac3b9ba1$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fGzMp.captureRouteChange)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $8c50530bac3b9ba1$var$finishLivePageExperiences();
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $8c50530bac3b9ba1$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $7v9li.hasHealthyRunningEditPageExperience)() || name === (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE) && (0, $7v9li.hasHealthyRunningCompanyHubEditExperience)() || name === (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE) && (0, $949zl.hasHealthyRunningViewPageExperience)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: $8c50530bac3b9ba1$export$3fe90f303be4225a
        });
    });
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(e.name);
    });
    $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $1NBp8.COMPANY_HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.CREATE_PAGE).name:
        case (0, $1NBp8.HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.VIEW_PAGE).name:
        case (0, $1NBp8.VIEW_BLOG).name:
        case (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.contentId, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $1NBp8.PAGE_SPLIT).name:
            $8c50530bac3b9ba1$var$startSplitPageLoad(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name:
            $8c50530bac3b9ba1$var$startEditPageSmartCreate(match);
            break;
        case (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $1NBp8.EXTERNAL_SHARE).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $1NBp8.SPACE_OVERVIEW).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $1NBp8.COMPANY_HUB).name:
            const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)(sessionData) || '';
            $8c50530bac3b9ba1$var$startViewContent(spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $1NBp8.HOME).name:
            (0, $h10mo.startHome)();
            break;
        case (0, $1NBp8.EDIT_TEMPLATE_SPACE).name:
        case (0, $1NBp8.EDIT_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.CREATE_TEMPLATE_SPACE).name:
        case (0, $1NBp8.CREATE_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $1NBp8.ADVANCED_SEARCH).name:
            $8c50530bac3b9ba1$var$startAdvancedSearch(match);
            break;
        case (0, $1NBp8.SPACE_ARCHIVED_PAGES).name:
            $8c50530bac3b9ba1$var$startArchivedPagesList();
            break;
        case (0, $1NBp8.SPACE_BULK_TOOLS).name:
            $8c50530bac3b9ba1$var$startContentManager();
            break;
        case (0, $1NBp8.SPACE_DIRECTORY).name:
            $8c50530bac3b9ba1$var$startSpaceDirectory();
            break;
        case (0, $1NBp8.TEMPLATE_GALLERY).name:
            $8c50530bac3b9ba1$var$startTemplateGallery();
            break;
        case (0, $1NBp8.SPACE_PAGES).name:
            $8c50530bac3b9ba1$var$startSpacePages();
            break;
        case (0, $1NBp8.WHITEBOARD_BOARD).name:
            $8c50530bac3b9ba1$var$startWhiteboardBoard(match);
            break;
        case (0, $1NBp8.SLIDES_VIEW).name:
            $8c50530bac3b9ba1$var$startSlideView(match.params.contentId);
            break;
        case (0, $1NBp8.DATABASE_VIEW).name:
            $8c50530bac3b9ba1$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $1NBp8.EMBED_VIEW).name:
            $8c50530bac3b9ba1$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $1NBp8.FOLDER_VIEW).name:
            $8c50530bac3b9ba1$var$startFolderView(match.params.contentId);
            break;
        case (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER).name:
            $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $1NBp8.SPACE_MANAGER).name:
            $8c50530bac3b9ba1$var$startSpaceManager();
            break;
        case (0, $1NBp8.ADMIN_COMPANY_HOME_BUILDER).name:
        case (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name:
            $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $1NBp8.CREATE_CONTENT).name) $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $8c50530bac3b9ba1$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $7v9li.startCreateAndEditPage)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $8c50530bac3b9ba1$var$startSplitPageLoad(contentId, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPLIT_PAGE_LOAD_EXPERIENCE),
        id: contentId,
        startTime: transitionId === 0 ? 0 : undefined
    });
}
function $8c50530bac3b9ba1$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE), (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE),
        id: id,
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_DIALOG_LOAD
    });
}
function $8c50530bac3b9ba1$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $34MZN.getActiveTrace)();
    if (!activeTrace) (0, $eYg5X.default)(experienceName.replace(/\//g, '-'));
}
function $8c50530bac3b9ba1$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $aJPUt.ExperienceTimeout).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $8c50530bac3b9ba1$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $8c50530bac3b9ba1$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $gykrH.isStop)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $gykrH.isStop)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $8c50530bac3b9ba1$var$startEditPageSmartCreate(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE),
        id: match.params.contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        attributes: {
            // The only identifier shared with the embedding product's preview experience.
            sharedFeaturesInstrumentationId: (0, $c3Qwv.getSingleParam)(match.query, 'sharedFeaturesInstrumentationId')
        },
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...$8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $8c50530bac3b9ba1$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    if (match.name === (0, $1NBp8.EDIT_PAGE_EMBED).name) editPageExperienceName = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (isLegacyEditor) editPageExperienceName = (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE);
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $8c50530bac3b9ba1$export$5396770e9da36673(match.name),
            contentType: $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || match?.name === (0, $1NBp8.HUB_EDIT).name,
            contentId: match.params.contentId,
            isGuest: sessionData?.accessStatus === 'EXTERNAL_COLLABORATOR_ACCESS'
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            const closeExperience = events.find((event)=>(0, $gykrH.isStop)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE), (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startTemplateEditPage(id, transitionId) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && event.name === (0, $irVI7.TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startAdvancedSearch(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
        id: (0, $hukUK.objectHash)((0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(match.query, [
            'search_id'
        ]))
    });
}
function $8c50530bac3b9ba1$var$startArchivedPagesList() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_ARCHIVED_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startContentManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CONTENT_MANAGER_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startSpaceDirectory() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_DIRECTORY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).SPACE_DIRECTORY
    });
}
function $8c50530bac3b9ba1$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $irVI7.TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_CARDS_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $1A7bE.collectAll)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $1A7bE.collectAll)([
        (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    ]);
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.TEMPLATE_GALLERY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startSpacePages() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $c3Qwv.getSingleParam)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.WHITEBOARD_EXPERIENCE));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'slide') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_SLIDE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort') && event.name === (0, $irVI7.SLIDE_CONTENT_EXPERIENCE)));
        }
    });
    else if (match.params.contentType === 'database') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.DATABASE_EXPERIENCE));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_EMBED_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.EMBED_EXPERIENCE));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) {
        // Undefined Links flows (linkCreation=true) are tracked under a separate non-SLA experience
        // to prevent them from polluting the SLA'd create-page experience
        const isLinkCreationFlow = (0, $c3Qwv.getSingleParam)(queryParams, 'linkCreation') === 'true';
        const createPageExperienceName = isLinkCreationFlow ? (0, $irVI7.CREATE_PAGE_FROM_LINK_CREATION_EXPERIENCE) : (0, $irVI7.CREATE_PAGE_EXPERIENCE);
        (0, $fGzMp.getExperienceTracker)().start({
            name: createPageExperienceName,
            timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
            attributes: {
                contentType: match.params.contentType,
                flow: flow,
                isCreateContentRoute: true,
                isPersonalSpace: isPersonalSpace,
                edition: sessionData?.edition,
                shard: sessionData?.shard,
                isLivePage: subType?.toLowerCase() === 'live'
            },
            collect: (events, experience)=>{
                const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || event.name === (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE)));
                if (editPageStarted) experience.succeed();
            }
        });
    }
}
function $8c50530bac3b9ba1$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const contentId = match.params.contentId;
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.WHITEBOARD_EXPERIENCE), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSlideView(contentId) {
    const subExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedSlideSubExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.SLIDE_EXPERIENCE), isEmbedded ? embeddedSlideSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startDatabaseView(contentId) {
    const subExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.DATABASE_EXPERIENCE), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EMBED_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $irVI7.FOLDER_CONTENT_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.FOLDER_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(folderSubExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startSpaceManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_MANAGER_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.COMPANY_HOME_BUILDER_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$finishLivePageExperiences() {
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const livePageExperiencesToSucceed = [
        (0, $irVI7.EDIT_PAGE_EXPERIENCE),
        (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}
module.exports["ROUTE_CHANGE_ABORT_REASON"] = $8c50530bac3b9ba1$export$3fe90f303be4225a;
module.exports["routeNameToContentTypeMap"] = $8c50530bac3b9ba1$export$4b786e0ae0cc0857;
module.exports["startExperienceForRoute"] = $8c50530bac3b9ba1$export$cac1117e2433d80e;
module.exports["startUFOPressTrace"] = $8c50530bac3b9ba1$export$b9a409823a06b924;
module.exports["startEditorExperiences"] = $8c50530bac3b9ba1$export$478e84e2cc5ff22d;
module.exports["startEditorSubExperience"] = $8c50530bac3b9ba1$export$7df6656d8508e8da;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, $9HkI0.v4)();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("1A7bE", function(module, exports) {

var $gykrH = parcelRequire("gykrH");

const $812facbbd37978f7$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $gykrH.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $812facbbd37978f7$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...experienceNames)));
module.exports["collectAll"] = $812facbbd37978f7$export$feb7963ae429f97f;
module.exports["collectAny"] = $812facbbd37978f7$export$79dbdd3e43727beb;

});

parcelRegister("h10mo", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

const $49be9d39a158f0e7$var$homeSubExperiences = [
    (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
    (0, $irVI7.HOME_RECENT_EXPERIENCE),
    (0, $irVI7.HOME_STARRED_EXPERIENCE),
    (0, $irVI7.HOME_WATCHING_EXPERIENCE),
    (0, $irVI7.HOME_DRAFTS_EXPERIENCE)
];
function $49be9d39a158f0e7$export$4278268ff5675d74() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.HOME_EXPERIENCE),
        collect: (0, $1A7bE.collectAny)($49be9d39a158f0e7$var$homeSubExperiences)
    });
}
module.exports["startHome"] = $49be9d39a158f0e7$export$4278268ff5675d74;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
let $3ac00da98b683ca3$var$commentExperienceContext = {};
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const context = {
            commentTargetType: attributes.commentTargetType ?? (attributes.commentType === 'block' ? attributes.blockType === 'media' ? 'media' : 'other' : 'text'),
            ...attributes.pageMode ? {
                pageMode: attributes.pageMode
            } : attributes.pageClass === 'renderer' ? {
                pageMode: 'view'
            } : {}
        };
        $3ac00da98b683ca3$var$commentExperienceContext = context;
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                ...context,
                compoundTaskId: compoundTaskId
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)(attributes.entryPoint === 'mediaViewerSidebar' ? [
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ] : [
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...context,
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint,
            edition: attributes.edition
        };
    },
    getContext: ()=>{
        const experience = (0, $fGzMp.getExperienceTracker)().getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        // An entry point without tracking must not inherit the previous completed attempt.
        return experience && !experience.hasStopped ? {
            ...$3ac00da98b683ca3$var$commentExperienceContext
        } : {};
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("8WQTF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $cozmU.useState)(null);
    const [pageId, setPageId] = (0, $cozmU.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $cozmU.useState)(undefined);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("4gEXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");

function $4ccc472e1abe9fa4$export$b3246a2f66464d01({ onConfirm: handleConfirm }) {
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const { setEditorCommentCloseGuard: setEditorCommentCloseGuard } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    // Register the shared guard that prevents comment navigation or closing from discarding
    // unsaved content without confirmation.
    (0, $cozmU.useEffect)(()=>{
        if (!annotationManager && (!(0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) || !(0, $6mKj3.expValEquals)('confluence_suggested_edits_inline_comment_fix', 'isEnabled', true))) return;
        const closeGuard = !hasContentChanged ? ()=>Promise.resolve(true) : ()=>new Promise((resolve)=>{
                showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        resetContentChanged();
                        handleConfirm();
                        resolve(true);
                    },
                    onCancel: ()=>resolve(false),
                    onClose: ()=>resolve(false)
                });
            });
        annotationManager?.setPreemptiveGate(closeGuard);
        if ((0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) && (0, $6mKj3.expValEquals)('confluence_suggested_edits_inline_comment_fix', 'isEnabled', true)) setEditorCommentCloseGuard(closeGuard);
        return ()=>{
            const allowClose = ()=>Promise.resolve(true);
            annotationManager?.setPreemptiveGate(allowClose);
            if ((0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) && (0, $6mKj3.expValEquals)('confluence_suggested_edits_inline_comment_fix', 'isEnabled', true)) setEditorCommentCloseGuard(allowClose);
        };
    }, [
        hasContentChanged,
        annotationManager,
        showModal,
        resetContentChanged,
        handleConfirm,
        setEditorCommentCloseGuard
    ]);
}
module.exports["usePreemptiveGate"] = $4ccc472e1abe9fa4$export$b3246a2f66464d01;

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("7NKS7"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("7NKS7", function(module, exports) {

let $5ae177c72d819b7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5ae177c72d819b7b$var$load("hhss7"),
    $5ae177c72d819b7b$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("bSvtO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $8s9DV.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $kBr4q.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $kBr4q.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $kBr4q.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$dbffca2f0193dbd0 = ()=>(0, $c6StJ.defaultRegistry).getStore($45ca38ec521afdf7$var$CommentsContentStore).storeState.getState();
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;
module.exports["getCommentsContentState"] = $45ca38ec521afdf7$export$dbffca2f0193dbd0;

});

parcelRegister("gJoPj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $a33Aa = parcelRequire("a33Aa");


var $gczDe = parcelRequire("gczDe");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");


var $6mKj3 = parcelRequire("6mKj3");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $7aRa9 = parcelRequire("7aRa9");


var $ep3mz = parcelRequire("ep3mz");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $9wGTI = parcelRequire("9wGTI");


var $8WQTF = parcelRequire("8WQTF");


var $lb2Lp = parcelRequire("lb2Lp");


var $aSsfA = parcelRequire("aSsfA");


var $1ZGYV = parcelRequire("1ZGYV");


var $eTcMK = parcelRequire("eTcMK");


var $ifBRq = parcelRequire("ifBRq");

const $61084f20d36cc3f6$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentLinkNotFoundFlagTitle: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    }
});
const $61084f20d36cc3f6$export$3cf51438c4a7a1a = ({ rendererRef: rendererRef, flags: flags })=>{
    const hasHandledCommentLink = (0, $cozmU.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, editCommentId: editCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const commentId = focusedCommentId || replyToCommentId || editCommentId;
    const skipNewFlow = !commentId;
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: skipNewFlow
        }
    });
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)({
        commentId: foundComment?.parentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: skipNewFlow || !foundComment?.parentId
        }
    });
    const queryParamData = (0, $cozmU.useMemo)(()=>{
        if (!commentError && !commentLoading && foundComment) {
            const location = foundComment.location;
            const parentId = foundComment.parentId;
            const parentLocation = parentId && !parentError && !parentLoading && parentComment ? parentComment.location : undefined;
            // Return the data if this is a root commment (it doesn't have a parent comment) and we
            // have just that comment's data or if it's a reply and we also have a parent comment
            // with valid data.  This prevents returning incomplete data while parent comment is
            // loading, which causes the dependent memoized items to be generated multiple times and in
            // turn causes multiple simulated annotation clicks when we only want one simulated click
            // after everything is loaded.
            if (!parentId || parentComment) return {
                location: location,
                parentId: parentId,
                parentLocation: parentLocation
            };
        }
        return undefined;
    // Note that we only want to regenerate this data only when the data contents has changed, not
    // when just the reference to the data has changed. Otherwise, we will generate the data twice:
    // once when useCommentById()'s single comment query returns with data and a second time when
    // the useAllCommentsData()'s query completes with similar data but a different reference -
    // which causes the dependent memoized items to be generated multiple times which in turn
    // causes multiple simulated annotation clicks when we only want one simulated click.
    // Note that looking at the comment IDs is sufficient because we only want to open/scroll to
    // the comment once even if other pieces of the comment's data change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentId,
        foundComment?.id,
        commentLoading,
        commentError,
        parentComment?.id,
        parentLoading,
        parentError
    ]);
    const queryParamDataExt = (0, $cozmU.useMemo)(()=>{
        const { location: location, parentLocation: parentLocation } = queryParamData || {};
        return location?.inlineMarkerRef ? {
            annotationId: location.inlineMarkerRef,
            isResolved: Boolean(location.inlineResolveProperties?.resolved)
        } : {
            annotationId: parentLocation?.inlineMarkerRef,
            isResolved: Boolean(parentLocation?.inlineResolveProperties?.resolved)
        };
    }, [
        queryParamData
    ]);
    // Create callback for handling replyToCommentId when comment is rendered
    const onReplyToCommentReady = (0, $cozmU.useCallback)(()=>{
        if (!replyToCommentId) return;
        const rawComment = foundComment;
        if (rawComment) {
            const commentWithAuthor = rawComment;
            // Get annotationId from the reply-to comment's location
            const annotationId = queryParamDataExt?.annotationId;
            // Set the thread key to the annotationId of the parent comment we're replying to
            if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
            // Access author field - both types have this field
            const author = commentWithAuthor?.author;
            // Set up reply state
            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, true));
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        replyToCommentId,
        foundComment,
        queryParamDataExt,
        setReplyToCommentId,
        setCurrentlySelectedThreadKey
    ]);
    const tryToFocusAndScrollActiveCommentCallback = (0, $cozmU.useCallback)(()=>{
        return $61084f20d36cc3f6$var$tryToFocusAndScrollActiveComment({
            parentId: queryParamData?.parentId,
            annotationId: queryParamDataExt?.annotationId || null,
            commentId: commentId || null
        });
    }, [
        queryParamData,
        queryParamDataExt,
        commentId
    ]);
    (0, $1ZGYV.useRetryOnMutation)({
        callback: tryToFocusAndScrollActiveCommentCallback,
        elementRef: rendererRef,
        skip: !commentId || !queryParamData || queryParamDataExt.isResolved
    });
    (0, $cozmU.useEffect)(()=>{
        if (!queryParamData || hasHandledCommentLink.current) return;
        const { location: location } = queryParamData;
        const { annotationId: annotationId } = queryParamDataExt;
        if (location) {
            if (queryParamDataExt.isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (annotationId) {
                    setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                }
                if ((0, $6mKj3.expValEquals)('cc_comments_fix_resolved_focused_comments', 'isEnabled', true)) hasHandledCommentLink.current = true;
            } else if (annotationId) {
                // rendererActions is populated asynchronously — wait for it before checking
                // annotation marks, otherwise we'd incorrectly treat active comments as dangling
                // and open an empty DELETED_CONTENT panel (the check below latches via
                // hasHandledCommentLink, so a premature run never recovers). The effect re-runs
                // when rendererActions becomes available (it is a dependency).
                if (!rendererActions) return;
                // Comment exists in DB (location is truthy) but annotation mark may be gone from page content.
                // Check if annotation mark exists in renderer; if not, open the panel on the detached comment.
                const marks = rendererActions.getAnnotationMarks();
                // The renderer can briefly report ZERO marks while it (re)hydrates the document during
                // load (observed transitioning 6 -> 0 -> 6). Concluding "dangling" during that window
                // opens an empty DELETED_CONTENT panel and latches it via hasHandledCommentLink, so it
                // never recovers. Requiring at least one mark closes that race — this is the view-path
                // counterpart of the editor fix for bug #19 (which uses annotations.length > 0).
                if (!marks || marks.length === 0) return;
                const annotationExists = marks?.some((mark)=>mark.attrs?.id === annotationId);
                if (!annotationExists) {
                    setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId);
                    showCommentsPanel({
                        openWithView: (0, $6mKj3.expValEquals)('cc_comments_detached_in_open_view', 'isEnabled', true) ? (0, $3mVfX.ViewValues).OPEN : (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
                    hasHandledCommentLink.current = true;
                    return;
                }
            }
        } else {
            // Wait for the comment query to finish before checking if annotation exists
            // This prevents race condition where we check before comment data is available
            // Only apply this check when the feature flag is enabled
            if ((0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) {
                // Wait for renderer actions and comment query to finish (isCommentNotFound is undefined while query is loading)
                if (!rendererActions || annotationId && isCommentNotFound === undefined) return;
            }
            // Check if annotation exists in renderer only when we need to make the decision
            // Ensure rendererActions is available before accessing it
            if (!rendererActions && (0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) return;
            const annotationExists = rendererActions?.getAnnotationMarks()?.some((mark)=>mark.attrs.id === annotationId);
            if (annotationId && !annotationExists) {
                setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE); // needed so that the view knows which thread to scroll to after rendering the threads
                setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                showCommentsPanel({
                    openWithView: (0, $6mKj3.expValEquals)('cc_comments_detached_in_open_view', 'isEnabled', true) ? (0, $3mVfX.ViewValues).OPEN : (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
            }
            hasHandledCommentLink.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        queryParamData,
        rendererActions,
        orderedActiveAnnotationIdList
    ]);
    // Only display the "comment not found" flag once
    (0, $cozmU.useEffect)(()=>{
        if (isCommentNotFound) {
            const VIEWPAGE_COMMMENT_LINK_NOT_FOUND_FLAG_ID = `viewpage-comment-link-not-found-${commentId}`;
            flags.showWarningFlag({
                id: VIEWPAGE_COMMMENT_LINK_NOT_FOUND_FLAG_ID,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $61084f20d36cc3f6$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $61084f20d36cc3f6$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
            });
        }
    }, [
        commentId,
        flags,
        isCommentNotFound
    ]);
    return null;
};
const $61084f20d36cc3f6$var$tryToFocusAndScrollActiveComment = ({ parentId: parentId, annotationId: annotationId, commentId: commentId })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const mark = document.querySelector(`[data-id="${annotationId}"]`);
    if (mark) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        // If the already open container is showing the correct comment, don't send another click event to open it
        if (focusedMarkerRef?.id !== annotationId) {
            const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
            (0, $aHcFH.checkElementExpand)(mark, true);
            emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId
                ],
                eventTarget: mark
            });
        }
        // Deep-link scrolling: unified navigation when we have a comment id; otherwise scroll to the mark
        // (replies skip mark-only scroll here — reply scrolling runs after the reply renders to avoid double scroll)
        if (commentId) {
            const success = (0, $9FoVw.handleDeepLinkNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: 'center',
                markElement: mark,
                commentId: commentId
            });
            if (!success) {
                (0, $a33Aa.abortAll)('new_interaction', `focused-comment-scroll`);
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        } else if (!parentId) {
            (0, $a33Aa.abortAll)('new_interaction', `focused-comment-scroll`);
            (0, $aHcFH.scrollToElementWithViewingRoom)({
                element: mark,
                useInstantScroll: true
            });
        }
    }
    return !!mark;
};
const $61084f20d36cc3f6$var$withInlineCommentQueryParamUnification = (Component)=>(props)=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_comment_param_unification')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ifBRq.CommentQueryParamsListener), {
            isArchived: props.isArchived,
            rendererRef: props.rendererRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props);
    };
const $61084f20d36cc3f6$export$34418bee20f397f = (0, $7aRa9.withFlags)($61084f20d36cc3f6$var$withInlineCommentQueryParamUnification($61084f20d36cc3f6$export$3cf51438c4a7a1a));
module.exports["InlineCommentQueryParamsListener"] = $61084f20d36cc3f6$export$34418bee20f397f;

});

parcelRegister("liGyh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");

const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    const { comment: comment, error: error } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery
        }
    });
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    let commentContainerId;
    if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
    commentContainerId = comment.container?.id;
    else commentContainerId = undefined;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === comment?.location?.type) && (pageId === commentContainerId || commentContainerId === undefined);
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParams = (0, $cozmU.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");

const $6b00aa328c211ce7$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        }
    };
};
const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["buildMutationContextForNoNetworkError"] = $6b00aa328c211ce7$export$5c24224d7e29c719;
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: skip = false } = options;
    // Get processed comments data
    const { isDataProcessed: isDataProcessed, flatCommentsMap: flatCommentsMap, flatMarkerRefMap: flatMarkerRefMap, error: processedCommentsError } = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $cozmU.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "comments-data-manager"
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $cozmU.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (isDataProcessed) {
            if (commentId) {
                const cachedComment = flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.filter((node)=>!!node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        flatCommentsMap,
        flatMarkerRefMap,
        isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $cozmU.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && isDataProcessed && !oneCommentData.loading && !processedCommentsError && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        isDataProcessed,
        processedCommentsError,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $cozmU.useMemo)(()=>{
        return validationError || processedCommentsError || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsError,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $cozmU.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "comments-data-manager"
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<1ab88c86ecf711245680266df88d829b>>
 * @relayHash 30943931b9ef970914fcabde1ec18427
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v9 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v25 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v26 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = {
        "kind": "ScalarField",
        "name": "when"
    }, v29 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v26 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v27 /*: any*/ ,
                                v28 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ 
        },
        "params": {
            "cacheID": "30943931b9ef970914fcabde1ec18427",
            "id": "e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "e144cc71550d14f94a82d8439ed2ba0e";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a1c5d5765ca44631 = [
    'DRAFT',
    'CURRENT',
    'ARCHIVED',
    'DELETED'
];
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: $bd3b81debc212a33$export$a1c5d5765ca44631,
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    const updatedRootComments = [
        ...cachedRootComments
    ];
    let updatedTotalCount = totalCount;
    // If there is already a comment with the same ID in the root array, replace it
    // Normally this shouldn't happen because new comments should always have unique IDs, but there
    // is a case were this can happen with replies (see below) - so let's be safe and handle it just
    // in case it ever happens with root comments as well.
    const existingRootIndex = updatedRootComments.findIndex((comment)=>newComment?.id && comment?.id === newComment?.id);
    if (existingRootIndex !== -1) updatedRootComments[existingRootIndex] = newComment;
    else {
        // Else add the newly added comment to the end of the root comments list
        updatedRootComments.push(newComment);
        // Increment total count. Note that we can only add individual comments without any replies, but
        // let's be safe and adjust for any replies in case this ever changes
        updatedTotalCount += repliesCount + 1;
    }
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies
        ];
        // If there is already a reply with the same ID in the parent's replies, replace it
        // Normally this shouldn't happen because new comments should always have unique IDs, but there
        // is a case were this can happen - when we're in edit mode and another user who is also in
        // edit mode also adds a reply to comment on the new text and then Updates the page -> we get
        // the new reply via the pubsub events and again when the new text is added by the Update.
        const existingReplyIndex = updatedReplies.findIndex((reply)=>newComment?.id && reply?.id === newComment?.id);
        if (existingReplyIndex !== -1) updatedReplies[existingReplyIndex] = newComment;
        else {
            // Else add the new  reply to the array
            updatedReplies.push(newComment);
            // Increment total count. We can only add individual comments without any replies, but let's be
            // safe and adjust for any replies in case this ever changes
            updatedTotalCount += 1 + repliesCount;
        }
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: parentOnCompleted, onError: parentOnError } = options;
    // Shared handling for query errors (initial load and refetch): mark certain errors as handled, then invoke callback.
    // WS-3494 / COMMENTS-188
    const applyQueryErrorHandling = (0, $cozmU.useCallback)((error, callback)=>{
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        callback?.(error);
    }, []);
    const handleQueryError = (0, $cozmU.useCallback)((error)=>applyQueryErrorHandling(error, parentOnError), [
        applyQueryErrorHandling,
        parentOnError
    ]);
    // Skip query if no content ID or explicitly skipped
    const shouldSkip = !contentId || !!options.skip;
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        context: {
            single: true
        },
        fetchPolicy: // We auto-batch queries that fire within 10ms of eachother. Since this query is slow, this unbatches it to avoid slowing down everything else
        fetchPolicy,
        onCompleted: (data)=>{
            parentOnCompleted?.(data);
        },
        onError: handleQueryError,
        __callerPackage__: "comments-data-manager"
    });
    const refetch = (0, $cozmU.useCallback)(async ({ onError: refetchOnError } = {})=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            applyQueryErrorHandling(error, refetchOnError ?? parentOnError);
        }
    }, [
        queryResponse,
        applyQueryErrorHandling,
        parentOnError
    ]);
    const addCommentInCache = (0, $cozmU.useCallback)(({ newComment: newComment, onError: onError, onCacheMiss: onCacheMiss })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            let dataProxy = null;
            try {
                dataProxy = (0, $l1uFv.readQueryInterop)({
                    query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                    variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                    __callerPackage__: "comments-data-manager"
                });
            } catch (e) {
                // Ignore cache misses for optimistic responses; otherwise report through `onCacheMiss`.
                if (newComment?.id !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) onCacheMiss?.(new Error(`Cache miss when adding comment with ID ${newComment?.id} to cache: ${e}`));
                return;
            }
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy.comments.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "comments-data-manager"
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $cozmU.useCallback)(({ commentId: commentId, onError: onError, onCacheMiss: onCacheMiss })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            let dataProxy = null;
            try {
                dataProxy = (0, $l1uFv.readQueryInterop)({
                    query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                    variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                    __callerPackage__: "comments-data-manager"
                });
            } catch (e) {
                onCacheMiss?.(new Error(`Cache miss when deleting comment with ID ${commentId} from cache: ${e}`));
                return false;
            }
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy.comments.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return false;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "comments-data-manager"
            });
            return true;
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
            return false;
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        data: queryResponse.data,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
const $bd3b81debc212a33$export$713a041e7ad7d7c4 = (contentId)=>{
    const dataProxy = (0, $l1uFv.readQueryInterop)({
        query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
        __callerPackage__: "comments-data-manager"
    });
    return dataProxy;
};
module.exports["MAX_COMMENTS_TO_RETURN"] = $bd3b81debc212a33$export$ef1591875b2a95ef;
module.exports["allContentStatuses"] = $bd3b81debc212a33$export$a1c5d5765ca44631;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;
module.exports["getCommentsDataFromCache"] = $bd3b81debc212a33$export$713a041e7ad7d7c4;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<88a71c42d0cb01ab5e7d98601a8ad2dc>>
 * @relayHash e661073d22fa388ab2cfa6921674c35d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "e661073d22fa388ab2cfa6921674c35d",
            "id": "a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "776a014f361baa317c627109df7aaaa3";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("l1uFv", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $jclGA = parcelRequire("jclGA");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    return (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : (0, $jclGA.cloneRelayQueryResult)(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("fEmGS", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $bqzdu = parcelRequire("bqzdu");


var $aSAi6 = parcelRequire("aSAi6");


var $9xOXQ = parcelRequire("9xOXQ");


var $7M67g = parcelRequire("7M67g");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Relay builds field storage keys from the operation's *resolved* variables, so a query declaring
    // `$first: Int = 20` normalizes under `field(...,first:20)` even when the caller omits `first`.
    // Resolving the artifact's declared defaults here keeps every Relay write below on the same
    // records Relay normalized and the UI subscribes to; using the raw variables would silently
    // write to a sibling record nobody reads. See getRelayOperationVariablesWithDefaults.
    const variables = (0, $7M67g.getRelayOperationVariablesWithDefaults)(params.query, params.variables);
    // Inside a Relay-native optimistic layer (commitMutation optimisticUpdater/updater), route the
    // write onto the provided store proxy so it participates in Relay's disposable layer instead of
    // committing permanently. This upserts records (incl. connection list changes) via the store
    // proxy — the capability the in-place path lacks — so no snapshot/replay rollback is needed;
    // Relay reverts the whole layer atomically.
    const ambientStore = (0, $bqzdu.getAmbientStoreProxy)();
    if (ambientStore && source === 'relay' && params.data) {
        const queryNode = params.query;
        const selections = queryNode?.operation?.selections;
        if (selections) {
            (0, $9xOXQ.writeQueryPayloadToStore)(ambientStore, // Normalization selections are a superset of the reader selections the primitive walks
            // (scalar/linked/inline-fragment/condition); matches the cast in writeQueryInteropRelay.
            selections, params.data, variables);
            return;
        }
    }
    if (source === 'relay') $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables);
    else $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data } = params;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for writeQueryInterop; ${params.__callerPackage__}.`);
    if (!data) return false;
    let didWrite = false;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) didWrite = (0, $aSAi6.writeQueryFields)(root, queryFields, data, variables);
    });
    if (!didWrite) {
        // If no existing Relay records were updated, fall back to Relay's normal payload
        // write path. Invalid Relay artifacts should still throw here, preserving the
        // original writeQueryInterop failure behavior.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), variables);
        relayEnv.commitPayload(operation, data);
        didWrite = true;
    }
    return didWrite;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
    return true;
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("aSAi6", function(module, exports) {

var $2ItkX = parcelRequire("2ItkX");

function $52093bfafa102098$export$77bf2d076cc42a0e(record, fields, data, variables) {
    if (!record || !$52093bfafa102098$var$isObjectRecord(data)) return false;
    // Relay commitUpdate is not transactional. Preflight the selection tree before
    // writing so list rewrites that require Relay normalization fall through to
    // commitPayload instead of committing partial in-place updates.
    if (!$52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables)) return false;
    return $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables);
}
function $52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables) {
    for (const field of fields){
        if (field.kind === 'Condition') {
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude && !$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'InlineFragment') {
            if (!$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) return false;
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords || fieldData.length !== existingRecords.length) return false;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    if (item == null) continue;
                    if (!$52093bfafa102098$var$isObjectRecord(item)) return false;
                    const existingRecord = existingRecords[index];
                    if (!existingRecord || $52093bfafa102098$var$hasDifferentRecordId(existingRecord, item)) return false;
                    if (!$52093bfafa102098$var$canWriteQueryFields(existingRecord, linkedField.selections, item, variables)) return false;
                }
                continue;
            }
            if (!$52093bfafa102098$var$isObjectRecord(fieldData)) return false;
            const linkedRecord = record.getLinkedRecord(fieldKey);
            if (!linkedRecord || $52093bfafa102098$var$hasDifferentRecordId(linkedRecord, fieldData)) return false;
            if (!$52093bfafa102098$var$canWriteQueryFields(linkedRecord, linkedField.selections, fieldData, variables)) return false;
            continue;
        }
        if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && !$52093bfafa102098$var$isRelaySetValue(scalarValue)) return false;
            continue;
        }
    }
    return true;
}
function $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables) {
    let didWrite = false;
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Honour @include/@skip so conditional fields (e.g. userPreferences) get written.
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        } else if (field.kind === 'InlineFragment') didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) continue;
                // Read plural fields with getLinkedRecords; the singular getter throws on
                // plural data. Missing/changed list records are handled by the commitPayload
                // fallback so this in-place path only updates known records.
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords) continue;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    const existingRecord = existingRecords[index];
                    if (existingRecord && $52093bfafa102098$var$isObjectRecord(item)) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(existingRecord, linkedField.selections, item, variables) || didWrite;
                }
            } else if ($52093bfafa102098$var$isObjectRecord(fieldData)) {
                const linkedRecord = record.getLinkedRecord(fieldKey);
                if (linkedRecord) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(linkedRecord, linkedField.selections, fieldData, variables) || didWrite;
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && $52093bfafa102098$var$isRelaySetValue(scalarValue)) {
                record.setValue(scalarValue, (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables));
                didWrite = true;
            }
        }
    }
    return didWrite;
}
function $52093bfafa102098$var$getRecordIdFromData(data) {
    const id = data.id;
    return typeof id === 'string' || typeof id === 'number' ? String(id) : null;
}
function $52093bfafa102098$var$hasDifferentRecordId(record, data) {
    const id = $52093bfafa102098$var$getRecordIdFromData(data);
    return Boolean(id && record.getDataID() !== id);
}
function $52093bfafa102098$var$isObjectRecord(value) {
    return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}
function $52093bfafa102098$var$isRelaySetValue(value) {
    if (Array.isArray(value)) // Relay scalar arrays can contain nulls, but undefined elements are not valid setValue payloads.
    return value.every((item)=>item !== undefined && $52093bfafa102098$var$isRelaySetValue(item));
    return value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
} /* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ 
module.exports["writeQueryFields"] = $52093bfafa102098$export$77bf2d076cc42a0e;

});

parcelRegister("kgNLQ", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $jbF1h = parcelRequire("jbF1h");

var $344a24116515d334$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $344a24116515d334$export$4883f94fcd5fa7aa = {
    ari: '',
    containerAri: '',
    reactionsCount: 0,
    reactionsSummaryForEmoji: [],
    __typename: 'ReactionsSummaryResponse'
};
const $344a24116515d334$export$99a332599a946905 = '998765432100';
const $344a24116515d334$export$c6a7031105fdebc = (commentData, commentId)=>{
    // Search in retreived comments and their replies
    for (const comment of commentData){
        // Check if this is the comment we're looking for
        if (comment?.id === commentId) return comment;
        // Check if it's in the replies
        if (comment?.replies) {
            const foundReply = comment.replies.find((reply)=>reply?.id === commentId);
            if (foundReply) return foundReply;
        }
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$6ba3a6375d12d24f = (commentData, replyParentId)=>{
    // Search through each root level comment's replies
    for (const comment of commentData){
        // Return this comment if it is the parent of the reply, else check if this comment has replies
        // and if any of them have the matching parentId
        if (comment?.id === replyParentId || comment?.replies.find((reply)=>reply?.id === replyParentId)) return comment;
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$3e4a472ec0de2dc6 = (commentData, markerRef)=>{
    // Search in retrieved comments and their replies
    for (const comment of commentData){
        // Check if this comment's marker ref matches
        const location = comment?.location;
        if (location?.inlineMarkerRef === markerRef) return comment;
    }
    return undefined;
};
const $344a24116515d334$export$499492f953d5abba = (comments, commentId, markerRef, contentStatus)=>{
    if (comments.length === 0) return undefined;
    let foundComment;
    if (commentId) foundComment = $344a24116515d334$export$c6a7031105fdebc(comments, commentId);
    else if (markerRef) foundComment = $344a24116515d334$export$3e4a472ec0de2dc6(comments, markerRef);
    if (!foundComment) return undefined;
    // Filter by contentStatus before returning
    const matchesContentStatusFilter = (comment)=>{
        if (!comment || !comment.contentStatus) return false;
        // Convert comment's contentStatus to uppercase to match GraphQLContentStatus format
        const commentStatus = comment.contentStatus.toUpperCase();
        return contentStatus.includes(commentStatus);
    };
    if (matchesContentStatusFilter(foundComment)) return foundComment;
    return undefined;
};
const $344a24116515d334$export$4d95f4b945556294 = (comment, mutationResult)=>{
    const resolveInlineComment = mutationResult?.data?.resolveInlineComment;
    const mutationStatus = resolveInlineComment?.status ?? false;
    const resolveProperties = resolveInlineComment?.resolveProperties ?? undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$d81a62b32f0e420f = (comment, mutationResult)=>{
    const commentResolutionStates = mutationResult?.data?.confluence_resolveComments?.commentResolutionStates;
    if ((commentResolutionStates?.length ?? 0) > 1) throw new Error('resolveCommentInCacheCallback() only supports one comment resolution state per mutation call');
    const firstResolutionState = commentResolutionStates?.[0] ?? undefined;
    const mutationStatus = firstResolutionState?.status ?? false;
    const partialResolveProperties = firstResolutionState?.resolveProperties ?? undefined;
    // We need to ensure that resolveProperties contains all non-optional properties so we can safely
    // spread it into the comment location resolve properties, so choose defaults for any missing
    // ones.  This is needed because some of the mutations don't request all the properties in their
    // responses.
    const resolveProperties = partialResolveProperties ? {
        resolved: true,
        isDangling: false,
        // These are nullable in the schema, but included to make Typescript happy
        resolvedUser: undefined,
        resolvedFriendlyDate: undefined,
        resolvedTime: undefined,
        // Add any non-null/undefined properties from the mutation result
        ...partialResolveProperties
    } : undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$aa65246494e3c3e0 = (comment, mutationResult)=>{
    // (The property is called "commentResolutionStates" but there is only one item per mutation call)
    const commentResolutionStates = mutationResult?.data?.confluence_reopenComment?.commentResolutionStates;
    if (commentResolutionStates) {
        const mutationStatus = commentResolutionStates.status ?? false;
        const partialResolveProperties = commentResolutionStates.resolveProperties ?? undefined;
        // We need to ensure that resolveProperties contains all non-optional properties so we can safely
        // spread it into the comment location resolve properties, so choose defaults for any missing
        // ones. This is needed because some of the mutations don't request all the properties - or even
        // the commentResolutionStates property at all in their responses.
        const resolveProperties = {
            resolved: false,
            isDangling: false,
            // These are nullable in the schema, but included to make Typescript happy
            resolvedUser: undefined,
            resolvedFriendlyDate: undefined,
            resolvedTime: undefined,
            // Add any non-null/undefined properties from the mutation result
            ...partialResolveProperties
        };
        return (0, $jbF1h.resolveCommentInCache)({
            comment: comment,
            mutationStatus: mutationStatus,
            resolveProperties: resolveProperties
        });
    }
    // Else commentResolutionStates wasn't returned - assume failure to reopen
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: false,
        resolveProperties: undefined
    });
};
const $344a24116515d334$export$e237bdee87974d46 = (pageMode)=>{
    // On view pages, exclude draft comments
    if (pageMode === (0, $cD1qu.PageMode).VIEW) return [
        'CURRENT',
        'ARCHIVED'
    ];
    // On edit and live pages, include all statuses
    return [
        'CURRENT',
        'ARCHIVED',
        'DRAFT'
    ];
};
const $344a24116515d334$export$70df9f207ee9869d = (comment)=>{
    const location = comment?.location;
    if (location) {
        if ('inlineResolveProperties' in location) return location.inlineResolveProperties?.resolved ?? false;
        else if ('commentResolveProperties' in location) return location.commentResolveProperties?.resolved ?? false;
    }
    return false;
};
const $344a24116515d334$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply && reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $344a24116515d334$export$2fa0b601110c277b = (comments, contentStatusFilters)=>{
    const allFilteredComments = [];
    const openComments = [];
    const openInlineComments = [];
    const openFooterComments = [];
    const resolvedComments = [];
    // Transform array-based data to map structure for legacy compatibility
    const commentsDataMap = {
        inline: {},
        general: {}
    };
    // Build flat map of all comments (including replies) for O(1) lookup by commentId
    const flatCommentsMap = {};
    // Build flat map of inline comments keyed by markerRef for O(1) lookup
    const flatMarkerRefMap = {};
    for (const comment of comments)// Filter by content status, which is a string literal type (that is, a set of allowed
    // strings), so be cautious if the definitions or schema change
    if (comment && contentStatusFilters.includes(comment.contentStatus?.toUpperCase())) {
        allFilteredComments.push(comment);
        // Add comment to flat map by commentId
        if (comment?.id) flatCommentsMap[comment.id] = comment;
        // Add inline parent comment to flatMarkerRefMap by markerRef (only parent comments, not replies)
        if (comment?.location?.type === 'INLINE' && !comment?.parentId) {
            const location = comment.location;
            if (location?.inlineMarkerRef) flatMarkerRefMap[location.inlineMarkerRef] = comment;
        }
        // Add all replies to flat map
        if (comment?.replies) {
            for (const reply of comment.replies)if (reply?.id) flatCommentsMap[reply.id] = reply;
        }
        const isOpen = !$344a24116515d334$export$70df9f207ee9869d(comment);
        const commentType = comment.location?.type === 'INLINE' ? "inline" : "general";
        const commentWithProperties = {
            ...comment,
            type: commentType,
            isOpen: isOpen,
            replies: comment.replies?.filter((reply)=>reply !== null && reply !== undefined).map((reply)=>({
                    ...reply
                }))
        };
        if (isOpen) {
            openComments.push(comment);
            if (comment?.location?.type === 'INLINE') openInlineComments.push(comment);
            else if (comment?.location?.type === 'FOOTER') openFooterComments.push(comment);
        // else unknown or missing location type, do nothing
        } else resolvedComments.push(comment);
        if (comment.location?.type === 'INLINE') {
            const threadKey = 'inlineMarkerRef' in comment.location ? comment.location.inlineMarkerRef || comment.id : comment.id;
            commentsDataMap.inline[threadKey] = commentWithProperties;
        } else if (comment.location?.type === 'FOOTER') commentsDataMap.general[comment.id] = commentWithProperties;
    }
    const hasNestedComments = $344a24116515d334$export$6036c2c532b2fa41(commentsDataMap);
    const commentCount = allFilteredComments.length;
    const hasAnyComments = commentCount > 0;
    return {
        allFilteredComments: allFilteredComments,
        openComments: openComments,
        openInlineComments: openInlineComments,
        openFooterComments: openFooterComments,
        resolvedComments: resolvedComments,
        commentsDataMap: commentsDataMap,
        flatCommentsMap: flatCommentsMap,
        flatMarkerRefMap: flatMarkerRefMap,
        hasNestedComments: hasNestedComments,
        commentCount: commentCount,
        hasAnyComments: hasAnyComments
    };
};
const $344a24116515d334$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        }
    };
};
module.exports["CommentType"] = $344a24116515d334$export$ffa1150e6a48f9cd;
module.exports["emptyReactionsSummary"] = $344a24116515d334$export$4883f94fcd5fa7aa;
module.exports["OPTIMISTIC_SAVE_COMMENT_ID"] = $344a24116515d334$export$99a332599a946905;
module.exports["findCommentInData"] = $344a24116515d334$export$c6a7031105fdebc;
module.exports["findRootCommentForReply"] = $344a24116515d334$export$6ba3a6375d12d24f;
module.exports["findAndFilterComment"] = $344a24116515d334$export$499492f953d5abba;
module.exports["resolveInlineCommentInCacheCallback"] = $344a24116515d334$export$4d95f4b945556294;
module.exports["resolveCommentInCacheCallback"] = $344a24116515d334$export$d81a62b32f0e420f;
module.exports["reopenCommentInCacheCallback"] = $344a24116515d334$export$aa65246494e3c3e0;
module.exports["buildDefaultCommentsContentStatusFilters"] = $344a24116515d334$export$e237bdee87974d46;
module.exports["isCommentResolved"] = $344a24116515d334$export$70df9f207ee9869d;
module.exports["categorizeComments"] = $344a24116515d334$export$2fa0b601110c277b;
module.exports["buildMutationContextForNoNetworkError"] = $344a24116515d334$export$5c24224d7e29c719;

});

parcelRegister("jbF1h", function(module, exports) {

var $82R8R = parcelRequire("82R8R");


var $6nYhN = parcelRequire("6nYhN");


var $cozmU = parcelRequire("cozmU");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");







// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/useCommentById.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this function - or at least the cache updating parts for the function
// - into the useAllCommentsData.ts file.
const $bd790562493588ff$var$updateCommentInCacheFragment = (0, $6nYhN.default);
// Fragment for reply comments (matches the replies schema from the main fragment)
const $bd790562493588ff$var$updateReplyInCacheFragment = (0, $82R8R.default);
// Type guard to check if a comment is a top-level comment (has replies field)
const $bd790562493588ff$var$isTopLevelComment = (comment)=>{
    return 'replies' in comment;
};
const $bd790562493588ff$export$8ce65958c48a9ac3 = ()=>{
    const readFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $6nYhN.default),
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const readReplyFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeReplyFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $82R8R.default),
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    /**
   * Function to update a comment in the Apollo cache.
   * @param mutationResult - The result of the mutation that triggered the cache update
   * @param commentId - ID of the comment to update
   * @param updateCallback - Callback function that receives the current comment data
   *                         and returns the updated comment data
   * @param onError - Optional error callback to handle errors during the update process
   * @param isReply - Whether this comment is a reply (true) or top-level comment (false)
   */ const updateCommentInCache = (0, $cozmU.useCallback)(({ mutationResult: mutationResult, commentId: commentId, updateCallback: updateCallback, onError: onError, isReply: isReply = false })=>{
        if (!commentId) {
            onError?.(new Error('Cannot update comment in cache: comment ID is missing'));
            return;
        }
        try {
            // The fragment ID format for Apollo cache
            const fragmentId = `Comment:${commentId}`;
            let cachedComment = null;
            if (isReply) cachedComment = readReplyFragment({
                id: fragmentId
            });
            else cachedComment = readFragment({
                id: fragmentId
            });
            if (!cachedComment) {
                // (There is a slight chance the comment is not in cache - but the mutation that calls
                // this function would have to completed successfully to call us, so presumably the
                // comment existed then. Thus the only legit reason for it to be missing from the cache
                // now is if another user deleted the comment in between the mutation and this cache
                // update call. That is unlikely, so let's log this as an error and return. If in
                // the future we find the legit use case is happening more often, we can change to a
                // warning instead.)
                onError?.(new Error(`Cannot update comment in cache: comment with ID ${commentId} not found in cache`));
                return;
            }
            // Apply the update callback on a copy of the cached comment
            // (Note that the updateCallback should return a new object, not mutate the original - so
            //  make copies of any nested objects you need to change also)
            const updatedComment = updateCallback({
                ...cachedComment
            }, mutationResult);
            // Write the updated comment back to cache using appropriate fragment
            if (isReply) writeReplyFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
            else writeFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when updating cached comment data: ${err}`));
            return;
        }
    }, [
        readFragment,
        writeFragment,
        readReplyFragment,
        writeReplyFragment
    ]);
    return {
        updateCommentInCache: updateCommentInCache
    };
};
const $bd790562493588ff$export$9e04af313e7174f4 = ({ comment: comment, mutationStatus: mutationStatus, resolveProperties: resolveProperties })=>{
    if (!mutationStatus || !resolveProperties) // Mutation result is missing or incomplete - so just return the comment unchanged
    return comment;
    // Extract isDangling separately since it is handled differently, and exclude __typename since we
    // don't need it and Typescript would complain about it being included in the spread below.
    const { __typename: __typename, isDangling: isDangling, ...otherResolveProperties } = resolveProperties;
    // Defaults for the nullable resolve fields. A partial mutation response (e.g. a reopen that only
    // returns `resolved: false`) leaves these `undefined` in the write data. The interop fragment
    // writer skips `undefined` scalars (setRelayScalarValue), so those fields would be absent in the
    // store and Relay warns "Missing field resolvedFriendlyDate/..." on the next read. Seeding them
    // as explicit `null` (their unresolved value) keeps the resolve-properties record complete; any
    // real value from the mutation response still overrides via the spread below.
    const resolvePropertyDefaults = {
        resolvedUser: null,
        resolvedFriendlyDate: null,
        resolvedTime: null
    };
    // Mark the comment as resolved in the cache, but how to do that depends on the comment type
    const location = comment.location;
    const newLocation = {
        ...location,
        ...'commentResolveProperties' in location ? {
            commentResolveProperties: {
                ...location.commentResolveProperties,
                ...resolvePropertyDefaults,
                ...otherResolveProperties
            }
        } : {},
        ...'inlineResolveProperties' in location ? {
            inlineResolveProperties: {
                ...location.inlineResolveProperties,
                ...resolvePropertyDefaults,
                ...otherResolveProperties,
                isDangling: isDangling
            }
        } : {}
    };
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    return {
        ...comment,
        location: newLocation
    };
};
const $bd790562493588ff$export$df3d27666bd765d5 = (comment, mutationResult)=>{
    const newBodyValue = mutationResult?.data?.updateComment?.body?.value;
    const updatedBody = {
        ...comment.body,
        // Remember that an empty string is a valid body value, so only skip updating if newBodyValue
        // is null or undefined
        ...newBodyValue || newBodyValue === '' ? {
            value: newBodyValue
        } : {}
    };
    const newVersion = mutationResult?.data?.updateComment?.version;
    const newDisplayName = newVersion?.by?.displayName;
    // If the existing comment's version doesn't have a "by" field, we don't want to add just part
    // of it - so set it to undefined so it won't be included in the updated comment. This probably
    // won't actually ever happen, but it makes Typescript happy just in case.
    const updatedBy = comment.version?.by ? {
        ...comment.version?.by,
        ...newDisplayName ? {
            displayName: newDisplayName
        } : {}
    } : undefined;
    const updatedVersion = {
        ...comment.version,
        ...newVersion?.number ? {
            number: newVersion.number
        } : {},
        ...newVersion?.when ? {
            when: newVersion.when
        } : {},
        ...updatedBy ? {
            by: {
                ...updatedBy
            }
        } : {}
    };
    const baseUpdatedComment = {
        ...comment,
        body: updatedBody,
        version: {
            ...updatedVersion
        }
    };
    // Return with appropriate type casting based on comment type
    return $bd790562493588ff$var$isTopLevelComment(comment) ? baseUpdatedComment : baseUpdatedComment;
};
module.exports["useUpdateCommentInCache"] = $bd790562493588ff$export$8ce65958c48a9ac3;
module.exports["resolveCommentInCache"] = $bd790562493588ff$export$9e04af313e7174f4;
module.exports["updateCommentBodyInCacheCallback"] = $bd790562493588ff$export$df3d27666bd765d5;

});

parcelRegister("82R8R", function(module, exports) {
/**
 * @generated SignedSource<<b6af2e5e8b1c672924f300605e9d9ac3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ee66e0478f0211a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v4 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheReplyFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            }
                        ],
                        "type": "KnownUser"
                    },
                    {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "profilePicture",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "path"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "representation",
                        "value": "ATLAS_DOC_FORMAT"
                    }
                ],
                "concreteType": "DocumentBody",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": v2 /*: any*/ ,
                "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "createdAt",
                "plural": false,
                "selections": v2 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "createdAtNonLocalized"
            },
            {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "commentResolveProperties",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "FooterComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "inlineMarkerRef"
                            },
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "inlineResolveProperties",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDangling"
                                    },
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "inlineText"
                            }
                        ],
                        "type": "InlineComment"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "parentId"
            },
            {
                "concreteType": "CommentPermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRemovable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isResolvable"
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$6ee66e0478f0211a$var$node.hash = "d793bb57d64855b11bf515ef7082e802";
var $6ee66e0478f0211a$export$2e2bcd8739ae039 = $6ee66e0478f0211a$var$node;
module.exports["default"] = $6ee66e0478f0211a$export$2e2bcd8739ae039;

});

parcelRegister("6nYhN", function(module, exports) {
/**
 * @generated SignedSource<<776c1b585ba7040195aa55b4ce020277>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d633d5b65e9f4e8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v10 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v11 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v12 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v4 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "number"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ 
                ]
            },
            v8 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v6 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    },
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ]
                            },
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v2 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v21 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "Comment"
    };
}();
$1d633d5b65e9f4e8$var$node.hash = "3eaa0227f14e77a83748a865f02fa321";
var $1d633d5b65e9f4e8$export$2e2bcd8739ae039 = $1d633d5b65e9f4e8$var$node;
module.exports["default"] = $1d633d5b65e9f4e8$export$2e2bcd8739ae039;

});

parcelRegister("ij4CE", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7EPz1 = parcelRequire("7EPz1");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");


var $bqzdu = parcelRequire("bqzdu");


var $kWvcF = parcelRequire("kWvcF");


var $cjdbm = parcelRequire("cjdbm");


var $81Pid = parcelRequire("81Pid");


var $86okN = parcelRequire("86okN");

// While a Relay-native optimistic layer is active (inside commitMutation's optimisticUpdater/updater),
// route the fragment write onto that layer's store proxy instead of committing permanently, so it
// participates in the disposable layer Relay reverts atomically. writeFragmentShim only uses
// `environment.commitUpdate`, so a thin env shim runs its in-place write against the provided proxy.
// Outside an updater this returns false and the normal permanent write path is used.
function $7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragment, fragmentId, data, variables) {
    const ambientStore = (0, $bqzdu.getAmbientStoreProxy)();
    if (!ambientStore || !fragment) return false;
    const ambientEnv = {
        commitUpdate: (updater)=>updater(ambientStore)
    };
    (0, $kWvcF.writeFragmentShim)(ambientEnv, fragment, fragmentId, data, variables);
    return true;
}
const $7fd39030140cad16$export$6e64625354109aa5 = (data, fragmentArtifact)=>(0, $kWvcF.addTypenameToData)(data, fragmentArtifact);
const $7fd39030140cad16$var$useWriteFragmentInteropRelay = (0, $3u0dr.isReactCompilerActiveV2)() ? function useWriteFragmentInteropRelay(args) {
    const $ = (0, $bDgLe.c)(4);
    const { fragmentSpec: fragmentSpec, __callerPackage__: __callerPackage__ } = args;
    const env = (0, $6SsN4.useRelayEnvironment)();
    let t0;
    if ($[0] !== __callerPackage__ || $[1] !== env || $[2] !== fragmentSpec) {
        t0 = (t1)=>{
            const { data: data, fragmentId: fragmentId, variables: variables } = t1;
            if ((0, $9wGTI.fg)("confluence_relay_migration_diagnostics_enabled")) {
                const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
                (0, $cjdbm.logRelayMigrationDiagnostic)("Fragment access", {
                    phase: "fragment",
                    action: "write",
                    api: "useWriteFragmentInterop",
                    callerPackage: __callerPackage__,
                    fragmentName: fragmentName,
                    fragmentType: fragmentType,
                    fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                    relayEnabled: true
                });
            }
            if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragmentSpec, fragmentId, data, variables)) return;
            (0, $kWvcF.writeFragmentShim)(env, fragmentSpec, fragmentId, data, variables);
        };
        $[0] = __callerPackage__;
        $[1] = env;
        $[2] = fragmentSpec;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : function useWriteFragmentInteropRelay(args) {
    const { fragmentSpec: fragmentSpec, __callerPackage__: __callerPackage__ } = args;
    const env = (0, $6SsN4.useRelayEnvironment)();
    return (0, $cozmU.useCallback)(({ data: data, fragmentId: fragmentId, variables: variables })=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
            const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
            (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
                phase: 'fragment',
                action: 'write',
                api: 'useWriteFragmentInterop',
                callerPackage: __callerPackage__,
                fragmentName: fragmentName,
                fragmentType: fragmentType,
                fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                relayEnabled: true
            });
        }
        if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragmentSpec, fragmentId, data, variables)) return;
        (0, $kWvcF.writeFragmentShim)(env, fragmentSpec, fragmentId, data, variables);
    }, [
        env,
        fragmentSpec,
        __callerPackage__
    ]);
};
const $7fd39030140cad16$var$useWriteFragmentInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useWriteFragmentInteropApollo(args) {
    const $ = (0, $bDgLe.c)(5);
    const { fragmentSpec: fragmentSpec, fragmentArtifact: fragmentArtifact, __callerPackage__: __callerPackage__ } = args;
    const apolloClient = (0, $7EPz1.useApolloClient)();
    let t0;
    if ($[0] !== __callerPackage__ || $[1] !== apolloClient || $[2] !== fragmentArtifact || $[3] !== fragmentSpec) {
        t0 = (t1)=>{
            const { data: data, fragmentId: fragmentId, variables: variables, useAggClient: useAggClient } = t1;
            if ((0, $9wGTI.fg)("confluence_relay_migration_diagnostics_enabled")) {
                const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
                (0, $cjdbm.logRelayMigrationDiagnostic)("Fragment access", {
                    phase: "fragment",
                    action: "write",
                    api: "useWriteFragmentInterop",
                    callerPackage: __callerPackage__,
                    fragmentName: fragmentName,
                    fragmentType: fragmentType,
                    fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                    relayEnabled: false
                });
            }
            const dataToWrite = $7fd39030140cad16$export$6e64625354109aa5(data, fragmentArtifact);
            const client = useAggClient && typeof window !== "undefined" ? window.GLOBAL_APOLLO_AGG_CLIENT : apolloClient;
            if (client) client.writeFragment({
                id: fragmentId,
                fragment: (0, $86okN.toDocumentNode)(fragmentSpec),
                data: dataToWrite,
                variables: variables
            });
        };
        $[0] = __callerPackage__;
        $[1] = apolloClient;
        $[2] = fragmentArtifact;
        $[3] = fragmentSpec;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : function useWriteFragmentInteropApollo(args) {
    const { fragmentSpec: fragmentSpec, fragmentArtifact: fragmentArtifact, __callerPackage__: __callerPackage__ } = args;
    const apolloClient = (0, $7EPz1.useApolloClient)();
    return (0, $cozmU.useCallback)(({ data: data, fragmentId: fragmentId, variables: variables, useAggClient: useAggClient })=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
            const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
            (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
                phase: 'fragment',
                action: 'write',
                api: 'useWriteFragmentInterop',
                callerPackage: __callerPackage__,
                fragmentName: fragmentName,
                fragmentType: fragmentType,
                fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                relayEnabled: false
            });
        }
        // Add __typename to data using the fragment artifact's type information
        const dataToWrite = $7fd39030140cad16$export$6e64625354109aa5(data, fragmentArtifact);
        // Guard window for server usage while preserving Apollo as the original write target.
        const client = useAggClient && typeof window !== 'undefined' ? window.GLOBAL_APOLLO_AGG_CLIENT : apolloClient;
        if (client) client.writeFragment({
            id: fragmentId,
            fragment: (0, $86okN.toDocumentNode)(fragmentSpec),
            data: dataToWrite,
            variables: variables
        });
    }, [
        apolloClient,
        fragmentSpec,
        fragmentArtifact,
        __callerPackage__
    ]);
};
function $7fd39030140cad16$export$b3a20d310cac24ba(args) {
    return (0, $iffSy.isRelayEnabled)(args.__callerPackage__, {
        phase: 'fragment'
    }) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fd39030140cad16$var$useWriteFragmentInteropRelay(args) : // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fd39030140cad16$var$useWriteFragmentInteropApollo(args);
}
function $7fd39030140cad16$export$a2dd3f95e566e3ed(options) {
    const { fragmentId: fragmentId, data: data, fragment: fragment, variables: variables, useAggClient: useAggClient, __callerPackage__: __callerPackage__ } = options;
    if (!data) return;
    const source = (0, $iffSy.isRelayEnabled)(__callerPackage__, {
        phase: 'fragment'
    }) ? 'relay' : 'apollo';
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
        const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragment);
        (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
            phase: 'fragment',
            action: 'write',
            api: 'writeFragmentInterop',
            callerPackage: __callerPackage__,
            fragmentName: fragmentName,
            fragmentType: fragmentType,
            fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
            relayEnabled: source === 'relay'
        });
    }
    if (source === 'relay') {
        const env = window['GLOBAL_RELAY_ENV'];
        if (fragment) {
            if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragment, fragmentId, data, variables)) return;
            (0, $kWvcF.writeFragmentShim)(env, fragment, fragmentId, data, variables);
        }
        return;
    }
    const client = useAggClient && typeof window !== 'undefined' ? window['GLOBAL_APOLLO_AGG_CLIENT'] : window['GLOBAL_APOLLO_CLIENT'];
    if (client && fragment) {
        const dataToWrite = (0, $kWvcF.addTypenameToData)(data, fragment);
        client.writeFragment({
            id: fragmentId,
            fragment: (0, $86okN.toDocumentNode)(fragment),
            data: dataToWrite,
            variables: variables
        });
    }
}
module.exports["useWriteFragmentInterop"] = $7fd39030140cad16$export$b3a20d310cac24ba;
module.exports["writeFragmentInterop"] = $7fd39030140cad16$export$a2dd3f95e566e3ed;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $7rovI = parcelRequire("7rovI");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const { isAvailable: isAccessLinkEdit, isEditMode: isAccessLinkEditing } = (0, $7rovI.useAccessLinkEditMode)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage || isAccessLinkEdit && isAccessLinkEditing) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("7rovI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $deabcafb397cc045$var$initialState = {
    isAvailable: false,
    isEditMode: false
};
const $deabcafb397cc045$var$setAvailable = (isAvailable)=>({ setState: setState })=>{
        // Leaving the route must also clear edit mode, or a later visit inherits it.
        setState(isAvailable ? {
            isAvailable: isAvailable
        } : {
            isAvailable: false,
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$enterEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: true
        });
    };
const $deabcafb397cc045$var$exitEditMode = ()=>({ setState: setState })=>{
        setState({
            isEditMode: false
        });
    };
const $deabcafb397cc045$var$actions = {
    setAvailable: $deabcafb397cc045$var$setAvailable,
    enterEditMode: $deabcafb397cc045$var$enterEditMode,
    exitEditMode: $deabcafb397cc045$var$exitEditMode
};
const $deabcafb397cc045$var$AccessLinkEditModeStore = (0, $8s9DV.createStore)({
    initialState: $deabcafb397cc045$var$initialState,
    actions: $deabcafb397cc045$var$actions,
    name: 'AccessLinkEditModeStore'
});
const $deabcafb397cc045$var$useAccessLinkEditModeStore = (0, $kBr4q.createHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$var$isOnAccessLinkRouteArgs = {
    selector: (routeName)=>{
        return (0, $1NBp8.ACCESS_LINK).name === routeName;
    }
};
/** Actions without a state subscription, so callers that only dispatch do not re-render. */ const $deabcafb397cc045$var$useAccessLinkEditModeStoreActions = (0, $kBr4q.createActionsHook)($deabcafb397cc045$var$AccessLinkEditModeStore);
const $deabcafb397cc045$export$87e25a0d26a92fdb = ()=>{
    const isAvailable = (0, $dPJCf.useRouteName)($deabcafb397cc045$var$isOnAccessLinkRouteArgs);
    const [{ isEditMode: isEditMode }, { enterEditMode: enter, exitEditMode: exit }] = $deabcafb397cc045$var$useAccessLinkEditModeStore();
    return {
        isAvailable: isAvailable,
        isEditMode: isEditMode,
        enterEditMode: enter,
        exitEditMode: exit
    };
};
const $deabcafb397cc045$export$b9623d5da41a49e7 = ({ children: children })=>{
    const { exitEditMode: exitEditMode } = $deabcafb397cc045$var$useAccessLinkEditModeStoreActions();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            exitEditMode();
        };
    }, [
        exitEditMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["useAccessLinkEditMode"] = $deabcafb397cc045$export$87e25a0d26a92fdb;
module.exports["AccessLinkEditModeProvider"] = $deabcafb397cc045$export$b9623d5da41a49e7;

});

parcelRegister("8i27m", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $3u5lg = parcelRequire("3u5lg");

var $33a0cfbfba499043$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
var $33a0cfbfba499043$export$74159dff405238c0 = /*#__PURE__*/ function(CommentActionType) {
    CommentActionType["DELETE_COMMENT"] = "deleted";
    // If you ever update this, please also update commentsNavigationUtils, which relies on the string to avoid circular deps
    CommentActionType["RESOLVE_COMMENT_THREAD"] = "resolved";
    return CommentActionType;
}({});
const $33a0cfbfba499043$export$53ac33307b5acee9 = ()=>({
        orderedActiveAnnotationIdList: [],
        commentThreadsRemovedByOtherUsers: {}
    });
const $33a0cfbfba499043$export$e324594224ef24da = {
    setOrderedActiveAnnotationIdList: (newCommentsList)=>({ getState: getState, setState: setState })=>{
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            if (!newCommentsList || newCommentsList.length === 0) {
                // Only update state if the current list is not already empty
                if (orderedActiveAnnotationIdList.length > 0) setState({
                    orderedActiveAnnotationIdList: []
                });
                return;
            }
            // Create a map of existing annotationId to their isLoaded states for quick lookup
            const existingAnnotationsMap = new Map(orderedActiveAnnotationIdList.map(({ threadKey: threadKey, isLoaded: isLoaded })=>[
                    threadKey,
                    isLoaded
                ]));
            // Use a Set to ensure unique annotation IDs
            const uniqueCommentsSet = new Set(newCommentsList);
            // Map the unique comments set to the new state, preserving isLoaded where possible
            const updatedAnnotationList = Array.from(uniqueCommentsSet).map((threadKey)=>({
                    threadKey: threadKey,
                    isLoaded: existingAnnotationsMap.get(threadKey) ?? false // Preserve existing isLoaded or default to false
                }));
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(orderedActiveAnnotationIdList, updatedAnnotationList)) setState({
                orderedActiveAnnotationIdList: updatedAnnotationList
            });
        },
    getCurrentCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    // keep track of removed annotations
    updateRemovedCommentIdsMap: ({ commentId: commentId, commentActionType: commentActionType })=>({ setState: setState, getState: getState })=>{
            const { commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            // Update commentThreadsRemovedByOtherUsers map
            const updatedRemovedComments = {
                ...commentThreadsRemovedByOtherUsers
            };
            updatedRemovedComments[commentId] = commentActionType;
            // Update the removed-by-other-users map.
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    reopenParentComment: ({ parentCommentId: parentCommentId })=>({ setState: setState, getState: getState })=>{
            // Records a reopened parent comment in the commentThreadsRemovedByOtherUsers map.
            if (!parentCommentId) return;
            const { commentThreadsRemovedByOtherUsers: currentRemovedComments } = getState();
            const updatedRemovedComments = {
                ...currentRemovedComments
            };
            delete updatedRemovedComments[parentCommentId];
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    clearRemovedComments: ()=>({ setState: setState })=>{
            setState({
                commentThreadsRemovedByOtherUsers: {}
            });
        },
    clearCommentsData: ()=>({ setState: setState })=>{
            setState($33a0cfbfba499043$export$53ac33307b5acee9());
        }
};
const $33a0cfbfba499043$export$13b7c646235a7fd4 = (0, $8s9DV.createStore)({
    initialState: $33a0cfbfba499043$export$53ac33307b5acee9(),
    actions: $33a0cfbfba499043$export$e324594224ef24da,
    name: 'CommentsDataStore'
});
const $33a0cfbfba499043$export$80f09eb388fa70f9 = (0, $kBr4q.createHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$b5e3986841a4e13f = (0, $kBr4q.createActionsHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$c14a8182bd597724 = (0, $kBr4q.createStateHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
module.exports["CommentType"] = $33a0cfbfba499043$export$ffa1150e6a48f9cd;
module.exports["CommentActionType"] = $33a0cfbfba499043$export$74159dff405238c0;
module.exports["useCommentsData"] = $33a0cfbfba499043$export$80f09eb388fa70f9;
module.exports["useCommentsDataActions"] = $33a0cfbfba499043$export$b5e3986841a4e13f;
module.exports["useCommentsDataState"] = $33a0cfbfba499043$export$c14a8182bd597724;

});

parcelRegister("5fMeR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $4pGaH = parcelRequire("4pGaH");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("djF2b"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("azsb0"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("60ddt"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("9HCgl"))).CommentsPanelWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderActions = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4wZwH",
    name: "CommentsPanelHeaderActions",
    loader: async ()=>(await (parcelRequire("f9Qyy"))).CommentsPanelHeaderActions
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelHeaderActions.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = (preloadedCanAddComments)=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true, preloadedCanAddComments);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $cozmU.useRef)(hasContentChanged);
    (0, $cozmU.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelClose = (0, $cozmU.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const canClosePanel = (0, $cozmU.useCallback)(async ()=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView, initialSort: initialSort } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        // Drag-to-resize on page surfaces only (same exclusions as the panel
        // itself). `expValEquals` is the LAST clause per
        // `confluence-feature-gating/no-preconditioning` so exposure is only
        // recorded for users who actually meet the surface preconditions.
        const isResizableSurface = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView && (0, $6mKj3.expValEquals)('confluence_fe_comments_panel_resize', 'isEnabled', true);
        const showFooter = canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelHeaderActions
            },
            BodyComponent: ()=>(0, $cozmU.createElement)((0, $4pGaH.CommentsPanelPermissionContext).Provider, {
                    value: preloadedCanAddComments
                }, (0, $cozmU.createElement)($3b7f940e5fdc8097$var$CommentsPanelWrapper, {
                    openWithView: openWithView,
                    initialSort: initialSort
                })),
            FooterComponent: showFooter ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            },
            isResizable: isResizableSurface
        }, 'push');
    };
    const showCommentsPanel = (0, $cozmU.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        preloadedCanAddComments,
        showObjectSidebar
    ]);
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $4PNpW.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig;
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo');
    const showShare = allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("36Uax", function(module, exports) {

var $kTPbu = parcelRequire("kTPbu");


var $bVevd = parcelRequire("bVevd");

var $dcf2160d889b63fd$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $dcf2160d889b63fd$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$var$pageAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$blogPostAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$whiteboardAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard
};
const $dcf2160d889b63fd$var$contentTypeAllowedFeatures = {
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $dcf2160d889b63fd$var$pageAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $dcf2160d889b63fd$var$blogPostAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $dcf2160d889b63fd$var$whiteboardAllowedFeatures
};
const $dcf2160d889b63fd$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$dcf2160d889b63fd$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $dcf2160d889b63fd$export$3207c60940c4a9b0;

});

parcelRegister("kTPbu", function(module, exports) {
var $eaa06f5f4964dde1$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $eaa06f5f4964dde1$export$942a5fac9b8c9dc2;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("4PNpW", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

const $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40 = (0, $36Uax.ALLOWED_FEATURES).view;
const $ff056bb0ad02bd7c$export$2c7469b01e61fde2 = (0, $36Uax.ALLOWED_FEATURES).edit;
const $ff056bb0ad02bd7c$export$72afc086e90eb0bf = (0, $36Uax.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $ff056bb0ad02bd7c$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1eD4P = parcelRequire("1eD4P");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $cozmU.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $cozmU.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("cxu5H", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $4PNpW.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    showSidebarControlIfNoPanel: ()=>({ setState: setState, getState: getState })=>{
            // Read the store at dispatch time rather than relying on a React render snapshot.
            // A deeplink can open the panel between render and a passive effect being flushed.
            if (!getState().isObjectSidebarShown) setState({
                sidebarControlState: 'shown'
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    PanelName["SuggestionsPanel"] = "suggestionsPanel";
    PanelName["AutomationsPanel"] = "automationsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    "suggestionsPanel",
    "automationsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("gfqXk", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d97010bba34874b5$var$editorEmitter = undefined;
const $d97010bba34874b5$export$60921b94e11f8e19 = ()=>{
    if (!$d97010bba34874b5$var$editorEmitter) $d97010bba34874b5$var$editorEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d97010bba34874b5$var$editorEmitter;
};
module.exports["getEditorAnnotationEventEmitter"] = $d97010bba34874b5$export$60921b94e11f8e19;

});

parcelRegister("htsj6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");

const $feac3235d890b171$export$50af12b79850199d = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, {
        ...options,
        __callerPackage__: "page-utils"
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, {
        ...options,
        __callerPackage__: "page-utils"
    });
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<46aaf98c7fe5f9fcbf890b27644f6f9d>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("3mVfX", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        isCurrentlySelectedThreadOptimisticallyAdded: false,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false,
            ["MENTIONS_ME"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        replyToContributorUsers: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null,
        triggerOnDemandSummary: false,
        isSummaryDismissedByUser: false,
        automaticSummariesPreference: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType, isOptimisticAddSuccess)=>({ getState: getState, setState: setState })=>{
            const { currentlySelectedThreadKey: currentlySelectedThreadKey } = getState();
            if (!!isOptimisticAddSuccess && commentType === (0, $8i27m.CommentType).GENERAL && currentlySelectedThreadKey !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) // This means that user has selected a different comment thread
            // after new comment was optimistically added on UI but before
            // the GQL mutation succeeded. In this case, we shouldn't set
            // currentlySelectedThreadKey to the new comment.
            return;
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType,
                // Note: Added for COMMENTS-6792: Optimistically adding a footer comment.
                // When adding a footer comment optimistically, setCurrentlySelectedThreadKey is
                // called twice: once when the comment is added to UI optimistically with a fake id,
                // and once more when the mutation succeeds and UI is updated with the actual id.
                // The effect of the second call is rendered on UI before the updated comment list
                // is rendered, which causes a visible flicker, where the new comment goes from
                // "selected" -> "unselected" (for an instant) -> "selected" again.
                // To fix this flicker, we keep showing the comment with fake id as "selected" when
                // this flag is true, even if value of `currentlySelectedThreadKey` has changed.
                isCurrentlySelectedThreadOptimisticallyAdded: commentType === (0, $8i27m.CommentType).GENERAL && !!isOptimisticAddSuccess
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user, contributorUsers: contributorUsers } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user,
                replyToContributorUsers: contributorUsers
            });
        },
    setReplyToContributorUsers: (users)=>({ setState: setState })=>{
            setState({
                replyToContributorUsers: users
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        },
    setTriggerOnDemandSummary: (triggerOnDemandSummary)=>({ setState: setState })=>{
            setState({
                triggerOnDemandSummary: triggerOnDemandSummary
            });
        },
    setIsSummaryDismissedByUser: (isSummaryDismissedByUser)=>({ setState: setState })=>{
            setState({
                isSummaryDismissedByUser: isSummaryDismissedByUser
            });
        },
    setAutomaticSummariesPreference: (automaticSummariesPreference)=>({ setState: setState })=>{
            setState({
                automaticSummariesPreference: automaticSummariesPreference
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $8s9DV.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $kBr4q.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $kBr4q.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $kBr4q.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $6ozxE = parcelRequire("6ozxE");



var $jtuBN = parcelRequire("jtuBN");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, // Retained for callers that pass preloaded permissions as the third argument.
_cacheOnly = false, preloadedCanAddComments)=>{
    const baseOptions = {
        skip: !contentId || preloadedCanAddComments !== undefined
    };
    const status = [
        'draft',
        'current'
    ];
    const { data: data, loading: loading, error: error, networkStatus: networkStatus } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        variables: {
            contentId: contentId,
            status: status
        },
        skipFetchIfCached: false,
        __callerPackage__: "comments-hooks"
    });
    const createPermission = (0, $6ozxE.canAddCommentsFromOperations)(data?.content?.nodes?.[0]?.operations);
    return {
        canAddComments: preloadedCanAddComments ?? createPermission,
        loading: preloadedCanAddComments === undefined ? loading : false,
        contentQueryError: preloadedCanAddComments === undefined ? error : undefined,
        refetch: $be6154107952d370$var$noOpRefetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<5821fd331c47db168316a2c3a4e69985>>
 * @relayHash f2ed22cac79248fed29ace7669709d01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 624f6c98a1c2b9a83cb2c19aecdae78adfcdabf9f4d3d08dad00de2c6cff9369
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f2ed22cac79248fed29ace7669709d01",
            "id": "624f6c98a1c2b9a83cb2c19aecdae78adfcdabf9f4d3d08dad00de2c6cff9369",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "60c40f4780bf1c488b0028e9d219e3d4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("6ozxE", function(module, exports) {

var $lfBMY = parcelRequire("lfBMY");

const $b3568511a7ce4c14$export$f67dec4694484421 = (operations)=>operations?.some((operation)=>operation?.operation === (0, $lfBMY.OperationTypes).CREATE && operation?.targetType === 'comment') ?? false;
module.exports["canAddCommentsFromOperations"] = $b3568511a7ce4c14$export$f67dec4694484421;

});

parcelRegister("lfBMY", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("4pGaH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0873c4e49e24a2d5$export$1011b0dca615a7c4 = (0, $cozmU.createContext)(undefined);
module.exports["CommentsPanelPermissionContext"] = $0873c4e49e24a2d5$export$1011b0dca615a7c4;

});

parcelRegister("djF2b", function(module, exports) {

let $9b1ce13fe2ad917c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9b1ce13fe2ad917c$var$load("hnpcA"),
    $9b1ce13fe2ad917c$var$load("6wr18"),
    $9b1ce13fe2ad917c$var$load("lKZDc"),
    $9b1ce13fe2ad917c$var$load("w3Gc8"),
    $9b1ce13fe2ad917c$var$load("ffEVr"),
    $9b1ce13fe2ad917c$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("azsb0", function(module, exports) {

let $7b2307858caabff1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7b2307858caabff1$var$load("jNr09"),
    $7b2307858caabff1$var$load("9xmQ5"),
    $7b2307858caabff1$var$load("iYvvi"),
    $7b2307858caabff1$var$load("eWXZF"),
    $7b2307858caabff1$var$load("kMVpD"),
    $7b2307858caabff1$var$load("6wr18"),
    $7b2307858caabff1$var$load("aIw3f"),
    $7b2307858caabff1$var$load("8LtYa"),
    $7b2307858caabff1$var$load("iOSMk"),
    $7b2307858caabff1$var$load("lKZDc"),
    $7b2307858caabff1$var$load("gAKfH"),
    $7b2307858caabff1$var$load("7oAXW"),
    $7b2307858caabff1$var$load("ffEVr"),
    $7b2307858caabff1$var$load("hhss7"),
    $7b2307858caabff1$var$load("cGkFm"),
    $7b2307858caabff1$var$load("2jERw"),
    $7b2307858caabff1$var$load("b7144"),
    $7b2307858caabff1$var$load("9LDVS"),
    $7b2307858caabff1$var$load("kiMHu"),
    $7b2307858caabff1$var$load("45r7q"),
    $7b2307858caabff1$var$load("aAWLw"),
    $7b2307858caabff1$var$load("7EorR"),
    $7b2307858caabff1$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("60ddt", function(module, exports) {

let $45ecfea625e292e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45ecfea625e292e8$var$load("6wr18"),
    $45ecfea625e292e8$var$load("ffEVr"),
    $45ecfea625e292e8$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("9HCgl", function(module, exports) {

let $7105cf5c03cffdff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7105cf5c03cffdff$var$load("jPAfq"),
    $7105cf5c03cffdff$var$load("jNr09"),
    $7105cf5c03cffdff$var$load("9xmQ5"),
    $7105cf5c03cffdff$var$load("g5INx"),
    $7105cf5c03cffdff$var$load("gLTKz"),
    $7105cf5c03cffdff$var$load("b19pM"),
    $7105cf5c03cffdff$var$load("7qCqs"),
    $7105cf5c03cffdff$var$load("lGCYm"),
    $7105cf5c03cffdff$var$load("iOSMk"),
    $7105cf5c03cffdff$var$load("lKZDc"),
    $7105cf5c03cffdff$var$load("5Y98G"),
    $7105cf5c03cffdff$var$load("bqdgP"),
    $7105cf5c03cffdff$var$load("4aKct"),
    $7105cf5c03cffdff$var$load("ennNB"),
    $7105cf5c03cffdff$var$load("9Hr92"),
    $7105cf5c03cffdff$var$load("eUsnQ"),
    $7105cf5c03cffdff$var$load("khIi2"),
    $7105cf5c03cffdff$var$load("eEjUf"),
    $7105cf5c03cffdff$var$load("3pkSd"),
    $7105cf5c03cffdff$var$load("5ax2I"),
    $7105cf5c03cffdff$var$load("5KWjU"),
    $7105cf5c03cffdff$var$load("7J1PC"),
    $7105cf5c03cffdff$var$load("446Ip"),
    $7105cf5c03cffdff$var$load("caMoT"),
    $7105cf5c03cffdff$var$load("4WVf0"),
    $7105cf5c03cffdff$var$load("dxcsb"),
    $7105cf5c03cffdff$var$load("epyZS"),
    $7105cf5c03cffdff$var$load("532dz"),
    $7105cf5c03cffdff$var$load("DsM5z"),
    $7105cf5c03cffdff$var$load("lyagC"),
    $7105cf5c03cffdff$var$load("frgRG"),
    $7105cf5c03cffdff$var$load("cGkFm"),
    $7105cf5c03cffdff$var$load("2jERw"),
    $7105cf5c03cffdff$var$load("b7144"),
    $7105cf5c03cffdff$var$load("a7sEM"),
    $7105cf5c03cffdff$var$load("a6kGP"),
    $7105cf5c03cffdff$var$load("dB5kj"),
    $7105cf5c03cffdff$var$load("ckVWI"),
    $7105cf5c03cffdff$var$load("ihRIc"),
    $7105cf5c03cffdff$var$load("9LDVS"),
    $7105cf5c03cffdff$var$load("kiMHu"),
    $7105cf5c03cffdff$var$load("bJbqV"),
    $7105cf5c03cffdff$var$load("hLB9K"),
    $7105cf5c03cffdff$var$load("le1z7"),
    $7105cf5c03cffdff$var$load("4xsdA"),
    $7105cf5c03cffdff$var$load("9TOep"),
    $7105cf5c03cffdff$var$load("ejk86"),
    $7105cf5c03cffdff$var$load("lUBBr"),
    $7105cf5c03cffdff$var$load("iYvvi"),
    $7105cf5c03cffdff$var$load("eWXZF"),
    $7105cf5c03cffdff$var$load("hhss7"),
    $7105cf5c03cffdff$var$load("isVeA"),
    $7105cf5c03cffdff$var$load("6wr18"),
    $7105cf5c03cffdff$var$load("ffEVr"),
    $7105cf5c03cffdff$var$load("7gPXS"),
    $7105cf5c03cffdff$var$load("91v6x"),
    $7105cf5c03cffdff$var$load("g7Yjk"),
    $7105cf5c03cffdff$var$load("aqs28"),
    $7105cf5c03cffdff$var$load("45r7q"),
    $7105cf5c03cffdff$var$load("hEkNB"),
    $7105cf5c03cffdff$var$load("dP7Qm"),
    $7105cf5c03cffdff$var$load("aAWLw"),
    $7105cf5c03cffdff$var$load("7EorR"),
    $7105cf5c03cffdff$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("f9Qyy", function(module, exports) {

let $b09076d862f3d41a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b09076d862f3d41a$var$load("hnpcA"),
    $b09076d862f3d41a$var$load("6wr18"),
    $b09076d862f3d41a$var$load("lKZDc"),
    $b09076d862f3d41a$var$load("w3Gc8"),
    $b09076d862f3d41a$var$load("ffEVr"),
    $b09076d862f3d41a$var$load("bZz7X"),
    $b09076d862f3d41a$var$load("9izCO")
]).then(()=>parcelRequire('gDZxl'));

});

parcelRegister("i6UMJ", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $7m1pr = parcelRequire("7m1pr");


var $6faGq = parcelRequire("6faGq");


var $3mVfX = parcelRequire("3mVfX");

var $6ed006a18ff2d87d$export$50c823aead020a09 = /*#__PURE__*/ function(LocationValue) {
    LocationValue["PANEL"] = "panel";
    LocationValue["FOOTER"] = "footer";
    LocationValue["STANDALONE"] = "standalone";
    return LocationValue;
}({});
const $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime = (comment)=>{
    const commentLocation = comment.location;
    const resolvedTime = commentLocation?.inlineResolveProperties?.resolvedTime || commentLocation?.commentResolveProperties?.resolvedTime;
    return resolvedTime || (0, $6faGq.getValidDate)(comment.createdAtNonLocalized).getTime();
};
const $6ed006a18ff2d87d$export$d2935240a910e26e = (currentSort, commentThreads)=>{
    if (currentSort === (0, $3mVfX.SortValues).MOST_RECENT) return [
        ...commentThreads
    ].sort((a, b)=>$6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(b) - $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(a));
    return commentThreads;
};
const $6ed006a18ff2d87d$export$47f9a121266175f = (annotations)=>annotations.map((annotation)=>annotation.threadKey);
const $6ed006a18ff2d87d$export$7119b2a60583b6dc = (marks = [])=>marks.map((mark)=>mark.attrs.id);
const $6ed006a18ff2d87d$export$b02d74cde949c060 = (commentA, commentB)=>(0, $6faGq.getValidDate)(commentA?.createdAtNonLocalized).getTime() - (0, $6faGq.getValidDate)(commentB?.createdAtNonLocalized).getTime();
const $6ed006a18ff2d87d$export$5425fcea1abfd6f7 = (error)=>{
    if (!error) // if falsy, consider it as NOT containing non-reactionsSummary errors
    return true;
    else if (error instanceof (0, $7m1pr.RelayError) || error instanceof (0, $9B4fQ.ApolloError)) {
        // TODO we will need to migrate to ApolloRelayInterops to get proper error type of ApolloErrorInterop instead of ApolloError
        // after migration, we can remove the instanceof ApolloError check here
        const hasOtherGqlErrors = error.graphQLErrors?.filter((e)=>!e.path?.includes('reactionsSummary'))?.length > 0;
        return !hasOtherGqlErrors && !error.networkError;
    } else // if truthy but not an ApolloErrorInterop, consider it as containing non-reactionsSummary errors
    return false;
};
module.exports["LocationValue"] = $6ed006a18ff2d87d$export$50c823aead020a09;
module.exports["getSortedCommentThreads"] = $6ed006a18ff2d87d$export$d2935240a910e26e;
module.exports["getAnnotationThreadKeys"] = $6ed006a18ff2d87d$export$47f9a121266175f;
module.exports["getMarkIds"] = $6ed006a18ff2d87d$export$7119b2a60583b6dc;
module.exports["getCommentsSortedOldestToNewest"] = $6ed006a18ff2d87d$export$b02d74cde949c060;
module.exports["onlyHasReactionsSummaryErrors"] = $6ed006a18ff2d87d$export$5425fcea1abfd6f7;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $kSwu1.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $cozmU.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
$parcel$export(module.exports, "formatRelativeTimeAgo", () => (parcelRequire("6gnMn")).formatRelativeTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


var $6gnMn = parcelRequire("6gnMn");


});

parcelRegister("1YXTQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $kSwu1.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    // oxlint-disable-next-line compat/compat
    const localeLanguage = new Intl.Locale(locale).language;
    // oxlint-disable-next-line compat/compat
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $cozmU.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $cozmU.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("6gnMn", function(module, exports) {

var $jb2R2 = parcelRequire("jb2R2");

var $bg9GW = parcelRequire("bg9GW");

var $fNtG8 = parcelRequire("fNtG8");

var $jgqX6 = parcelRequire("jgqX6");

var $hnDzv = parcelRequire("hnDzv");


var $kSwu1 = parcelRequire("kSwu1");

const $926347e03f273aaa$var$i18n = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "time-ago.relative.just-now",
        defaultMessage: "Just now"
    },
    minutesAgo: {
        id: "time-ago.relative.minutes-ago",
        defaultMessage: "{minuteCount} {minuteCount, plural, one {minute} other {minutes}} ago"
    },
    hoursAgo: {
        id: "time-ago.relative.hours-ago",
        defaultMessage: "{hourCount} {hourCount, plural, one {hour} other {hours}} ago"
    },
    daysAgo: {
        id: "time-ago.relative.days-ago",
        defaultMessage: "{dayCount} {dayCount, plural, one {day} other {days}} ago"
    },
    monthsAgo: {
        id: "time-ago.relative.months-ago",
        defaultMessage: "{monthCount} {monthCount, plural, one {month} other {months}} ago"
    },
    yearsAgo: {
        id: "time-ago.relative.years-ago",
        defaultMessage: "{yearCount} {yearCount, plural, one {year} other {years}} ago"
    }
});
const $926347e03f273aaa$export$b77ccb75f39eecf = (date, intl, now = new Date())=>{
    const dateObject = new Date(date);
    const minutesDiff = (0, $fNtG8.default)(now, dateObject);
    const hoursDiff = (0, $bg9GW.default)(now, dateObject);
    const daysDiff = (0, $jb2R2.default)(now, dateObject);
    const monthsDiff = (0, $jgqX6.default)(now, dateObject);
    const yearsDiff = (0, $hnDzv.default)(now, dateObject);
    if (minutesDiff < 1) return intl.formatMessage($926347e03f273aaa$var$i18n.justNow);
    if (minutesDiff < 60) return intl.formatMessage($926347e03f273aaa$var$i18n.minutesAgo, {
        minuteCount: minutesDiff
    });
    if (hoursDiff < 24) return intl.formatMessage($926347e03f273aaa$var$i18n.hoursAgo, {
        hourCount: hoursDiff
    });
    if (daysDiff < 31) return intl.formatMessage($926347e03f273aaa$var$i18n.daysAgo, {
        dayCount: daysDiff
    });
    if (monthsDiff < 12) return intl.formatMessage($926347e03f273aaa$var$i18n.monthsAgo, {
        monthCount: monthsDiff
    });
    return intl.formatMessage($926347e03f273aaa$var$i18n.yearsAgo, {
        yearCount: yearsDiff
    });
};
module.exports["formatRelativeTimeAgo"] = $926347e03f273aaa$export$b77ccb75f39eecf;

});

parcelRegister("bg9GW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8328b4ddc95230a8$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $8328b4ddc95230a8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInHour);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jO73f", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e6b828148d99ab2b$export$dfd9b671c89acc8e = 7;
var $e6b828148d99ab2b$export$3913210603d8e9ae = 365.2425;
var $e6b828148d99ab2b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e6b828148d99ab2b$export$91246f0b9bd9beff = 60000;
var $e6b828148d99ab2b$export$7f72910d6dfd237a = 3600000;
var $e6b828148d99ab2b$export$397c2d5776aa9055 = 1000;
var $e6b828148d99ab2b$export$4dec998e48f9c246 = -$e6b828148d99ab2b$export$81caae6e1cc7a622;
var $e6b828148d99ab2b$export$f2f5ae5a8e2d8f9f = 60;
var $e6b828148d99ab2b$export$3c58128db900d44e = 3;
var $e6b828148d99ab2b$export$80d7e435f744f319 = 12;
var $e6b828148d99ab2b$export$4db7641526e3241f = 4;
var $e6b828148d99ab2b$export$698aec755e92c695 = 3600;
var $e6b828148d99ab2b$export$a77c1a7ebebe2a5a = 60;
var $e6b828148d99ab2b$export$815a9362476d2fe3 = $e6b828148d99ab2b$export$698aec755e92c695 * 24;
var $e6b828148d99ab2b$export$34804a017b31e2fe = $e6b828148d99ab2b$export$815a9362476d2fe3 * 7;
var $e6b828148d99ab2b$export$7271e9e3478110d1 = $e6b828148d99ab2b$export$815a9362476d2fe3 * $e6b828148d99ab2b$export$3913210603d8e9ae;
var $e6b828148d99ab2b$export$8e6600bbdee7dabb = $e6b828148d99ab2b$export$7271e9e3478110d1 / 12;
var $e6b828148d99ab2b$export$be1dccf2de902d31 = $e6b828148d99ab2b$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e6b828148d99ab2b$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e6b828148d99ab2b$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e6b828148d99ab2b$export$397c2d5776aa9055;

});

parcelRegister("g93kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc101184c63d7a7a$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $bc101184c63d7a7a$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $3yGK6.default)(2, arguments);
    return (0, $dkBOe.default)(dateLeft).getTime() - (0, $dkBOe.default)(dateRight).getTime();
}

});

parcelRegister("byLBW", function(module, exports) {
var $86a7cd36e9b99950$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $86a7cd36e9b99950$var$defaultRoundingMethod = 'trunc';
function $86a7cd36e9b99950$export$b6474a47258c1211(method) {
    return method ? $86a7cd36e9b99950$var$roundingMap[method] : $86a7cd36e9b99950$var$roundingMap[$86a7cd36e9b99950$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $86a7cd36e9b99950$export$b6474a47258c1211;

});

parcelRegister("fNtG8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8027429ed7dcbe2$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $b8027429ed7dcbe2$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInMinute);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jgqX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0646b18c90b3a18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3c3I9 = parcelRequire("3c3I9");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");


var $2iY37 = parcelRequire("2iY37");

function $e0646b18c90b3a18$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c3I9.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2iY37.default)((0, $dkBOe.default)(dirtyDateLeft)) && difference === 1 && (0, $eYSi7.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("3c3I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25355f04f79cc351$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $25355f04f79cc351$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eYSi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae80c86a80ef7d08$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $ae80c86a80ef7d08$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("2iY37", function(module, exports) {
$parcel$export(module.exports, "default", () => $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $1Ltep = parcelRequire("1Ltep");


var $WeoLw = parcelRequire("WeoLw");


var $3yGK6 = parcelRequire("3yGK6");

function $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    return (0, $1Ltep.default)(date).getTime() === (0, $WeoLw.default)(date).getTime();
}

});

parcelRegister("1Ltep", function(module, exports) {
$parcel$export(module.exports, "default", () => $1490daf4e920e8da$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1490daf4e920e8da$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("WeoLw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af0962005736f62$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0af0962005736f62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("hnDzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca7347c324945db7$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $9wdry = parcelRequire("9wdry");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");

function $ca7347c324945db7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $9wdry.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("9wdry", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee187ccd32d3646$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $6ee187ccd32d3646$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("1ZGYV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION = 20000;
const $b6108840e0d320f3$var$USER_INTERACTION_EVENTS = [
    'mousedown',
    'keydown',
    'wheel',
    'touchstart'
];
const $b6108840e0d320f3$export$544875121493f258 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { callback: callback, elementRef: elementRef, skip: skip } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const stopObserverCallbacks = (0, $cozmU.useRef)(t1);
    const mutationEndTimer = (0, $cozmU.useRef)(0);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (_reason)=>{
            stopObserverCallbacks.current.forEach($b6108840e0d320f3$var$_temp);
            stopObserverCallbacks.current = [];
            if (mutationEndTimer.current !== 0) {
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = 0;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const stopMonitoring = t2;
    let t3;
    if ($[2] !== callback || $[3] !== elementRef) {
        t3 = ()=>{
            if (!stopObserverCallbacks.current.length && elementRef?.current) {
                const mutationObserver = new MutationObserver(()=>{
                    window.clearTimeout(mutationEndTimer.current);
                    mutationEndTimer.current = window.setTimeout(()=>{
                        stopMonitoring("Deep link target never found");
                    }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                    if (callback()) stopMonitoring("Callback succeeded");
                });
                mutationObserver.observe(elementRef.current, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true
                });
                stopObserverCallbacks.current.push(()=>{
                    mutationObserver.disconnect();
                });
                $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                    const userInteractionHandler = ()=>stopMonitoring("User interaction");
                    window.addEventListener(name, userInteractionHandler, true);
                    stopObserverCallbacks.current.push(()=>{
                        window.removeEventListener(name, userInteractionHandler, true);
                    });
                });
            }
        };
        $[2] = callback;
        $[3] = elementRef;
        $[4] = t3;
    } else t3 = $[4];
    const startMonitoring = t3;
    let t4;
    let t5;
    if ($[5] !== callback || $[6] !== elementRef || $[7] !== skip || $[8] !== startMonitoring) {
        t4 = ()=>{
            if (skip || !elementRef?.current) return;
            if (callback()) return;
            startMonitoring();
            return ()=>{
                stopMonitoring("Canceled by unmount");
            };
        };
        t5 = [
            elementRef,
            callback,
            skip,
            startMonitoring,
            stopMonitoring
        ];
        $[5] = callback;
        $[6] = elementRef;
        $[7] = skip;
        $[8] = startMonitoring;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
} : ({ callback: callback, elementRef: elementRef, skip: skip })=>{
    const stopObserverCallbacks = (0, $cozmU.useRef)([]);
    const mutationEndTimer = (0, $cozmU.useRef)(0);
    const stopMonitoring = (0, $cozmU.useCallback)((_reason)=>{
        stopObserverCallbacks.current.forEach((stop)=>{
            stop();
        });
        stopObserverCallbacks.current = [];
        if (mutationEndTimer.current !== 0) {
            window.clearTimeout(mutationEndTimer.current);
            mutationEndTimer.current = 0;
        }
    }, []);
    const startMonitoring = (0, $cozmU.useCallback)(()=>{
        if (!stopObserverCallbacks.current.length && elementRef?.current) {
            const mutationObserver = new MutationObserver(()=>{
                // Every time there's a change, restart the timer that ends watching for mutations
                // (keep the observer going until changes stop for a while).
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = window.setTimeout(()=>{
                    // De-bouncing ended. Timeout finally running, time to stop observing and trying to follow the anchor
                    stopMonitoring('Deep link target never found');
                }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                if (callback()) // If the callback succeeded, stop monitoring
                stopMonitoring('Callback succeeded');
            });
            mutationObserver.observe(elementRef.current, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true
            });
            stopObserverCallbacks.current.push(()=>{
                mutationObserver.disconnect();
            });
            // Listen for user interaction to end checking for changes
            $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                const userInteractionHandler = ()=>stopMonitoring('User interaction');
                window.addEventListener(name, userInteractionHandler, true);
                stopObserverCallbacks.current.push(()=>{
                    window.removeEventListener(name, userInteractionHandler, true);
                });
            });
        }
    }, [
        elementRef,
        callback,
        stopMonitoring
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Do nothing if skip is true or the elementRef is not set.
        if (skip || !elementRef?.current) return;
        // Try right away in case the page has already settled and there are no mutations to observe.
        if (callback()) return;
        // Watch for changes to the page and call the callback whenever one occurs.
        startMonitoring();
        return ()=>{
            stopMonitoring('Canceled by unmount');
        };
    }, [
        elementRef,
        callback,
        skip,
        startMonitoring,
        stopMonitoring
    ]);
};
function $b6108840e0d320f3$var$_temp(stop) {
    stop();
}
module.exports["useRetryOnMutation"] = $b6108840e0d320f3$export$544875121493f258;

});

parcelRegister("eTcMK", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ const $cae726f3aa41e4da$export$497a036b5874e4b0 = (parentCommentId, location, author, shouldIncludeUser)=>{
    return {
        parentCommentId: parentCommentId,
        location: location,
        user: author && shouldIncludeUser ? {
            displayName: author.displayName,
            accountId: author.accountId
        } : undefined
    };
};
module.exports["createReplyToCommentParams"] = $cae726f3aa41e4da$export$497a036b5874e4b0;

});

parcelRegister("ifBRq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $a33Aa = parcelRequire("a33Aa");


var $gczDe = parcelRequire("gczDe");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $lb2Lp = parcelRequire("lb2Lp");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $7aRa9 = parcelRequire("7aRa9");


var $ep3mz = parcelRequire("ep3mz");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $8WQTF = parcelRequire("8WQTF");


var $aSsfA = parcelRequire("aSsfA");


var $dPJCf = parcelRequire("dPJCf");


var $eTcMK = parcelRequire("eTcMK");


var $1ZGYV = parcelRequire("1ZGYV");

// Maximum wait time for scroll operations (in milliseconds)
const $4d5518b698c93929$var$SCROLL_TIMEOUT_MS = 4000;
// Minimum time page must be stable before scrolling (in milliseconds)
const $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS = 500;
// Wait for document height to stabilize (tables may have async layout)
const $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS = 150;
const $4d5518b698c93929$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentLinkNotFoundFlagTitle: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    }
});
// ---------------------------------------------------------------------------
// Query param hooks
// ---------------------------------------------------------------------------
const $4d5518b698c93929$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $4d5518b698c93929$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $4d5518b698c93929$var$useCommentQueryParamsData = (0, $3u0dr.isReactCompilerActiveV2)() ? function useCommentQueryParamsData(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { commentId: commentId, contentId: contentId } = t0;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let t1;
    if ($[0] !== pageMode) {
        t1 = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
        $[0] = pageMode;
        $[1] = t1;
    } else t1 = $[1];
    const contentStatusFilters = t1;
    const t2 = commentId || "";
    const t3 = contentId || "";
    const t4 = !commentId;
    let t5;
    if ($[2] !== t4) {
        t5 = {
            skip: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== contentStatusFilters || $[5] !== t2 || $[6] !== t3 || $[7] !== t5) {
        t6 = {
            commentId: t2,
            contentId: t3,
            contentStatus: contentStatusFilters,
            options: t5
        };
        $[4] = contentStatusFilters;
        $[5] = t2;
        $[6] = t3;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)(t6);
    const t7 = foundComment?.parentId || "";
    const t8 = contentId || "";
    const t9 = !foundComment?.parentId;
    let t10;
    if ($[9] !== t9) {
        t10 = {
            skip: t9
        };
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] !== contentStatusFilters || $[12] !== t10 || $[13] !== t7 || $[14] !== t8) {
        t11 = {
            commentId: t7,
            contentId: t8,
            contentStatus: contentStatusFilters,
            options: t10
        };
        $[11] = contentStatusFilters;
        $[12] = t10;
        $[13] = t7;
        $[14] = t8;
        $[15] = t11;
    } else t11 = $[15];
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)(t11);
    let isResolved = undefined;
    let parentId = undefined;
    if (foundComment && !commentError) {
        const loc = foundComment.location;
        if (loc?.type === "INLINE") isResolved = Boolean(loc?.inlineResolveProperties?.resolved);
        else isResolved = Boolean(loc?.commentResolveProperties?.resolved);
        parentId = foundComment.parentId;
    }
    const t12 = Boolean(commentError);
    const t13 = Boolean(parentError);
    let t14;
    if ($[16] !== commentId || $[17] !== commentLoading || $[18] !== foundComment || $[19] !== isResolved || $[20] !== parentComment || $[21] !== parentId || $[22] !== parentLoading || $[23] !== t12 || $[24] !== t13) {
        t14 = {
            commentId: commentId,
            foundComment: foundComment,
            parentComment: parentComment,
            commentLoading: commentLoading,
            commentError: t12,
            parentLoading: parentLoading,
            parentError: t13,
            isResolved: isResolved,
            parentId: parentId
        };
        $[16] = commentId;
        $[17] = commentLoading;
        $[18] = foundComment;
        $[19] = isResolved;
        $[20] = parentComment;
        $[21] = parentId;
        $[22] = parentLoading;
        $[23] = t12;
        $[24] = t13;
        $[25] = t14;
    } else t14 = $[25];
    return t14;
} : function useCommentQueryParamsData({ commentId: commentId, contentId: contentId }) {
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: !commentId
        }
    });
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)({
        commentId: foundComment?.parentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: !foundComment?.parentId
        }
    });
    // Derive isResolved + parentId from the comment
    let isResolved = undefined;
    let parentId = undefined;
    if (foundComment && !commentError) {
        const loc = foundComment.location;
        if (loc?.type === 'INLINE') isResolved = Boolean(loc?.inlineResolveProperties?.resolved);
        else isResolved = Boolean(loc?.commentResolveProperties?.resolved);
        parentId = foundComment.parentId;
    }
    return {
        commentId: commentId,
        foundComment: foundComment,
        parentComment: parentComment,
        commentLoading: commentLoading,
        commentError: Boolean(commentError),
        parentLoading: parentLoading,
        parentError: Boolean(parentError),
        isResolved: isResolved,
        parentId: parentId
    };
}; // ---------------------------------------------------------------------------
const $4d5518b698c93929$var$InlineCommentHandler = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(59);
    const { commentId: commentId, rendererRef: rendererRef, flags: flags, data: data } = t0;
    const hasHandledCommentLink = (0, $cozmU.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const { replyToCommentId: replyToCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)();
    const { foundComment: foundComment, parentComment: parentComment } = data;
    let t1;
    bb0: {
        if (!data.commentError && !data.commentLoading && foundComment) {
            const location = foundComment.location ?? undefined;
            const pid = foundComment.parentId;
            const parentLocation = pid && !data.parentError && !data.parentLoading && parentComment ? parentComment.location ?? undefined : undefined;
            if (!pid || parentComment) {
                let t2;
                if ($[0] !== location || $[1] !== parentLocation || $[2] !== pid) {
                    t2 = {
                        location: location,
                        parentId: pid,
                        parentLocation: parentLocation
                    };
                    $[0] = location;
                    $[1] = parentLocation;
                    $[2] = pid;
                    $[3] = t2;
                } else t2 = $[3];
                t1 = t2;
                break bb0;
            }
        }
        t1 = undefined;
    }
    const queryParamData = t1;
    let t2;
    if ($[4] !== queryParamData) {
        t2 = queryParamData || {};
        $[4] = queryParamData;
        $[5] = t2;
    } else t2 = $[5];
    const { location: loc, parentLocation: pLoc } = t2;
    let t3;
    if ($[6] !== loc || $[7] !== pLoc?.inlineMarkerRef || $[8] !== pLoc?.inlineResolveProperties?.resolved) {
        t3 = loc?.inlineMarkerRef ? {
            annotationId: loc.inlineMarkerRef,
            isResolved: Boolean(loc.inlineResolveProperties?.resolved)
        } : {
            annotationId: pLoc?.inlineMarkerRef,
            isResolved: Boolean(pLoc?.inlineResolveProperties?.resolved)
        };
        $[6] = loc;
        $[7] = pLoc?.inlineMarkerRef;
        $[8] = pLoc?.inlineResolveProperties?.resolved;
        $[9] = t3;
    } else t3 = $[9];
    const queryParamDataExt = t3;
    let t4;
    if ($[10] !== foundComment || $[11] !== queryParamDataExt.annotationId || $[12] !== replyToCommentId || $[13] !== setCurrentlySelectedThreadKey || $[14] !== setReplyToCommentId) {
        t4 = ()=>{
            if (!replyToCommentId) return;
            if (foundComment) {
                const annotationId = queryParamDataExt?.annotationId;
                if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
                const author = foundComment?.author;
                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, true));
            }
        };
        $[10] = foundComment;
        $[11] = queryParamDataExt.annotationId;
        $[12] = replyToCommentId;
        $[13] = setCurrentlySelectedThreadKey;
        $[14] = setReplyToCommentId;
        $[15] = t4;
    } else t4 = $[15];
    const onReplyToCommentReady = t4;
    let t5;
    if ($[16] !== commentId || $[17] !== onReplyToCommentReady || $[18] !== queryParamData?.parentId || $[19] !== queryParamDataExt || $[20] !== setCurrentlySelectedThreadKey || $[21] !== showCommentsPanel) {
        t5 = ()=>{
            const { annotationId: annotationId_0 } = queryParamDataExt;
            showCommentsPanel({
                openWithView: (0, $3mVfX.ViewValues).OPEN
            });
            const mark = document.querySelector(`[data-id="${annotationId_0}"]`);
            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: "center",
                inline: "center",
                commentId: commentId ?? undefined,
                annotationId: annotationId_0,
                commentType: "INLINE",
                annotationClicked: true,
                expectedView: (0, $3mVfX.ViewValues).OPEN,
                isReply: Boolean(queryParamData?.parentId)
            }).then((success)=>{
                if (!success && mark) {
                    (0, $a33Aa.abortAll)("new_interaction", "focused-comment-scroll");
                    (0, $aHcFH.scrollToElementWithViewingRoom)({
                        element: mark,
                        useInstantScroll: true
                    });
                }
            });
            setCurrentlySelectedThreadKey(annotationId_0 ?? "", (0, $kgNLQ.CommentType).INLINE);
            (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
            hasHandledCommentLink.current = true;
        };
        $[16] = commentId;
        $[17] = onReplyToCommentReady;
        $[18] = queryParamData?.parentId;
        $[19] = queryParamDataExt;
        $[20] = setCurrentlySelectedThreadKey;
        $[21] = showCommentsPanel;
        $[22] = t5;
    } else t5 = $[22];
    const navigateToActiveInlineComment = t5;
    let t6;
    if ($[23] !== commentId || $[24] !== queryParamData?.parentId || $[25] !== queryParamDataExt.annotationId) {
        t6 = ()=>$4d5518b698c93929$var$tryToFocusAndScrollActiveComment({
                parentId: queryParamData?.parentId,
                annotationId: queryParamDataExt?.annotationId || null,
                commentId: commentId || null
            });
        $[23] = commentId;
        $[24] = queryParamData?.parentId;
        $[25] = queryParamDataExt.annotationId;
        $[26] = t6;
    } else t6 = $[26];
    const tryToFocusAndScrollActiveCommentCallback = t6;
    const t7 = !commentId || !queryParamData || queryParamDataExt.isResolved;
    let t8;
    if ($[27] !== rendererRef || $[28] !== t7 || $[29] !== tryToFocusAndScrollActiveCommentCallback) {
        t8 = {
            callback: tryToFocusAndScrollActiveCommentCallback,
            elementRef: rendererRef,
            skip: t7
        };
        $[27] = rendererRef;
        $[28] = t7;
        $[29] = tryToFocusAndScrollActiveCommentCallback;
        $[30] = t8;
    } else t8 = $[30];
    (0, $1ZGYV.useRetryOnMutation)(t8);
    let t9;
    if ($[31] !== commentId || $[32] !== isCommentNotFound || $[33] !== navigateToActiveInlineComment || $[34] !== onReplyToCommentReady || $[35] !== queryParamData || $[36] !== queryParamDataExt || $[37] !== rendererActions || $[38] !== setCommentContainerToFocus || $[39] !== setCurrentlySelectedThreadKey || $[40] !== showCommentsPanel) {
        t9 = ()=>{
            if (!queryParamData || hasHandledCommentLink.current) return;
            const { location: location_0 } = queryParamData;
            const { annotationId: annotationId_1 } = queryParamDataExt;
            if (location_0) {
                if (queryParamDataExt.isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    if (annotationId_1) {
                        setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                        setCommentContainerToFocus(commentId ?? undefined);
                    }
                    if ((0, $6mKj3.expValEquals)("cc_comments_fix_resolved_focused_comments", "isEnabled", true)) hasHandledCommentLink.current = true;
                } else if (annotationId_1) {
                    if (!rendererActions) return;
                    const marks = rendererActions.getAnnotationMarks();
                    if (!marks || marks.length === 0) return;
                    const annotationExists = marks?.some((mark_0)=>mark_0.attrs?.id === annotationId_1);
                    if (!annotationExists) {
                        setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                        setCommentContainerToFocus(commentId ?? undefined);
                        showCommentsPanel({
                            openWithView: (0, $6mKj3.expValEquals)("cc_comments_detached_in_open_view", "isEnabled", true) ? (0, $3mVfX.ViewValues).OPEN : (0, $3mVfX.ViewValues).DELETED_CONTENT
                        });
                        (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
                        hasHandledCommentLink.current = true;
                        return;
                    } else if ((0, $6mKj3.expValEquals)("confluence_comment_panel_inlinecomment_qp", "isEnabled", true)) {
                        navigateToActiveInlineComment();
                        return;
                    }
                }
            } else {
                if ((0, $6mKj3.expValEquals)("confluence_comment_improve_comment_deeplink", "isEnabled", true)) {
                    if (!rendererActions || annotationId_1 && isCommentNotFound === undefined) return;
                }
                if (!rendererActions && (0, $6mKj3.expValEquals)("confluence_comment_improve_comment_deeplink", "isEnabled", true)) return;
                const annotationExists_0 = rendererActions?.getAnnotationMarks()?.some((mark_1)=>mark_1.attrs?.id === annotationId_1);
                if (annotationId_1 && !annotationExists_0) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                    showCommentsPanel({
                        openWithView: (0, $6mKj3.expValEquals)("cc_comments_detached_in_open_view", "isEnabled", true) ? (0, $3mVfX.ViewValues).OPEN : (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
                }
                hasHandledCommentLink.current = true;
            }
        };
        $[31] = commentId;
        $[32] = isCommentNotFound;
        $[33] = navigateToActiveInlineComment;
        $[34] = onReplyToCommentReady;
        $[35] = queryParamData;
        $[36] = queryParamDataExt;
        $[37] = rendererActions;
        $[38] = setCommentContainerToFocus;
        $[39] = setCurrentlySelectedThreadKey;
        $[40] = showCommentsPanel;
        $[41] = t9;
    } else t9 = $[41];
    let t10;
    if ($[42] !== commentId || $[43] !== isCommentNotFound || $[44] !== navigateToActiveInlineComment || $[45] !== onReplyToCommentReady || $[46] !== orderedActiveAnnotationIdList || $[47] !== queryParamData || $[48] !== queryParamDataExt || $[49] !== rendererActions || $[50] !== setCommentContainerToFocus || $[51] !== setCurrentlySelectedThreadKey || $[52] !== showCommentsPanel) {
        t10 = [
            queryParamData,
            rendererActions,
            orderedActiveAnnotationIdList,
            queryParamDataExt,
            showCommentsPanel,
            setCurrentlySelectedThreadKey,
            setCommentContainerToFocus,
            commentId,
            isCommentNotFound,
            onReplyToCommentReady,
            navigateToActiveInlineComment
        ];
        $[42] = commentId;
        $[43] = isCommentNotFound;
        $[44] = navigateToActiveInlineComment;
        $[45] = onReplyToCommentReady;
        $[46] = orderedActiveAnnotationIdList;
        $[47] = queryParamData;
        $[48] = queryParamDataExt;
        $[49] = rendererActions;
        $[50] = setCommentContainerToFocus;
        $[51] = setCurrentlySelectedThreadKey;
        $[52] = showCommentsPanel;
        $[53] = t10;
    } else t10 = $[53];
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[54] !== commentId || $[55] !== flags || $[56] !== isCommentNotFound) {
        t11 = ()=>{
            if (isCommentNotFound) flags.showWarningFlag({
                id: `viewpage-comment-link-not-found-${commentId}`,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
            });
        };
        t12 = [
            commentId,
            flags,
            isCommentNotFound
        ];
        $[54] = commentId;
        $[55] = flags;
        $[56] = isCommentNotFound;
        $[57] = t11;
        $[58] = t12;
    } else {
        t11 = $[57];
        t12 = $[58];
    }
    (0, $cozmU.useEffect)(t11, t12);
    return null;
} : ({ commentId: commentId, rendererRef: rendererRef, flags: flags, data: data })=>{
    const hasHandledCommentLink = (0, $cozmU.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const { replyToCommentId: replyToCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)();
    const { foundComment: foundComment, isResolved: _ignored, parentComment: parentComment } = data;
    const queryParamData = (0, $cozmU.useMemo)(()=>{
        if (!data.commentError && !data.commentLoading && foundComment) {
            const location = foundComment.location ?? undefined;
            const pid = foundComment.parentId;
            const parentLocation = pid && !data.parentError && !data.parentLoading && parentComment ? parentComment.location ?? undefined : undefined;
            if (!pid || parentComment) return {
                location: location,
                parentId: pid,
                parentLocation: parentLocation
            };
        }
        return undefined;
    }, [
        data.commentError,
        data.commentLoading,
        foundComment,
        data.parentError,
        data.parentLoading,
        parentComment
    ]);
    const queryParamDataExt = (0, $cozmU.useMemo)(()=>{
        const { location: loc, parentLocation: pLoc } = queryParamData || {};
        return loc?.inlineMarkerRef ? {
            annotationId: loc.inlineMarkerRef,
            isResolved: Boolean(loc.inlineResolveProperties?.resolved)
        } : {
            annotationId: pLoc?.inlineMarkerRef,
            isResolved: Boolean(pLoc?.inlineResolveProperties?.resolved)
        };
    }, [
        queryParamData
    ]);
    const onReplyToCommentReady = (0, $cozmU.useCallback)(()=>{
        if (!replyToCommentId) return;
        if (foundComment) {
            const annotationId = queryParamDataExt?.annotationId;
            if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $kgNLQ.CommentType).INLINE);
            const author = foundComment?.author;
            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, true));
        }
    }, [
        replyToCommentId,
        foundComment,
        queryParamDataExt,
        setReplyToCommentId,
        setCurrentlySelectedThreadKey
    ]);
    const navigateToActiveInlineComment = (0, $cozmU.useCallback)(()=>{
        const { annotationId: annotationId_0 } = queryParamDataExt;
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const mark = document.querySelector(`[data-id="${annotationId_0}"]`);
        (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            block: 'center',
            inline: 'center',
            commentId: commentId ?? undefined,
            annotationId: annotationId_0,
            commentType: 'INLINE',
            annotationClicked: true,
            expectedView: (0, $3mVfX.ViewValues).OPEN,
            isReply: Boolean(queryParamData?.parentId)
        }).then((success)=>{
            if (!success && mark) {
                (0, $a33Aa.abortAll)('new_interaction', 'focused-comment-scroll');
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        });
        setCurrentlySelectedThreadKey(annotationId_0 ?? '', (0, $kgNLQ.CommentType).INLINE);
        (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
        hasHandledCommentLink.current = true;
    }, [
        queryParamData,
        queryParamDataExt,
        commentId,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        onReplyToCommentReady
    ]);
    const tryToFocusAndScrollActiveCommentCallback = (0, $cozmU.useCallback)(()=>{
        return $4d5518b698c93929$var$tryToFocusAndScrollActiveComment({
            parentId: queryParamData?.parentId,
            annotationId: queryParamDataExt?.annotationId || null,
            commentId: commentId || null
        });
    }, [
        queryParamData,
        queryParamDataExt,
        commentId
    ]);
    (0, $1ZGYV.useRetryOnMutation)({
        callback: tryToFocusAndScrollActiveCommentCallback,
        elementRef: rendererRef,
        skip: !commentId || !queryParamData || queryParamDataExt.isResolved
    });
    (0, $cozmU.useEffect)(()=>{
        if (!queryParamData || hasHandledCommentLink.current) return;
        const { location: location_0 } = queryParamData;
        const { annotationId: annotationId_1 } = queryParamDataExt;
        if (location_0) {
            if (queryParamDataExt.isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (annotationId_1) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                }
                if ((0, $6mKj3.expValEquals)('cc_comments_fix_resolved_focused_comments', 'isEnabled', true)) hasHandledCommentLink.current = true;
            } else if (annotationId_1) {
                // rendererActions is populated asynchronously — wait for it before checking
                // annotation marks, otherwise we'd incorrectly treat active comments as dangling.
                if (!rendererActions) return;
                // Comment exists in DB but annotation mark may be gone from page content (deleted content).
                // Check if annotation mark exists in renderer; if not, open the panel on the detached comment.
                const marks = rendererActions.getAnnotationMarks();
                // The renderer can briefly report ZERO marks while it (re)hydrates the document during
                // load (observed transitioning 6 -> 0 -> 6). Concluding "dangling" during that window
                // opens an empty DELETED_CONTENT panel and latches it via hasHandledCommentLink, so it
                // never recovers. Requiring at least one mark closes that race — this is the view-path
                // counterpart of the editor fix for bug #19 (which uses annotations.length > 0). A
                // genuinely dangling comment on a page with other comments still has their marks present.
                if (!marks || marks.length === 0) return;
                const annotationExists = marks?.some((mark_0)=>mark_0.attrs?.id === annotationId_1);
                if (!annotationExists) {
                    setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                    showCommentsPanel({
                        openWithView: (0, $6mKj3.expValEquals)('cc_comments_detached_in_open_view', 'isEnabled', true) ? (0, $3mVfX.ViewValues).OPEN : (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
                    hasHandledCommentLink.current = true;
                    return;
                } else if ((0, $6mKj3.expValEquals)('confluence_comment_panel_inlinecomment_qp', 'isEnabled', true)) {
                    // Active inline comment with annotation mark present — open panel and navigate to it.
                    navigateToActiveInlineComment();
                    return;
                }
            }
        } else {
            if ((0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) {
                if (!rendererActions || annotationId_1 && isCommentNotFound === undefined) return;
            }
            if (!rendererActions && (0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) return;
            const annotationExists_0 = rendererActions?.getAnnotationMarks()?.some((mark_1)=>mark_1.attrs?.id === annotationId_1);
            if (annotationId_1 && !annotationExists_0) {
                setCurrentlySelectedThreadKey(annotationId_1, (0, $kgNLQ.CommentType).INLINE);
                setCommentContainerToFocus(commentId ?? undefined);
                showCommentsPanel({
                    openWithView: (0, $6mKj3.expValEquals)('cc_comments_detached_in_open_view', 'isEnabled', true) ? (0, $3mVfX.ViewValues).OPEN : (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
            }
            hasHandledCommentLink.current = true;
        }
    }, [
        queryParamData,
        rendererActions,
        orderedActiveAnnotationIdList,
        queryParamDataExt,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        setCommentContainerToFocus,
        commentId,
        isCommentNotFound,
        onReplyToCommentReady,
        navigateToActiveInlineComment
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isCommentNotFound) flags.showWarningFlag({
            id: `viewpage-comment-link-not-found-${commentId}`,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
        });
    }, [
        commentId,
        flags,
        isCommentNotFound
    ]);
    return null;
};
// Helper (kept private — only used by InlineCommentHandler)
const $4d5518b698c93929$var$tryToFocusAndScrollActiveComment = ({ parentId: parentId, annotationId: annotationId, commentId: commentId })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const mark = document.querySelector(`[data-id="${annotationId}"]`);
    if (mark) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        if (focusedMarkerRef?.id !== annotationId) {
            const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
            (0, $aHcFH.checkElementExpand)(mark, true);
            emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId
                ],
                eventTarget: mark
            });
        }
        if (commentId) {
            const success = (0, $9FoVw.handleDeepLinkNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: 'center',
                markElement: mark,
                commentId: commentId
            });
            if (!success) {
                (0, $a33Aa.abortAll)('new_interaction', 'focused-comment-scroll');
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        } else if (!parentId) {
            (0, $a33Aa.abortAll)('new_interaction', 'focused-comment-scroll');
            (0, $aHcFH.scrollToElementWithViewingRoom)({
                element: mark,
                useInstantScroll: true
            });
        }
    }
    return !!mark;
};
const $4d5518b698c93929$var$ObjectCommentHandler = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    const { commentId: commentId, focusedCommentId: focusedCommentId, replyToComment: replyToComment, hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, data: data } = t0;
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $cozmU.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $cozmU.useState)(false);
    const mutationObserverRef = (0, $cozmU.useRef)(null);
    const scrollTimeoutRef = (0, $cozmU.useRef)(null);
    const lastMutationTimeRef = (0, $cozmU.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (scrollTimeoutRef.current !== null) {
                if (typeof scrollTimeoutRef.current === "number") {
                    if (typeof window !== "undefined" && "cancelIdleCallback" in window) window.cancelIdleCallback(scrollTimeoutRef.current);
                } else clearTimeout(scrollTimeoutRef.current);
                scrollTimeoutRef.current = null;
            }
        };
        $[0] = t1;
    } else t1 = $[0];
    const clearScrollTimeout = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (mutationObserverRef.current) {
                mutationObserverRef.current.disconnect();
                mutationObserverRef.current = null;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const cleanupMutationObserver = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (mutationObserverRef.current) cleanupMutationObserver();
            if (scrollTimeoutRef.current !== null) clearScrollTimeout();
        };
        $[2] = t3;
    } else t3 = $[2];
    const cleanupScrollResources = t3;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { isDataProcessed: isDataProcessed, allComments: allComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const { isResolved: isResolved, parentId: parentId, foundComment: comment, commentError: commentError } = data;
    let t4;
    if ($[3] !== allComments || $[4] !== allObjectCommentsRendered || $[5] !== comment || $[6] !== commentError || $[7] !== commentId || $[8] !== focusedCommentId || $[9] !== hasLoadedObjectComments || $[10] !== hasScrolledToFocusedComment || $[11] !== hasScrolledToReplyComment || $[12] !== isDataProcessed || $[13] !== isResolved || $[14] !== parentId || $[15] !== replyToComment || $[16] !== setCurrentlySelectedThreadKey || $[17] !== setReplyToCommentId || $[18] !== showCommentsPanel) {
        t4 = ()=>{
            const hasData = comment && !commentError;
            if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                let rootCommentId;
                if (isDataProcessed && allComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId)?.id;
                if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
            }
            if (hasData && commentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_queryparam_selection", "isEnabled", true)) {
                const location = comment?.location;
                if (location && "type" in location && location.type === "INLINE") return;
            }
            if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
                if (isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    setCurrentlySelectedThreadKey(commentId, (0, $kgNLQ.CommentType).GENERAL);
                    if (focusedCommentId) setHasScrolledToFocusedComment(true);
                    else setHasScrolledToReplyComment(true);
                } else {
                    const commentElementId = `footer-comment-thread-${commentId}-container`;
                    const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                    let threadToBeSelected = commentId;
                    if (parentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                        let rootCommentId_0;
                        if (isDataProcessed && allComments.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId)?.id;
                        threadToBeSelected = rootCommentId_0 ?? parentId;
                    }
                    if (commentId) {
                        if ((0, $6mKj3.expValEquals)("confluence_comment_deeplink_delay_scroll", "isEnabled", true)) {
                            if (replyToComment) {
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                const author = comment?.author;
                                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true)));
                                setHasScrolledToReplyComment(true);
                                return;
                            }
                            cleanupMutationObserver();
                            const getDocumentScrollHeight = $4d5518b698c93929$var$_temp;
                            const scrollToComment = ()=>{
                                const el = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (el && (0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) getDocumentScrollHeight();
                                showCommentsPanel({
                                    openWithView: (0, $3mVfX.ViewValues).OPEN
                                });
                                (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                                    context: (0, $9FoVw.NavigationContext).PANEL,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    annotationId: threadToBeSelected,
                                    commentType: "FOOTER",
                                    annotationClicked: true,
                                    expectedView: (0, $3mVfX.ViewValues).OPEN,
                                    isReply: Boolean(parentId)
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                cleanupMutationObserver();
                            };
                            const performScrollAndCleanup = ()=>{
                                clearScrollTimeout();
                                if ((0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) requestAnimationFrame(()=>requestAnimationFrame(scrollToComment));
                                else scrollToComment();
                            };
                            const checkHeightStabilityThenScroll = ()=>{
                                if (!(0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) {
                                    performScrollAndCleanup();
                                    return;
                                }
                                const h1 = getDocumentScrollHeight();
                                scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    const h2 = getDocumentScrollHeight();
                                    if (h1 === h2) performScrollAndCleanup();
                                    else scheduleScroll();
                                }, $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS);
                            };
                            const scheduleScroll = ()=>{
                                clearScrollTimeout();
                                lastMutationTimeRef.current = Date.now();
                                if (typeof window !== "undefined" && "requestIdleCallback" in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                    const checkStabilityAndScroll = ()=>{
                                        const timeSince = Date.now() - lastMutationTimeRef.current;
                                        if (timeSince >= $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                        else scrollTimeoutRef.current = setTimeout(()=>{
                                            scrollTimeoutRef.current = null;
                                            checkStabilityAndScroll();
                                        }, $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS - timeSince);
                                    };
                                    checkStabilityAndScroll();
                                });
                                else scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    checkHeightStabilityThenScroll();
                                }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                            };
                            const getElementAndCheckReady = ()=>{
                                const el_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (!el_0) return {
                                    element: null,
                                    isReady: false
                                };
                                const rect = el_0.getBoundingClientRect();
                                return {
                                    element: el_0,
                                    isReady: el_0.offsetHeight > 0 && el_0.offsetWidth > 0 && rect.height > 0 && rect.width > 0
                                };
                            };
                            const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                            if (currentElement && isReady) scheduleScroll();
                            else {
                                mutationObserverRef.current = new MutationObserver(()=>{
                                    lastMutationTimeRef.current = Date.now();
                                    const { element: el_1, isReady: elReady } = getElementAndCheckReady();
                                    if (el_1 && elReady) scheduleScroll();
                                });
                                if (currentElement) {
                                    mutationObserverRef.current.observe(currentElement, {
                                        childList: true,
                                        subtree: true,
                                        attributes: true,
                                        attributeFilter: [
                                            "style",
                                            "class"
                                        ]
                                    });
                                    const parent = currentElement.parentElement;
                                    if (parent) mutationObserverRef.current.observe(parent, {
                                        childList: true,
                                        subtree: true
                                    });
                                } else mutationObserverRef.current.observe(document.body, {
                                    childList: true,
                                    subtree: true
                                });
                                setTimeout(()=>{
                                    if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                                }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                            }
                        } else {
                            const el_2 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (el_2) {
                                showCommentsPanel({
                                    openWithView: (0, $3mVfX.ViewValues).OPEN
                                });
                                (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                    context: (0, $9FoVw.NavigationContext).PANEL,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    annotationId: threadToBeSelected,
                                    commentType: "FOOTER",
                                    annotationClicked: true,
                                    expectedView: (0, $3mVfX.ViewValues).OPEN,
                                    isReply: Boolean(parentId)
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                            }
                        }
                    }
                }
            }
        };
        $[3] = allComments;
        $[4] = allObjectCommentsRendered;
        $[5] = comment;
        $[6] = commentError;
        $[7] = commentId;
        $[8] = focusedCommentId;
        $[9] = hasLoadedObjectComments;
        $[10] = hasScrolledToFocusedComment;
        $[11] = hasScrolledToReplyComment;
        $[12] = isDataProcessed;
        $[13] = isResolved;
        $[14] = parentId;
        $[15] = replyToComment;
        $[16] = setCurrentlySelectedThreadKey;
        $[17] = setReplyToCommentId;
        $[18] = showCommentsPanel;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== allComments || $[21] !== allObjectCommentsRendered || $[22] !== comment || $[23] !== commentBatchCount || $[24] !== commentBatchRendered || $[25] !== commentError || $[26] !== commentId || $[27] !== focusedCommentId || $[28] !== hasLoadedObjectComments || $[29] !== hasScrolledToFocusedComment || $[30] !== hasScrolledToReplyComment || $[31] !== isDataProcessed || $[32] !== isResolved || $[33] !== parentId || $[34] !== replyToComment || $[35] !== setCurrentlySelectedThreadKey || $[36] !== setReplyToCommentId || $[37] !== showCommentsPanel) {
        t5 = [
            comment,
            commentError,
            hasLoadedObjectComments,
            commentId,
            focusedCommentId,
            replyToComment,
            allObjectCommentsRendered,
            commentBatchRendered,
            commentBatchCount,
            setCurrentlySelectedThreadKey,
            setReplyToCommentId,
            isResolved,
            showCommentsPanel,
            hasScrolledToFocusedComment,
            hasScrolledToReplyComment,
            parentId,
            isDataProcessed,
            allComments,
            cleanupMutationObserver,
            clearScrollTimeout
        ];
        $[20] = allComments;
        $[21] = allObjectCommentsRendered;
        $[22] = comment;
        $[23] = commentBatchCount;
        $[24] = commentBatchRendered;
        $[25] = commentError;
        $[26] = commentId;
        $[27] = focusedCommentId;
        $[28] = hasLoadedObjectComments;
        $[29] = hasScrolledToFocusedComment;
        $[30] = hasScrolledToReplyComment;
        $[31] = isDataProcessed;
        $[32] = isResolved;
        $[33] = parentId;
        $[34] = replyToComment;
        $[35] = setCurrentlySelectedThreadKey;
        $[36] = setReplyToCommentId;
        $[37] = showCommentsPanel;
        $[38] = t5;
    } else t5 = $[38];
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasScrolledToFocusedComment(false);
            setHasScrolledToReplyComment(false);
            cleanupScrollResources();
        };
        $[39] = t6;
    } else t6 = $[39];
    let t7;
    if ($[40] !== focusedCommentId || $[41] !== replyToComment) {
        t7 = [
            focusedCommentId,
            replyToComment,
            cleanupScrollResources
        ];
        $[40] = focusedCommentId;
        $[41] = replyToComment;
        $[42] = t7;
    } else t7 = $[42];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>()=>cleanupScrollResources();
        t9 = [
            cleanupScrollResources
        ];
        $[43] = t8;
        $[44] = t9;
    } else {
        t8 = $[43];
        t9 = $[44];
    }
    (0, $cozmU.useEffect)(t8, t9);
    return null;
} : ({ commentId: commentId, focusedCommentId: focusedCommentId, replyToComment: replyToComment, hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, data: data })=>{
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $cozmU.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $cozmU.useState)(false);
    const mutationObserverRef = (0, $cozmU.useRef)(null);
    const scrollTimeoutRef = (0, $cozmU.useRef)(null);
    const lastMutationTimeRef = (0, $cozmU.useRef)(0);
    const clearScrollTimeout = (0, $cozmU.useCallback)(()=>{
        if (scrollTimeoutRef.current !== null) {
            if (typeof scrollTimeoutRef.current === 'number') {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window) window.cancelIdleCallback(scrollTimeoutRef.current);
            } else clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
        }
    }, []);
    const cleanupMutationObserver = (0, $cozmU.useCallback)(()=>{
        if (mutationObserverRef.current) {
            mutationObserverRef.current.disconnect();
            mutationObserverRef.current = null;
        }
    }, []);
    const cleanupScrollResources = (0, $cozmU.useCallback)(()=>{
        if (mutationObserverRef.current) cleanupMutationObserver();
        if (scrollTimeoutRef.current !== null) clearScrollTimeout();
    }, [
        cleanupMutationObserver,
        clearScrollTimeout
    ]);
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { isDataProcessed: isDataProcessed, allComments: allComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const { isResolved: isResolved, parentId: parentId, foundComment: comment, commentError: commentError } = data;
    // Handle scrolling to focused/replyTo comment after the data is loaded
    (0, $cozmU.useEffect)(()=>{
        const hasData = comment && !commentError;
        // Update currentlySelectedThreadKey to root comment for replies (after scroll)
        if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
            let rootCommentId;
            if (isDataProcessed && allComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId)?.id;
            if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
        }
        // Early return if this is actually an INLINE comment — handled by InlineCommentHandler
        if (hasData && commentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_queryparam_selection', 'isEnabled', true)) {
            const location = comment?.location;
            if (location && 'type' in location && location.type === 'INLINE') return;
        }
        if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                setCurrentlySelectedThreadKey(commentId, (0, $kgNLQ.CommentType).GENERAL);
                if (focusedCommentId) setHasScrolledToFocusedComment(true);
                else setHasScrolledToReplyComment(true);
            } else {
                const commentElementId = `footer-comment-thread-${commentId}-container`;
                const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                let threadToBeSelected = commentId;
                if (parentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
                    let rootCommentId_0;
                    if (isDataProcessed && allComments.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId)?.id;
                    threadToBeSelected = rootCommentId_0 ?? parentId;
                }
                if (commentId) {
                    if ((0, $6mKj3.expValEquals)('confluence_comment_deeplink_delay_scroll', 'isEnabled', true)) {
                        if (replyToComment) {
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            const author = comment?.author;
                            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true)));
                            setHasScrolledToReplyComment(true);
                            return;
                        }
                        cleanupMutationObserver();
                        const getDocumentScrollHeight = ()=>Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
                        const scrollToComment = ()=>{
                            const el = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                            if (el && (0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                el.offsetTop;
                                getDocumentScrollHeight();
                            }
                            showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                annotationId: threadToBeSelected,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                isReply: Boolean(parentId)
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            cleanupMutationObserver();
                        };
                        const performScrollAndCleanup = ()=>{
                            clearScrollTimeout();
                            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                            if ((0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) requestAnimationFrame(()=>requestAnimationFrame(scrollToComment));
                            else scrollToComment();
                        };
                        const checkHeightStabilityThenScroll = ()=>{
                            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                            if (!(0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                performScrollAndCleanup();
                                return;
                            }
                            const h1 = getDocumentScrollHeight();
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                const h2 = getDocumentScrollHeight();
                                if (h1 === h2) performScrollAndCleanup();
                                else scheduleScroll();
                            }, $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS);
                        };
                        const scheduleScroll = ()=>{
                            clearScrollTimeout();
                            lastMutationTimeRef.current = Date.now();
                            if (typeof window !== 'undefined' && 'requestIdleCallback' in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                const checkStabilityAndScroll = ()=>{
                                    const timeSince = Date.now() - lastMutationTimeRef.current;
                                    if (timeSince >= $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                    else scrollTimeoutRef.current = setTimeout(()=>{
                                        scrollTimeoutRef.current = null;
                                        checkStabilityAndScroll();
                                    }, $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS - timeSince);
                                };
                                checkStabilityAndScroll();
                            });
                            else scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                checkHeightStabilityThenScroll();
                            }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                        };
                        const getElementAndCheckReady = ()=>{
                            const el_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (!el_0) return {
                                element: null,
                                isReady: false
                            };
                            const rect = el_0.getBoundingClientRect();
                            return {
                                element: el_0,
                                isReady: el_0.offsetHeight > 0 && el_0.offsetWidth > 0 && rect.height > 0 && rect.width > 0
                            };
                        };
                        const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                        if (currentElement && isReady) scheduleScroll();
                        else {
                            mutationObserverRef.current = new MutationObserver(()=>{
                                lastMutationTimeRef.current = Date.now();
                                const { element: el_1, isReady: elReady } = getElementAndCheckReady();
                                if (el_1 && elReady) scheduleScroll();
                            });
                            if (currentElement) {
                                mutationObserverRef.current.observe(currentElement, {
                                    childList: true,
                                    subtree: true,
                                    attributes: true,
                                    attributeFilter: [
                                        'style',
                                        'class'
                                    ]
                                });
                                const parent = currentElement.parentElement;
                                if (parent) mutationObserverRef.current.observe(parent, {
                                    childList: true,
                                    subtree: true
                                });
                            } else mutationObserverRef.current.observe(document.body, {
                                childList: true,
                                subtree: true
                            });
                            setTimeout(()=>{
                                if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                            }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                        }
                    } else {
                        const el_2 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                        if (el_2) {
                            showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                annotationId: threadToBeSelected,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                isReply: Boolean(parentId)
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                        }
                    }
                }
            }
        }
    }, [
        comment,
        commentError,
        hasLoadedObjectComments,
        commentId,
        focusedCommentId,
        replyToComment,
        allObjectCommentsRendered,
        commentBatchRendered,
        commentBatchCount,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        isResolved,
        showCommentsPanel,
        hasScrolledToFocusedComment,
        hasScrolledToReplyComment,
        parentId,
        isDataProcessed,
        allComments,
        cleanupMutationObserver,
        clearScrollTimeout
    ]);
    // Reset scroll tracking when focusedCommentId or replyToComment changes
    (0, $cozmU.useEffect)(()=>{
        setHasScrolledToFocusedComment(false);
        setHasScrolledToReplyComment(false);
        cleanupScrollResources();
    }, [
        focusedCommentId,
        replyToComment,
        cleanupScrollResources
    ]);
    // Clean up MutationObserver and timeout on unmount
    (0, $cozmU.useEffect)(()=>()=>cleanupScrollResources(), [
        cleanupScrollResources
    ]);
    return null;
};
const $4d5518b698c93929$export$c21fa150171418d7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isArchived: t1, rendererRef: rendererRef, hasLoadedObjectComments: t2, allObjectCommentsRendered: t3, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, flags: flags } = t0;
    const isArchived = t1 === undefined ? false : t1;
    const hasLoadedObjectComments = t2 === undefined ? false : t2;
    const allObjectCommentsRendered = t3 === undefined ? false : t3;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { focusedCommentId: inlineFocusedId, replyToCommentId: replyToCommentId, editCommentId: editCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const focusedCommentIdQP = $4d5518b698c93929$var$useFocusedCommentIdQueryParam();
    const replyToCommentQP = $4d5518b698c93929$var$useReplyToCommentQueryParam();
    const commentId = inlineFocusedId || replyToCommentId || editCommentId || focusedCommentIdQP || replyToCommentQP;
    let t4;
    if ($[0] !== commentId || $[1] !== contentId) {
        t4 = {
            commentId: commentId,
            contentId: contentId
        };
        $[0] = commentId;
        $[1] = contentId;
        $[2] = t4;
    } else t4 = $[2];
    const sharedData = $4d5518b698c93929$var$useCommentQueryParamsData(t4);
    const commentLocationType = sharedData.foundComment?.location?.type;
    const isInlineComment = !commentLocationType || commentLocationType === "INLINE";
    if (isInlineComment && rendererRef) {
        let t5;
        if ($[3] !== commentId || $[4] !== flags || $[5] !== isArchived || $[6] !== rendererRef || $[7] !== sharedData) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d5518b698c93929$var$InlineCommentHandler, {
                commentId: commentId,
                isArchived: isArchived,
                rendererRef: rendererRef,
                flags: flags,
                data: sharedData
            });
            $[3] = commentId;
            $[4] = flags;
            $[5] = isArchived;
            $[6] = rendererRef;
            $[7] = sharedData;
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    }
    if (!isInlineComment) {
        const t5 = focusedCommentIdQP || inlineFocusedId;
        const t6 = replyToCommentQP || replyToCommentId;
        let t7;
        if ($[9] !== allObjectCommentsRendered || $[10] !== commentBatchCount || $[11] !== commentBatchRendered || $[12] !== commentId || $[13] !== hasLoadedObjectComments || $[14] !== sharedData || $[15] !== t5 || $[16] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d5518b698c93929$var$ObjectCommentHandler, {
                commentId: commentId,
                focusedCommentId: t5,
                replyToComment: t6,
                hasLoadedObjectComments: hasLoadedObjectComments,
                allObjectCommentsRendered: allObjectCommentsRendered,
                commentBatchRendered: commentBatchRendered,
                commentBatchCount: commentBatchCount,
                data: sharedData
            });
            $[9] = allObjectCommentsRendered;
            $[10] = commentBatchCount;
            $[11] = commentBatchRendered;
            $[12] = commentId;
            $[13] = hasLoadedObjectComments;
            $[14] = sharedData;
            $[15] = t5;
            $[16] = t6;
            $[17] = t7;
        } else t7 = $[17];
        return t7;
    }
    return null;
} : ({ isArchived: isArchived = false, rendererRef: rendererRef, hasLoadedObjectComments: hasLoadedObjectComments = false, allObjectCommentsRendered: allObjectCommentsRendered = false, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // Inline query params (used for InlineCommentHandler + shared commentId)
    const { focusedCommentId: inlineFocusedId, replyToCommentId: replyToCommentId, editCommentId: editCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    // Object query params
    const focusedCommentIdQP = $4d5518b698c93929$var$useFocusedCommentIdQueryParam();
    const replyToCommentQP = $4d5518b698c93929$var$useReplyToCommentQueryParam();
    // Unified commentId: prefer inline params, fall back to object params
    const commentId = inlineFocusedId || replyToCommentId || editCommentId || focusedCommentIdQP || replyToCommentQP;
    // Single shared data fetch — one query for all comment types
    const sharedData = $4d5518b698c93929$var$useCommentQueryParamsData({
        commentId: commentId,
        contentId: contentId
    });
    // Determine comment type from the comment location
    const commentLocationType = sharedData.foundComment?.location?.type;
    // Treat undefined (not yet loaded) as INLINE to satisfy InlineCommentHandler
    // which handles the "not found" case. Once loaded, route based on actual type.
    const isInlineComment = !commentLocationType || commentLocationType === 'INLINE';
    if (isInlineComment && rendererRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d5518b698c93929$var$InlineCommentHandler, {
        commentId: commentId,
        isArchived: isArchived,
        rendererRef: rendererRef,
        flags: flags,
        data: sharedData
    });
    if (!isInlineComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d5518b698c93929$var$ObjectCommentHandler, {
        commentId: commentId,
        focusedCommentId: focusedCommentIdQP || inlineFocusedId,
        replyToComment: replyToCommentQP || replyToCommentId,
        hasLoadedObjectComments: hasLoadedObjectComments,
        allObjectCommentsRendered: allObjectCommentsRendered,
        commentBatchRendered: commentBatchRendered,
        commentBatchCount: commentBatchCount,
        data: sharedData
    });
    return null;
};
const $4d5518b698c93929$export$d7e13e4fc19ecc08 = (0, $7aRa9.withFlags)($4d5518b698c93929$export$c21fa150171418d7);
function $4d5518b698c93929$var$_temp() {
    return Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
}
module.exports["CommentQueryParamsListener"] = $4d5518b698c93929$export$d7e13e4fc19ecc08;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $cozmU.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $cozmU.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $cozmU.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $cozmU.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $cozmU.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $cozmU.useState)(0);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $cozmU.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $cozmU.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("apfIM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8WQTF = parcelRequire("8WQTF");

const $f7fdc9c663d47c5a$export$2f2529470fc43ad6 = /*#__PURE__*/ (0, $cozmU.memo)(({ actions: actions, pageId: pageId })=>{
    const { setRendererActions: setRendererActions } = (0, $8WQTF.useRendererActionsDispatch)();
    (0, $cozmU.useEffect)(()=>{
        setRendererActions(actions, pageId);
    }, [
        actions,
        pageId,
        setRendererActions
    ]);
    return null;
});
module.exports["RendererActionsListener"] = $f7fdc9c663d47c5a$export$2f2529470fc43ad6;

});

parcelRegister("804Ue", function(module, exports) {

var $lFugL = parcelRequire("lFugL");


var $cozmU = parcelRequire("cozmU");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $cozmU.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $cozmU.useRef)(null);
    const missedEventQueryTimeout = (0, $cozmU.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $cozmU.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $cozmU.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        // this is required for page navigation using the page tree
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $cozmU.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        if (latestVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            if ((0, $6mKj3.expValEquals)('confluence_fe_correct_document_needs_update', 'isEnabled', true)) // Set documentNeedsUpdate to true only if all of the following are true:
            // 1. pageMode is VIEW
            // 2. currentDocumentVersion is set to a valid version number
            // 3. latestVersion is different from currentDocumentVersion
            // Otherwise, set documentNeedsUpdate to false.
            setDocumentNeedsUpdate(pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion > 0 && latestVersion !== currentDocumentVersion);
            else setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate,
        pageMode
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $lFugL.default),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
                __callerPackage__: "comments-pubsub"
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = comment.comment?.author?.accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
            (0, $9wGTI.fg)('cc_fps_migration_comments') && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $cozmU.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $cozmU.useEffect)(()=>{
        if (// oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('cc_fps_migration_comments') && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('cc_fps_migration_comments') && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $cozmU.useEffect)(()=>{
        if (// oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('cc_fps_migration_comments') && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("lFugL", function(module, exports) {
/**
 * @generated SignedSource<<ec37448e00124aacfed3c0e6870df73b>>
 * @relayHash 7477557bbdcb7cd2b6d07a81a3bcb66a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559
const $f560d9e78fe64cde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "since"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "since",
            "variableName": "since"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "time"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "KnownUser"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "UnknownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7477557bbdcb7cd2b6d07a81a3bcb66a",
            "id": "b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559",
            "metadata": {},
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "operationKind": "query",
            "text": "query MissedPubSubCommentEventsHandlerQuery($contentId:Long!,$since:Long!){quickReload(pageId:$contentId,since:$since){time,comments{comment{id,location{__typename,type},author{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}"
        }
    };
}();
$f560d9e78fe64cde$var$node.hash = "7c3b6fa82a316ebe81a0bcd5cab2114e";
var $f560d9e78fe64cde$export$2e2bcd8739ae039 = $f560d9e78fe64cde$var$node;
module.exports["default"] = $f560d9e78fe64cde$export$2e2bcd8739ae039;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "page-info"
    });
    return (0, $cozmU.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<a52aa17c9371e87ad68639adf48d413b>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("hi2PR", function(module, exports) {
/* eslint-disable import/no-duplicates */ 
var $fJCU9 = parcelRequire("fJCU9");


var $epbW8 = parcelRequire("epbW8");


var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");


var $gczDe = parcelRequire("gczDe");


var $aMfLn = parcelRequire("aMfLn");


var $hfNnW = parcelRequire("hfNnW");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $lb2Lp = parcelRequire("lb2Lp");


var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");


var $cD1qu = parcelRequire("cD1qu");


var $3BPrE = parcelRequire("3BPrE");


var $b11gn = parcelRequire("b11gn");

const $039e5ede5bcb8619$var$sendFailedPubsubEvent = ({ createAnalyticsEvent: createAnalyticsEvent, publishVersionNumber: publishVersionNumber, publishedDocumentVersion: publishedDocumentVersion })=>{
    if (createAnalyticsEvent && publishVersionNumber && publishedDocumentVersion) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'rendererInlineCommentsPubSub',
            action: 'failed',
            actionSubject: 'createPubSubEvent',
            actionSubjectId: 'rendererInlineComments',
            attributes: {
                stepVersion: publishVersionNumber,
                documentVersion: publishedDocumentVersion
            }
        }
    }).fire();
};
const $039e5ede5bcb8619$var$isEventCommentThreadOpen = (markerRef)=>{
    if (!markerRef) return false;
    if (typeof document !== 'undefined') {
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        // Figure out if the reply's parent markerRef is open
        // HACK: Is there a way to do this without query selectors?
        return focusedMarkerRef && focusedMarkerRef.id === markerRef;
    }
    return false;
};
const $039e5ede5bcb8619$export$4197a8a52311d1d2 = ({ inlineCommentRequestBody: inlineCommentRequestBody, rendererActions: rendererActions, updateDocument: updateDocument, needsContentUpdate: needsContentUpdate, setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent })=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'rendererInlineCommentsPubSub',
            action: 'received',
            actionSubject: 'createPubSubEvent',
            actionSubjectId: 'rendererInlineComments'
        }
    }).fire();
    const { markerRef: markerRef, step: step, publishVersionNumber: publishVersionNumber } = inlineCommentRequestBody;
    // If the users content is out of date or different, the steps from this pubsub event will be wrong
    // The new comment flag shown by VQR will be triggered to refetch the content
    if (step && publishVersionNumber === publishedDocumentVersion && !needsContentUpdate) {
        const { to: to, from: from, pos: pos, mark: { attrs: { annotationType: annotationType } } } = step;
        const position = pos !== undefined && pos !== null ? {
            to: pos,
            from: pos
        } : {
            to: to,
            from: from
        };
        const annotation = {
            annotationId: markerRef,
            annotationType: annotationType
        };
        const result = rendererActions?.applyAnnotation(position, annotation);
        if (result) updateDocument && updateDocument(result.doc);
    } else {
        if (!needsContentUpdate) setContentNeedsUpdate && setContentNeedsUpdate(true);
        // If we can't apply the step, send an event
        $039e5ede5bcb8619$var$sendFailedPubsubEvent({
            createAnalyticsEvent: createAnalyticsEvent,
            publishVersionNumber: publishVersionNumber,
            publishedDocumentVersion: publishedDocumentVersion
        });
    }
};
const $039e5ede5bcb8619$export$14eb0441cdcaaa35 = ({ inlineCommentRequestBody: inlineCommentRequestBody, rendererActions: rendererActions, updateDocument: updateDocument, eventEmitter: eventEmitter })=>{
    const { markerRef: markerRef } = inlineCommentRequestBody;
    if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef)) eventEmitter?.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
    const deleteResult = rendererActions?.deleteAnnotation(markerRef, (0, $epbW8.AnnotationTypes).INLINE_COMMENT);
    if (deleteResult) updateDocument && updateDocument(deleteResult.doc);
};
let $039e5ede5bcb8619$var$pagePublicationEventParams = {};
const $039e5ede5bcb8619$var$setPagePublicationEventParams = (params)=>{
    $039e5ede5bcb8619$var$pagePublicationEventParams = params;
};
const $039e5ede5bcb8619$var$onPagePublicationEvent = async (event, payload)=>{
    let confVersion;
    let trigger;
    // oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        confVersion = payload.pageUpdated.confVersion;
        trigger = payload.pageUpdated.trigger;
    } else {
        confVersion = payload.pageUpdatedRequestBody.confVersion;
        trigger = payload.pageUpdatedRequestBody.trigger;
    }
    const { setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, setPublishedDocumentVersion: setPublishedDocumentVersion } = $039e5ede5bcb8619$var$pagePublicationEventParams;
    // need to modify this for subscriptions since the event wont have avi/know content type this way
    // myabe the type in the page updated response will be what we want
    // if pageupdated trigger is publish
    if ((event === (0, $3BPrE.PagePubSubEvents).PagePublished || event === (0, $3BPrE.PagePubSubEvents).BlogPublished || event === (0, $3BPrE.PageSubscriptionEvents).PageUpdated && trigger === 'publish') && publishedDocumentVersion !== confVersion) {
        // TODO: Eventually we want to read the values passed to us to see if this is positional breaking
        setContentNeedsUpdate && setContentNeedsUpdate(true);
        if ((0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setPublishedDocumentVersion && setPublishedDocumentVersion(confVersion);
    }
};
let $039e5ede5bcb8619$var$commentPublicationEventParams = {};
const $039e5ede5bcb8619$export$11d6bf62aa2fcbf9 = (params)=>{
    $039e5ede5bcb8619$var$commentPublicationEventParams = params;
};
const $039e5ede5bcb8619$export$8579923c4bc2600 = async (event, payload)=>{
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const { accountId: accountId, originTabId: originTabId } = payload;
    let inlineCommentRequestBody;
    // oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) inlineCommentRequestBody = payload?.[event];
    else inlineCommentRequestBody = payload.inlineCommentRequestBody;
    const { inlineCommentType: inlineCommentType, markerRef: markerRef, commentId: commentId } = inlineCommentRequestBody || {};
    const isReply = inlineCommentType === 'REPLY';
    const { contentId: contentId, currentUserId: currentUserId, rendererActions: rendererActions, updateDocument: updateDocument, updateUnresolvedInlineComment: updateUnresolvedInlineComment, needsContentUpdate: needsContentUpdate, setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, setActiveHighlight: setActiveHighlight, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = $039e5ede5bcb8619$var$commentPublicationEventParams;
    if ((0, $hfNnW.shouldSkipOwnPubSubEvent)({
        accountId: accountId,
        currentUserId: currentUserId,
        originTabId: originTabId
    })) return;
    const { start: startCommentsPubSubExperience, fail: failCommentsPubSubExperience, handleCompletePubSubExperiences: handleCompletePubSubExperiences } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).RendererInlineCommentsPubSub, commentId);
    startCommentsPubSubExperience(event);
    try {
        // These promises were previously dispatched as fire-and-forget (`void`).
        // Arguably they should be awaited, but until they are, we keep track of
        // their failures by collecting them here and handing them to
        // handleCompletePubSubExperiences() at the end, so any rejection becomes a `fail` on the
        // experience and a successful resolution becomes a `succeed`. Entries carrying a comment
        // are also validated against the event that refetched them.
        const trackedEvents = [];
        switch(event){
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUnresolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUnresolved:
                if (event) {
                    if (commentId && contentId) {
                        // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        trackedEvents.push({
                            comment: comment,
                            type: (0, $b11gn.CommentsPubsubTrackedEventType).Reopen
                        });
                        // Synchronously process the updated comment data cache to get it added to the open
                        // comments array. If we don't manually do this now, the updated cache isn't processed
                        // until the next render cycle when useAllCommentsDataQuery updates, which is too late
                        // for the updateRendererAnnotations() call below. If the comment is not in the open
                        // array at that time, the annotation is not added to the orderedActiveAnnotationIdList
                        // and the reopened comment then appears to be attached to deleted content.
                        const updatedCachedData = (0, $NYiei.getCommentsDataFromCache)(contentId);
                        (0, $4L9ve.getProcessedCommentsDataActions)().processCommentsData({
                            data: updatedCachedData,
                            pageMode: (0, $cD1qu.PageMode).VIEW
                        });
                    }
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (markerRef && reopenParentComment) reopenParentComment({
                        threadKey: markerRef,
                        commentType: (0, $kgNLQ.CommentType).INLINE,
                        parentCommentId: commentId
                    });
                }
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [markerRef]: {
                        id: markerRef,
                        annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $epbW8.AnnotationMarkStates).ACTIVE
                    }
                });
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentResolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentResolved:
                // If the thread is open, close it and clear highlight
                if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef)) {
                    eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                    if ((0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setActiveHighlight?.(null);
                }
                // Remove the resolved comment from the navigation list
                if (setOrderedActiveAnnotationIdList && orderedActiveAnnotationIdList && (0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== markerRef));
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [markerRef]: {
                        id: markerRef,
                        annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $epbW8.AnnotationMarkStates).RESOLVED
                    }
                });
                if (commentId && contentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                trackedEvents.push({
                    comment: (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    }),
                    type: (0, $b11gn.CommentsPubsubTrackedEventType).Resolve
                });
                const { inlineResolveProperties: inlineResolveProperties, inlineText: inlineText } = inlineCommentRequestBody;
                updateRemovedCommentIdsMap && inlineResolveProperties && inlineText && updateRemovedCommentIdsMap({
                    threadKey: markerRef,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                    isReply: isReply,
                    commentType: (0, $kgNLQ.CommentType).INLINE,
                    resolvedProperties: {
                        inlineResolveProperties: inlineResolveProperties,
                        inlineText: inlineText
                    }
                });
                const { replies: replies = [] } = inlineCommentRequestBody;
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId,
                    ...replies
                ]), 'remove');
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).RendererInlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).RendererInlineCommentCreated:
                if (inlineCommentType === 'TOP_LEVEL') {
                    if (addCommentInCache && commentId && contentId) {
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        if (comment) addCommentInCache({
                            newComment: comment,
                            onError: failCommentsPubSubExperience
                        });
                        // This needs to happen AFTER the cache update. applyStepAndAddCommentToDoc triggers the doc to re-render, which triggers getRendererAnnotationStates
                        // getRendererAnnotationStates pulls data from the cache to determine which annotations to show
                        // In the legacy version this wasn't a problem, since it does a full network call
                        $039e5ede5bcb8619$export$4197a8a52311d1d2({
                            inlineCommentRequestBody: inlineCommentRequestBody,
                            rendererActions: rendererActions,
                            updateDocument: updateDocument,
                            needsContentUpdate: needsContentUpdate,
                            setContentNeedsUpdate: setContentNeedsUpdate,
                            publishedDocumentVersion: publishedDocumentVersion,
                            createAnalyticsEvent: createAnalyticsEvent
                        });
                    }
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                } else if (isReply) {
                    if (addCommentInCache && commentId && contentId) {
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        if (comment) addCommentInCache({
                            newComment: comment,
                            onError: failCommentsPubSubExperience
                        });
                    }
                    if (updateUnreadCommentIDSet && accountId !== currentUserId) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                }
                break;
            // just for replies
            case (0, $3BPrE.InlineCommentSubscriptionEvents).EditorInlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).EditorInlineCommentCreated:
                if (isReply) {
                    if (addCommentInCache && commentId && contentId) {
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        if (comment) addCommentInCache({
                            newComment: comment,
                            onError: failCommentsPubSubExperience
                        });
                    }
                    if (typeof document !== 'undefined') {
                        // Check if the annotation exists in the renderer DOM before updating unread comments
                        const annotationElement = document.getElementById(markerRef);
                        if (annotationElement && updateUnreadCommentIDSet && accountId !== currentUserId) updateUnreadCommentIDSet(new Set([
                            commentId
                        ]), 'add');
                    }
                }
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted:
                // Always handle annotation logic
                if (inlineCommentType === 'TOP_LEVEL') $039e5ede5bcb8619$export$14eb0441cdcaaa35({
                    inlineCommentRequestBody: inlineCommentRequestBody,
                    rendererActions: rendererActions,
                    updateDocument: updateDocument,
                    eventEmitter: eventEmitter
                });
                if (deleteCommentInCache && commentId) deleteCommentInCache({
                    commentId: commentId,
                    onError: failCommentsPubSubExperience
                });
                // both a parent comment and reply can be deleted
                updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
                    threadKey: markerRef,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    isReply: isReply,
                    commentType: (0, $kgNLQ.CommentType).INLINE
                });
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId
                ]), 'remove');
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentReattached:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentReattached:
                $039e5ede5bcb8619$export$4197a8a52311d1d2({
                    inlineCommentRequestBody: inlineCommentRequestBody,
                    rendererActions: rendererActions,
                    updateDocument: updateDocument,
                    needsContentUpdate: needsContentUpdate,
                    setContentNeedsUpdate: setContentNeedsUpdate,
                    publishedDocumentVersion: publishedDocumentVersion,
                    createAnalyticsEvent: createAnalyticsEvent
                });
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUpdated:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUpdated:
                // If the initial comment thread is open, refresh it
                if (commentId && contentId) {
                    const previousVersionNumber = (0, $b11gn.getCachedCommentVersionNumber)(commentId);
                    // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    trackedEvents.push({
                        comment: (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }),
                        type: (0, $b11gn.CommentsPubsubTrackedEventType).Edit,
                        previousVersionNumber: previousVersionNumber
                    });
                }
                break;
            default:
                failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event}`));
                break;
        }
        // oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
            if (inlineCommentType !== 'REPLY' && !needsContentUpdate && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).RendererInlineCommentCreated && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentReattached && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted) {
                if (rendererActions && contentId && updateUnresolvedInlineComment) trackedEvents.push((0, $aMfLn.updateRendererAnnotations)({
                    rendererActions: rendererActions,
                    contentId: contentId,
                    updateUnresolvedInlineComment: updateUnresolvedInlineComment
                }));
            }
        } else {
            // Always update if we've handled the event
            if (inlineCommentType !== 'REPLY' && !needsContentUpdate && event !== (0, $3BPrE.InlineCommentPubSubEvents).RendererInlineCommentCreated && event !== (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentReattached && event !== (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted) {
                if (rendererActions && contentId && updateUnresolvedInlineComment) trackedEvents.push((0, $aMfLn.updateRendererAnnotations)({
                    rendererActions: rendererActions,
                    contentId: contentId,
                    updateUnresolvedInlineComment: updateUnresolvedInlineComment
                }));
            }
        }
        await handleCompletePubSubExperiences(trackedEvents);
    } catch (error) {
        failCommentsPubSubExperience(error);
        throw error;
    }
};
function $039e5ede5bcb8619$export$9ac99a17b366f8ef({ contentId: contentId, currentUserId: currentUserId, contentType: contentType, rendererActions: rendererActions, updateDocument: updateDocument, updateUnresolvedInlineComment: updateUnresolvedInlineComment, setContentNeedsUpdate: setContentNeedsUpdate, needsContentUpdate: needsContentUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, addSubscriber: addSubscriber, setContentId: setContentId, setContentType: setContentType, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, setActiveHighlight: setActiveHighlight, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }) {
    const pubSubResourceType = contentType || 'page';
    $039e5ede5bcb8619$export$11d6bf62aa2fcbf9({
        contentId: contentId,
        currentUserId: currentUserId,
        rendererActions: rendererActions,
        updateDocument: updateDocument,
        updateUnresolvedInlineComment: updateUnresolvedInlineComment,
        needsContentUpdate: needsContentUpdate,
        setContentNeedsUpdate: setContentNeedsUpdate,
        publishedDocumentVersion: publishedDocumentVersion,
        createAnalyticsEvent: createAnalyticsEvent,
        updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
        reopenParentComment: reopenParentComment,
        updateUnreadCommentIDSet: updateUnreadCommentIDSet,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache,
        setActiveHighlight: setActiveHighlight,
        setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList
    });
    $039e5ede5bcb8619$var$setPagePublicationEventParams({
        currentUserId: currentUserId,
        setContentNeedsUpdate: setContentNeedsUpdate,
        publishedDocumentVersion: publishedDocumentVersion,
        setPublishedDocumentVersion: setPublishedDocumentVersion
    });
    // oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentId || !setContentType) return;
        const subscriptions = [];
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentResolved',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentResolved'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentUnresolved',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentUnresolved'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubRendererInlineCommentCreated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'rendererInlineCommentCreated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubEditorInlineCommentCreated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'editorInlineCommentCreated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentDeleted',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentDeleted'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentReattached',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentReattached'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentUpdated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentUpdated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubPageUpdated',
                onSubscriptionData: $039e5ede5bcb8619$var$onPagePublicationEvent,
                delta: 'pageUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriptions.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriptions;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('created:renderer_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('reattach:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('publish:page'), $039e5ede5bcb8619$var$onPagePublicationEvent);
            client.subscribe((0, $7S9uM.eventToAvi)('publish:blogpost'), $039e5ede5bcb8619$var$onPagePublicationEvent);
        }).catch((error)=>{
            throw new Error(`PubSub Web Client joinChannel ${JSON.stringify(error)}`);
        });
    });
}
function $039e5ede5bcb8619$export$d3539dc2c41bd511({ contentId: contentId, contentType: contentType, subscriptions: subscriptions, removeSubscriber: removeSubscriber }) {
    const pubSubResourceType = contentType || 'page';
    // oxlint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) for (const subscriber of subscriptions)removeSubscriber?.(subscriber);
    else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:renderer_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('reattach:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('publish:page'), $039e5ede5bcb8619$var$onPagePublicationEvent);
        client.unsubscribe((0, $7S9uM.eventToAvi)('publish:blogpost'), $039e5ede5bcb8619$var$onPagePublicationEvent);
    });
}
module.exports["setUpRendererInlineCommentsPubSub"] = $039e5ede5bcb8619$export$9ac99a17b366f8ef;
module.exports["removeRendererInlineCommentsPubSub"] = $039e5ede5bcb8619$export$d3539dc2c41bd511;

});

parcelRegister("aMfLn", function(module, exports) {

var $eOaGc = parcelRequire("eOaGc");


var $kDIns = parcelRequire("kDIns");

const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};
module.exports["updateRendererAnnotations"] = $194c389c7ab5ab2c$export$bbbd7ccaedea9691;
module.exports["constructStepForGql"] = $194c389c7ab5ab2c$export$2600439b3e609c06;

});

parcelRegister("kDIns", function(module, exports) {

var $kmYOg = parcelRequire("kmYOg");


var $dOBRD = parcelRequire("dOBRD");


var $3u5lg = parcelRequire("3u5lg");


var $epbW8 = parcelRequire("epbW8");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $7W8i8 = parcelRequire("7W8i8");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $cD1qu = parcelRequire("cD1qu");


var $c0rhi = parcelRequire("c0rhi");

const $655a1f23a26f4e27$export$c53aa0aa4a7c5e4 = (0, $kmYOg.default);
const $655a1f23a26f4e27$export$7037a4d88a618a89 = (contentId, pageMode)=>({
        pageId: contentId,
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        first: (0, $NYiei.MAX_COMMENTS_TO_RETURN)
    });
const $655a1f23a26f4e27$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:state-resolver');
const $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData = async ({ contentId: contentId, pageMode: pageMode })=>{
    if (!contentId) return [];
    // Check if processed comments data is available
    const processedData = (0, $4L9ve.getProcessedCommentsDataState)();
    // If data is processed, use it directly
    if (processedData.isDataProcessed) return processedData.openInlineComments;
    // Data not processed yet - fetch fresh data directly with network-only
    // This is simpler (albeit slightly slower) than preloading and guarantees fresh data
    // If we do preload in the future - keep in mind that we have to satisfy the following use cases
    // 1. We load in SSR and preload fails --> no cache data
    // 2. We load in SPA and preload hasn't completed before we check the cache value
    // 3. We load in SPA and have a stale value in the cache
    // If preloading you can also show stale data initially and refresh by manually updating annotations states
    // However if you do this, be careful for integrations w/ focused comments
    try {
        const result = await (0, $c0rhi.queryInterop)({
            query: $655a1f23a26f4e27$export$c53aa0aa4a7c5e4,
            variables: $655a1f23a26f4e27$export$7037a4d88a618a89(contentId, pageMode),
            fetchPolicy: 'network-only',
            __callerPackage__: "comments-util"
        });
        return result?.data?.comments?.nodes?.filter((node)=>Boolean(node?.location)) || [];
    } catch  {
        return [];
    }
};
const $655a1f23a26f4e27$export$8f0e4480674935ab = (0, $dOBRD.default)((annotations, validAnnotationsCallback, states, reactionMarkerRefs, optimisticResolvedMarkerRefs)=>{
    const rendererAnnotationMap = {};
    const annotationState = [];
    const optimisticResolvedMarkerRefSet = new Set(optimisticResolvedMarkerRefs);
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Renderer
        rendererAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: (0, $epbW8.AnnotationMarkStates).RESOLVED
        });
    });
    states?.forEach((state)=>{
        const annotationId = state.location.inlineMarkerRef;
        const isResolved = Boolean(state.location?.inlineResolveProperties?.resolved) || (annotationId ? optimisticResolvedMarkerRefSet.has(annotationId) : false);
        // mark all unresolved annotations to be displayed by the renderer
        if (!isResolved) {
            if (annotationId) {
                const index = rendererAnnotationMap[annotationId];
                /**
         * If the BE returns an annotation that the Renderer did not
         * provide, we could error here. Also account for 0 index.
         */ if (index || index === 0) annotationState[index].state = (0, $epbW8.AnnotationMarkStates).ACTIVE;
            }
        }
    });
    // Mark inline reaction annotations as ACTIVE so they render as highlights
    reactionMarkerRefs?.forEach((markerRef)=>{
        const index = rendererAnnotationMap[markerRef];
        if ((index || index === 0) && !optimisticResolvedMarkerRefSet.has(markerRef)) annotationState[index].state = (0, $epbW8.AnnotationMarkStates).ACTIVE;
    });
    const validAnnotations = annotations.filter((annotation)=>{
        const index = rendererAnnotationMap[annotation];
        return annotationState[index].state === (0, $epbW8.AnnotationMarkStates).ACTIVE;
    });
    // Record the valid annotations to use for navigation and query params
    validAnnotationsCallback(validAnnotations);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $655a1f23a26f4e27$export$228a0d958905d789 = (0, $dOBRD.default)((annotations, states, updateUnresolvedInlineComment, optimisticResolvedMarkerRefs)=>{
    /**
   * Build a map of annotation states with a default of true for resolved.
   * This is to accommodate deleted annotations that still exist in the ADF.
   */ const editorAnnotationMap = {};
    const annotationState = [];
    const optimisticResolvedMarkerRefSet = new Set(optimisticResolvedMarkerRefs);
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Editor
        editorAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: {
                resolved: true
            }
        });
    });
    states.forEach((state)=>{
        const annotationId = state?.location?.inlineMarkerRef || '';
        const isResolved = Boolean(state?.location?.inlineResolveProperties?.resolved) || (annotationId ? optimisticResolvedMarkerRefSet.has(annotationId) : false);
        // mark all unresolved annotations to be displayed by the editor
        if (!isResolved) {
            const index = editorAnnotationMap[annotationId];
            /**
       * If the BE returns an annotation that the Editor did not
       * provide, we could error here. Also account for 0 index.
       */ if (index || index === 0) annotationState[index].state.resolved = false;
        }
    });
    //Ordered list of unresolved inline comments
    const unresolvedInlineComments = annotations.filter((annotationId)=>{
        const index = editorAnnotationMap[annotationId];
        if (!annotationState[index].state.resolved) return annotationId;
    });
    updateUnresolvedInlineComment(unresolvedInlineComments);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $655a1f23a26f4e27$export$38c1ce6adefc79a5 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs })=>{
    if (!annotations.length) {
        updateUnresolvedInlineComment([]);
        return Promise.resolve([]);
    }
    try {
        // Use preload-aware annotations data utility
        const annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).LIVE // same as PageMode.EDIT for our case
        });
        // Common logic: map annotation state nodes to editor states
        return $655a1f23a26f4e27$export$228a0d958905d789(annotations, annotationStateNodes, updateUnresolvedInlineComment, optimisticResolvedMarkerRefs);
    } catch (error) {
        // COMMENTS-211 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                data: {
                    source: 'editorComponent',
                    action: 'failed',
                    actionSubject: 'annotationState',
                    actionSubjectId: 'inlineComments',
                    attributes: {
                        errorName: error.name,
                        errorMessage: error.message
                    }
                },
                type: 'sendOperationalEvent'
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
let $655a1f23a26f4e27$var$rendererAnnotationsIds;
const $655a1f23a26f4e27$export$a0fcca613dd8b2c7 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, validAnnotationsCallback: validAnnotationsCallback, isNestedRender: isNestedRender, reactionMarkerRefs: reactionMarkerRefs, optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs })=>{
    // We need to have the page level renderer annotations
    // When the page renders the value of isNestedRender is false as per PageContentRendererFabrics
    // Later, when the macro renders isNestedRender is true
    // so, we will hold the value of annotations for the page renderer when isNestedRender is false
    if (!annotations.length) {
        validAnnotationsCallback([]);
        return Promise.resolve([]);
    }
    if (!isNestedRender) $655a1f23a26f4e27$var$rendererAnnotationsIds = annotations;
    try {
        // Use preload-aware annotations data utility
        const annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).VIEW
        });
        // Common logic: map annotation state nodes to renderer states
        return $655a1f23a26f4e27$export$8f0e4480674935ab($655a1f23a26f4e27$var$rendererAnnotationsIds, validAnnotationsCallback, annotationStateNodes, reactionMarkerRefs, optimisticResolvedMarkerRefs);
    } catch (error) {
        // COMMENTS-1131 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                source: 'rendererComponent',
                action: 'failed',
                actionSubject: 'annotationState',
                actionSubjectId: 'inlineComments',
                attributes: {
                    errorName: error.name,
                    errorMessage: error.message
                }
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
module.exports["getEditorResolvedState"] = $655a1f23a26f4e27$export$38c1ce6adefc79a5;
module.exports["getRendererAnnotationStates"] = $655a1f23a26f4e27$export$a0fcca613dd8b2c7;

});

parcelRegister("kmYOg", function(module, exports) {
/**
 * @generated SignedSource<<8fc743fa44c5cd210e605b4e8ce0cf28>>
 * @relayHash d689c46cc95f36419f19f207f3ceb687
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f
const $f5022931ec1c887f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "INLINE"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "INLINE"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "inlineMarkerRef"
                                        },
                                        {
                                            "concreteType": "InlineCommentResolveProperties",
                                            "kind": "LinkedField",
                                            "name": "inlineResolveProperties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "resolved"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "InlineComment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v3 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "d689c46cc95f36419f19f207f3ceb687",
            "id": "da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f",
            "metadata": {},
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "operationKind": "query",
            "text": "query stateResolverPreloadAnnotationsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:INLINE},type:[INLINE],depth:ROOT,first:$first){nodes{id,contentStatus,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}},totalCount,__typename}}"
        }
    };
}();
$f5022931ec1c887f$var$node.hash = "af92d028ec6cef46bb981d53522dfe18";
var $f5022931ec1c887f$export$2e2bcd8739ae039 = $f5022931ec1c887f$var$node;
module.exports["default"] = $f5022931ec1c887f$export$2e2bcd8739ae039;

});

parcelRegister("hfNnW", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $3ZKFP = parcelRequire("3ZKFP");

const $8c6826fc16df1cbc$export$e314db58fea1ec32 = ({ accountId: accountId = null, currentUserId: currentUserId = null, originTabId: originTabId = null })=>{
    if ((0, $6mKj3.expVal)('cc_use_browser_tab_id', 'isEnabled', false)) return originTabId === (0, $3ZKFP.getBrowserTabId)();
    return !!accountId && accountId === currentUserId;
};
module.exports["shouldSkipOwnPubSubEvent"] = $8c6826fc16df1cbc$export$e314db58fea1ec32;

});

parcelRegister("3BPrE", function(module, exports) {
var $e3661bd3089bf51c$export$7309710dd8a888d9 = /*#__PURE__*/ function(InlineCommentPubSubEvents) {
    InlineCommentPubSubEvents["InlineCommentCreated"] = "avi:confluence:created:inline_comment";
    InlineCommentPubSubEvents["RendererInlineCommentCreated"] = "avi:confluence:created:renderer_inline_comment";
    InlineCommentPubSubEvents["EditorInlineCommentCreated"] = "avi:confluence:created:editor_inline_comment";
    InlineCommentPubSubEvents["InlineCommentDeleted"] = "avi:confluence:deleted:inline_comment";
    InlineCommentPubSubEvents["InlineCommentResolved"] = "avi:confluence:resolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUnresolved"] = "avi:confluence:unresolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUpdated"] = "avi:confluence:updated:inline_comment";
    InlineCommentPubSubEvents["InlineCommentReattached"] = "avi:confluence:reattach:inline_comment";
    return InlineCommentPubSubEvents;
}({});
var $e3661bd3089bf51c$export$d05a35896d8f557d = /*#__PURE__*/ function(InlineCommentSubscriptionEvents) {
    InlineCommentSubscriptionEvents["InlineCommentCreated"] = "inlineCommentCreated";
    InlineCommentSubscriptionEvents["RendererInlineCommentCreated"] = "rendererInlineCommentCreated";
    InlineCommentSubscriptionEvents["EditorInlineCommentCreated"] = "editorInlineCommentCreated";
    InlineCommentSubscriptionEvents["InlineCommentDeleted"] = "inlineCommentDeleted";
    InlineCommentSubscriptionEvents["InlineCommentResolved"] = "inlineCommentResolved";
    InlineCommentSubscriptionEvents["InlineCommentUnresolved"] = "inlineCommentUnresolved";
    InlineCommentSubscriptionEvents["InlineCommentUpdated"] = "inlineCommentUpdated";
    InlineCommentSubscriptionEvents["InlineCommentReattached"] = "inlineCommentReattached";
    return InlineCommentSubscriptionEvents;
}({});
var $e3661bd3089bf51c$export$5d941a2346cc8f6a = /*#__PURE__*/ function(PagePubSubEvents) {
    PagePubSubEvents["PagePublished"] = "avi:confluence:publish:page";
    PagePubSubEvents["BlogPublished"] = "avi:confluence:publish:blogpost";
    return PagePubSubEvents;
}({});
var $e3661bd3089bf51c$export$15c104b3df413bde = /*#__PURE__*/ function(PageSubscriptionEvents) {
    PageSubscriptionEvents["PageUpdated"] = "pageUpdated";
    return PageSubscriptionEvents;
}({});
module.exports["InlineCommentPubSubEvents"] = $e3661bd3089bf51c$export$7309710dd8a888d9;
module.exports["InlineCommentSubscriptionEvents"] = $e3661bd3089bf51c$export$d05a35896d8f557d;
module.exports["PagePubSubEvents"] = $e3661bd3089bf51c$export$5d941a2346cc8f6a;
module.exports["PageSubscriptionEvents"] = $e3661bd3089bf51c$export$15c104b3df413bde;

});

parcelRegister("b11gn", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");

var $c84c3a6392bd7f68$export$4dc7cc9100b67c07 = /*#__PURE__*/ function(CommentsPubSubSource) {
    CommentsPubSubSource["EditorInlineCommentsPubSub"] = "editorInlineCommentsPubSub";
    CommentsPubSubSource["RendererInlineCommentsPubSub"] = "rendererInlineCommentsPubSub";
    CommentsPubSubSource["PageCommentsPubSub"] = "pageCommentsPubSub";
    return CommentsPubSubSource;
}({});
var $c84c3a6392bd7f68$export$6c1f9a49b2d5ac05 = /*#__PURE__*/ function(CommentsPubsubTrackedEventType) {
    CommentsPubsubTrackedEventType["Resolve"] = "resolve";
    CommentsPubsubTrackedEventType["Reopen"] = "reopen";
    CommentsPubsubTrackedEventType["Edit"] = "edit";
    return CommentsPubsubTrackedEventType;
}({});
/**
 * A commentResolved / InlineCommentResolved event promises the refetched comment is resolved.
 * If a network-only refetch still shows it unresolved, the read raced ahead of replication and
 * the success can't be verified.
 */ const $c84c3a6392bd7f68$var$getStaleResolveError = (comment)=>comment && (0, $kgNLQ.isCommentResolved)(comment) ? undefined : new Error('commentResolved: stale read');
/**
 * A commentReopened / InlineCommentUnresolved event promises the refetched comment is
 * unresolved. Same staleness risk as resolve, in the other direction.
 */ const $c84c3a6392bd7f68$var$getStaleReopenError = (comment)=>comment && !(0, $kgNLQ.isCommentResolved)(comment) ? undefined : new Error('commentReopened: stale read');
/**
 * A commentUpdated / InlineCommentUpdated event carries no version number of its own (neither
 * the AVI nor the AGG payload includes one), so the only way to catch a stale (pre-edit) read is
 * comparing the refetched version against the version we had cached before the refetch was
 * issued (see getCachedCommentVersionNumber).
 */ const $c84c3a6392bd7f68$var$getStaleEditError = (comment, previousVersionNumber)=>{
    const currentVersionNumber = comment?.version?.number ?? null;
    return previousVersionNumber != null && currentVersionNumber != null && currentVersionNumber <= previousVersionNumber ? new Error('commentUpdated: stale read') : undefined;
};
const $c84c3a6392bd7f68$var$getStaleCommentError = (type, comment, previousVersionNumber)=>{
    switch(type){
        case "resolve":
            return $c84c3a6392bd7f68$var$getStaleResolveError(comment);
        case "reopen":
            return $c84c3a6392bd7f68$var$getStaleReopenError(comment);
        case "edit":
            return $c84c3a6392bd7f68$var$getStaleEditError(comment, previousVersionNumber);
        default:
            return undefined;
    }
};
const $c84c3a6392bd7f68$export$c83a826d1956bd57 = (source, commentId)=>{
    // Unique per event invocation; lets us detect concurrent-event collisions
    // by matching initialTrackingId === terminalTrackingId in logs.
    let trackingId;
    const fail = (err)=>{
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
            error: err instanceof Error ? err : new Error(String(err)),
            attributes: {
                terminalTrackingId: trackingId
            }
        });
    };
    return {
        start: (event)=>{
            // IMPORTANT - because this is in a factory method, it is deliberate that mixing
            // & matching starts / failures / successes across invocations will lead to different trackingIDs.
            // If you need to refactor this to be cross-file, or cross-function for a valid case,
            // you'll probably need to lift this out of the factory
            trackingId = crypto.randomUUID();
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                // 15s — above the AGG client's ~10s network timeout.
                timeout: 15000,
                attributes: {
                    event: event,
                    source: source,
                    initialTrackingId: trackingId,
                    commentId: commentId
                }
            });
        },
        fail: fail,
        handleCompletePubSubExperiences: async (eventsToValidate = [])=>{
            // Rejections deliberately propagate rather than being reported here - a failing
            // fetchCommentById is handled by the caller's existing catch, which fails the
            // experience and rethrows.
            const staleErrors = await Promise.all(eventsToValidate.map(async (trackedEvent)=>{
                // Each entry is either a plain Promise<void> or a TrackedCommentEvent - never
                // both - so only one of these two awaits is ever doing real work. Awaiting a
                // plain promise resolves to undefined and short-circuits below. Awaiting a
                // TrackedCommentEvent (not itself a promise) resolves immediately to itself;
                // its `comment` field is what actually gets awaited next.
                const event = await trackedEvent;
                if (!event) return undefined;
                return $c84c3a6392bd7f68$var$getStaleCommentError(event.type, await event.comment, event.previousVersionNumber);
            }));
            const staleError = staleErrors.find((error)=>error);
            if (staleError) {
                fail(staleError);
                return;
            }
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                attributes: {
                    terminalTrackingId: trackingId
                }
            });
        }
    };
};
const $c84c3a6392bd7f68$export$bfad633ca9511e62 = (commentId)=>(0, $4L9ve.getProcessedCommentsDataState)().flatCommentsMap[commentId]?.version?.number ?? null;
module.exports["CommentsPubSubSource"] = $c84c3a6392bd7f68$export$4dc7cc9100b67c07;
module.exports["CommentsPubsubTrackedEventType"] = $c84c3a6392bd7f68$export$6c1f9a49b2d5ac05;
module.exports["createCommentsPubSubExperienceTracker"] = $c84c3a6392bd7f68$export$c83a826d1956bd57;
module.exports["getCachedCommentVersionNumber"] = $c84c3a6392bd7f68$export$bfad633ca9511e62;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $cozmU.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $cozmU.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $cozmU.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("k8e76", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $8s9DV.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $kBr4q.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $kBr4q.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $kBr4q.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $5GOpG.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $l0zDh = parcelRequire("l0zDh");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $cozmU.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $cozmU.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $cozmU.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $cozmU.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $cozmU.useState)(false);
    const firstHighlightClicked = (0, $cozmU.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $cozmU.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $cozmU.useState)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $cozmU.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0;
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(nextThreadKey) || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(`footer-comment-thread-${nextThreadKey}-container`);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $l0zDh.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("l0zDh", function(module, exports) {
const $cae4ddecf89022a7$var$prefix = 'pm-alt-text';
const $cae4ddecf89022a7$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$cae4ddecf89022a7$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};
module.exports["ClassNames"] = $cae4ddecf89022a7$export$9b9c0f9d9f3552b8;

});

parcelRegister("fHAwL", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $8s9DV.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $kBr4q.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $kBr4q.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $kBr4q.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $knAY5 = parcelRequire("knAY5");


var $a33Aa = parcelRequire("a33Aa");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $8W4Gr = parcelRequire("8W4Gr");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { metric: metric, onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        // Register the destination for mixed React/imperative consumers without starting BM3.
        const binding = metric ? (0, $8W4Gr.bindPageSegmentToUFO)(metric, prefixedKey) : undefined;
        if (binding) (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`, [], binding.startTime);
        else (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        metric,
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("a3q17", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});
const $60a54f1e533f2ef6$export$fc794218ec0a6fa5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: 'direct-comment-data-flow',
    timings: [
        {
            key: 'commentCreationStart',
            startMark: 'commentCreationStart'
        },
        {
            key: 'commentCreationEnd',
            endMark: 'commentCreationEnd'
        },
        {
            key: 'commentDataLoad',
            startMark: 'commentDataLoadStart',
            endMark: 'commentDataLoadEnd'
        }
    ]
});
module.exports["EDITOR_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$52ff686bd4414bc5;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$ac7f79e65475cee7;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_METRIC"] = $60a54f1e533f2ef6$export$321e1f68b293bf76;
module.exports["DIRECT_COMMENT_DATA_FLOW_METRIC"] = $60a54f1e533f2ef6$export$fc794218ec0a6fa5;

});

parcelRegister("WheoQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b0ecc354fcdb9645$export$23b7aa19be1bc1ad = (callbacks)=>(0, $cozmU.useCallback)((annotationsList)=>{
        callbacks.forEach((callback)=>callback(annotationsList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, callbacks);
module.exports["useUpdateAnnotations"] = $b0ecc354fcdb9645$export$23b7aa19be1bc1ad;

});

parcelRegister("3D6uL", function(module, exports) {

var $3w2O3 = parcelRequire("3w2O3");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $dc4cdd28902d8267$export$6bf92d32985d66db = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $3w2O3.default), {
        fetchPolicy: 'cache-and-network',
        skip: !userId,
        __callerPackage__: "comments-util"
    });
    return (0, $cozmU.useMemo)(()=>{
        // We always want to default to true until we get a result
        let isHighlightOptionPanelEnabled = true;
        if (error) // We always want to handle errors caused from this, just default to existing behavior
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!loading && data?.userPreferences) isHighlightOptionPanelEnabled = data?.userPreferences.highlightOptionPanelEnabled;
        return {
            isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled
        };
    }, [
        data,
        loading,
        error
    ]);
};
module.exports["useIsHighlightOptionPanelEnabled"] = $dc4cdd28902d8267$export$6bf92d32985d66db;

});

parcelRegister("3w2O3", function(module, exports) {
/**
 * @generated SignedSource<<270a8763bde6e8a6b1f015f9a7a2f8e7>>
 * @relayHash 8a0218b2e1c99a56ce8c33454f5c992d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0cf895ac8ba230224c74d275c984b0c91d2ac44dddcf2fde63e3993339c6b240
const $9a2dad19e5d5deeb$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "highlightOptionPanelEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "8a0218b2e1c99a56ce8c33454f5c992d",
            "id": "0cf895ac8ba230224c74d275c984b0c91d2ac44dddcf2fde63e3993339c6b240",
            "metadata": {},
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "operationKind": "query",
            "text": "query useIsHighlightOptionPanelEnabledQuery{userPreferences{highlightOptionPanelEnabled}}"
        }
    };
}();
$9a2dad19e5d5deeb$var$node.hash = "f1838f0592c7a8f202fdc84d54752216";
var $9a2dad19e5d5deeb$export$2e2bcd8739ae039 = $9a2dad19e5d5deeb$var$node;
module.exports["default"] = $9a2dad19e5d5deeb$export$2e2bcd8739ae039;

});

parcelRegister("fFRTr", function(module, exports) {

var $5lLx0 = parcelRequire("5lLx0");


var $1nGEl = parcelRequire("1nGEl");


var $2goVK = parcelRequire("2goVK");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $c0rhi = parcelRequire("c0rhi");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $6UYek = parcelRequire("6UYek");


var $bQm3c = parcelRequire("bQm3c");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $NYiei = parcelRequire("NYiei");


var $lb2Lp = parcelRequire("lb2Lp");


var $4L9ve = parcelRequire("4L9ve");


var $6hmtW = parcelRequire("6hmtW");


var $fHAwL = parcelRequire("fHAwL");


var $cD1qu = parcelRequire("cD1qu");


var $9jl6v = parcelRequire("9jl6v");


var $dklIa = parcelRequire("dklIa");


var $5h5pD = parcelRequire("5h5pD");


var $jU6SV = parcelRequire("jU6SV");

// Three dedicated queries for the pubsub handler. They mirror the queries
// owned by `useReactionsSummary`, `useActiveInlineData`, and `useReactedUsers`
// but are declared here so the handler does not depend on those hooks'
// codegen artefacts. CI's Relay codegen will produce the matching
// `__generated__/...graphql.ts` files on first build.
const $e9ac562e4865c3d2$var$inlineReactionsPubSubHandlerSummaryRefetchQuery = (0, $2goVK.default);
const $e9ac562e4865c3d2$var$inlineReactionsPubSubHandlerActiveDataRefetchQuery = (0, $1nGEl.default);
const $e9ac562e4865c3d2$var$inlineReactionsPubSubHandlerActorQuery = (0, $5lLx0.default);
const $e9ac562e4865c3d2$var$i18n = (0, $kSwu1.defineMessages)({
    newReactionFlagTitle: {
        id: "experiment-inline-reactions.pubsub.new-reaction-flag-title",
        defaultMessage: "New reaction"
    },
    somebodyReactedToPage: {
        id: "experiment-inline-reactions.pubsub.somebody-reacted-to-page",
        defaultMessage: "{somebody} reacted to this page"
    },
    somebodyReactedToBlog: {
        id: "experiment-inline-reactions.pubsub.somebody-reacted-to-blog",
        defaultMessage: "{somebody} reacted to this blog post"
    },
    someoneFallback: {
        id: "experiment-inline-reactions.pubsub.someone-fallback",
        defaultMessage: "Someone"
    }
});
const $e9ac562e4865c3d2$var$InlineReactionsPubSubHandlerComponent = ({ contentId: contentId, contentType: contentType = 'page', rendererActions: rendererActions, updateDocument: updateDocument, allowDocumentMutation: allowDocumentMutation = true, pageMode: pageMode = (0, $cD1qu.PageMode).VIEW, syncEditorInlineReactionAnnotation: syncEditorInlineReactionAnnotation, flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { addOptimisticReaction: addOptimisticReaction, removeOptimisticResolvedMarkerRef: removeOptimisticResolvedMarkerRef, pruneOptimisticReactions: pruneOptimisticReactions, applyRemoteDelta: applyRemoteDelta, markReactedUsersChanged: markReactedUsersChanged } = (0, $dklIa.useInlineReactionActions)();
    const { addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: false
        }
    });
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)() || {};
    const dispatchContext = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const { publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    // Track the latest doc version in a ref so the handler closure always
    // reads the current value without causing the subscription to be torn
    // down and re-established on every version bump.
    const publishedDocumentVersionRef = (0, $cozmU.useRef)(publishedDocumentVersion);
    publishedDocumentVersionRef.current = publishedDocumentVersion;
    const subscriptionsRef = (0, $cozmU.useRef)([]);
    const showCustomFlagRef = (0, $cozmU.useRef)(flags.showCustomFlag);
    showCustomFlagRef.current = flags.showCustomFlag;
    const addOptimisticReactionRef = (0, $cozmU.useRef)(addOptimisticReaction);
    addOptimisticReactionRef.current = addOptimisticReaction;
    const removeOptimisticResolvedMarkerRefRef = (0, $cozmU.useRef)(removeOptimisticResolvedMarkerRef);
    removeOptimisticResolvedMarkerRefRef.current = removeOptimisticResolvedMarkerRef;
    const pruneOptimisticReactionsRef = (0, $cozmU.useRef)(pruneOptimisticReactions);
    pruneOptimisticReactionsRef.current = pruneOptimisticReactions;
    const applyRemoteDeltaRef = (0, $cozmU.useRef)(applyRemoteDelta);
    applyRemoteDeltaRef.current = applyRemoteDelta;
    const markReactedUsersChangedRef = (0, $cozmU.useRef)(markReactedUsersChanged);
    markReactedUsersChangedRef.current = markReactedUsersChanged;
    const addCommentInCacheRef = (0, $cozmU.useRef)(addCommentInCache);
    addCommentInCacheRef.current = addCommentInCache;
    const deleteCommentInCacheRef = (0, $cozmU.useRef)(deleteCommentInCache);
    deleteCommentInCacheRef.current = deleteCommentInCache;
    const updateUnreadCommentIDSetRef = (0, $cozmU.useRef)(updateUnreadCommentIDSet);
    updateUnreadCommentIDSetRef.current = updateUnreadCommentIDSet;
    const setActiveHighlightRef = (0, $cozmU.useRef)(setActiveHighlight);
    setActiveHighlightRef.current = setActiveHighlight;
    const syncEditorInlineReactionAnnotationRef = (0, $cozmU.useRef)(syncEditorInlineReactionAnnotation);
    syncEditorInlineReactionAnnotationRef.current = syncEditorInlineReactionAnnotation;
    const commentServiceRef = (0, $cozmU.useRef)(commentService);
    commentServiceRef.current = commentService;
    const addSubscriberRef = (0, $cozmU.useRef)(dispatchContext?.addSubscriber);
    addSubscriberRef.current = dispatchContext?.addSubscriber;
    const removeSubscriberRef = (0, $cozmU.useRef)(dispatchContext?.removeSubscriber);
    removeSubscriberRef.current = dispatchContext?.removeSubscriber;
    const setContentIdRef = (0, $cozmU.useRef)(dispatchContext?.setContentId);
    setContentIdRef.current = dispatchContext?.setContentId;
    const setContentTypeRef = (0, $cozmU.useRef)(dispatchContext?.setContentType);
    setContentTypeRef.current = dispatchContext?.setContentType;
    const markDocumentNeedsUpdate = (0, $cozmU.useCallback)(()=>{
        if (!allowDocumentMutation) return;
        // Triggers a full page-content refetch to deliver a new annotation
        // mark when it cannot be applied directly from the pubsub event
        // (e.g. position data is absent, or the receiver's doc version
        // doesn't match — see `createInlineReactionAddedHandler`).
        setRefetchContent(true);
    }, [
        allowDocumentMutation,
        setRefetchContent
    ]);
    // Re-issue the same query nodes that `useReactionsSummary` and
    // `useActiveInlineData` use. `queryInterop` writes the response into the
    // shared cache against the same key those hooks watch, so any active
    // subscriber instance re-renders with the fresh data automatically.
    const refetchReactionsSummary = (0, $cozmU.useCallback)((commentId)=>{
        const variables = {
            cloudId: cloudId,
            contentId: (0, $5h5pD.extractNumericCommentId)(commentId),
            contentType: 'COMMENT'
        };
        (0, $c0rhi.queryInterop)({
            query: $e9ac562e4865c3d2$var$inlineReactionsPubSubHandlerSummaryRefetchQuery,
            variables: variables,
            fetchPolicy: 'network-only',
            __callerPackage__: "experiment-inline-reactions"
        }).catch(()=>{
        // Network failure — leave the cached entry as-is. A
        // subsequent user-initiated refetch will recover.
        });
    }, [
        cloudId
    ]);
    const refetchActiveInlineData = (0, $cozmU.useCallback)(()=>{
        // `confluence_activeInlineData` expects a content (page/blogpost) ARI,
        // not the comment ARI. Build it from the resource type the handler
        // was mounted with.
        const resource = contentType === 'blogpost' ? 'blogpost' : 'page';
        const variables = {
            cloudId: cloudId,
            contentId: `ari:cloud:confluence:${cloudId}:${resource}/${contentId}`
        };
        (0, $c0rhi.queryInterop)({
            query: $e9ac562e4865c3d2$var$inlineReactionsPubSubHandlerActiveDataRefetchQuery,
            variables: variables,
            fetchPolicy: 'network-only',
            __callerPackage__: "experiment-inline-reactions"
        }).catch(()=>{
        // Network failure — leave the cached entry as-is.
        });
    }, [
        cloudId,
        contentId,
        contentType
    ]);
    const showReactionFlag = (0, $cozmU.useCallback)(({ commentId: commentId, emojiId: emojiId, actorAccountId: actorAccountId, contentType: flagContentType })=>{
        const buildDescription = (somebody)=>intl.formatMessage(flagContentType === 'blogpost' ? $e9ac562e4865c3d2$var$i18n.somebodyReactedToBlog : $e9ac562e4865c3d2$var$i18n.somebodyReactedToPage, {
                somebody: somebody
            });
        const fallbackName = intl.formatMessage($e9ac562e4865c3d2$var$i18n.someoneFallback);
        const flagId = `inline-reactions-pubsub-${commentId}`;
        const presentFlag = (somebody, avatarSrc)=>{
            showCustomFlagRef.current({
                id: flagId,
                title: intl.formatMessage($e9ac562e4865c3d2$var$i18n.newReactionFlagTitle),
                description: buildDescription(somebody),
                isAutoDismiss: true,
                ...avatarSrc ? {
                    customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                        src: avatarSrc,
                        name: somebody,
                        size: "small"
                    })
                } : {}
            });
        };
        // If we don't have enough info to resolve the actor name, just show
        // the fallback flag immediately — there's nothing to wait on.
        if (!emojiId || !actorAccountId) {
            presentFlag(fallbackName);
            return;
        }
        const containerType = contentType === 'blogpost' ? 'BLOGPOST' : 'PAGE';
        const variables = {
            cloudId: cloudId,
            input: {
                contentId: (0, $5h5pD.extractNumericCommentId)(commentId),
                contentType: 'COMMENT',
                containerId: contentId,
                containerType: containerType,
                emojiId: emojiId
            }
        };
        (0, $c0rhi.queryInterop)({
            query: $e9ac562e4865c3d2$var$inlineReactionsPubSubHandlerActorQuery,
            variables: variables,
            __callerPackage__: "experiment-inline-reactions"
        }).then(({ data: data })=>{
            const persons = data?.confluence_reactedUsers?.confluencePerson ?? [];
            const actor = persons.find((p)=>Boolean(p?.accountId && p.accountId === actorAccountId));
            const displayName = actor?.displayName?.trim();
            const avatarSrc = actor?.profilePicture?.path ?? undefined;
            presentFlag(displayName || fallbackName, avatarSrc);
        }).catch(()=>{
            presentFlag(fallbackName);
        });
    }, [
        cloudId,
        contentId,
        contentType,
        intl
    ]);
    const hasSubscriptionDispatch = Boolean(dispatchContext?.addSubscriber) && Boolean(dispatchContext?.removeSubscriber) && Boolean(dispatchContext?.setContentId) && Boolean(dispatchContext?.setContentType);
    (0, $cozmU.useEffect)(()=>{
        // `confluence_enable_subscriptions-context-provider` is at 100% rollout
        // (cleanup phase), so we don't gate on it here — adding a new use of a
        // stale gate would just have to be cleaned up again. The dispatch
        // helpers below are the practical signal that the central subscription
        // is wired up.
        if (!(0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true)) return;
        if (!hasSubscriptionDispatch) return;
        if (!contentId) return;
        const addSubscriber = addSubscriberRef.current;
        const removeSubscriber = removeSubscriberRef.current;
        const setContentId = setContentIdRef.current;
        const setContentType = setContentTypeRef.current;
        if (!addSubscriber || !removeSubscriber || !setContentId || !setContentType) return;
        subscriptionsRef.current = (0, $jU6SV.setUpInlineReactionsPubSub)({
            contentId: contentId,
            contentType: contentType,
            currentUserId: userId,
            rendererActions: rendererActions,
            updateDocument: updateDocument,
            publishedDocumentVersionRef: publishedDocumentVersionRef,
            allowDocumentMutation: allowDocumentMutation,
            pageMode: pageMode,
            addOptimisticReaction: (...args)=>addOptimisticReactionRef.current(...args),
            removeOptimisticResolvedMarkerRef: (...args)=>removeOptimisticResolvedMarkerRefRef.current(...args),
            isOptimisticallyResolvedMarkerRef: $dklIa.isOptimisticallyResolvedMarkerRef,
            pruneOptimisticReactions: (...args)=>pruneOptimisticReactionsRef.current(...args),
            applyRemoteDelta: (...args)=>applyRemoteDeltaRef.current(...args),
            markReactedUsersChanged: (...args)=>markReactedUsersChangedRef.current(...args),
            setActiveHighlight: (markerRef)=>setActiveHighlightRef.current?.(markerRef),
            refetchReactionsSummary: refetchReactionsSummary,
            refetchActiveInlineData: refetchActiveInlineData,
            markDocumentNeedsUpdate: markDocumentNeedsUpdate,
            showReactionFlag: showReactionFlag,
            addCommentInCache: (...args)=>addCommentInCacheRef.current?.(...args),
            deleteCommentInCache: (...args)=>deleteCommentInCacheRef.current?.(...args),
            fetchCommentById: $lb2Lp.fetchCommentById,
            updateUnreadCommentIDSet: (...args)=>updateUnreadCommentIDSetRef.current(...args),
            getCommentsDataFromCache: $NYiei.getCommentsDataFromCache,
            getProcessedCommentsDataActions: $4L9ve.getProcessedCommentsDataActions,
            syncEditorInlineReactionAnnotation: (...args)=>syncEditorInlineReactionAnnotationRef.current?.(...args),
            triggerCommentPanelRefresh: ()=>commentServiceRef.current.triggerCommentPanelRefresh(),
            addSubscriber: addSubscriber,
            setContentId: setContentId,
            setContentType: setContentType
        });
        return ()=>{
            (0, $jU6SV.removeInlineReactionsPubSub)({
                subscriptions: subscriptionsRef.current,
                removeSubscriber: removeSubscriber
            });
            subscriptionsRef.current = [];
        };
    }, [
        contentId,
        contentType,
        userId,
        rendererActions,
        updateDocument,
        allowDocumentMutation,
        pageMode,
        hasSubscriptionDispatch,
        refetchReactionsSummary,
        refetchActiveInlineData,
        markDocumentNeedsUpdate,
        showReactionFlag
    ]);
    return null;
};
$e9ac562e4865c3d2$var$InlineReactionsPubSubHandlerComponent.displayName = 'InlineReactionsPubSubHandler';
const $e9ac562e4865c3d2$export$e414c7c4ac2239c9 = (0, $7aRa9.withFlags)($e9ac562e4865c3d2$var$InlineReactionsPubSubHandlerComponent);
module.exports["InlineReactionsPubSubHandler"] = $e9ac562e4865c3d2$export$e414c7c4ac2239c9;

});

parcelRegister("5lLx0", function(module, exports) {
/**
 * @generated SignedSource<<2d9c6d6f92ffa68d22ca34f1616ae2c1>>
 * @relayHash 3b56cf2c02a3d609bd032afc04aa717c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8427e6324f4143c7ea10d2f41f01c03e756aa65f6f0da9ddcddd47114798cf67
const $92c7921fcd58227c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceReactedUsersResponsePayload",
            "kind": "LinkedField",
            "name": "confluence_reactedUsers",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePerson",
                    "kind": "LinkedField",
                    "name": "confluencePerson",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineReactionsPubSubHandlerActorQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineReactionsPubSubHandlerActorQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3b56cf2c02a3d609bd032afc04aa717c",
            "id": "8427e6324f4143c7ea10d2f41f01c03e756aa65f6f0da9ddcddd47114798cf67",
            "metadata": {},
            "name": "InlineReactionsPubSubHandlerActorQuery",
            "operationKind": "query",
            "text": "query InlineReactionsPubSubHandlerActorQuery($cloudId:ID!,$input:ConfluenceReactedUsersInput!){confluence_reactedUsers(cloudId:$cloudId,input:$input){confluencePerson{accountId,displayName,profilePicture{path}}}}"
        }
    };
}();
$92c7921fcd58227c$var$node.hash = "a1e84416e2dd1c9ba82fe43078a7880b";
var $92c7921fcd58227c$export$2e2bcd8739ae039 = $92c7921fcd58227c$var$node;
module.exports["default"] = $92c7921fcd58227c$export$2e2bcd8739ae039;

});

parcelRegister("1nGEl", function(module, exports) {
/**
 * @generated SignedSource<<54c5c496fa1f97660fc3987c9060a03e>>
 * @relayHash 2f5d3679776f11daa4eccecd35dae85e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e1d4be0e4e8ce9b4c81c2bdec447f04835d6249940850eb6ade0a1fe016b40f
const $ffcf781047a64c91$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceActiveInlineData",
            "kind": "LinkedField",
            "name": "confluence_activeInlineData",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceInlineMarker",
                    "kind": "LinkedField",
                    "name": "reactions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "commentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "markerRef"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineReactionsPubSubHandlerActiveDataRefetchQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineReactionsPubSubHandlerActiveDataRefetchQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2f5d3679776f11daa4eccecd35dae85e",
            "id": "8e1d4be0e4e8ce9b4c81c2bdec447f04835d6249940850eb6ade0a1fe016b40f",
            "metadata": {},
            "name": "InlineReactionsPubSubHandlerActiveDataRefetchQuery",
            "operationKind": "query",
            "text": "query InlineReactionsPubSubHandlerActiveDataRefetchQuery($cloudId:ID!,$contentId:ID!){confluence_activeInlineData(cloudId:$cloudId,contentId:$contentId){reactions{commentId,markerRef,type}}}"
        }
    };
}();
$ffcf781047a64c91$var$node.hash = "be7a25bc5dc7583ac8cffc6c204b17f0";
var $ffcf781047a64c91$export$2e2bcd8739ae039 = $ffcf781047a64c91$var$node;
module.exports["default"] = $ffcf781047a64c91$export$2e2bcd8739ae039;

});

parcelRegister("2goVK", function(module, exports) {
/**
 * @generated SignedSource<<6f96fcf3e62ea2b310c2f1659ad91f32>>
 * @relayHash 0b2a3eaaa6f9df353def4a88ff63a46e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7c0ecb0b97752b2869bcf56bc9bea4a25d220c498fed91a36a9d9e3ede4e82ee
const $6ec35d2ee41c7645$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "ConfluenceReactionSummary",
            "kind": "LinkedField",
            "name": "confluence_contentReactionsSummary",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceReactionsSummaryResponse",
                    "kind": "LinkedField",
                    "name": "reactionsSummary",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "containerAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "concreteType": "ConfluenceReactionsSummaryForEmoji",
                            "kind": "LinkedField",
                            "name": "reactionsSummaryForEmoji",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "emojiId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reacted"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineReactionsPubSubHandlerSummaryRefetchQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineReactionsPubSubHandlerSummaryRefetchQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0b2a3eaaa6f9df353def4a88ff63a46e",
            "id": "7c0ecb0b97752b2869bcf56bc9bea4a25d220c498fed91a36a9d9e3ede4e82ee",
            "metadata": {},
            "name": "InlineReactionsPubSubHandlerSummaryRefetchQuery",
            "operationKind": "query",
            "text": "query InlineReactionsPubSubHandlerSummaryRefetchQuery($cloudId:ID!,$contentId:ID!,$contentType:GraphQLReactionContentType!){confluence_contentReactionsSummary(cloudId:$cloudId,contentId:$contentId,contentType:$contentType){reactionsSummary{ari,containerAri,reactionsCount,reactionsSummaryForEmoji{emojiId,count,reacted}}}}"
        }
    };
}();
$6ec35d2ee41c7645$var$node.hash = "085d906d041b6881f9e1e396bc97ba34";
var $6ec35d2ee41c7645$export$2e2bcd8739ae039 = $6ec35d2ee41c7645$var$node;
module.exports["default"] = $6ec35d2ee41c7645$export$2e2bcd8739ae039;

});

parcelRegister("6hmtW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $cozmU.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $cozmU.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $cozmU.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $cozmU.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $cozmU.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $cozmU.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
        this.syncActiveCommentMarkersHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    /**
   * Register a handler for active comment marker updates (called by CFE)
   * @param handler - Receives the `inlineMarkerRef` of each inline comment in the
   * content, in display order
   * @see syncActiveCommentMarkers for the counterpart method
   */ registerSyncActiveCommentMarkers(handler) {
        this.syncActiveCommentMarkersHandler = handler;
    }
    /**
   * Replaces the active comment markers (fired by content types) Content Types -> CFE
   * @param markerRefs - The `inlineMarkerRef` of each inline comment in the content, in
   * display order
   * @see registerSyncActiveCommentMarkers for the counterpart method
   */ syncActiveCommentMarkers(markerRefs) {
        this.syncActiveCommentMarkersHandler?.(markerRefs);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.syncActiveCommentMarkersHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
        this.syncActiveCommentMarkersHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("dklIa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

const $c3a6d60a3494ed40$var$defaultCommentState = Object.freeze({
    optimisticReactions: Object.freeze([]),
    inFlightEmojiIds: Object.freeze(new Set()),
    rollbackMap: Object.freeze(new Map()),
    error: undefined
});
const $c3a6d60a3494ed40$var$getCommentState = (state, commentId)=>state.commentReactionState[commentId] ?? $c3a6d60a3494ed40$var$defaultCommentState;
const $c3a6d60a3494ed40$var$setCommentState = (state, commentId, patch)=>({
        ...state.commentReactionState,
        [commentId]: {
            ...$c3a6d60a3494ed40$var$getCommentState(state, commentId),
            ...patch
        }
    });
const $c3a6d60a3494ed40$var$DEFAULT_STALENESS = Object.freeze({
    changed: 0,
    fetched: 0
});
const $c3a6d60a3494ed40$export$64e3401c254cca65 = (commentId, emojiId)=>`${commentId}::${emojiId}`;
/**
 * Merges server reaction data into the existing display order.
 * Existing emojis keep their position; their values are updated from `server`
 * (or from `inFlightOverrides` when a mutation is in-flight).
 * Emojis absent from both `server` and `inFlightOverrides` are dropped.
 * New emojis (from server or still-in-flight) are appended at the end.
 */ const $c3a6d60a3494ed40$var$stabilizeReactions = (current, server, inFlightOverrides = new Map(), deletedInFlight = new Set())=>{
    const serverMap = new Map();
    for (const r of server)if (!deletedInFlight.has(r.emojiId)) serverMap.set(r.emojiId, r);
    const result = [];
    const seenIds = new Set();
    for (const r of current){
        if (deletedInFlight.has(r.emojiId)) continue;
        const inFlight = inFlightOverrides.get(r.emojiId);
        if (inFlight) {
            result.push(inFlight);
            seenIds.add(r.emojiId);
        } else if (serverMap.has(r.emojiId)) {
            result.push(serverMap.get(r.emojiId));
            seenIds.add(r.emojiId);
        }
    // not in server and not in-flight → removed, omit
    }
    for (const r of server)if (!seenIds.has(r.emojiId) && !deletedInFlight.has(r.emojiId)) {
        result.push(r);
        seenIds.add(r.emojiId);
    }
    for (const [emojiId, optimistic] of inFlightOverrides)if (!seenIds.has(emojiId)) {
        result.push(optimistic);
        seenIds.add(emojiId);
    }
    return result;
};
const $c3a6d60a3494ed40$var$initialState = {
    opener: null,
    picker: null,
    optimisticReactionMarkerMap: {},
    optimisticResolvedMarkerRefs: new Set(),
    optimisticDeletedMarkerRefs: new Set(),
    commentReactionState: {},
    reactedUsersStaleness: {}
};
const $c3a6d60a3494ed40$var$registerOpener = (opener)=>({ setState: setState })=>{
        setState({
            opener: opener
        });
    };
const $c3a6d60a3494ed40$var$triggerOpen = ()=>({ getState: getState })=>{
        getState().opener?.();
    };
const $c3a6d60a3494ed40$var$openPicker = ({ anchorTop: anchorTop, anchorLeft: anchorLeft, contentType: contentType, pageId: pageId, onCreate: onCreate, step: step, originalSelection: originalSelection, onClose: onClose })=>({ setState: setState, getState: getState })=>{
        if (getState().picker) return;
        setState({
            picker: {
                anchorTop: anchorTop,
                anchorLeft: anchorLeft,
                contentType: contentType,
                pageId: pageId,
                onCreate: onCreate,
                step: step,
                originalSelection: originalSelection,
                onClose: onClose
            }
        });
    };
const $c3a6d60a3494ed40$var$closePicker = ()=>({ setState: setState, getState: getState })=>{
        const { picker: picker } = getState();
        if (!picker) return;
        picker.onClose?.();
        setState({
            picker: null
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticReaction = (markerRef, commentId)=>({ setState: setState, getState: getState })=>{
        setState({
            optimisticReactionMarkerMap: {
                ...getState().optimisticReactionMarkerMap,
                [markerRef]: commentId
            }
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticResolvedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (current.has(markerRef)) return;
        setState({
            optimisticResolvedMarkerRefs: new Set([
                ...current,
                markerRef
            ])
        });
    };
/**
 * Roll back an optimistic resolve — removes the ref from the set so the
 * highlight reappears. Called when the resolve mutation fails.
 */ const $c3a6d60a3494ed40$var$removeOptimisticResolvedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (!current.has(markerRef)) return;
        const next = new Set(current);
        next.delete(markerRef);
        setState({
            optimisticResolvedMarkerRefs: next
        });
    };
/**
 * Drain any optimistic-resolved refs that are no longer present in the
 * server-confirmed marker refs (meaning the server has confirmed removal).
 * No-ops when the set is empty to avoid an extra re-render.
 */ const $c3a6d60a3494ed40$var$pruneOptimisticResolvedMarkerRefs = (serverMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (current.size === 0) return;
        const serverSet = new Set(serverMarkerRefs);
        const next = new Set();
        for (const ref of current)// Keep only refs that the server still returns (not yet confirmed removed).
        if (serverSet.has(ref)) next.add(ref);
        if (next.size !== current.size) setState({
            optimisticResolvedMarkerRefs: next
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticDeletedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticDeletedMarkerRefs;
        if (current.has(markerRef)) return;
        setState({
            optimisticDeletedMarkerRefs: new Set([
                ...current,
                markerRef
            ])
        });
    };
const $c3a6d60a3494ed40$var$pruneOptimisticDeletedMarkerRefs = (serverMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticDeletedMarkerRefs;
        if (current.size === 0) return;
        const serverSet = new Set(serverMarkerRefs);
        const next = new Set();
        for (const ref of current)if (serverSet.has(ref)) next.add(ref);
        if (next.size !== current.size) setState({
            optimisticDeletedMarkerRefs: next
        });
    };
/**
 * Drop any optimistic entries whose markerRef is now in the server-confirmed map.
 * Called from `useRendererAnnotationProviderOptions` whenever `useActiveInlineData`
 * returns a new `reactionMarkerMap`, so the optimistic store does not grow forever.
 * No-ops (and skips the setState) when nothing needs to be pruned to avoid an
 * extra re-render cycle.
 */ const $c3a6d60a3494ed40$var$pruneOptimisticReactions = (confirmedMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticReactionMarkerMap;
        if (Object.keys(current).length === 0 || confirmedMarkerRefs.length === 0) return;
        const confirmedSet = new Set(confirmedMarkerRefs);
        let changed = false;
        const next = {};
        for (const [markerRef, commentId] of Object.entries(current)){
            if (confirmedSet.has(markerRef)) {
                changed = true;
                continue;
            }
            next[markerRef] = commentId;
        }
        if (changed) setState({
            optimisticReactionMarkerMap: next
        });
    };
/**
 * Sync server reactions into the store for a given comment.
 *
 * When nothing is in-flight, the server data replaces the optimistic array.
 * When mutations are in-flight, server data is merged: in-flight emojis keep
 * their optimistic values while everything else updates to the server truth.
 */ const $c3a6d60a3494ed40$var$syncServerReactions = (commentId, serverReactions)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.size === 0) {
            setState({
                commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                    optimisticReactions: $c3a6d60a3494ed40$var$stabilizeReactions(comment.optimisticReactions, serverReactions)
                })
            });
            return;
        }
        // Merge: keep optimistic values for in-flight emojis, use server for the rest.
        // Build the snapshot as a Map for O(1) lookup (avoids quadratic nested iteration).
        const inFlightSnapshot = new Map();
        for (const r of comment.optimisticReactions)if (comment.inFlightEmojiIds.has(r.emojiId)) inFlightSnapshot.set(r.emojiId, r);
        // Track emojis that were optimistically deleted (in-flight but absent from
        // optimisticReactions because their count hit 0). We must suppress these from
        // the server payload so they don't get resurrected before the mutation settles.
        const deletedInFlight = new Set();
        for (const id of comment.inFlightEmojiIds)if (!inFlightSnapshot.has(id)) deletedInFlight.add(id);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: $c3a6d60a3494ed40$var$stabilizeReactions(comment.optimisticReactions, serverReactions, inFlightSnapshot, deletedInFlight)
            })
        });
    };
/**
 * Apply an optimistic toggle (add or remove) for an existing emoji.
 * Returns `null` if the emoji is already in-flight or not found (no-op).
 * Otherwise applies the optimistic update, marks in-flight, and returns
 * `true` if removing or `false` if adding, so the caller knows which
 * mutation to fire.
 *
 * This combines the guard, optimistic update, and in-flight marking into a
 * single synchronous store transaction so that rapid-fire calls (e.g. double
 * clicks) are properly de-duped even before React re-renders.
 */ const $c3a6d60a3494ed40$var$applyOptimisticToggle = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.has(emojiId)) return null;
        const currentReaction = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        if (!currentReaction) return null;
        const isRemoving = currentReaction.reacted;
        // Save rollback snapshot
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.set(emojiId, comment.optimisticReactions);
        // Mark in-flight
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.add(emojiId);
        let nextReactions;
        if (isRemoving) {
            const newCount = currentReaction.count - 1;
            if (newCount <= 0) nextReactions = comment.optimisticReactions.filter((r)=>r.emojiId !== emojiId);
            else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: newCount,
                    reacted: false
                } : r);
        } else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                ...r,
                count: r.count + 1,
                reacted: true
            } : r);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions,
                rollbackMap: nextRollback,
                inFlightEmojiIds: nextInFlight,
                error: undefined
            })
        });
        return isRemoving;
    };
/**
 * Apply an optimistic add for a new or existing-but-not-reacted emoji.
 * Returns `false` if already in-flight or already reacted (no-op).
 * Otherwise applies the optimistic update, marks in-flight, and returns `true`.
 *
 * Like `applyOptimisticToggle`, this combines guard + update + in-flight
 * into a single synchronous transaction.
 */ const $c3a6d60a3494ed40$var$applyOptimisticAdd = (commentId, emojiId, templateAri, templateContainerAri)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.has(emojiId)) return false;
        const existingReaction = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        if (existingReaction?.reacted) return false;
        // Save rollback snapshot
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.set(emojiId, comment.optimisticReactions);
        // Mark in-flight
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.add(emojiId);
        let nextReactions;
        if (existingReaction) nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                ...r,
                count: r.count + 1,
                reacted: true
            } : r);
        else nextReactions = [
            ...comment.optimisticReactions,
            {
                ari: templateAri,
                containerAri: templateContainerAri,
                emojiId: emojiId,
                count: 1,
                reacted: true
            }
        ];
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions,
                rollbackMap: nextRollback,
                inFlightEmojiIds: nextInFlight,
                error: undefined
            })
        });
        return true;
    };
/** Clear in-flight and rollback state for a settled mutation. */ const $c3a6d60a3494ed40$var$onEmojiSettled = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.delete(emojiId);
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.delete(emojiId);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                inFlightEmojiIds: nextInFlight,
                rollbackMap: nextRollback
            })
        });
    };
/** Roll back optimistic state on mutation error. */ const $c3a6d60a3494ed40$var$onEmojiMutationError = (commentId, emojiId, error)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const rollback = comment.rollbackMap.get(emojiId);
        // Clear in-flight and rollback for this emoji
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.delete(emojiId);
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.delete(emojiId);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: rollback ?? comment.optimisticReactions,
                inFlightEmojiIds: nextInFlight,
                rollbackMap: nextRollback,
                error: error
            })
        });
    };
/** Remove all state for a comment (call on unmount). */ const $c3a6d60a3494ed40$var$cleanupComment = (commentId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { [commentId]: _, ...rest } = state.commentReactionState;
        // Drop any reacted-users freshness entries for this comment's pairs so the
        // registry does not grow unbounded across a long session.
        const keyPrefix = `${commentId}::`;
        let removedStaleness = false;
        const nextStaleness = {};
        for (const [key, value] of Object.entries(state.reactedUsersStaleness)){
            if (key.startsWith(keyPrefix)) {
                removedStaleness = true;
                continue;
            }
            nextStaleness[key] = value;
        }
        setState({
            commentReactionState: rest,
            ...removedStaleness ? {
                reactedUsersStaleness: nextStaleness
            } : {}
        });
    };
/**
 * Record that the reactor list for a comment+emoji pair changed (local mutation
 * or remote pubsub event), bumping its `changed` counter so the next mounted
 * facepile fetcher refetches from the network.
 */ const $c3a6d60a3494ed40$var$markReactedUsersChanged = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const key = $c3a6d60a3494ed40$export$64e3401c254cca65(commentId, emojiId);
        const current = state.reactedUsersStaleness[key] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS;
        setState({
            reactedUsersStaleness: {
                ...state.reactedUsersStaleness,
                [key]: {
                    changed: current.changed + 1,
                    fetched: current.fetched
                }
            }
        });
    };
/**
 * Record that a facepile fetcher has refetched the reactor list for a
 * comment+emoji pair, catching `fetched` up to `changed`. No-ops when already
 * caught up to avoid a redundant re-render.
 */ const $c3a6d60a3494ed40$var$markReactedUsersFetched = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const key = $c3a6d60a3494ed40$export$64e3401c254cca65(commentId, emojiId);
        const current = state.reactedUsersStaleness[key];
        if (!current || current.fetched === current.changed) return;
        setState({
            reactedUsersStaleness: {
                ...state.reactedUsersStaleness,
                [key]: {
                    changed: current.changed,
                    fetched: current.changed
                }
            }
        });
    };
/**
 * Apply a remote pubsub delta (add or remove) from another user.
 *
 * On +1: increment the existing emoji count, or create a new entry with
 *        count=1 and reacted=false if it doesn't exist yet.
 * On -1: decrement the count, removing the entry if it reaches zero.
 *        No-ops if the comment has no state yet (nothing to decrement).
 */ const $c3a6d60a3494ed40$var$applyRemoteDelta = (commentId, emojiId, delta, templateAri = '', templateContainerAri = '')=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const existing = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        let nextReactions;
        if (delta === 1) {
            if (existing) // Increment existing entry, preserve `reacted` (current user's state)
            nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: r.count + 1
                } : r);
            else {
                // If this comment has no store entry yet, skip writing: persisting a new
                // CommentReactionState here would create a leaked record (ari: '', containerAri: '')
                // for a comment that is not currently mounted. syncServerReactions will provide
                // authoritative state when the component does mount and refetches.
                if (state.commentReactionState[commentId] === undefined) return;
                // Create a new entry - 'reacted' is false since this is a remote user's reaction
                nextReactions = [
                    ...comment.optimisticReactions,
                    {
                        ari: templateAri,
                        containerAri: templateContainerAri,
                        emojiId: emojiId,
                        count: 1,
                        reacted: false
                    }
                ];
            }
        } else {
            // delta === -1
            if (!existing) // No emoji found in store - nothing to decrement
            return;
            const newCount = existing.count - 1;
            if (newCount <= 0) nextReactions = comment.optimisticReactions.filter((r)=>r.emojiId !== emojiId);
            else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: newCount
                } : r);
        }
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions
            })
        });
    };
const $c3a6d60a3494ed40$var$actions = {
    registerOpener: $c3a6d60a3494ed40$var$registerOpener,
    triggerOpen: $c3a6d60a3494ed40$var$triggerOpen,
    openPicker: $c3a6d60a3494ed40$var$openPicker,
    closePicker: $c3a6d60a3494ed40$var$closePicker,
    addOptimisticReaction: $c3a6d60a3494ed40$var$addOptimisticReaction,
    pruneOptimisticReactions: $c3a6d60a3494ed40$var$pruneOptimisticReactions,
    addOptimisticResolvedMarkerRef: $c3a6d60a3494ed40$var$addOptimisticResolvedMarkerRef,
    removeOptimisticResolvedMarkerRef: $c3a6d60a3494ed40$var$removeOptimisticResolvedMarkerRef,
    pruneOptimisticResolvedMarkerRefs: $c3a6d60a3494ed40$var$pruneOptimisticResolvedMarkerRefs,
    addOptimisticDeletedMarkerRef: $c3a6d60a3494ed40$var$addOptimisticDeletedMarkerRef,
    pruneOptimisticDeletedMarkerRefs: $c3a6d60a3494ed40$var$pruneOptimisticDeletedMarkerRefs,
    syncServerReactions: $c3a6d60a3494ed40$var$syncServerReactions,
    applyOptimisticToggle: $c3a6d60a3494ed40$var$applyOptimisticToggle,
    applyOptimisticAdd: $c3a6d60a3494ed40$var$applyOptimisticAdd,
    onEmojiSettled: $c3a6d60a3494ed40$var$onEmojiSettled,
    onEmojiMutationError: $c3a6d60a3494ed40$var$onEmojiMutationError,
    cleanupComment: $c3a6d60a3494ed40$var$cleanupComment,
    applyRemoteDelta: $c3a6d60a3494ed40$var$applyRemoteDelta,
    markReactedUsersChanged: $c3a6d60a3494ed40$var$markReactedUsersChanged,
    markReactedUsersFetched: $c3a6d60a3494ed40$var$markReactedUsersFetched
};
const $c3a6d60a3494ed40$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: $c3a6d60a3494ed40$var$initialState,
    actions: $c3a6d60a3494ed40$var$actions,
    name: 'inlineReactionStore'
});
const $c3a6d60a3494ed40$export$4bea784acc47afc0 = (0, $kBr4q.createActionsHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9);
const $c3a6d60a3494ed40$export$95648a16d8bcb2ae = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.picker
});
const $c3a6d60a3494ed40$export$a2df1890187165d2 = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticReactionMarkerMap
});
function $c3a6d60a3494ed40$export$8adad8a188e9f237() {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().optimisticReactionMarkerMap;
}
function $c3a6d60a3494ed40$export$ff40a497e226daf7(markerRef) {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().optimisticResolvedMarkerRefs.has(markerRef);
}
function $c3a6d60a3494ed40$export$e0bbeb963dd9ccf1(markerRef) {
    (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).actions.addOptimisticDeletedMarkerRef(markerRef);
}
const $c3a6d60a3494ed40$export$acabd5c13c46827c = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticResolvedMarkerRefs
});
const $c3a6d60a3494ed40$export$15ea3ad646d59eec = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticDeletedMarkerRefs
});
const $c3a6d60a3494ed40$export$c2b73a32145e6e04 = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state, commentId)=>state.commentReactionState[commentId] ?? $c3a6d60a3494ed40$var$defaultCommentState
});
const $c3a6d60a3494ed40$export$2b46bd66d45480ef = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state, pairKey)=>state.reactedUsersStaleness[pairKey] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS
});
function $c3a6d60a3494ed40$export$20c2e9914ef136a5(pairKey) {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().reactedUsersStaleness[pairKey] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS;
}
module.exports["reactedUsersPairKey"] = $c3a6d60a3494ed40$export$64e3401c254cca65;
module.exports["useInlineReactionActions"] = $c3a6d60a3494ed40$export$4bea784acc47afc0;
module.exports["useInlineReactionPicker"] = $c3a6d60a3494ed40$export$95648a16d8bcb2ae;
module.exports["useOptimisticReactionMarkerMap"] = $c3a6d60a3494ed40$export$a2df1890187165d2;
module.exports["getOptimisticReactionMarkerMap"] = $c3a6d60a3494ed40$export$8adad8a188e9f237;
module.exports["isOptimisticallyResolvedMarkerRef"] = $c3a6d60a3494ed40$export$ff40a497e226daf7;
module.exports["markOptimisticDeletedMarkerRef"] = $c3a6d60a3494ed40$export$e0bbeb963dd9ccf1;
module.exports["useOptimisticResolvedMarkerRefs"] = $c3a6d60a3494ed40$export$acabd5c13c46827c;
module.exports["useOptimisticDeletedMarkerRefs"] = $c3a6d60a3494ed40$export$15ea3ad646d59eec;
module.exports["useCommentReactionState"] = $c3a6d60a3494ed40$export$c2b73a32145e6e04;
module.exports["useReactedUsersStaleness"] = $c3a6d60a3494ed40$export$2b46bd66d45480ef;
module.exports["getReactedUsersStaleness"] = $c3a6d60a3494ed40$export$20c2e9914ef136a5;

});

parcelRegister("5h5pD", function(module, exports) {
/**
 * Extracts the trailing numeric segment from a comment ARI.
 *
 * Examples:
 *   "ari:cloud:confluence:tenant:comment/12345" → "12345"
 *   "12345"                                     → "12345"  (already numeric)
 */ const $2f5a01fd9d883268$export$f636d72758a31c59 = (commentAri)=>{
    const parts = commentAri.split('/');
    return parts[parts.length - 1] || commentAri;
};
module.exports["extractNumericCommentId"] = $2f5a01fd9d883268$export$f636d72758a31c59;

});

parcelRegister("jU6SV", function(module, exports) {
/**
 * Inline reactions pubsub handlers, mirroring the inline-comments pubsub flow
 * (`@confluence/comments-pubsub/src/inline/rendererInlineCommentsPubSub.ts`).
 *
 * Three new AGG fields ride on the existing `confluence_onContentModified`
 * subscription:
 *   - `inlineReactionAdded`              → User added a reaction (creates a
 *     new highlight when `newHighlight=true`, otherwise increments an
 *     existing reaction count).
 *   - `inlineReactionRemoved`            → A reaction was removed but the
 *     highlight still has other reactions remaining.
 *   - `inlineReactionHighlightDeleted`   → The last reaction was removed,
 *     causing the anchor comment to be deleted and the ADF annotation mark
 *     to be removed.
 *
 */ 
var $7W8i8 = parcelRequire("7W8i8");


var $epbW8 = parcelRequire("epbW8");


var $cD1qu = parcelRequire("cD1qu");


var $hfNnW = parcelRequire("hfNnW");


var $5h5pD = parcelRequire("5h5pD");


var $Fp23B = parcelRequire("Fp23B");


var $37gNP = parcelRequire("37gNP");

const $9bf4a6e2087195a5$var$logger = (0, $7W8i8.getLogger)('experiment-inline-reactions');
const $9bf4a6e2087195a5$export$717f531ab7512f5 = {
    InlineReactionAdded: 'inlineReactionAdded',
    InlineReactionRemoved: 'inlineReactionRemoved',
    InlineReactionHighlightDeleted: 'inlineReactionHighlightDeleted',
    InlineCommentUnresolved: 'inlineCommentUnresolved'
};
const $9bf4a6e2087195a5$var$shouldSkipOwnReactionEvent = (payload, currentUserId)=>(0, $hfNnW.shouldSkipOwnPubSubEvent)({
        accountId: payload?.accountId,
        currentUserId: currentUserId,
        originTabId: payload?.originTabId
    });
const $9bf4a6e2087195a5$export$f6be9c59a276eaed = (params)=>(_event, payload)=>{
        if ($9bf4a6e2087195a5$var$shouldSkipOwnReactionEvent(payload, params.currentUserId)) return;
        const event = payload?.inlineReactionAdded;
        if (!event || !event.commentId || !event.markerRef) return;
        const { addOptimisticReaction: addOptimisticReaction, applyRemoteDelta: applyRemoteDelta, markReactedUsersChanged: markReactedUsersChanged, refetchReactionsSummary: refetchReactionsSummary, refetchActiveInlineData: refetchActiveInlineData, markDocumentNeedsUpdate: markDocumentNeedsUpdate, showReactionFlag: showReactionFlag, contentType: contentType, contentId: contentId, rendererActions: rendererActions, updateDocument: updateDocument, publishedDocumentVersionRef: publishedDocumentVersionRef, addCommentInCache: addCommentInCache, fetchCommentById: fetchCommentById, updateUnreadCommentIDSet: updateUnreadCommentIDSet, getCommentsDataFromCache: getCommentsDataFromCache, getProcessedCommentsDataActions: getProcessedCommentsDataActions, triggerCommentPanelRefresh: triggerCommentPanelRefresh, syncEditorInlineReactionAnnotation: syncEditorInlineReactionAnnotation, allowDocumentMutation: allowDocumentMutation = true, pageMode: pageMode = (0, $cD1qu.PageMode).VIEW } = params;
        const numericCommentId = (0, $5h5pD.extractNumericCommentId)(event.commentId);
        if (event.newHighlight) {
            addOptimisticReaction(event.markerRef, event.commentId);
            refetchActiveInlineData();
            if (allowDocumentMutation && event.step && event.publishVersionNumber != null && event.publishVersionNumber === publishedDocumentVersionRef?.current) // The event carries position data and the receiver's doc version matches —
            // apply the annotation mark directly for an instant highlight paint.
            try {
                const { from: from, to: to } = event.step;
                const result = rendererActions?.applyAnnotation({
                    from: from,
                    to: to
                }, {
                    annotationId: event.markerRef,
                    annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                });
                if (result && updateDocument) updateDocument(result.doc);
                else markDocumentNeedsUpdate();
            } catch  {
                // Step position was invalid for the current doc —
                // deliver the highlight via a full page-content refetch instead.
                markDocumentNeedsUpdate();
            }
            else // Missing step, version mismatch, or publishVersionNumber absent —
            // deliver the highlight via a full page-content refetch instead.
            if (allowDocumentMutation) markDocumentNeedsUpdate();
            if (!allowDocumentMutation) syncEditorInlineReactionAnnotation?.('create', event.markerRef, event.step);
        }
        // Apply the delta directly to the store for an instant count update.
        // Only when emojiId is present — without it we can't identify which
        // emoji to increment. The background refetch will always correct the
        // authoritative state regardless.
        if (event.emojiId) {
            applyRemoteDelta(numericCommentId, event.emojiId, 1);
            // Mark the facepile reactor list stale so the next mounted fetcher
            // refetches it — even if the popup/tile is currently closed.
            markReactedUsersChanged(numericCommentId, event.emojiId);
        }
        // Refetch for authoritative counts + `reacted` state for the current user.
        refetchReactionsSummary(event.commentId);
        // Update the comments panel cache so the new reaction appears without a
        // page refresh — feature parity with inline comments pubsub behaviour.
        // fetchCommentById fetches the updated comment (including its reactionsSummary)
        // and writes it into the shared cache that the comments panel reads from.
        (0, $37gNP.syncInlineReactionCommentToPanel)({
            commentId: numericCommentId,
            contentId: contentId,
            pageMode: pageMode,
            fetchCommentById: fetchCommentById,
            addCommentInCache: addCommentInCache,
            getCommentsDataFromCache: getCommentsDataFromCache,
            processCommentsData: getProcessedCommentsDataActions?.().processCommentsData,
            triggerCommentPanelRefresh: triggerCommentPanelRefresh
        });
        // Mark the reaction comment as unread to trigger the blue-dot indicator
        // in the content wrapper — matching inline comment pubsub behaviour.
        if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
            numericCommentId
        ]), 'add');
        showReactionFlag({
            commentId: event.commentId,
            markerRef: event.markerRef,
            emojiId: event.emojiId,
            contentType: contentType ?? 'page',
            actorAccountId: payload?.accountId
        });
    };
const $9bf4a6e2087195a5$export$1898285831c18448 = (params)=>(_event, payload)=>{
        if ($9bf4a6e2087195a5$var$shouldSkipOwnReactionEvent(payload, params.currentUserId)) return;
        const event = payload?.inlineReactionRemoved;
        if (!event || !event.commentId) return;
        const numericCommentId = (0, $5h5pD.extractNumericCommentId)(event.commentId);
        // Apply the delta directly to the store for an instant count update.
        // Only when emojiId is present (same guard as the added handler).
        if (event.emojiId) {
            params.applyRemoteDelta(numericCommentId, event.emojiId, -1);
            // Mark the facepile reactor list stale (see added handler).
            params.markReactedUsersChanged(numericCommentId, event.emojiId);
        }
        // No flag for removals — matches inline-comment pubsub behaviour,
        // which only surfaces flags for new comments, not deletions.
        params.refetchReactionsSummary(event.commentId);
        (0, $37gNP.syncInlineReactionCommentToPanel)({
            commentId: numericCommentId,
            contentId: params.contentId,
            pageMode: params.pageMode ?? (0, $cD1qu.PageMode).VIEW,
            fetchCommentById: params.fetchCommentById,
            addCommentInCache: params.addCommentInCache,
            getCommentsDataFromCache: params.getCommentsDataFromCache,
            processCommentsData: params.getProcessedCommentsDataActions?.().processCommentsData,
            triggerCommentPanelRefresh: params.triggerCommentPanelRefresh
        });
    };
const $9bf4a6e2087195a5$var$getReopenedInlineCommentEvent = (event, payload)=>event === $9bf4a6e2087195a5$export$717f531ab7512f5.InlineCommentUnresolved ? payload.inlineCommentUnresolved ?? payload.inlineCommentRequestBody : undefined;
const $9bf4a6e2087195a5$var$getFetchedCommentMarkerRef = (comment)=>{
    if (!comment || typeof comment !== 'object') return undefined;
    const location = comment.location;
    return location?.inlineMarkerRef ?? undefined;
};
const $9bf4a6e2087195a5$export$c2d03eb6dc018515 = (params)=>(event, payload)=>{
        if ($9bf4a6e2087195a5$var$shouldSkipOwnReactionEvent(payload, params.currentUserId)) return;
        const reopenedComment = $9bf4a6e2087195a5$var$getReopenedInlineCommentEvent(event, payload);
        if (!reopenedComment?.commentId || reopenedComment.inlineCommentType === 'REPLY') return;
        const markerRefFromPayload = reopenedComment.markerRef;
        if (markerRefFromPayload && params.isOptimisticallyResolvedMarkerRef && !params.isOptimisticallyResolvedMarkerRef(markerRefFromPayload)) return;
        const reopenedCommentId = reopenedComment.commentId;
        const numericCommentId = (0, $5h5pD.extractNumericCommentId)(reopenedCommentId);
        const { fetchCommentById: fetchCommentById } = params;
        if (!fetchCommentById) return;
        fetchCommentById({
            commentId: numericCommentId,
            contentId: params.contentId,
            fetchPolicy: 'network-only'
        }).then((fetchedComment)=>{
            if (!fetchedComment || !(0, $Fp23B.isInlineReactionThread)(fetchedComment)) return;
            const markerRef = markerRefFromPayload ?? $9bf4a6e2087195a5$var$getFetchedCommentMarkerRef(fetchedComment);
            if (!markerRef) return;
            if (params.isOptimisticallyResolvedMarkerRef && !params.isOptimisticallyResolvedMarkerRef(markerRef)) return;
            params.removeOptimisticResolvedMarkerRef?.(markerRef);
            params.addOptimisticReaction(markerRef, reopenedCommentId);
            params.refetchActiveInlineData();
            params.addCommentInCache?.({
                newComment: fetchedComment
            });
            if (params.getCommentsDataFromCache) {
                const updatedCommentsData = params.getCommentsDataFromCache(params.contentId);
                params.getProcessedCommentsDataActions?.().processCommentsData({
                    data: updatedCommentsData,
                    pageMode: params.pageMode ?? (0, $cD1qu.PageMode).VIEW
                });
            }
            if (params.allowDocumentMutation === false) {
                params.syncEditorInlineReactionAnnotation?.('create', markerRef);
                params.triggerCommentPanelRefresh?.();
            }
        }).catch((error)=>{
            $9bf4a6e2087195a5$var$logger.error`Failed to fetch reopened inline reaction comment ${error}`;
        });
    };
const $9bf4a6e2087195a5$export$32d640d739a62937 = (params)=>(_event, payload)=>{
        if ($9bf4a6e2087195a5$var$shouldSkipOwnReactionEvent(payload, params.currentUserId)) return;
        const event = payload?.inlineReactionHighlightDeleted;
        if (!event || !event.markerRef) return;
        const { rendererActions: rendererActions, updateDocument: updateDocument, pruneOptimisticReactions: pruneOptimisticReactions, setActiveHighlight: setActiveHighlight, refetchActiveInlineData: refetchActiveInlineData, allowDocumentMutation: allowDocumentMutation = true, deleteCommentInCache: deleteCommentInCache, updateUnreadCommentIDSet: updateUnreadCommentIDSet, getCommentsDataFromCache: getCommentsDataFromCache, getProcessedCommentsDataActions: getProcessedCommentsDataActions, triggerCommentPanelRefresh: triggerCommentPanelRefresh, contentId: contentId, pageMode: pageMode = (0, $cD1qu.PageMode).VIEW, syncEditorInlineReactionAnnotation: syncEditorInlineReactionAnnotation } = params;
        const numericCommentId = event.commentId ? (0, $5h5pD.extractNumericCommentId)(event.commentId) : undefined;
        if (allowDocumentMutation) {
            const deleteResult = rendererActions?.deleteAnnotation(event.markerRef, (0, $epbW8.AnnotationTypes).INLINE_COMMENT);
            if (deleteResult && updateDocument) updateDocument(deleteResult.doc);
        } else syncEditorInlineReactionAnnotation?.('delete', event.markerRef);
        // Drop the optimistic entry (if any) so the renderer doesn't try to
        // keep painting the highlight after the mark is removed.
        pruneOptimisticReactions([
            event.markerRef
        ]);
        setActiveHighlight?.(null);
        // Refresh the active-inline-data cache so the markerRef set is
        // correct on subsequent renders.
        refetchActiveInlineData();
        if (!allowDocumentMutation && numericCommentId) {
            deleteCommentInCache?.({
                commentId: numericCommentId
            });
            updateUnreadCommentIDSet?.(new Set([
                numericCommentId
            ]), 'remove');
            if (getCommentsDataFromCache) {
                const updatedCommentsData = getCommentsDataFromCache(contentId);
                getProcessedCommentsDataActions?.().processCommentsData({
                    data: updatedCommentsData,
                    pageMode: pageMode
                });
            }
        }
        if (!allowDocumentMutation) triggerCommentPanelRefresh?.();
    };
const $9bf4a6e2087195a5$export$d38633fc53b44d7a = (params)=>{
    const { addSubscriber: addSubscriber, setContentId: setContentId, setContentType: setContentType, contentId: contentId, contentType: contentType } = params;
    if (!addSubscriber || !setContentId || !setContentType) return [];
    setContentType(contentType ?? 'page');
    setContentId(contentId);
    const subscribers = [
        {
            subscriberId: 'inlineReactionsPubSubInlineReactionAdded',
            onSubscriptionData: $9bf4a6e2087195a5$export$f6be9c59a276eaed(params),
            delta: $9bf4a6e2087195a5$export$717f531ab7512f5.InlineReactionAdded
        },
        {
            subscriberId: 'inlineReactionsPubSubInlineReactionRemoved',
            onSubscriptionData: $9bf4a6e2087195a5$export$1898285831c18448(params),
            delta: $9bf4a6e2087195a5$export$717f531ab7512f5.InlineReactionRemoved
        },
        {
            subscriberId: 'inlineReactionsPubSubInlineReactionHighlightDeleted',
            onSubscriptionData: $9bf4a6e2087195a5$export$32d640d739a62937(params),
            delta: $9bf4a6e2087195a5$export$717f531ab7512f5.InlineReactionHighlightDeleted
        },
        {
            subscriberId: 'inlineReactionsPubSubInlineCommentUnresolved',
            onSubscriptionData: $9bf4a6e2087195a5$export$c2d03eb6dc018515(params),
            delta: $9bf4a6e2087195a5$export$717f531ab7512f5.InlineCommentUnresolved
        }
    ];
    return subscribers.map((subscriber)=>({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        }));
};
const $9bf4a6e2087195a5$export$3a14251eaaa9c59 = ({ subscriptions: subscriptions, removeSubscriber: removeSubscriber })=>{
    if (!removeSubscriber) return;
    for (const subscription of subscriptions)removeSubscriber(subscription);
};
module.exports["setUpInlineReactionsPubSub"] = $9bf4a6e2087195a5$export$d38633fc53b44d7a;
module.exports["removeInlineReactionsPubSub"] = $9bf4a6e2087195a5$export$3a14251eaaa9c59;

});

parcelRegister("Fp23B", function(module, exports) {
const $9ee5de976e30fe43$export$6d3de88194b88471 = (commentLocation)=>commentLocation?.__typename === 'InlineComment' || commentLocation?.type === 'INLINE';
const $9ee5de976e30fe43$export$3dddfff1fed5a7c2 = (comment)=>comment.location;
const $9ee5de976e30fe43$export$28c0031aa2072589 = (comment)=>{
    const bodyValue = comment.body?.value ?? '';
    if (bodyValue.trim() === '') return true;
    try {
        const adf = JSON.parse(bodyValue);
        if (adf?.type !== 'doc') return false;
        const content = adf?.content;
        return !content || content.length === 0 || content.length === 1 && content[0].type === 'paragraph' && (!content[0].content || content[0].content.length === 0);
    } catch  {
        return false;
    }
};
const $9ee5de976e30fe43$export$9370221b5262a105 = (comment)=>{
    // Must be a root comment (no parentId)
    if (comment.parentId) return false;
    // Must be an inline comment location
    const commentLocation = $9ee5de976e30fe43$export$3dddfff1fed5a7c2(comment);
    if (!$9ee5de976e30fe43$export$6d3de88194b88471(commentLocation)) return false;
    // Must have a non-empty reactions summary
    if (!comment.reactionsSummary || comment.reactionsSummary.reactionsCount <= 0) return false;
    return $9ee5de976e30fe43$export$28c0031aa2072589(comment);
};
module.exports["isInlineReactionThread"] = $9ee5de976e30fe43$export$9370221b5262a105;

});

parcelRegister("37gNP", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $5h5pD = parcelRequire("5h5pD");

const $fe529059116505e2$var$logger = (0, $7W8i8.getLogger)('syncInlineReactionCommentToPanel');
const $fe529059116505e2$var$isRootComment = (comment)=>Boolean(comment && 'replies' in comment);
const $fe529059116505e2$export$280a33f7628a3cde = async ({ commentId: commentId, contentId: contentId, pageMode: pageMode, fetchCommentById: fetchCommentById, addCommentInCache: addCommentInCache, getCommentsDataFromCache: getCommentsDataFromCache, processCommentsData: processCommentsData })=>{
    if (!fetchCommentById || !addCommentInCache || !getCommentsDataFromCache || !processCommentsData) {
        const missingCallbacks = [
            !fetchCommentById && 'fetchCommentById',
            !addCommentInCache && 'addCommentInCache',
            !getCommentsDataFromCache && 'getCommentsDataFromCache',
            !processCommentsData && 'processCommentsData'
        ].filter(Boolean);
        $fe529059116505e2$var$logger.warn`Skipping inline reaction comments panel sync because required callbacks are missing: ${missingCallbacks.join(', ')}`;
        return;
    }
    try {
        const numericCommentId = (0, $5h5pD.extractNumericCommentId)(commentId);
        const comment = await fetchCommentById({
            commentId: numericCommentId,
            contentId: contentId,
            fetchPolicy: 'network-only'
        });
        if (!$fe529059116505e2$var$isRootComment(comment)) {
            $fe529059116505e2$var$logger.warn`Skipping comments panel sync for inline reaction: fetchCommentById returned an unexpected shape for comment ${numericCommentId} (null, undefined, or reply-only)`;
            return;
        }
        addCommentInCache({
            newComment: comment
        });
        const updatedCommentsData = getCommentsDataFromCache(contentId);
        processCommentsData({
            data: updatedCommentsData,
            pageMode: pageMode
        });
    } catch (error) {
        // TODO ACTIVATION-2708: replace with proper experience tracking to match inline comments.
        $fe529059116505e2$var$logger.warn`Failed to update comments panel data for inline reaction: ${error instanceof Error ? error : new Error(String(error))}`;
    }
};
module.exports["syncInlineReactionCommentToPanel"] = $fe529059116505e2$export$280a33f7628a3cde;

});

parcelRegister("gHDPx", function(module, exports) {

let $c28f8ef9f4e376b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c28f8ef9f4e376b8$var$load("7TMgc"),
    $c28f8ef9f4e376b8$var$load("iYvvi"),
    $c28f8ef9f4e376b8$var$load("eWXZF"),
    $c28f8ef9f4e376b8$var$load("7I4uK"),
    $c28f8ef9f4e376b8$var$load("hUbK8"),
    $c28f8ef9f4e376b8$var$load("6wr18"),
    $c28f8ef9f4e376b8$var$load("kfpjk"),
    $c28f8ef9f4e376b8$var$load("46Rej"),
    $c28f8ef9f4e376b8$var$load("5rU1Y"),
    $c28f8ef9f4e376b8$var$load("lHIG6"),
    $c28f8ef9f4e376b8$var$load("lqyPk"),
    $c28f8ef9f4e376b8$var$load("1jVx9"),
    $c28f8ef9f4e376b8$var$load("7qCqs"),
    $c28f8ef9f4e376b8$var$load("Oocfq"),
    $c28f8ef9f4e376b8$var$load("7BITa"),
    $c28f8ef9f4e376b8$var$load("3Nd0K"),
    $c28f8ef9f4e376b8$var$load("lcAZ1"),
    $c28f8ef9f4e376b8$var$load("2DxYV"),
    $c28f8ef9f4e376b8$var$load("2bOpC"),
    $c28f8ef9f4e376b8$var$load("iOSMk"),
    $c28f8ef9f4e376b8$var$load("5PoQp"),
    $c28f8ef9f4e376b8$var$load("7SteV"),
    $c28f8ef9f4e376b8$var$load("Msrsx"),
    $c28f8ef9f4e376b8$var$load("211bN"),
    $c28f8ef9f4e376b8$var$load("3Xf9v"),
    $c28f8ef9f4e376b8$var$load("gft53"),
    $c28f8ef9f4e376b8$var$load("2j57H"),
    $c28f8ef9f4e376b8$var$load("c0XG0"),
    $c28f8ef9f4e376b8$var$load("lJP3e"),
    $c28f8ef9f4e376b8$var$load("2ol93"),
    $c28f8ef9f4e376b8$var$load("03zSE"),
    $c28f8ef9f4e376b8$var$load("b9Ivi"),
    $c28f8ef9f4e376b8$var$load("lPKve"),
    $c28f8ef9f4e376b8$var$load("dmzjI"),
    $c28f8ef9f4e376b8$var$load("f7eY1"),
    $c28f8ef9f4e376b8$var$load("kedWY"),
    $c28f8ef9f4e376b8$var$load("5Qxj8"),
    $c28f8ef9f4e376b8$var$load("bABRe"),
    $c28f8ef9f4e376b8$var$load("3UmlS"),
    $c28f8ef9f4e376b8$var$load("a1ETE"),
    $c28f8ef9f4e376b8$var$load("60a9E"),
    $c28f8ef9f4e376b8$var$load("jPAfq"),
    $c28f8ef9f4e376b8$var$load("VXbA1"),
    $c28f8ef9f4e376b8$var$load("jqoep"),
    $c28f8ef9f4e376b8$var$load("j5aD5"),
    $c28f8ef9f4e376b8$var$load("gWjIZ"),
    $c28f8ef9f4e376b8$var$load("1yVM6"),
    $c28f8ef9f4e376b8$var$load("7EorR"),
    $c28f8ef9f4e376b8$var$load("hhss7"),
    $c28f8ef9f4e376b8$var$load("dxcsb"),
    $c28f8ef9f4e376b8$var$load("9TOep"),
    $c28f8ef9f4e376b8$var$load("7qcPK"),
    $c28f8ef9f4e376b8$var$load("ffEVr"),
    $c28f8ef9f4e376b8$var$load("jNr09"),
    $c28f8ef9f4e376b8$var$load("9xmQ5"),
    $c28f8ef9f4e376b8$var$load("gl4lh")
]).then(()=>parcelRequire('11FDr'));

});

parcelRegister("kxrtD", function(module, exports) {

let $ef3c34117ebcfc38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ef3c34117ebcfc38$var$load("46Rej"),
    $ef3c34117ebcfc38$var$load("30b92"),
    $ef3c34117ebcfc38$var$load("jNr09"),
    $ef3c34117ebcfc38$var$load("9xmQ5"),
    $ef3c34117ebcfc38$var$load("iYvvi"),
    $ef3c34117ebcfc38$var$load("eWXZF"),
    $ef3c34117ebcfc38$var$load("6wr18"),
    $ef3c34117ebcfc38$var$load("kfpjk"),
    $ef3c34117ebcfc38$var$load("jdmfD"),
    $ef3c34117ebcfc38$var$load("lqyPk"),
    $ef3c34117ebcfc38$var$load("1jVx9"),
    $ef3c34117ebcfc38$var$load("7qCqs"),
    $ef3c34117ebcfc38$var$load("7Y0AX"),
    $ef3c34117ebcfc38$var$load("1GCFv"),
    $ef3c34117ebcfc38$var$load("cJsay"),
    $ef3c34117ebcfc38$var$load("2bOpC"),
    $ef3c34117ebcfc38$var$load("iOSMk"),
    $ef3c34117ebcfc38$var$load("dV54p"),
    $ef3c34117ebcfc38$var$load("ffEVr"),
    $ef3c34117ebcfc38$var$load("hhss7"),
    $ef3c34117ebcfc38$var$load("7EorR"),
    $ef3c34117ebcfc38$var$load("jqoep"),
    $ef3c34117ebcfc38$var$load("18ilu")
]).then(()=>parcelRequire('3Xs7k'));

});

parcelRegister("3BQbc", function(module, exports) {

let $2a0d4d99e9917243$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2a0d4d99e9917243$var$load("lGCYm"),
    $2a0d4d99e9917243$var$load("hwZxn"),
    $2a0d4d99e9917243$var$load("jPAfq"),
    $2a0d4d99e9917243$var$load("30b92"),
    $2a0d4d99e9917243$var$load("kYIow"),
    $2a0d4d99e9917243$var$load("jNr09"),
    $2a0d4d99e9917243$var$load("9xmQ5"),
    $2a0d4d99e9917243$var$load("iYvvi"),
    $2a0d4d99e9917243$var$load("eWXZF"),
    $2a0d4d99e9917243$var$load("fWCBZ"),
    $2a0d4d99e9917243$var$load("6wr18"),
    $2a0d4d99e9917243$var$load("kfpjk"),
    $2a0d4d99e9917243$var$load("1jVx9"),
    $2a0d4d99e9917243$var$load("lK9vp"),
    $2a0d4d99e9917243$var$load("50xKF"),
    $2a0d4d99e9917243$var$load("7qCqs"),
    $2a0d4d99e9917243$var$load("7Y0AX"),
    $2a0d4d99e9917243$var$load("1GCFv"),
    $2a0d4d99e9917243$var$load("cJsay"),
    $2a0d4d99e9917243$var$load("2bOpC"),
    $2a0d4d99e9917243$var$load("aIw3f"),
    $2a0d4d99e9917243$var$load("iOSMk"),
    $2a0d4d99e9917243$var$load("2HkZg"),
    $2a0d4d99e9917243$var$load("9TOep"),
    $2a0d4d99e9917243$var$load("hhss7"),
    $2a0d4d99e9917243$var$load("7EorR"),
    $2a0d4d99e9917243$var$load("jqoep"),
    $2a0d4d99e9917243$var$load("ffEVr"),
    $2a0d4d99e9917243$var$load("icLYb"),
    $2a0d4d99e9917243$var$load("6TLS9"),
    $2a0d4d99e9917243$var$load("kPE95"),
    $2a0d4d99e9917243$var$load("frgRG"),
    $2a0d4d99e9917243$var$load("ckVWI"),
    $2a0d4d99e9917243$var$load("lpzz1")
]).then(()=>parcelRequire('fZ65r'));

});

parcelRegister("3EC4N", function(module, exports) {

let $2a92a4b63a5a59f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a92a4b63a5a59f2$var$load("l1bfS").then(()=>parcelRequire('4K1uG'));

});

parcelRegister("5dnlf", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ // We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("lginF");
var $81AxR = parcelRequire("81AxR");


var $kSwu1 = parcelRequire("kSwu1");

const $407fdba28f01fe31$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: "content-renderer.inlineComment.marker.start",
        defaultMessage: "inline comment start"
    },
    contentRendererInlineCommentMarkerEnd: {
        id: "content-renderer.inlineComment.marker.end",
        defaultMessage: "inline comment end"
    }
});
/* Yellow highlights*/ const $407fdba28f01fe31$var$highlightStyle = (intl, isFabric)=>(0, $81AxR.default)`
	cursor: pointer;
	background-color: ${isFabric ? "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" : "var(--ds-background-accent-yellow-subtler, #F5E989)"};
	border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
	&.active-highlight {
		background-color: ${"var(--ds-background-accent-yellow-subtle, #EED12B)"};
		border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
		box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
	}

	/* Accessibility markers for screen readers: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/mark#accessibility_concerns */
	&::before,
	&::after {
		clip-path: inset(100%);
		clip: rect(1px, 1px, 1px, 1px);
		height: 1px;
		overflow: hidden;
		position: absolute;
		white-space: nowrap;
		width: 1px;
	}

	&.first-mark-highlight::before {
		content: ' [${intl.formatMessage($407fdba28f01fe31$export$defe85febe8b728c.contentRendererInlineCommentMarkerStart)}] ';
	}

	&.last-mark-highlight::after {
		content: ' [${intl.formatMessage($407fdba28f01fe31$export$defe85febe8b728c.contentRendererInlineCommentMarkerEnd)}] ';
	}
`;
const $407fdba28f01fe31$export$ff7bdbeb01ad8e1f = (markerRefs, isFabric, intl)=>{
    const combinedStyles = {
        ...$407fdba28f01fe31$export$b2855f2a39bd93e8(intl) // Include the SPA styles
    };
    // Add SSR-style direct marker ref targeting
    markerRefs.forEach((markerRef)=>{
        const attribute = isFabric ? 'id' : 'ref';
        const selector = isFabric ? `mark[data-${attribute}="${markerRef}"]` : `span[data-${attribute}="${markerRef}"]`;
        combinedStyles[selector] = $407fdba28f01fe31$var$highlightStyle(intl, isFabric);
    });
    return combinedStyles;
};
const $407fdba28f01fe31$export$b2855f2a39bd93e8 = (intl)=>(0, $81AxR.default)`
	div[mode='stick'] {
		z-index: 1;
		background: ${"var(--ds-background-inverse-subtle, #00000029)"};
	}

	span {
		&.inline-highlight {
			${$407fdba28f01fe31$var$highlightStyle(intl)}
		}

		&.inline-create-comment-selection {
			background-color: ${"var(--ds-background-accent-yellow-subtle, #EED12B)"};
			border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
			box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
		}
	}
`;
module.exports["messages"] = $407fdba28f01fe31$export$defe85febe8b728c;
module.exports["inlineHighlightStyles"] = $407fdba28f01fe31$export$ff7bdbeb01ad8e1f;
module.exports["inlineCommentStyles"] = $407fdba28f01fe31$export$b2855f2a39bd93e8;

});

parcelRegister("lginF", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("81AxR")).default);

var $cgTkH = parcelRequire("cgTkH");


var $cozmU = parcelRequire("cozmU");

parcelRequire("dM0vO");


var $206dM = parcelRequire("206dM");


var $lxV8r = parcelRequire("lxV8r");


var $bNoFS = parcelRequire("bNoFS");


var $3lHLp = parcelRequire("3lHLp");


var $81AxR = parcelRequire("81AxR");

var $f7a9599a00299e41$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $206dM.h).call(props, 'css')) // $FlowFixMe
    return (0, $cozmU.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $206dM.E);
    createElementArgArray[1] = (0, $206dM.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $cozmU.createElement).apply(null, createElementArgArray);
};
var $f7a9599a00299e41$var$warnedAboutCssPropForGlobal = false;
var $f7a9599a00299e41$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $206dM.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $cozmU.createElement)((0, $206dM.T).Consumer, null, function(theme) {
        var serialized = (0, $bNoFS.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $cozmU.createElement)($f7a9599a00299e41$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $bNoFS.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $cozmU.createElement)($f7a9599a00299e41$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $f7a9599a00299e41$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $3lHLp.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $lxV8r.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $cozmU.Component));
var $f7a9599a00299e41$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $81AxR.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $f7a9599a00299e41$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $f7a9599a00299e41$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $lxV8r.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f7a9599a00299e41$var$Noop = function Noop() {
    return null;
};
var $f7a9599a00299e41$export$9b9c0f9d9f3552b8 = (0, $206dM.w)(function(props, context) {
    return /*#__PURE__*/ (0, $cozmU.createElement)((0, $206dM.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $bNoFS.serializeStyles)(args, context.registered);
            (0, $lxV8r.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $f7a9599a00299e41$var$merge(context.registered, css, $f7a9599a00299e41$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $cozmU.createElement)($f7a9599a00299e41$var$Noop, null);
        return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), null, possiblyStyleElement, ele);
    });
});

});

parcelRegister("dM0vO", function(module, exports) {

var $3lHLp = parcelRequire("3lHLp");


var $7tFKg = parcelRequire("7tFKg");

parcelRequire("764xz");

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $a07027c373f947fa$var$delimiter = '/*|*/';
var $a07027c373f947fa$var$needle = $a07027c373f947fa$var$delimiter + '}';
function $a07027c373f947fa$var$toSheet(block) {
    if (block) $a07027c373f947fa$var$Sheet.current.insert(block + '}');
}
var $a07027c373f947fa$var$Sheet = {
    current: null
};
var $a07027c373f947fa$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $a07027c373f947fa$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $a07027c373f947fa$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $a07027c373f947fa$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $a07027c373f947fa$var$delimiter : '');
            }
        case -2:
            content.split($a07027c373f947fa$var$needle).forEach($a07027c373f947fa$var$toSheet);
    }
};
var $a07027c373f947fa$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $7tFKg.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($a07027c373f947fa$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $a07027c373f947fa$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $3lHLp.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $a07027c373f947fa$export$2e2bcd8739ae039 = $a07027c373f947fa$var$createCache;
module.exports["default"] = $a07027c373f947fa$export$2e2bcd8739ae039;

});

parcelRegister("3lHLp", function(module, exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $270547d726eea1d3$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $270547d726eea1d3$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $270547d726eea1d3$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $270547d726eea1d3$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $270547d726eea1d3$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();
module.exports["StyleSheet"] = $270547d726eea1d3$export$9d753cd7ae895cce;

});

parcelRegister("7tFKg", function(module, exports) {
function $571b9f941bd8a740$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $571b9f941bd8a740$export$2e2bcd8739ae039 = $571b9f941bd8a740$var$stylis_min;
module.exports["default"] = $571b9f941bd8a740$export$2e2bcd8739ae039;

});

parcelRegister("764xz", function(module, exports) {
var $52ac9d922628be6a$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $52ac9d922628be6a$export$2e2bcd8739ae039 = $52ac9d922628be6a$var$weakMemoize;

});

parcelRegister("206dM", function(module, exports) {
parcelRequire("cgTkH");


var $cozmU = parcelRequire("cozmU");


var $dM0vO = parcelRequire("dM0vO");


var $lxV8r = parcelRequire("lxV8r");


var $bNoFS = parcelRequire("bNoFS");

var $17506843aa74096e$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $17506843aa74096e$var$EmotionCacheContext = /*#__PURE__*/ (0, $cozmU.createContext)(// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $dM0vO.default)() : null);
var $17506843aa74096e$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $cozmU.createContext)({});
var $17506843aa74096e$export$e7094788287c5e9b = $17506843aa74096e$var$EmotionCacheContext.Provider;
var $17506843aa74096e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $cozmU.createElement)($17506843aa74096e$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $cozmU.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $17506843aa74096e$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $17506843aa74096e$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $17506843aa74096e$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $17506843aa74096e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($17506843aa74096e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$17506843aa74096e$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $17506843aa74096e$var$Noop = function Noop() {
    return null;
};
var $17506843aa74096e$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$17506843aa74096e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $lxV8r.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bNoFS.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $lxV8r.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($17506843aa74096e$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $17506843aa74096e$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $cozmU.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $cozmU.createElement)($17506843aa74096e$var$Noop, null);
    return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $17506843aa74096e$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $17506843aa74096e$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $cozmU.createElement)($17506843aa74096e$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $17506843aa74096e$var$render(cache, props, theme, ref);
    });
    return $17506843aa74096e$var$render(cache, props, null, ref);
});
module.exports["h"] = $17506843aa74096e$export$dda1d9f60106f0e9;
module.exports["T"] = $17506843aa74096e$export$971d5caa766a69d7;
module.exports["w"] = $17506843aa74096e$export$efccba1c4a2ef57b;
module.exports["c"] = $17506843aa74096e$export$db3b6bfb95261072;
module.exports["E"] = $17506843aa74096e$export$a9c23c6ac3fc3eca;

});

parcelRegister("bNoFS", function(module, exports) {

var $3zwHP = parcelRequire("3zwHP");


var $74JGu = parcelRequire("74JGu");


var $k6x20 = parcelRequire("k6x20");

var $89676927576878c3$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $89676927576878c3$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $89676927576878c3$var$hyphenateRegex = /[A-Z]|^ms/g;
var $89676927576878c3$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $89676927576878c3$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $89676927576878c3$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $89676927576878c3$var$processStyleName = (0, $k6x20.default)(function(styleName) {
    return $89676927576878c3$var$isCustomProperty(styleName) ? styleName : styleName.replace($89676927576878c3$var$hyphenateRegex, '-$&').toLowerCase();
});
var $89676927576878c3$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($89676927576878c3$var$animationRegex, function(match, p1, p2) {
                $89676927576878c3$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $89676927576878c3$var$cursor
                };
                return p1;
            });
    }
    if ((0, $74JGu.default)[key] !== 1 && !$89676927576878c3$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $89676927576878c3$var$contentValuePattern, $89676927576878c3$var$contentValues, $89676927576878c3$var$oldProcessStyleValue, $89676927576878c3$var$msPattern, $89676927576878c3$var$hyphenPattern, $89676927576878c3$var$hyphenatedCache;
var $89676927576878c3$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $89676927576878c3$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $89676927576878c3$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $89676927576878c3$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $89676927576878c3$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $89676927576878c3$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $89676927576878c3$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $89676927576878c3$var$cursor;
                var result = interpolation(mergedProps);
                $89676927576878c3$var$cursor = previousCursor;
                return $89676927576878c3$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $89676927576878c3$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $89676927576878c3$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($89676927576878c3$var$isProcessableValue(value)) string += $89676927576878c3$var$processStyleName(_key) + ":" + $89676927576878c3$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($89676927576878c3$var$isProcessableValue(value[_i])) string += $89676927576878c3$var$processStyleName(_key) + ":" + $89676927576878c3$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $89676927576878c3$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $89676927576878c3$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $89676927576878c3$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $89676927576878c3$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $89676927576878c3$var$cursor;
var $89676927576878c3$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $89676927576878c3$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $89676927576878c3$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $89676927576878c3$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $89676927576878c3$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $89676927576878c3$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3zwHP.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $89676927576878c3$var$cursor
    };
};
module.exports["serializeStyles"] = $89676927576878c3$export$6321afa313b251b5;

});

parcelRegister("3zwHP", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $299e02ae2b978e01$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $299e02ae2b978e01$export$2e2bcd8739ae039 = $299e02ae2b978e01$var$murmur2;
module.exports["default"] = $299e02ae2b978e01$export$2e2bcd8739ae039;

});

parcelRegister("74JGu", function(module, exports) {
var $0154540052a968a2$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $0154540052a968a2$export$2e2bcd8739ae039 = $0154540052a968a2$var$unitlessKeys;
module.exports["default"] = $0154540052a968a2$export$2e2bcd8739ae039;

});

parcelRegister("k6x20", function(module, exports) {
function $ea2dfd8c20a4504b$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $ea2dfd8c20a4504b$export$2e2bcd8739ae039 = $ea2dfd8c20a4504b$var$memoize;
module.exports["default"] = $ea2dfd8c20a4504b$export$2e2bcd8739ae039;

});

parcelRegister("81AxR", function(module, exports) {

var $hEGiT = parcelRequire("hEGiT");

function $5d7ac3d63e21a973$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $hEGiT.serializeStyles)(args);
}
var $5d7ac3d63e21a973$export$2e2bcd8739ae039 = $5d7ac3d63e21a973$var$css;
module.exports["default"] = $5d7ac3d63e21a973$export$2e2bcd8739ae039;

});

parcelRegister("hEGiT", function(module, exports) {

var $cmJIN = parcelRequire("cmJIN");


var $dTRLb = parcelRequire("dTRLb");


var $26x9I = parcelRequire("26x9I");

var $cda6fcb8f829184b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $cda6fcb8f829184b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $cda6fcb8f829184b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $cda6fcb8f829184b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $cda6fcb8f829184b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $cda6fcb8f829184b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $cda6fcb8f829184b$var$processStyleName = (0, $26x9I.default)(function(styleName) {
    return $cda6fcb8f829184b$var$isCustomProperty(styleName) ? styleName : styleName.replace($cda6fcb8f829184b$var$hyphenateRegex, '-$&').toLowerCase();
});
var $cda6fcb8f829184b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($cda6fcb8f829184b$var$animationRegex, function(match, p1, p2) {
                $cda6fcb8f829184b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $cda6fcb8f829184b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $dTRLb.default)[key] !== 1 && !$cda6fcb8f829184b$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $cda6fcb8f829184b$var$contentValuePattern, $cda6fcb8f829184b$var$contentValues, $cda6fcb8f829184b$var$oldProcessStyleValue, $cda6fcb8f829184b$var$msPattern, $cda6fcb8f829184b$var$hyphenPattern, $cda6fcb8f829184b$var$hyphenatedCache;
var $cda6fcb8f829184b$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $cda6fcb8f829184b$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $cda6fcb8f829184b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $cda6fcb8f829184b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $cda6fcb8f829184b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $cda6fcb8f829184b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $cda6fcb8f829184b$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $cda6fcb8f829184b$var$cursor;
                var result = interpolation(mergedProps);
                $cda6fcb8f829184b$var$cursor = previousCursor;
                return $cda6fcb8f829184b$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $cda6fcb8f829184b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $cda6fcb8f829184b$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($cda6fcb8f829184b$var$isProcessableValue(value)) string += $cda6fcb8f829184b$var$processStyleName(_key) + ":" + $cda6fcb8f829184b$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($cda6fcb8f829184b$var$isProcessableValue(value[_i])) string += $cda6fcb8f829184b$var$processStyleName(_key) + ":" + $cda6fcb8f829184b$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $cda6fcb8f829184b$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $cda6fcb8f829184b$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $cda6fcb8f829184b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $cda6fcb8f829184b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $cda6fcb8f829184b$var$cursor;
var $cda6fcb8f829184b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $cda6fcb8f829184b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $cda6fcb8f829184b$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $cda6fcb8f829184b$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $cda6fcb8f829184b$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $cda6fcb8f829184b$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $cmJIN.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $cda6fcb8f829184b$var$cursor
    };
};
module.exports["serializeStyles"] = $cda6fcb8f829184b$export$6321afa313b251b5;

});

parcelRegister("cmJIN", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $900b016eb18aed8c$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $900b016eb18aed8c$export$2e2bcd8739ae039 = $900b016eb18aed8c$var$murmur2;
module.exports["default"] = $900b016eb18aed8c$export$2e2bcd8739ae039;

});

parcelRegister("dTRLb", function(module, exports) {
var $a1ea1d0c0030b2fe$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $a1ea1d0c0030b2fe$export$2e2bcd8739ae039 = $a1ea1d0c0030b2fe$var$unitlessKeys;
module.exports["default"] = $a1ea1d0c0030b2fe$export$2e2bcd8739ae039;

});

parcelRegister("26x9I", function(module, exports) {
function $1885dc51d521499e$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $1885dc51d521499e$export$2e2bcd8739ae039 = $1885dc51d521499e$var$memoize;
module.exports["default"] = $1885dc51d521499e$export$2e2bcd8739ae039;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gXsSh", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");

function $fce7c419b91370d9$export$62d325d4ac84165c(WrappedComponent) {
    function WithRoutesContext(props) {
        const $ = (0, $bDgLe.c)(3);
        const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
        let t0;
        if ($[0] !== props || $[1] !== routesContext) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...routesContext,
                ...props
            });
            $[0] = props;
            $[1] = routesContext;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    WithRoutesContext.displayName = `withRoutesContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithRoutesContext;
}
module.exports["withRoutesContext"] = $fce7c419b91370d9$export$62d325d4ac84165c;

});

parcelRegister("hSHWm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("f0NfR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");

function $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a(WrappedComponent) {
    function WithSessionData(props) {
        const sessionData = (0, $bQm3c.useSessionData)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            sessionData: sessionData,
            ...props
        });
    }
    WithSessionData.displayName = `withSessionData(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithSessionData;
}
module.exports["withSessionData"] = $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a;

});

parcelRegister("1SPMi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $iTJtk = parcelRequire("iTJtk");


var $hcnuR = parcelRequire("hcnuR");


var $bQm3c = parcelRequire("bQm3c");


var $1P7Cq = parcelRequire("1P7Cq");


var $2SowE = parcelRequire("2SowE");


var $8ld8H = parcelRequire("8ld8H");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const nonProductionBuildAnalyticsAttributes = (0, $cozmU.useMemo)(()=>(0, $hcnuR.getNonProductionBuildAnalyticsAttributes)(()=>renderServerPlaceholder ? undefined : (0, $8ld8H.getConfluenceNonProductionBuild)()), [
        renderServerPlaceholder
    ]);
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            if (nonProductionBuildAnalyticsAttributes.isNonProductionBuild !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, nonProductionBuildAnalyticsAttributes);
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source,
        nonProductionBuildAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("hcnuR", function(module, exports) {
const $62bc818b780bdfc1$export$68a914b05fdf9ed1 = (classification)=>{
    const isNonProductionBuild = typeof classification === 'function' ? classification() : classification;
    return isNonProductionBuild !== undefined ? {
        isNonProductionBuild: isNonProductionBuild
    } : {};
};
module.exports["getNonProductionBuildAnalyticsAttributes"] = $62bc818b780bdfc1$export$68a914b05fdf9ed1;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("8ld8H", function(module, exports) {

var $eSuZj = parcelRequire("eSuZj");


var $68uaC = parcelRequire("68uaC");

const $ca70a3574c04adc8$var$BRANCH_COOKIE = 'useFrontendBranch';
const $ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE = 'bifrost-override';
const $ca70a3574c04adc8$var$isActiveBranchCookie = (value)=>{
    if (!value || value === 'off') return false;
    const override = JSON.parse(value);
    if (!override || typeof override !== 'object' || Array.isArray(override)) return undefined;
    const version = override?.['cc-fe-bifrost']?.version ?? override?.version;
    if (version === undefined) return false;
    return typeof version === 'string' ? Boolean(version && version !== 'off' && version !== 'CLASSIC-off-off') : undefined;
};
const $ca70a3574c04adc8$export$89ba981936f5422e = ()=>{
    try {
        const { RELEASE_TRACK: RELEASE_TRACK } = (0, $eSuZj.getBuildInfo)();
        if (RELEASE_TRACK === 'dev' || RELEASE_TRACK === 'staging') return true;
        if (![
            'prod',
            'hello',
            'canary'
        ].includes(RELEASE_TRACK)) return undefined;
        if (window.__SSR_RENDERED__) {
            let bifrostOverride;
            try {
                bifrostOverride = (0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE);
            } catch  {
            // Fall back to the frontend branch cookie if the Bifrost cookie cannot be read.
            }
            if (bifrostOverride) return $ca70a3574c04adc8$var$isActiveBranchCookie(bifrostOverride);
        }
        const branchVersion = (0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BRANCH_COOKIE);
        return Boolean(branchVersion && branchVersion !== 'off');
    } catch  {
        return undefined;
    }
};
module.exports["getConfluenceNonProductionBuild"] = $ca70a3574c04adc8$export$89ba981936f5422e;

});

parcelRegister("fySJw", function(module, exports) {

var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");


var $1AM4E = parcelRequire("1AM4E");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("4ekNI"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const transfer = {
                extensionKey: extensionKey,
                localId: localId,
                data: data,
                isViewPage: isViewPage
            };
            const isTrackable = (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).isTrackable(transfer);
            let didStartExperience = false;
            const shouldTrack = isTrackable;
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("4ekNI"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (shouldTrack && !didStartExperience && !(e instanceof DataTransferValidationError)) {
                    (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                    didStartExperience = true;
                }
                if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).fail(e instanceof Error ? e : String(e));
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            if (shouldTrack && !didStartExperience) {
                (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                didStartExperience = true;
            }
            this.emit(localId, data.eventData);
            if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).succeed();
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    const defaultWrmResources = $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES;
    const staticConnectWrmResources = $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES;
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...defaultWrmResources
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...defaultWrmResources,
            ...staticConnectWrmResources,
            ...contexts,
            ...keys
        ];
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    /* oxlint-disable-next-line eslint-core/no-restricted-syntax */ // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $1i7uI = parcelRequire("1i7uI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    let jiraADFNode = null;
    try {
        // fetch ADF structure of JIM, and modify it to provide to editor later
        jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    } catch (error) {
        // The placeholder endpoint does not honour a share token, so it 404s for these viewers.
        // Letting it reject would take the whole extension provider down with it.
        const isAccessLinkViewer = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location?.pathname && (0, $1NBp8.ACCESS_LINK).match((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location.pathname)) && (0, $6mKj3.expValEquals)('access_link_m2', 'isEnabled', true);
        if (!isAccessLinkViewer) throw error;
    }
    if (!jiraADFNode) return ()=>null;
    const resolvedJiraADFNode = jiraADFNode;
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, resolvedJiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("foRF9", function(module, exports) {

var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl } = options;
    const results = await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)({
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    });
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    // A failed request resolves to an empty `json`, so the parse above throws and leaves this unset.
    // Continuing would build an `attrs`-less node and crash in `formatAsMacroAttributes` instead,
    // which reads as a macro bug rather than the failed fetch it actually is.
    if (!placeholderAdf) throw new Error('Macro placeholder ADF unavailable');
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("iS5Ay", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $6kV7w = parcelRequire("6kV7w");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $7m1pr = parcelRequire("7m1pr");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $7m1pr.RelayError)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return (0, $7m1pr.createGraphQLError)(message, {
        path: null,
        originalError: originalError,
        extensions: extensions
    });
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    LIST_LABELS: 'listlabels',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block',
    VIEWXLS: 'viewxls'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIST_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWXLS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.HIDE
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("aMlgD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $lPJNC = parcelRequire("lPJNC");


var $l0P92 = parcelRequire("l0P92");


var $12FeT = parcelRequire("12FeT");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $kSwu1.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a link to anywhere"
    },
    opsgenieAttribution: {
        id: "fabric-extension-lib.quick-insert.preview-attribution.opsgenie",
        defaultMessage: "Opsgenie"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items (Child pages)"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "Display a custom list of content nested under a page or live doc."
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties (Page properties)"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Enter a table of summary information in this macro and display it on another page or live doc using a content properties report macro. You will need to add a label to this content and specify it in the report macro."
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree (Page tree)"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree."
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content (Include page)"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Display the full contents of a page or live doc."
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report (Page properties report)"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Display a table of pages and live docs that contain a content properties macro and a specific label. The table includes a link to each item and the summary from the macro on that page or doc."
    },
    jiraMacroTitle: {
        id: "fabric-extension-lib.jira.title",
        defaultMessage: "Jira Data Center"
    },
    jiraMacroDescription: {
        id: "fabric-extension-lib.jira.description",
        defaultMessage: "Insert Jira work items from Data Center via JQL"
    }
});
const $123431e233f03ed6$export$9f32ba550957708c = (preview, intl)=>{
    const { attribution: attribution, ...previewWithoutAttribution } = preview;
    if (!attribution) return previewWithoutAttribution;
    return {
        ...previewWithoutAttribution,
        attribution: {
            name: intl.formatMessage(attribution.message),
            ...attribution.icon ? {
                icon: attribution.icon
            } : {}
        }
    };
};
const $123431e233f03ed6$var$macroQuickInsertPreviewOverrides = {
    iframe: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI8.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLM.png'
        }
    },
    'blog-posts': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIU.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLJ.png'
        }
    },
    'change-history': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIA.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMK.png'
        }
    },
    children: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIP.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVME.png'
        }
    },
    details: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIQ.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLR.png'
        }
    },
    detailssummary: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIS.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM9.png'
        }
    },
    'content-report-table': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI6.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMC.png'
        }
    },
    pagetree: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIV.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNC.png'
        }
    },
    contributors: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ0.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL1.png'
        }
    },
    decisionreport: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHF.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMF.png'
        }
    },
    contentbylabel: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIX.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKY.png'
        }
    },
    listlabels: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHS.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMI.png'
        }
    },
    livesearch: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIL.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL4.png'
        }
    },
    pagetreesearch: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK0.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMB.png'
        }
    },
    'popular-labels': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ4.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKR.png'
        }
    },
    'questionslist-macro-native': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHQ.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMH.png'
        }
    },
    'recently-updated': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ5.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKX.png'
        }
    },
    'tasks-report-macro': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHJ.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL3.png'
        }
    },
    calendar: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ8.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM5.png'
        }
    },
    userlister: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ3.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLH.png'
        }
    },
    profile: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI1.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVML.png'
        }
    },
    excerpt: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJT.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLX.png'
        }
    },
    'excerpt-include': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJR.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVN9.png'
        }
    },
    include: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHV.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNP.png'
        }
    },
    jirachart: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionJira,
            icon: (0, $12FeT.JiraAttributionIcon)
        }
    },
    jira: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionJira,
            icon: (0, $12FeT.JiraAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJW.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVND.png'
        }
    },
    portfolioforjiraplan: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionJira,
            icon: (0, $12FeT.JiraAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJX.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNF.png'
        }
    },
    'opsgenie-incident-timeline-eu-macro': {
        attribution: {
            message: $123431e233f03ed6$var$i18n.opsgenieAttribution
        }
    },
    'sharelinks-urlmacro': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHZ.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL7.png'
        }
    },
    'toc-zone': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJS.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNE.png'
        }
    },
    viewpdf: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        }
    },
    viewxls: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionMicrosoft
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIW.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL2.png'
        }
    },
    'profile-picture': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIN.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLS.png'
        }
    },
    anchor: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHH.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKZ.png'
        }
    },
    toc: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJG.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMX.png'
        }
    },
    'create-from-template': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OZ55.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OZ54.png'
        }
    },
    widget: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        }
    },
    roadmap: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        }
    },
    attachments: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        }
    }
};
const $123431e233f03ed6$export$4752f1531f8f7b08 = (extensionKey, intl)=>{
    const preview = $123431e233f03ed6$var$macroQuickInsertPreviewOverrides[extensionKey];
    return preview ? $123431e233f03ed6$export$9f32ba550957708c(preview, intl) : undefined;
};
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroTitle);
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["localizeQuickInsertPreview"] = $123431e233f03ed6$export$9f32ba550957708c;
module.exports["getMacroQuickInsertPreviewOverride"] = $123431e233f03ed6$export$4752f1531f8f7b08;
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("l0P92", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $b70fc362a02fef99$export$f5752395a477e5ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.confluenceIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.confluenceIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["ConfluenceAttributionIcon"] = $b70fc362a02fef99$export$f5752395a477e5ed;

});

parcelRegister("kp580", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb0b17085479d6a47c0256168de66f61>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ const $eec4d9b8943404d8$export$82d1529631ebf0fd = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$f936b2d6e392668e = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z'/> </svg> ";
const $eec4d9b8943404d8$export$ef4515a2b2e64fb9 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z'/> </svg> ";
const $eec4d9b8943404d8$export$e46fc5b9f36b0a2a = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727' clip-rule='evenodd'/> <path fill='%23101214' d='M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z'/> </svg> ";
const $eec4d9b8943404d8$export$937778b9dd7a3235 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z'/> </svg> ";
const $eec4d9b8943404d8$export$d994760fc7f4d251 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578'/> </svg> ";
const $eec4d9b8943404d8$export$4ed1e309cbc9944e = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582'/> </svg> ";
const $eec4d9b8943404d8$export$f082a360c4afba79 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$8d3a8a08ef6ddfb7 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 82 82'> <path fill='%2394c748' d='M0 20.5C0 9.178 9.178 0 20.5 0h41C72.822 0 82 9.178 82 20.5v41C82 72.822 72.822 82 61.5 82h-41C9.178 82 0 72.822 0 61.5z'/> <path fill='%23101214' d='M24.6 23.78h24.6v26.24H24.6z'/> <path fill='%23101214' fill-rule='evenodd' d='M36.762 56.548c-10.927 0-19.785-8.858-19.785-19.786 0-10.927 8.858-19.785 19.785-19.785 10.928 0 19.786 8.858 19.786 19.785 0 3.55-.934 6.88-2.57 9.76l11.624 11.625-7.533 7.533-11.647-11.646a19.7 19.7 0 0 1-9.66 2.514m-.933-32.014-.828 2.103c-1.175 2.987-1.763 4.481-2.848 5.606s-2.557 1.765-5.5 3.048l-1.26.549v1.74l1.26.548c2.943 1.282 4.415 1.924 5.5 3.048s1.673 2.619 2.849 5.607l.827 2.103h1.74l.827-2.104c1.176-2.987 1.764-4.481 2.848-5.606 1.085-1.124 2.557-1.766 5.5-3.048l1.26-.549v-1.74l-1.26-.548c-2.943-1.283-4.415-1.924-5.5-3.048s-1.672-2.619-2.848-5.606l-.828-2.103z' clip-rule='evenodd'/> <g fill='%2394c748' clip-path='url(%23clip0_458_334619)'> <path d='m33.96 42.3-5.4-5.4 5.4-5.4-2.32-2.32-7.72 7.72 7.72 7.72zm5.88-10.8 5.4 5.4-5.4 5.4 2.32 2.32 7.72-7.72-7.72-7.72z'/> </g> <defs> <clipPath id='clip0_458_334619'> <path fill='%23fff' d='M17.22 17.22h39.36v39.36H17.22z'/> </clipPath> </defs> </svg> ";
const $eec4d9b8943404d8$export$591e8b3773b35267 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$a3743ca7417fb23c = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z'/> <path fill='%23101214' d='M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z'/> </svg> ";
const $eec4d9b8943404d8$export$c7c3bc01199c13a4 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617'/> </svg> ";
const $eec4d9b8943404d8$export$d522b359cb8c5c04 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673'/> </svg> ";
const $eec4d9b8943404d8$export$52ddff92dfaa8b68 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433'/> </svg> ";
const $eec4d9b8943404d8$export$9fbf2bb44326bb19 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$e293cb595239063c = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z'/> </svg> ";
const $eec4d9b8943404d8$export$d9455021fb3d272f = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <path fill='%2394c748' d='M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z'/> <path fill='%23101214' d='m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z'/> </svg> ";
const $eec4d9b8943404d8$export$3ed6243f17a53ae7 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <rect width='48' height='48' fill='%23c97cf4' rx='12'/> <path fill='%23101214' d='M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z'/> </svg> ";
const $eec4d9b8943404d8$export$2837c3a55abaa285 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z'/> </svg> ";
const $eec4d9b8943404d8$export$51f93e7b4b9eb293 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0'/> <path fill='%23101214' fill-rule='evenodd' d='M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$eb29548f99467d60 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649'/> </svg> ";
const $eec4d9b8943404d8$export$2aba1ca138d7bd07 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649'/> </svg> ";
const $eec4d9b8943404d8$export$2e2deae5fbafd37b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z'/> </svg> ";
const $eec4d9b8943404d8$export$c7a8f12525e3fb68 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 32 32'> <g clip-path='url(%23clip0_95164_16219)'> <path fill='%23dddee1' d='M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z'/> <g clip-path='url(%23clip1_95164_16219)'> <path fill='%23101214' fill-rule='evenodd' d='M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z' clip-rule='evenodd'/> </g> </g> <defs> <clipPath id='clip0_95164_16219'> <path fill='%23fff' d='M0 0h32v32H0z'/> </clipPath> <clipPath id='clip1_95164_16219'> <path fill='%23fff' d='M2 2h28v28H2z'/> </clipPath> </defs> </svg> ";
const $eec4d9b8943404d8$export$b24c6e7728e33086 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <path fill='%23dddee1' d='M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z'/> <path fill='%23101214' d='M36.5 37.5h-25v-4h25zM18.25 31h-6.5v-9h6.5zm9 0h-6.5V18h6.5zm2.53-13.93c1.15.51 1.46.72 1.66.93l.1.12c.24.3.47.82 1.12 2.47l.97 2.49h2.61V31h-6.5V17.06zm6.7-8.85c.68 1.73 1.01 2.59 1.64 3.24.62.65 1.47 1.02 3.16 1.76l.73.32v1.01l-.72.32q-.53.23-.96.43c-1.08.49-1.71.82-2.2 1.34l-.11.12c-.52.6-.85 1.39-1.4 2.82l-.12.3-.5 1.2h-1l-.48-1.22c-.25-.65-.46-1.17-.65-1.61-.32-.73-.6-1.22-.99-1.63-.5-.53-1.16-.87-2.28-1.37q-.26-.12-.57-.25l-.31-.14-.72-.32v-1.01l.73-.32c.61-.27 1.11-.49 1.53-.69l.18-.09q.11-.05.21-.11l.16-.09a7 7 0 0 0 .33-.19 5 5 0 0 0 .29-.2 4 4 0 0 0 .45-.39c.62-.65.96-1.51 1.64-3.24L35 7h1z'/> </svg> ";
const $eec4d9b8943404d8$export$817524b4a4c71959 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 55 55'> <path fill='%231868db' d='M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z'/> <path fill='%23fff' d='M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z'/> </svg> ";
const $eec4d9b8943404d8$export$645368f1ea0478bc = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z'/> </svg> ";
const $eec4d9b8943404d8$export$18c65aa2927f3995 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23c97cf4' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z'/> </svg> ";
const $eec4d9b8943404d8$export$8a1ee2e50fe5beb1 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 25 24'> <path fill='%23fff' d='M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5'/> <path stroke='%23dddee1' d='M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z'/> <path fill='%231868db' d='M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z'/> </svg> ";
const $eec4d9b8943404d8$export$b90ef39cc7d9d158 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z'/> </svg> ";
const $eec4d9b8943404d8$export$fa286aa7e20bed9b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z'/> </svg> ";
const $eec4d9b8943404d8$export$668450ac5134d2b8 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23625df5' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302'/> </svg> ";
const $eec4d9b8943404d8$export$ce29d3d34b2cdd71 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302'/> </svg> ";
const $eec4d9b8943404d8$export$24d80805366b7b8f = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z'/> </svg> ";
const $eec4d9b8943404d8$export$a07965903d0d8925 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848'/> </svg> ";
const $eec4d9b8943404d8$export$5d8aa0e5e461a369 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$6248e4308e35c81 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z'/> <path fill='%23fff' d='M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691'/> </svg> ";
const $eec4d9b8943404d8$export$5bde95973ddbe69b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678' clip-rule='evenodd'/> <path fill='%23101214' fill-rule='evenodd' d='M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$238fafeb4135d57 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z'/> <path fill='%23101214' d='M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75'/> </svg> ";
const $eec4d9b8943404d8$export$494586f00e0959f0 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$d82a05c5cfbe1aa1 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$8687ffcdea58e000 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$dc9f14a5d9a626e2 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68'/> </svg> ";
const $eec4d9b8943404d8$export$d2c4cddab147c0da = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z' clip-rule='evenodd'/> <path fill='%23101214' d='M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z'/> </svg> ";
const $eec4d9b8943404d8$export$eaf28ddd8a75ca21 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$2475d3c354c72640 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63'/> </svg> ";
const $eec4d9b8943404d8$export$a1ac7613cb802f12 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231558bc' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z'/> </svg> ";
const $eec4d9b8943404d8$export$750778568a97222d = {
    admin: $eec4d9b8943404d8$export$82d1529631ebf0fd,
    align: $eec4d9b8943404d8$export$f936b2d6e392668e,
    analytics: $eec4d9b8943404d8$export$ef4515a2b2e64fb9,
    assets: $eec4d9b8943404d8$export$e46fc5b9f36b0a2a,
    bamboo: $eec4d9b8943404d8$export$937778b9dd7a3235,
    bitbucketDataCenter: $eec4d9b8943404d8$export$d994760fc7f4d251,
    bitbucket: $eec4d9b8943404d8$export$4ed1e309cbc9944e,
    chat: $eec4d9b8943404d8$export$f082a360c4afba79,
    codeSearch: $eec4d9b8943404d8$export$8d3a8a08ef6ddfb7,
    companyHub: $eec4d9b8943404d8$export$591e8b3773b35267,
    compass: $eec4d9b8943404d8$export$a3743ca7417fb23c,
    confluenceDataCenter: $eec4d9b8943404d8$export$c7c3bc01199c13a4,
    confluence: $eec4d9b8943404d8$export$d522b359cb8c5c04,
    crowd: $eec4d9b8943404d8$export$52ddff92dfaa8b68,
    customLink: $eec4d9b8943404d8$export$9fbf2bb44326bb19,
    customerServiceManagement: $eec4d9b8943404d8$export$e293cb595239063c,
    dx: $eec4d9b8943404d8$export$d9455021fb3d272f,
    feedback: $eec4d9b8943404d8$export$3ed6243f17a53ae7,
    focus: $eec4d9b8943404d8$export$2837c3a55abaa285,
    goals: $eec4d9b8943404d8$export$51f93e7b4b9eb293,
    guardDetect: $eec4d9b8943404d8$export$eb29548f99467d60,
    guard: $eec4d9b8943404d8$export$2aba1ca138d7bd07,
    home: $eec4d9b8943404d8$export$2e2deae5fbafd37b,
    hub: $eec4d9b8943404d8$export$c7a8f12525e3fb68,
    insights: $eec4d9b8943404d8$export$b24c6e7728e33086,
    jiraCodingAgent: $eec4d9b8943404d8$export$817524b4a4c71959,
    jiraDataCenter: $eec4d9b8943404d8$export$645368f1ea0478bc,
    jiraProductDiscovery: $eec4d9b8943404d8$export$18c65aa2927f3995,
    jiraServiceManagementDataCenter: $eec4d9b8943404d8$export$8a1ee2e50fe5beb1,
    jiraServiceManagement: $eec4d9b8943404d8$export$b90ef39cc7d9d158,
    jira: $eec4d9b8943404d8$export$fa286aa7e20bed9b,
    loomInternal: $eec4d9b8943404d8$export$668450ac5134d2b8,
    loom: $eec4d9b8943404d8$export$ce29d3d34b2cdd71,
    moreAtlassianApps: $eec4d9b8943404d8$export$24d80805366b7b8f,
    opsgenie: $eec4d9b8943404d8$export$a07965903d0d8925,
    projects: $eec4d9b8943404d8$export$5d8aa0e5e461a369,
    rovoClassic: $eec4d9b8943404d8$export$6248e4308e35c81,
    rovoDevAgent: $eec4d9b8943404d8$export$5bde95973ddbe69b,
    rovoDev: $eec4d9b8943404d8$export$238fafeb4135d57,
    rovoHex: $eec4d9b8943404d8$export$494586f00e0959f0,
    rovo: $eec4d9b8943404d8$export$d82a05c5cfbe1aa1,
    search: $eec4d9b8943404d8$export$8687ffcdea58e000,
    statuspage: $eec4d9b8943404d8$export$dc9f14a5d9a626e2,
    studio: $eec4d9b8943404d8$export$d2c4cddab147c0da,
    talent: $eec4d9b8943404d8$export$eaf28ddd8a75ca21,
    teams: $eec4d9b8943404d8$export$2475d3c354c72640,
    trello: $eec4d9b8943404d8$export$a1ac7613cb802f12
};
module.exports["assetsIcon"] = $eec4d9b8943404d8$export$e46fc5b9f36b0a2a;
module.exports["bitbucketIcon"] = $eec4d9b8943404d8$export$4ed1e309cbc9944e;
module.exports["confluenceIcon"] = $eec4d9b8943404d8$export$d522b359cb8c5c04;
module.exports["feedbackIcon"] = $eec4d9b8943404d8$export$3ed6243f17a53ae7;
module.exports["focusIcon"] = $eec4d9b8943404d8$export$2837c3a55abaa285;
module.exports["goalsIcon"] = $eec4d9b8943404d8$export$51f93e7b4b9eb293;
module.exports["homeIcon"] = $eec4d9b8943404d8$export$2e2deae5fbafd37b;
module.exports["jiraProductDiscoveryIcon"] = $eec4d9b8943404d8$export$18c65aa2927f3995;
module.exports["jiraServiceManagementIcon"] = $eec4d9b8943404d8$export$b90ef39cc7d9d158;
module.exports["jiraIcon"] = $eec4d9b8943404d8$export$fa286aa7e20bed9b;
module.exports["loomIcon"] = $eec4d9b8943404d8$export$ce29d3d34b2cdd71;
module.exports["projectsIcon"] = $eec4d9b8943404d8$export$5d8aa0e5e461a369;
module.exports["rovoHexIcon"] = $eec4d9b8943404d8$export$494586f00e0959f0;
module.exports["studioIcon"] = $eec4d9b8943404d8$export$d2c4cddab147c0da;
module.exports["talentIcon"] = $eec4d9b8943404d8$export$eaf28ddd8a75ca21;
module.exports["teamsIcon"] = $eec4d9b8943404d8$export$2475d3c354c72640;
module.exports["trelloIcon"] = $eec4d9b8943404d8$export$a1ac7613cb802f12;

});

parcelRegister("12FeT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $da086be7599055eb$export$5a5b2410f606869 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.jiraIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.jiraIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["JiraAttributionIcon"] = $da086be7599055eb$export$5a5b2410f606869;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = attrs?.parameters ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    if (adf.attrs?.parameters) adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("1AM4E", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $b8656fd966301400$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $b8656fd966301400$export$9e19abdf0a0245fe = new class ConnectReferentialityExperienceTrackerSupport {
    isTrackable(transfer) {
        return Boolean(transfer?.extensionKey) && Boolean(transfer?.localId) && Boolean(transfer?.data);
    }
    start(transfer) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            attributes: {
                extensionKey: transfer?.extensionKey,
                isViewPage: transfer?.isViewPage
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            error: $b8656fd966301400$var$getError(messageOrError)
        });
    }
}();
module.exports["ConnectReferentialityExperienceTrackerSupport"] = $b8656fd966301400$export$9e19abdf0a0245fe;

});

parcelRegister("4ekNI", function(module, exports) {

let $31489ad81c5dfcf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $31489ad81c5dfcf6$var$load("g7Yjk"),
    $31489ad81c5dfcf6$var$load("iEvs6")
]).then(()=>parcelRequire('bppNh'));

});

parcelRegister("3QmmH", function(module, exports) {

let $2cc793af9b113daa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cc793af9b113daa$var$load("9a4Lf").then(()=>parcelRequire('1EipK'));

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("blsdD", function(module, exports) {
const $91a4a128f3ac2264$var$observations = new Map();
let $91a4a128f3ac2264$var$observer;
function $91a4a128f3ac2264$export$4d315c8c80147824(element, listener) {
    if (typeof window === 'undefined' || !window.ResizeObserver) return;
    $91a4a128f3ac2264$var$observer ?? ($91a4a128f3ac2264$var$observer = new ResizeObserver((entries)=>{
        for (const { target: target, contentRect: { height: height, width: width } } of entries){
            const observation = $91a4a128f3ac2264$var$observations.get(target);
            if (!observation || !Number.isFinite(height) || !Number.isFinite(width) || height < 0 || width < 0) continue;
            const dimensions = {
                height: Math.round(height),
                width: Math.round(width)
            };
            if (observation.dimensions?.height === dimensions.height && observation.dimensions?.width === dimensions.width) continue;
            observation.dimensions = dimensions;
            observation.listeners.forEach((notify)=>notify(dimensions));
        }
    }));
    let observation = $91a4a128f3ac2264$var$observations.get(element);
    if (!observation) {
        observation = {
            listeners: new Set()
        };
        $91a4a128f3ac2264$var$observations.set(element, observation);
        $91a4a128f3ac2264$var$observer.observe(element);
    }
    observation.listeners.add(listener);
    if (observation.dimensions) listener(observation.dimensions);
    return ()=>{
        if (!observation.listeners.delete(listener) || observation.listeners.size) return;
        $91a4a128f3ac2264$var$observer?.unobserve(element);
        $91a4a128f3ac2264$var$observations.delete(element);
        if (!$91a4a128f3ac2264$var$observations.size) {
            $91a4a128f3ac2264$var$observer?.disconnect();
            $91a4a128f3ac2264$var$observer = undefined;
        }
    };
}
module.exports["observeElementDimensions"] = $91a4a128f3ac2264$export$4d315c8c80147824;

});

parcelRegister("7W9kD", function(module, exports) {

var $blsdD = parcelRequire("blsdD");

const $9f0ae7ee0cebc5b7$var$registrations = new Map();
// Bound the addition to the existing UFO payload, even on tenants with many apps.
const $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS = 50;
const $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b = (element, source, extensionId)=>{
    if (!extensionId || !window.ResizeObserver) return;
    $9f0ae7ee0cebc5b7$var$registrations.get(element)?.stop?.();
    const registration = {
        source: source,
        extensionId: extensionId
    };
    $9f0ae7ee0cebc5b7$var$registrations.set(element, registration);
    registration.stop = (0, $blsdD.observeElementDimensions)(element, (dimensions)=>{
        registration.dimensions = dimensions;
    });
    return ()=>{
        if ($9f0ae7ee0cebc5b7$var$registrations.get(element) !== registration) return;
        registration.stop?.();
        $9f0ae7ee0cebc5b7$var$registrations.delete(element);
    };
};
const $9f0ae7ee0cebc5b7$export$e4b460b98000468c = ()=>{
    const groups = new Map();
    for (const [element, { source: source, extensionId: extensionId, dimensions: dimensions }] of $9f0ae7ee0cebc5b7$var$registrations){
        if (!element.isConnected || !dimensions) continue;
        const group = groups.get(source) ?? new Map();
        group.set(extensionId, {
            ...dimensions
        });
        groups.set(source, group);
    }
    let reported = 0;
    let omitted = 0;
    const extensionDimensions = Object.fromEntries(Array.from(groups, ([source, dimensions])=>[
            source,
            Object.fromEntries(Array.from(dimensions).filter(()=>{
                if (reported < $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS) {
                    reported++;
                    return true;
                }
                omitted++;
                return false;
            }))
        ]));
    return {
        extensionDimensions: extensionDimensions,
        ...omitted ? {
            extensionDimensionsOmittedCount: omitted
        } : {}
    };
};
module.exports["observeExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b;
module.exports["getExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$e4b460b98000468c;

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)();
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $7m1pr = parcelRequire("7m1pr");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $7m1pr.RelayError)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("dYU3e", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $iffSy = parcelRequire("iffSy");



var $7Lnfv = parcelRequire("7Lnfv");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$addExtraInfoToError = (error, extraInfo)=>{
    try {
        const existingExtraInfo = Reflect.get(error, 'extraInfo');
        const existingExtraInfoObject = typeof existingExtraInfo === 'object' && existingExtraInfo !== null ? existingExtraInfo : undefined;
        Reflect.set(error, 'extraInfo', {
            ...existingExtraInfoObject,
            ...extraInfo
        });
    } catch  {
    // Some error shapes can be non-extensible. Extra info is best-effort diagnostics.
    }
};
const $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors = (errors, extraInfo)=>{
    errors?.forEach((error)=>{
        $48ba6fb41a85dc7e$var$addExtraInfoToError(error, extraInfo);
    });
};
const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__, relayQueryPreloadRetention: relayQueryPreloadRetention }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    const preloaderErrorExtraInfo = {
        operationName: name ?? 'unknown',
        callerPackage: __callerPackage__
    };
    const queryContext = {
        ...context
    };
    queryContext.headers = {
        ...context?.headers,
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__,
        relayQueryPreloadRetention: relayQueryPreloadRetention
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        if (result.error) $48ba6fb41a85dc7e$var$addExtraInfoToError(result.error, preloaderErrorExtraInfo);
        $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors(errors, preloaderErrorExtraInfo);
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeAggQuery"] = $48ba6fb41a85dc7e$export$5e270d77b1b480de;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("5SzHz", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("2iGHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b090c2970a43735$export$2e2bcd8739ae039);
var $3b090c2970a43735$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("2khPJ", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/user/manifest.ts
var $1b1b4861ffbabf45$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $1b1b4861ffbabf45$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9j37t.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $1b1b4861ffbabf45$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("dBcar", function(module, exports) {

var $5AFnD = parcelRequire("5AFnD");

const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804),
    (0, $5AFnD.LOOM_NUDGE_REMIND_ME),
    (0, $5AFnD.LOOM_NUDGE_LAST_SHOWN_AT)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("5AFnD", function(module, exports) {
const $00e2d16f0c5935d6$export$477408ab8b02b670 = 'twcg-2202-loom-nudge:remindMe';
const $00e2d16f0c5935d6$export$c98b33a7293cedf4 = 'twcg-2202-loom-nudge:lastShownAt';
module.exports["LOOM_NUDGE_REMIND_ME"] = $00e2d16f0c5935d6$export$477408ab8b02b670;
module.exports["LOOM_NUDGE_LAST_SHOWN_AT"] = $00e2d16f0c5935d6$export$c98b33a7293cedf4;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$53635c098825d80c = 'system.attachment';
const $0673dc41d4591954$export$b55f44bb0675280a = 'system.attachment.metadata';
const $0673dc41d4591954$export$932fbff4e94f11bd = 'system.attachment.history';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["SYSTEM_ATTACHMENT"] = $0673dc41d4591954$export$53635c098825d80c;
module.exports["SYSTEM_ATTACHMENT_METADATA"] = $0673dc41d4591954$export$b55f44bb0675280a;
module.exports["SYSTEM_ATTACHMENT_HISTORY"] = $0673dc41d4591954$export$932fbff4e94f11bd;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$3d2f468c166bad70 = 'confluence:attachmentAction';
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$3d2f468c166bad70,
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_ATTACHMENT_ACTION"] = $af2b0e533822f413$export$3d2f468c166bad70;
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("3j8TZ", function(module, exports) {
/**
 * @generated SignedSource<<bcf6371051972dda4e73703ef8d6345b>>
 * @relayHash 44fbfb9d6df590a6ee4e002cd5037220
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01
const $bcd0dbc3bf494067$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "size"
    }, v7 = {
        "kind": "ScalarField",
        "name": "mimeType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "processingStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "cloudId",
                                                            "variableName": "cloudId"
                                                        }
                                                    ],
                                                    "concreteType": "MediaItem",
                                                    "kind": "LinkedField",
                                                    "name": "mediaItems",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        },
                                                        {
                                                            "concreteType": "MediaFileDetails",
                                                            "kind": "LinkedField",
                                                            "name": "details",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaType"
                                                                },
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "failReason"
                                                                },
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MediaFilePreview",
                                                                    "kind": "LinkedField",
                                                                    "name": "preview",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "cdnUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileArtifact",
                                                                    "kind": "LinkedField",
                                                                    "name": "artifactsList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileRepresentations",
                                                                    "kind": "LinkedField",
                                                                    "name": "representations",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "MediaImageRepresentation",
                                                                            "kind": "LinkedField",
                                                                            "name": "image",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "_empty"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "duration"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileAbuseClassification",
                                                                    "kind": "LinkedField",
                                                                    "name": "abuseClassification",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "classification"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "confidence"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "44fbfb9d6df590a6ee4e002cd5037220",
            "id": "3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenWithMediaItemsQuery($cloudId:ID!,$contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token},mediaItems(cloudId:$cloudId){id,type,details{name,size,mimeType,mediaType,processingStatus,failReason,createdAt,preview{cdnUrl},artifactsList{createdAt,mimeType,name,processingStatus,size,url},representations{image{_empty}},mediaMetadata{duration},abuseClassification{classification,confidence}}}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$bcd0dbc3bf494067$var$node.hash = "c03e617139295e9107b3907ee1a06cb3";
var $bcd0dbc3bf494067$export$2e2bcd8739ae039 = $bcd0dbc3bf494067$var$node;
module.exports["default"] = $bcd0dbc3bf494067$export$2e2bcd8739ae039;

});

parcelRegister("jGizm", function(module, exports) {

var $2zscg = parcelRequire("2zscg");

const $04d4b8463fee3aa7$var$extensionCache = new WeakMap();
const $04d4b8463fee3aa7$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
/**
 * Most property values (`title`, `key`, `type`, `resource`, `icon`, …) are plain strings
 * rather than JSON, so parsing them unconditionally throws for the majority of the list —
 * around 1,100 caught `SyntaxError`s per pass on a real 143-app payload, which dominates
 * the transform.
 *
 * A JSON document can only open as an object, array, string or number, or be one of the
 * three bare literals. Anything else would have thrown and fallen back to the raw string,
 * so skipping the parse is equivalent.
 *
 * Property values that are not strings are kept verbatim for the same reason: stringifying
 * them for `JSON.parse` throws for anything but a bare literal, so the raw value survives.
 */ const $04d4b8463fee3aa7$var$canStartJsonDocument = (value)=>{
    const firstCharacter = value[0];
    return firstCharacter === '{' || firstCharacter === '[' || firstCharacter === '"' || firstCharacter === '-' || firstCharacter >= '0' && firstCharacter <= '9' || value === 'true' || value === 'false' || value === 'null';
};
const $04d4b8463fee3aa7$var$normalizeProperties = (properties)=>{
    const normalizedProperties = properties.reduce((acc, property)=>{
        if (!property.value || !property.key) return acc;
        if (typeof property.value !== 'string' || !$04d4b8463fee3aa7$var$canStartJsonDocument(property.value.trim())) {
            acc[property.key] = property.value;
            return acc;
        }
        try {
            const jsonValue = JSON.parse(property.value);
            acc[property.key] = jsonValue;
        } catch (_error) {
            acc[property.key] = property.value;
        }
        return acc;
    }, {});
    if ('migratedFrom' in normalizedProperties && !$04d4b8463fee3aa7$var$isStringArray(normalizedProperties.migratedFrom)) {
        const { migratedFrom: _migratedFrom, ...propertiesWithoutInvalidMigratedFrom } = normalizedProperties;
        return propertiesWithoutInvalidMigratedFrom;
    }
    return normalizedProperties;
};
const $04d4b8463fee3aa7$export$9ff84ea1b2ab439c = (extensions)=>{
    if (!extensions || extensions.length === 0) return [];
    if ($04d4b8463fee3aa7$var$extensionCache.has(extensions)) return $04d4b8463fee3aa7$var$extensionCache.get(extensions);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2zscg.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2zscg.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2zscg.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2zscg.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: $04d4b8463fee3aa7$var$normalizeProperties(extension.properties),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $04d4b8463fee3aa7$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                remoteInstallationRegion: extension.remoteInstallationRegion ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                sandboxPolicies: extension.sandboxPolicies ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $04d4b8463fee3aa7$var$extensionCache.set(extensions, result);
    return result;
};
const $04d4b8463fee3aa7$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $04d4b8463fee3aa7$export$9ff84ea1b2ab439c;

});

parcelRegister("2zscg", function(module, exports) {
var $a413c718e4c7bf40$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $a413c718e4c7bf40$export$9a2372818e2520c6 = {
    ATTACHMENT_ACTION: 'confluence:attachmentAction',
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $a413c718e4c7bf40$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $a413c718e4c7bf40$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
const $a413c718e4c7bf40$export$ffcb70f38ee10c0a = {
    FULL_PAGE: 'global:fullPage',
    GLOBAL_UI: 'global:ui'
};
module.exports["ExtensionEnvironment"] = $a413c718e4c7bf40$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $a413c718e4c7bf40$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $a413c718e4c7bf40$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $a413c718e4c7bf40$export$586232a3e4271798;
module.exports["GlobalExtension"] = $a413c718e4c7bf40$export$ffcb70f38ee10c0a;

});

parcelRegister("ceVeI", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $c9f3102bc65ac225$export$2512ab5eef87236d = [
    'attachments',
    'blog-posts',
    'change-history',
    'contributors',
    'detailssummary',
    'iframe',
    'include',
    'pagetree',
    'pagetreesearch',
    'profile',
    'profile-picture',
    'recently-updated',
    'viewpdf',
    'viewxls',
    'widget',
    'contentbylabel',
    'listlabels',
    'popular-labels',
    'tasks-report-macro'
];
const $c9f3102bc65ac225$var$getExperimentValue = (extensionKey)=>{
    switch(extensionKey){
        case 'contributors':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
        case 'detailssummary':
        case 'profile':
        case 'profile-picture':
            return (0, $6mKj3.expValEquals)('cc_macro_full_ssr_support', 'isEnabled', true);
        case 'blog-posts':
        case 'contentbylabel':
        case 'iframe':
        case 'include':
        case 'popular-labels':
        case 'viewxls':
        case 'viewpdf':
        case 'widget':
            return true;
        case 'listlabels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_listlabels_legacy_macro', 'isEnabled', true);
        case 'pagetree':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
        case 'pagetreesearch':
            return true;
        case 'recently-updated':
            return (0, $6mKj3.expValEquals)('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
        case 'attachments':
            return (0, $6mKj3.expValEquals)('cc_rewrite_attachments_legacy_macro', 'isEnabled', true);
        case 'tasks-report-macro':
            return (0, $6mKj3.expValEquals)('cc_rewrite_tasks_report_macro', 'isEnabled', true);
        case 'change-history':
            return (0, $6mKj3.expValEquals)('cc_rewrite_change_history_legacy_macro', 'isEnabled', true);
        default:
            return false;
    }
};
const $c9f3102bc65ac225$var$isMigratedMacroExtensionKey = (key)=>$c9f3102bc65ac225$export$2512ab5eef87236d.includes(key);
const $c9f3102bc65ac225$export$95a5e4cb1c9fae51 = (extensionKey)=>{
    const overrideList = (0, $1xpoY.default).getStringList('cc_macro_override_to_legacy_renderer', []);
    if (overrideList.includes(extensionKey)) return false;
    if (!$c9f3102bc65ac225$var$isMigratedMacroExtensionKey(extensionKey)) return false;
    return $c9f3102bc65ac225$var$getExperimentValue(extensionKey);
};
module.exports["MIGRATED_MACRO_EXTENSION_KEYS"] = $c9f3102bc65ac225$export$2512ab5eef87236d;
module.exports["isMigratedMacroImplEnabled"] = $c9f3102bc65ac225$export$95a5e4cb1c9fae51;

});

parcelRegister("fExfj", function(module, exports) {

var $92rGz = parcelRequire("92rGz");


var $8FkVw = parcelRequire("8FkVw");

const $6d29423afdca551a$export$eab97d15b1788b8d = $8FkVw;
const $6d29423afdca551a$export$3b4c04cf7dad0e50 = $92rGz;
module.exports["utils"] = $6d29423afdca551a$export$eab97d15b1788b8d;

});

parcelRegister("92rGz", function(module, exports) {

var $1Udvu = parcelRequire("1Udvu");


var $6kV7w = parcelRequire("6kV7w");


var $gG4RG = parcelRequire("gG4RG");


var $4sHaf = parcelRequire("4sHaf");


var $8F9fo = parcelRequire("8F9fo");


var $eCMSo = parcelRequire("eCMSo");

const $feac65a19c55a1da$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $8F9fo.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $4sHaf.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $gG4RG.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $eCMSo.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $1Udvu.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $feac65a19c55a1da$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};
module.exports["requestServiceMultipart"] = $feac65a19c55a1da$export$8b13532c81e8ac89;

});

parcelRegister("1Udvu", function(module, exports) {
async function $16357f97c0090164$export$74e0a034be2368c7(e, t) {
    if (!e.ok || !e.body || e.bodyUsed) return e;
    let n = e.headers.get("content-type");
    if (!n || !~n.indexOf("multipart/")) return e;
    let i = n.indexOf("boundary="), l = "-";
    if (~i) {
        let e = i + 9, t = n.indexOf(";", e);
        l = n.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(e, t, n) {
        let i, l, r, d = new TextDecoder("utf8"), o = e.getReader(), a = !n || !n.multiple, f = t.length, s = "", c = [];
        try {
            let e;
            e: for(; !(e = await o.read()).done;){
                let n = d.decode(e.value, {
                    stream: !0
                });
                i = s.length, s += n;
                let o = n.indexOf(t);
                for(~o ? i += o : i = s.indexOf(t), c = []; ~i;){
                    let e = s.slice(0, i), n = s.slice(i + f);
                    if (l) {
                        let t = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", t), l = !1, d = e.slice(t, i > -1 ? void 0 : i), o = String(e.slice(0, t)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; r = o[--s]; r = r.split(": "), f[r.shift().toLowerCase()] = r.join(": "));
                        if (r = f["content-type"], r && ~r.indexOf("application/json")) try {
                            d = JSON.parse(d), l = !0;
                        } catch (e) {}
                        if (r = {
                            headers: f,
                            body: d,
                            json: l
                        }, a ? yield r : c.push(r), "--" === n.slice(0, 2)) break e;
                    } else t = "\r\n" + t, l = f += 2;
                    s = n, i = s.indexOf(t);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(e.body, `--${l}`, t);
}
module.exports["meros"] = $16357f97c0090164$export$74e0a034be2368c7;

});

parcelRegister("gG4RG", function(module, exports) {
const $e76949c2aa479bf9$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $e76949c2aa479bf9$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $e76949c2aa479bf9$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $e76949c2aa479bf9$var$addToHeaders(headers, secOptions.headers);
    return headers;
};
module.exports["buildHeaders"] = $e76949c2aa479bf9$export$7d6ed858a91629c3;

});

parcelRegister("4sHaf", function(module, exports) {
const $1060d48a7c3c566e$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
module.exports["buildUrl"] = $1060d48a7c3c566e$export$b5cd97dee32de81d;

});

parcelRegister("8F9fo", function(module, exports) {
const $39f3fe1498ecdf1b$export$160dbda113bfad3b = {};
module.exports["defaultRequestServiceOptions"] = $39f3fe1498ecdf1b$export$160dbda113bfad3b;

});

parcelRegister("eCMSo", function(module, exports) {
const $e0f49dd64fe47409$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};
module.exports["buildCredentials"] = $e0f49dd64fe47409$export$2ac26f1ab7eda637;

});

parcelRegister("8FkVw", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => (parcelRequire("d42dq")).extractTracingHeaders);
$parcel$export(module.exports, "requestService", () => (parcelRequire("i3nsM")).requestService);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { extractTracingHeaders } from '@atlaskit/util-service-support/extractTracingHeaders'` instead.
 */ 
var $d42dq = parcelRequire("d42dq");


var $i3nsM = parcelRequire("i3nsM");


});

parcelRegister("d42dq", function(module, exports) {
const $4b6ed4b3c47c9806$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $4b6ed4b3c47c9806$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $4b6ed4b3c47c9806$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};
module.exports["extractTracingHeaders"] = $4b6ed4b3c47c9806$export$4f34edf253146101;

});

parcelRegister("i3nsM", function(module, exports) {

var $6kV7w = parcelRequire("6kV7w");


var $gG4RG = parcelRequire("gG4RG");


var $4sHaf = parcelRequire("4sHaf");


var $d42dq = parcelRequire("d42dq");


var $8F9fo = parcelRequire("8F9fo");


var $eCMSo = parcelRequire("eCMSo");

const $1269a5671963131d$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $8F9fo.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $4sHaf.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $gG4RG.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $eCMSo.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options?.reportTracingHeaders) {
            const tracingHeaders = (0, $d42dq.extractTracingHeaders)(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $1269a5671963131d$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
module.exports["requestService"] = $1269a5671963131d$export$97bfde5a702aaeca;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("3Ww6H", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $50aee1cd0289a711$export$b4958caff08a0960 = (...args)=>{
    (0, $jmjuG.ufologger).log(...args);
};
module.exports["ufolog"] = $50aee1cd0289a711$export$b4958caff08a0960;

});

parcelRegister("jmjuG", function(module, exports) {
class $fdaa18971c6567c6$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$fdaa18971c6567c6$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $fdaa18971c6567c6$export$4ab84f6f04f6566d = new $fdaa18971c6567c6$var$UFOLogger();
module.exports["ufologger"] = $fdaa18971c6567c6$export$4ab84f6f04f6566d;

});

parcelRegister("cNAch", function(module, exports) {

var $YHNTN = parcelRequire("YHNTN");

class $c65b2e96b7a8c980$export$c00d22927c60484a extends (0, $YHNTN.UFOAbstractExperience) {
}
module.exports["UFOExperience"] = $c65b2e96b7a8c980$export$c00d22927c60484a;

});

parcelRegister("YHNTN", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $dd3JJ = parcelRequire("dd3JJ");


var $gDr1n = parcelRequire("gDr1n");


var $11QNa = parcelRequire("11QNa");


var $i3Cqs = parcelRequire("i3Cqs");


var $8D8OR = parcelRequire("8D8OR");


var $3Ww6H = parcelRequire("3Ww6H");


var $bdTYA = parcelRequire("bdTYA");


var $aNeq3 = parcelRequire("aNeq3");


var $f07wD = parcelRequire("f07wD");


var $e22Cc = parcelRequire("e22Cc");


var $j7Sza = parcelRequire("j7Sza");


var $g8bWJ = parcelRequire("g8bWJ");


var $4MiWC = parcelRequire("4MiWC");


var $DJFHw = parcelRequire("DJFHw");

const $35f46dabe2d905ec$var$getPageVisibleState = ()=>{
    return !(0, $e22Cc.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $f07wD.PageVisibleState).VISIBLE : (0, $f07wD.PageVisibleState).HIDDEN;
};
class $35f46dabe2d905ec$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $3Ww6H.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $g8bWJ.canTransition)(this.state, newState)) {
            (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $j7Sza.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $03RpJ.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $11QNa.getGlobalEventStream)().push((0, $8D8OR.unsubscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $3Ww6H.ufolog)('this.parent', this.parent);
                (0, $11QNa.getGlobalEventStream)().push((0, $gDr1n.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bdTYA.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $j7Sza.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
            (0, $aNeq3.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $3Ww6H.ufolog)('subscribed', this.id);
                (0, $11QNa.getGlobalEventStream)().push((0, $i3Cqs.subscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $f07wD.FMP_MARK) && name !== (0, $f07wD.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bdTYA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $DJFHw.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $j7Sza.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $f07wD.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $f07wD.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bdTYA.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $3Ww6H.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $dd3JJ.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $j7Sza.UFOExperienceState).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $f07wD.PageVisibleState).MIXED;
            (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}
module.exports["UFOAbstractExperience"] = $35f46dabe2d905ec$export$d31c89db257648c;

});

parcelRegister("dd3JJ", function(module, exports) {
// temp solution until we can get it automated
const $79d018f255564301$export$2295b861f318254a = '0.1.5';
module.exports["UFO_EXPERIMENTAL_BUILD_VERSION"] = $79d018f255564301$export$2295b861f318254a;

});

parcelRegister("gDr1n", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $7cdf9804f4fb0f15$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};
module.exports["experiencePayloadEvent"] = $7cdf9804f4fb0f15$export$7c957416596ca127;

});

parcelRegister("f07wD", function(module, exports) {
var $ff3bb8d57004c3c7$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $ff3bb8d57004c3c7$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $ff3bb8d57004c3c7$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $ff3bb8d57004c3c7$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $ff3bb8d57004c3c7$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $ff3bb8d57004c3c7$export$9f2bf58999404c75 = 'fmp';
const $ff3bb8d57004c3c7$export$837e0f79a8056912 = 'inline-response';
module.exports["UFOGlobalEventStreamEventType"] = $ff3bb8d57004c3c7$export$96253c35c37cf96b;
module.exports["PageVisibleState"] = $ff3bb8d57004c3c7$export$a12c67b37a306b13;
module.exports["SUBSCRIBE_ALL"] = $ff3bb8d57004c3c7$export$79bf131685ad41d7;
module.exports["FMP_MARK"] = $ff3bb8d57004c3c7$export$9f2bf58999404c75;
module.exports["INLINE_RESPONSE_MARK"] = $ff3bb8d57004c3c7$export$837e0f79a8056912;

});

parcelRegister("11QNa", function(module, exports) {

var $7Ce5m = parcelRequire("7Ce5m");

const $c1569a93aa4391e4$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $7Ce5m.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
module.exports["getGlobalEventStream"] = $c1569a93aa4391e4$export$6123a44dc2384540;

});

parcelRegister("7Ce5m", function(module, exports) {
const $0cc5590ab6f8b46e$export$d8b468db8a225bc9 = 250;
module.exports["MAX_EARLY_QUEUE_LENGTH"] = $0cc5590ab6f8b46e$export$d8b468db8a225bc9;

});

parcelRegister("i3Cqs", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $a239602ece96b732$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["subscribeEvent"] = $a239602ece96b732$export$37863216db4b714d;

});

parcelRegister("8D8OR", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["unsubscribeEvent"] = $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e;

});

parcelRegister("bdTYA", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $5c1c0b03503ca679$export$d53d07b6034c4560 = (...args)=>{
    (0, $jmjuG.ufologger).warn(...args);
};
module.exports["ufowarn"] = $5c1c0b03503ca679$export$d53d07b6034c4560;

});

parcelRegister("aNeq3", function(module, exports) {

var $e22Cc = parcelRequire("e22Cc");

class $1043fc05a880bbb3$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $e22Cc.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $1043fc05a880bbb3$export$13e680397ec8f3eb = new $1043fc05a880bbb3$var$VisibilityChangeObserver();
module.exports["visibilityChangeObserver"] = $1043fc05a880bbb3$export$13e680397ec8f3eb;

});

parcelRegister("e22Cc", function(module, exports) {
const $0f617bf44fb531ac$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};
module.exports["isWindowObjectAvailable"] = $0f617bf44fb531ac$export$15e172712955e18f;

});

parcelRegister("j7Sza", function(module, exports) {
const $f267d4a3139d0594$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};
module.exports["UFOExperienceState"] = $f267d4a3139d0594$export$81b70111112841a0;

});

parcelRegister("g8bWJ", function(module, exports) {

var $j7Sza = parcelRequire("j7Sza");

const $59fdb64e04330d55$var$UFOStateAvailableTransitions = {
    [(0, $j7Sza.UFOExperienceState).NOT_STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).BLOCKED.id]: [
        (0, $j7Sza.UFOExperienceState).RECOVERED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).RECOVERED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).FAILED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).ABORTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ]
};
const $59fdb64e04330d55$export$178881f329fdb81f = (state1, state2)=>{
    return $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id] && $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};
module.exports["canTransition"] = $59fdb64e04330d55$export$178881f329fdb81f;

});

parcelRegister("4MiWC", function(module, exports) {
var $d8444ff033f3362a$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $d8444ff033f3362a$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});
module.exports["ExperienceTypes"] = $d8444ff033f3362a$export$994164cf3ae1cc9a;
module.exports["ExperiencePerformanceTypes"] = $d8444ff033f3362a$export$cc26007c03242fff;

});

parcelRegister("DJFHw", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2xhEb = parcelRequire("2xhEb");

const $56570a8acedc1b5f$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2xhEb.roundPerfNow)();
};
module.exports["perfNowOrTimestamp"] = $56570a8acedc1b5f$export$c753e8669d30c8ad;

});

parcelRegister("2xhEb", function(module, exports) {
const $a279419ecc31ce6a$export$5f490af6b2b115cf = ()=>~~performance.now();
module.exports["roundPerfNow"] = $a279419ecc31ce6a$export$5f490af6b2b115cf;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("yuV6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    const baseUrl = (0, $iDrrr.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("8Pm8w", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $3xsB6 = parcelRequire("3xsB6");


var $05aaK = parcelRequire("05aaK");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $7GRSG = parcelRequire("7GRSG");


var $cuwGS = parcelRequire("cuwGS");


var $d04Ge = parcelRequire("d04Ge");

const $9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX = /^ari:cloud:blocks:.*:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$mapBlockError = (error)=>{
    switch(error.status){
        case 400:
        case 401:
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 403:
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 404:
            return (0, $79ir6.SyncBlockError).NotFound;
        case 409:
            return (0, $79ir6.SyncBlockError).Conflict;
        case 429:
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 500:
        case 503:
        case 504:
            return (0, $79ir6.SyncBlockError).ServerError;
    }
    return (0, $79ir6.SyncBlockError).Errored;
};
const $9b0c4608cd445e14$var$mapErrorResponseCode = (errorCode)=>{
    switch(errorCode){
        case 'FORBIDDEN':
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 'RESOURCE_NOT_FOUND':
        case 'NOT_FOUND':
            return (0, $79ir6.SyncBlockError).NotFound;
        case 'EntityNotFound':
            return (0, $79ir6.SyncBlockError).EntityNotFound;
        case 'INVALID_REQUEST':
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 'CONFLICT':
            return (0, $79ir6.SyncBlockError).Conflict;
        case 'RATE_LIMITED':
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 'SERVER_ERROR':
            return (0, $79ir6.SyncBlockError).ServerError;
        case 'INVALID_CONTENT':
            return (0, $79ir6.SyncBlockError).InvalidContent;
        default:
            return (0, $79ir6.SyncBlockError).Errored;
    }
};
const $9b0c4608cd445e14$export$7a367d6c9621d11 = (blockAri)=>{
    // Validate ARI format and extract resourceId using regex
    // Format: ari:cloud:blocks:{uuid}:synced-block/{product}/{parentId}/{resourceId}
    // The regex captures the full path after synced-block/
    // e.g. ari:cloud:blocks:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:synced-block/confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    // should return confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    const match = blockAri.match($9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX);
    return match?.[1] || null;
};
const $9b0c4608cd445e14$export$bba762cb095b2f42 = (data, resourceId)=>{
    let createdAt;
    if (data.createdAt !== undefined && data.createdAt !== null) try {
        createdAt = new Date(data.createdAt).toISOString();
    } catch  {
        // fallback to undefined
        // as we don't want to block the whole process due to invalid date
        createdAt = undefined;
    }
    return {
        blockInstanceId: data.blockInstanceId,
        content: JSON.parse(data.content),
        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(data.contentUpdatedAt),
        createdAt: createdAt,
        createdBy: data.createdBy,
        product: data.product,
        resourceId: resourceId,
        sourceAri: data.sourceAri,
        status: data.status
    };
};
const $9b0c4608cd445e14$export$17132bdfdc28611c = async (documentAri)=>{
    let response;
    try {
        response = await (0, $05aaK.getReferenceSyncedBlocks)(documentAri);
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return $9b0c4608cd445e14$var$mapBlockError(error);
        return (0, $79ir6.SyncBlockError).Errored;
    }
    const { blocks: blocks, errors: errors } = response || {};
    const blocksInstances = (blocks || []).map((blockContentResponse)=>{
        try {
            const resourceId = $9b0c4608cd445e14$export$7a367d6c9621d11(blockContentResponse.blockAri);
            if (!resourceId) // could not extract resourceId from blockAri, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
            return {
                data: $9b0c4608cd445e14$export$bba762cb095b2f42(blockContentResponse, resourceId),
                resourceId: resourceId
            };
        } catch  {
            // JSON parsing error, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
        }
    });
    const errorInstances = (errors || []).map((errorBlock)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: errorBlock.blockAri
        }));
    return [
        ...blocksInstances,
        ...errorInstances
    ];
};
const $9b0c4608cd445e14$export$2837853885c81488 = (blockAri)=>{
    const match = blockAri.match($9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX);
    return match?.[1];
};
const $9b0c4608cd445e14$export$abdcb5d4d6767e73 = async (cloudId, parentAri, blockNodeIdentifiers, config)=>{
    const blockIdentifiers = blockNodeIdentifiers.map((blockIdentifier)=>({
            blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: cloudId,
                resourceId: blockIdentifier.resourceId
            }),
            blockInstanceId: blockIdentifier.blockInstanceId
        }));
    // Create a set of valid resourceIds for validation
    const validResourceIds = new Set(blockNodeIdentifiers.map((blockNodeIdentifier)=>blockNodeIdentifier.resourceId));
    // Track which resourceIds have been processed
    const processedResourceIds = new Set();
    if (!parentAri) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: blockNodeIdentifier.resourceId
        }));
    try {
        const response = await (0, $05aaK.batchRetrieveSyncedBlocks)({
            blockIdentifiers: blockIdentifiers,
            config: config
        });
        const results = [];
        // Process successful blocks
        if (response.success) for (const blockContentResponse of response.success){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(blockContentResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            const { content: content, deletionReason: deletionReason, sourceAri: sourceAri, blockAri: blockAri, contentUpdatedAt: contentUpdatedAt, blockInstanceId: blockInstanceId, product: product, status: status } = blockContentResponse;
            if (!content) {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).NotFound,
                        reason: deletionReason,
                        sourceAri: sourceAri
                    },
                    resourceId: resourceId
                });
                continue;
            }
            try {
                const syncedBlockData = JSON.parse(content);
                results.push({
                    data: {
                        content: syncedBlockData,
                        resourceId: blockAri,
                        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                        blockInstanceId: blockInstanceId,
                        sourceAri: sourceAri,
                        product: product,
                        status: status,
                        deletionReason: deletionReason
                    },
                    resourceId: resourceId
                });
            } catch  {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).Errored,
                        reason: `parsing JSON content response failed for resourceId: ${resourceId} localId: ${blockAri}`
                    },
                    resourceId: resourceId
                });
            }
        }
        // Process errors
        if (response.error) for (const errorResponse of response.error){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(errorResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            results.push({
                error: {
                    type: $9b0c4608cd445e14$var$mapErrorResponseCode(errorResponse.code),
                    reason: errorResponse.reason
                },
                resourceId: resourceId
            });
        }
        // Ensure all resourceIds have a result - return NotFound for any missing ones
        for (const blockNodeIdentifier of blockNodeIdentifiers)if (!processedResourceIds.has(blockNodeIdentifier.resourceId)) results.push({
            error: {
                type: (0, $79ir6.SyncBlockError).NotFound
            },
            resourceId: blockNodeIdentifier.resourceId
        });
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockTimeoutError) && (0, $ieeJu.expValEquals)('platform_editor_sync_block_ssr_config', 'isEnabled', true)) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: (0, $79ir6.SyncBlockError).Aborted,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
        // If batch request fails, return error for all resourceIds. Capture the HTTP
        // status from `BlockError` so fetch analytics can break failures down by
        // statusCode (EDITOR-7862); undefined for non-HTTP failures. Thread the PII-safe
        // original message/name so the renderer can de-opaque the `errored` bucket.
        return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: error instanceof (0, $05aaK.BlockError) ? $9b0c4608cd445e14$var$mapBlockError(error) : (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...error instanceof (0, $05aaK.BlockError) && {
                        statusCode: error.status
                    },
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
    }
};
const $9b0c4608cd445e14$export$13b682467148f88a = async (cloudId, parentAri, parentId, product, data, stepVersion)=>{
    if (!parentAri || !parentId) return data.map((block)=>({
            error: (0, $79ir6.SyncBlockError).Errored,
            resourceId: block.resourceId
        }));
    try {
        // Create a map from blockAri to original resourceId for matching responses
        const blockAriToResourceIdMap = new Map();
        const blocks = data.map((block)=>{
            const blockAri = (0, $3xsB6.generateBlockAri)({
                cloudId: cloudId,
                parentId: parentId,
                product: product,
                resourceId: block.resourceId
            });
            blockAriToResourceIdMap.set(blockAri, block.resourceId);
            return {
                blockAri: blockAri,
                content: JSON.stringify(block.content),
                status: block.status,
                stepVersion: stepVersion
            };
        });
        const response = await (0, $05aaK.updateSyncedBlocks)({
            blocks: blocks
        });
        const results = [];
        // Process successful updates
        if (response.success) {
            const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
            for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                resourceId: block.resourceId
            });
        }
        if (response.error) {
            const errorResourceIds = new Map(response.error.map((err)=>[
                    // Use the map to get the original resourceId
                    blockAriToResourceIdMap.get(err.blockAri) || '',
                    $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                ]));
            for (const block of data){
                const error = errorResourceIds.get(block.resourceId);
                if (error) results.push({
                    error: error,
                    resourceId: block.resourceId
                });
                else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                results.push({
                    error: (0, $79ir6.SyncBlockError).Errored,
                    resourceId: block.resourceId
                });
            }
        }
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: block.resourceId,
                statusCode: error.status
            }));
        return data.map((block)=>({
                error: (0, $916Gd.stringifyError)(error),
                resourceId: block.resourceId
            }));
    }
};

/**
 * ADFFetchProvider implementation that fetches synced block data from Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFFetchProvider {
    generateResourceIdForReference(sourceId) {
        if (!this.product || !this.parentId) return sourceId;
        return (0, $cuwGS.createResourceIdForReference)(this.product, this.parentId, sourceId);
    }
    // resourceId of the reference synced block.
    // the ARI must be constructed to call the block service API
    async fetchData(resourceId) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        try {
            const blockContentResponse = await (0, $05aaK.getSyncedBlockContent)({
                blockAri: blockAri
            });
            const { content: content, sourceAri: sourceAri, deletionReason: deletionReason, blockInstanceId: blockInstanceId, contentUpdatedAt: contentUpdatedAt, product: product, status: status } = blockContentResponse;
            if (!content) return {
                error: {
                    type: (0, $79ir6.SyncBlockError).NotFound,
                    reason: deletionReason,
                    sourceAri: sourceAri
                },
                resourceId: resourceId
            };
            // Parse the synced block content from the response's content
            const syncedBlockData = JSON.parse(content);
            return {
                data: {
                    content: syncedBlockData,
                    resourceId: blockAri,
                    blockInstanceId: blockInstanceId,
                    // this was the node's localId, but has become the resourceId.
                    contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                    sourceAri: sourceAri,
                    product: product,
                    status: status,
                    deletionReason: deletionReason
                },
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) // Capture the HTTP status so fetch analytics can break failures down by
            // statusCode (EDITOR-7862). Thread the PII-safe original message/name so
            // the renderer can de-opaque failures.
            return {
                error: {
                    type: $9b0c4608cd445e14$var$mapBlockError(error),
                    reason: error.message,
                    statusCode: error.status,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
        }
    }
    async fetchReferences(referenceResourceId) {
        try {
            const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: this.cloudId,
                resourceId: referenceResourceId
            });
            const response = await (0, $05aaK.getReferenceSyncedBlocksByBlockAri)({
                blockAri: blockAri
            });
            const locationScopeOf = (documentAri)=>(0, $7GRSG.getFieldAwareLocationScope)({
                    documentAri: documentAri,
                    hostAri: this.parentAri,
                    productType: (0, $3xsB6.getProductFromSourceAri)(documentAri)
                });
            const references = [];
            response.references.forEach((reference)=>{
                references.push({
                    ...reference,
                    hasAccess: true,
                    onSameDocument: this.parentAri === reference.documentAri,
                    ...locationScopeOf(reference.documentAri)
                });
            });
            response.errors.forEach((reference)=>{
                if (reference.code === 'FORBIDDEN') references.push({
                    blockAri: reference.blockAri,
                    documentAri: reference.documentAri,
                    hasAccess: false,
                    onSameDocument: false,
                    ...locationScopeOf(reference.documentAri)
                });
            });
            return {
                references: references
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error)
            };
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
    }
    /**
   * Batch fetches multiple synced blocks by their resource IDs.
   * @param blockNodeIdentifiers - Array of block node identifiers to fetch
   * @param config - Optional batch fetch configuration
   * @returns Array of SyncBlockInstance results
   */ async batchFetchData(blockNodeIdentifiers, config) {
        return await $9b0c4608cd445e14$export$abdcb5d4d6767e73(this.cloudId, this.parentAri, blockNodeIdentifiers, config);
    }
    /**
   * Subscribes to real-time updates for a specific block using GraphQL WebSocket subscriptions.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        // Track the real unsubscribe fn once the dynamic import resolves
        let unsubscribe;
        let cancelled = false;
        // Dynamically import blockSubscription so that graphql-ws is NOT pulled
        // into the SSR/preload bundle that imports this subpath.
        (parcelRequire("cvOi6")).then(({ subscribeToBlockUpdates: subscribeToBlockUpdatesWS })=>{
            if (cancelled) return;
            unsubscribe = subscribeToBlockUpdatesWS(blockAri, (parsedData)=>{
                // Convert ParsedBlockSubscriptionData to SyncBlockInstance
                const syncBlockInstance = {
                    data: {
                        content: parsedData.content,
                        resourceId: parsedData.blockAri,
                        blockInstanceId: parsedData.blockInstanceId,
                        sourceAri: parsedData.sourceAri,
                        product: parsedData.product,
                        createdAt: parsedData.createdAt,
                        contentUpdatedAt: parsedData.contentUpdatedAt,
                        createdBy: parsedData.createdBy,
                        status: parsedData.status
                    },
                    resourceId: parsedData.resourceId
                };
                onUpdate(syncBlockInstance);
            }, onError, onComplete);
        }).catch((err)=>{
            if (cancelled) return;
            onError?.(err instanceof Error ? err : new Error('Failed to load subscription module'));
        });
        // Return an unsubscribe fn that works whether the import has resolved or not
        return ()=>{
            cancelled = true;
            unsubscribe?.();
        };
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product }){
        this.cloudId = void 0;
        this.parentAri = void 0;
        this.parentId = void 0;
        this.product = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFWriteProvider {
    async writeData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            const status = data.status;
            await (0, $05aaK.updateSyncedBlock)({
                blockAri: blockAri,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    async createData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        const status = 'unpublished';
        try {
            await (0, $05aaK.createSyncedBlock)({
                blockAri: blockAri,
                blockInstanceId: data.blockInstanceId,
                sourceAri: this.parentAri,
                product: this.product,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    // soft deletes the source synced block
    async deleteData(resourceId, deleteReason) {
        if (!this.parentId) return {
            resourceId: resourceId,
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        try {
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockNotFoundError) && this.parentAri) return this.deleteOrphanBlock({
                blockAri: blockAri,
                resourceId: resourceId,
                parentAri: this.parentAri,
                deleteReason: deleteReason
            });
            if (error instanceof (0, $05aaK.BlockError)) {
                if (error.status === 404) // User should not be blocked by not_found error when deleting,
                // hence returns successful result for 404 error
                return {
                    resourceId: resourceId,
                    success: true
                };
                return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    statusCode: error.status
                };
            }
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // The block is an orphan (e.g. from a copied page) — it doesn't exist in Block Service.
    // Block Service uses soft-deletes, so we must first create the block then delete it,
    // ensuring a deletion-reason record is stored (used to display errors in reference blocks).
    async deleteOrphanBlock({ blockAri: blockAri, resourceId: resourceId, parentAri: parentAri, deleteReason: deleteReason }) {
        try {
            const stepVersion = this.getVersion ? await this.getVersion() : undefined;
            try {
                await (0, $05aaK.createSyncedBlock)({
                    blockAri: blockAri,
                    blockInstanceId: resourceId,
                    sourceAri: parentAri,
                    product: this.product,
                    content: '[]',
                    stepVersion: stepVersion
                });
            } catch (createError) {
                // "Conditional check failed" means the block already exists in Block Service.
                // This can happen when an orphan block is copied and pasted — a reference block repair
                // in the backend may have already created it. We can proceed directly to delete it.
                if (createError instanceof Error && createError.message.includes('Conditional check failed')) ;
                else if (createError instanceof (0, $05aaK.BlockError)) return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(createError),
                    statusCode: createError.status
                };
                else return {
                    resourceId: resourceId,
                    success: false,
                    error: (0, $916Gd.stringifyError)(createError)
                };
            }
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                resourceId: resourceId,
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // the sourceId is the resourceId of the source synced block.
    generateResourceIdForReference(sourceId) {
        return (0, $cuwGS.createResourceIdForReference)(this.product, this.parentId || '', sourceId);
    }
    generateResourceId() {
        return crypto.randomUUID();
    }
    generateBlockAri(resourceId) {
        return (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId || '',
            product: this.product,
            resourceId: resourceId
        });
    }
    async updateReferenceData(blocks, noContent) {
        if (!this.parentAri) return {
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        try {
            await (0, $05aaK.updateReferenceSyncedBlockOnDocument)({
                documentAri: this.parentAri,
                blocks: blocks.map((block)=>({
                        blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                            cloudId: this.cloudId,
                            resourceId: block.resourceId
                        }),
                        blockInstanceId: block.localId
                    })),
                noContent: noContent
            });
            return {
                success: true
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    async writeDataBatch(data) {
        if (!this.parentAri || !this.parentId) return data.map((block)=>({
                error: (0, $79ir6.SyncBlockError).Errored,
                resourceId: block.resourceId
            }));
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            // Create a map from blockAri to original resourceId for matching responses
            const blockAriToResourceIdMap = new Map();
            const blocks = data.map((block)=>{
                const blockAri = this.generateBlockAri(block.resourceId);
                blockAriToResourceIdMap.set(blockAri, block.resourceId);
                return {
                    blockAri: blockAri,
                    content: JSON.stringify(block.content),
                    status: block.status,
                    stepVersion: stepVersion
                };
            });
            const response = await (0, $05aaK.updateSyncedBlocks)({
                blocks: blocks
            });
            const results = [];
            // Process successful updates
            if (response.success) {
                const successBlocks = new Map(response.success.map((block)=>[
                        blockAriToResourceIdMap.get(block.blockAri),
                        block
                    ]));
                for (const block of data){
                    const successBlock = successBlocks.get(block.resourceId);
                    if (successBlock) results.push({
                        resourceId: block.resourceId,
                        status: successBlock.status
                    });
                }
            }
            if (response.error) {
                const errorResourceIds = new Map(response.error.map((err)=>[
                        // Use the map to get the original resourceId
                        blockAriToResourceIdMap.get(err.blockAri) || '',
                        $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                    ]));
                for (const block of data){
                    const error = errorResourceIds.get(block.resourceId);
                    if (error) {
                        if (error !== (0, $79ir6.SyncBlockError).NotFound) results.push({
                            error: error,
                            resourceId: block.resourceId
                        });
                    } else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                    results.push({
                        error: (0, $79ir6.SyncBlockError).Errored,
                        resourceId: block.resourceId
                    });
                }
            }
            return results;
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    resourceId: block.resourceId,
                    statusCode: error.status
                }));
            return data.map((block)=>({
                    error: (0, $916Gd.stringifyError)(error),
                    resourceId: block.resourceId
                }));
        }
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion }){
        this.cloudId = void 0;
        this.parentId = void 0;
        this.getVersion = void 0;
        this.product = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
        this.getVersion = getVersion;
    }
}
const $9b0c4608cd445e14$var$createBlockServiceAPIProviders = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product
        }),
        writeProvider: new $9b0c4608cd445e14$var$BlockServiceADFWriteProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        })
    };
};
const $9b0c4608cd445e14$export$ec654f5ac7e6d976 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return (0, $cozmU.useMemo)(()=>{
        return $9b0c4608cd445e14$var$createBlockServiceAPIProviders({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        });
    }, [
        cloudId,
        parentAri,
        parentId,
        product,
        getVersion
    ]);
};
const $9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product
        }),
        writeProvider: undefined
    };
};
const $9b0c4608cd445e14$export$1e67317f82b65067 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product })=>(0, $cozmU.useMemo)(()=>$9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product
        }), [
        cloudId,
        parentAri,
        parentId,
        product
    ]);
module.exports["batchFetchData"] = $9b0c4608cd445e14$export$abdcb5d4d6767e73;
module.exports["useMemoizedBlockServiceAPIProviders"] = $9b0c4608cd445e14$export$ec654f5ac7e6d976;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ 
var $4o0zT = parcelRequire("4o0zT");


var $EBNuL = parcelRequire("EBNuL");

const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$36d45714d1e88dec = ({ documentAri: documentAri, hostAri: hostAri })=>{
    if (documentAri === hostAri) return 'same-document';
    const location = (0, $EBNuL.parseJiraFieldLocation)({
        ari: documentAri
    });
    const hostLocation = (0, $EBNuL.parseJiraFieldLocation)({
        ari: hostAri
    });
    if (!location || !hostLocation || location.issueAri !== hostLocation.issueAri) return 'elsewhere';
    return location.fieldId === hostLocation.fieldId ? 'same-document' : 'same-parent-document';
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    if (!ari && (0, $4o0zT.isExperimentEnabled)('platform_editor_blocks_patch_11')) return undefined;
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getLocationScope"] = $a2c616dead6b3b85$export$36d45714d1e88dec;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("EBNuL", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX = /ari:cloud:jira:([^:]+):issue\/(\d+)/;
const $059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX = /ari:cloud:jira:([^:]+):issuefieldvalue\/([^/]+)\/([^/]+)/;
const $059546548da04295$export$e7d6f26185793d4f = ({ cloudId: cloudId, workItemId: workItemId })=>{
    return `ari:cloud:jira:${cloudId}:issue/${workItemId}`;
};
const $059546548da04295$var$getFieldValueAriParts = (ari)=>{
    const match = ari.match($059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX);
    if (match?.[1] && match[2] && match[3]) return {
        cloudId: match[1],
        issueId: match[2],
        fieldId: match[3]
    };
    return undefined;
};
const $059546548da04295$export$3ee1e41ffca0b1ff = ({ ari: ari })=>{
    const match = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (match?.[2]) return match[2];
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return fieldValueParts.issueId;
    throw new Error(`Invalid Jira work item ARI: ${ari}`);
};
const $059546548da04295$export$9d29a8e91440be5c = ({ ari: ari })=>{
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return $059546548da04295$export$e7d6f26185793d4f({
        cloudId: fieldValueParts.cloudId,
        workItemId: fieldValueParts.issueId
    });
    return ari;
};
const $059546548da04295$export$335defc86b234ea0 = 'description';
const $059546548da04295$var$toJiraFieldLocation = ({ cloudId: cloudId, fieldId: fieldId, issueId: issueId })=>({
        fieldId: fieldId,
        issueAri: $059546548da04295$export$e7d6f26185793d4f({
            cloudId: cloudId,
            workItemId: issueId
        })
    });
const $059546548da04295$export$decd92eb8dd00bf5 = ({ ari: ari })=>{
    const workItemMatch = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (workItemMatch?.[1] && workItemMatch[2]) return $059546548da04295$var$toJiraFieldLocation({
        cloudId: workItemMatch[1],
        fieldId: $059546548da04295$export$335defc86b234ea0,
        issueId: workItemMatch[2]
    });
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    return fieldValueParts && $059546548da04295$var$toJiraFieldLocation(fieldValueParts);
};
module.exports["getJiraIssueAriFromSourceAri"] = $059546548da04295$export$9d29a8e91440be5c;
module.exports["JIRA_DESCRIPTION_FIELD_ID"] = $059546548da04295$export$335defc86b234ea0;
module.exports["parseJiraFieldLocation"] = $059546548da04295$export$decd92eb8dd00bf5;

});

parcelRegister("05aaK", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $48FpT = parcelRequire("48FpT");

const $59e004c7d849e8bb$export$f426a9918d7f49b3 = (response)=>{
    const content = response.content;
    return typeof content === 'string';
};
const $59e004c7d849e8bb$export$571f6abc3f4e5951 = async (documentAri)=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery(documentAri),
        operationName: $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetDocumentReferenceBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getDocumentReferenceBlocks;
};
const $59e004c7d849e8bb$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $59e004c7d849e8bb$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_DOCUMENT_REFERENCE_BLOCKS';
const $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_BLOCK';
const $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE_BLOCK';
const $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE_BLOCK';
const $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_DOCUMENT_REFERENCES';
const $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_RETRIEVE_BLOCKS';
const $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_REFERENCES';
const $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_BLOCK';
const $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_UPDATE_BLOCKS';
const $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery = (documentAri)=>`query ${$59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME} {
	blockService_getDocumentReferenceBlocks(documentAri: ${JSON.stringify(documentAri)}) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
const $59e004c7d849e8bb$var$buildGetBlockQuery = (blockAri)=>`query ${$59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME} {
	blockService_getBlock(blockAri: ${JSON.stringify(blockAri)}) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
const $59e004c7d849e8bb$var$buildUpdateBlockMutation = (blockAri, content, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `content: ${JSON.stringify(content)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME} {
	blockService_updateBlock(input: { ${inputArgs} }) {
		__typename
	}
}`;
};
const $59e004c7d849e8bb$var$buildDeleteBlockMutation = (blockAri, deletionReason)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`
    ];
    if (deletionReason !== undefined) inputParts.push(`deletionReason: ${JSON.stringify(deletionReason)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME} {
	blockService_deleteBlock(input: { ${inputArgs} }) {
		deleted
	}
}`;
};
/**
 * Converts product string to GraphQL enum format
 * 'confluence-page' -> 'CONFLUENCE_PAGE'
 * 'jira-work-item' -> 'JIRA_WORK_ITEM'
 */ const $59e004c7d849e8bb$var$convertProductToGraphQLEnum = (product)=>{
    switch(product){
        case 'confluence-page':
            return 'CONFLUENCE_PAGE';
        case 'jira-work-item':
            return 'JIRA_WORK_ITEM';
        default:
            {
                const exhaustiveCheck = product;
                throw new Error(`Unsupported product: ${exhaustiveCheck}`);
            }
    }
};
const $59e004c7d849e8bb$var$buildCreateBlockMutation = (blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `blockInstanceId: ${JSON.stringify(blockInstanceId)}`,
        `content: ${JSON.stringify(content)}`,
        `product: ${$59e004c7d849e8bb$var$convertProductToGraphQLEnum(product)}`,
        `sourceAri: ${JSON.stringify(sourceAri)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME} {
	blockService_createBlock(input: { ${inputArgs} }) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
};
const $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation = (documentAri, blocks, noContent)=>{
    const blocksArray = blocks.map((block)=>`{ blockAri: ${JSON.stringify(block.blockAri)}, blockInstanceId: ${JSON.stringify(block.blockInstanceId)} }`).join(', ');
    const inputArgs = `documentAri: ${JSON.stringify(documentAri)}, blocks: [${blocksArray}], noContent: ${noContent}`;
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME} {
	blockService_updateDocumentReferences(input: { ${inputArgs} }) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery = (blockAris)=>{
    const blockArisArray = blockAris.map((ari)=>JSON.stringify(ari)).join(', ');
    const inputArgs = `blockAris: [${blockArisArray}]`;
    return `query ${$59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME} {
	blockService_batchRetrieveBlocks(input: { ${inputArgs} }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildGetBlockReferencesQuery = (blockAri)=>{
    return `query ${$59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME} {
	blockService_getReferences(blockAri: ${JSON.stringify(blockAri)}) {
		references {
			blockAri
			blockInstanceId
			createdAt
			createdBy
			documentAri
		}
		errors {
			blockAri
			code${(0, $4o0zT.isExperimentEnabled)('platform_editor_blocks_patch_11') ? '\n\t\t\tdocumentAri' : ''}
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation = (blocks)=>{
    const blocksArray = blocks.map((block)=>{
        const inputParts = [
            `blockAri: ${JSON.stringify(block.blockAri)}`,
            `content: ${JSON.stringify(block.content)}`
        ];
        if (block.stepVersion !== undefined) inputParts.push(`stepVersion: ${block.stepVersion}`);
        if (block.status !== undefined) inputParts.push(`status: ${JSON.stringify(block.status)}`);
        return `{ ${inputParts.join(', ')} }`;
    }).join(', ');
    return `mutation ${$59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME} {
	blockService_batchUpdateBlocks(input: { blocks: [${blocksArray}] }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
class $59e004c7d849e8bb$export$e47a0a94b0998697 extends Error {
    constructor(status){
        super(`Block error`), this.status = status;
    }
}
class $59e004c7d849e8bb$export$f5a00468af285e38 extends Error {
    constructor(){
        super('Block not found in Block Service');
        this.name = 'BlockNotFoundError';
    }
}
class $59e004c7d849e8bb$export$b5687000eb0902be extends Error {
    constructor(){
        super('Block request timed out');
        this.name = 'BlockTimeoutError';
    }
}
const $59e004c7d849e8bb$export$fab66d51cc0c1a7 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getBlock) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getBlock;
};
const $59e004c7d849e8bb$export$48a4f565308f4741 = async ({ blockIdentifiers: blockIdentifiers, config: config })=>{
    const blockAris = blockIdentifiers.map((blockIdentifier)=>blockIdentifier.blockAri);
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery(blockAris),
        operationName: $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchRetrieveBlocks`;
    // undefined or 0 or negative means no timeout,
    // We don't enforce a minimum timeout for simplicity
    const fetchPromise = (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    const timeoutMs = config?.timeoutMs ?? 0;
    const response = await (timeoutMs > 0 ? Promise.race([
        fetchPromise,
        new Promise((_, reject)=>setTimeout(()=>reject(new $59e004c7d849e8bb$export$b5687000eb0902be()), timeoutMs))
    ]) : fetchPromise);
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchRetrieveBlocks) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_batchRetrieveBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
const $59e004c7d849e8bb$export$cbbc86409cac3ee5 = async ({ blockAri: blockAri, deleteReason: deleteReason })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildDeleteBlockMutation(blockAri, deleteReason),
        operationName: $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockDeleteBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) {
        const allNotFound = result.errors.every((e)=>e.extensions?.errorType === 'RESOURCE_NOT_FOUND');
        if (allNotFound) // Throw BlockNotFoundError so the caller can create the block first then retry the delete.
        // Block Service uses soft-deletes: the entry must exist before deletion so a deletion-reason
        // is stored (used to display errors in reference blocks).
        throw new $59e004c7d849e8bb$export$f5a00468af285e38();
        throw new Error(result.errors.map((e)=>e.message).join(', '));
    }
    const isDeleted = result.data?.blockService_deleteBlock?.deleted;
    if (!isDeleted) throw new Error('Block deletion failed; deleted flag is false');
};
const $59e004c7d849e8bb$export$d5bf0c5618431e5e = async ({ blockAri: blockAri, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateBlockMutation(blockAri, content, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
};
const $59e004c7d849e8bb$export$fbc30658d812c800 = async ({ blockAri: blockAri, blockInstanceId: blockInstanceId, sourceAri: sourceAri, product: product, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildCreateBlockMutation(blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockCreateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_createBlock) throw new Error('No data returned from GraphQL mutation');
    return result.data.blockService_createBlock;
};
const $59e004c7d849e8bb$export$59c7369fa04bcba1 = async ({ documentAri: documentAri, blocks: blocks, noContent: noContent = true })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation(documentAri, blocks, noContent),
        operationName: $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateDocumentReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData),
        keepalive: true
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!noContent) {
        if (!result.data?.blockService_updateDocumentReferences) throw new Error('No data returned from GraphQL mutation');
        return result.data.blockService_updateDocumentReferences;
    }
};
const $59e004c7d849e8bb$export$75f5aeff9ce22a33 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockReferencesQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getReferences) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_getReferences;
    return {
        blockAri: blockAri,
        references: graphqlResponse.references || [],
        errors: graphqlResponse.errors || []
    };
};
const $59e004c7d849e8bb$export$a9e53fa4329b5ed2 = async ({ blocks: blocks })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation(blocks),
        operationName: $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchUpdateBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchUpdateBlocks) throw new Error('No data returned from GraphQL mutation');
    const graphqlResponse = result.data.blockService_batchUpdateBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
module.exports["getReferenceSyncedBlocks"] = $59e004c7d849e8bb$export$571f6abc3f4e5951;
module.exports["BlockError"] = $59e004c7d849e8bb$export$e47a0a94b0998697;
module.exports["BlockNotFoundError"] = $59e004c7d849e8bb$export$f5a00468af285e38;
module.exports["BlockTimeoutError"] = $59e004c7d849e8bb$export$b5687000eb0902be;
module.exports["getSyncedBlockContent"] = $59e004c7d849e8bb$export$fab66d51cc0c1a7;
module.exports["batchRetrieveSyncedBlocks"] = $59e004c7d849e8bb$export$48a4f565308f4741;
module.exports["deleteSyncedBlock"] = $59e004c7d849e8bb$export$cbbc86409cac3ee5;
module.exports["updateSyncedBlock"] = $59e004c7d849e8bb$export$d5bf0c5618431e5e;
module.exports["createSyncedBlock"] = $59e004c7d849e8bb$export$fbc30658d812c800;
module.exports["updateReferenceSyncedBlockOnDocument"] = $59e004c7d849e8bb$export$59c7369fa04bcba1;
module.exports["getReferenceSyncedBlocksByBlockAri"] = $59e004c7d849e8bb$export$75f5aeff9ce22a33;
module.exports["updateSyncedBlocks"] = $59e004c7d849e8bb$export$a9e53fa4329b5ed2;

});

parcelRegister("48FpT", function(module, exports) {
const $fc075454b76b2577$var$MAX_RETRY_DELAY = 30000;
const $fc075454b76b2577$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $fc075454b76b2577$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $fc075454b76b2577$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $fc075454b76b2577$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $fc075454b76b2577$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $fc075454b76b2577$export$cffaac380b94df26;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution, sourceLocation) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct, sourceLocation)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct, undefined, sourceLocation);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution, sourceLocation)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution, sourceLocation);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$6611683c2e3e50db = (resourceId, blockInstanceId, sourceProduct, sourceLocation)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct, sourceLocation)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment, sourceLocation)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            },
            ...enrichment?.nodeTypes?.length && {
                nodeTypes: enrichment.nodeTypes
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["getSourceInfoSuccessPayload"] = $5f570f8dd9ccb4e4$export$6611683c2e3e50db;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("7GRSG", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $3xsB6 = parcelRequire("3xsB6");


var $EBNuL = parcelRequire("EBNuL");

const $23c76758ad9684b4$export$63fea0488f1f3b79 = (productType)=>productType === 'jira-work-item' && (0, $4o0zT.isExperimentEnabled)('editor_synced_blocks_jira_custom_rich_text');
const $23c76758ad9684b4$export$6f2c88a8b48b006f = ({ documentAri: documentAri, hostAri: hostAri, productType: productType })=>hostAri !== undefined && $23c76758ad9684b4$export$63fea0488f1f3b79(productType) ? {
        locationScope: (0, $3xsB6.getLocationScope)({
            documentAri: documentAri,
            hostAri: hostAri
        })
    } : undefined;
const $23c76758ad9684b4$export$406c316e26a555c = (sourceAri)=>{
    if (!sourceAri || !$23c76758ad9684b4$export$63fea0488f1f3b79((0, $3xsB6.getProductFromSourceAri)(sourceAri))) return undefined;
    const location = (0, $EBNuL.parseJiraFieldLocation)({
        ari: sourceAri
    });
    if (!location) return undefined;
    return location.fieldId === (0, $EBNuL.JIRA_DESCRIPTION_FIELD_ID) ? 'description' : 'custom-field';
};
module.exports["getFieldAwareLocationScope"] = $23c76758ad9684b4$export$6f2c88a8b48b006f;
module.exports["getSourceLocation"] = $23c76758ad9684b4$export$406c316e26a555c;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("cvOi6", function(module, exports) {

let $91bf6407ae0be4ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $91bf6407ae0be4ff$var$load("7J1PC"),
    $91bf6407ae0be4ff$var$load("446Ip"),
    $91bf6407ae0be4ff$var$load("cp9QV")
]).then(()=>parcelRequire('kRm6Y'));

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("gb05o", function(module, exports) {
/**
 * Error codes for synced blocks preloading
 * Used for tracking and monitoring errors during SSR preload phase
 */ const $dcd4a25c1def153c$export$f10410d219e3ec29 = {
    /**
   * Occurs when the fetch operation returns fewer results than requested.
   * This indicates incomplete data retrieval or potential data loss.
   * Included in error: list of missing block identifiers
   */ FETCH_INCOMPLETE: 'SYNCED_BLOCKS_FETCH_INCOMPLETE',
    /**
   * Occurs when the batch fetch operation throws an error during execution.
   * This indicates a network error, timeout, or API failure.
   * Included in error: resource IDs that failed to fetch
   */ BATCH_FETCH_FAILED: 'SYNCED_BLOCKS_BATCH_FETCH_FAILED',
    /**
   * Occurs when the fetch operation times out without returning results.
   * This is specific to the bulk fetch operation with a configurable timeout.
   */ FETCH_TIMEOUT: 'SYNCED_BLOCKS_FETCH_TIMEOUT'
};
module.exports["SyncedBlocksSSRErrorCodeMap"] = $dcd4a25c1def153c$export$f10410d219e3ec29;

});

parcelRegister("2yWJZ", function(module, exports) {

var $2khPJ = parcelRequire("2khPJ");

const $7f640ed30a5677e6$export$62a80b577b02c670 = 'ai_mate_agent';
const $7f640ed30a5677e6$export$eaedd3c4d259c3db = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $7f640ed30a5677e6$export$d4e191820de5cb9e = $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$cf40b355c500b3f7 = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
const $7f640ed30a5677e6$export$84f2221dfd1486e2 = 'SYSTEM';
const $7f640ed30a5677e6$export$d54b716922cade63 = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $7f640ed30a5677e6$export$4529494ee013eb50 = ({ agentId: agentId, agentNamedId: agentNamedId })=>$7f640ed30a5677e6$export$d54b716922cade63(agentId) === $7f640ed30a5677e6$export$eaedd3c4d259c3db || $7f640ed30a5677e6$export$d54b716922cade63(agentNamedId) === $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$71c4912d3c1bf3e3 = (value)=>{
    const normalizedValue = $7f640ed30a5677e6$export$d54b716922cade63(value);
    if (!normalizedValue) return undefined;
    if (!normalizedValue.includes('ari:')) return normalizedValue;
    try {
        return $7f640ed30a5677e6$export$d54b716922cade63((0, $2khPJ.IdentityUserAri).parse(normalizedValue).userId);
    } catch  {
        return undefined;
    }
};
module.exports["ROVO_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$62a80b577b02c670;
module.exports["ROVO_AGENT_UUID"] = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $7f640ed30a5677e6$export$cf40b355c500b3f7;
module.exports["DEFAULT_AGENT_CREATOR_TYPE"] = $7f640ed30a5677e6$export$84f2221dfd1486e2;
module.exports["trimToUndefined"] = $7f640ed30a5677e6$export$d54b716922cade63;
module.exports["isDefaultRovoChat"] = $7f640ed30a5677e6$export$4529494ee013eb50;
module.exports["normalizeAccountIdFromIdentityAri"] = $7f640ed30a5677e6$export$71c4912d3c1bf3e3;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<aa6a269424bc1b4fc1bcb7ed6da5dcee>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "b239b4c898f62763088962d6011df617";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("kmvdJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d41dcdce6cad96086bdeda5999432f37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed2e1473028ddf28$var$_react = $ed2e1473028ddf28$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ed2e1473028ddf28$var$_iconNew = $ed2e1473028ddf28$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ed2e1473028ddf28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/audio
 * Usage guidance:
 * 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed2e1473028ddf28$var$AudioIcon = (props)=>/*#__PURE__*/ $ed2e1473028ddf28$var$_react.default.createElement($ed2e1473028ddf28$var$_iconNew.default, Object.assign({
        name: "AudioIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$ed2e1473028ddf28$var$AudioIcon.displayName = 'AudioIcon';
var $ed2e1473028ddf28$var$_default = module.exports.default = $ed2e1473028ddf28$var$AudioIcon;

});

parcelRegister("iqehY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d695bd348a8c5b11$var$_react = $d695bd348a8c5b11$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $d695bd348a8c5b11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d695bd348a8c5b11$var$Archive16Icon = (props)=>/*#__PURE__*/ $d695bd348a8c5b11$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d695bd348a8c5b11$var$Archive16Icon.displayName = 'Archive16Icon';
var $d695bd348a8c5b11$var$_default = module.exports.default = $d695bd348a8c5b11$var$Archive16Icon;

});

parcelRegister("adk2f", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $3cb2d8c9faefdb0f$var$iconStyles = null;
const $3cb2d8c9faefdb0f$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _0mcUfEey7F _2kxbLJey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg _0mcUfEoWWg _2kxbLJoWWg",
    large: "_39xV02Uofl _0jFU0VUofl _0mcUfEUofl _2kxbLJUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _0mcUfEpJKa _2kxbLJpJKa"
}; /**
    * For windows high contrast mode
    */ 
const $3cb2d8c9faefdb0f$var$baseHcmStyles = null;
const $3cb2d8c9faefdb0f$var$primaryEqualsSecondaryHcmStyles = null;
const $3cb2d8c9faefdb0f$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $3cb2d8c9faefdb0f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Icon(props) {
    const $ = (0, $bDgLe.c)(24);
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: t0, secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const primaryColor = t0 === undefined ? "currentColor" : t0;
    let t1;
    if ($[0] !== Glyph || $[1] !== dangerouslySetGlyph) {
        t1 = dangerouslySetGlyph ? {
            dangerouslySetInnerHTML: {
                __html: dangerouslySetGlyph
            }
        } : {
            children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
                role: "presentation"
            }) : null
        };
        $[0] = Glyph;
        $[1] = dangerouslySetGlyph;
        $[2] = t1;
    } else t1 = $[2];
    const glyphProps = t1;
    let t2;
    if ($[3] !== height || $[4] !== width) {
        t2 = width && height ? {
            width: width + "px",
            height: height + "px"
        } : null;
        $[3] = height;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    const customDimensions = t2;
    const t3 = `icon-${testId}`;
    const t4 = label ? "img" : undefined;
    const t5 = label ? label : undefined;
    const t6 = label ? undefined : true;
    let t7;
    if ($[6] !== UNSAFE_margin || $[7] !== customDimensions || $[8] !== primaryColor || $[9] !== secondaryColor) {
        t7 = {
            ...customDimensions,
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor,
            margin: UNSAFE_margin
        };
        $[6] = UNSAFE_margin;
        $[7] = customDimensions;
        $[8] = primaryColor;
        $[9] = secondaryColor;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    const t9 = primaryColor === secondaryColor && "_2W1hK9k5Cz";
    const t10 = secondaryColor === "transparent" && "_0ibj0wjOvk";
    const t11 = size && $3cb2d8c9faefdb0f$var$sizeStyles[size];
    let t12;
    if ($[11] !== t10 || $[12] !== t11 || $[13] !== t9) {
        t12 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _03DdiXlfZc _26BoRw7dHp _4hYdNbnQyn _4ktURhnQyn _1QzFdLN91d _2S9CkHN91d _3Krhx8bMfJ _0fvd5AdkvI _1O5n5yYbGa _4rPVFiUWqv _3J08zt98eZ",
            "_1hdADdMFyn _16qGwyTxK4 _4l7oXfk5Cz",
            t9,
            t10,
            t11
        ]);
        $[11] = t10;
        $[12] = t11;
        $[13] = t9;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== glyphProps || $[16] !== t12 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t8 || $[22] !== testId) {
        t13 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            "data-vc": t3,
            role: t4,
            "aria-label": t5,
            "aria-hidden": t6,
            style: t8,
            ...glyphProps,
            className: t12
        });
        $[15] = glyphProps;
        $[16] = t12;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = testId;
        $[23] = t13;
    } else t13 = $[23];
    return t13;
} : function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _03DdiXlfZc _26BoRw7dHp _4hYdNbnQyn _4ktURhnQyn _1QzFdLN91d _2S9CkHN91d _3Krhx8bMfJ _0fvd5AdkvI _1O5n5yYbGa _4rPVFiUWqv _3J08zt98eZ",
            "_1hdADdMFyn _16qGwyTxK4 _4l7oXfk5Cz",
            primaryColor === secondaryColor && "_2W1hK9k5Cz",
            secondaryColor === 'transparent' && "_0ibj0wjOvk",
            size && $3cb2d8c9faefdb0f$var$sizeStyles[size]
        ])
    });
});
var $3cb2d8c9faefdb0f$export$2e2bcd8739ae039 = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;
module.exports["Icon"] = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;

});

parcelRegister("3OVVx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2c82f9b957a0dd41$var$_react = $2c82f9b957a0dd41$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2c82f9b957a0dd41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2c82f9b957a0dd41$var$Executable16Icon = (props)=>/*#__PURE__*/ $2c82f9b957a0dd41$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm3 6.72v3.572c0 .394.32.714.714.714h8.572c.394 0 .714-.32.714-.714V8.714zM4.345 3a.714.714 0 0 0-.709.626L3 8.714h10l-.636-5.088A.714.714 0 0 0 11.655 3zm.798 7.143h5.714a.714.714 0 0 1 0 1.428H5.143a.714.714 0 1 1 0-1.428"/></svg>`
    }, props, {
        size: 'small'
    }));
$2c82f9b957a0dd41$var$Executable16Icon.displayName = 'Executable16Icon';
var $2c82f9b957a0dd41$var$_default = module.exports.default = $2c82f9b957a0dd41$var$Executable16Icon;

});

parcelRegister("EhIdb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $079179cb50a24843$var$_react = $079179cb50a24843$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $079179cb50a24843$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $079179cb50a24843$var$Gif16Icon = (props)=>/*#__PURE__*/ $079179cb50a24843$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$079179cb50a24843$var$Gif16Icon.displayName = 'Gif16Icon';
var $079179cb50a24843$var$_default = module.exports.default = $079179cb50a24843$var$Gif16Icon;

});

parcelRegister("hmd8r", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ca2eae1e9270fd6e$var$_react = $ca2eae1e9270fd6e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $ca2eae1e9270fd6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ca2eae1e9270fd6e$var$GoogleDoc16Icon = (props)=>/*#__PURE__*/ $ca2eae1e9270fd6e$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$ca2eae1e9270fd6e$var$GoogleDoc16Icon.displayName = 'GoogleDoc16Icon';
var $ca2eae1e9270fd6e$var$_default = module.exports.default = $ca2eae1e9270fd6e$var$GoogleDoc16Icon;

});

parcelRegister("lLxTI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fd88481d2a5e9c77$var$_react = $fd88481d2a5e9c77$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $fd88481d2a5e9c77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fd88481d2a5e9c77$var$GoogleForm16Icon = (props)=>/*#__PURE__*/ $fd88481d2a5e9c77$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fd88481d2a5e9c77$var$GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var $fd88481d2a5e9c77$var$_default = module.exports.default = $fd88481d2a5e9c77$var$GoogleForm16Icon;

});

parcelRegister("kUQwC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f3a1c7fef4d4d082$var$_react = $f3a1c7fef4d4d082$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f3a1c7fef4d4d082$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f3a1c7fef4d4d082$var$GoogleSheet16Icon = (props)=>/*#__PURE__*/ $f3a1c7fef4d4d082$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f3a1c7fef4d4d082$var$GoogleSheet16Icon.displayName = 'GoogleSheet16Icon';
var $f3a1c7fef4d4d082$var$_default = module.exports.default = $f3a1c7fef4d4d082$var$GoogleSheet16Icon;

});

parcelRegister("1G3Dq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $138c887dc5ea0961$var$_react = $138c887dc5ea0961$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $138c887dc5ea0961$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $138c887dc5ea0961$var$GoogleSlide16Icon = (props)=>/*#__PURE__*/ $138c887dc5ea0961$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$138c887dc5ea0961$var$GoogleSlide16Icon.displayName = 'GoogleSlide16Icon';
var $138c887dc5ea0961$var$_default = module.exports.default = $138c887dc5ea0961$var$GoogleSlide16Icon;

});

parcelRegister("1kVaD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0f9401986b2d6c49$var$_react = $0f9401986b2d6c49$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $0f9401986b2d6c49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0f9401986b2d6c49$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $0f9401986b2d6c49$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$0f9401986b2d6c49$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $0f9401986b2d6c49$var$_default = module.exports.default = $0f9401986b2d6c49$var$ExcelSpreadsheet16Icon;

});

parcelRegister("aeJll", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $773e626dd1065814$var$_react = $773e626dd1065814$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $773e626dd1065814$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $773e626dd1065814$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $773e626dd1065814$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$773e626dd1065814$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $773e626dd1065814$var$_default = module.exports.default = $773e626dd1065814$var$PowerpointPresentation16Icon;

});

parcelRegister("8If3N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $657e1d6efd6121d9$var$_react = $657e1d6efd6121d9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $657e1d6efd6121d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $657e1d6efd6121d9$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $657e1d6efd6121d9$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$657e1d6efd6121d9$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $657e1d6efd6121d9$var$_default = module.exports.default = $657e1d6efd6121d9$var$WordDocument16Icon;

});

parcelRegister("8B1YK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6423506162d1ed28$var$_react = $6423506162d1ed28$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $6423506162d1ed28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6423506162d1ed28$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $6423506162d1ed28$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$6423506162d1ed28$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $6423506162d1ed28$var$_default = module.exports.default = $6423506162d1ed28$var$PdfDocument16Icon;

});

parcelRegister("AzmWu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $06decc763d5ed155$var$_react = $06decc763d5ed155$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $06decc763d5ed155$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $06decc763d5ed155$var$Sketch16Icon = (props)=>/*#__PURE__*/ $06decc763d5ed155$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.02 13.333a.67.67 0 0 0 .502-.228L13.17 7.77a.67.67 0 0 0 .063-.79l-1.657-2.666A.67.67 0 0 0 11.01 4H5.116a.67.67 0 0 0-.554.296L2.779 6.963a.67.67 0 0 0 .054.81l4.686 5.334a.67.67 0 0 0 .5.226"/></svg>`
    }, props, {
        size: 'small'
    }));
$06decc763d5ed155$var$Sketch16Icon.displayName = 'Sketch16Icon';
var $06decc763d5ed155$var$_default = module.exports.default = $06decc763d5ed155$var$Sketch16Icon;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size,
            children: t3
        });
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("ipkS0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $3GQl6 = parcelRequire("3GQl6");

const $689b0be44fd5c2f8$var$logger = (0, $7W8i8.getLogger)('trackReactLazy');
// Marks a subtree whose code only loads when a render-time lazy component renders. The client
// cannot load it before hydration, so lazy components inside it must not hold hydration.
const $689b0be44fd5c2f8$var$RenderTimeLazyAncestor = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $689b0be44fd5c2f8$var$warnedRenderTimeIds = new Set();
// React 18's lazy initializer checks the component's status as soon as `then` returns, and suspends
// unless `then` has already called back. `Promise.resolve(loaded)` always calls back in a
// microtask, so it would suspend even for a loaded module. This Promise overrides `then` to call
// back synchronously. The rest of the Promise API goes through `then`, so `catch`, `finally` and
// `Promise.all` still work.
const $689b0be44fd5c2f8$var$resolvedThenable = (value)=>{
    const promise = new Promise((resolve)=>resolve(value));
    promise.then = (onFulfilled)=>Promise.resolve(onFulfilled ? onFulfilled(value) : value);
    return promise;
};
function $689b0be44fd5c2f8$var$withServerTracking(id, module, { renderTime: renderTime, source: source }) {
    const Original = module.default;
    const TrackedLazy = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        const hasRenderTimeAncestor = (0, $cozmU.useContext)($689b0be44fd5c2f8$var$RenderTimeLazyAncestor);
        const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Original, {
            ...props,
            ref: ref
        });
        if (renderTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689b0be44fd5c2f8$var$RenderTimeLazyAncestor.Provider, {
            value: true
        }, element);
        // Effects do not run during SSR, so render is the only place to record the rendered split.
        if (!hasRenderTimeAncestor && (0, $6mKj3.expValEquals)('confluence_ssr_react_lazy_preload', 'isEnabled', true)) (0, $3GQl6.addLoadableId)(id);
        return element;
    });
    TrackedLazy.displayName = `TrackedLazy(${Original.displayName || Original.name || 'Component'})`;
    return {
        ...module,
        default: TrackedLazy
    };
}
function $689b0be44fd5c2f8$export$fb5c897fe5d03fec(id, loader, options = {}) {
    // process.env.REACT_SSR is read inline so each build can drop the other side's branch. None of
    // these branches changes rendered markup, so they cannot cause a hydration mismatch.
    const prepare = (module)=>module;
    if (options.renderTime) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return loader;
    let loaded;
    let pending;
    const load = ()=>{
        pending ?? (pending = loader().then((module)=>{
            loaded = prepare(module);
            return loaded;
        }, (error)=>{
            pending = undefined;
            throw error;
        }));
        return pending;
    };
    let preloaded = false;
    // preloadIfNeeded can start loading at once. Waiting a microtask lets the defining module
    // finish evaluating before the loader reads any of its bindings.
    (0, $3GQl6.preloadIfNeeded)(id, undefined, ()=>Promise.resolve().then(load).then(()=>{
            preloaded = true;
        }));
    return ()=>{
        if (!loaded) return load();
        // The client only answers synchronously after the preload the server asked for, so lazy
        // components behave as before when the experiment is off.
        const canResolveSynchronously = preloaded;
        return canResolveSynchronously ? $689b0be44fd5c2f8$var$resolvedThenable(loaded) : load();
    };
}
module.exports["trackReactLazy"] = $689b0be44fd5c2f8$export$fb5c897fe5d03fec;

});

parcelRegister("3y1ko", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
        if (res.ok) enabled = await res.text() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await $4c06255176f911bc$export$632d1cf1f5c6210f();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$var$VERSION_HISTORY_CONTENT_TYPE_SET = {
    whiteboard: true,
    database: true,
    slide: true
};
const $2aa2bdb281c6889a$export$4c89eeb173e3fb0e = (contentType)=>!!contentType && Object.prototype.hasOwnProperty.call($2aa2bdb281c6889a$var$VERSION_HISTORY_CONTENT_TYPE_SET, contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["isVersionHistoryContentType"] = $2aa2bdb281c6889a$export$4c89eeb173e3fb0e;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("cuWGz", function(module, exports) {

var $e66dL = parcelRequire("e66dL");


var $aO6uT = parcelRequire("aO6uT");

function $61987beec044a597$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $aO6uT.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $e66dL.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $aO6uT.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $61987beec044a597$var$classifyComDomain(host);
        case 'net':
            return $61987beec044a597$var$classifyNetDomain(host);
        default:
            return (0, $aO6uT.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $61987beec044a597$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $aO6uT.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $aO6uT.Environment).Staging : (0, $aO6uT.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $aO6uT.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $61987beec044a597$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $aO6uT.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
        return (0, $aO6uT.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $aO6uT.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $aO6uT.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $aO6uT.Environment).Prod;
            return (0, $aO6uT.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $aO6uT.Environment).Development;
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
module.exports["getEnvironment"] = $61987beec044a597$export$57570b1603cf6adb;

});

parcelRegister("e66dL", function(module, exports) {

var $aO6uT = parcelRequire("aO6uT");

const $1c6adf460a912312$export$636c0c57a2ce36e9 = {
    localhost: (0, $aO6uT.Environment).Development,
    '127.0.0.1': (0, $aO6uT.Environment).Development,
    'id.atlassian.com': (0, $aO6uT.Environment).Prod,
    'admin.atlassian.com': (0, $aO6uT.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $aO6uT.Environment).Staging,
    'admin.stg.atlassian.com': (0, $aO6uT.Environment).Staging
};
module.exports["EXACT_HOST_MAP"] = $1c6adf460a912312$export$636c0c57a2ce36e9;

});

parcelRegister("aO6uT", function(module, exports) {
var $cf10c8edb5d48b94$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});
module.exports["Environment"] = $cf10c8edb5d48b94$export$7dc6752a22ab011a;

});

parcelRegister("a9aSv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("a5rDX", function(module, exports) {
const $86842ff0dedec441$export$8633a0edef8e95dd = 'emoji-common-selected';
const $86842ff0dedec441$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $86842ff0dedec441$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $86842ff0dedec441$export$b06c4aab1d012063 = 'emoji-common-node';
const $86842ff0dedec441$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $86842ff0dedec441$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $86842ff0dedec441$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $86842ff0dedec441$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $86842ff0dedec441$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $86842ff0dedec441$export$b0fe756d87022806 = 'emoji-picker-add-emoji';
module.exports["commonSelectedStyles"] = $86842ff0dedec441$export$8633a0edef8e95dd;
module.exports["selectOnHoverStyles"] = $86842ff0dedec441$export$860109dfd198259b;
module.exports["emojiSprite"] = $86842ff0dedec441$export$1c10634420a08d8a;
module.exports["emojiNodeStyles"] = $86842ff0dedec441$export$b06c4aab1d012063;
module.exports["emojiImage"] = $86842ff0dedec441$export$da61cef1c8919f7c;
module.exports["emojiDeleteButton"] = $86842ff0dedec441$export$b11fa39b56a371f6;
module.exports["emojiMainStyle"] = $86842ff0dedec441$export$11462c0756c24ab6;
module.exports["deletableEmoji"] = $86842ff0dedec441$export$22b19c311e9caa4;
module.exports["placeholder"] = $86842ff0dedec441$export$c7187bbd1a7a9244;
module.exports["emojiPickerAddEmoji"] = $86842ff0dedec441$export$b0fe756d87022806;

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("2uDbg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_30huDKYbGa _1xC2CJsLaB _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _0jFU0VN91d _034jHtYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _1YKVNsdnbC"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
            ]
        });
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss,
            children: [
                t16,
                t17,
                t18
            ]
        });
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hekY6.default)([
                    $5e9458ef4430c05f$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
                ]
            })
        ]
    });
}));
$5e9458ef4430c05f$export$48513f6b9f8ce62d.displayName = 'Checkbox'; // keep the default export for backwards compatibility
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["Checkbox"] = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_1xC2CJsLaB _4bt5LAnQyn _2WAcuGnQyn _23rrnHXVX0 _0bjKvDKxmn _32BiAhDfsT _1pp6NdYbGa _1UtDYzQPq5 _1rdFvh1XeA _3e6OgrLl21",
    rect: "_23rrnHFqy6 _4gxJYwNvrM _4e1TYvUkr1"
}; // Cross-fade colors and glyphs without moving the input or focus outline.
// Semantic tokens keep SVG colors, borders and indicators aligned with input motion.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $ef6550583d45a5c6$var$motionStyles = {
    root: "_23rrnHnc7r",
    selected: "_1YKVNs7dHp",
    glyph: "_23rrnHnc7r _1YKVNsdnbC _3wrwGmYbGa",
    border: "_23rrnHnc7r"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked, motionState) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit",
        className: (0, $hekY6.default)([
            motionState && $ef6550583d45a5c6$var$motionStyles.glyph,
            motionState === 'visible' && $ef6550583d45a5c6$var$motionStyles.selected
        ])
    });
    if (isChecked) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit",
        className: (0, $hekY6.default)([
            motionState && $ef6550583d45a5c6$var$motionStyles.glyph,
            motionState === 'visible' && $ef6550583d45a5c6$var$motionStyles.selected
        ])
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const hasMotion = (0, $iDrrr.fg)('platform_design_system_selection_radial_fade');
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root,
            hasMotion && $ef6550583d45a5c6$var$motionStyles.root
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $hekY6.default)([
                        $ef6550583d45a5c6$var$svgStyles.rect,
                        hasMotion && $ef6550583d45a5c6$var$motionStyles.border
                    ])
                }),
                hasMotion ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                    children: [
                        $ef6550583d45a5c6$var$getIcon(false, true, isChecked && !isIndeterminate ? 'visible' : 'hidden'),
                        $ef6550583d45a5c6$var$getIcon(true, false, isIndeterminate ? 'visible' : 'hidden')
                    ]
                }) : icon
            ]
        })
    });
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_2mHwu8RsfN _2iEGP2a3NQ";
    const t2 = (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4";
    const t3 = isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi";
    const t4 = isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id,
            children: children
        });
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            label && "_2mHwu8RsfN _2iEGP2a3NQ",
            (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi",
            isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r",
            isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]),
        children: children
    });
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_1UtDYzAyGJ _0LQT5EFQfX"
            ]),
            children: "*"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ _0LQT5EFQfX"
        ]),
        children: "*"
    });
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("e3Wrf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$inputMotionStyles = {
    legacy: "_23rrnH5Vpu",
    base: "_23rrnHGIwA"
};
const $f7ddda300dd34381$var$finessePlaceholderStyles = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
    subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textarea uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_2sNsIgmnOE _1gitD220Hp",
    monospace: "_2sNsIgmnOE _0WKd3Gfx9v _1gitD220Hp _3n0EfXdh5F"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_2HIj7GD4qA",
    vertical: "_2HIj7GbI28",
    auto: "_2HIj7GZSoF",
    smart: "_2HIj7GYbGa",
    none: "_2HIj7GYbGa"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(59);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const isInputMotionEnabled = (0, $iDrrr.fg)("platform-dst-motion-uplift-input");
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    const t20 = (0, $hekY6.default)([
        "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
        !isInputMotionEnabled && $f7ddda300dd34381$var$inputMotionStyles.legacy,
        isInputMotionEnabled && isInteractive && $f7ddda300dd34381$var$inputMotionStyles.base,
        (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_3AxjleZpcK",
        $f7ddda300dd34381$var$appearanceStyles[appearance],
        $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
        $f7ddda300dd34381$var$resizeStyles[resize],
        "_22P5CgPgdP _2Ombu6q5bj"
    ]);
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[36] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[36] = t21;
        $[37] = t22;
    } else t22 = $[37];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[38] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[38] = t23;
        $[39] = t24;
    } else t24 = $[39];
    let t25;
    if ($[40] !== maxHeight || $[41] !== style || $[42] !== t22 || $[43] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[40] = maxHeight;
        $[41] = style;
        $[42] = t22;
        $[43] = t24;
        $[44] = t25;
    } else t25 = $[44];
    let t26;
    if ($[45] !== controlProps || $[46] !== getTextAreaRef || $[47] !== handleOnChange || $[48] !== isDisabled || $[49] !== isReadOnly || $[50] !== isRequired || $[51] !== minimumRows || $[52] !== onBlurWithAnalytics || $[53] !== onFocusWithAnalytics || $[54] !== rest || $[55] !== t20 || $[56] !== t25 || $[57] !== value) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[45] = controlProps;
        $[46] = getTextAreaRef;
        $[47] = handleOnChange;
        $[48] = isDisabled;
        $[49] = isReadOnly;
        $[50] = isRequired;
        $[51] = minimumRows;
        $[52] = onBlurWithAnalytics;
        $[53] = onFocusWithAnalytics;
        $[54] = rest;
        $[55] = t20;
        $[56] = t25;
        $[57] = value;
        $[58] = t26;
    } else t26 = $[58];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const isInputMotionEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            !isInputMotionEnabled && $f7ddda300dd34381$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $f7ddda300dd34381$var$inputMotionStyles.base,
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("b5sDq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c17957e788935e20cad1a731882f109>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81265fa4dab37321$var$_react = $81265fa4dab37321$var$_interopRequireDefault((parcelRequire("cozmU")));

var $81265fa4dab37321$var$_iconNew = $81265fa4dab37321$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $81265fa4dab37321$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolMindMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/diagram-symbol-mind-map
 * Usage guidance:
 * Reserved for mind map diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81265fa4dab37321$var$DiagramSymbolMindMapIcon = (props)=>/*#__PURE__*/ $81265fa4dab37321$var$_react.default.createElement($81265fa4dab37321$var$_iconNew.default, Object.assign({
        name: "DiagramSymbolMindMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 13.5h2.5v-2H12zM1.5 9H4V7H1.5zM12 4.5h2.5v-2H12zm4 .125C16 5.385 15.384 6 14.625 6h-2.75c-.76 0-1.375-.616-1.375-1.375V4.25h-1a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h1v-.375c0-.76.616-1.375 1.375-1.375h2.75c.76 0 1.375.616 1.375 1.375v2.25c0 .76-.616 1.375-1.375 1.375h-2.75c-.76 0-1.375-.616-1.375-1.375v-.375h-1a2 2 0 0 1-2-2v-2.5h-2v.375c0 .76-.616 1.375-1.375 1.375h-2.75C.615 10.5 0 9.884 0 9.125v-2.25C0 6.115.616 5.5 1.375 5.5h2.75c.76 0 1.375.616 1.375 1.375v.375h2v-2.5a2 2 0 0 1 2-2h1v-.375c0-.76.616-1.375 1.375-1.375h2.75l.14.007c.694.07 1.235.656 1.235 1.368z"/>`
    }, props));
$81265fa4dab37321$var$DiagramSymbolMindMapIcon.displayName = 'DiagramSymbolMindMapIcon';
var $81265fa4dab37321$var$_default = module.exports.default = $81265fa4dab37321$var$DiagramSymbolMindMapIcon;

});

parcelRegister("eRn3r", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("9aUDG")).lazyForPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("9aUDG")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $5a3Es = parcelRequire("5a3Es");


var $9aUDG = parcelRequire("9aUDG");

parcelRequire("6VSrF");
var $86UVJ = parcelRequire("86UVJ");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("hZz7i");
var $3QYdZ = parcelRequire("3QYdZ");


var $itHHy = parcelRequire("itHHy");


var $bvYi1 = parcelRequire("bvYi1");


});

parcelRegister("jxKH9", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("3Pobi")).MODE);

var $3Pobi = parcelRequire("3Pobi");

const $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e3a55206c71bac9e$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e3a55206c71bac9e$var$DEFAULT_MODE = (0, $3Pobi.MODE).HYDRATE;
const $e3a55206c71bac9e$var$DEFAULT_RETRY = 2;
const $e3a55206c71bac9e$var$config = {
    crossOrigin: $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e3a55206c71bac9e$var$DEFAULT_MANIFEST,
    mode: $e3a55206c71bac9e$var$DEFAULT_MODE,
    retry: $e3a55206c71bac9e$var$DEFAULT_RETRY
};
const $e3a55206c71bac9e$export$44487a86467333c3 = ()=>$e3a55206c71bac9e$var$config;
const $e3a55206c71bac9e$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $e3a55206c71bac9e$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN;
    $e3a55206c71bac9e$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $e3a55206c71bac9e$var$DEFAULT_MANIFEST;
    $e3a55206c71bac9e$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $e3a55206c71bac9e$var$DEFAULT_MODE;
    $e3a55206c71bac9e$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $e3a55206c71bac9e$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $e3a55206c71bac9e$export$44487a86467333c3;
module.exports["setConfig"] = $e3a55206c71bac9e$export$940a7873bb071df8;

});

parcelRegister("3Pobi", function(module, exports) {
const $2c98e46ce94c4b5d$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $2c98e46ce94c4b5d$export$e48589d9e4824227;

});

parcelRegister("5a3Es", function(module, exports) {

var $eegtN = parcelRequire("eegtN");


var $jxKH9 = parcelRequire("jxKH9");

parcelRequire("itHHy");
var $ehkpF = parcelRequire("ehkpF");
var $8r5Wf = parcelRequire("8r5Wf");


var $hBrZE = parcelRequire("hBrZE");

const $3c20b80e9e8d3df3$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $jxKH9.setConfig)(config);
        (0, $ehkpF.LISTENERS).length = 0;
        (0, $8r5Wf.setCurrent)(0);
        if (!(0, $hBrZE.isNodeEnvironment)()) (0, $eegtN.collect)();
    }
};

});

parcelRegister("eegtN", function(module, exports) {

var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");


var $4qzp5 = parcelRequire("4qzp5");


var $8WAU6 = parcelRequire("8WAU6");

const $a5bf27f95a5c4338$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $jxKH9.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $3Pobi.MODE).RENDER ? (0, $4qzp5.cloneElements)(markers[i], lazyBegin) : (0, $8WAU6.refElements)(markers[i], lazyBegin);
        if ((0, $gy5kI.COLLECTED).has(lazyBegin)) (0, $gy5kI.COLLECTED).get(lazyBegin).push(value);
        else (0, $gy5kI.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $a5bf27f95a5c4338$export$bb44f104e3c54dae;

});

parcelRegister("gy5kI", function(module, exports) {
const $c0c3f558a37c633a$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c0c3f558a37c633a$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $c0c3f558a37c633a$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $c0c3f558a37c633a$export$4831ef3968ea94ef;

});

parcelRegister("4qzp5", function(module, exports) {
const $33950d892bd67505$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $33950d892bd67505$export$c42217d53a7ebafb;

});

parcelRegister("8WAU6", function(module, exports) {
const $68305ddfb331b362$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $68305ddfb331b362$export$c69443129766a7fc;

});

parcelRegister("itHHy", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("8r5Wf")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("8r5Wf")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("ehkpF")).LISTENERS);

var $8r5Wf = parcelRequire("8r5Wf");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");


});

parcelRegister("8r5Wf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gy5kI = parcelRequire("gy5kI");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");

let $6245739e6eaab8ef$var$CURRENT_PHASE = (0, $gy5kI.PHASE).PAINT;
const $6245739e6eaab8ef$export$5f80f094fd31fffd = (phase)=>{
    $6245739e6eaab8ef$var$CURRENT_PHASE = phase;
    (0, $ehkpF.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $6245739e6eaab8ef$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $6h5l4.createSubscribe)((0, $ehkpF.LISTENERS)),
    currentValue: ()=>$6245739e6eaab8ef$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).PAINT)
    }
});
const $6245739e6eaab8ef$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($6245739e6eaab8ef$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $6245739e6eaab8ef$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $6245739e6eaab8ef$export$5a25eca35e5debcb;

});

parcelRegister("ehkpF", function(module, exports) {
const $a6527ccf54714552$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $a6527ccf54714552$export$81b9c458a026d68f;

});

parcelRegister("6h5l4", function(module, exports) {
const $491878cc97587aa1$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $491878cc97587aa1$export$364097d812234b3f;

});

parcelRegister("hBrZE", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("9fFjP")).default);

var $9fFjP = parcelRequire("9fFjP");

const $cd0b9b420a47cee1$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $cd0b9b420a47cee1$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $cd0b9b420a47cee1$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $cd0b9b420a47cee1$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $cd0b9b420a47cee1$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $cd0b9b420a47cee1$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $cd0b9b420a47cee1$export$283635c04a02cc36;
module.exports["attrToProp"] = $cd0b9b420a47cee1$export$62bf630d0de3d781;

});

parcelRegister("9fFjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc590d7746b5907$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6bc590d7746b5907$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9aUDG", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");


var $hBrZE = parcelRequire("hBrZE");
var $9fFjP = parcelRequire("9fFjP");


var $aH9lN = parcelRequire("aH9lN");


var $ilEj6 = parcelRequire("ilEj6");


var $lJ3sU = parcelRequire("lJ3sU");


var $ajpr4 = parcelRequire("ajpr4");


var $67Nku = parcelRequire("67Nku");


var $edTIv = parcelRequire("edTIv");


var $17PxK = parcelRequire("17PxK");

function $6ae0fb8adbd87448$var$_extends() {
    $6ae0fb8adbd87448$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ae0fb8adbd87448$var$_extends.apply(this, arguments);
}
function $6ae0fb8adbd87448$var$lazyProxy(_loader, { defer: defer = (0, $gy5kI.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $hBrZE.isNodeEnvironment)();
    const dataLazyId = (0, $9fFjP.default)(moduleId);
    const LazyInternal = isServer ? (0, $lJ3sU.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $ilEj6.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ajpr4.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $jxKH9.getConfig)();
                return (0, $edTIv.retry)(_loader, {
                    delay: (0, $aH9lN.RETRY_DELAY),
                    factor: (0, $aH9lN.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $hBrZE.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jxKH9.getConfig)();
        return (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gy5kI.PHASE).PAINT ? (0, $aH9lN.PRIORITY).HIGH : (0, $aH9lN.PRIORITY).LOW;
        return (0, $67Nku.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6ae0fb8adbd87448$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gy5kI.PHASE).LAZY
    }
};
function $6ae0fb8adbd87448$export$c952e5f94576010e(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$291dd592399bdafa(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$488013bae63b21da(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6ae0fb8adbd87448$export$c952e5f94576010e;
module.exports["lazy"] = $6ae0fb8adbd87448$export$488013bae63b21da;

});

parcelRegister("hXfAR", function(module, exports) {
const $d1240ae4295f4288$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $d1240ae4295f4288$export$303f43e55cf1ef2f;

});

parcelRegister("aH9lN", function(module, exports) {
const $7c952c608ad2380e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $7c952c608ad2380e$export$a339266ad71b2447 = 300;
const $7c952c608ad2380e$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $7c952c608ad2380e$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $7c952c608ad2380e$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $7c952c608ad2380e$export$ba64c908e55507fe;

});

parcelRegister("ilEj6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("6VSrF");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $aH9lN = parcelRequire("aH9lN");


var $17PxK = parcelRequire("17PxK");


var $6adGO = parcelRequire("6adGO");


var $jl5l1 = parcelRequire("jl5l1");


var $67Nku = parcelRequire("67Nku");


var $bvYi1 = parcelRequire("bvYi1");


var $aiyJe = parcelRequire("aiyJe");

function $d5b97455f4530d40$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $cozmU.useContext)((0, $bvYi1.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $17PxK.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $aiyJe.useSubscription)({
            context: (0, $dHqFW.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gy5kI.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $aiyJe.useSubscription)({
                context: (0, $8r5Wf.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $cozmU.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $67Nku.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $aH9lN.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        (0, $cozmU.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gy5kI.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jxKH9.getConfig)().mode === (0, $3Pobi.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6adGO.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jl5l1.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $d5b97455f4530d40$export$6898b5504b58699a;

});

parcelRegister("6VSrF", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("dHqFW")).WaitContext);

var $dHqFW = parcelRequire("dHqFW");


var $86UVJ = parcelRequire("86UVJ");


});

parcelRegister("dHqFW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eYtLL = parcelRequire("eYtLL");

const $9f93fbb489094a52$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: ()=>(0, $eYtLL.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $9f93fbb489094a52$export$9ba3fe09d15de47b;

});

parcelRegister("eYtLL", function(module, exports) {
const $ae6dc2e0431b9395$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $ae6dc2e0431b9395$export$276c7dbda7675aec;

});

parcelRegister("86UVJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dHqFW = parcelRequire("dHqFW");

const $5e7b0b64cd38d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $cozmU.useContext)((0, $dHqFW.WaitContext));
    const value = (0, $cozmU.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $cozmU.useRef)(new Set());
    const api = (0, $cozmU.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $cozmU.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHqFW.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("hZz7i", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("aZNtm")).LazySuspenseContext);

var $3QYdZ = parcelRequire("3QYdZ");


var $aZNtm = parcelRequire("aZNtm");


});

parcelRegister("3QYdZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");


var $aZNtm = parcelRequire("aZNtm");

class $2ce4f1cfa8b44b57$export$256c542058532d6f extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $hBrZE.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $cozmU.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $2ce4f1cfa8b44b57$export$256c542058532d6f;

});

parcelRegister("aZNtm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8015fa1bd12f3c41$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $8015fa1bd12f3c41$export$c33990e84065970c;

});

parcelRegister("17PxK", function(module, exports) {
const $0d1e6d5848f254be$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $0d1e6d5848f254be$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$0d1e6d5848f254be$export$6aa69c1258005366]: true
    });
    return error;
};
const $0d1e6d5848f254be$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($0d1e6d5848f254be$export$6aa69c1258005366);
module.exports["createLoaderError"] = $0d1e6d5848f254be$export$c73a6a6f0bf7d425;

});

parcelRegister("6adGO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $47ce4bb11269d032$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $47ce4bb11269d032$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($47ce4bb11269d032$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $47ce4bb11269d032$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $47ce4bb11269d032$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $47ce4bb11269d032$export$d55db778a3e1446b;

});

parcelRegister("jl5l1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");

function $e1441e868bb78192$var$_extends() {
    $e1441e868bb78192$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1441e868bb78192$var$_extends.apply(this, arguments);
}
const $e1441e868bb78192$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $hBrZE.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), $e1441e868bb78192$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $e1441e868bb78192$export$ca5b8fbc835d95e4;

});

parcelRegister("67Nku", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");


var $hBrZE = parcelRequire("hBrZE");


var $aH9lN = parcelRequire("aH9lN");


var $2mjKV = parcelRequire("2mjKV");


var $bvYi1 = parcelRequire("bvYi1");

function $4759a958e17e309b$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jxKH9.getConfig)();
    const assets = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $2mjKV.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $4759a958e17e309b$var$fakePromise = {
    then: ()=>$4759a958e17e309b$var$fakePromise,
    catch: ()=>$4759a958e17e309b$var$fakePromise,
    finally: ()=>$4759a958e17e309b$var$fakePromise
};
function $4759a958e17e309b$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $2mjKV.insertLinkTag)(href, rel));
        return $4759a958e17e309b$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $4759a958e17e309b$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $eYtLL.noopCleanup;
}
function $4759a958e17e309b$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $hBrZE.isNodeEnvironment)()) return 0, $eYtLL.noopCleanup;
    (_GlobalReactLooselyLa = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $aH9lN.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $4759a958e17e309b$export$3af04dbcb01bad4d,
        $4759a958e17e309b$export$1046fd6a49d5e7a,
        $4759a958e17e309b$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $eYtLL.noopCleanup;
}
module.exports["preloadAsset"] = $4759a958e17e309b$export$25bad4aa00c45355;

});

parcelRegister("2mjKV", function(module, exports) {

var $bvYi1 = parcelRequire("bvYi1");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");

function $1b7cf5f1f73f5f76$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $eYtLL.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jxKH9.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $1b7cf5f1f73f5f76$export$6610512821c8a4ce;

});

parcelRegister("bvYi1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $86215b3df1759e88$export$e2d53c0cbedd2710 = {
    current: null
};
const $86215b3df1759e88$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $cozmU.createContext)($86215b3df1759e88$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $86215b3df1759e88$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $86215b3df1759e88$export$8146ab57a3f7a7cb;

});

parcelRegister("aiyJe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $77f6862aa953f5ea$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $77f6862aa953f5ea$export$368b4214baeb914c;

});

parcelRegister("lJ3sU", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $hBrZE = parcelRequire("hBrZE");


var $17PxK = parcelRequire("17PxK");

function $fd107d191750b962$var$load(moduleId, loader) {
    try {
        return (0, $hBrZE.getExport)(loader());
    } catch (err) {
        throw (0, $17PxK.createLoaderError)(err);
    }
}
function $fd107d191750b962$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $fd107d191750b962$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $jxKH9.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gy5kI.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
                key: url,
                rel: defer === (0, $gy5kI.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $fd107d191750b962$export$eb2e4b04351cdd9e;

});

parcelRegister("ajpr4", function(module, exports) {
const $781f68b739b0ef47$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $781f68b739b0ef47$export$e673efccd97e4223;

});

parcelRegister("edTIv", function(module, exports) {
const $a5ad7fc44a458961$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $a5ad7fc44a458961$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $a5ad7fc44a458961$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $a5ad7fc44a458961$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $a5ad7fc44a458961$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $a5ad7fc44a458961$var$calculateDelay(context, policy);
        if (delay) await $a5ad7fc44a458961$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $a5ad7fc44a458961$export$9369b12211e1fce4;

});

parcelRegister("1LXnB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

const $12a75cc47e499450$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
module.exports["WidthObserver"] = $12a75cc47e499450$export$b2ad68b9bc407b80;

});

parcelRegister("69NJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("6Gf6E", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cRhiT = parcelRequire("cRhiT");


var $ieeJu = parcelRequire("ieeJu");


var $haHjk = parcelRequire("haHjk");


var $ktiH5 = parcelRequire("ktiH5");


var $ft6gK = parcelRequire("ft6gK");


var $ipkS0 = parcelRequire("ipkS0");


const $b84cbf4837a1f547$var$LazyAkCodeBlock = /*#__PURE__*/ (0, $cozmU.lazy)(// eslint-disable-next-line require-await
(0, $ipkS0.trackReactLazy)("rl-HDTU_y", async ()=>(parcelRequire("lQxzK"))));
const $b84cbf4837a1f547$var$joinWithSpaces = (...strs)=>strs.join(' ');
const $b84cbf4837a1f547$var$MemoizedLightWeightCodeBlock = /*#__PURE__*/ (0, $cozmU.memo)((0, $ft6gK.default));
const $b84cbf4837a1f547$var$WindowedCodeBlock = ({ text: text, language: language, allowCopyToClipboard: allowCopyToClipboard, allowDownloadCodeBlock: allowDownloadCodeBlock, allowWrapCodeBlock: allowWrapCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, hideLineNumbers: hideLineNumbers = false, className: rootClassName, wrap: wrap })=>{
    const { isInViewport: isInViewport, trackingRef: trackingRef } = (0, $haHjk.useInViewport)();
    const className = $b84cbf4837a1f547$var$joinWithSpaces((0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, rootClassName);
    const memoizedLightWeightCodeBlock = /*#__PURE__*/ (0, $lOiVq.jsx)($b84cbf4837a1f547$var$MemoizedLightWeightCodeBlock, {
        ref: trackingRef,
        text: text,
        hideLineNumbers: (0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && hideLineNumbers,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: rootClassName
    });
    const [wrapLongLines, setWrapLongLines] = (0, $cozmU.useState)(()=>(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && Boolean(wrap));
    return isInViewport ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Suspense), {
        fallback: memoizedLightWeightCodeBlock
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ktiH5.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        allowDownloadCodeBlock: allowDownloadCodeBlock,
        language: language,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($b84cbf4837a1f547$var$LazyAkCodeBlock, {
        language: language,
        text: text,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines,
        shouldShowLineNumbers: !((0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && hideLineNumbers),
        hasBidiWarnings: false
    })))) : memoizedLightWeightCodeBlock;
};
var $b84cbf4837a1f547$export$2e2bcd8739ae039 = $b84cbf4837a1f547$var$WindowedCodeBlock;
module.exports["default"] = $b84cbf4837a1f547$export$2e2bcd8739ae039;

});

parcelRegister("haHjk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9e23c124dab9d57b$export$6215040b989f9b0f = ()=>{
    const trackingRef = (0, $cozmU.useRef)(null);
    const [isInViewport, setIsInViewport] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!trackingRef || !trackingRef?.current) return;
        const target = trackingRef.current;
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) setIsInViewport(true);
        });
        observer.observe(target);
        return ()=>observer.disconnect();
    }, [
        trackingRef
    ]);
    return {
        isInViewport: isInViewport,
        trackingRef: trackingRef
    };
};
module.exports["useInViewport"] = $9e23c124dab9d57b$export$6215040b989f9b0f;

});

parcelRegister("ktiH5", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $cRhiT = parcelRequire("cRhiT");


var $lWhNb = parcelRequire("lWhNb");

const $9f5f5a5e204d1173$var$codeBlockStyleOverrides = /*#__PURE__*/ (0, $lOiVq.css)({
    tabSize: 4,
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        opacity: 0,
        transition: 'opacity 0.2s ease 0s'
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        button: {
            opacity: 1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $cRhiT.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem',
        backgroundImage: `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			)`,
        backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
        backgroundPosition: '0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0'
    }
});
const $9f5f5a5e204d1173$var$denseModeOverrides = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $cRhiT.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5em'
    }
});
const $9f5f5a5e204d1173$var$CodeBlockContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowDownloadCodeBlock: allowDownloadCodeBlock, allowWrapCodeBlock: allowWrapCodeBlock, children: children, className: className, language: language, localId: localId, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-local-id": localId,
        css: [
            $9f5f5a5e204d1173$var$codeBlockStyleOverrides,
            $9f5f5a5e204d1173$var$denseModeOverrides
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lWhNb.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowDownloadCodeBlock: allowDownloadCodeBlock,
        allowWrapCodeBlock: allowWrapCodeBlock,
        language: language,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }), children);
};
var $9f5f5a5e204d1173$export$2e2bcd8739ae039 = $9f5f5a5e204d1173$var$CodeBlockContainer;
module.exports["default"] = $9f5f5a5e204d1173$export$2e2bcd8739ae039;

});

parcelRegister("lWhNb", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $l2vLQ = parcelRequire("l2vLQ");


var $ZsWjb = parcelRequire("ZsWjb");


var $c7hhP = parcelRequire("c7hhP");

const $52190c6d0ebde3fc$var$codeBlockButtonsWrapper = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'sticky',
    top: '0px',
    background: `${"var(--ds-surface, #FFFFFF)"}`
});
const $52190c6d0ebde3fc$var$codeBlockButtonsStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    height: '0',
    width: '100%',
    right: "var(--ds-space-075, 6px)",
    top: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        height: '32px',
        width: '32px',
        border: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        borderRadius: "var(--ds-radius-small, 4px)",
        marginLeft: "var(--ds-space-050, 4px)",
        padding: "var(--ds-space-025, 2px)",
        background: `${"var(--ds-surface-overlay, #FFFFFF)"}`,
        color: `${"var(--ds-icon, #292A2E)"}`,
        '&:hover': {
            borderWidth: "var(--ds-border-width-selected, 2px)",
            backgroundColor: `${"var(--ds-surface-overlay-hovered, #F0F1F2)"}`,
            height: '32px',
            width: '32px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.clicked': {
            backgroundColor: `${"var(--ds-background-neutral-bold-pressed, #505258)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${"var(--ds-icon-inverse, #FFFFFF)"} !important`
        }
    }
});
const $52190c6d0ebde3fc$var$CodeBlockButtonContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowDownloadCodeBlock: allowDownloadCodeBlock, allowWrapCodeBlock: allowWrapCodeBlock, language: language, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $52190c6d0ebde3fc$var$codeBlockButtonsWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $52190c6d0ebde3fc$var$codeBlockButtonsStyle
    }, allowDownloadCodeBlock && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ZsWjb.default), {
        content: text,
        language: language ?? null
    }), allowWrapCodeBlock && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c7hhP.default), {
        setWrapLongLines: setWrapLongLines,
        wrapLongLines: wrapLongLines
    }), allowCopyToClipboard && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l2vLQ.default), {
        content: text
    })));
};
var $52190c6d0ebde3fc$export$2e2bcd8739ae039 = $52190c6d0ebde3fc$var$CodeBlockButtonContainer;
module.exports["default"] = $52190c6d0ebde3fc$export$2e2bcd8739ae039;

});

parcelRegister("l2vLQ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $go7uG = parcelRequire("go7uG");


var $fHs3z = parcelRequire("fHs3z");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $grAaA = parcelRequire("grAaA");


var $GTXrQ = parcelRequire("GTXrQ");


var $jyFxy = parcelRequire("jyFxy");

const $4d50ddf7976fff0b$var$CopyButton = ({ content: content, intl: intl })=>{
    const copyCodeToClipboardMessage = (0, $4o0zT.isExperimentEnabled)('platform_editor_a11y_codeblock_copy_name') ? (0, $go7uG.codeBlockButtonMessages).copyCodeSnippetToClipboard : (0, $go7uG.codeBlockButtonMessages).copyCodeToClipboard;
    const [tooltip, setTooltip] = (0, $cozmU.useState)(intl.formatMessage(copyCodeToClipboardMessage));
    const [className, setClassName] = (0, $cozmU.useState)('copy-to-clipboard');
    const onMouseLeave = ()=>{
        setTooltip(intl.formatMessage(copyCodeToClipboardMessage));
        setClassName('copy-to-clipboard');
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $grAaA.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top",
            hasNewContentOnTriggerClick: true
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            onMouseLeave: onMouseLeave,
            onBlur: onMouseLeave
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
            appearance: "subtle",
            "aria-haspopup": (0, $iDrrr.fg)('platform_editor_a11y_codeblock_haspopup') ? undefined : true,
            "aria-label": tooltip,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                label: tooltip
            }),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $GTXrQ.ACTION).CLICKED,
                    actionSubject: (0, $GTXrQ.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $GTXrQ.ACTION_SUBJECT_ID).CODEBLOCK_COPY,
                    eventType: (0, $GTXrQ.EVENT_TYPE).UI
                });
                (0, $jyFxy.copyTextToClipboard)(content);
                setTooltip(intl.formatMessage((0, $go7uG.codeBlockButtonMessages).copiedCodeToClipboard));
                setClassName('copy-to-clipboard clicked');
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
const $4d50ddf7976fff0b$var$_default_1 = (0, $kSwu1.injectIntl)($4d50ddf7976fff0b$var$CopyButton);
var $4d50ddf7976fff0b$export$2e2bcd8739ae039 = $4d50ddf7976fff0b$var$_default_1;
module.exports["default"] = $4d50ddf7976fff0b$export$2e2bcd8739ae039;

});

parcelRegister("go7uG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8f99a430e8355353$export$74e304339778e94d = (0, $kSwu1.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copyCodeSnippetToClipboard: {
        id: "editor-common.messages.codeBlockButton.copyCodeSnippetToClipboard",
        defaultMessage: "Copy code text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    wrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.wrapCode",
        defaultMessage: "Wrap code"
    },
    unwrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCode",
        defaultMessage: "Unwrap code"
    },
    showLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.showLineNumbers",
        defaultMessage: "Show line numbers"
    },
    hideLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.hideLineNumbers",
        defaultMessage: "Hide line numbers"
    },
    formatCode: {
        id: "fabric.editor.codeBlockFormatButton.formatCode",
        defaultMessage: "Format code"
    },
    formatCodeUnavailable: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeUnavailable",
        defaultMessage: "Formatting not available for this language"
    },
    formatCodeFailed: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailed",
        defaultMessage: "Code formatting failed"
    },
    formatCodeFailedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedDescription",
        defaultMessage: "Review the content or change the selected language."
    },
    formatCodeFailedAutoDetectedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription",
        defaultMessage: "Review the content or select a specific language."
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    },
    detectLanguage: {
        id: "fabric.editor.codeBlock.detectLanguage",
        defaultMessage: "Detect language"
    },
    detectedLanguage: {
        id: "fabric.editor.codeBlock.detectedLanguage",
        defaultMessage: "{language} (detected)"
    },
    noneDetected: {
        id: "fabric.editor.codeBlock.noneDetected",
        defaultMessage: "(None detected)"
    },
    recentlyUsed: {
        id: "fabric.editor.codeBlock.recentlyUsed",
        defaultMessage: "Recently used"
    },
    all: {
        id: "fabric.editor.codeBlock.all",
        defaultMessage: "All"
    },
    downloadCodeBlock: {
        id: "fabric.editor.codeBlockDownloadButton.downloadCodeBlock",
        defaultMessage: "Download"
    }
});
module.exports["codeBlockButtonMessages"] = $8f99a430e8355353$export$74e304339778e94d;

});

parcelRegister("ZsWjb", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $go7uG = parcelRequire("go7uG");


var $6Fmj3 = parcelRequire("6Fmj3");


var $lpNn5 = parcelRequire("lpNn5");


var $grAaA = parcelRequire("grAaA");


var $GTXrQ = parcelRequire("GTXrQ");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a2cfbdf1fa443b38$var$FILENAME_COMMENT_REGEX = /^(?:#|\/\/|<!--)\s*([\w.\-]+)\s*(?:-->)?$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a2cfbdf1fa443b38$var$FILE_EXTENSION_STRIP_REGEX = /\.[^.]+$/;
/**
 * NOTE: The language-to-extension mapping logic below is intentionally duplicated in
 * platform/packages/ai-mate/conversation-assistant-utils/src/downloadCodeBlock.ts.
 * This is because @atlaskit/renderer cannot import from @atlassian/conversation-assistant-utils
 * (cross-package dependency not allowed). If you update the logic here, update it there too.
 *
 * Maps ADF code block language names to file extensions.
 * Inlined here to avoid cross-package dependencies on ai-mate packages.
 */ const $a2cfbdf1fa443b38$var$languageToExtension = {
    bash: 'sh',
    c: 'c',
    cpp: 'cpp',
    css: 'css',
    csv: 'csv',
    go: 'go',
    htm: 'html',
    html: 'html',
    java: 'java',
    javascript: 'js',
    js: 'js',
    json: 'json',
    jsx: 'jsx',
    less: 'less',
    markdown: 'md',
    md: 'md',
    python: 'py',
    ruby: 'rb',
    rust: 'rs',
    scss: 'scss',
    sh: 'sh',
    shell: 'sh',
    sql: 'sql',
    ts: 'ts',
    tsx: 'tsx',
    typescript: 'ts',
    xml: 'xml',
    yaml: 'yaml',
    yml: 'yaml'
};
const $a2cfbdf1fa443b38$var$getFileExtension = (language)=>{
    if (!language) return 'txt';
    return $a2cfbdf1fa443b38$var$languageToExtension[language.toLowerCase()] ?? 'txt';
};
const $a2cfbdf1fa443b38$var$suggestBaseName = (content)=>{
    const firstMeaningfulLine = content.split('\n').find((l)=>l.trim()) ?? '';
    const filenameMatch = firstMeaningfulLine.trim().match($a2cfbdf1fa443b38$var$FILENAME_COMMENT_REGEX);
    if (filenameMatch) return filenameMatch[1].replace($a2cfbdf1fa443b38$var$FILE_EXTENSION_STRIP_REGEX, '') || 'rovo-snippet';
    const cleaned = firstMeaningfulLine// Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    .replace(/[^a-zA-Z0-9\s]/g, ' ').trim()// eslint-disable-next-line require-unicode-regexp
    .replace(/\s+/g, '-').toLowerCase().slice(0, 30);
    return cleaned || 'rovo-snippet';
};
const $a2cfbdf1fa443b38$var$triggerDownload = (content, language)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    if (typeof document === 'undefined') return;
    const extension = $a2cfbdf1fa443b38$var$getFileExtension(language);
    const resolvedFilename = `${$a2cfbdf1fa443b38$var$suggestBaseName(content)}.${extension}`;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const doc = document;
    const blob = new Blob([
        content
    ], {
        type: 'text/plain'
    });
    const url = URL.createObjectURL(blob);
    const anchor = doc.createElement('a');
    anchor.href = url;
    anchor.download = resolvedFilename;
    anchor.style.display = 'none';
    doc.body.appendChild(anchor);
    anchor.dispatchEvent(new MouseEvent('click', {
        bubbles: false,
        cancelable: true,
        view: window
    }));
    doc.body.removeChild(anchor);
    // Defer revocation to avoid race condition in Safari/Firefox
    setTimeout(()=>URL.revokeObjectURL(url), 0);
};
const $a2cfbdf1fa443b38$var$DownloadButton = ({ content: content, language: language, intl: intl })=>{
    const tooltip = intl.formatMessage((0, $go7uG.codeBlockButtonMessages).downloadCodeBlock);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $grAaA.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1sCHt.default), {
            appearance: "subtle",
            label: tooltip,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $GTXrQ.ACTION).CLICKED,
                    actionSubject: (0, $GTXrQ.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $GTXrQ.ACTION_SUBJECT_ID).CODEBLOCK_DOWNLOAD,
                    eventType: (0, $GTXrQ.EVENT_TYPE).UI
                });
                $a2cfbdf1fa443b38$var$triggerDownload(content, language);
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
const $a2cfbdf1fa443b38$var$_default_1 = (0, $kSwu1.injectIntl)($a2cfbdf1fa443b38$var$DownloadButton);
var $a2cfbdf1fa443b38$export$2e2bcd8739ae039 = $a2cfbdf1fa443b38$var$_default_1;
module.exports["default"] = $a2cfbdf1fa443b38$export$2e2bcd8739ae039;

});

parcelRegister("c7hhP", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $go7uG = parcelRequire("go7uG");


var $dwAVI = parcelRequire("dwAVI");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $grAaA = parcelRequire("grAaA");


var $GTXrQ = parcelRequire("GTXrQ");

const $43a24c6a53301d6c$var$CodeBlockWrapButton = ({ setWrapLongLines: setWrapLongLines, wrapLongLines: wrapLongLines, intl: intl })=>{
    const wrapMessage = intl.formatMessage(wrapLongLines ? (0, $go7uG.codeBlockButtonMessages).unwrapCode : (0, $go7uG.codeBlockButtonMessages).wrapCode);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $grAaA.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: wrapMessage,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
            appearance: "subtle",
            "aria-haspopup": (0, $iDrrr.fg)('platform_editor_a11y_codeblock_haspopup') ? undefined : true,
            "aria-label": wrapMessage,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `wrap-code ${wrapLongLines ? 'clicked' : ''}`,
            iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dwAVI))), {
                label: ""
            }),
            isSelected: wrapLongLines,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $GTXrQ.ACTION).CLICKED,
                    actionSubject: (0, $GTXrQ.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $GTXrQ.ACTION_SUBJECT_ID).CODEBLOCK_WRAP,
                    attributes: {
                        wrapped: !wrapLongLines
                    },
                    eventType: (0, $GTXrQ.EVENT_TYPE).UI
                });
                setWrapLongLines(!wrapLongLines);
                event.stopPropagation();
            },
            spacing: "compact"
        }))));
};
const $43a24c6a53301d6c$var$_default_1 = (0, $kSwu1.injectIntl)($43a24c6a53301d6c$var$CodeBlockWrapButton);
var $43a24c6a53301d6c$export$2e2bcd8739ae039 = $43a24c6a53301d6c$var$_default_1;
module.exports["default"] = $43a24c6a53301d6c$export$2e2bcd8739ae039;

});

parcelRegister("lQxzK", function(module, exports) {

let $fe787fb01d254b96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe787fb01d254b96$var$load("kMVpD"),
    $fe787fb01d254b96$var$load("fKQ9j"),
    $fe787fb01d254b96$var$load("b21kU")
]).then(()=>parcelRequire('8hQmz'));

});

parcelRegister("azTKI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $LQnOI = parcelRequire("LQnOI");


var $8Yf90 = parcelRequire("8Yf90");


var $dE1Ef = parcelRequire("dE1Ef");


var $aiIAm = parcelRequire("aiIAm");


var $8hFP3 = parcelRequire("8hFP3");

const $be4360ed45643068$var$getCodeBlockStyles = {
    root: "_2sNsIgNxAV _0bjKvD8fU6 _3hxITiYbGa _3iDTPbQ4SZ _26BoRwSPN1 _4bt5LAIZbP _1ANEUSZYee _3kIIylnHLs _0KLXruTnLi _1UtDYzy7kJ _41xRuTZqHV _0wsbMQZqHV _1Vv2BRZqHV _1MJTRw2ADO _1VRVtu2ADO _3Zw3U32ADO _1sW0GU2ADO _1cpJ0P2ADO _4uAYuq2ADO _3xurjO8OLE _24aN1k8OLE _24cw6O8OLE _2YUq7vT56g _4rwuIAT56g _4relqwT56g _4h2nXCLylE _2X8S4KVo9d _26OL3SA17z _3f1HWyUNDJ _3nEQ9lWVPG _45HGsTogpp _1NDUiPRk67 _2AZQRwRAKS _070NdTe513 _2mR1zoJ5bs _1JRCrsJ5bs _1MrCCcWfES _1fOBFsIZbP _07M2jG7dHp _3UzSvZwPeg _26723KAASz _2bS9wvnQyn _1pRU7ZnQyn _3PHYjSnQyn _1KFGm0nQyn _2xUcbno0UC _03sBWZo0UC _1vNOowdEFh _3KfFpTdEFh _2dLOxDHZdu _37Zs15HZdu _1xk3cBWVPG _2HVJpyWVPG _3moo9OLRg7 _3wNpSILRg7 _3RewtzHZdu _1y77T5HZdu _18Ay7cDMqu _1RZDyz7bNJ _1ez7v1JUHd _0gsOWsgpwa _1czuGQWfES _3uxU7hecOK _3OqUgdUS2K _25mvE1KG6X _2yiaa3KG6X _3OqUgdvLZJ _1PWdmGvLZJ _45Qk4AYbGa _3BIJL2YbGa _1jeJFj0dzo _1poUkx0dzo _1Ifefc2ADO _0OxqLg2ADO _35sviK2ADO _4FTb7w2ADO _2e6T0BWfES _0iupi1WfES _0YOcqP2Njc _0Oip2Y2Njc _2lek4NdnbC _34MfQ4dnbC _1tklhi1PzL _0MrNBj1PzL _2zMfI7WMvv _17laEUWMvv _4w3UV24WFv _2OfOg54WFv _0DagTWmb2E _0Pms1oquXj _0D6SsjGpkd _1y7ChDGpkd _2hw91PGpkd _0XohueNSuU _1VNVCDNSuU _1v3FcSquXj _0eivC9quXj _1cwHzQZqHV _0EyMX8DIkS _4zNlXb9qYF _4ilBRJy7kJ _2Aqhav9qYF _3HZJ4Jy7kJ _0BGVQj866Z _2yaqNYjgGB _3qO1JaY3Jz _1bWu9ZYfD7 _0cwANAy7kJ _2rPjlHKGUX _3UcXUV866Z _1WAgFnY3Jz _3HDkH0866Z _13xEgzy7kJ _2ikkxZKGUX _0uxFrp9qYF _4G3kv7YfD7 _4tUqIpYfD7 _4c3v8AYfD7 _4qeMtX9qYF _29yBp3Y3Jz _0t7QZoY3Jz _3R7oq7Y3Jz _3flWPdY3Jz _1ED3NYY3Jz _008WkAYfD7 _1nFDoWY3Jz _3WibeRY3Jz _1siGfsY3Jz _37rtJn866Z _4kXAQn866Z _4bhSaL866Z _42VNCi866Z _1kfycv866Z _04xRuFKGUX _0a0obTDIkS _1kLOyZYfD7 _0JDL4nKGUX _16PhfRKGUX _3mKtdo866Z _0CjFNWY3Jz _1JVEKb866Z _0sY6Cf866Z",
    showLineNumbers: "_2PYTHN2Knr _3zmZ6SQ4SZ _2OyLtHdnbC _184mfRdnbC _1Hail4dnbC _3rkWqZdnbC _2v76MbdnbC _3a6DiydnbC",
    dontShowLineNumbers: "_3zmZ6SvLZJ _2OyLtH2ADO _184mfR2ADO _1Hail42ADO _3rkWqZ2ADO _2v76Mb2ADO _3a6Diy2ADO",
    shouldWrapLongLines: "_2B7tyz7dHp",
    dontWrapLongLines: "_2B7tyz7dHp"
}; /**
    * __Code block__
    *
    * A code block highlights an entire block of code and keeps the formatting.
    *
    * - [Examples](https://atlassian.design/components/code/code-block/examples)
    * - [Code](https://atlassian.design/components/code/code-block/code)
    * - [Usage](https://atlassian.design/components/code/code-block/usage)
    */ 
const $be4360ed45643068$var$CodeBlock = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { showLineNumbers: t1, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: t2, language: t3, highlight: t4, highlightedStartText: t5, highlightedEndText: t6, testId: testId, text: text, codeBidiWarnings: t7, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: t8, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: t9, label: t10 } = t0;
    const showLineNumbers = t1 === undefined ? true : t1;
    const firstLineNumber = t2 === undefined ? 1 : t2;
    const providedLanguage = t3 === undefined ? "text" : t3;
    const highlight = t4 === undefined ? "" : t4;
    const highlightedStartText = t5 === undefined ? "Highlight start" : t5;
    const highlightedEndText = t6 === undefined ? "Highlight end" : t6;
    const codeBidiWarnings = t7 === undefined ? true : t7;
    const codeBidiWarningTooltipEnabled = t8 === undefined ? true : t8;
    const shouldWrapLongLines = t9 === undefined ? false : t9;
    const label = t10 === undefined ? "Scrollable content" : t10;
    const scrollableRef = (0, $cozmU.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $cozmU.useState)(false);
    const t11 = text || "";
    let t12;
    if ($[0] !== t11) {
        t12 = t11.split("\n");
        $[0] = t11;
        $[1] = t12;
    } else t12 = $[1];
    const numLines = t12.length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    let t13;
    if ($[2] !== numLines) {
        t13 = numLines ? (0, $dE1Ef.getLineNumWidth)(numLines) : 0;
        $[2] = numLines;
        $[3] = t13;
    } else t13 = $[3];
    const lineNumberWidth = t13;
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    let t14;
    let t15;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>{
            const schedule = (0, $LQnOI.default)(()=>{
                const target = scrollableRef.current;
                target && setShowContentFocus(target.scrollWidth > target.clientWidth);
            });
            schedule();
            const unbindWindowEvent = (0, $cbY7C.bind)(window, {
                type: "resize",
                listener: schedule
            });
            return unbindWindowEvent;
        };
        t15 = [
            scrollableRef
        ];
        $[4] = t14;
        $[5] = t15;
    } else {
        t14 = $[4];
        t15 = $[5];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    if ($[6] !== highlight || $[7] !== testId) {
        t16 = {
            highlight: highlight,
            testId: testId
        };
        $[6] = highlight;
        $[7] = testId;
        $[8] = t16;
    } else t16 = $[8];
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $8Yf90.useHighlightLines)(t16);
    let t17;
    if ($[9] !== getHighlightStyles || $[10] !== highlightedLines) {
        t17 = (line)=>getHighlightStyles(line, highlightedLines);
        $[9] = getHighlightStyles;
        $[10] = highlightedLines;
        $[11] = t17;
    } else t17 = $[11];
    const getLineProps = t17;
    let t18;
    if ($[12] !== providedLanguage) {
        t18 = (0, $aiIAm.normalizeLanguage)(providedLanguage);
        $[12] = providedLanguage;
        $[13] = t18;
    } else t18 = $[13];
    const language = t18;
    const languageToUse = text ? language : "text";
    const t19 = `calc(${lineNumberWidth} + 16px)`;
    let t20;
    if ($[14] !== highlightedEndText || $[15] !== highlightedStartText || $[16] !== t19) {
        t20 = {
            "--ads-code-line-number-width": t19,
            "--ads-highlighted-start-text": highlightedStartText,
            "--ads-highlighted-end-text": highlightedEndText
        };
        $[14] = highlightedEndText;
        $[15] = highlightedStartText;
        $[16] = t19;
        $[17] = t20;
    } else t20 = $[17];
    const t21 = highlight.length > 0 || !!testId;
    const t22 = showContentFocus ? "0" : undefined;
    const t23 = showContentFocus ? label : undefined;
    const t24 = showContentFocus ? "region" : undefined;
    const t25 = shouldWrapLongLines ? $be4360ed45643068$var$getCodeBlockStyles.shouldWrapLongLines : $be4360ed45643068$var$getCodeBlockStyles.dontWrapLongLines;
    const t26 = shouldShowLineNumbersValue ? $be4360ed45643068$var$getCodeBlockStyles.showLineNumbers : $be4360ed45643068$var$getCodeBlockStyles.dontShowLineNumbers;
    let t27;
    if ($[18] !== t25 || $[19] !== t26) {
        t27 = (0, $hekY6.default)([
            $be4360ed45643068$var$getCodeBlockStyles.root,
            t25,
            t26
        ]);
        $[18] = t25;
        $[19] = t26;
        $[20] = t27;
    } else t27 = $[20];
    let t28;
    if ($[21] !== codeBidiWarningLabel || $[22] !== firstLineNumber || $[23] !== getLineProps || $[24] !== language || $[25] !== languageToUse || $[26] !== shouldEnableTooltip || $[27] !== shouldShowBidiWarnings || $[28] !== shouldShowLineNumbersValue || $[29] !== shouldWrapLongLines || $[30] !== t20 || $[31] !== t21 || $[32] !== t22 || $[33] !== t23 || $[34] !== t24 || $[35] !== t27 || $[36] !== testId || $[37] !== text) {
        t28 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8hFP3.default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            style: t20,
            showLineNumbers: shouldShowLineNumbersValue,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: t21,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: shouldShowBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: shouldEnableTooltip,
            text: text,
            tabIndex: t22,
            "aria-label": t23,
            role: t24,
            scrollRef: scrollableRef,
            className: t27
        });
        $[21] = codeBidiWarningLabel;
        $[22] = firstLineNumber;
        $[23] = getLineProps;
        $[24] = language;
        $[25] = languageToUse;
        $[26] = shouldEnableTooltip;
        $[27] = shouldShowBidiWarnings;
        $[28] = shouldShowLineNumbersValue;
        $[29] = shouldWrapLongLines;
        $[30] = t20;
        $[31] = t21;
        $[32] = t22;
        $[33] = t23;
        $[34] = t24;
        $[35] = t27;
        $[36] = testId;
        $[37] = text;
        $[38] = t28;
    } else t28 = $[38];
    return t28;
} : ({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' })=>{
    const scrollableRef = (0, $cozmU.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $cozmU.useState)(false); // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $dE1Ef.getLineNumWidth)(numLines) : 0; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled; // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $cozmU.useEffect)(()=>{
        const schedule = (0, $LQnOI.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $8Yf90.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $cozmU.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $cozmU.useMemo)(()=>(0, $aiIAm.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]); // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8hFP3.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $hekY6.default)([
            $be4360ed45643068$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $be4360ed45643068$var$getCodeBlockStyles.shouldWrapLongLines : $be4360ed45643068$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $be4360ed45643068$var$getCodeBlockStyles.showLineNumbers : $be4360ed45643068$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $be4360ed45643068$export$2e2bcd8739ae039 = $be4360ed45643068$var$CodeBlock;
module.exports["default"] = $be4360ed45643068$export$2e2bcd8739ae039;

});

parcelRegister("8Yf90", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b6616760b57d61ef$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $b6616760b57d61ef$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$b6616760b57d61ef$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $b6616760b57d61ef$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $b6616760b57d61ef$export$84415a200bdf33ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { highlight: t1, testId: testId } = t0;
    const highlight = t1 === undefined ? "" : t1;
    let t2;
    bb0: {
        if (!highlight) {
            let t3;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = [];
                $[0] = t3;
            } else t3 = $[0];
            t2 = t3;
            break bb0;
        }
        let t3;
        if ($[1] !== highlight) {
            t3 = highlight.split(",").map($b6616760b57d61ef$var$_temp3).reduce($b6616760b57d61ef$var$_temp4, []) || [];
            $[1] = highlight;
            $[2] = t3;
        } else t3 = $[2];
        t2 = t3;
    }
    const highlightedLines = t2;
    let t3;
    if ($[3] !== highlight || $[4] !== testId) {
        t3 = (lineNumber, highlightedLines_0)=>{
            if (!highlight || highlightedLines_0.length === 0) return $b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines_0.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    "data-ds--code--row--highlight": ""
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId);
        };
        $[3] = highlight;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    const getHighlightStyles = t3;
    let t4;
    if ($[6] !== getHighlightStyles || $[7] !== highlightedLines) {
        t4 = {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
        $[6] = getHighlightStyles;
        $[7] = highlightedLines;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $cozmU.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $cozmU.useCallback)((lineNumber, highlightedLines_0)=>{
        if (!highlight || highlightedLines_0.length === 0) return $b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines_0.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};
function $b6616760b57d61ef$var$_temp(a, b) {
    return a - b;
}
function $b6616760b57d61ef$var$_temp2(_, index) {
    return index;
}
function $b6616760b57d61ef$var$_temp3(num) {
    if (num.indexOf("-") > 0) {
        const [from, to] = num.split("-").map(Number).sort($b6616760b57d61ef$var$_temp);
        return Array(to + 1).fill(undefined).map($b6616760b57d61ef$var$_temp2).slice(from, to + 1);
    }
    return Number(num);
}
function $b6616760b57d61ef$var$_temp4(acc, val) {
    return acc.concat(val);
}
module.exports["useHighlightLines"] = $b6616760b57d61ef$export$84415a200bdf33ed;

});

parcelRegister("dE1Ef", function(module, exports) {
const $ddf77cb4ea5c6975$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};
module.exports["getLineNumWidth"] = $ddf77cb4ea5c6975$export$cb7aec0206b595d2;

});

parcelRegister("aiIAm", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $8Xus6 = parcelRequire("8Xus6");

const $fd1f127bb5d9a2d7$export$f38728011c178796 = (0, $dOBRD.default)((language)=>{
    if (!language) return '';
    const match = (0, $8Xus6.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});
module.exports["normalizeLanguage"] = $fd1f127bb5d9a2d7$export$f38728011c178796;

});

parcelRegister("8Xus6", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages
const $cfd109792a890cba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $cfd109792a890cba$export$7c77c3a9bb93870d;

});

parcelRegister("8hFP3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $dy0x0 = parcelRequire("dy0x0");

// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $3e52128a57221d8f$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $8aG6j.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    AsyncHighlighter.astGenerator = null;
    AsyncHighlighter.highlightInstance = (0, $dy0x0.default);
    AsyncHighlighter.astGeneratorPromise = void 0;
    return AsyncHighlighter;
};

const $3e52128a57221d8f$var$asyncGenerator = $3e52128a57221d8f$var$generator({
    loader: ()=>(parcelRequire("fVAUw")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $3e52128a57221d8f$export$2e2bcd8739ae039 = $3e52128a57221d8f$var$asyncGenerator;
module.exports["default"] = $3e52128a57221d8f$export$2e2bcd8739ae039;

});

parcelRegister("dy0x0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $guTSu = parcelRequire("guTSu");


var $9kQvF = parcelRequire("9kQvF");

/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $5653218f26b4434f$var$Highlight = /*#__PURE__*/ (0, $cozmU.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $guTSu.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $9kQvF.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $5653218f26b4434f$export$2e2bcd8739ae039 = $5653218f26b4434f$var$Highlight;
module.exports["default"] = $5653218f26b4434f$export$2e2bcd8739ae039;

});

parcelRegister("guTSu", function(module, exports) {
$parcel$export(module.exports, "default", () => $65ca4c69dbd48716$export$2e2bcd8739ae039);

var $felT0 = parcelRequire("felT0");


var $h4laV = parcelRequire("h4laV");


var $bGjaO = parcelRequire("bGjaO");


var $8vsoX = parcelRequire("8vsoX");

const $65ca4c69dbd48716$var$newLineRegex = /\n/g;
function $65ca4c69dbd48716$var$getNewLines(str) {
    return str.match($65ca4c69dbd48716$var$newLineRegex);
}
function $65ca4c69dbd48716$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $8vsoX.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $felT0.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $bGjaO.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $65ca4c69dbd48716$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $h4laV.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $h4laV.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});

parcelRegister("felT0", function(module, exports) {

var $h4laV = parcelRequire("h4laV");


var $8SWaI = parcelRequire("8SWaI");

function $072d30781f36cca2$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $h4laV.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $8SWaI.default)(lineNumber));
            return children;
        }
    };
}
var $072d30781f36cca2$export$2e2bcd8739ae039 = $072d30781f36cca2$var$createLineGenerator;
module.exports["default"] = $072d30781f36cca2$export$2e2bcd8739ae039;

});

parcelRegister("h4laV", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f661f77f5eb16d1$export$2e2bcd8739ae039);

var $8SWaI = parcelRequire("8SWaI");

function $4f661f77f5eb16d1$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $8SWaI.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $8SWaI.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});

parcelRegister("8SWaI", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e34657173dc8a32$export$2e2bcd8739ae039);
function $1e34657173dc8a32$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});

parcelRegister("bGjaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2b14fb4112a1d0b$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");


var $h4laV = parcelRequire("h4laV");

function $f2b14fb4112a1d0b$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $h4laV.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            // If this node is a re-highlighted fenced code-block wrapper (added by
            // rehighlightFencedBlocks in get-code-tree.tsx), reset the accumulated
            // class list instead of concatenating onto ancestors.  Without this,
            // every token inside the fenced block inherits all ancestor classes
            // (e.g. "token code token code-block language-jsx token plain-text").
            const nodeClasses = node.properties.className || [];
            const isCodeBlock = (0, $iDrrr.fg)('platform-code-highlight-markdown-safe') && nodeClasses.includes('code-block');
            // When entering a re-highlighted fenced code-block wrapper, reset the
            // accumulated ancestor classes to empty so children only carry their
            // own token classes (not the full ancestor chain).
            const classNames = isCodeBlock ? [] : className.concat(nodeClasses);
            $f2b14fb4112a1d0b$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("8vsoX", function(module, exports) {
$parcel$export(module.exports, "default", () => $50be1c6a1c382338$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

/**
 * Extract the plain text content from a list of RefractorNodes.
 */ function $50be1c6a1c382338$var$extractText(nodes) {
    return nodes.map((n)=>{
        if (n.type === 'text') return n.value;
        return n.children ? $50be1c6a1c382338$var$extractText(n.children) : '';
    }).join('');
}
/**
 * Walk the safe-highlighted AST and, for every fenced code block (a `token code`
 * span), replace the raw text child with a properly highlighted `token code-block
 * language-{lang}` span so that inner tokens carry the correct classes.
 */ function $50be1c6a1c382338$var$rehighlightFencedBlocks(nodes, astGenerator) {
    const refractorLike = astGenerator;
    return nodes.map((node)=>{
        if (node.type !== 'element') return node;
        const classes = node.properties?.className ?? [];
        const isCodeToken = classes.includes('token') && classes.includes('code');
        if (!isCodeToken || !node.children) return {
            ...node,
            children: $50be1c6a1c382338$var$rehighlightFencedBlocks(node.children ?? [], astGenerator)
        };
        // Find the code-language child to determine which sub-language to use.
        const langNode = node.children.find((c)=>c.type === 'element' && c.properties?.className?.includes('code-language'));
        const subLang = langNode && langNode.type === 'element' ? $50be1c6a1c382338$var$extractText(langNode.children ?? []).trim() : null;
        // Find the raw text child that holds the fenced block content (after the
        // opening ``` line and before the closing ```).
        const children = node.children.map((child)=>{
            // This is the raw code content
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            const rawContent = 'value' in child ? child.value : undefined;
            if (!subLang || !rawContent) return child;
            // Only re-highlight when the sub-language is registered with refractor to
            // avoid an uncaught exception.
            const isRegistered = typeof refractorLike.registered === 'function' ? refractorLike.registered(subLang) : Boolean(refractorLike.languages?.[subLang]);
            if (!isRegistered) return child;
            let highlighted;
            try {
                highlighted = astGenerator.highlight(rawContent, subLang);
            } catch  {
                return child;
            }
            // Wrap in a `token code-block language-{lang}` span to match what the
            // normal (non-safe) markdown highlight would produce.
            const codeBlockNode = {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: [
                        'token',
                        'code-block',
                        `language-${subLang}`
                    ]
                },
                children: highlighted
            };
            return codeBlockNode;
        });
        return {
            ...node,
            children: children
        };
    });
}
function $50be1c6a1c382338$var$highlightMarkdownSafely(code, astGenerator) {
    const refractorLike = astGenerator;
    const markdownCodeToken = refractorLike.languages?.markdown?.code;
    const fencedToken = Array.isArray(markdownCodeToken) ? markdownCodeToken[1] : undefined;
    const originalInside = fencedToken?.inside;
    const canDisableEmbeddedCodeBlock = originalInside && 'code-block' in originalInside;
    if (canDisableEmbeddedCodeBlock) {
        const patchedInside = {
            ...originalInside
        };
        delete patchedInside['code-block'];
        fencedToken.inside = patchedInside;
    }
    let result;
    try {
        result = astGenerator.highlight(code, 'markdown');
    } finally{
        if (canDisableEmbeddedCodeBlock) fencedToken.inside = originalInside;
    }
    // Re-highlight inner fenced code blocks so tokens carry proper classes.
    return $50be1c6a1c382338$var$rehighlightFencedBlocks(result, astGenerator);
}
function $50be1c6a1c382338$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        if (language === 'markdown' && (0, $iDrrr.fg)('platform-code-highlight-markdown-safe')) return $50be1c6a1c382338$var$highlightMarkdownSafely(code, astGenerator);
        return astGenerator.highlight(code, language);
    } catch  {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});

parcelRegister("9kQvF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $809xX = parcelRequire("809xX");

/**
 * __React Renderer__
 *
 * A component that receives processed code lines and renders them into the code
 * rows inside the wrapping span and nested code tag, applying passed props and
 * code bidi warning config settings.
 */ const $92dee5d6cf819d4e$var$ReactRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ReactRenderer(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig } = t0;
    let t1;
    if ($[0] !== codeBidiWarningConfig || $[1] !== rows) {
        let t2;
        if ($[3] !== codeBidiWarningConfig) {
            t2 = (node, i)=>(0, $809xX.default)({
                    node: node,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment${i}`
                });
            $[3] = codeBidiWarningConfig;
            $[4] = t2;
        } else t2 = $[4];
        t1 = rows.map(t2);
        $[0] = codeBidiWarningConfig;
        $[1] = rows;
        $[2] = t1;
    } else t1 = $[2];
    const renderedRows = t1;
    let t2;
    if ($[5] !== codeTagProps || $[6] !== renderedRows) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        });
        $[5] = codeTagProps;
        $[6] = renderedRows;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== containerProps || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ...containerProps,
            children: t2
        });
        $[8] = containerProps;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : function ReactRenderer({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $809xX.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
};
var $92dee5d6cf819d4e$export$2e2bcd8739ae039 = $92dee5d6cf819d4e$var$ReactRenderer;
module.exports["default"] = $92dee5d6cf819d4e$export$2e2bcd8739ae039;

});

parcelRegister("809xX", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4471c7360c10a82$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cOjjv = parcelRequire("cOjjv");


var $fYRS9 = parcelRequire("fYRS9");


var $6tTKn = parcelRequire("6tTKn");

function $b4471c7360c10a82$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $b4471c7360c10a82$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $cOjjv.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fYRS9.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $6tTKn.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $b4471c7360c10a82$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});

parcelRegister("6tTKn", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc6767443d5ef390$export$2e2bcd8739ae039);

var $809xX = parcelRequire("809xX");

function $dc6767443d5ef390$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $809xX.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});

parcelRegister("fVAUw", function(module, exports) {

let $b988cf96a4df261f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b988cf96a4df261f$var$load("6BcKU"),
    $b988cf96a4df261f$var$load("jLzUq"),
    $b988cf96a4df261f$var$load("aHPkU"),
    $b988cf96a4df261f$var$load("eFN6F"),
    $b988cf96a4df261f$var$load("6y28K"),
    $b988cf96a4df261f$var$load("70T6q"),
    $b988cf96a4df261f$var$load("3Q1al"),
    $b988cf96a4df261f$var$load("kZNtA"),
    $b988cf96a4df261f$var$load("dJz5X"),
    $b988cf96a4df261f$var$load("cYM9J"),
    $b988cf96a4df261f$var$load("1lMYe"),
    $b988cf96a4df261f$var$load("hGWdL"),
    $b988cf96a4df261f$var$load("8mXuQ"),
    $b988cf96a4df261f$var$load("iweX1"),
    $b988cf96a4df261f$var$load("dJHgt"),
    $b988cf96a4df261f$var$load("ilPgZ"),
    $b988cf96a4df261f$var$load("18ynq"),
    $b988cf96a4df261f$var$load("91r0n"),
    $b988cf96a4df261f$var$load("krBs8"),
    $b988cf96a4df261f$var$load("i2zNU"),
    $b988cf96a4df261f$var$load("1djfG"),
    $b988cf96a4df261f$var$load("5eCbj"),
    $b988cf96a4df261f$var$load("b6K6H"),
    $b988cf96a4df261f$var$load("d5Kce"),
    $b988cf96a4df261f$var$load("eRRvI"),
    $b988cf96a4df261f$var$load("lpmt6"),
    $b988cf96a4df261f$var$load("cEygf"),
    $b988cf96a4df261f$var$load("hOZqL"),
    $b988cf96a4df261f$var$load("5wICh"),
    $b988cf96a4df261f$var$load("arxq8"),
    $b988cf96a4df261f$var$load("jlfAK"),
    $b988cf96a4df261f$var$load("flGYk"),
    $b988cf96a4df261f$var$load("9SnQD"),
    $b988cf96a4df261f$var$load("da56Y"),
    $b988cf96a4df261f$var$load("g6dof"),
    $b988cf96a4df261f$var$load("bAPA5"),
    $b988cf96a4df261f$var$load("4aYRs"),
    $b988cf96a4df261f$var$load("dtWTG"),
    $b988cf96a4df261f$var$load("eG8G4"),
    $b988cf96a4df261f$var$load("htCkI"),
    $b988cf96a4df261f$var$load("g28Sl"),
    $b988cf96a4df261f$var$load("6gMuM"),
    $b988cf96a4df261f$var$load("juHD5"),
    $b988cf96a4df261f$var$load("ivuvF"),
    $b988cf96a4df261f$var$load("fDDPF"),
    $b988cf96a4df261f$var$load("lBGAC"),
    $b988cf96a4df261f$var$load("1i9T4"),
    $b988cf96a4df261f$var$load("6M79T"),
    $b988cf96a4df261f$var$load("6gFO0"),
    $b988cf96a4df261f$var$load("20IMn")
]).then(()=>parcelRequire('lRcwr'));

});

parcelRegister("6KU95", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $azTKI = parcelRequire("azTKI");


var $cRhiT = parcelRequire("cRhiT");


var $ieeJu = parcelRequire("ieeJu");


var $ktiH5 = parcelRequire("ktiH5");

function $70357f4ec334e6c0$var$CodeBlock(props) {
    const { text: text, language: language, allowCopyToClipboard: allowCopyToClipboard = false, allowWrapCodeBlock: allowWrapCodeBlock = false, allowDownloadCodeBlock: allowDownloadCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, hideLineNumbers: hideLineNumbers = false, localId: localId, wrap: wrap } = props;
    const className = [
        (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
        props.className
    ].join(' ');
    const [wrapLongLines, setWrapLongLines] = (0, $cozmU.useState)(()=>(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && Boolean(wrap));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ktiH5.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        allowDownloadCodeBlock: allowDownloadCodeBlock,
        language: language,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        localId: localId,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $azTKI.default), {
        testId: "renderer-code-block",
        language: language,
        text: text,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines,
        shouldShowLineNumbers: !((0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && hideLineNumbers),
        hasBidiWarnings: false
    }));
}
const $70357f4ec334e6c0$var$_default_1 = (0, $kSwu1.injectIntl)($70357f4ec334e6c0$var$CodeBlock);
var $70357f4ec334e6c0$export$2e2bcd8739ae039 = $70357f4ec334e6c0$var$_default_1;
module.exports["default"] = $70357f4ec334e6c0$export$2e2bcd8739ae039;

});

parcelRegister("gvXEn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $8kNOP = parcelRequire("8kNOP");

class $732d2f7205e6fea4$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { children: children, localId: localId } = this.props;
        if ((0, $cozmU.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8kNOP.default), {
            listId: localId,
            children: children
        });
    }
}
module.exports["default"] = $732d2f7205e6fea4$export$2e2bcd8739ae039;

});

parcelRegister("8kNOP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $g8WS7 = parcelRequire("g8WS7");


var $52VjW = parcelRequire("52VjW");

const $7aade51ade799bff$var$listStyles = null;
const $7aade51ade799bff$var$TaskList = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { listId: listId, children: children } = t0;
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!children) return null;
    const t1 = "group";
    const t2 = "";
    let t3;
    if ($[0] !== formatMessage) {
        t3 = formatMessage((0, $52VjW.messages).fieldsetLabel);
        $[0] = formatMessage;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_0aNu0LYbGa _2Zuz6QdnbC _1gva8q1Y8M"
        ]);
        $[2] = t4;
    } else t4 = $[2];
    const t5 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8WS7.FabricElementsAnalyticsContext), {
            data: {
                listLocalId: listId,
                listSize: listSize,
                position: idx
            }
        }, child));
    let t6;
    if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: t1,
            "data-task-list-local-id": t2,
            "aria-label": t3,
            className: t4
        }, t5);
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ listId: listId, children: children })=>{
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!children) return null;
     // Data attributes are required for copy and paste from rendered content
    // to the editor to preserve the task.
    // This allows the editor to differentiate between numbered and ordered lists,
    // and action items, which all share the common '‹li›' element.
    // The value of 'data-task-local-id' should be discarded upon paste, with a
    // a new uuid generated by the editor for the cloned content.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "group",
        "data-task-list-local-id": "",
        "aria-label": formatMessage((0, $52VjW.messages).fieldsetLabel),
        className: (0, $hekY6.default)([
            "_0aNu0LYbGa _2Zuz6QdnbC _1gva8q1Y8M"
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8WS7.FabricElementsAnalyticsContext), {
            data: {
                listLocalId: listId,
                listSize: listSize,
                position: idx
            }
        }, child);
    }));
};
var $7aade51ade799bff$export$2e2bcd8739ae039 = $7aade51ade799bff$var$TaskList;
module.exports["default"] = $7aade51ade799bff$export$2e2bcd8739ae039;

});

parcelRegister("52VjW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c512c8181206eb99$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    fieldsetLabel: {
        id: "fabric.editor.fieldsetLabel",
        defaultMessage: "Action Item List"
    },
    markTaskAsCompleted: {
        id: "platform.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "platform.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    decisionAriaLabel: {
        id: "platform.taskDecision.decisionAriaLabel",
        defaultMessage: "Decision"
    },
    undefinedDecisionAriaLabel: {
        id: "platform.taskDecision.undefinedDecisionAriaLabel",
        defaultMessage: "Undefined decision"
    }
});
module.exports["messages"] = $c512c8181206eb99$export$defe85febe8b728c;

});

parcelRegister("ckvpk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $g8WS7 = parcelRequire("g8WS7");


var $eNbr2 = parcelRequire("eNbr2");


var $794I6 = parcelRequire("794I6");


var $mEDVg = parcelRequire("mEDVg");


var $4pA5x = parcelRequire("4pA5x");

class $572f389b36152ea8$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'taskDecisionProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderWithProvider = (providers)=>{
            const { taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { children: children, localId: localId, state: state, rendererContext: rendererContext, disabled: disabled, dataAttributes: dataAttributes, disableOnChange: disableOnChange } = this.props;
            let objectAri = '';
            if (rendererContext) objectAri = rendererContext.objectAri || '';
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                data: {
                    userContext: 'document'
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $mEDVg.TaskItemsFormatProvider), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $mEDVg.TaskItemsFormatConsumer), {
                        children: ([, dispatch])=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4pA5x.default), {
                                objectAri: objectAri,
                                taskId: localId,
                                isDone: state === 'DONE',
                                isRenderer: true,
                                disabled: disabled,
                                disableOnChange: disableOnChange,
                                taskDecisionProvider: taskDecisionProvider,
                                contextIdentifierProvider: contextIdentifierProvider,
                                dataAttributes: dataAttributes,
                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                onChange: (_, isChecked)=>{
                                    dispatch(isChecked);
                                },
                                children: children
                            })
                    })
                })
            });
        };
        this.providerFactory = props.providers || new (0, $eNbr2.default)();
    }
}
module.exports["default"] = $572f389b36152ea8$export$2e2bcd8739ae039;

});

parcelRegister("mEDVg", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $54e06962532c21fc$var$defaultValue = [
    undefined,
    ()=>{}
];
const $54e06962532c21fc$var$TaskItemsFormatContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($54e06962532c21fc$var$defaultValue);
const $54e06962532c21fc$var$reducer = (_state, action)=>{
    return action;
};
function $54e06962532c21fc$export$1ca88acfa8fef6b0({ children: children }) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useReducer($54e06962532c21fc$var$reducer, undefined);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($54e06962532c21fc$var$TaskItemsFormatContext.Provider, {
        value: value,
        children: children
    });
}
function $54e06962532c21fc$export$617439880b48c653() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($54e06962532c21fc$var$TaskItemsFormatContext);
}
function $54e06962532c21fc$export$be32c078f3ebeea0({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($54e06962532c21fc$var$TaskItemsFormatContext.Consumer, {
        children: children
    });
}
module.exports["TaskItemsFormatProvider"] = $54e06962532c21fc$export$1ca88acfa8fef6b0;
module.exports["useTaskItemsFormatContext"] = $54e06962532c21fc$export$617439880b48c653;
module.exports["TaskItemsFormatConsumer"] = $54e06962532c21fc$export$be32c078f3ebeea0;

});

parcelRegister("4pA5x", function(module, exports) {
$parcel$export(module.exports, "default", () => $89c9a44fb89052c5$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $1uod6 = parcelRequire("1uod6");

function $89c9a44fb89052c5$export$2e2bcd8739ae039(props) {
    const { objectAri: objectAri, isRenderer: isRenderer, ...otherProps } = props;
    const [resolvedContextProvider, setResolvedContextProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    const updateContextIdentifierProvider = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async (contextIdentifierProvider)=>{
        if (contextIdentifierProvider) try {
            const resolvedContextProvider = await contextIdentifierProvider;
            setResolvedContextProvider(resolvedContextProvider);
            return;
        } catch  {}
        setResolvedContextProvider(undefined);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        updateContextIdentifierProvider(props.contextIdentifierProvider);
    }, [
        props.contextIdentifierProvider,
        updateContextIdentifierProvider
    ]);
    const resolvedObjectId = resolvedContextProvider && resolvedContextProvider.objectId || objectAri;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-task-local-id": props.taskId || '',
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1uod6.default), {
            ...otherProps,
            objectAri: resolvedObjectId,
            isRenderer: isRenderer
        })
    });
}

});

parcelRegister("1uod6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g8WS7 = parcelRequire("g8WS7");


var $83cfL = parcelRequire("83cfL");

class $cf79afba58b531c3$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        this.mounted = true;
        this.subscribe(this.props.taskDecisionProvider, this.props.objectAri, this.props.isDone);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDone !== this.props.isDone) // This only occurs for Actions (DONE vs TODO), since Decisions only support DECIDED.
        // If the document is refreshed or changed, we need to reset the local state to match the new
        // source of truth from the revised data.
        this.onUpdate(nextProps.isDone ? 'DONE' : 'TODO');
        if (nextProps.taskDecisionProvider !== this.props.taskDecisionProvider || nextProps.objectAri !== this.props.objectAri) {
            this.unsubscribe();
            this.subscribe(nextProps.taskDecisionProvider, nextProps.objectAri, nextProps.isDone);
        }
    }
    componentWillUnmount() {
        this.unsubscribe();
        this.mounted = false;
    }
    subscribe(taskDecisionProvider, objectAri, isDone) {
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            if (!this.mounted) return;
            const { taskId: taskId } = this.props;
            const objectKey = {
                localId: taskId,
                objectAri: objectAri
            };
            const item = {
                ...objectKey,
                state: isDone ? 'DONE' : 'TODO',
                lastUpdateDate: new Date(),
                type: 'TASK'
            };
            provider.subscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate, item);
        });
    }
    unsubscribe() {
        const { taskDecisionProvider: taskDecisionProvider, taskId: taskId, objectAri: objectAri } = this.props;
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            provider.unsubscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate);
        });
    }
    render() {
        const { isDone: isDone } = this.state;
        const { appearance: appearance, children: children, contentRef: contentRef, objectAri: objectAri, showPlaceholder: showPlaceholder, placeholder: placeholder, taskId: taskId, disabled: disabled, dataAttributes: dataAttributes, isRenderer: isRenderer, isFocused: isFocused, inputRef: inputRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8WS7.FabricElementsAnalyticsContext), {
            data: {
                objectAri: objectAri
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $83cfL.default), {
            isDone: isDone,
            isRenderer: isRenderer,
            isFocused: isFocused,
            taskId: taskId,
            onChange: this.handleOnChange,
            onClick: this.handleOnClick,
            appearance: appearance,
            contentRef: contentRef,
            showPlaceholder: showPlaceholder,
            placeholder: placeholder,
            disabled: disabled,
            dataAttributes: dataAttributes,
            inputRef: inputRef
        }, children));
    }
    constructor(props){
        super(props);
        this.mounted = false;
        this.onUpdate = (state)=>{
            this.setState({
                isDone: state === 'DONE'
            });
        };
        this.handleOnChange = (taskId, isDone)=>{
            const { taskDecisionProvider: taskDecisionProvider, objectAri: objectAri, onChange: onChange, disableOnChange: disableOnChange } = this.props;
            if (disableOnChange) return;
            // Optimistically update the task
            this.setState({
                isDone: isDone
            });
            if (taskDecisionProvider && objectAri) // Call provider to update task
            taskDecisionProvider.then((provider)=>{
                if (!this.mounted) return;
                provider.toggleTask({
                    localId: taskId,
                    objectAri: objectAri
                }, isDone ? 'DONE' : 'TODO');
                // onChange could trigger a rerender, in order to get the correct state
                // we should only call onChange once the internal state have been modified
                if (onChange) onChange(taskId, isDone);
            });
            else // No provider - state managed by consumer
            if (onChange) onChange(taskId, isDone);
        };
        this.handleOnClick = ()=>{
            const { onClick: onClick } = this.props;
            if (onClick) onClick();
        };
        this.state = {
            isDone: props.isDone
        };
    }
}
$cf79afba58b531c3$export$2e2bcd8739ae039.defaultProps = {
    appearance: 'inline'
};
module.exports["default"] = $cf79afba58b531c3$export$2e2bcd8739ae039;

});

parcelRegister("83cfL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2VwyL = parcelRequire("2VwyL");


var $lzgC6 = parcelRequire("lzgC6");


var $QJ7O4 = parcelRequire("QJ7O4");


var $d0CGr = parcelRequire("d0CGr");


var $80me9 = parcelRequire("80me9");


var $52VjW = parcelRequire("52VjW");


var $18ZNy = parcelRequire("18ZNy");

const $212e5f1922e9252a$var$CheckboxUncheckedIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QJ7O4.Icon), {
            dangerouslySetGlyph: "<rect width=\"12.5\" height=\"12.5\" x=\"1.75\" y=\"1.75\" stroke=\"currentcolor\" stroke-width=\"1.5\" rx=\"1.25\"/>",
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QJ7O4.Icon), {
        dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentcolor" stroke-width="1.5" rx="1.25"/>`,
        ...props
    }); /**
                                                                                                                                                                                       * References packages/design-system/checkbox/src/checkbox.tsx
                                                                                                                                                                                       * To be used until mobile editor does not require legacy themed() API anymore,
                                                                                                                                                                                       * which will allow migration to use @atlaskit/checkbox instead
                                                                                                                                                                                       */ 
const $212e5f1922e9252a$var$checkboxStyles = null;
let $212e5f1922e9252a$var$taskCount = 0;
const $212e5f1922e9252a$var$getCheckBoxId = (localId)=>`${localId}-${$212e5f1922e9252a$var$taskCount++}`;
const $212e5f1922e9252a$var$TaskItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(42);
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== taskId) {
        t0 = $212e5f1922e9252a$var$getCheckBoxId(taskId);
        $[0] = taskId;
        $[1] = t0;
    } else t0 = $[1];
    const checkBoxId = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== isDone || $[4] !== onChange || $[5] !== taskId) {
        t1 = (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? "checked" : "unchecked";
            if (createAnalyticsEvent) (0, $80me9.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: "action",
                eventType: "ui",
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
        $[2] = createAnalyticsEvent;
        $[3] = isDone;
        $[4] = onChange;
        $[5] = taskId;
        $[6] = t1;
    } else t1 = $[6];
    const handleOnChange = t1;
    let t2;
    if ($[7] !== handleOnChange) {
        t2 = (event)=>{
            if (event.key === "Enter") handleOnChange(event);
        };
        $[7] = handleOnChange;
        $[8] = t2;
    } else t2 = $[8];
    const handleOnKeyPress = t2;
    const localInputRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[9] !== inputRefFromProps) {
        t3 = inputRefFromProps === undefined ? [
            localInputRef
        ] : [
            inputRefFromProps,
            localInputRef
        ];
        $[9] = inputRefFromProps;
        $[10] = t3;
    } else t3 = $[10];
    const inputRef = (0, $2VwyL.useMergeRefs)(t3);
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEoWWg _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _4xdlr07p2s _4gCaOw98eZ _2QqU2pYbGa _0UXt9rT6kp _3vymXgdnbC _1TAPrFdnbC _12zra7dnbC _4gqQundnbC _1BUG4AnQyn _3LgLJknQyn _33xYQJXVX0 _2VdevGFqy6 _2OyTeTHKt7 _0FaG1X7dHp _1IOx4J2Njc _1KpxtsS8kF _2oLtZl715P _2kXGEF715P _1sRR9kiDnZ _1p22ofZqHV _3kmXW6ZqHV _4mmBgUWVPG _0cADMf7Cj1 _4wSwwnnQyn _0SRqqtHtSk _0422iw1Y8M _148SudWVPG _28VVKd5zaO _4he1wK5zaO _2XqjrQogpp _35XZgYvLZJ _18KwGv715P _1NE3IH715P _0QccnXiDnZ _46HRDHey7F _0DdVJjey7F _3Ripac7dHp _1R10kl7zJH _3fKmf0dnbC _0y3WMLWVPG _1HyEhi715P _0iEAnG715P _4dqkZ8iDnZ _2DbpRZ18ZR _4iMPL4oWWg _3WXbLgoWWg _0QiM2WWVPG _0CZMVz715P _3T2ukd715P _30y4AniDnZ _2ztmbdqWX3 _3RuPdLHKt7 _4oEGCYXLOx _1XCDAh6BYM _02icfTXLOx _47hyyTYvD1 _1JlW2UkLmD _07Zf9z6BYM _223H6tkLmD _15y4m1utHW _077SfA9r67 _03K5EYutHW _29Gh4D6BYM _0O3zXs9r67 _0RsWd7VrZW _3m56efVrZW _37It6EVrZW _2NDTdNVrZW _0L0HniVrZW _0R8c3PVrZW _3uACMjVrZW _31MEBPVrZW _4yzLD8oM2E"
        ]);
        $[11] = t4;
    } else t4 = $[11];
    const t5 = isDone ? (0, $52VjW.messages).markTaskAsNotCompleted : (0, $52VjW.messages).markTaskAsCompleted;
    let t6;
    if ($[12] !== formatMessage || $[13] !== t5) {
        t6 = formatMessage(t5);
        $[12] = formatMessage;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    const t7 = !!isDone;
    const t8 = !!disabled;
    let t9;
    if ($[15] !== checkBoxId || $[16] !== handleOnChange || $[17] !== handleOnKeyPress || $[18] !== inputRef || $[19] !== onClick || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            id: checkBoxId,
            "aria-label": t6,
            name: checkBoxId,
            type: "checkbox",
            onChange: handleOnChange,
            onClick: onClick,
            checked: t7,
            disabled: t8,
            suppressHydrationWarning: true,
            onKeyPress: handleOnKeyPress,
            ref: inputRef
        });
        $[15] = checkBoxId;
        $[16] = handleOnChange;
        $[17] = handleOnKeyPress;
        $[18] = inputRef;
        $[19] = onClick;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== isDone) {
        t10 = isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0CGr))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($212e5f1922e9252a$var$CheckboxUncheckedIcon, {
            label: ""
        });
        $[24] = isDone;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10 || $[27] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            contentEditable: false,
            className: t4
        }, t9, t10);
        $[26] = t10;
        $[27] = t9;
        $[28] = t11;
    } else t11 = $[28];
    const icon = t11;
    let t12;
    let t13;
    if ($[29] !== inputRef || $[30] !== isFocused) {
        t12 = ()=>{
            if (isFocused && inputRef.current) {
                inputRef.current?.focus();
                inputRef.current?.blur();
                setTimeout(()=>{
                    inputRef.current?.focus();
                }, 100);
            }
        };
        t13 = [
            isFocused,
            inputRef
        ];
        $[29] = inputRef;
        $[30] = isFocused;
        $[31] = t12;
        $[32] = t13;
    } else {
        t12 = $[31];
        t13 = $[32];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t12, t13);
    let t14;
    if ($[33] !== appearance || $[34] !== checkBoxId || $[35] !== children || $[36] !== contentRef || $[37] !== dataAttributes || $[38] !== icon || $[39] !== placeholder || $[40] !== showPlaceholder) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18ZNy.default), {
            appearance: appearance,
            contentRef: contentRef,
            icon: icon,
            placeholder: placeholder,
            showPlaceholder: showPlaceholder,
            itemType: "TASK",
            dataAttributes: dataAttributes,
            checkBoxId: checkBoxId
        }, children);
        $[33] = appearance;
        $[34] = checkBoxId;
        $[35] = children;
        $[36] = contentRef;
        $[37] = dataAttributes;
        $[38] = icon;
        $[39] = placeholder;
        $[40] = showPlaceholder;
        $[41] = t14;
    } else t14 = $[41];
    return t14;
} : (props)=>{
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const checkBoxId = (0, $cozmU.useMemo)(()=>$212e5f1922e9252a$var$getCheckBoxId(taskId), [
        taskId
    ]);
    const handleOnChange = (0, $cozmU.useMemo)(()=>{
        return (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) (0, $80me9.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: 'action',
                eventType: 'ui',
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
    }, [
        onChange,
        taskId,
        isDone,
        createAnalyticsEvent
    ]);
    const handleOnKeyPress = (0, $cozmU.useMemo)(()=>(event)=>{
            if (event.key === 'Enter') handleOnChange(event);
        }, [
        handleOnChange
    ]);
    const localInputRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $2VwyL.useMergeRefs)(inputRefFromProps === undefined ? [
        localInputRef
    ] : [
        inputRefFromProps,
        localInputRef
    ]);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        contentEditable: false,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEoWWg _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _4xdlr07p2s _4gCaOw98eZ _2QqU2pYbGa _0UXt9rT6kp _3vymXgdnbC _1TAPrFdnbC _12zra7dnbC _4gqQundnbC _1BUG4AnQyn _3LgLJknQyn _33xYQJXVX0 _2VdevGFqy6 _2OyTeTHKt7 _0FaG1X7dHp _1IOx4J2Njc _1KpxtsS8kF _2oLtZl715P _2kXGEF715P _1sRR9kiDnZ _1p22ofZqHV _3kmXW6ZqHV _4mmBgUWVPG _0cADMf7Cj1 _4wSwwnnQyn _0SRqqtHtSk _0422iw1Y8M _148SudWVPG _28VVKd5zaO _4he1wK5zaO _2XqjrQogpp _35XZgYvLZJ _18KwGv715P _1NE3IH715P _0QccnXiDnZ _46HRDHey7F _0DdVJjey7F _3Ripac7dHp _1R10kl7zJH _3fKmf0dnbC _0y3WMLWVPG _1HyEhi715P _0iEAnG715P _4dqkZ8iDnZ _2DbpRZ18ZR _4iMPL4oWWg _3WXbLgoWWg _0QiM2WWVPG _0CZMVz715P _3T2ukd715P _30y4AniDnZ _2ztmbdqWX3 _3RuPdLHKt7 _4oEGCYXLOx _1XCDAh6BYM _02icfTXLOx _47hyyTYvD1 _1JlW2UkLmD _07Zf9z6BYM _223H6tkLmD _15y4m1utHW _077SfA9r67 _03K5EYutHW _29Gh4D6BYM _0O3zXs9r67 _0RsWd7VrZW _3m56efVrZW _37It6EVrZW _2NDTdNVrZW _0L0HniVrZW _0R8c3PVrZW _3uACMjVrZW _31MEBPVrZW _4yzLD8oM2E"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        id: checkBoxId,
        "aria-label": formatMessage(isDone ? (0, $52VjW.messages).markTaskAsNotCompleted : (0, $52VjW.messages).markTaskAsCompleted),
        name: checkBoxId,
        type: "checkbox",
        onChange: handleOnChange,
        onClick: onClick,
        checked: !!isDone,
        disabled: !!disabled,
        suppressHydrationWarning: true,
        onKeyPress: handleOnKeyPress,
        ref: inputRef
    }), isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0CGr))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($212e5f1922e9252a$var$CheckboxUncheckedIcon, {
        label: ""
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.blur();
            setTimeout(()=>{
                inputRef.current?.focus();
            }, 100);
        }
    }, [
        isFocused,
        inputRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18ZNy.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "TASK",
        dataAttributes: dataAttributes,
        checkBoxId: checkBoxId
    }, children);
};
const $212e5f1922e9252a$var$_default_1 = (0, $lzgC6.default)()($212e5f1922e9252a$var$TaskItem);
var $212e5f1922e9252a$export$2e2bcd8739ae039 = $212e5f1922e9252a$var$_default_1;
module.exports["default"] = $212e5f1922e9252a$export$2e2bcd8739ae039;

});

parcelRegister("80me9", function(module, exports) {

var $2iGHk = parcelRequire("2iGHk");

const $d64a1f68a077e776$export$7ba5d2eed2cf9f14 = 'fabric-elements';
const $d64a1f68a077e776$export$53eef0dcd9611650 = (0, $2iGHk.default)($d64a1f68a077e776$export$7ba5d2eed2cf9f14);
module.exports["createAndFireEventInElementsChannel"] = $d64a1f68a077e776$export$53eef0dcd9611650;

});

parcelRegister("18ZNy", function(module, exports) {
/* Item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

function $a7c5bff37900dca6$var$_defineProperty(e, r, t) {
    return (r = $a7c5bff37900dca6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a7c5bff37900dca6$var$_toPropertyKey(t) {
    var i = $a7c5bff37900dca6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a7c5bff37900dca6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $a7c5bff37900dca6$var$placeholderStyles = null;
const $a7c5bff37900dca6$var$placeholderTaskStyles = null;
const $a7c5bff37900dca6$var$decisionStyles = null;
const $a7c5bff37900dca6$var$contentStyles = null;
const $a7c5bff37900dca6$var$taskStyles = null;
class $a7c5bff37900dca6$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    renderPlaceholder() {
        const { children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, itemType: itemType } = this.props;
        if (!showPlaceholder || !placeholder || children) return null;
        return /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": "task-decision-item-placeholder",
            "data-component": "placeholder",
            contentEditable: false,
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFM6F1I _4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _1UtDYzKGUX _1pp6NdYbGa _39HuIbz8Lp _1ANEUSLRg7 _1EqgXlwwuR",
                itemType === 'TASK' && "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMhxRX"
            ])
        }, placeholder);
    }
    renderMessageAppearance() {
        const { contentRef: contentRef, children: children, icon: icon, itemType: itemType, checkBoxId: checkBoxId, dataAttributes: dataAttributes } = this.props;
        if (itemType === 'TASK') return /*#__PURE__*/ $cozmU.createElement("div", {
            id: `${checkBoxId}-wrapper`,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5v1qpb _1mT5xdRAKS"
            ])
        }, icon, this.renderPlaceholder(), /*#__PURE__*/ $cozmU.createElement("div", {
            "data-component": "content",
            ref: contentRef,
            ...dataAttributes,
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1T2N03wPeg _4ouGXIdnbC"
            ])
        }, children));
        else if (itemType === 'DECISION') return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "elements-decision-item",
            "data-decision-wrapper": "true",
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _3iDTPbQ4SZ _0aFT5v1qpb _3138422ADO _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q8HPE _0KLXruDMqu _1mT5xdRAKS _2FEOdCIZbP"
            ])
        }, icon, this.renderPlaceholder(), /*#__PURE__*/ $cozmU.createElement("div", {
            "data-component": "content",
            ref: contentRef,
            ...dataAttributes,
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1T2N03wPeg _4ouGXIdnbC"
            ])
        }, children));
        return null;
    }
    render() {
        return this.renderMessageAppearance();
    }
}
$a7c5bff37900dca6$var$_defineProperty($a7c5bff37900dca6$export$2e2bcd8739ae039, "defaultProps", {
    appearance: 'inline'
});
module.exports["default"] = $a7c5bff37900dca6$export$2e2bcd8739ae039;

});

parcelRegister("jx4WZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $97Gqa = parcelRequire("97Gqa");

class $ecd9cedc867d893f$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { children: children } = this.props;
        if ((0, $cozmU.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $97Gqa.default), {
            children: children
        });
    }
}
module.exports["default"] = $ecd9cedc867d893f$export$2e2bcd8739ae039;

});

parcelRegister("97Gqa", function(module, exports) {
/* DecisionList.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $2f5ba59e41a91b69$var$listStyles = null;
class $2f5ba59e41a91b69$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
         // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the decision.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-decision-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ol", {
            "data-decision-list-local-id": "",
            "data-node-type": "decisionList",
            className: (0, $hekY6.default)([
                "_39qHGVYbGa _4GiLnvdnbC"
            ])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
                key: idx,
                "data-decision-local-id": localId || '',
                "data-decision-state": "DECIDED"
            }, child);
        }));
    }
}
module.exports["default"] = $2f5ba59e41a91b69$export$2e2bcd8739ae039;

});

parcelRegister("jOsRQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2125db14c4604735$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $53Uph = parcelRequire("53Uph");

function $2125db14c4604735$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $53Uph.default), {
        dataAttributes: dataAttributes,
        children: children
    });
}

});

parcelRegister("53Uph", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $dimUV = parcelRequire("dimUV");


var $52VjW = parcelRequire("52VjW");


var $18ZNy = parcelRequire("18ZNy");

const $eda2047cc34f4c7b$var$iconStyles = null;
const $eda2047cc34f4c7b$var$iconStylesWithPlaceholder = null;
const $eda2047cc34f4c7b$var$DecisionItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = showPlaceholder && "_1UtDYz4YkS";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqE50T1 _0jFU0Vey7F _39xV02ey7F _3138421Y8M _0adFHs8HPE _1DCdHidnbC _2XsHFMdnbC _1UtDYzfyEX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== formatMessage || $[4] !== showPlaceholder) {
        t3 = showPlaceholder && children === undefined ? formatMessage((0, $52VjW.messages).undefinedDecisionAriaLabel) : formatMessage((0, $52VjW.messages).decisionAriaLabel);
        $[2] = children;
        $[3] = formatMessage;
        $[4] = showPlaceholder;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
            label: t3,
            spacing: "spacious",
            color: "currentColor"
        });
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("span", {
            contentEditable: false,
            className: t2
        }, t4);
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    const icon = t5;
    let t6;
    if ($[11] !== appearance || $[12] !== children || $[13] !== contentRef || $[14] !== dataAttributes || $[15] !== icon || $[16] !== placeholder || $[17] !== showPlaceholder) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $18ZNy.default), {
            appearance: appearance,
            contentRef: contentRef,
            icon: icon,
            placeholder: placeholder,
            showPlaceholder: showPlaceholder,
            itemType: "DECISION",
            dataAttributes: dataAttributes
        }, children);
        $[11] = appearance;
        $[12] = children;
        $[13] = contentRef;
        $[14] = dataAttributes;
        $[15] = icon;
        $[16] = placeholder;
        $[17] = showPlaceholder;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const icon = /*#__PURE__*/ $cozmU.createElement("span", {
        contentEditable: false,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqE50T1 _0jFU0Vey7F _39xV02ey7F _3138421Y8M _0adFHs8HPE _1DCdHidnbC _2XsHFMdnbC _1UtDYzfyEX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            showPlaceholder && "_1UtDYz4YkS"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
        label: showPlaceholder && children === undefined ? formatMessage((0, $52VjW.messages).undefinedDecisionAriaLabel) : formatMessage((0, $52VjW.messages).decisionAriaLabel),
        spacing: "spacious",
        color: "currentColor"
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $18ZNy.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "DECISION",
        dataAttributes: dataAttributes
    }, children);
};
var $eda2047cc34f4c7b$export$2e2bcd8739ae039 = $eda2047cc34f4c7b$var$DecisionItem;
module.exports["default"] = $eda2047cc34f4c7b$export$2e2bcd8739ae039;

});

parcelRegister("7BiiX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $e4nz6 = parcelRequire("e4nz6");


var $efgwK = parcelRequire("efgwK");


var $kS1Yv = parcelRequire("kS1Yv");


var $31fUM = parcelRequire("31fUM");


var $mEDVg = parcelRequire("mEDVg");

const $ec9720bbe5f648ce$var$Date = /*#__PURE__*/ (0, $cozmU.memo)(function Date(props) {
    const inlineAnnotationProps = (0, $31fUM.useInlineAnnotationProps)(props);
    const { timestamp: timestamp, parentIsIncompleteTask: parentIsIncompleteTask, intl: intl } = props;
    const { timeZone: timeZone } = (0, $kS1Yv.useRendererContext)();
    const className = !!parentIsIncompleteTask && (0, $efgwK.isPastDate)(timestamp, timeZone) ? 'date-node date-node-highlighted' : 'date-node';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $e4nz6.DateSharedCssClassName).DATE_WRAPPER,
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-node-type": "date",
            "data-timestamp": timestamp,
            children: parentIsIncompleteTask ? (0, $efgwK.timestampToTaskContext)(timestamp, intl, timeZone) : (0, $efgwK.timestampToString)(timestamp, intl)
        })
    });
});
const $ec9720bbe5f648ce$export$19285a5b05c4ea7c = (0, $kSwu1.injectIntl)($ec9720bbe5f648ce$var$Date);
function $ec9720bbe5f648ce$var$DateWithFormatContext(props) {
    const [isChecked] = (0, $mEDVg.useTaskItemsFormatContext)();
    let parentIsIncompleteTask = props.parentIsIncompleteTask;
    if (typeof isChecked !== 'undefined') parentIsIncompleteTask = !isChecked;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ec9720bbe5f648ce$export$19285a5b05c4ea7c, {
        ...props,
        parentIsIncompleteTask: parentIsIncompleteTask
    });
}
var $ec9720bbe5f648ce$export$2e2bcd8739ae039 = $ec9720bbe5f648ce$var$DateWithFormatContext;
module.exports["default"] = $ec9720bbe5f648ce$export$2e2bcd8739ae039;

});

parcelRegister("efgwK", function(module, exports) {

var $1Ujre = parcelRequire("1Ujre");


var $mr7nI = parcelRequire("mr7nI");

var $c57af174cd21b1e3$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($c57af174cd21b1e3$var$FORMATS || {});
const $c57af174cd21b1e3$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $c57af174cd21b1e3$export$6297728405c48562 = (timeZone)=>{
    const today = new Date(Date.now());
    if (timeZone) {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }).formatToParts(today);
        const year = Number(parts.find((p)=>p.type === 'year')?.value);
        const month = Number(parts.find((p)=>p.type === 'month')?.value) - 1;
        const day = Number(parts.find((p)=>p.type === 'day')?.value);
        return Date.UTC(year, month, day).toString();
    }
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $c57af174cd21b1e3$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $c57af174cd21b1e3$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $c57af174cd21b1e3$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $c57af174cd21b1e3$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $c57af174cd21b1e3$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$c57af174cd21b1e3$var$addLeadingZero(date.getUTCMonth() + 1)}-${$c57af174cd21b1e3$var$addLeadingZero(date.getUTCDate())}`;
};
const $c57af174cd21b1e3$export$e6cc7bfc6e0e363e = (timestamp, timeZone)=>{
    return (0, $mr7nI.default)(new Date(Number(timestamp)), new Date(Number($c57af174cd21b1e3$export$6297728405c48562(timeZone))));
};
const $c57af174cd21b1e3$export$fbc04a9e57b04a80 = (timestamp, intl, timeZone)=>{
    const curDate = new Date(Number($c57af174cd21b1e3$export$6297728405c48562(timeZone)));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $1Ujre.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $c57af174cd21b1e3$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $c57af174cd21b1e3$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};
module.exports["timestampToUTCDate"] = $c57af174cd21b1e3$export$56c3660a4ee2196a;
module.exports["todayTimestampInUTC"] = $c57af174cd21b1e3$export$6297728405c48562;
module.exports["timestampToString"] = $c57af174cd21b1e3$export$48755a044ef883a0;
module.exports["timestampToIsoFormat"] = $c57af174cd21b1e3$export$70a1b7b6fffe4dd1;
module.exports["isPastDate"] = $c57af174cd21b1e3$export$e6cc7bfc6e0e363e;
module.exports["timestampToTaskContext"] = $c57af174cd21b1e3$export$fbc04a9e57b04a80;

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("31fUM", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $iDrrr = parcelRequire("iDrrr");


var $hZmcT = parcelRequire("hZmcT");

function $1e80a135c5761dad$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $hZmcT.useAnnotationRangeState)();
    if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}
module.exports["useInlineAnnotationProps"] = $1e80a135c5761dad$export$11564cda945bb3c9;

});

parcelRegister("fBB7S", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $g8WS7 = parcelRequire("g8WS7");


var $iDrrr = parcelRequire("iDrrr");


var $fhdGv = parcelRequire("fhdGv");


var $31fUM = parcelRequire("31fUM");

const $642760c453ea34c8$var$ANALYTICS_DATA = {
    userContext: 'document'
};
const $642760c453ea34c8$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)(function Status(props) {
    const { text: text, color: color, style: style, localId: localId } = props;
    const inlineAnnotationProps = (0, $31fUM.useInlineAnnotationProps)(props);
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ...inlineAnnotationProps,
            role: 'emphasis',
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
                data: $642760c453ea34c8$var$ANALYTICS_DATA,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fhdGv.Status), {
                    text: style === 'mixedCase' ? text : text.toUpperCase(),
                    color: color,
                    localId: localId,
                    role: undefined
                })
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
            data: $642760c453ea34c8$var$ANALYTICS_DATA,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fhdGv.Status), {
                text: style === 'mixedCase' ? text : text.toUpperCase(),
                color: color,
                localId: localId,
                role: undefined
            })
        });
    }
    if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...inlineAnnotationProps,
        role: 'emphasis',
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            data: {
                userContext: 'document'
            },
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fhdGv.Status), {
                text: text,
                color: color,
                localId: localId,
                role: undefined,
                isBold: true
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            userContext: 'document'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: "emphasis",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fhdGv.Status), {
                text: text,
                color: color,
                localId: localId,
                isBold: true
            })
        })
    });
});
var $642760c453ea34c8$export$2e2bcd8739ae039 = $642760c453ea34c8$var$_default_1;
module.exports["default"] = $642760c453ea34c8$export$2e2bcd8739ae039;

});

parcelRegister("fhdGv", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lzgC6 = parcelRequire("lzgC6");


var $aCJyI = parcelRequire("aCJyI");


var $ftY7H = parcelRequire("ftY7H");


var $jDboD = parcelRequire("jDboD");


var $fB42n = parcelRequire("fB42n");

function $ba35a2a9fe36df5b$var$_defineProperty(e, r, t) {
    return (r = $ba35a2a9fe36df5b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba35a2a9fe36df5b$var$_toPropertyKey(t) {
    var i = $ba35a2a9fe36df5b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba35a2a9fe36df5b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ba35a2a9fe36df5b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $ba35a2a9fe36df5b$var$inlineBlockStyles = null; // Bound the Lozenge to its parent while keeping short statuses content-sized.
const $ba35a2a9fe36df5b$var$constrainedToParentStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $ba35a2a9fe36df5b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $ba35a2a9fe36df5b$var$StatusInternal extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold, isConstrainedToParent: isConstrainedToParent } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = (0, $fB42n.getLozengeAppearance)(color); // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                $ba35a2a9fe36df5b$var$isAndroidChromium && "_0ReY56US2K _3HdVfPey7F _3pS3pEt2nV",
                isConstrainedToParent && "_3iDTPbvbI6 _1EqgXlN91d",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onKeyDown: onClick ? this.handleKeyDown : undefined,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: onClick ? -1 : undefined,
            "data-node-type": "status",
            "data-color": (0, $fB42n.normalizeColor)(color),
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $cozmU.createElement((0, $aCJyI.default), {
            appearance: appearance,
            maxWidth: $ba35a2a9fe36df5b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "hoverStartTime", 0);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleKeyDown", (e)=>{
            const { onClick: onClick } = this.props;
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e);
            }
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleFocus", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleBlur", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$ba35a2a9fe36df5b$var$_defineProperty($ba35a2a9fe36df5b$var$StatusInternal, "displayName", 'StatusInternal');
const $ba35a2a9fe36df5b$export$96e9906d6d93a972 = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($ba35a2a9fe36df5b$var$StatusInternal);
module.exports["Status"] = $ba35a2a9fe36df5b$export$96e9906d6d93a972;

});

parcelRegister("ftY7H", function(module, exports) {
const $63d299faa378dc1a$export$d821aa4c8afb384e = 'fabric-elements';
const $63d299faa378dc1a$var$packageName = "platform-pkg";
const $63d299faa378dc1a$var$packageVersion = "0.0.0-use.local";
const $63d299faa378dc1a$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $63d299faa378dc1a$var$packageName;
        statusPayload.attributes.packageVersion = $63d299faa378dc1a$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($63d299faa378dc1a$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $63d299faa378dc1a$export$aa98853957f9f5aa;

});

parcelRegister("jDboD", function(module, exports) {
const $92130f7ce8b5e3de$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $92130f7ce8b5e3de$export$7452d7062a4d0634;

});

parcelRegister("fB42n", function(module, exports) {

var $2pQiO = parcelRequire("2pQiO");

const $7f74d498381e9123$export$c6adb6b4e776f0d5 = [
    'neutral',
    'purple',
    'blue',
    'red',
    'yellow',
    'green'
];
const $7f74d498381e9123$export$ccac7cd631a2cc0f = [
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime — named `green` renders identically
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange — named `yellow` renders identically
    '#FDD0EC' // Magenta
];
const $7f74d498381e9123$export$acfdfc8c64e6747 = 'neutral';
const $7f74d498381e9123$export$645e10b5a408e986 = {
    neutral: 'neutral',
    purple: 'discovery',
    blue: 'information',
    red: 'danger',
    yellow: 'warning',
    green: 'success'
};
const $7f74d498381e9123$export$692279d423b4caab = "var(--ds-icon, #292A2E)";
const $7f74d498381e9123$export$56d196d2844d1ca1 = {
    neutral: {
        appearance: 'neutral',
        labelKey: 'neutralColor',
        swatch: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            borderColor: "var(--ds-border, #0B120E24)"
        }
    },
    blue: {
        appearance: 'accent-blue',
        labelKey: 'blueColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
            borderColor: "var(--ds-border-accent-blue-subtle, #8FB8F6)"
        }
    },
    '#B3F5FF': {
        appearance: 'accent-teal',
        labelKey: 'tealColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            borderColor: "var(--ds-border-accent-teal-subtle, #9DD9EE)"
        }
    },
    '#ABF5D1': {
        appearance: 'accent-green',
        labelKey: 'greenColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            borderColor: "var(--ds-border-accent-green-subtle, #7EE2B8)"
        }
    },
    '#D3F1A7': {
        appearance: 'accent-lime',
        labelKey: 'limeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            borderColor: "var(--ds-border-accent-lime-subtle, #B3DF72)"
        }
    },
    '#FFF0B3': {
        appearance: 'accent-yellow',
        labelKey: 'yellowColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderColor: "var(--ds-border-accent-yellow-subtle, #EED12B)"
        }
    },
    '#FCE4A6': {
        appearance: 'accent-orange',
        labelKey: 'orangeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
            borderColor: "var(--ds-border-accent-orange-subtle, #FBC828)"
        }
    },
    red: {
        appearance: 'accent-red',
        labelKey: 'redColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            borderColor: "var(--ds-border-accent-red-subtle, #FD9891)"
        }
    },
    '#FDD0EC': {
        appearance: 'accent-magenta',
        labelKey: 'magentaColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            borderColor: "var(--ds-border-accent-magenta-subtle, #F797D2)"
        }
    },
    purple: {
        appearance: 'accent-purple',
        labelKey: 'purpleColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
            borderColor: "var(--ds-border-accent-purple-subtle, #D8A0F7)"
        }
    },
    yellow: {
        appearance: 'accent-orange',
        labelKey: 'yellowColor'
    },
    green: {
        appearance: 'accent-lime',
        labelKey: 'greenColor'
    }
};
const $7f74d498381e9123$export$d42d7c94d7629c23 = [
    'neutral',
    // Gray
    'blue',
    // Blue
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange
    'red',
    // Red
    '#FDD0EC',
    // Magenta
    'purple' // Purple
];
const $7f74d498381e9123$export$ee5a21461d1db57c = (color)=>$7f74d498381e9123$export$c6adb6b4e776f0d5.includes(color);
const $7f74d498381e9123$export$4cde5df63f53f473 = (color)=>color.startsWith('#') ? color.toUpperCase() : color;
const $7f74d498381e9123$var$specFor = (color)=>$7f74d498381e9123$export$56d196d2844d1ca1[$7f74d498381e9123$export$4cde5df63f53f473(color)];
const $7f74d498381e9123$export$4bc90a066e1dabc3 = (color)=>$7f74d498381e9123$var$specFor(color)?.labelKey ?? 'neutralColor';
const $7f74d498381e9123$export$13752f03fbf881b8 = (swatchValue, selectedColor)=>{
    if (!selectedColor) return false;
    if ($7f74d498381e9123$export$4cde5df63f53f473(swatchValue) === $7f74d498381e9123$export$4cde5df63f53f473(selectedColor)) return true;
    // A swatch also counts as selected when it renders the same hue under a different
    // id — legacy named `green`/`yellow` share the Lime/Orange swatches. Unknown values
    // have no spec, so they never collide on the neutral fallback.
    const swatchAppearance = $7f74d498381e9123$var$specFor(swatchValue)?.appearance;
    return swatchAppearance !== undefined && swatchAppearance === $7f74d498381e9123$var$specFor(selectedColor)?.appearance;
};
const $7f74d498381e9123$export$4d9e331cafeacb9d = (color)=>{
    const isUpdateStatusColorsEnabled = (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false) || (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors_jira', 'isEnabled', false);
    // Named colours are recoloured only by the experiment, so they must never reach the
    // hex mapping below.
    if ($7f74d498381e9123$export$ee5a21461d1db57c(color)) return isUpdateStatusColorsEnabled ? $7f74d498381e9123$export$56d196d2844d1ca1[color].appearance : $7f74d498381e9123$export$645e10b5a408e986[color];
    return $7f74d498381e9123$var$specFor(color)?.appearance ?? $7f74d498381e9123$export$acfdfc8c64e6747;
};
module.exports["SWATCH_ICON_COLOR"] = $7f74d498381e9123$export$692279d423b4caab;
module.exports["COLORS"] = $7f74d498381e9123$export$56d196d2844d1ca1;
module.exports["PICKER_SWATCHES"] = $7f74d498381e9123$export$d42d7c94d7629c23;
module.exports["normalizeColor"] = $7f74d498381e9123$export$4cde5df63f53f473;
module.exports["getColorLabelKey"] = $7f74d498381e9123$export$4bc90a066e1dabc3;
module.exports["isSwatchSelected"] = $7f74d498381e9123$export$13752f03fbf881b8;
module.exports["getLozengeAppearance"] = $7f74d498381e9123$export$4d9e331cafeacb9d;

});

parcelRegister("2buHA", function(module, exports) {

var $2DBsV = parcelRequire("2DBsV");

function $004d94a28e8e7a45$export$e6e9c38db7e6b0b1(fallbackText) {
    return (0, $2DBsV.isSingleEmoji)(fallbackText) ? undefined : '\uFFFD';
}
module.exports["getEmojiCustomFallback"] = $004d94a28e8e7a45$export$e6e9c38db7e6b0b1;

});

parcelRegister("2DBsV", function(module, exports) {
const $cdd07b0bc87acc5f$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
RegExp("^(\\p{Emoji_Presentation}(?:[\\u{1F3FB}-\\u{1F3FF}])?|\\p{Extended_Pictographic}\\u{FE0F}(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)*|\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
function $cdd07b0bc87acc5f$export$1d677781db73ff20(fallbackText) {
    return $cdd07b0bc87acc5f$var$SINGLE_EMOJI_REGEX.test(fallbackText ?? '');
}
module.exports["isSingleEmoji"] = $cdd07b0bc87acc5f$export$1d677781db73ff20;

});

parcelRegister("2O2Zk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $373e836c88a63247$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $373e836c88a63247$export$defe85febe8b728c;

});

parcelRegister("dDpOM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1aedaca47fa21d78$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $1aedaca47fa21d78$var$PanelErrorGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $1aedaca47fa21d78$export$76fa6c311f4e2871 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($1aedaca47fa21d78$var$PanelErrorGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($1aedaca47fa21d78$var$PanelErrorGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelErrorIcon"] = $1aedaca47fa21d78$export$76fa6c311f4e2871;

});

parcelRegister("jA0E3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a579bb9ddad96162$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $a579bb9ddad96162$var$PanelInfoGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $a579bb9ddad96162$export$2187dc2d495c3efc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($a579bb9ddad96162$var$PanelInfoGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($a579bb9ddad96162$var$PanelInfoGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelInfoIcon"] = $a579bb9ddad96162$export$2187dc2d495c3efc;

});

parcelRegister("564fr", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $276a71e22fa0e942$var$iconStyles = null;
const $276a71e22fa0e942$var$PanelNoteGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $276a71e22fa0e942$export$d4f894f0c3f0db6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const t0 = props.label ? "img" : undefined;
    const t1 = props.label ? props.label : undefined;
    const t2 = props.label ? undefined : true;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)($276a71e22fa0e942$var$PanelNoteGlyph, {
            role: "presentation"
        });
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    let t5;
    if ($[2] !== t0 || $[3] !== t1 || $[4] !== t2) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t0,
            "aria-label": t1,
            "aria-hidden": t2,
            className: t3,
            children: t4
        });
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($276a71e22fa0e942$var$PanelNoteGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelNoteIcon"] = $276a71e22fa0e942$export$d4f894f0c3f0db6;

});

parcelRegister("30pGv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $5ac0d457a06bc975$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $5ac0d457a06bc975$var$PanelSuccessGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $5ac0d457a06bc975$export$a5a5162e21242c3c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($5ac0d457a06bc975$var$PanelSuccessGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($5ac0d457a06bc975$var$PanelSuccessGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelSuccessIcon"] = $5ac0d457a06bc975$export$a5a5162e21242c3c;

});

parcelRegister("6MmtN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $532129d0e2b29baf$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $532129d0e2b29baf$var$PanelWarningGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $532129d0e2b29baf$export$246c5468186717b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($532129d0e2b29baf$var$PanelWarningGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($532129d0e2b29baf$var$PanelWarningGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelWarningIcon"] = $532129d0e2b29baf$export$246c5468186717b7;

});

parcelRegister("aHoC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc71b9d8c80c48f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $5o4s6 = parcelRequire("5o4s6");


var $4G6PK = parcelRequire("4G6PK");


var $95Vjg = parcelRequire("95Vjg");


var $ihn0W = parcelRequire("ihn0W");


var $hNvnn = parcelRequire("hNvnn");

function $7fc71b9d8c80c48f$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $ihn0W.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    // Preserve the absolute height before it is scaled below, so we can fall back to it if the
    // pixel-width computation yields a non-finite value (e.g. editorWidth/lineLength is 0 or
    // undefined in some host renderers such as Jira issue view).
    const absoluteHeight = height;
    if (mediaSingleWidth) {
        const pxWidth = (0, $95Vjg.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined && !Number.isFinite(height / width * 100)) // The aspect-ratio (padding-bottom) trick collapses to 0 when the ratio is non-finite,
    // which happens when the resolved pixel width is 0/NaN (e.g. editorWidth/lineLength is
    // unavailable in the host renderer). Fall back to the embed's absolute height so the box
    // keeps a usable height instead of collapsing.
    // For embedCard nodes the `height` prop is the iframe height only; the normal ratio path
    // adds 32px for the embed header (see `calc(... + 32px)` below), so add it here too to
    // avoid clipping the header.
    mediaWrapperHeight = Number.isFinite(absoluteHeight) ? absoluteHeight + (nodeType === 'embedCard' ? 32 : 0) : undefined;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $hNvnn.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')
        }),
        "data-layout": layout,
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $5o4s6.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $hNvnn.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("5X6fy", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("4G6PK", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $4e6f18d969fc9276$export$5937600f4cc784f0 = 24;
const $4e6f18d969fc9276$export$71d660e8ca5b8f73 = 320;
const $4e6f18d969fc9276$export$cd11d7d46412c89b = 3;
const $4e6f18d969fc9276$export$71482734bb54ac3 = 10;
const $4e6f18d969fc9276$export$fd2b09475ada41cc = 12;
const $4e6f18d969fc9276$export$8c5ac0b0c62a3d21 = 8;
const $4e6f18d969fc9276$export$68d0abe4f03863fb = $4e6f18d969fc9276$export$fd2b09475ada41cc * 2;
const $4e6f18d969fc9276$export$d722b7527b1834a8 = 250;
const $4e6f18d969fc9276$export$da894f7669b4e67c = 200;
const $4e6f18d969fc9276$export$e13825c38da2ce1 = 100;
var $4e6f18d969fc9276$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $4e6f18d969fc9276$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $4e6f18d969fc9276$export$4d41d008e9cd4f34 = 0.5;
const $4e6f18d969fc9276$export$b4b560efd3c61856 = 'caption-placeholder';
module.exports["MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH"] = $4e6f18d969fc9276$export$5937600f4cc784f0;
module.exports["MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH"] = $4e6f18d969fc9276$export$71d660e8ca5b8f73;
module.exports["MEDIA_SINGLE_SNAP_GAP"] = $4e6f18d969fc9276$export$cd11d7d46412c89b;
module.exports["MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN"] = $4e6f18d969fc9276$export$8c5ac0b0c62a3d21;
module.exports["MEDIA_SINGLE_GUTTER_SIZE"] = $4e6f18d969fc9276$export$68d0abe4f03863fb;
module.exports["DEFAULT_IMAGE_WIDTH"] = $4e6f18d969fc9276$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $4e6f18d969fc9276$export$da894f7669b4e67c;
module.exports["MEDIA_SINGLE_RESIZE_THROTTLE_TIME"] = $4e6f18d969fc9276$export$e13825c38da2ce1;
module.exports["wrappedLayouts"] = $4e6f18d969fc9276$export$405baca3d8bc263d;
module.exports["DEFAULT_ROUNDING_INTERVAL"] = $4e6f18d969fc9276$export$4d41d008e9cd4f34;
module.exports["CAPTION_PLACEHOLDER_ID"] = $4e6f18d969fc9276$export$b4b560efd3c61856;

});

parcelRegister("95Vjg", function(module, exports) {
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $69e3419be6a9274a$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
module.exports["getMediaSinglePixelWidth"] = $69e3419be6a9274a$export$a6f4ec2edd25b07e;

});

parcelRegister("ihn0W", function(module, exports) {

var $34CLe = parcelRequire("34CLe");

const $24a1030e8452f7d6$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $34CLe.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
module.exports["shouldAddDefaultWrappedWidth"] = $24a1030e8452f7d6$export$7cd5aab2c4f1fb1e;

});

parcelRegister("34CLe", function(module, exports) {
const $df10a01237b702c1$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
module.exports["wrappedLayouts"] = $df10a01237b702c1$export$405baca3d8bc263d;

});

parcelRegister("hNvnn", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8qft0 = parcelRequire("8qft0");


var $h9Lux = parcelRequire("h9Lux");


var $5y9Nl = parcelRequire("5y9Nl");


var $fuDKy = parcelRequire("fuDKy");

function $640d411acbc53708$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $640d411acbc53708$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $640d411acbc53708$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $640d411acbc53708$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $640d411acbc53708$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $640d411acbc53708$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $640d411acbc53708$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $640d411acbc53708$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $640d411acbc53708$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $fuDKy.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $5y9Nl.calcResizedWidth)(layout, width || 0, containerWidth) : $640d411acbc53708$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $640d411acbc53708$var$_ref2, " ", isInRenderer ? $640d411acbc53708$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $640d411acbc53708$var$float(layout), ";margin:", $640d411acbc53708$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $640d411acbc53708$var$isImageAligned(layout), ";");
};
const $640d411acbc53708$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $lOiVq.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $640d411acbc53708$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("position:relative;", $640d411acbc53708$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $640d411acbc53708$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $640d411acbc53708$export$9e3fd9f6215dd7b6(rest)
    }, children);
$640d411acbc53708$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $640d411acbc53708$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    const borderRadius = "var(--ds-radius-large, 8px)";
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $640d411acbc53708$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $640d411acbc53708$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $640d411acbc53708$export$e18e95249d813157;

});

parcelRegister("8qft0", function(module, exports) {
const $5b70b8fd3b65ebb8$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
module.exports["nonWrappedLayouts"] = $5b70b8fd3b65ebb8$export$607795ead6e50626;

});

parcelRegister("5y9Nl", function(module, exports) {

var $h9Lux = parcelRequire("h9Lux");

function $a736c0097336f0f5$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
module.exports["calcResizedWidth"] = $a736c0097336f0f5$export$d48e8f24f681763e;

});

parcelRegister("fuDKy", function(module, exports) {
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $e6d228c4639d9fdf$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
module.exports["roundToClosestEvenPxValue"] = $e6d228c4639d9fdf$export$c832331b07480714;

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $ebRBT = parcelRequire("ebRBT");

// `grayBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `grayBold` directly with `gray`.
const $c358709489b4576e$var$FileIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $ebRBT = parcelRequire("ebRBT");

// `purpleBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `purpleBold` directly with `purple`.
const $3736b97729106be6$var$ChartBarIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $ebRBT = parcelRequire("ebRBT");

// `greenBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `greenBold` directly with `green`.
const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("9TA3F", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73453881445d309b$var$_react = $73453881445d309b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $73453881445d309b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73453881445d309b$var$Archive24Icon = (props)=>/*#__PURE__*/ $73453881445d309b$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$73453881445d309b$var$Archive24Icon.displayName = 'Archive24Icon';
var $73453881445d309b$var$_default = module.exports.default = $73453881445d309b$var$Archive24Icon;

});

parcelRegister("jTyNF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e7be25f42053d936$var$_react = $e7be25f42053d936$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $e7be25f42053d936$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e7be25f42053d936$var$Executable24Icon = (props)=>/*#__PURE__*/ $e7be25f42053d936$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e7be25f42053d936$var$Executable24Icon.displayName = 'Executable24Icon';
var $e7be25f42053d936$var$_default = module.exports.default = $e7be25f42053d936$var$Executable24Icon;

});

parcelRegister("gCL8n", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1a4c1cb74e7fe66$var$_react = $c1a4c1cb74e7fe66$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $c1a4c1cb74e7fe66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1a4c1cb74e7fe66$var$Gif24Icon = (props)=>/*#__PURE__*/ $c1a4c1cb74e7fe66$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1a4c1cb74e7fe66$var$Gif24Icon.displayName = 'Gif24Icon';
var $c1a4c1cb74e7fe66$var$_default = module.exports.default = $c1a4c1cb74e7fe66$var$Gif24Icon;

});

parcelRegister("l8FBD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f63a9e6c3f95b37c$var$_react = $f63a9e6c3f95b37c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f63a9e6c3f95b37c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f63a9e6c3f95b37c$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $f63a9e6c3f95b37c$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f63a9e6c3f95b37c$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $f63a9e6c3f95b37c$var$_default = module.exports.default = $f63a9e6c3f95b37c$var$GoogleDoc24Icon;

});

parcelRegister("cSPDT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9612964eb3dd5544$var$_react = $9612964eb3dd5544$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $9612964eb3dd5544$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9612964eb3dd5544$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $9612964eb3dd5544$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9612964eb3dd5544$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $9612964eb3dd5544$var$_default = module.exports.default = $9612964eb3dd5544$var$GoogleForm24Icon;

});

parcelRegister("lhYzt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f7fa2ba87c6278a2$var$_react = $f7fa2ba87c6278a2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f7fa2ba87c6278a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f7fa2ba87c6278a2$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $f7fa2ba87c6278a2$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f7fa2ba87c6278a2$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $f7fa2ba87c6278a2$var$_default = module.exports.default = $f7fa2ba87c6278a2$var$GoogleSheet24Icon;

});

parcelRegister("3Ll8s", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd627f5b12c5946$var$_react = $2bd627f5b12c5946$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2bd627f5b12c5946$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd627f5b12c5946$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $2bd627f5b12c5946$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd627f5b12c5946$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $2bd627f5b12c5946$var$_default = module.exports.default = $2bd627f5b12c5946$var$GoogleSlide24Icon;

});

parcelRegister("67SYT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $475e0ba3e7829a3a$var$_react = $475e0ba3e7829a3a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $475e0ba3e7829a3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $475e0ba3e7829a3a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $475e0ba3e7829a3a$var$_default = module.exports.default = $475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon;

});

parcelRegister("6lknI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $49e483933a21e023$var$_react = $49e483933a21e023$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $49e483933a21e023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $49e483933a21e023$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $49e483933a21e023$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$49e483933a21e023$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $49e483933a21e023$var$_default = module.exports.default = $49e483933a21e023$var$PowerpointPresentation24Icon;

});

parcelRegister("fGSwx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b6c5128728f95629$var$_react = $b6c5128728f95629$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $b6c5128728f95629$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b6c5128728f95629$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $b6c5128728f95629$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$b6c5128728f95629$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $b6c5128728f95629$var$_default = module.exports.default = $b6c5128728f95629$var$WordDocument24Icon;

});

parcelRegister("90EXt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $01b15a5d4b81fd5c$var$_react = $01b15a5d4b81fd5c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $01b15a5d4b81fd5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01b15a5d4b81fd5c$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $01b15a5d4b81fd5c$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$01b15a5d4b81fd5c$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $01b15a5d4b81fd5c$var$_default = module.exports.default = $01b15a5d4b81fd5c$var$PdfDocument24Icon;

});

parcelRegister("8BODT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64490ff67d091387$var$_react = $64490ff67d091387$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $64490ff67d091387$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64490ff67d091387$var$Sketch24Icon = (props)=>/*#__PURE__*/ $64490ff67d091387$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$64490ff67d091387$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $64490ff67d091387$var$_default = module.exports.default = $64490ff67d091387$var$Sketch24Icon;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
 //# sourceMappingURL=index.modern.mjs.map
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("k5sGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9fa87e3de3aa88c$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $e9fa87e3de3aa88c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3yGK6.default)(1, arguments);
    var additionalDigits = (0, $kr6hK.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e9fa87e3de3aa88c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $e9fa87e3de3aa88c$var$parseYear(dateStrings.date, additionalDigits);
        date = $e9fa87e3de3aa88c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $e9fa87e3de3aa88c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e9fa87e3de3aa88c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $e9fa87e3de3aa88c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $e9fa87e3de3aa88c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $e9fa87e3de3aa88c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $e9fa87e3de3aa88c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e9fa87e3de3aa88c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($e9fa87e3de3aa88c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $e9fa87e3de3aa88c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e9fa87e3de3aa88c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e9fa87e3de3aa88c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($e9fa87e3de3aa88c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $e9fa87e3de3aa88c$var$parseDateUnit(captures[1]);
    var month = $e9fa87e3de3aa88c$var$parseDateUnit(captures[2]) - 1;
    var day = $e9fa87e3de3aa88c$var$parseDateUnit(captures[3]);
    var week = $e9fa87e3de3aa88c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $e9fa87e3de3aa88c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e9fa87e3de3aa88c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e9fa87e3de3aa88c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$e9fa87e3de3aa88c$var$validateDate(year, month, day) || !$e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e9fa87e3de3aa88c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e9fa87e3de3aa88c$var$parseTime(timeString) {
    var captures = timeString.match($e9fa87e3de3aa88c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[1]);
    var minutes = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[2]);
    var seconds = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[3]);
    if (!$e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * 1000;
}
function $e9fa87e3de3aa88c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $e9fa87e3de3aa88c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($e9fa87e3de3aa88c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e9fa87e3de3aa88c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute));
}
function $e9fa87e3de3aa88c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $e9fa87e3de3aa88c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e9fa87e3de3aa88c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e9fa87e3de3aa88c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e9fa87e3de3aa88c$var$daysInMonths[month] || ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e9fa87e3de3aa88c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e9fa87e3de3aa88c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jrCh2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e27e3a4c5ffdab0c$export$2e2bcd8739ae039);
function $e27e3a4c5ffdab0c$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("8Bx1z", function(module, exports) {
"use strict";
var $643b655b3a668be3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $643b655b3a668be3$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $643b655b3a668be3$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $643b655b3a668be3$var$filter;
var $643b655b3a668be3$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $643b655b3a668be3$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $643b655b3a668be3$var$FilterSubscriber = function(_super) {
    $643b655b3a668be3$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=filter.js.map

});

parcelRegister("eeWDH", function(module, exports) {
"use strict";
var $a5dfdc0a1bdb1c58$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");


var $kjYch = parcelRequire("kjYch");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $a5dfdc0a1bdb1c58$var$take(count) {
    return function(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else return source.lift(new $a5dfdc0a1bdb1c58$var$TakeOperator(count));
    };
}
module.exports.take = $a5dfdc0a1bdb1c58$var$take;
var $a5dfdc0a1bdb1c58$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5dfdc0a1bdb1c58$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5dfdc0a1bdb1c58$var$TakeSubscriber = function(_super) {
    $a5dfdc0a1bdb1c58$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=take.js.map

});

parcelRegister("atSr0", function(module, exports) {
"use strict";
var $7a16d669c235c821$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $7a16d669c235c821$var$ArgumentOutOfRangeError = function(_super) {
    $7a16d669c235c821$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $7a16d669c235c821$var$ArgumentOutOfRangeError; //# sourceMappingURL=ArgumentOutOfRangeError.js.map

});

parcelRegister("34cAP", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $23bb83863f0fc948$export$45b10814cc054894, (v) => $23bb83863f0fc948$export$45b10814cc054894 = v);
var $23bb83863f0fc948$export$45b10814cc054894;
"use strict";

var $7bBVm = parcelRequire("7bBVm");

function $23bb83863f0fc948$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $23bb83863f0fc948$var$toArray() {
    return $7bBVm.reduce($23bb83863f0fc948$var$toArrayReducer, []);
}
$23bb83863f0fc948$export$45b10814cc054894 = $23bb83863f0fc948$var$toArray; //# sourceMappingURL=toArray.js.map

});

parcelRegister("7bBVm", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $53b6fa7559558246$export$533b26079ad0b4b, (v) => $53b6fa7559558246$export$533b26079ad0b4b = v);
var $53b6fa7559558246$export$533b26079ad0b4b;
"use strict";

var $bbCp3 = parcelRequire("bbCp3");


var $lQvgf = parcelRequire("lQvgf");


var $dTFgb = parcelRequire("dTFgb");


var $kPZwo = parcelRequire("kPZwo");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $53b6fa7559558246$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $kPZwo.pipe($bbCp3.scan(accumulator, seed), $lQvgf.takeLast(1), $dTFgb.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $kPZwo.pipe($bbCp3.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $lQvgf.takeLast(1))(source);
    };
}
$53b6fa7559558246$export$533b26079ad0b4b = $53b6fa7559558246$var$reduce; //# sourceMappingURL=reduce.js.map

});

parcelRegister("bbCp3", function(module, exports) {
"use strict";
var $824e82d9ed0a6633$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $824e82d9ed0a6633$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $824e82d9ed0a6633$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $824e82d9ed0a6633$var$scan;
var $824e82d9ed0a6633$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $824e82d9ed0a6633$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $824e82d9ed0a6633$var$ScanSubscriber = function(_super) {
    $824e82d9ed0a6633$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=scan.js.map

});

parcelRegister("lQvgf", function(module, exports) {
"use strict";
var $fe76b4167e522f00$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");


var $kjYch = parcelRequire("kjYch");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $fe76b4167e522f00$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else return source.lift(new $fe76b4167e522f00$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $fe76b4167e522f00$var$takeLast;
var $fe76b4167e522f00$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe76b4167e522f00$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe76b4167e522f00$var$TakeLastSubscriber = function(_super) {
    $fe76b4167e522f00$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=takeLast.js.map

});

parcelRegister("dTFgb", function(module, exports) {
"use strict";
var $a1e06aced5e020ea$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $a1e06aced5e020ea$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $a1e06aced5e020ea$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $a1e06aced5e020ea$var$defaultIfEmpty;
var $a1e06aced5e020ea$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a1e06aced5e020ea$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a1e06aced5e020ea$var$DefaultIfEmptySubscriber = function(_super) {
    $a1e06aced5e020ea$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=defaultIfEmpty.js.map

});

parcelRegister("lv9Cv", function(module, exports) {
$parcel$export(module.exports, "of", () => $fa73f494791b08e6$export$ba255e9e49e00608, (v) => $fa73f494791b08e6$export$ba255e9e49e00608 = v);
var $fa73f494791b08e6$export$ba255e9e49e00608;
"use strict";

var $hmT2x = parcelRequire("hmT2x");

$fa73f494791b08e6$export$ba255e9e49e00608 = $hmT2x.ArrayObservable.of; //# sourceMappingURL=of.js.map

});

parcelRegister("hrJHY", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $1XTds = parcelRequire("1XTds");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteDelay = $fEWBj.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($1XTds.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($1XTds.Notification.createComplete());
    };
    return DelaySubscriber;
}($fNVRJ.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}(); //# sourceMappingURL=delay.js.map

});

parcelRegister("zAMIg", function(module, exports) {
$parcel$export(module.exports, "async", () => $06afcdac526dbf67$export$12af436354f1a4f7, (v) => $06afcdac526dbf67$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $06afcdac526dbf67$export$12af436354f1a4f7;
"use strict";

var $1HJiA = parcelRequire("1HJiA");


var $fJ8RQ = parcelRequire("fJ8RQ");

$06afcdac526dbf67$export$12af436354f1a4f7 = new $fJ8RQ.AsyncScheduler($1HJiA.AsyncAction); //# sourceMappingURL=async.js.map

});

parcelRegister("fEWBj", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $b6680c598ae7a287$export$871608497c498473, (v) => $b6680c598ae7a287$export$871608497c498473 = v);
var $b6680c598ae7a287$export$871608497c498473;
"use strict";
function $b6680c598ae7a287$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$b6680c598ae7a287$export$871608497c498473 = $b6680c598ae7a287$var$isDate; //# sourceMappingURL=isDate.js.map

});

parcelRegister("9Hb6D", function(module, exports) {
$parcel$export(module.exports, "merge", () => $70f0bea37c3dd158$export$4950aa0f605343fb, (v) => $70f0bea37c3dd158$export$4950aa0f605343fb = v);
var $70f0bea37c3dd158$export$4950aa0f605343fb;
"use strict";

var $1pK8e = parcelRequire("1pK8e");


var $hmT2x = parcelRequire("hmT2x");


var $lRrDg = parcelRequire("lRrDg");


var $c9SbF = parcelRequire("c9SbF");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $70f0bea37c3dd158$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($lRrDg.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $1pK8e.Observable) return observables[0];
    return $c9SbF.mergeAll(concurrent)(new $hmT2x.ArrayObservable(observables, scheduler));
}
$70f0bea37c3dd158$export$4950aa0f605343fb = $70f0bea37c3dd158$var$merge; //# sourceMappingURL=merge.js.map

});

parcelRegister("c9SbF", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $8da05bbe9f24d995$export$18aef43295bbe906, (v) => $8da05bbe9f24d995$export$18aef43295bbe906 = v);
var $8da05bbe9f24d995$export$18aef43295bbe906;
"use strict";

var $inXGV = parcelRequire("inXGV");


var $lIS42 = parcelRequire("lIS42");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $8da05bbe9f24d995$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $inXGV.mergeMap($lIS42.identity, null, concurrent);
}
$8da05bbe9f24d995$export$18aef43295bbe906 = $8da05bbe9f24d995$var$mergeAll; //# sourceMappingURL=mergeAll.js.map

});

parcelRegister("lIS42", function(module, exports) {
$parcel$export(module.exports, "identity", () => $fd07a50b5336926a$export$f0954fd7d5368655, (v) => $fd07a50b5336926a$export$f0954fd7d5368655 = v);
var $fd07a50b5336926a$export$f0954fd7d5368655;
"use strict";
function $fd07a50b5336926a$var$identity(x) {
    return x;
}
$fd07a50b5336926a$export$f0954fd7d5368655 = $fd07a50b5336926a$var$identity; //# sourceMappingURL=identity.js.map

});

parcelRegister("g0fSg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8m50u = parcelRequire("8m50u");


var $iDrrr = parcelRequire("iDrrr");


var $g9ZnD = parcelRequire("g9ZnD");


var $gIMcb = parcelRequire("gIMcb");

const $e5bbb38f64c6a3e7$export$9f7977d4a2561bee = (Component)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
        const mediaClient = (0, $cozmU.useMemo)(()=>existingMediaClient ?? (0, $g9ZnD.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaClient
        }));
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                })))));
module.exports["withMediaClient"] = $e5bbb38f64c6a3e7$export$9f7977d4a2561bee;

});

parcelRegister("jmmTp", function(module, exports) {
const $ad0c18c377a101ba$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
module.exports["isFileIdentifier"] = $ad0c18c377a101ba$export$7695387cd66cf5b5;

});

parcelRegister("fA65V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c226a72f375a9da1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    select_an_avatar_option: {
        id: "fabric.media.select_an_avatar_option",
        defaultMessage: "Default avatar option {number}"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    line_count: {
        id: "fabric.media.line_count",
        defaultMessage: "{count, plural, one {# line} other {# lines}}"
    },
    plain_text: {
        id: "fabric.media.plain_text",
        defaultMessage: "Plain text"
    },
    archive_format_not_supported: {
        id: "fabric.media.archive_format_not_supported",
        defaultMessage: "Preview is not available for this file type."
    },
    unsupported_file_format: {
        id: "fabric.media.unsupported_file_format",
        defaultMessage: "Unsupported file format"
    },
    file_too_large_to_preview: {
        id: "fabric.media.file_too_large_to_preview",
        defaultMessage: "File is too large to preview"
    },
    file_too_large_description: {
        id: "fabric.media.file_too_large_description",
        defaultMessage: "Preview isn't available for files of this size."
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    zoom_to_fit: {
        id: "fabric.media.zoom_to_fit",
        defaultMessage: "Fit to screen"
    },
    zoom_to_fit_with_level: {
        id: "fabric.media.zoom_to_fit_with_level",
        defaultMessage: "{zoomLevel} zoom, fit to screen"
    },
    hide_sidebar: {
        id: "fabric.media.viewer.hide_sidebar",
        defaultMessage: "Hide sidebar"
    },
    show_sidebar: {
        id: "fabric.media.viewer.show_sidebar",
        defaultMessage: "Show sidebar"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    playbackSpeedValue: {
        id: "fabric.media.playback_speed_value",
        defaultMessage: "Playback speed {speed}x"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    expand: {
        id: "fabric.media.expand",
        defaultMessage: "Expand"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    open_file_in_viewer_aria_label: {
        id: "fabric.media.open_file_in_viewer_aria_label",
        defaultMessage: "Open {name} in fullscreen"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    }
});
module.exports["messages"] = $c226a72f375a9da1$export$defe85febe8b728c;

});

parcelRegister("42Fpa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2f17777bbdd9049a$var$_react = $2f17777bbdd9049a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2f17777bbdd9049a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f17777bbdd9049a$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2f17777bbdd9049a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2f17777bbdd9049a$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2f17777bbdd9049a$var$_default = module.exports.default = $2f17777bbdd9049a$var$SourceCode24Icon;

});

parcelRegister("jZpwZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e8d784bfa3b30ee1$var$_react = $e8d784bfa3b30ee1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $e8d784bfa3b30ee1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8d784bfa3b30ee1$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $e8d784bfa3b30ee1$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e8d784bfa3b30ee1$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $e8d784bfa3b30ee1$var$_default = module.exports.default = $e8d784bfa3b30ee1$var$Spreadsheet24Icon;

});

parcelRegister("9Jnyo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $715a9653e306c98f$var$_react = $715a9653e306c98f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $715a9653e306c98f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $715a9653e306c98f$var$Audio16Icon = (props)=>/*#__PURE__*/ $715a9653e306c98f$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$715a9653e306c98f$var$Audio16Icon.displayName = 'Audio16Icon';
var $715a9653e306c98f$var$_default = module.exports.default = $715a9653e306c98f$var$Audio16Icon;

});

parcelRegister("gCdaE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c18a696825273ec6$var$_react = $c18a696825273ec6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $c18a696825273ec6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c18a696825273ec6$var$Audio24Icon = (props)=>/*#__PURE__*/ $c18a696825273ec6$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c18a696825273ec6$var$Audio24Icon.displayName = 'Audio24Icon';
var $c18a696825273ec6$var$_default = module.exports.default = $c18a696825273ec6$var$Audio24Icon;

});

parcelRegister("5m8Xe", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e65f3f767377aa6$var$_react = $3e65f3f767377aa6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $3e65f3f767377aa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e65f3f767377aa6$var$Document16Icon = (props)=>/*#__PURE__*/ $3e65f3f767377aa6$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e65f3f767377aa6$var$Document16Icon.displayName = 'Document16Icon';
var $3e65f3f767377aa6$var$_default = module.exports.default = $3e65f3f767377aa6$var$Document16Icon;

});

parcelRegister("dj32l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9aff67bd6f8a5bd3$var$_react = $9aff67bd6f8a5bd3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $9aff67bd6f8a5bd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9aff67bd6f8a5bd3$var$Document24Icon = (props)=>/*#__PURE__*/ $9aff67bd6f8a5bd3$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9aff67bd6f8a5bd3$var$Document24Icon.displayName = 'Document24Icon';
var $9aff67bd6f8a5bd3$var$_default = module.exports.default = $9aff67bd6f8a5bd3$var$Document24Icon;

});

parcelRegister("5t27u", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3fb14e1bddde3789$var$_react = $3fb14e1bddde3789$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $3fb14e1bddde3789$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3fb14e1bddde3789$var$Generic16Icon = (props)=>/*#__PURE__*/ $3fb14e1bddde3789$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3fb14e1bddde3789$var$Generic16Icon.displayName = 'Generic16Icon';
var $3fb14e1bddde3789$var$_default = module.exports.default = $3fb14e1bddde3789$var$Generic16Icon;

});

parcelRegister("cAa12", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $92909dc17280e83d$var$_react = $92909dc17280e83d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $92909dc17280e83d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $92909dc17280e83d$var$Generic24Icon = (props)=>/*#__PURE__*/ $92909dc17280e83d$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$92909dc17280e83d$var$Generic24Icon.displayName = 'Generic24Icon';
var $92909dc17280e83d$var$_default = module.exports.default = $92909dc17280e83d$var$Generic24Icon;

});

parcelRegister("1rDre", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $10d6e7acdde4b7aa$var$_react = $10d6e7acdde4b7aa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $10d6e7acdde4b7aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $10d6e7acdde4b7aa$var$Image16Icon = (props)=>/*#__PURE__*/ $10d6e7acdde4b7aa$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$10d6e7acdde4b7aa$var$Image16Icon.displayName = 'Image16Icon';
var $10d6e7acdde4b7aa$var$_default = module.exports.default = $10d6e7acdde4b7aa$var$Image16Icon;

});

parcelRegister("4C7IM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $35c0b35464adb49e$var$_react = $35c0b35464adb49e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $35c0b35464adb49e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $35c0b35464adb49e$var$Image24Icon = (props)=>/*#__PURE__*/ $35c0b35464adb49e$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
    }, props, {
        size: 'medium'
    }));
$35c0b35464adb49e$var$Image24Icon.displayName = 'Image24Icon';
var $35c0b35464adb49e$var$_default = module.exports.default = $35c0b35464adb49e$var$Image24Icon;

});

parcelRegister("eziPO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a9b2f1c15109a71a$var$_react = $a9b2f1c15109a71a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $a9b2f1c15109a71a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9b2f1c15109a71a$var$Video16Icon = (props)=>/*#__PURE__*/ $a9b2f1c15109a71a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
    }, props, {
        size: 'small'
    }));
$a9b2f1c15109a71a$var$Video16Icon.displayName = 'Video16Icon';
var $a9b2f1c15109a71a$var$_default = module.exports.default = $a9b2f1c15109a71a$var$Video16Icon;

});

parcelRegister("5Dz6O", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $41abd4227f5a613a$var$_react = $41abd4227f5a613a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $41abd4227f5a613a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $41abd4227f5a613a$var$Video24Icon = (props)=>/*#__PURE__*/ $41abd4227f5a613a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$41abd4227f5a613a$var$Video24Icon.displayName = 'Video24Icon';
var $41abd4227f5a613a$var$_default = module.exports.default = $41abd4227f5a613a$var$Video24Icon;

});

parcelRegister("c2smn", function(module, exports) {

var $iC5Q5 = parcelRequire("iC5Q5");


var $hsnIS = parcelRequire("hsnIS");


var $adEwt = parcelRequire("adEwt");

const $a3703bbade11fb84$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $a3703bbade11fb84$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hsnIS.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $adEwt.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $a3703bbade11fb84$export$836625761e76d373 = {
    mediaInline: false
};
function $a3703bbade11fb84$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $iC5Q5.getGenericFeatureFlag)(flagName, $a3703bbade11fb84$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $a3703bbade11fb84$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $a3703bbade11fb84$export$383e8f51978266d;

});

parcelRegister("iC5Q5", function(module, exports) {

var $2hYl7 = parcelRequire("2hYl7");

function $cf2104adc10a7224$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $2hYl7.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $cf2104adc10a7224$export$f2687d0de19e4973;

});

parcelRegister("2hYl7", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $8ed9ff59a41a6857$export$d125817a2695dbc9 = (key)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return typeof window !== 'undefined' && window.localStorage ? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $8ed9ff59a41a6857$export$d125817a2695dbc9;

});

parcelRegister("hsnIS", function(module, exports) {
const $642951ddc1f8ae05$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $642951ddc1f8ae05$export$189fe120be7e73fc = ()=>$642951ddc1f8ae05$var$productKeys;
module.exports["getProductKeys"] = $642951ddc1f8ae05$export$189fe120be7e73fc;

});

parcelRegister("adEwt", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $55eb57bebd45f4d3$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $55eb57bebd45f4d3$export$2db74afa1ef496f1;

});

parcelRegister("6wYuL", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 



const $d6a90985447658eb$export$dbe437e0902936cc = 'media-blob-url';
module.exports["mediaBlobUrlIdentifier"] = $d6a90985447658eb$export$dbe437e0902936cc;

});

parcelRegister("gjPL4", function(module, exports) {
const $2cc17340c0c1baf9$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $2cc17340c0c1baf9$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $2cc17340c0c1baf9$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $2cc17340c0c1baf9$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $2cc17340c0c1baf9$export$d87a47989c00f322;
    if (appearance === 'square') return $2cc17340c0c1baf9$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $2cc17340c0c1baf9$export$aeb48196afcd236a;
    return $2cc17340c0c1baf9$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $2cc17340c0c1baf9$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $2cc17340c0c1baf9$export$ed7b8a4728e9c63;

});

parcelRegister("8BNw5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gjPL4 = parcelRequire("gjPL4");


var $8TTbR = parcelRequire("8TTbR");


var $iDrrr = parcelRequire("iDrrr");


var $5o4s6 = parcelRequire("5o4s6");

class $d868351120faa6d0$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const numChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(this.props.children);
        let content;
        if (numChildren === 1) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const card = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(this.props.children)[0];
            switch(card.props.type){
                case 'file':
                    content = this.renderSingleFile(card);
                    break;
                case 'link':
                    content = null;
                    break;
                default:
                    content = this.renderSingleLink(card);
            }
        } else content = this.renderStrip();
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: "MediaGroup",
                ...(0, $5o4s6.VcMediaWrapperProps),
                children: content
            })
        });
    }
    renderSingleFile(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            // the media group component renders in crop mode in editor thus this enables consistency
            // also crop is much easier to make consistent across SSR and hydration
            resizeMode: (0, $iDrrr.fg)('media-perf-uplift-mutation-fix') ? 'crop' : 'stretchy-fit',
            cardDimensions: (0, $gjPL4.defaultImageCardDimensions),
            useInlinePlayer: false,
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderSingleLink(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            appearance: 'auto',
            featureFlags: this.props.featureFlags
        });
    }
    cloneFileCard(child, surroundingItems) {
        const cardClickHandler = this.props && this.props.eventHandlers && this.props.eventHandlers.media && this.props.eventHandlers.media.onClick;
        const onClick = cardClickHandler ? this.onMediaClick(cardClickHandler, child, surroundingItems) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            useInlinePlayer: false,
            eventHandlers: {
                ...child.props.eventHandlers,
                media: {
                    onClick: onClick
                }
            },
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderStrip() {
        const { children: children } = this.props;
        const { animate: animate, offset: offset } = this.state;
        const childIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return this.mapMediaPropsToIdentifier(child.props);
        });
        const surroundingItems = (childIdentifiers || []).filter((identifier)=>!!identifier);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8TTbR.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (rawChild)=>{
                const child = rawChild;
                switch(child.props.type){
                    case 'file':
                        return this.cloneFileCard(child, surroundingItems);
                    case 'link':
                        return null;
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                            featureFlags: this.props.featureFlags,
                            enableDownloadButton: this.props.enableDownloadButton
                        });
                }
            })
        });
    }
    mapMediaPropsToIdentifier({ id: id, type: type, occurrenceKey: occurrenceKey, collection: collection }) {
        switch(type){
            case 'file':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: type,
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
            case 'link':
                return undefined;
            case 'external':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: 'file',
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            animate: false,
            offset: 0
        };
        this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            });
        this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            });
        this.onMediaClick = (cardClickHandler, child, surroundingItems)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (event, analyticsEvent)=>{
                const surroundings = {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    collectionName: child.props.collection,
                    list: surroundingItems
                };
                cardClickHandler(event, surroundings, analyticsEvent);
            };
    }
}
module.exports["default"] = $d868351120faa6d0$export$2e2bcd8739ae039;

});

parcelRegister("8TTbR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j3UOY = parcelRequire("j3UOY");


var $gWRZb = parcelRequire("gWRZb");

const $75428e9db26defa4$var$DURATION_MIN = 0.5;
const $75428e9db26defa4$var$DURATION_MAX = 1.0;
const $75428e9db26defa4$var$EXTRA_PADDING = 4;
const $75428e9db26defa4$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $75428e9db26defa4$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $75428e9db26defa4$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $75428e9db26defa4$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $75428e9db26defa4$var$DURATION_MAX - $75428e9db26defa4$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $75428e9db26defa4$var$DURATION_MAX), $75428e9db26defa4$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $75428e9db26defa4$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $75428e9db26defa4$var$EXTRA_PADDING) return newOffset - $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $75428e9db26defa4$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, $75428e9db26defa4$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($j3UOY)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$75428e9db26defa4$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $75428e9db26defa4$var$mapReactChildToReactNode(child, index) {
    const key = $75428e9db26defa4$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $75428e9db26defa4$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $75428e9db26defa4$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $75428e9db26defa4$export$817db220b90d8024;

});

parcelRegister("j3UOY", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $de0a5fa3d60c62bd$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$de0a5fa3d60c62bd$var$debounce.debounce = $de0a5fa3d60c62bd$var$debounce;
module.exports = $de0a5fa3d60c62bd$var$debounce;

});

parcelRegister("gWRZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jXJyv = parcelRequire("jXJyv");

const $8dba4ca83cef8f6b$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
const $8dba4ca83cef8f6b$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
const $8dba4ca83cef8f6b$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
const $8dba4ca83cef8f6b$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
const $8dba4ca83cef8f6b$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
const $8dba4ca83cef8f6b$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
const $8dba4ca83cef8f6b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
module.exports["LeftArrow"] = $8dba4ca83cef8f6b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $8dba4ca83cef8f6b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $8dba4ca83cef8f6b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $8dba4ca83cef8f6b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $8dba4ca83cef8f6b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $8dba4ca83cef8f6b$export$54cfc70c184c0713;

});

parcelRegister("jXJyv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $8TTbR = parcelRequire("8TTbR");

const $b735c99c0da4e1ae$var$filmStripViewStyles = null;
const $b735c99c0da4e1ae$var$filmStripListWrapperStyles = null;
const $b735c99c0da4e1ae$var$filmStripListStyles = null;
const $b735c99c0da4e1ae$var$filmStripListItemStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperMotionStyles = null;
const $b735c99c0da4e1ae$var$arrowLeftWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowRightWrapperStyles = null;
const $b735c99c0da4e1ae$var$shadowStyles = null;
const $b735c99c0da4e1ae$var$resetButtonStyle = null;
const $b735c99c0da4e1ae$var$shadowLeftStyles = null;
const $b735c99c0da4e1ae$var$shadowRightStyles = null;
const $b735c99c0da4e1ae$var$ShadowLeft = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = (event)=>onClick && onClick(event);
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            onClick: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = (event)=>onClick && onClick(event);
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            onClick: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
            color: "currentColor",
            spacing: "spacious",
            label: "left"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $b735c99c0da4e1ae$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            color: "currentColor",
            spacing: "spacious",
            label: "right"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $b735c99c0da4e1ae$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ])
    }, children);
const $b735c99c0da4e1ae$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId || $[3] !== onTouchEnd || $[4] !== onTouchMove || $[5] !== onTouchStart || $[6] !== onWheel || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            onWheel: onWheel,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = onTouchEnd;
        $[4] = onTouchMove;
        $[5] = onTouchStart;
        $[6] = onWheel;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ])
    }, children));
const $b735c99c0da4e1ae$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, style: style } = t0;
    const t1 = ref;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== style || $[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            ref: t1,
            style: style,
            className: t2
        }, children);
        $[1] = children;
        $[2] = style;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ])
    }, children));
const $b735c99c0da4e1ae$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, index: index } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: t1,
            "data-testid": "media-filmstrip-list-item",
            key: index
        }, children);
        $[1] = children;
        $[2] = index;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $b735c99c0da4e1ae$export$924abd21043fc000;
module.exports["ShadowRight"] = $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $b735c99c0da4e1ae$export$abf07652016c7e56;
module.exports["LeftArrow"] = $b735c99c0da4e1ae$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $b735c99c0da4e1ae$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $b735c99c0da4e1ae$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $b735c99c0da4e1ae$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $b735c99c0da4e1ae$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $b735c99c0da4e1ae$export$54cfc70c184c0713;

});

parcelRegister("lWEf5", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $4iudd = parcelRequire("4iudd");


var $aHoC6 = parcelRequire("aHoC6");


var $dUm2W = parcelRequire("dUm2W");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $4PCaV = parcelRequire("4PCaV");


var $hZmcT = parcelRequire("hZmcT");


var $2bxao = parcelRequire("2bxao");

function $c0c05cdaad03161d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c0c05cdaad03161d$var$DEFAULT_WIDTH = 250;
const $c0c05cdaad03161d$var$DEFAULT_HEIGHT = 200;
const $c0c05cdaad03161d$var$uiMediaSingleBaseStyles = {
    name: "1a43hhz",
    styles: "transition:all 0.1s linear"
};
const $c0c05cdaad03161d$var$uiMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
const $c0c05cdaad03161d$var$isMediaElement = (media)=>{
    if (!media) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { nodeType: nodeType, type: type } = media.props || {};
    // Use this to perform a rough check
    // better than assume the first item in children is media
    return nodeType === 'media' || [
        'external',
        'file',
        'link'
    ].indexOf(type) >= 0;
};
const $c0c05cdaad03161d$var$checkForMediaElement = (children)=>{
    const [media] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (media && !$c0c05cdaad03161d$var$isMediaElement(media) && media.props.children) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $c0c05cdaad03161d$var$checkForMediaElement(media.props.children);
    return media;
};
const $c0c05cdaad03161d$export$507465eaf3c57f05 = (currentContainerWidth, layout)=>{
    if (!currentContainerWidth) // SSR mode fallback to default layout width
    switch(layout){
        case 'full-width':
            return 0, $7Y8M5.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $7Y8M5.akEditorWideLayoutWidth;
        default:
            return 0, $7Y8M5.akEditorDefaultLayoutWidth;
    }
    return currentContainerWidth;
};
const $c0c05cdaad03161d$var$MediaSingleWithChildren = (props)=>{
    const { rendererAppearance: rendererAppearance, featureFlags: featureFlags, isInsideOfBlockNode: isInsideOfBlockNode, layout: layout, width: widthAttr, widthType: widthType, allowCaptions: allowCaptions = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, media: media, caption: caption, editorAppearance: editorAppearance } = props;
    const [externalImageDimensions, setExternalImageDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        width: 0,
        height: 0
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const onExternalImageLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ width: width, height: height })=>{
        setExternalImageDimensions({
            width: width,
            height: height
        });
    }, []);
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { width: width = $c0c05cdaad03161d$var$DEFAULT_WIDTH, height: height = $c0c05cdaad03161d$var$DEFAULT_HEIGHT, type: type } = media.props;
    if (type === 'external') {
        const { width: stateWidth, height: stateHeight } = externalImageDimensions;
        if (width === null) width = stateWidth || $c0c05cdaad03161d$var$DEFAULT_WIDTH;
        if (height === null) height = stateHeight || $c0c05cdaad03161d$var$DEFAULT_HEIGHT;
    }
    if (width === null) {
        width = $c0c05cdaad03161d$var$DEFAULT_WIDTH;
        height = $c0c05cdaad03161d$var$DEFAULT_HEIGHT;
    }
    const isFullPage = rendererAppearance === 'full-page';
    const isFullWidth = rendererAppearance === 'full-width';
    const padding = isFullPage ? (0, $2bxao.FullPagePadding) * 2 : 0;
    const calcDimensions = (0, $cozmU.useCallback)((mediaContainerWidth)=>{
        const containerWidth = $c0c05cdaad03161d$export$507465eaf3c57f05(mediaContainerWidth, layout);
        let cardDimensions = {};
        if ((0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
            const maxWidth = widthAttr && typeof widthAttr === 'number' && widthType === 'pixel' ? widthAttr : containerWidth;
            cardDimensions = {
                width: `${maxWidth}px`,
                height: `100%`
            };
        } else {
            const maxWidth = (0, $4iudd.isSSR)() && widthAttr && typeof widthAttr === 'number' ? Math.max(widthAttr, containerWidth) : containerWidth;
            const maxHeight = height / width * maxWidth;
            cardDimensions = {
                width: `${maxWidth}px`,
                height: `${maxHeight}px`
            };
        }
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $7Y8M5.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $7Y8M5.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const minWidth = Math.min((0, $7Y8M5.akEditorFullWidthLayoutWidth), containerWidth - padding);
        const lineLength = isFullWidth ? minWidth : nonFullWidthSize;
        return {
            cardDimensions: cardDimensions,
            lineLength: lineLength
        };
    }, [
        height,
        isFullWidth,
        isInsideOfBlockNode,
        layout,
        padding,
        rendererAppearance,
        width,
        widthAttr,
        widthType
    ]);
    const originalDimensions = (0, $cozmU.useMemo)(()=>({
            width: width,
            height: height
        }), [
        height,
        width
    ]);
    const { setHoverTarget: setHoverTarget } = (0, $hZmcT.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $4PCaV.useAnnotationHoverDispatch)();
    const isFullPageRenderer = isFullPage || isFullWidth;
    (0, $cozmU.useEffect)(()=>{
        const mediaSingleElement = ref.current;
        const handleMouseEnter = (event)=>{
            cancelTimeout();
            if (event.buttons === 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                setHoverTarget && setHoverTarget(event.target);
                setIsWithinRange(true);
            }
        };
        const handleMouseLeave = ()=>{
            initiateTimeout();
        };
        if (mediaSingleElement && isFullPageRenderer) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseenter', handleMouseEnter);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseleave', handleMouseLeave);
        }
        return ()=>{
            if (mediaSingleElement && isFullPageRenderer) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseenter', handleMouseEnter);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [
        setHoverTarget,
        isFullPageRenderer,
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    // Note: in SSR mode the `window` object is not defined,
    // therefore width here is 0, see:
    // packages/editor/editor-common/src/ui/WidthProvider/index.tsx
    const { width: renderWidth } = (0, $cozmU.useContext)((0, $dUm2W.WidthContext));
    const containerWidth = $c0c05cdaad03161d$export$507465eaf3c57f05(renderWidth, layout);
    const { cardDimensions: cardDimensions, lineLength: lineLength } = (0, $cozmU.useMemo)(()=>calcDimensions(containerWidth), [
        calcDimensions,
        containerWidth
    ]);
    const renderMediaSingle = ()=>{
        const mediaComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(media, {
            resizeMode: 'stretchy-fit',
            cardDimensions: cardDimensions,
            originalDimensions: originalDimensions,
            onExternalImageLoaded: onExternalImageLoaded,
            disableOverlay: true,
            featureFlags: featureFlags,
            mediaSingleElement: ref.current
        });
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? [
            $c0c05cdaad03161d$var$uiMediaSingleBaseStyles,
            $c0c05cdaad03161d$var$uiMediaSingleLayoutStyles
        ] : [
            $c0c05cdaad03161d$var$uiMediaSingleBaseStyles
        ];
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aHoC6.default), {
            css: uiMediaSingleStyles,
            handleMediaSingleRef: ref,
            layout: layout,
            width: width,
            height: height,
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            containerWidth: containerWidth,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            size: {
                width: widthAttr,
                widthType: widthType
            },
            fullWidthMode: isFullWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            dataAttributes: dataAttributes,
            editorAppearance: editorAppearance,
            isInRenderer: true
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, mediaComponent), allowCaptions && caption);
    };
    return renderMediaSingle();
};
const $c0c05cdaad03161d$var$MediaSingle = (props)=>{
    const { children: children } = props;
    let media;
    const [node, caption] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
    if (!$c0c05cdaad03161d$var$isMediaElement(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mediaElement = $c0c05cdaad03161d$var$checkForMediaElement(node.props.children);
        if (!mediaElement) return node;
        media = mediaElement;
    } else media = node;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)($c0c05cdaad03161d$var$MediaSingleWithChildren, {
        ...props,
        media: media,
        caption: caption
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $c0c05cdaad03161d$var$_default_1 = (0, $kSwu1.injectIntl)($c0c05cdaad03161d$var$MediaSingle);
var $c0c05cdaad03161d$export$2e2bcd8739ae039 = $c0c05cdaad03161d$var$_default_1;
module.exports["default"] = $c0c05cdaad03161d$export$2e2bcd8739ae039;

});

parcelRegister("4cczm", function(module, exports) {
const $577b7b0c5e75a3c1$export$d821aa4c8afb384e = 'fabric-elements';
const $577b7b0c5e75a3c1$export$af8124aa496797f2 = '_|unknown|_';
module.exports["ELEMENTS_CHANNEL"] = $577b7b0c5e75a3c1$export$d821aa4c8afb384e;
module.exports["UNKNOWN_USER_ID"] = $577b7b0c5e75a3c1$export$af8124aa496797f2;

});

parcelRegister("caelp", function(module, exports) {
const $c573a2458006a7eb$export$43bc8ec87115a7b3 = '__agent-mentions-load-error__';
var $c573a2458006a7eb$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $c573a2458006a7eb$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $c573a2458006a7eb$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $c573a2458006a7eb$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $c573a2458006a7eb$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $c573a2458006a7eb$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $c573a2458006a7eb$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
module.exports["AGENT_MENTION_LOAD_ERROR_ID"] = $c573a2458006a7eb$export$43bc8ec87115a7b3;
module.exports["MentionType"] = $c573a2458006a7eb$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $c573a2458006a7eb$export$81124e6148ca5db0;
module.exports["UserType"] = $c573a2458006a7eb$export$8436e53e45ffe15b;
module.exports["SliNames"] = $c573a2458006a7eb$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $c573a2458006a7eb$export$5c42d9dea6d035c1;
module.exports["Actions"] = $c573a2458006a7eb$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $c573a2458006a7eb$export$b8fa67dc54502853;

});

parcelRegister("2SUNK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b516e3b9bd2f12c$export$2e2bcd8739ae039);
let $1b516e3b9bd2f12c$var$debugEnabled = false;
let $1b516e3b9bd2f12c$var$stacktracesEnabled = false;
function $1b516e3b9bd2f12c$export$748ada60eaf985cc(enable) {
    $1b516e3b9bd2f12c$var$debugEnabled = enable;
}
function $1b516e3b9bd2f12c$export$4f7017086af31c25(enable) {
    $1b516e3b9bd2f12c$var$stacktracesEnabled = enable;
}
function $1b516e3b9bd2f12c$export$2a858f450a2f66d() {
    if ($1b516e3b9bd2f12c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b516e3b9bd2f12c$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b516e3b9bd2f12c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::378c0a04d2cca8641793d5a92fac3d1a>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {
const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$export$efd16d9cf43b6e97 = 'teamProfileCard';
const $e8b102093dcaac45$export$7611b3e6899481f9 = 'profilecard';
const $e8b102093dcaac45$export$4c23d6e68fa71371 = 'rovoAgentProfilecard';
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["TEAM_SUBJECT"] = $e8b102093dcaac45$export$efd16d9cf43b6e97;
module.exports["USER_SUBJECT"] = $e8b102093dcaac45$export$7611b3e6899481f9;
module.exports["AGENT_SUBJECT"] = $e8b102093dcaac45$export$4c23d6e68fa71371;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $hMCZS = parcelRequire("hMCZS");


var $lUcpS = parcelRequire("lUcpS");


var $dSW04 = parcelRequire("dSW04");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                profileHref = (0, $hMCZS.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $dSW04.AgentForbiddenError)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $etoPX = parcelRequire("etoPX");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
            creatorNameWithLink: creator.name
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("dSW04", function(module, exports) {
class $99c5d70c0df67415$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
module.exports["AgentForbiddenError"] = $99c5d70c0df67415$export$a6d78d75d03919f1;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ipkS0 = parcelRequire("ipkS0");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-7xjQ31", ()=>(parcelRequire("lLAOq"))));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("lLAOq", function(module, exports) {

let $fd8a8ae5e55b02b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd8a8ae5e55b02b3$var$load("7J1PC"),
    $fd8a8ae5e55b02b3$var$load("446Ip"),
    $fd8a8ae5e55b02b3$var$load("6wr18"),
    $fd8a8ae5e55b02b3$var$load("iYJZz"),
    $fd8a8ae5e55b02b3$var$load("jqoep"),
    $fd8a8ae5e55b02b3$var$load("ea3NB"),
    $fd8a8ae5e55b02b3$var$load("ffEVr"),
    $fd8a8ae5e55b02b3$var$load("7EorR"),
    $fd8a8ae5e55b02b3$var$load("hhss7"),
    $fd8a8ae5e55b02b3$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("eilSC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $9wMFw = parcelRequire("9wMFw");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $krYZG = parcelRequire("krYZG");


var $cSuwJ = parcelRequire("cSuwJ");


var $dUm2W = parcelRequire("dUm2W");


var $7Y8M5 = parcelRequire("7Y8M5");


var $aDSIl = parcelRequire("aDSIl");


var $4o0zT = parcelRequire("4o0zT");


var $lpNn5 = parcelRequire("lpNn5");


var $cY9xy = parcelRequire("cY9xy");


var $lEb7o = parcelRequire("lEb7o");


var $h10Mg = parcelRequire("h10Mg");

function $bf5e8c9c7e771773$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bf5e8c9c7e771773$var$titleStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    outline: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $7Y8M5.akEditorLineHeight),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
    textAlign: 'left'
});
const $bf5e8c9c7e771773$var$titleStylesDense = {
    name: "13vs5qp",
    styles: "font-size:var(--ak-renderer-base-font-size)"
};
const $bf5e8c9c7e771773$var$containerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    borderWidth: "var(--ds-border-width, 1px)",
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: "var(--ds-radius-small, 4px)",
    minHeight: '25px',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `background 0.3s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`,
    padding: "var(--ds-space-0, 0px)",
    paddingBottom: "var(--ds-space-0, 0px)",
    marginTop: "var(--ds-space-050, 4px)",
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td > :not(style):first-child, td > style:first-child + *': {
        marginTop: 0
    }
});
const $bf5e8c9c7e771773$var$containerStylesExpanded = {
    name: "mpp6x6",
    styles: "background:var(--ds-surface, #FFFFFF);padding-bottom:var(--ds-space-100, 8px);border-color:var(--ds-border, #0B120E24)"
};
const $bf5e8c9c7e771773$var$containerStylesFocused = {
    name: "pkf2kr",
    styles: "border-color:var(--ds-border-focused, #4688EC)"
};
const $bf5e8c9c7e771773$var$containerStylesDataNodeTypeExpand = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: `-${(0, $7Y8M5.akLayoutGutterOffset)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: `-${(0, $7Y8M5.akLayoutGutterOffset)}px`
});
const $bf5e8c9c7e771773$var$titleContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    alignItems: 'flex-start',
    background: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    width: '100%',
    color: "var(--ds-text-subtle, #505258)",
    overflow: 'hidden',
    cursor: 'pointer',
    padding: "var(--ds-space-100, 8px)",
    '&:focus': {
        outline: 0
    }
});
const $bf5e8c9c7e771773$var$titleContainerStylesExpanded = {
    name: "dkidh7",
    styles: "padding-bottom:var(--ds-space-0, 0px)"
};
// Base styles for the content container. visibility:hidden hides collapsed content.
// When browser find is supported, the useEffect clears visibility:hidden after setting
// hidden="until-found" on the DOM element, which applies content-visibility:hidden natively —
// this hides the content while allowing browser Ctrl+F to index the text.
// The visibility:hidden in CSS serves as an SSR fallback (useEffect doesn't run server-side).
const $bf5e8c9c7e771773$var$contentContainerStyles = {
    name: "br2f98",
    styles: "padding-top:var(--ds-space-0, 0px);margin-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-200, 16px);padding-left:var(--ds-space-400, 32px);visibility:hidden;@supports not (display: flow-root){width:100%;box-sizing:border-box;}"
};
// display:flow-root is applied only when browser find is not supported.
// It must NOT be set when browser find is supported — it overrides the
// content-visibility:hidden applied by hidden="until-found" and makes content visible.
const $bf5e8c9c7e771773$var$contentContainerStylesFlowRoot = {
    name: "12r8j1i",
    styles: "display:flow-root"
};
const $bf5e8c9c7e771773$var$contentContainerStylesExpanded = {
    name: "xhzdsf",
    styles: "padding-top:var(--ds-space-100, 8px);visibility:visible"
};
const $bf5e8c9c7e771773$var$contentContainerStylesNotExpanded = {
    name: "1njmbsg",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;height:0;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);user-select:none;}"
};
// When browser find is supported and expand is collapsed, we rely on the
// hidden="until-found" attribute on the outer container to hide content.
// We remove height:0/overflow:hidden/clip from the inner wrapper so the
// browser can actually search through the content.
//
// `user-select: none` must NOT be set here, unlike the variant above. WebKit scrolls to a
// find-in-page match by selecting it, so unselectable text is matched but never revealed: the
// reader is told there is a hit, the `hidden` attribute stays put, and the expand never opens.
// Chrome does not need a selection, so it hid the problem. Nothing is lost by leaving it out —
// content-visibility:hidden already makes a skipped subtree unselectable. It is only needed in the
// other variant, where the content is merely clipped and would otherwise be selectable.
const $bf5e8c9c7e771773$var$contentContainerStylesNotExpandedBrowserFind = {
    name: "d8pelj",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;}"
};
const $bf5e8c9c7e771773$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $bf5e8c9c7e771773$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $bf5e8c9c7e771773$var$containerStyles,
            props['data-node-type'] === 'expand' && $bf5e8c9c7e771773$var$containerStylesDataNodeTypeExpand,
            props.expanded && $bf5e8c9c7e771773$var$containerStylesExpanded,
            props.focused && $bf5e8c9c7e771773$var$containerStylesFocused
        ],
        "data-testid": props['data-testid'],
        "data-node-type": props['data-node-type'],
        "data-title": props['data-title'],
        "data-expanded": props['data-expanded'],
        "data-local-id": props['data-local-id']
    }, props.children);
};
const $bf5e8c9c7e771773$var$TitleContainer = (props)=>{
    const { expanded: expanded } = props;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
        type: "button",
        css: [
            $bf5e8c9c7e771773$var$titleContainerStyles,
            expanded && $bf5e8c9c7e771773$var$titleContainerStylesExpanded
        ],
        onClick: props.onClick,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        "aria-labelledby": props['aria-labelledby'],
        "aria-expanded": props['aria-expanded'],
        contentEditable: props.contentEditable
    }, props.children));
};
$bf5e8c9c7e771773$var$TitleContainer.displayName = 'TitleContainerButton';
const $bf5e8c9c7e771773$var$ContentContainer = (props)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: props.contentRef,
        css: [
            $bf5e8c9c7e771773$var$contentContainerStyles,
            !props.enableBrowserFind && $bf5e8c9c7e771773$var$contentContainerStylesFlowRoot,
            props.expanded && $bf5e8c9c7e771773$var$contentContainerStylesExpanded,
            !props.expanded && (props.enableBrowserFind ? $bf5e8c9c7e771773$var$contentContainerStylesNotExpandedBrowserFind : $bf5e8c9c7e771773$var$contentContainerStylesNotExpanded)
        ]
    }, props.children);
};
function $bf5e8c9c7e771773$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) return;
    fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand' ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
        attributes: {
            platform: (0, $cY9xy.PLATFORM).WEB,
            mode: (0, $cY9xy.MODE).RENDERER,
            expanded: !expanded
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    });
}
function $bf5e8c9c7e771773$var$Expand({ title: title, children: children, nodeType: nodeType, intl: intl, fireAnalyticsEvent: fireAnalyticsEvent, localId: localId, nestedHeaderIds: nestedHeaderIds, rendererContentMode: rendererContentMode, node: node }) {
    const ancestorBody = (0, $h10Mg.useExpandBody)();
    // Shared with every expand in the chain: the element that stood in for this expand and caught the
    // find sits under an expand further out, and by the time this one mounts that element is gone.
    //
    // Built on first render rather than passed to `useRef`, which would evaluate and discard a new set
    // on every render for the life of the expand.
    const ownRevealedByFind = (0, $cozmU.useRef)(null);
    if (!ownRevealedByFind.current) ownRevealedByFind.current = new WeakSet();
    const revealedByFind = ancestorBody?.revealedByFind ?? ownRevealedByFind.current;
    /**
   * Browser find matched inside this expand while the expand above it was still collapsed, so it
   * opens as soon as it mounts — otherwise the reader would watch the outer expand open onto a
   * closed one, with the match nowhere to be seen. Empty on the server and on the first client
   * render, so hydration cannot disagree; only a find on the client ever puts anything in it.
   */ const revealedByFindOnMount = node !== undefined && revealedByFind.has(node);
    const [expanded, setExpanded] = (0, $cozmU.useState)(revealedByFindOnMount);
    const [focused, setFocused] = (0, $cozmU.useState)(false);
    /**
   * PGXT-9021: once opened, the body stays rendered even if the reader closes the expand again.
   * Throwing it away would re-run every macro and Forge fetch inside it on the next open, which is
   * slower and visibly reloads content the reader has already seen. We only wanted to save work on
   * the first page load, and by now that has happened. Starts false on both the server and the
   * first client render, so hydration cannot disagree.
   */ const [hasBeenExpanded, setHasBeenExpanded] = (0, $cozmU.useState)(revealedByFindOnMount);
    const isMobile = false;
    const label = intl.formatMessage(expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode);
    const { current: id } = (0, $cozmU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($9wMFw)))('expand-title-'));
    const contentContainerRef = (0, $cozmU.useRef)(null);
    const contentWrapperRef = (0, $cozmU.useRef)(null);
    const handleFocus = (0, $cozmU.useCallback)(()=>setFocused(true), []);
    const handleBlur = (0, $cozmU.useCallback)(()=>setFocused(false), []);
    // Both state updates happen in the same handler so they land in one render, rather than the
    // latch reacting to `expanded` from an effect.
    const openBody = (0, $cozmU.useCallback)(()=>{
        setExpanded(true);
        setHasBeenExpanded(true);
    }, []);
    // The browser found the text inside this expand. Opening this one is not enough: if it sits
    // inside other expands, those have to open too or the reader still cannot see it. Each expand
    // asks the one above it, so a single match opens the whole chain and nothing else.
    const openWithAncestors = (0, $cozmU.useCallback)(()=>{
        // Remembered before anything opens: a block above this expand may have been standing in for
        // itself, and rendering it rebuilds this expand. Without this it would come back closed over
        // the match the reader was just taken to.
        if (node) revealedByFind.add(node);
        openBody();
        ancestorBody?.openWithAncestors();
    }, [
        ancestorBody,
        node,
        openBody,
        revealedByFind
    ]);
    // Feature-detect hidden="until-found" support via the beforematch event. Chrome 102+,
    // Firefox 139+ and Safari 26.2+ all have it; in a browser without it, hidden="until-found" is
    // treated as plain boolean hidden (display:none), which would break the expand entirely.
    // Starts as `undefined`, meaning "we do not know yet", and is only answered in an effect. We
    // cannot check during render: the server has no browser to check, so it would say no there and
    // yes on the client, and hydration would disagree.
    const [supportsHiddenUntilFound, setSupportsHiddenUntilFound] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const doc = (0, $1hQ0e.getDocument)();
        setSupportsHiddenUntilFound(doc?.body ? 'onbeforematch' in doc.body : false);
    }, []);
    // React 18 treats `hidden` as a boolean attribute and strips the "until-found" value,
    // rendering it as just `hidden` (which applies display:none and blocks find-in-page).
    // We bypass React by setting the attribute directly on the DOM element around the text.
    //
    // We also remove the CSS visibility:hidden (SSR fallback) once hidden="until-found" is set,
    // because visibility:hidden blocks browser find. On expanded, we restore visibility to visible.
    //
    // Only applied when the browser supports hidden="until-found" (detected via onbeforematch).
    // Without it we skip this entirely and fall back to the normal CSS hiding
    // (visibility:hidden + height:0), which doesn't support find-in-page but still works
    // correctly for expand/collapse.
    (0, $cozmU.useEffect)(()=>{
        const contentContainer = contentContainerRef.current;
        const contentWrapper = contentWrapperRef.current;
        if (!contentWrapper) return;
        if (supportsHiddenUntilFound && !expanded) {
            contentWrapper.setAttribute('hidden', 'until-found');
            // Products ship a CSS reset with `[hidden] { display: none }` — Confluence does. That is an
            // author rule, so it beats the UA stylesheet's
            // `[hidden="until-found"] { content-visibility: hidden }` and takes the content out of the
            // page altogether, where find cannot reach it. Setting display next to the attribute keeps
            // the two together, rather than relying on a class selector elsewhere out-weighing a reset
            // we do not own.
            contentWrapper.style.display = 'block';
            // Override the CSS visibility:hidden from contentContainerStyles — hidden="until-found"
            // now handles hiding via content-visibility:hidden, which allows browser find to index
            // the content. We use 'visible' (not '') because '' only clears the inline style but
            // the Emotion CSS class rule still applies visibility:hidden, blocking find-in-page.
            contentContainer?.style.setProperty('visibility', 'visible');
            contentWrapper.style.visibility = 'visible';
        } else {
            contentWrapper.removeAttribute('hidden');
            contentWrapper.style.display = '';
            contentContainer?.style.removeProperty('visibility');
            contentWrapper.style.visibility = '';
        }
    }, [
        expanded,
        supportsHiddenUntilFound
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (expanded) return;
        const contentWrapper = contentWrapperRef.current;
        const unbindWrapperBeforeMatch = contentWrapper && supportsHiddenUntilFound ? (0, $cbY7C.bind)(contentWrapper, {
            type: 'beforematch',
            listener: openWithAncestors
        }) : undefined;
        return ()=>{
            unbindWrapperBeforeMatch?.();
        };
    }, [
        expanded,
        openWithAncestors,
        supportsHiddenUntilFound
    ]);
    // While this is false, the blocks of the body show their text instead of rendering. It is true
    // when:
    // - the expand is open, or has been opened before, so the reader wants to see the content;
    // - no node was given, so this expand never opted into lazy loading;
    // - the browser has no hidden="until-found", so the text would not be findable and standing it in
    //   would gain nothing. While we still do not know, we assume the browser has it — assuming the
    //   opposite would render the whole body on the first paint and lose the saving entirely.
    const revealed = expanded || hasBeenExpanded || !node || supportsHiddenUntilFound === false;
    const expandBody = (0, $cozmU.useMemo)(()=>({
            revealed: revealed,
            openWithAncestors: openWithAncestors,
            revealedByFind: revealedByFind
        }), [
        revealed,
        openWithAncestors,
        revealedByFind
    ]);
    const body = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $h10Mg.ExpandBodyProvider), {
        value: expandBody
    }, children);
    return /*#__PURE__*/ (0, $lOiVq.jsx)($bf5e8c9c7e771773$var$Container, {
        "data-testid": `expand-container-${nodeType}-${id}`,
        "data-node-type": nodeType,
        "data-title": title,
        "data-expanded": expanded,
        "data-local-id": localId,
        expanded: expanded,
        focused: focused
    }, nestedHeaderIds && nestedHeaderIds.length > 0 ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lEb7o.ActiveHeaderIdConsumer), {
        nestedHeaderIds: nestedHeaderIds,
        onNestedHeaderIdMatch: openBody
    }) : null, /*#__PURE__*/ (0, $lOiVq.jsx)($bf5e8c9c7e771773$var$TitleContainer, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $bf5e8c9c7e771773$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent);
            // Recorded so a product remounting this expand under its own body gets it back as the
            // reader left it.
            const recordsToggle = node !== undefined && (0, $4o0zT.isExperimentEnabled)('cc_light_mode_table_virtualization');
            if (expanded) {
                setExpanded(false);
                if (recordsToggle) revealedByFind.delete(node);
            } else {
                openBody();
                if (recordsToggle) revealedByFind.add(node);
            }
            e.persist();
            // @ts-ignore detail doesn't exist on type
            e.detail ? handleBlur() : handleFocus();
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-labelledby": id,
        "aria-expanded": expanded,
        contentEditable: false,
        expanded: expanded
    }, isMobile ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cSuwJ.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: label,
        spacing: "spacious",
        size: "small"
    })) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: label,
        position: "top",
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $cSuwJ.ExpandLayoutWrapperWithRef),
        testId: 'tooltip'
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cSuwJ.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: label,
        spacing: "spacious",
        size: "small"
    }))), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            $bf5e8c9c7e771773$var$titleStyles,
            rendererContentMode === 'compact' && $bf5e8c9c7e771773$var$titleStylesDense
        ],
        id: id
    }, title || intl.formatMessage((0, $cSuwJ.messages).expandDefaultTitle))), /*#__PURE__*/ (0, $lOiVq.jsx)($bf5e8c9c7e771773$var$ContentContainer, {
        expanded: expanded,
        enableBrowserFind: supportsHiddenUntilFound,
        contentRef: contentContainerRef
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        className: `${nodeType}-content-wrapper`,
        ref: contentWrapperRef
    }, revealed ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthProvider), null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $bf5e8c9c7e771773$var$clearNextSiblingMarginTopStyle
    }), body) : body)));
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $bf5e8c9c7e771773$var$_default_1 = (0, $kSwu1.injectIntl)($bf5e8c9c7e771773$var$Expand);
var $bf5e8c9c7e771773$export$2e2bcd8739ae039 = $bf5e8c9c7e771773$var$_default_1;
module.exports["default"] = $bf5e8c9c7e771773$export$2e2bcd8739ae039;

});

parcelRegister("9wMFw", function(module, exports) {

var $dojlP = parcelRequire("dojlP");

/** Used to generate unique IDs. */ var $6efcdace0fb66c85$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $6efcdace0fb66c85$var$uniqueId(prefix) {
    var id = ++$6efcdace0fb66c85$var$idCounter;
    return $dojlP(prefix) + id;
}
module.exports = $6efcdace0fb66c85$var$uniqueId;

});

parcelRegister("cSuwJ", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");

function $4a8c68f17b3fe31c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a8c68f17b3fe31c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    },
    // Clean up with platform_editor_expand_content_a11y_2.
    expandBodyAriaLabelOriginal: {
        id: "fabric.editor.expandBodyAriaLabel",
        defaultMessage: "Expand body content"
    },
    expandBodyAriaLabel: {
        id: "editor-common.Expand.expandBodyAriaLabel",
        defaultMessage: "Body content for {title}"
    },
    expandBodyAriaLabelUntitled: {
        id: "editor-common.Expand.expandBodyAriaLabelUntitled",
        defaultMessage: "untitled expand"
    },
    expandBodyAriaDescription: {
        id: "fabric.editor.expandBodyAriaDescription",
        defaultMessage: "Enter the content that will be revealed when this expand is opened."
    },
    expandBodyRoleDescription: {
        id: "fabric.editor.expandBodyRoleDescription",
        defaultMessage: "macro"
    }
});
const $4a8c68f17b3fe31c$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>expanded ? [
                $4a8c68f17b3fe31c$var$expandIconWrapperStyle(),
                $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle
            ] : $4a8c68f17b3fe31c$var$expandIconWrapperStyle()
    }, children);
};
const $4a8c68f17b3fe31c$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`
        }
    });
const $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $4a8c68f17b3fe31c$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $4a8c68f17b3fe31c$export$c67faf67c1185cba = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $4a8c68f17b3fe31c$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $4a8c68f17b3fe31c$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $4a8c68f17b3fe31c$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $4a8c68f17b3fe31c$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $4a8c68f17b3fe31c$export$c67faf67c1185cba;

});

parcelRegister("gWbtJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $de127ad6a6b1acf7$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

function $de127ad6a6b1acf7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-sync-block": true,
        "data-local-id": props.localId,
        "data-resource-id": props.resourceId
    });
}

});

parcelRegister("30QUD", function(module, exports) {
$parcel$export(module.exports, "default", () => $99af99aba878edda$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $95bQO = parcelRequire("95bQO");

function $99af99aba878edda$export$2e2bcd8739ae039(props) {
    const { children: children, localId: localId, resourceId: resourceId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-bodied-sync-block": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $95bQO.BodiedSyncBlockSharedCssClassName).renderer,
        "data-local-id": localId,
        "data-resource-id": resourceId,
        children: children
    });
}

});

parcelRegister("cFVPs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $96Ikf = parcelRequire("96Ikf");


var $iCEWf = parcelRequire("iCEWf");


var $jLdbZ = parcelRequire("jLdbZ");

const $a12da25560425c44$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $jU6s6.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $jLdbZ.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iCEWf.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).viewed, (0, $iCEWf.AISessionState).error, (0, $iCEWf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iCEWf.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).submitted, (0, $iCEWf.AISessionState).actioned, (0, $iCEWf.AISessionState).adopted, (0, $iCEWf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $96Ikf.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $a12da25560425c44$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a12da25560425c44$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a12da25560425c44$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
 //# sourceMappingURL=index.js.map
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("jU6s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f90c1a79bae927c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $1f90c1a79bae927c$export$4f059feb37b5835e;

});

parcelRegister("4dW9D", function(module, exports) {

var $iCEWf = parcelRequire("iCEWf");

const $7545c0c100898f47$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iCEWf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $7545c0c100898f47$export$5013b36eeed4ec19;

});

parcelRegister("iCEWf", function(module, exports) {
var $d6416e2c87d11da8$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d6416e2c87d11da8$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d6416e2c87d11da8$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d6416e2c87d11da8$export$7052d5b66e36f60f;

});

parcelRegister("96Ikf", function(module, exports) {
const $3836d38b50a38c42$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $3836d38b50a38c42$export$e053e424fcbfebe9;

});

parcelRegister("jLdbZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1r1cI = parcelRequire("1r1cI");


var $7mJer = parcelRequire("7mJer");


var $iCEWf = parcelRequire("iCEWf");

const $e5d5cfe1f6d4c858$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $iCEWf.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $1r1cI.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7mJer.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7mJer.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e5d5cfe1f6d4c858$export$259576f4e7ac6488;

});

parcelRegister("1r1cI", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $03RpJ = parcelRequire("03RpJ");

function $d83e4e74e28b2b37$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $03RpJ.default)());
}
module.exports["getNewSingleInstrumentationID"] = $d83e4e74e28b2b37$export$cee2a1482be61648;

});

parcelRegister("7mJer", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $0ca840bf5f9ee98d$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $0ca840bf5f9ee98d$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $0ca840bf5f9ee98d$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $0ca840bf5f9ee98d$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $0ca840bf5f9ee98d$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$d6fb1caea334c7c7;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("haiCi", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $5rzIE = parcelRequire("5rzIE");

const $a406323faf455711$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $a406323faf455711$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    const operation = startedAt === undefined ? undefined : $a406323faf455711$var$extractQueryName(gqlQuery);
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $a406323faf455711$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $a406323faf455711$export$ba203f24e0131ba7) {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'graphqlError'
            });
            throw err;
        }
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'abort'
            });
            return {
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing GraphQL abort baseline: abort returns an empty typed success shape for generic callers.
                data: null,
                errors: undefined
            };
        }
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'networkError'
        });
        throw new (0, $jTKfH.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $a406323faf455711$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $a406323faf455711$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $a406323faf455711$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $a406323faf455711$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $a406323faf455711$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $a406323faf455711$export$ba203f24e0131ba7;

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("9Ha4j", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $29e11ce05e624c9c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
const $29e11ce05e624c9c$export$3f95fcfdc25a741d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GuardIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Guard" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $29e11ce05e624c9c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function GuardIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $29e11ce05e624c9c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["GuardIcon"] = $29e11ce05e624c9c$export$3f95fcfdc25a741d;

});

parcelRegister("6ojvx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBxDy = parcelRequire("hBxDy");

const $59e5036a3fbf2e2e$export$6a671bebd9daad64 = (0, $cozmU.createContext)((0, $hBxDy.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $59e5036a3fbf2e2e$export$6a671bebd9daad64;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("ix7El", function(module, exports) {
var $04c5b557f78447f3$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $04c5b557f78447f3$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $04c5b557f78447f3$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $04c5b557f78447f3$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $04c5b557f78447f3$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $04c5b557f78447f3$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $04c5b557f78447f3$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $04c5b557f78447f3$export$9c0545f564a8227f;

});

parcelRegister("4K6lC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $3d3WW = parcelRequire("3d3WW");

const $a3a18abb8f8abee5$export$d28801614368e543 = 'forge-ui';
const $a3a18abb8f8abee5$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $852mP.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $852mP.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $852mP.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
// Merge forgeUIAttributes from outermost to innermost analytics contexts, so child contexts can
// override parent values in the final payload. If an inner context replaces extensionKey, keep the
// previous extensionKey separately so embedded macro events can report it as parentExtensionKey.
function $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(contexts) {
    return contexts.reduce((prev, curr)=>{
        // Only extract attributes passed as an object via the forgeUIAttributes key
        const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
        const previousExtensionKey = prev.forgeUIAttributes.extensionKey;
        const nextExtensionKey = forgeUIAttributes.extensionKey;
        const isExtensionKeyOverridden = Boolean(previousExtensionKey && nextExtensionKey && previousExtensionKey !== nextExtensionKey);
        // Capture the first extensionKey that gets replaced by a nested context. That replaced
        // value is the parent macro key once a child renderer context contributes its own key.
        const overriddenExtensionKey = prev.overriddenExtensionKey ?? (isExtensionKeyOverridden ? previousExtensionKey : undefined);
        return {
            forgeUIAttributes: {
                ...prev.forgeUIAttributes,
                ...forgeUIAttributes
            },
            overriddenExtensionKey: overriddenExtensionKey
        };
    }, {
        forgeUIAttributes: {}
    });
}
const $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, client: client, commonAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const commonAttributes = t2;
    let t3;
    if ($[2] !== client || $[3] !== commonAttributes) {
        t3 = (event)=>{
            const { eventType: eventType, data: data } = event.payload;
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
            const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
            const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? "unknown";
            const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
            let parentExtensionKey = {};
            if (action === "rendered" && actionSubject === "forge.ui.renderer" && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) parentExtensionKey = {
                parentExtensionKey: overriddenExtensionKey
            };
            else if (action === "rendered" && actionSubject === "forge.ui.bodied_macro_embedded_content" && attributes?.extensionKey && forgeUIAttributes.extensionKey) parentExtensionKey = {
                parentExtensionKey: forgeUIAttributes.extensionKey
            };
            const nestingAnalyticsAttributes = {
                ...forgeUIAttributes,
                ...parentExtensionKey
            };
            const payload = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                ...forgeUIAnalyticsContext,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...nestingAnalyticsAttributes,
                    ...attributes
                },
                tags: tags
            };
            $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
                eventType: eventType,
                ...payload
            });
        };
        $[2] = client;
        $[3] = commonAttributes;
        $[4] = t3;
    } else t3 = $[4];
    const listenerHandler = t3;
    let t4;
    if ($[5] !== children || $[6] !== listenerHandler) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            onEvent: listenerHandler,
            channel: $a3a18abb8f8abee5$export$d28801614368e543
        }, children);
        $[5] = children;
        $[6] = listenerHandler;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        // Use the merged nested context attributes and add parentExtensionKey for embedded macro
        // events that override extensionKey.
        const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
        let parentExtensionKey = {};
        if (action === 'rendered' && actionSubject === 'forge.ui.renderer' && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) // Child Forge renderer contexts replace extensionKey with the child macro key, so the
        // parent key is the previous extensionKey captured during context merging.
        parentExtensionKey = {
            parentExtensionKey: overriddenExtensionKey
        };
        else if (action === 'rendered' && actionSubject === 'forge.ui.bodied_macro_embedded_content' && attributes?.extensionKey && forgeUIAttributes.extensionKey) // Embedded macro events carry the child macro key on the event attributes, while the
        // surrounding context still carries the parent macro extensionKey.
        parentExtensionKey = {
            parentExtensionKey: forgeUIAttributes.extensionKey
        };
        const nestingAnalyticsAttributes = {
            ...forgeUIAttributes,
            ...parentExtensionKey
        };
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...nestingAnalyticsAttributes,
                ...attributes
            },
            tags: tags
        };
        $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: listenerHandler,
        channel: $a3a18abb8f8abee5$export$d28801614368e543
    }, children);
};
var $a3a18abb8f8abee5$export$2e2bcd8739ae039 = $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener;
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $a3a18abb8f8abee5$export$d28801614368e543;
module.exports["sendEvent"] = $a3a18abb8f8abee5$export$7329bcdc3edcd90e;
module.exports["default"] = $a3a18abb8f8abee5$export$2e2bcd8739ae039;

});

parcelRegister("DIyeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $6ojvx = parcelRequire("6ojvx");

const $5577a309d6f3499e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $cozmU.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $5577a309d6f3499e$export$163ecee29aa3a8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { value: value, children: children } = t0;
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    let t1;
    let t2;
    if ($[0] !== envFromContext || $[1] !== environment || $[2] !== page || $[3] !== product) {
        t1 = ()=>({
                environment: environment ?? envFromContext,
                product: product,
                page: page
            });
        t2 = [
            page,
            environment,
            envFromContext,
            product
        ];
        $[0] = envFromContext;
        $[1] = environment;
        $[2] = page;
        $[3] = product;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    const memoedValue = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== memoedValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
            value: memoedValue
        }, children);
        $[6] = children;
        $[7] = memoedValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ value: value, children: children })=>{
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $5xQdV.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $5577a309d6f3499e$export$dba2dab0d0f39612 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
} : ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $5577a309d6f3499e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $5577a309d6f3499e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $5577a309d6f3499e$export$dba2dab0d0f39612;

});

parcelRegister("iGKcz", function(module, exports) {
// our service
const $fa265340e5382bcc$var$SERVICE = 'forge-ui';
const $fa265340e5382bcc$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $fa265340e5382bcc$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $fa265340e5382bcc$export$14ef296862e3705e;

});

parcelRegister("2rD5H", function(module, exports) {

var $iLX84 = parcelRequire("iLX84");


var $iDrrr = parcelRequire("iDrrr");

const $2571750a7eec7dec$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2571750a7eec7dec$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          remoteInstallationRegion
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					sandboxPolicies
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        remoteInstallationRegion
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				sandboxPolicies
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$54ff27488d768aba = (0, $iLX84.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}sandboxPolicies scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId remoteInstallationRegion hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2571750a7eec7dec$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2571750a7eec7dec$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2571750a7eec7dec$export$54ff27488d768aba;

});

parcelRegister("hzmpb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gGKeL = parcelRequire("gGKeL");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $4o0zT = parcelRequire("4o0zT");


var $4K6lC = parcelRequire("4K6lC");


var $DIyeF = parcelRequire("DIyeF");


var $iGKcz = parcelRequire("iGKcz");


var $ix7El = parcelRequire("ix7El");


var $2rD5H = parcelRequire("2rD5H");


var $jGizm = parcelRequire("jGizm");

const $c7be4ab3ad813948$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)([
                    ...contextIds
                ].sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $c7be4ab3ad813948$export$88e0391b02a3c5c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions } = t0;
    let t1;
    if ($[0] !== client || $[1] !== cloudId || $[2] !== context || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions || $[6] !== types) {
        t1 = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
        $[0] = client;
        $[1] = cloudId;
        $[2] = context;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const requestOptions = t1;
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    let t2;
    if ($[8] !== data || $[9] !== loading) {
        t2 = $c7be4ab3ad813948$export$55348c7eb6377fe1({
            loading: loading,
            data: data
        });
        $[8] = data;
        $[9] = loading;
        $[10] = t2;
    } else t2 = $[10];
    const extensions = t2;
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== extensions || $[13] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[11] = createAnalyticsEvent;
        $[12] = extensions;
        $[13] = page;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== createAnalyticsEvent || $[17] !== error || $[18] !== extensions || $[19] !== page) {
        t5 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($c7be4ab3ad813948$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "usePrefilteredExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = error;
        $[18] = extensions;
        $[19] = page;
        $[20] = t5;
        $[21] = t6;
    } else {
        t5 = $[20];
        t6 = $[21];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[22] !== extensions) {
        t7 = extensions || [];
        $[22] = extensions;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== error || $[25] !== loading || $[26] !== t7) {
        t8 = {
            error: error,
            extensions: t7,
            loading: loading
        };
        $[24] = error;
        $[25] = loading;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $c7be4ab3ad813948$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $c7be4ab3ad813948$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
const $c7be4ab3ad813948$var$fetchRequests = new Map();
const $c7be4ab3ad813948$export$f55e1916fecb1860 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, queryOptions: queryOptions } = t0;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== cloudId || $[1] !== context || $[2] !== environment || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions?.skip || $[6] !== types) {
        t1 = ()=>{
            if (queryOptions?.skip && types.includes("confluence:pageBanner") && (0, $4o0zT.isExperimentEnabled)("confluence_ssr_forge_page_banner")) return;
            const cacheKey = JSON.stringify({
                cloudId: cloudId,
                context: context,
                includeHidden: includeHidden,
                locale: locale,
                types: types
            });
            if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
                const extensions_0 = new Promise((resolve, reject)=>{
                    (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                        cloudId: cloudId,
                        context: context,
                        includeHidden: includeHidden,
                        locale: locale,
                        types: types
                    }, {
                        networkCacheConfig: {
                            metadata: {
                                headers: {
                                    "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                                },
                                allowOnExternalPage: true
                            }
                        }
                    }).subscribe({
                        next: (data)=>{
                            resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                                data: data,
                                loading: false
                            }));
                        },
                        error: (error_0)=>{
                            $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                            reject(error_0);
                        }
                    });
                });
                $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
            }
            $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
                setExtensions(extensions_1);
                setLoading(false);
            }).catch((error_1)=>{
                setError(error_1);
                setLoading(false);
            });
        };
        $[0] = cloudId;
        $[1] = context;
        $[2] = environment;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions?.skip;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const t2 = queryOptions?.skip;
    let t3;
    if ($[8] !== cloudId || $[9] !== context || $[10] !== environment || $[11] !== includeHidden || $[12] !== locale || $[13] !== t2 || $[14] !== types) {
        t3 = [
            cloudId,
            context,
            includeHidden,
            locale,
            types,
            environment,
            t2
        ];
        $[8] = cloudId;
        $[9] = context;
        $[10] = environment;
        $[11] = includeHidden;
        $[12] = locale;
        $[13] = t2;
        $[14] = types;
        $[15] = t3;
    } else t3 = $[15];
    (0, $cozmU.useEffect)(t1, t3);
    let t4;
    let t5;
    if ($[16] !== createAnalyticsEvent || $[17] !== extensions || $[18] !== page) {
        t4 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t5 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = extensions;
        $[18] = page;
        $[19] = t4;
        $[20] = t5;
    } else {
        t4 = $[19];
        t5 = $[20];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[21] !== createAnalyticsEvent || $[22] !== error || $[23] !== extensions || $[24] !== page) {
        t6 = ()=>{
            if (!extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
                const err_0 = error.source.errors.find($c7be4ab3ad813948$var$_temp2);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t7 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[21] = createAnalyticsEvent;
        $[22] = error;
        $[23] = extensions;
        $[24] = page;
        $[25] = t6;
        $[26] = t7;
    } else {
        t6 = $[25];
        t7 = $[26];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[27] !== extensions) {
        t8 = extensions || [];
        $[27] = extensions;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== error || $[30] !== loading || $[31] !== t8) {
        t9 = {
            extensions: t8,
            loading: loading,
            error: error
        };
        $[29] = error;
        $[30] = loading;
        $[31] = t8;
        $[32] = t9;
    } else t9 = $[32];
    return t9;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, queryOptions: queryOptions })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (queryOptions?.skip && types.includes('confluence:pageBanner') && (0, $4o0zT.isExperimentEnabled)('confluence_ssr_forge_page_banner')) return;
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
            const extensions_0 = new Promise((resolve, reject)=>{
                (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error_0)=>{
                        $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                        reject(error_0);
                    }
                });
            });
            $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
        }
        $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
            setExtensions(extensions_1);
            setLoading(false);
        }).catch((error_1)=>{
            setError(error_1);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment,
        queryOptions?.skip
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
            const err_0 = error.source.errors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $c7be4ab3ad813948$var$_temp(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
function $c7be4ab3ad813948$var$_temp2(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $c7be4ab3ad813948$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $c7be4ab3ad813948$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $c7be4ab3ad813948$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $c7be4ab3ad813948$export$f55e1916fecb1860;

});

parcelRegister("gGKeL", function(module, exports) {
/**
 * @generated SignedSource<<7da5a0cc59e307e949d5c921ecd41a2b>>
 * @relayHash ae8c0df8b458c191f8dbdc3067c4d451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5629fcf1f358b362aa590d439d2c0b3b1226aeff22ab5c3341f879647bc9d2c
const $57d2af88a889106f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "sandboxPolicies"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "remoteInstallationRegion"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "f5629fcf1f358b362aa590d439d2c0b3b1226aeff22ab5c3341f879647bc9d2c",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$57d2af88a889106f$var$node.hash = "9988fba56919e313afdb928b7bdb852d";
var $57d2af88a889106f$export$2e2bcd8739ae039 = $57d2af88a889106f$var$node;
module.exports["default"] = $57d2af88a889106f$export$2e2bcd8739ae039;

});

parcelRegister("bLswh", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
parcelRequire("9iaDP");
var $hBxDy = parcelRequire("hBxDy");

parcelRequire("gwrSD");
var $hcYP2 = parcelRequire("hcYP2");
var $31kME = parcelRequire("31kME");
var $d8yi8 = parcelRequire("d8yi8");


});

parcelRegister("9iaDP", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);

var $2y56N = parcelRequire("2y56N");


var $hBxDy = parcelRequire("hBxDy");


var $iztBQ = parcelRequire("iztBQ");


var $2zscg = parcelRequire("2zscg");


});

parcelRegister("2y56N", function(module, exports) {
const $43f88a3108220757$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $43f88a3108220757$export$3ee8c58bb87b9685 = [
    ...$43f88a3108220757$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("iztBQ", function(module, exports) {
const $6db1db68019c99c9$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("gwrSD", function(module, exports) {

var $d8yi8 = parcelRequire("d8yi8");


var $31kME = parcelRequire("31kME");


var $hcYP2 = parcelRequire("hcYP2");


});

parcelRegister("d8yi8", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $487f0b3478e8e725$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $487f0b3478e8e725$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $487f0b3478e8e725$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $487f0b3478e8e725$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $487f0b3478e8e725$export$20b9f6acb0888554(effect) {
    return $487f0b3478e8e725$export$7e816460364ed464(effect) || $487f0b3478e8e725$export$eb5bd7f371e458af(effect) || $487f0b3478e8e725$export$f632ad3064955f31(effect);
}

});

parcelRegister("31kME", function(module, exports) {
const $7d3783c6a9539d7e$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $7d3783c6a9539d7e$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $7d3783c6a9539d7e$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $7d3783c6a9539d7e$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $7d3783c6a9539d7e$export$caa8cab0db5b0a61(effect) {
    return $7d3783c6a9539d7e$export$65d7078e01574f24(effect) || $7d3783c6a9539d7e$export$709a27a9f80556b8(effect) || $7d3783c6a9539d7e$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("hcYP2", function(module, exports) {
// From forge.ts
const $1da5394af23f0a63$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $1da5394af23f0a63$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $1da5394af23f0a63$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $1da5394af23f0a63$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $1da5394af23f0a63$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $1da5394af23f0a63$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $1da5394af23f0a63$export$881df9824c17587a = (extensionContext)=>extensionContext.type === 'confluence:attachmentAction';
const $1da5394af23f0a63$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $1da5394af23f0a63$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $1da5394af23f0a63$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $1da5394af23f0a63$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $1da5394af23f0a63$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("4ewzf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4K6lC = parcelRequire("4K6lC");


var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");

const $4d5d83f604ebdb2f$export$64f0f7e9be5f8ff = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children } = t0;
    let t1;
    if ($[0] !== page || $[1] !== product) {
        t1 = {
            product: product,
            page: page
        };
        $[0] = page;
        $[1] = product;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== page) {
        t2 = {
            moduleType: page
        };
        $[3] = page;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== analyticsWebClient || $[6] !== children || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K6lC.default), {
            client: analyticsWebClient,
            commonAttributes: t2
        }, children);
        $[5] = analyticsWebClient;
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $DIyeF.MetricsContextProvider), {
            value: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== environment || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ojvx.EnvironmentContext).Provider, {
            value: environment
        }, t4);
        $[12] = environment;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ojvx.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $DIyeF.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K6lC.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $4d5d83f604ebdb2f$export$64f0f7e9be5f8ff;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fbwmZ = parcelRequire("fbwmZ");


var $bAWmc = parcelRequire("bAWmc");


$fbwmZ.__exportStar((parcelRequire("5ixmT")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $6b362a72760d8152$var$InvalidAriError extends Error {
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ static withConstraintViolations(ariString, violations) {
        return new $6b362a72760d8152$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $6b362a72760d8152$var$InvalidAriError.prototype);
    }
}
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $6b362a72760d8152$var$resourceTypeCharConstraints = $bAWmc.pattern(/^[a-z][a-z.-]*$/i);
const $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
const $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$resourceTypeCharConstraints
];
const $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(3, 255)
];
const $6b362a72760d8152$var$siteResourceType = 'site';
const $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
const $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp(`^${$6b362a72760d8152$var$resourceIdChars}+(/${$6b362a72760d8152$var$resourceIdChars}*)*(;v=${$6b362a72760d8152$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $6b362a72760d8152$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $6b362a72760d8152$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ static parse(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new $6b362a72760d8152$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
   * Converts this Ari to a string.
   */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
   * Converts this object to its json representation
   */ toJSON() {
        return this.toString();
    }
    /**
   * Checks if this context is the same as another context
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
   */ equals(other) {
        return other instanceof $6b362a72760d8152$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
   * This method checks if the current context contains the other context.
   *
   * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
   * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
   *
   * @param {Ari} other
   * @returns {boolean}
   */ contains(other) {
        return this.matches(new $6b362a72760d8152$var$ResourceIdentifier(other));
    }
    /**
   * Checks if this context is the same as or contains the provided context.
   *
   * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
   *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
   *
   * e.g.
   * ```
   * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
   * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
   */ matches(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $6b362a72760d8152$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
}
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gkGWr = parcelRequire("gkGWr");

class $871053056dfd3da9$var$LengthConstraint {
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
}
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
class $871053056dfd3da9$var$RegexConstraint {
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
    constructor(regex){
        this.regex = regex;
    }
}
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
class $871053056dfd3da9$var$GeneralValidationError {
    toString() {
        return this.error;
    }
    constructor(error){
        this.error = error;
    }
}
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
class $871053056dfd3da9$var$ConstraintViolation {
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
}
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($gkGWr.isDefined);
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("gkGWr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $be3fd2ee1b486656$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $be3fd2ee1b486656$var$isPresent;
function $be3fd2ee1b486656$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $be3fd2ee1b486656$var$isDefined;
function $be3fd2ee1b486656$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $be3fd2ee1b486656$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $be3fd2ee1b486656$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $be3fd2ee1b486656$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $be3fd2ee1b486656$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $be3fd2ee1b486656$var$hasValueAtKey; //# sourceMappingURL=index.js.map

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $3db8846e4ba8de9f$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
class $3db8846e4ba8de9f$var$NotAppFamilyAriError extends $3db8846e4ba8de9f$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
class $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError extends $3db8846e4ba8de9f$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");


var $bAWmc = parcelRequire("bAWmc");

const $0d5dd8c916c95343$var$versionPrefix = ';v=';
const $0d5dd8c916c95343$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $0d5dd8c916c95343$var$uuidConstraints = [
    $bAWmc.pattern(new RegExp(`^${$0d5dd8c916c95343$var$uuidRegExpString}$`, 'i'))
];
const $0d5dd8c916c95343$var$extensionGroupIdConstraints = [
    $bAWmc.pattern(new RegExp(`^(${$0d5dd8c916c95343$var$uuidRegExpString}|static)$`, 'i'))
];
class $0d5dd8c916c95343$var$AppFamilyAriImpl {
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$5ixmT.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, `resourceType must be one of ${$5ixmT.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($0d5dd8c916c95343$var$versionPrefix);
        const segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$5ixmT.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$5ixmT.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$5ixmT.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$5ixmT.AppFamilyAri.environmentResourceType}`);
        return new $0d5dd8c916c95343$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $bAWmc.validateField(this, 'environmentId', $0d5dd8c916c95343$var$uuidConstraints),
            $bAWmc.validateField(this, 'appId', $0d5dd8c916c95343$var$uuidConstraints),
            $bAWmc.validateField(this, 'extensionGroupId', $0d5dd8c916c95343$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $9cGsb.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$0d5dd8c916c95343$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
    constructor(json){
        this.json = json;
        this.validate();
    }
}
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("2qJQZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $4hmAW = parcelRequire("4hmAW");

const $f3e0d6c6400f29a4$var$PageObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $f3e0d6c6400f29a4$export$2e2bcd8739ae039 = $f3e0d6c6400f29a4$var$PageObject;
module.exports["default"] = $f3e0d6c6400f29a4$export$2e2bcd8739ae039;

});

parcelRegister("8BldL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f1df1ad831df9f5a$export$6107f09ca09b8b5f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    embeddedParentModalKey: undefined,
    setEmbeddedParentModalKey: ()=>{},
    forwarder: ()=>Promise.resolve()
});
module.exports["EmbeddedModalContext"] = $f1df1ad831df9f5a$export$6107f09ca09b8b5f;

});

parcelRegister("eLuPt", function(module, exports) {
/* ForgeErrorBoundary.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $1VhsF = parcelRequire("1VhsF");


var $4K6lC = parcelRequire("4K6lC");


var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");


var $h48r4 = parcelRequire("h48r4");


var $k26hW = parcelRequire("k26hW");

function $b57f2c4814ca99d9$var$_defineProperty(e, r, t) {
    return (r = $b57f2c4814ca99d9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b57f2c4814ca99d9$var$_toPropertyKey(t) {
    var i = $b57f2c4814ca99d9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b57f2c4814ca99d9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $b57f2c4814ca99d9$var$ForgeErrorBoundary extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
        const { page: page } = this.props;
        const environment = this.props.environment;
        (0, $h48r4.captureAndReportError)({
            error: error,
            errorExtensionDetails: this.props.extension ? {
                type: this.props.extension.type,
                environmentType: this.props.extension.environmentType,
                appOwnerAccountId: this.props.extension.appOwner?.accountId,
                properties: this.props.extension.properties,
                id: this.props.extension?.id
            } : undefined,
            errorInfo: errorInfo,
            page: page,
            environment: environment
        });
        if (!(error instanceof (0, $k26hW.APIError))) this.props.createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "ForgeErrorBoundary"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "error",
            title: "Error rendering app"
        }, thrownError.error.message));
    }
    constructor(...args){
        super(...args);
        $b57f2c4814ca99d9$var$_defineProperty(this, "state", {
            thrownError: undefined
        });
    }
}
const $b57f2c4814ca99d9$var$withAnalyticsContext = (Component)=>({ extension: extension, children: children })=>{
        const { page: page, environment: envFromContext } = (0, $DIyeF.useMetricsContext)();
        const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
        return /*#__PURE__*/ $cozmU.createElement(Component, {
            environment: envFromContext ?? environment,
            extension: extension,
            page: page,
            createAnalyticsEvent: createAnalyticsEvent
        }, children);
    };
const $b57f2c4814ca99d9$var$_default_1 = $b57f2c4814ca99d9$var$withAnalyticsContext($b57f2c4814ca99d9$var$ForgeErrorBoundary);
var $b57f2c4814ca99d9$export$2e2bcd8739ae039 = $b57f2c4814ca99d9$var$_default_1;
module.exports["default"] = $b57f2c4814ca99d9$export$2e2bcd8739ae039;

});

parcelRegister("k26hW", function(module, exports) {
class $0e4aafd74f221aa2$export$3e5b797e39668f84 extends Error {
    constructor(message){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $0e4aafd74f221aa2$export$3e5b797e39668f84.prototype);
    }
}
module.exports["APIError"] = $0e4aafd74f221aa2$export$3e5b797e39668f84;

});

parcelRegister("bdpeX", function(module, exports) {

var $54Kws = parcelRequire("54Kws");

class $88516670672fc955$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $54Kws.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $88516670672fc955$export$2e2bcd8739ae039;

});

parcelRegister("54Kws", function(module, exports) {
async function $4782fc034cf1736f$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
module.exports["getAutoConvertPatternsFromModule"] = $4782fc034cf1736f$export$60407594ea5edd1c;

});

parcelRegister("fuSOM", function(module, exports) {
parcelRequire("eRn3r");
var $9aUDG = parcelRequire("9aUDG");


var $lA6N5 = parcelRequire("lA6N5");


const $cb5189150b488f78$var$LazyLinkPickerComponent = (0, $9aUDG.lazyForPaint)(()=>(parcelRequire("40bvE")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $cb5189150b488f78$var$_default_1 = (0, $lA6N5.composeLinkPicker)($cb5189150b488f78$var$LazyLinkPickerComponent);
var $cb5189150b488f78$export$2e2bcd8739ae039 = $cb5189150b488f78$var$_default_1;
module.exports["default"] = $cb5189150b488f78$export$2e2bcd8739ae039;

});

parcelRegister("lA6N5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

parcelRequire("eRn3r");
var $3QYdZ = parcelRequire("3QYdZ");


var $gBjHb = parcelRequire("gBjHb");


var $kJo8F = parcelRequire("kJo8F");


var $eg7eG = parcelRequire("eg7eG");


var $fCO8c = parcelRequire("fCO8c");


var $k5YvC = parcelRequire("k5YvC");


var $lg1Gp = parcelRequire("lg1Gp");

const $12f35d08bde2472f$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $12f35d08bde2472f$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $kJo8F.COMPONENT_NAME),
    source: (0, $kJo8F.COMPONENT_NAME)
};
const $12f35d08bde2472f$var$DefaultRootComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $12f35d08bde2472f$var$fixedWidthContainerStyles = null;
const $12f35d08bde2472f$var$FixedWidthContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02oEu0"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02oEu0"
        ])
    });
};
const $12f35d08bde2472f$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $12f35d08bde2472f$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: $12f35d08bde2472f$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg7eG.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lg1Gp.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $kJo8F.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12f35d08bde2472f$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCO8c.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3QYdZ.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5YvC.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RootComponent, {
            ...props,
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $12f35d08bde2472f$export$922eb685ceb4a294;

});

parcelRegister("kJo8F", function(module, exports) {
const $001c95c8c9eb30f1$export$85183a312807388d = 'media';
const $001c95c8c9eb30f1$export$fc44104665f4d1e5 = 'linkPicker';
const $001c95c8c9eb30f1$export$452f1062ecf44be7 = 5;
const $001c95c8c9eb30f1$export$bf31a09f182d5584 = 342;
const $001c95c8c9eb30f1$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $001c95c8c9eb30f1$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $001c95c8c9eb30f1$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $001c95c8c9eb30f1$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $001c95c8c9eb30f1$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $001c95c8c9eb30f1$export$542fb16962bf430c;

});

parcelRegister("eg7eG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $gt5Em = parcelRequire("gt5Em");

const $c7635a085ba363f5$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $c7635a085ba363f5$export$3285420c698bc605 = /*#__PURE__*/ (0, $cozmU.createContext)($c7635a085ba363f5$export$c07727f5eddb98f);
const $c7635a085ba363f5$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $cozmU.useRef)((0, $03RpJ.default)());
    (0, $cozmU.useEffect)(()=>{
        (0, $gt5Em.startUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
        return ()=>(0, $gt5Em.abortUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7635a085ba363f5$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $c7635a085ba363f5$export$36ecc935abdc3636 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
} : ()=>(0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $c7635a085ba363f5$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $c7635a085ba363f5$export$36ecc935abdc3636;

});

parcelRegister("gt5Em", function(module, exports) {

var $fh15z = parcelRequire("fh15z");


var $4MiWC = parcelRequire("4MiWC");

const $64cb77453c568c86$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $64cb77453c568c86$var$ufoExperiences = {
    [$64cb77453c568c86$export$f9c7780c574346a2.mounted]: new (0, $fh15z.ConcurrentExperience)($64cb77453c568c86$export$f9c7780c574346a2.mounted, {
        type: (0, $4MiWC.ExperienceTypes).Load,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $64cb77453c568c86$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $64cb77453c568c86$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $64cb77453c568c86$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $64cb77453c568c86$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $64cb77453c568c86$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $64cb77453c568c86$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $64cb77453c568c86$export$b1021040eb94cdca;

});

parcelRegister("fCO8c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gt5Em = parcelRequire("gt5Em");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $eg7eG = parcelRequire("eg7eG");


var $aRBFH = parcelRequire("aRBFH");


var $f3GZb = parcelRequire("f3GZb");

const $96adf85769963d68$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $779pE.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    const handleError = (0, $cozmU.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $779pE.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $96adf85769963d68$export$e926676385687eaf;

});

parcelRegister("779pE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8ad800c149f887c26cf6e1c701c20ed0>>
 * @codegenCommand afm workspace @atlaskit/link-picker codegen-analytics
 */ function $eafc2c5357085519$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $eafc2c5357085519$export$2e2bcd8739ae039 = $eafc2c5357085519$var$createEventPayload;
module.exports["default"] = $eafc2c5357085519$export$2e2bcd8739ae039;

});

parcelRegister("aRBFH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $baa71a56a1d588bd$export$688779ac61ee945f extends (0, $cozmU.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $baa71a56a1d588bd$export$688779ac61ee945f;

});

parcelRegister("f3GZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kJo8F = parcelRequire("kJo8F");


var $bXDzR = parcelRequire("bXDzR");


var $k3ncb = parcelRequire("k3ncb");


var $dOXsL = parcelRequire("dOXsL");

const $66e5302c045c6e9e$var$errorBoundaryFallbackStyles = null;
const $66e5302c045c6e9e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $66e5302c045c6e9e$export$8a28b7e38e4685dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
            header: header,
            renderImage: $66e5302c045c6e9e$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const header = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
    const description = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null),
        description: description
    }));
};
function $66e5302c045c6e9e$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $66e5302c045c6e9e$export$8a28b7e38e4685dd;

});

parcelRegister("bXDzR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $efcb4a3aca6e9417$var$SIZE = 96;
const $efcb4a3aca6e9417$var$genericErrorStyles = null;
const $efcb4a3aca6e9417$export$e54420a1a27457a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ]);
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $efcb4a3aca6e9417$export$e54420a1a27457a4;

});

parcelRegister("k3ncb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");

const $abc7c062eda24665$var$styles = {
    containerV2: "_0Of8r2NHnM _1Znuxbp0Oa _2Zuz6Qp0Oa _1wydGWS40j _2fwxA5DIqT",
    whiteSpaceNormal: "_1ANEUSzUZr"
};
const $abc7c062eda24665$export$fddf379e22a74b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, $abc7c062eda24665$var$styles.whiteSpaceNormal);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== renderImage) {
        t2 = renderImage?.();
        $[1] = renderImage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, header);
        $[3] = header;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== description) {
        t4 = description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p",
            color: "color.text"
        }, description);
        $[5] = description;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = action && action;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: t1,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, $abc7c062eda24665$var$styles.whiteSpaceNormal),
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $abc7c062eda24665$export$fddf379e22a74b00;

});

parcelRegister("dOXsL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $1bc658963d2888d5$var$minHeightComponentStyles = null;
const $1bc658963d2888d5$export$42134e2a251518b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLFlnN _37wbyuDIqT _4kiQYAjtAN",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $1bc658963d2888d5$export$42134e2a251518b3;

});

parcelRegister("k5YvC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $dOXsL = parcelRequire("dOXsL");

const $9e6da8c9bb613998$var$styles = null;
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $9e6da8c9bb613998$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $9e6da8c9bb613998$export$d96e921133238c41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $9e6da8c9bb613998$export$d96e921133238c41;

});

parcelRegister("lg1Gp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Vh5j9 = parcelRequire("Vh5j9");

const $f169ae6f19f5b49d$export$54320b51a950d54a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $f169ae6f19f5b49d$export$54320b51a950d54a;

});

parcelRegister("Vh5j9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $935R1 = parcelRequire("935R1");


var $2H5my = parcelRequire("2H5my");

const $550b5e1058020e28$export$d013d33430f9fb4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: (0, $935R1.default),
            loaderFn: (0, $2H5my.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $935R1.default),
        loaderFn: (0, $2H5my.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $550b5e1058020e28$export$d013d33430f9fb4b;

});

parcelRegister("2H5my", function(module, exports) {

var $b3upr = parcelRequire("b3upr");

const $d0c1d8c70ea117ba$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $d0c1d8c70ea117ba$export$2b153a2030b0feb2;

});

parcelRegister("b3upr", function(module, exports) {

























const $f5a6a4ca12953b28$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("cocSb")),
    da: ()=>(parcelRequire("8hHUq")),
    de: ()=>(parcelRequire("6xY5a")),
    en_GB: ()=>(parcelRequire("9S69a")),
    en_ZZ: ()=>(parcelRequire("7p3RA")),
    en: ()=>Promise.resolve((parcelRequire("935R1"))),
    es: ()=>(parcelRequire("1ijPU")),
    fi: ()=>(parcelRequire("hgktU")),
    fr: ()=>(parcelRequire("2X88N")),
    hu: ()=>(parcelRequire("gVpg0")),
    it: ()=>(parcelRequire("iDF1E")),
    ja: ()=>(parcelRequire("94sol")),
    ko: ()=>(parcelRequire("kaacA")),
    nb: ()=>(parcelRequire("6fz2I")),
    nl: ()=>(parcelRequire("jA2SL")),
    pl: ()=>(parcelRequire("hzJqW")),
    pt_BR: ()=>(parcelRequire("hoKfB")),
    ru: ()=>(parcelRequire("imEOn")),
    sv: ()=>(parcelRequire("cGIqm")),
    th: ()=>(parcelRequire("5e2PY")),
    tr: ()=>(parcelRequire("11CPA")),
    uk: ()=>(parcelRequire("hRtvo")),
    vi: ()=>(parcelRequire("9PM3y")),
    zh_TW: ()=>(parcelRequire("5ZmT8")),
    zh: ()=>(parcelRequire("iDdpg"))
};
module.exports["locales"] = $f5a6a4ca12953b28$export$df1c34db1371eeed;

});

parcelRegister("cocSb", function(module, exports) {

let $9051b633a19cf27b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9051b633a19cf27b$var$load("1JYrd"),
    $9051b633a19cf27b$var$load("cip6w"),
    $9051b633a19cf27b$var$load("gAG2n"),
    $9051b633a19cf27b$var$load("3feYV"),
    $9051b633a19cf27b$var$load("cwjU2"),
    $9051b633a19cf27b$var$load("7rL7C"),
    $9051b633a19cf27b$var$load("3Ff1R"),
    $9051b633a19cf27b$var$load("423Ga")
]).then(()=>parcelRequire('ksVtB'));

});

parcelRegister("8hHUq", function(module, exports) {

let $6081f8b0ed39508c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6081f8b0ed39508c$var$load("30242"),
    $6081f8b0ed39508c$var$load("3qBwQ"),
    $6081f8b0ed39508c$var$load("cYGDU"),
    $6081f8b0ed39508c$var$load("7Q1SM"),
    $6081f8b0ed39508c$var$load("33Iaa"),
    $6081f8b0ed39508c$var$load("1RSxn"),
    $6081f8b0ed39508c$var$load("blA7x"),
    $6081f8b0ed39508c$var$load("gJroP")
]).then(()=>parcelRequire('1VdaT'));

});

parcelRegister("6xY5a", function(module, exports) {

let $4c446e418128a786$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4c446e418128a786$var$load("15aAJ"),
    $4c446e418128a786$var$load("8rREG"),
    $4c446e418128a786$var$load("dgXJL"),
    $4c446e418128a786$var$load("7JdzX"),
    $4c446e418128a786$var$load("6681T"),
    $4c446e418128a786$var$load("ghT31"),
    $4c446e418128a786$var$load("3dn3H"),
    $4c446e418128a786$var$load("cYXvt")
]).then(()=>parcelRequire('h2ceo'));

});

parcelRegister("9S69a", function(module, exports) {

let $72fdecd9dd738c1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $72fdecd9dd738c1c$var$load("l5BBd"),
    $72fdecd9dd738c1c$var$load("93ASN"),
    $72fdecd9dd738c1c$var$load("htu5t"),
    $72fdecd9dd738c1c$var$load("24LNf"),
    $72fdecd9dd738c1c$var$load("lM2G0"),
    $72fdecd9dd738c1c$var$load("iYQCc"),
    $72fdecd9dd738c1c$var$load("nBJth")
]).then(()=>parcelRequire('6VGGT'));

});

parcelRegister("7p3RA", function(module, exports) {

let $563ddd59fb0fa745$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $563ddd59fb0fa745$var$load("bbv9t"),
    $563ddd59fb0fa745$var$load("9fQoJ"),
    $563ddd59fb0fa745$var$load("lTboH"),
    $563ddd59fb0fa745$var$load("cnlNg"),
    $563ddd59fb0fa745$var$load("d3Phe"),
    $563ddd59fb0fa745$var$load("lTP5S"),
    $563ddd59fb0fa745$var$load("lASLx"),
    $563ddd59fb0fa745$var$load("bIXgz")
]).then(()=>parcelRequire('glan9'));

});

parcelRegister("1ijPU", function(module, exports) {

let $0f16dbf23003f2e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0f16dbf23003f2e3$var$load("7p4je"),
    $0f16dbf23003f2e3$var$load("8SZbD"),
    $0f16dbf23003f2e3$var$load("iE05k"),
    $0f16dbf23003f2e3$var$load("9Uf61"),
    $0f16dbf23003f2e3$var$load("3Yk1e"),
    $0f16dbf23003f2e3$var$load("jZqyp"),
    $0f16dbf23003f2e3$var$load("5lJyy"),
    $0f16dbf23003f2e3$var$load("9w9df")
]).then(()=>parcelRequire('jIUdy'));

});

parcelRegister("hgktU", function(module, exports) {

let $c913d17b53ae571b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c913d17b53ae571b$var$load("1jQRQ"),
    $c913d17b53ae571b$var$load("5pOQA"),
    $c913d17b53ae571b$var$load("5GSny"),
    $c913d17b53ae571b$var$load("fJSEb"),
    $c913d17b53ae571b$var$load("ajzkj"),
    $c913d17b53ae571b$var$load("kIcDP"),
    $c913d17b53ae571b$var$load("eyysG"),
    $c913d17b53ae571b$var$load("27gvR")
]).then(()=>parcelRequire('j6sWj'));

});

parcelRegister("2X88N", function(module, exports) {

let $2267680e8ed7bae6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2267680e8ed7bae6$var$load("km37l"),
    $2267680e8ed7bae6$var$load("gbksI"),
    $2267680e8ed7bae6$var$load("j2X7f"),
    $2267680e8ed7bae6$var$load("9TeWr"),
    $2267680e8ed7bae6$var$load("kUZ7k"),
    $2267680e8ed7bae6$var$load("8e8NT"),
    $2267680e8ed7bae6$var$load("dJQL7"),
    $2267680e8ed7bae6$var$load("czj6d")
]).then(()=>parcelRequire('6POS4'));

});

parcelRegister("gVpg0", function(module, exports) {

let $c5258fc18afd6137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c5258fc18afd6137$var$load("lTbXI"),
    $c5258fc18afd6137$var$load("a98cw"),
    $c5258fc18afd6137$var$load("e40mE"),
    $c5258fc18afd6137$var$load("fOGnR"),
    $c5258fc18afd6137$var$load("cDQOq"),
    $c5258fc18afd6137$var$load("gznax"),
    $c5258fc18afd6137$var$load("8upye"),
    $c5258fc18afd6137$var$load("GlmUM")
]).then(()=>parcelRequire('5BZIn'));

});

parcelRegister("iDF1E", function(module, exports) {

let $038072583318b171$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $038072583318b171$var$load("iUyZj"),
    $038072583318b171$var$load("4PDaO"),
    $038072583318b171$var$load("lMhbw"),
    $038072583318b171$var$load("8nEeY"),
    $038072583318b171$var$load("kLZKK"),
    $038072583318b171$var$load("2gIpG"),
    $038072583318b171$var$load("c7GMc"),
    $038072583318b171$var$load("bnhJ1")
]).then(()=>parcelRequire('dkwKE'));

});

parcelRegister("94sol", function(module, exports) {

let $69aa82c635856cdf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $69aa82c635856cdf$var$load("kPlMQ"),
    $69aa82c635856cdf$var$load("ervs7"),
    $69aa82c635856cdf$var$load("8CX31"),
    $69aa82c635856cdf$var$load("fzzMQ"),
    $69aa82c635856cdf$var$load("33S6H"),
    $69aa82c635856cdf$var$load("iZiNp"),
    $69aa82c635856cdf$var$load("kFae4"),
    $69aa82c635856cdf$var$load("iZWpE")
]).then(()=>parcelRequire('4VLhA'));

});

parcelRegister("kaacA", function(module, exports) {

let $eadca7b8b0c7e43e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eadca7b8b0c7e43e$var$load("iT2sv"),
    $eadca7b8b0c7e43e$var$load("iMMtn"),
    $eadca7b8b0c7e43e$var$load("23VWs"),
    $eadca7b8b0c7e43e$var$load("3gNEO"),
    $eadca7b8b0c7e43e$var$load("93obY"),
    $eadca7b8b0c7e43e$var$load("6Bgnb"),
    $eadca7b8b0c7e43e$var$load("6Y9jE"),
    $eadca7b8b0c7e43e$var$load("cUTaY")
]).then(()=>parcelRequire('gVcgA'));

});

parcelRegister("6fz2I", function(module, exports) {

let $48cf538efc08928f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $48cf538efc08928f$var$load("lyPpF"),
    $48cf538efc08928f$var$load("eX5n7"),
    $48cf538efc08928f$var$load("aiYuN"),
    $48cf538efc08928f$var$load("gvylW"),
    $48cf538efc08928f$var$load("bxfRe"),
    $48cf538efc08928f$var$load("43PKJ"),
    $48cf538efc08928f$var$load("ed6s8"),
    $48cf538efc08928f$var$load("lAuJd")
]).then(()=>parcelRequire('6B7wN'));

});

parcelRegister("jA2SL", function(module, exports) {

let $e4139d7ff7455fb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4139d7ff7455fb3$var$load("iN3cj"),
    $e4139d7ff7455fb3$var$load("3nHdy"),
    $e4139d7ff7455fb3$var$load("gDEvm"),
    $e4139d7ff7455fb3$var$load("80OLx"),
    $e4139d7ff7455fb3$var$load("1EVcg"),
    $e4139d7ff7455fb3$var$load("fqoiV"),
    $e4139d7ff7455fb3$var$load("96q1k"),
    $e4139d7ff7455fb3$var$load("XQtfV")
]).then(()=>parcelRequire('6e51k'));

});

parcelRegister("hzJqW", function(module, exports) {

let $ccb8f2b7f0b31592$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ccb8f2b7f0b31592$var$load("eC1OL"),
    $ccb8f2b7f0b31592$var$load("ilL9c"),
    $ccb8f2b7f0b31592$var$load("64nco"),
    $ccb8f2b7f0b31592$var$load("e4s0V"),
    $ccb8f2b7f0b31592$var$load("28EXy"),
    $ccb8f2b7f0b31592$var$load("dHzvE"),
    $ccb8f2b7f0b31592$var$load("7RZp5"),
    $ccb8f2b7f0b31592$var$load("leyTH")
]).then(()=>parcelRequire('guLr4'));

});

parcelRegister("hoKfB", function(module, exports) {

let $caa88dfb824256c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $caa88dfb824256c7$var$load("4NJ49"),
    $caa88dfb824256c7$var$load("bfOZL"),
    $caa88dfb824256c7$var$load("jLbRX"),
    $caa88dfb824256c7$var$load("4dPO1"),
    $caa88dfb824256c7$var$load("gg8tK"),
    $caa88dfb824256c7$var$load("1SbqQ"),
    $caa88dfb824256c7$var$load("eF54W"),
    $caa88dfb824256c7$var$load("3hnPt")
]).then(()=>parcelRequire('9NY5A'));

});

parcelRegister("imEOn", function(module, exports) {

let $d5e9f05f0f1966b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5e9f05f0f1966b0$var$load("g9gkE"),
    $d5e9f05f0f1966b0$var$load("jYdbS"),
    $d5e9f05f0f1966b0$var$load("6ncWv"),
    $d5e9f05f0f1966b0$var$load("ltrgi"),
    $d5e9f05f0f1966b0$var$load("fu25G"),
    $d5e9f05f0f1966b0$var$load("di9bz"),
    $d5e9f05f0f1966b0$var$load("iQGcz"),
    $d5e9f05f0f1966b0$var$load("ar4uw")
]).then(()=>parcelRequire('l7nLc'));

});

parcelRegister("cGIqm", function(module, exports) {

let $93cbddf8b86b3fc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $93cbddf8b86b3fc5$var$load("jhikU"),
    $93cbddf8b86b3fc5$var$load("f0i3H"),
    $93cbddf8b86b3fc5$var$load("bvBAp"),
    $93cbddf8b86b3fc5$var$load("69YlM"),
    $93cbddf8b86b3fc5$var$load("cyTsc"),
    $93cbddf8b86b3fc5$var$load("iL6r3"),
    $93cbddf8b86b3fc5$var$load("kXCsp"),
    $93cbddf8b86b3fc5$var$load("disCG")
]).then(()=>parcelRequire('ijDRq'));

});

parcelRegister("5e2PY", function(module, exports) {

let $3ce075fd9818b53d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ce075fd9818b53d$var$load("e2Idi").then(()=>parcelRequire('fC7VU'));

});

parcelRegister("11CPA", function(module, exports) {

let $0bf4017cfd787023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf4017cfd787023$var$load("3gdIo").then(()=>parcelRequire('4USSX'));

});

parcelRegister("hRtvo", function(module, exports) {

let $d00e46120947d0cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00e46120947d0cd$var$load("1uCJj").then(()=>parcelRequire('dWB8a'));

});

parcelRegister("9PM3y", function(module, exports) {

let $728e27781bf035cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728e27781bf035cb$var$load("crqMH").then(()=>parcelRequire('qL2MH'));

});

parcelRegister("5ZmT8", function(module, exports) {

let $45c4675def33c250$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45c4675def33c250$var$load("d91RK"),
    $45c4675def33c250$var$load("f7hfJ"),
    $45c4675def33c250$var$load("QI1kr"),
    $45c4675def33c250$var$load("brdRT"),
    $45c4675def33c250$var$load("lWBlc"),
    $45c4675def33c250$var$load("ZkI53"),
    $45c4675def33c250$var$load("s2EmI"),
    $45c4675def33c250$var$load("jc0YL")
]).then(()=>parcelRequire('ayAwo'));

});

parcelRegister("iDdpg", function(module, exports) {

let $d90644c3b275ca0d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d90644c3b275ca0d$var$load("708J7"),
    $d90644c3b275ca0d$var$load("kVqUf"),
    $d90644c3b275ca0d$var$load("2IMxh"),
    $d90644c3b275ca0d$var$load("j03Pa"),
    $d90644c3b275ca0d$var$load("kke1I"),
    $d90644c3b275ca0d$var$load("dJQNS"),
    $d90644c3b275ca0d$var$load("gOwMq"),
    $d90644c3b275ca0d$var$load("6GfaN")
]).then(()=>parcelRequire('3x4gn'));

});

parcelRegister("40bvE", function(module, exports) {

let $2ea0170d9d4f12e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2ea0170d9d4f12e8$var$load("7J1PC"),
    $2ea0170d9d4f12e8$var$load("446Ip"),
    $2ea0170d9d4f12e8$var$load("45r7q"),
    $2ea0170d9d4f12e8$var$load("6wr18"),
    $2ea0170d9d4f12e8$var$load("ffEVr"),
    $2ea0170d9d4f12e8$var$load("7EorR"),
    $2ea0170d9d4f12e8$var$load("9TOep"),
    $2ea0170d9d4f12e8$var$load("hhss7"),
    $2ea0170d9d4f12e8$var$load("gnocL")
]).then(()=>parcelRequire('8mHp9'));

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("dhtsm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32f92d4b4659c87427bca36d4cc14c22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ab3b6586bd7bdc0$var$_react = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ab3b6586bd7bdc0$var$_iconNew = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $9ab3b6586bd7bdc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/field-text
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ab3b6586bd7bdc0$var$FieldTextIcon = (props)=>/*#__PURE__*/ $9ab3b6586bd7bdc0$var$_react.default.createElement($9ab3b6586bd7bdc0$var$_iconNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$9ab3b6586bd7bdc0$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $9ab3b6586bd7bdc0$var$_default = module.exports.default = $9ab3b6586bd7bdc0$var$FieldTextIcon;

});

parcelRegister("gQEZd", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4414baec8e12e18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7D31j = parcelRequire("7D31j");


var $3yGK6 = parcelRequire("3yGK6");

function $c4414baec8e12e18$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $3yGK6.default)(1, arguments);
    var originalDate = (0, $dkBOe.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $7D31j.default)(originalDate.getDate(), 2);
        var month = (0, $7D31j.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $7D31j.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $7D31j.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $7D31j.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $7D31j.default)(originalDate.getHours(), 2);
        var minute = (0, $7D31j.default)(originalDate.getMinutes(), 2);
        var second = (0, $7D31j.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("i1agE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1e048e4b12a2678$var$_react = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d1e048e4b12a2678$var$_iconNew = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d1e048e4b12a2678$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1e048e4b12a2678$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $d1e048e4b12a2678$var$_react.default.createElement($d1e048e4b12a2678$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d1e048e4b12a2678$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $d1e048e4b12a2678$var$_default = module.exports.default = $d1e048e4b12a2678$var$WarningOutlineIcon;

});

parcelRegister("7JHs4", function(module, exports) {

var $7cOM2 = parcelRequire("7cOM2");

const $7a6b4c41eab74d34$export$4ed794c7d557e96c = (skillAri)=>(0, $7cOM2.RovoSkillAri).check(skillAri);
module.exports["isCustomSkill"] = $7a6b4c41eab74d34$export$4ed794c7d557e96c;

});

parcelRegister("7cOM2", function(module, exports) {

var $5Qmva = parcelRequire("5Qmva");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/rovo/skill/manifest.ts
var $53f10a0782e7c469$var$rovoSkillAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5Qmva.RovoSkillAriResourceOwner),
    resourceType: (0, $5Qmva.RovoSkillAriResourceType),
    resourceIdSlug: "activation/{activationId}/{skillId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        skillId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/rovo/skill/index.ts
var $53f10a0782e7c469$export$600deb9b76723b82 = class _RovoSkillAri extends (0, $9j37t.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get skillId() {
        return this._skillId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $53f10a0782e7c469$var$rovoSkillAriStaticOpts.qualifier,
            platformQualifier: $53f10a0782e7c469$var$rovoSkillAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $53f10a0782e7c469$var$rovoSkillAriStaticOpts.resourceOwner,
            resourceType: $53f10a0782e7c469$var$rovoSkillAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.skillId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                skillId: opts.skillId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $53f10a0782e7c469$var$rovoSkillAriStaticOpts);
        return new _RovoSkillAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $53f10a0782e7c469$var$rovoSkillAriStaticOpts);
        return new _RovoSkillAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            skillId: this.skillId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._skillId = opts.resourceIdSegmentValues.skillId;
    }
};
module.exports["RovoSkillAri"] = $53f10a0782e7c469$export$600deb9b76723b82;

});

parcelRegister("5Qmva", function(module, exports) {
// src/rovo/skill/types.ts
var $4413436cecb8e596$export$81cd1bc4e5b170fb = "rovo", $4413436cecb8e596$export$91ee5cc73270e65d = "skill";
module.exports["RovoSkillAriResourceOwner"] = $4413436cecb8e596$export$81cd1bc4e5b170fb;
module.exports["RovoSkillAriResourceType"] = $4413436cecb8e596$export$91ee5cc73270e65d;

});

parcelRegister("9OqBj", function(module, exports) {
const $e3eab036398f830e$export$3056677f7f7d8f5d = {
    LIME: {
        default: "var(--ds-border-accent-lime, #6A9A23)",
        icon: "var(--ds-icon-accent-lime, #6A9A23)"
    },
    RED: {
        default: "var(--ds-border-accent-red, #E2483D)",
        icon: "var(--ds-icon-accent-red, #C9372C)"
    },
    ORANGE: {
        default: "var(--ds-border-accent-orange, #E06C00)",
        icon: "var(--ds-icon-accent-orange, #E06C00)"
    },
    YELLOW: {
        default: "var(--ds-border-accent-yellow, #B38600)",
        icon: "var(--ds-icon-accent-yellow, #B38600)"
    },
    GREEN: {
        default: "var(--ds-border-accent-green, #22A06B)",
        icon: "var(--ds-icon-accent-green, #22A06B)"
    },
    TEAL: {
        default: "var(--ds-border-accent-teal, #2898BD)",
        icon: "var(--ds-icon-accent-teal, #2898BD)"
    },
    BLUE: {
        default: "var(--ds-border-accent-blue, #357DE8)",
        icon: "var(--ds-icon-accent-blue, #357DE8)"
    },
    PURPLE: {
        default: "var(--ds-border-accent-purple, #AF59E1)",
        icon: "var(--ds-icon-accent-purple, #AF59E1)"
    },
    MAGENTA: {
        default: "var(--ds-border-accent-magenta, #CD519D)",
        icon: "var(--ds-icon-accent-magenta, #CD519D)"
    },
    GRAY: {
        default: "var(--ds-border-accent-gray, #7D818A)",
        icon: "var(--ds-icon-accent-gray, #7D818A)"
    },
    DEFAULT: {
        default: "var(--ds-border, #0B120E24)",
        inverse: "var(--ds-border-inverse, #FFFFFF)",
        icon: "var(--ds-icon-subtle, #505258)"
    }
};
const $e3eab036398f830e$export$dbc6cfecd630bcea = (color, invertColors)=>{
    if (color) {
        const colorObject = $e3eab036398f830e$export$3056677f7f7d8f5d[color];
        const colorType = invertColors ? 'inverse' : 'default';
        return colorObject?.[colorType] ?? colorObject?.default ?? "var(--ds-border, #0B120E24)";
    }
    return invertColors ? "var(--ds-border-inverse, #FFFFFF)" : "var(--ds-border, #0B120E24)";
};
const $e3eab036398f830e$export$bb417e0702eb86b5 = (color, invertColors)=>{
    if (color) {
        const colorObject = $e3eab036398f830e$export$3056677f7f7d8f5d[color];
        if (invertColors && color === 'DEFAULT') return "var(--ds-icon-inverse, #FFFFFF)";
        return colorObject?.icon ?? "var(--ds-icon-subtle, #505258)";
    }
    return invertColors ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
};
module.exports["SKILL_COLOR_MAP"] = $e3eab036398f830e$export$3056677f7f7d8f5d;
module.exports["getBorderColor"] = $e3eab036398f830e$export$dbc6cfecd630bcea;
module.exports["getIconColor"] = $e3eab036398f830e$export$bb417e0702eb86b5;

});

parcelRegister("9MCKh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ipkS0 = parcelRequire("ipkS0");






































const $d0265bb51b10f57e$export$dce8bc0f04f0d915 = {
    skill: ()=>(parcelRequire("d7YwR")),
    assets: ()=>Promise.resolve((parcelRequire("437ur"))),
    add: ()=>Promise.resolve((parcelRequire("gFEZF"))),
    'chart-bar-line': ()=>(parcelRequire("kU1Yt")),
    'ai-generative-text': ()=>(parcelRequire("44fpQ")),
    'work-item': ()=>Promise.resolve((parcelRequire("iRFKG"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("4efpo"))),
    'chart-pie': ()=>(parcelRequire("e8Ghu")),
    plan: ()=>(parcelRequire("fhtzK")),
    settings: ()=>Promise.resolve((parcelRequire("11OF7"))),
    'project-status': ()=>(parcelRequire("duNV8")),
    'merge-success': ()=>(parcelRequire("3pUsI")),
    'person-add': ()=>(parcelRequire("1ORsb")),
    'people-group': ()=>Promise.resolve((parcelRequire("fBqzD"))),
    'person-added': ()=>(parcelRequire("1VVw9")),
    login: ()=>(parcelRequire("lp0Ka")),
    'ai-generative-text-summary': ()=>Promise.resolve((parcelRequire("f0b2F"))),
    transition: ()=>(parcelRequire("lPrvY")),
    board: ()=>Promise.resolve((parcelRequire("4MdqE"))),
    release: ()=>Promise.resolve((parcelRequire("2F2yY"))),
    'app-switcher': ()=>(parcelRequire("gfpxd")),
    search: ()=>Promise.resolve((parcelRequire("hAgam"))),
    'playlist-add': ()=>(parcelRequire("lJQ5X")),
    'playlist-remove': ()=>(parcelRequire("bYXrx")),
    summary: ()=>Promise.resolve((parcelRequire("f0b2F"))),
    clock: ()=>Promise.resolve((parcelRequire("5ZtfK"))),
    'ai-generative-chapters': ()=>(parcelRequire("62FON")),
    talent: ()=>(parcelRequire("j74pS")),
    incident: ()=>Promise.resolve((parcelRequire("ipvL3"))),
    form: ()=>(parcelRequire("e3rWd")),
    ticket: ()=>(parcelRequire("fS7mD")),
    alert: ()=>(parcelRequire("hBRNG")),
    pulse: ()=>(parcelRequire("4SYP6")),
    'text-lengthen': ()=>(parcelRequire("4Rd0H")),
    'ai-generative-cleanup': ()=>(parcelRequire("ivYfD")),
    survey: ()=>(parcelRequire("eNJEs")),
    'text-review': ()=>(parcelRequire("9ImZK"))
};
const $d0265bb51b10f57e$export$ca2f546e21dcce87 = $d0265bb51b10f57e$export$dce8bc0f04f0d915.skill;
const $d0265bb51b10f57e$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($d0265bb51b10f57e$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-x78ShG", loader, {
            renderTime: true,
            source: "platform/packages/ai-mate/rovo-platform-ui-components/src/ui/skills/skill-icons.ts:194"
        }))
    ]));
const $d0265bb51b10f57e$export$78596fa6083c04d1 = $d0265bb51b10f57e$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $d0265bb51b10f57e$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $d0265bb51b10f57e$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $d0265bb51b10f57e$export$f7883dcc9f65479a;
module.exports["DefaultSkillIcon"] = $d0265bb51b10f57e$export$78596fa6083c04d1;

});

parcelRegister("d7YwR", function(module, exports) {

let $98eae1a14b896567$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98eae1a14b896567$var$load("ji2ex").then(()=>parcelRequire('h5LaW'));

});

parcelRegister("kU1Yt", function(module, exports) {

let $f37a91b0c5a24fd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f37a91b0c5a24fd5$var$load("hrkGn").then(()=>parcelRequire('5kuIA'));

});

parcelRegister("44fpQ", function(module, exports) {

let $2f637e6c42f731d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f637e6c42f731d0$var$load("5k22f").then(()=>parcelRequire('9V507'));

});

parcelRegister("e8Ghu", function(module, exports) {

let $a4b29c33d05c1a9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4b29c33d05c1a9b$var$load("c6nMJ").then(()=>parcelRequire('eVhjN'));

});

parcelRegister("fhtzK", function(module, exports) {

let $b1ff629eca57471a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1ff629eca57471a$var$load("i1I18").then(()=>parcelRequire('dIT3V'));

});

parcelRegister("duNV8", function(module, exports) {

let $9d34ccdd49f0003a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d34ccdd49f0003a$var$load("bSZcP").then(()=>parcelRequire('6fcYF'));

});

parcelRegister("3pUsI", function(module, exports) {

let $27cf81197ca52259$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27cf81197ca52259$var$load("3GLMP").then(()=>parcelRequire('bAdTB'));

});

parcelRegister("1ORsb", function(module, exports) {

let $1533ecb52c97b893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1533ecb52c97b893$var$load("kBatH").then(()=>parcelRequire('am3XR'));

});

parcelRegister("1VVw9", function(module, exports) {

let $1687bb1e68c06fb7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1687bb1e68c06fb7$var$load("iN26T").then(()=>parcelRequire('4s4Os'));

});

parcelRegister("lp0Ka", function(module, exports) {

let $f94c827133a4a8ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f94c827133a4a8ea$var$load("85Ack").then(()=>parcelRequire('hPGQU'));

});

parcelRegister("lPrvY", function(module, exports) {

let $fe43b4375d61c3d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe43b4375d61c3d3$var$load("jjuzw").then(()=>parcelRequire('iJGPY'));

});

parcelRegister("gfpxd", function(module, exports) {

let $bd41dab43722c8d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd41dab43722c8d5$var$load("dnVmf").then(()=>parcelRequire('9ib3C'));

});

parcelRegister("lJQ5X", function(module, exports) {

let $fd3635f2e5aabac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd3635f2e5aabac0$var$load("glmO2").then(()=>parcelRequire('3yAls'));

});

parcelRegister("bYXrx", function(module, exports) {

let $8b93687e70d55260$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b93687e70d55260$var$load("32NHR").then(()=>parcelRequire('e3DmL'));

});

parcelRegister("62FON", function(module, exports) {

let $46635e3aa0f21791$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46635e3aa0f21791$var$load("8GFi1").then(()=>parcelRequire('dQeg1'));

});

parcelRegister("j74pS", function(module, exports) {

let $dea218c262683901$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dea218c262683901$var$load("iWYx4").then(()=>parcelRequire('f1G8J'));

});

parcelRegister("e3rWd", function(module, exports) {

let $a3b7046b3b58e574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3b7046b3b58e574$var$load("cXTJH").then(()=>parcelRequire('bFnmR'));

});

parcelRegister("fS7mD", function(module, exports) {

let $b8e19c809ca15790$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8e19c809ca15790$var$load("kMmm1").then(()=>parcelRequire('2ZUqo'));

});

parcelRegister("hBRNG", function(module, exports) {

let $cd1f9ffc4306ed9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd1f9ffc4306ed9a$var$load("k25pB").then(()=>parcelRequire('QrYx2'));

});

parcelRegister("4SYP6", function(module, exports) {

let $38eb62ceae487952$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38eb62ceae487952$var$load("aWKP7").then(()=>parcelRequire('dK3CB'));

});

parcelRegister("4Rd0H", function(module, exports) {

let $3896343509561fa9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3896343509561fa9$var$load("kfhZM").then(()=>parcelRequire('2xJ2w'));

});

parcelRegister("ivYfD", function(module, exports) {

let $d7a9dbdfd2c52ad4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7a9dbdfd2c52ad4$var$load("2bJoN").then(()=>parcelRequire('7Jde4'));

});

parcelRegister("eNJEs", function(module, exports) {

let $ac690dbfdd63bd67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac690dbfdd63bd67$var$load("bGOwY").then(()=>parcelRequire('2WCju'));

});

parcelRegister("9ImZK", function(module, exports) {

let $712a0f72ca3115b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $712a0f72ca3115b0$var$load("k6TzV").then(()=>parcelRequire('4u3xL'));

});

parcelRegister("9DTaz", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $281f0207d5f06906$export$eb38a1b15192a777 = (helpText, description)=>{
    const availableHelpText = typeof helpText === 'string' && helpText.trim() ? helpText : '';
    if ((0, $iDrrr.fg)('chat_skill_helptext_enabled') && availableHelpText) return availableHelpText;
    const availableDescription = typeof description === 'string' ? description : '';
    return availableDescription || availableHelpText;
};
module.exports["resolveSkillDisplayDescription"] = $281f0207d5f06906$export$eb38a1b15192a777;

});

parcelRegister("2pqVH", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $KTiWz = parcelRequire("KTiWz");


var $3F4bj = parcelRequire("3F4bj");


var $eilSC = parcelRequire("eilSC");


var $8bJxr = parcelRequire("8bJxr");


var $gPm8T = parcelRequire("gPm8T");


var $cfEQy = parcelRequire("cfEQy");


var $30QUD = parcelRequire("30QUD");


var $dMjNA = parcelRequire("dMjNA");


var $dRPWO = parcelRequire("dRPWO");


var $6KU95 = parcelRequire("6KU95");


var $6Gf6E = parcelRequire("6Gf6E");


var $7BiiX = parcelRequire("7BiiX");


var $jOsRQ = parcelRequire("jOsRQ");


var $jx4WZ = parcelRequire("jx4WZ");


var $5iJHZ = parcelRequire("5iJHZ");


var $bBXra = parcelRequire("bBXra");


var $hMAfQ = parcelRequire("hMAfQ");


var $6MqGo = parcelRequire("6MqGo");


var $62oYX = parcelRequire("62oYX");


var $k7Rhl = parcelRequire("k7Rhl");


var $12rmB = parcelRequire("12rmB");


var $gPRUa = parcelRequire("gPRUa");


var $l531v = parcelRequire("l531v");


var $3PnTZ = parcelRequire("3PnTZ");


var $1YbJm = parcelRequire("1YbJm");


var $aNi0I = parcelRequire("aNi0I");


var $4msnK = parcelRequire("4msnK");


var $8BNw5 = parcelRequire("8BNw5");


var $4gSB2 = parcelRequire("4gSB2");


var $lWEf5 = parcelRequire("lWEf5");


var $4ybgQ = parcelRequire("4ybgQ");


var $h41Wr = parcelRequire("h41Wr");


var $cLDox = parcelRequire("cLDox");


var $eE4tp = parcelRequire("eE4tp");


var $ZVVLb = parcelRequire("ZVVLb");


var $174uk = parcelRequire("174uk");


var $fARVe = parcelRequire("fARVe");


var $fBB7S = parcelRequire("fBB7S");


var $gWbtJ = parcelRequire("gWbtJ");


var $gPrpc = parcelRequire("gPrpc");


var $cAWpJ = parcelRequire("cAWpJ");


var $7OAKt = parcelRequire("7OAKt");


var $ckvpk = parcelRequire("ckvpk");


var $gvXEn = parcelRequire("gvXEn");


var $57Y2G = parcelRequire("57Y2G");

const $736bcfca813402fe$export$695720b7e7a61533 = {
    blockCard: (0, $8bJxr.default),
    blockquote: (0, $gPm8T.default),
    blockTaskItem: (0, $ckvpk.default),
    bodiedExtension: (0, $cfEQy.default),
    bodiedSyncBlock: (0, $30QUD.default),
    bulletList: (0, $dMjNA.default),
    caption: (0, $dRPWO.default),
    codeBlock: (0, $6KU95.default),
    date: (0, $7BiiX.default),
    decisionItem: (0, $jOsRQ.default),
    decisionList: (0, $jx4WZ.default),
    doc: (0, $5iJHZ.default),
    embedCard: (0, $bBXra.default),
    emoji: (0, $hMAfQ.default),
    expand: (0, $eilSC.default),
    extension: (0, $6MqGo.default),
    extensionFrame: (0, $62oYX.default),
    hardBreak: (0, $k7Rhl.default),
    heading: (0, $12rmB.default),
    inlineCard: (0, $gPRUa.default),
    inlineExtension: (0, $l531v.default),
    layoutColumn: (0, $3PnTZ.default),
    layoutSection: (0, $1YbJm.default),
    listItem: (0, $aNi0I.default),
    media: (0, $4msnK.default),
    mediaGroup: (0, $8BNw5.default),
    mediaInline: (0, $4gSB2.default),
    mediaSingle: (0, $lWEf5.default),
    mention: (0, $4ybgQ.default),
    multiBodiedExtension: (0, $h41Wr.default),
    nestedExpand: (0, $eilSC.default),
    orderedList: (0, $cLDox.default),
    panel: (0, $eE4tp.default),
    panel_c1: (0, $eE4tp.default),
    paragraph: (0, $ZVVLb.default),
    placeholder: (0, $174uk.default),
    rule: (0, $fARVe.default),
    status: (0, $fBB7S.default),
    syncBlock: (0, $gWbtJ.default),
    table: (0, $gPrpc.default),
    tableCell: (0, $cAWpJ.TableCell),
    tableHeader: (0, $cAWpJ.TableHeader),
    tableRow: (0, $7OAKt.default),
    taskItem: (0, $ckvpk.default),
    taskList: (0, $gvXEn.default),
    unknownBlock: (0, $57Y2G.default),
    unsupportedBlock: (0, $KTiWz.default),
    unsupportedInline: (0, $3F4bj.default),
    windowedCodeBlock: (0, $6Gf6E.default)
};
module.exports["nodes"] = $736bcfca813402fe$export$695720b7e7a61533;

});

parcelRegister("f6VI9", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $9DTaz = parcelRequire("9DTaz");

const $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES = new Set([
    'WorkItemWorkflowContextMinion',
    'JiraWorkItemCreateMinion',
    'JiraPermissionsSkill',
    'JiraNavigationMinion'
]);
/**
 * Rovo Space conversations support Anthropic skills plus a small set of
 * Stratus skills that provide the Jira capabilities required in that context.
 */ function $ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node) {
    return node.source === 'ANTHROPIC' || node.source === 'STRATUS' && Boolean(node.name && $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES.has(node.name));
}
function $ae2233479ab8cd62$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $ae2233479ab8cd62$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const displayDescription = node.description ?? '';
    const trimmedDescription = displayDescription.length > 150 ? `${displayDescription.slice(0, 147)}...` : displayDescription;
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        ...node.integrationKey?.key ? {
            productKey: node.integrationKey.key
        } : {},
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    const productKey = primaryIntegration?.key ?? node.integrationKeys?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] || ((0, $iDrrr.fg)('rovo_skill_tag_label_wrapping') ? node.name : '') || '',
        name: node.displayName ?? node.name ?? '',
        description: node.description ?? '',
        helpText: (0, $9DTaz.resolveSkillDisplayDescription)(node.helpText, node.description),
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        ...productKey ? {
            productKey: productKey
        } : {},
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$db36004670a5626e(edge?.node) ? $ae2233479ab8cd62$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$7d1ba2a7b9e1a07(edge?.node) ? $ae2233479ab8cd62$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$faef8b68e529d4a7(edges, options = {}) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($ae2233479ab8cd62$export$db36004670a5626e(node)) {
            // Legacy directory items do not expose the source needed to establish
            // eligibility for a Rovo Space conversation.
            if (options.restrictToRovoSpaceSkills) return null;
            return $ae2233479ab8cd62$export$74ea09dd5afceb60(node);
        }
        if ($ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node)) {
            if (options.restrictToRovoSpaceSkills && !$ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node)) return null;
            return $ae2233479ab8cd62$export$fd76a94f4a001a14(node);
        }
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $ae2233479ab8cd62$export$74ea09dd5afceb60;
module.exports["parseConvoAiSkillEdges"] = $ae2233479ab8cd62$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $ae2233479ab8cd62$export$faef8b68e529d4a7;

});

parcelRegister("aJNFh", function(module, exports) {

var $f6VI9 = parcelRequire("f6VI9");

const $71f78acdff7635c4$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Unified GraphQL query — convoai_availableSkills.
 */ const $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $71f78acdff7635c4$var$skillsCache = new Map();
function $71f78acdff7635c4$export$e6cf70cf6554c856() {
    $71f78acdff7635c4$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 150
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $f6VI9.parseConvoAiSkillEdges)(edges);
}
async function $71f78acdff7635c4$export$268d57ae88e7df66(cloudId) {
    const cacheKey = cloudId;
    const cached = $71f78acdff7635c4$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = await $71f78acdff7635c4$var$fetchSkillsUnified(cloudId);
        $71f78acdff7635c4$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $71f78acdff7635c4$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $71f78acdff7635c4$export$268d57ae88e7df66;

});

parcelRegister("aIn0d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $10I6z = parcelRequire("10I6z");

const $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $5f85a79aee555eb3$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $5f85a79aee555eb3$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $10I6z.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5f85a79aee555eb3$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $5f85a79aee555eb3$export$e0542ba0c737fe5c;

});

parcelRegister("10I6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1ae8fb340800d3e1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $1ae8fb340800d3e1$export$a7357cdd1f0b0168;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9feda705e9481f913d0df858359ce6d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_iconNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_iconNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("2eX69", function(module, exports) {

var $e9nC3 = parcelRequire("e9nC3");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5BnIc = parcelRequire("5BnIc");


var $9C5oc = parcelRequire("9C5oc");


var $h45y6 = parcelRequire("h45y6");

const $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $a45798977a968ec1$var$singleLineTruncatedText = (text, length = $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $9C5oc.default)(singleLineText, length);
};
class $a45798977a968ec1$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $a45798977a968ec1$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h45y6.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $iDrrr.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $5BnIc.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $e9nC3.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$a45798977a968ec1$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $a45798977a968ec1$export$2e2bcd8739ae039;

});

parcelRegister("5BnIc", function(module, exports) {
const $db292a71bf6452ef$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $db292a71bf6452ef$export$f0f6fc934288a17c;

});

parcelRegister("9C5oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5409c9e56ee67a$export$2e2bcd8739ae039);
function $0c5409c9e56ee67a$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("h45y6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2uDbg = parcelRequire("2uDbg");


var $7BfeF = parcelRequire("7BfeF");


var $dUI0h = parcelRequire("dUI0h");


var $2Nu0e = parcelRequire("2Nu0e");


var $dTHYM = parcelRequire("dTHYM");


var $dQLwo = parcelRequire("dQLwo");


var $hpa99 = parcelRequire("hpa99");


var $i1t43 = parcelRequire("i1t43");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $iDrrr = parcelRequire("iDrrr");


var $1VhsF = parcelRequire("1VhsF");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $dcf72f8838f67ff8$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
const $dcf72f8838f67ff8$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $cozmU.useState)(false);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $cozmU.useState)(false);
    const [type, setType] = (0, $cozmU.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $5r21M.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $5r21M.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $5r21M.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $5r21M.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $5r21M.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $5r21M.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $5r21M.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $5r21M.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $5r21M.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $5r21M.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $5r21M.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $5r21M.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $cozmU.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponse;
    };
    const renderContactLabel = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelWithResponse;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }, formatMessage((0, $5r21M.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null));
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, formatMessage((0, $5r21M.messages).feedbackIsAnonymous));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $iDrrr.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "topic",
        id: "topic",
        label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
        isRequired: true,
        validate: validateType
    }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            ...restProps,
            value: selectOptions.find((opt)=>opt.value === type) ?? null,
            onChange: (option)=>{
                if (!option || option instanceof Array) return;
                setType(option.value);
                restProps.onChange?.(option.value);
            },
            menuPosition: "fixed",
            options: selectOptions,
            shouldPreventEscapePropagation: true,
            // @ts-ignore
            ref: focusRef,
            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
            inputId: id,
            isInvalid: !!error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
        isRequired: true,
        name: "description",
        id: "description",
        validate: validateDescription
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            name: "foo",
            minimumRows: 6,
            placeholder: summaryPlaceholder || undefined,
            onChange: (e)=>{
                setDescription(e.target.value);
                fieldProps.onChange(e.target.value);
            },
            value: description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "can-be-contacted"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }
            }),
            onChange: (event)=>setCanBeContacted(event.target.checked)
        }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank"
        }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "enroll-in-research-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
        }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: 'anonymousFeedback'
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
            appearance: 'information'
        }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: isSubmitting || isDisabled,
        testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel)))));
};
const $dcf72f8838f67ff8$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$FeedbackForm, props));
};
var $dcf72f8838f67ff8$export$2e2bcd8739ae039 = $dcf72f8838f67ff8$var$FeedbackFormWithIntl;
module.exports["default"] = $dcf72f8838f67ff8$export$2e2bcd8739ae039;

});

parcelRegister("5r21M", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0eef762dd50d9f91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabelWithResponse: {
        id: "feedback-collector.can-be-contacted.label-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppifyWithResponse: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $0eef762dd50d9f91$export$defe85febe8b728c;

});

parcelRegister("hTUp6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $b2A1s = parcelRequire("b2A1s");

const $fb8b4f9502ba72fc$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $b2A1s.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};
module.exports["IntlProviderWithResolvedMessages"] = $fb8b4f9502ba72fc$export$f793de1293176fe6;

});

parcelRegister("b2A1s", function(module, exports) {
const $e1a3f1d7e16f1235$var$isNestedMessagesModule = (value)=>'default' in value && typeof value.default === 'object' && value.default !== null;
const $e1a3f1d7e16f1235$var$unwrapMessages = (messages)=>{
    const defaultExport = messages.default;
    return $e1a3f1d7e16f1235$var$isNestedMessagesModule(defaultExport) ? defaultExport.default : defaultExport;
};





























const $e1a3f1d7e16f1235$var$messagesLoaders = {
    cs: ()=>(parcelRequire("gR4U1")),
    da: ()=>(parcelRequire("f1jrk")),
    de: ()=>(parcelRequire("aOLRB")),
    en: ()=>(parcelRequire("6kEFl")),
    en_GB: ()=>(parcelRequire("bjsxN")),
    en_ZZ: ()=>(parcelRequire("9DhD6")),
    es: ()=>(parcelRequire("ddpWy")),
    fi: ()=>(parcelRequire("5XvgX")),
    fr: ()=>(parcelRequire("cZf5E")),
    hr: ()=>(parcelRequire("CsODP")),
    hu: ()=>(parcelRequire("hPRyr")),
    it: ()=>(parcelRequire("z7zpe")),
    ja: ()=>(parcelRequire("8pzcT")),
    ko: ()=>(parcelRequire("1I2b8")),
    nb: ()=>(parcelRequire("gPBz3")),
    nl: ()=>(parcelRequire("78iTh")),
    pl: ()=>(parcelRequire("gHYE1")),
    pt_BR: ()=>(parcelRequire("9qN1z")),
    ru: ()=>(parcelRequire("dNwJi")),
    sl: ()=>(parcelRequire("fXweJ")),
    sr_RS: ()=>(parcelRequire("nFTVL")),
    sr_YR: ()=>(parcelRequire("bsw4B")),
    sv: ()=>(parcelRequire("97qPc")),
    th: ()=>(parcelRequire("bZmWu")),
    tr: ()=>(parcelRequire("aspSd")),
    uk: ()=>(parcelRequire("kWvvj")),
    vi: ()=>(parcelRequire("c5Sph")),
    zh: ()=>(parcelRequire("ecWO0")),
    zh_TW: ()=>(parcelRequire("dpkEO"))
};
const $e1a3f1d7e16f1235$var$getMessages = async (locale)=>{
    const loadMessages = $e1a3f1d7e16f1235$var$messagesLoaders[locale];
    if (!loadMessages) return undefined;
    try {
        const messages = await loadMessages();
        return $e1a3f1d7e16f1235$var$unwrapMessages(messages);
    } catch  {
        return undefined;
    }
};
const $e1a3f1d7e16f1235$export$d0a3169680473b6c = async (locale)=>{
    const localeKey = locale.replace('-', '_');
    const messages = await $e1a3f1d7e16f1235$var$getMessages(localeKey);
    return messages ?? $e1a3f1d7e16f1235$var$getMessages(localeKey.split(/[-_]/)[0]);
};
module.exports["getMessagesForLocale"] = $e1a3f1d7e16f1235$export$d0a3169680473b6c;

});

parcelRegister("gR4U1", function(module, exports) {

let $c455661dc243c654$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c455661dc243c654$var$load("iGnEn").then(()=>parcelRequire('6S4lG'));

});

parcelRegister("f1jrk", function(module, exports) {

let $aef60752586d2f07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aef60752586d2f07$var$load("81CwI").then(()=>parcelRequire('9Q7ky'));

});

parcelRegister("aOLRB", function(module, exports) {

let $7e03b39534ef9cf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e03b39534ef9cf9$var$load("coMdg").then(()=>parcelRequire('4ELWT'));

});

parcelRegister("6kEFl", function(module, exports) {

let $49c427b32ae5dc71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49c427b32ae5dc71$var$load("4t3GG").then(()=>parcelRequire('aPmYJ'));

});

parcelRegister("bjsxN", function(module, exports) {

let $83c79c54c6feadd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83c79c54c6feadd2$var$load("lJDHR").then(()=>parcelRequire('fYO3Z'));

});

parcelRegister("9DhD6", function(module, exports) {

let $70356e70b5fecfa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70356e70b5fecfa6$var$load("izI99").then(()=>parcelRequire('fcttw'));

});

parcelRegister("ddpWy", function(module, exports) {

let $99f09d110267a62d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f09d110267a62d$var$load("3LmH0").then(()=>parcelRequire('iTEZG'));

});

parcelRegister("5XvgX", function(module, exports) {

let $456ab880bb5ad2de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $456ab880bb5ad2de$var$load("9nUzh").then(()=>parcelRequire('jCyLN'));

});

parcelRegister("cZf5E", function(module, exports) {

let $9746e31b2d06b6ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9746e31b2d06b6ef$var$load("b0H0M").then(()=>parcelRequire('sjYCD'));

});

parcelRegister("CsODP", function(module, exports) {

let $0739e6f0f7a8ce09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0739e6f0f7a8ce09$var$load("rlX60").then(()=>parcelRequire('kdtG9'));

});

parcelRegister("hPRyr", function(module, exports) {

let $cfc0bde35e1c9468$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfc0bde35e1c9468$var$load("8XGfa").then(()=>parcelRequire('9cMV0'));

});

parcelRegister("z7zpe", function(module, exports) {

let $0699244176860d72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0699244176860d72$var$load("kX4YP").then(()=>parcelRequire('65zeK'));

});

parcelRegister("8pzcT", function(module, exports) {

let $61fbf7e9b29a6824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61fbf7e9b29a6824$var$load("cYuG5").then(()=>parcelRequire('amjcb'));

});

parcelRegister("1I2b8", function(module, exports) {

let $13eb9721d58dad03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13eb9721d58dad03$var$load("5bV9Q").then(()=>parcelRequire('3z1HI'));

});

parcelRegister("gPBz3", function(module, exports) {

let $c40e8c41f36f3f1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c40e8c41f36f3f1d$var$load("gjrov").then(()=>parcelRequire('ePp5T'));

});

parcelRegister("78iTh", function(module, exports) {

let $5317ef0d88303541$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5317ef0d88303541$var$load("ekD3q").then(()=>parcelRequire('3sPeQ'));

});

parcelRegister("gHYE1", function(module, exports) {

let $c29fb436da7f42d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c29fb436da7f42d1$var$load("CRIov").then(()=>parcelRequire('21Pza'));

});

parcelRegister("9qN1z", function(module, exports) {

let $6ddc91febcf834c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ddc91febcf834c3$var$load("kLzqf").then(()=>parcelRequire('2YIPE'));

});

parcelRegister("dNwJi", function(module, exports) {

let $a0b93d651cd2386e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0b93d651cd2386e$var$load("89F7K").then(()=>parcelRequire('lXD2K'));

});

parcelRegister("fXweJ", function(module, exports) {

let $b9e55f3b28230681$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9e55f3b28230681$var$load("5ZUDB").then(()=>parcelRequire('16fIE'));

});

parcelRegister("nFTVL", function(module, exports) {

let $0472a6c8d6c4c707$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0472a6c8d6c4c707$var$load("h2pVk").then(()=>parcelRequire('byreT'));

});

parcelRegister("bsw4B", function(module, exports) {

let $857b304eeac06c5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857b304eeac06c5e$var$load("hKNph").then(()=>parcelRequire('diuUZ'));

});

parcelRegister("97qPc", function(module, exports) {

let $6a39935eb8b824b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a39935eb8b824b7$var$load("bEB1L").then(()=>parcelRequire('57pGr'));

});

parcelRegister("bZmWu", function(module, exports) {

let $8ba730127f966548$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ba730127f966548$var$load("1DxcO").then(()=>parcelRequire('grvEM'));

});

parcelRegister("aspSd", function(module, exports) {

let $79d096d1d3432597$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79d096d1d3432597$var$load("4KHc0").then(()=>parcelRequire('13DVp'));

});

parcelRegister("kWvvj", function(module, exports) {

let $f3f1a976fda4a8c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3f1a976fda4a8c1$var$load("fWsCx").then(()=>parcelRequire('im5if'));

});

parcelRegister("c5Sph", function(module, exports) {

let $8ce027b238ed199c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ce027b238ed199c$var$load("eVExC").then(()=>parcelRequire('1U1j1'));

});

parcelRegister("ecWO0", function(module, exports) {

let $a57fcd3be5a7543a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a57fcd3be5a7543a$var$load("BGq3S").then(()=>parcelRequire('kBazV'));

});

parcelRegister("dpkEO", function(module, exports) {

let $9c2da245872fb648$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c2da245872fb648$var$load("1BBYh").then(()=>parcelRequire('3tROA'));

});

parcelRegister("206E4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c3df761541b2068a$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="var(--tile-color,#dddee1)" rx="12"/>
    <path fill="var(--icon-color, #101214)" d="m24.127 17.587-4.788 17.87 12.654 3.39 4.788-17.87z"/>
    <path fill="var(--icon-color, #101214)" d="M22.078 13.65 17.93 29.11H13V10h14.077v4.984z"/>
</svg>
`;
const $c3df761541b2068a$export$76a76378b46fc395 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ArtifactsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Artifacts" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c3df761541b2068a$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function ArtifactsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Artifacts', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c3df761541b2068a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["ArtifactsIcon"] = $c3df761541b2068a$export$76a76378b46fc395;

});

parcelRegister("lvJqX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6JrSr = parcelRequire("6JrSr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $cEipP = parcelRequire("cEipP");

const $7c29b2adacb89176$var$styles = {
    contentStyles: "_4bt5LAIZbP _2WAcuGIZbP _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _1EqgXlhPwX _0NUa3rhPwX",
    rootStyles: "_3iDTPbvbI6 _1EqgXlN91d _4GplSjDF1i _2fqI0W7iY9",
    pressableStyles: "_0bjKvDKTcp _2sNsIgmnOE _4c065UPgdg _2Y7lL4Pgdg _3iDTPbccYA _0KLXru66of _1UtDYzZpcK _1ANEUSLRg7 _1mT5xdRAKS _0hPCNLQame _1EqgXlN91d _0jFU0VIZbP _39xV02IZbP _1RrJLiQame _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $7c29b2adacb89176$var$iconColor = {
    connectivity: "_2bHMMpZFWO",
    confirmation: "_2bHMMpfyEX",
    info: "_2bHMMpTNil",
    warning: "_2bHMMpspgB",
    error: "_2bHMMp7j8z"
}; /**
    * __Inline message__
    *
    * An inline message lets users know when important information is available or when an action is required.
    *
    * - [Examples](https://atlassian.design/components/inline-message/examples)
    * - [Code](https://atlassian.design/components/inline-message/code)
    * - [Usage](https://atlassian.design/components/inline-message/usage)
    *
    * @example
    *
    * ```jsx
    * const Component = () => (
    *   <InlineMessage
    *    title="Inline Message Title Example"
    *    secondaryText="Secondary Text"
    *   >
    *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
    *   </InlineMessage>
    * );
    * ```
    */ 
const $7c29b2adacb89176$var$InlineMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { placement: t1, secondaryText: t2, title: t3, appearance: t4, spacing: t5, children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements } = t0;
    const placement = t1 === undefined ? "bottom-start" : t1;
    const secondaryText = t2 === undefined ? "" : t2;
    const title = t3 === undefined ? "" : t3;
    const appearance = t4 === undefined ? "connectivity" : t4;
    const spacing = t5 === undefined ? "spacious" : t5;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsOpen($7c29b2adacb89176$var$_temp);
        };
        $[0] = t6;
    } else t6 = $[0];
    const toggleDialog = t6;
    let t7;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[1] = t7;
    } else t7 = $[1];
    const onCloseDialog = t7;
    const t8 = $7c29b2adacb89176$var$iconColor[appearance];
    let t9;
    if ($[2] !== t8) {
        t9 = (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            t8
        ]);
        $[2] = t8;
        $[3] = t9;
    } else t9 = $[3];
    let t10;
    if ($[4] !== children) {
        t10 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles,
                children: children
            });
        $[4] = children;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = testId && `${testId}--popup`;
    let t12;
    if ($[6] !== appearance || $[7] !== iconLabel || $[8] !== id || $[9] !== isOpen || $[10] !== secondaryText || $[11] !== spacing || $[12] !== testId || $[13] !== title) {
        t12 = (t13)=>{
            const { ref: ref, ...triggerProps } = t13;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    as: "span",
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cEipP.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            as: "span",
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            });
        };
        $[6] = appearance;
        $[7] = iconLabel;
        $[8] = id;
        $[9] = isOpen;
        $[10] = secondaryText;
        $[11] = spacing;
        $[12] = testId;
        $[13] = title;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== fallbackPlacements || $[16] !== id || $[17] !== isOpen || $[18] !== placement || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            onClose: onCloseDialog,
            content: t10,
            isOpen: isOpen,
            placement: placement,
            testId: t11,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: t12
        });
        $[15] = fallbackPlacements;
        $[16] = id;
        $[17] = isOpen;
        $[18] = placement;
        $[19] = t10;
        $[20] = t11;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t13 || $[24] !== t9 || $[25] !== testId) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            className: t9,
            children: t13
        });
        $[23] = t13;
        $[24] = t9;
        $[25] = testId;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $cozmU.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            $7c29b2adacb89176$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            onClose: onCloseDialog,
            content: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $7c29b2adacb89176$var$styles.contentStyles,
                    children: children
                }),
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--popup`,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                    ...triggerProps,
                    ref: ref,
                    id: id,
                    "data-ds--inline-message--button": true,
                    onClick: toggleDialog,
                    testId: testId && `${testId}--button`,
                    xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                    "aria-expanded": isOpen,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        as: "span",
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cEipP.default), {
                                isOpen: isOpen,
                                appearance: appearance,
                                label: iconLabel,
                                spacing: spacing
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                as: "span",
                                space: "space.100",
                                children: [
                                    title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: "medium",
                                        testId: testId && `${testId}--title`,
                                        children: title
                                    }),
                                    secondaryText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: "medium",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        testId: testId && `${testId}--text`,
                                        children: secondaryText
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $7c29b2adacb89176$export$2e2bcd8739ae039 = $7c29b2adacb89176$var$InlineMessage;
function $7c29b2adacb89176$var$_temp(oldState) {
    return !oldState;
}
module.exports["default"] = $7c29b2adacb89176$export$2e2bcd8739ae039;

});

parcelRegister("cEipP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $axHIJ = parcelRequire("axHIJ");

const $fe4d2a60aea58684$var$iconColor = {
    connectivity: "_1UtDYzZFWO",
    confirmation: "_1UtDYzfyEX",
    info: "_1UtDYzTNil",
    warning: "_1UtDYzspgB",
    error: "_1UtDYz7j8z"
};
const $fe4d2a60aea58684$var$iconWrapperStyles = null;
const $fe4d2a60aea58684$var$iconColorStyles = null; /**
                               * __Selected icon__
                               *
                               * The selected icon is used as the primary interactive element for the dialog.
                               * Can be used with or without supporting text.
                               */ 
const $fe4d2a60aea58684$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $axHIJ.typesMapping);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT",
            $fe4d2a60aea58684$var$iconColor[appearance],
            isOpen && "_1UtDYzDF1i"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            spacing: spacing
        })
    });
};
var $fe4d2a60aea58684$export$2e2bcd8739ae039 = $fe4d2a60aea58684$var$SelectedIcon;
module.exports["default"] = $fe4d2a60aea58684$export$2e2bcd8739ae039;

});

parcelRegister("axHIJ", function(module, exports) {

var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $0c91ff1a933c23ee$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
        defaultLabel: 'error inline message'
    }
};
module.exports["typesMapping"] = $0c91ff1a933c23ee$export$4d111645c0b39d5d;

});

parcelRegister("dWfVs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eFO72 = parcelRequire("eFO72");


var $l0P92 = parcelRequire("l0P92");


var $77Mp1 = parcelRequire("77Mp1");


var $4vTOw = parcelRequire("4vTOw");


var $12FeT = parcelRequire("12FeT");


var $kf8A1 = parcelRequire("kf8A1");


var $lPJNC = parcelRequire("lPJNC");


var $kAKjI = parcelRequire("kAKjI");


var $eC4ZY = parcelRequire("eC4ZY");


var $4Y1Z5 = parcelRequire("4Y1Z5");


var $4o0zT = parcelRequire("4o0zT");


var $4aRua = parcelRequire("4aRua");


var $8lhhf = parcelRequire("8lhhf");


var $7JHs4 = parcelRequire("7JHs4");


var $9DTaz = parcelRequire("9DTaz");


var $9OqBj = parcelRequire("9OqBj");


var $9MCKh = parcelRequire("9MCKh");

const $ad58f4ad7597918e$var$DEFAULT_CATEGORY = 'AI';
const $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH = 150;
const $ad58f4ad7597918e$var$PRODUCT_ATTRIBUTIONS = {
    confluence: {
        name: (0, $lPJNC.messages).previewAttributionConfluence,
        icon: (0, $l0P92.ConfluenceAttributionIcon)
    },
    jira: {
        name: (0, $lPJNC.messages).previewAttributionJira,
        icon: (0, $12FeT.JiraAttributionIcon)
    },
    jsm: {
        name: (0, $lPJNC.messages).previewAttributionJiraServiceManagement,
        icon: (0, $kf8A1.JiraServiceManagementAttributionIcon)
    },
    talent: {
        name: (0, $lPJNC.messages).previewAttributionTalent,
        icon: (0, $eC4ZY.TalentAttributionIcon)
    },
    studio: {
        name: (0, $lPJNC.messages).previewAttributionStudio,
        icon: (0, $kAKjI.StudioAttributionIcon)
    },
    assets: {
        name: (0, $lPJNC.messages).previewAttributionAssets,
        icon: (0, $eFO72.AssetsAttributionIcon)
    },
    focus: {
        name: (0, $lPJNC.messages).previewAttributionFocus,
        icon: (0, $4vTOw.FocusAttributionIcon)
    },
    trello: {
        name: (0, $lPJNC.messages).previewAttributionTrello,
        icon: (0, $4Y1Z5.TrelloAttributionIcon)
    },
    feedback: {
        name: (0, $lPJNC.messages).previewAttributionFeedback,
        icon: (0, $77Mp1.FeedbackAttributionIcon)
    }
};
// Atlassian skills whose product is not in PRODUCT_ATTRIBUTIONS, or that have no product, are
// attributed to Atlassian.
const $ad58f4ad7597918e$var$DEFAULT_ATTRIBUTION = {
    name: (0, $lPJNC.messages).previewAttributionAtlassian
};
// Custom skills are authored by users rather than by a product, so they have no attribution.
const $ad58f4ad7597918e$var$getSkillAttribution = (skill)=>{
    if ((0, $7JHs4.isCustomSkill)(skill.id)) return undefined;
    return skill.productKey && $ad58f4ad7597918e$var$PRODUCT_ATTRIBUTIONS[skill.productKey] || $ad58f4ad7597918e$var$DEFAULT_ATTRIBUTION;
};
const $ad58f4ad7597918e$var$DEFAULT_BETA_LOZENGE = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
    color: "color.text.subtle",
    size: "small"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
    defaultMessage: "Beta",
    id: "fabric.editor.quickInsert.skill.beta"
}));
/**
 * Truncate description to a maximum length.
 * Used to keep insert menu items readable when skill descriptions are long.
 */ function $ad58f4ad7597918e$var$truncateDescription(description) {
    if (description.length <= $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH) return description;
    return description.slice(0, $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH).trim() + "\u2026";
}
/**
 * Returns the skill-specific icon with its configured color.
 * Falls back to the default skill icon if no match is found.
 */ const $ad58f4ad7597918e$var$getLegacySkillIcon = (skill)=>{
    const iconName = skill.iconName;
    const loadIcon = iconName && (0, $9MCKh.skillIcon)[iconName] ? (0, $9MCKh.skillIcon)[iconName] : (0, $9MCKh.defaultIcon);
    const iconColor = (0, $9OqBj.getIconColor)(skill.color);
    return async ()=>{
        const { default: Icon } = await loadIcon();
        const IconComponent = Icon;
        const ColoredSkillIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
            const $ = (0, $bDgLe.c)(2);
            let t0;
            if ($[0] !== props) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                    ...props,
                    color: iconColor
                });
                $[0] = props;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        } : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                ...props,
                color: iconColor
            });
        return {
            default: ColoredSkillIcon
        };
    };
};
function $ad58f4ad7597918e$export$a01f1ff56cba4b1c(skills, options = {}) {
    const { onAction: onAction, categories: categories = [
        $ad58f4ad7597918e$var$DEFAULT_CATEGORY
    ], priority: priority, getLozenge: getLozenge, nodes: nodes, isHidden: isHidden } = options;
    const showSlashPreviews = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    const quickInsertModules = skills.map((skill)=>{
        const keywords = [
            skill.slug,
            skill.product,
            skill.name,
            'skill',
            'skills'
        ].filter((k)=>typeof k === 'string' && k.length > 0);
        const description = (0, $9DTaz.resolveSkillDisplayDescription)(skill.helpText, skill.description);
        let preview;
        if (showSlashPreviews) {
            const attribution = skill.productKey ? $ad58f4ad7597918e$var$PRODUCT_ATTRIBUTIONS[skill.productKey] : undefined;
            preview = attribution ? {
                attribution: attribution
            } : skill.product ? {
                attribution: {
                    name: skill.product
                }
            } : {};
        }
        return {
            key: skill.slug,
            ...isHidden && {
                isHidden: ()=>isHidden(skill)
            },
            title: skill.name,
            description: showSlashPreviews ? description : $ad58f4ad7597918e$var$truncateDescription(description),
            keywords: keywords,
            categories: categories,
            ...priority !== undefined && {
                priority: priority
            },
            icon: $ad58f4ad7597918e$var$getLegacySkillIcon(skill),
            ...getLozenge && {
                lozenge: getLozenge(skill)
            },
            ...preview && {
                preview: preview
            },
            action: async ()=>onAction?.(skill)
        };
    });
    return {
        title: 'Rovo Skills',
        description: 'AI-powered skills from Rovo',
        type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
        key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
        icons: {
            '16': (0, $9MCKh.defaultIcon),
            '24': (0, $9MCKh.defaultIcon),
            '48': (0, $9MCKh.defaultIcon)
        },
        modules: {
            quickInsert: quickInsertModules,
            ...nodes && {
                nodes: nodes
            }
        }
    };
}
const $ad58f4ad7597918e$export$8a18dddc0824814c = (skill)=>{
    const iconName = skill.iconName;
    const loadIcon = iconName && (0, $9MCKh.skillIcon)[iconName] ? (0, $9MCKh.skillIcon)[iconName] : (0, $9MCKh.defaultIcon);
    const iconColor = (0, $9OqBj.getIconColor)(skill.color);
    const loadColoredIcon = async ()=>{
        const { default: Icon } = await loadIcon();
        const IconComponent = Icon;
        const ColoredSkillIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
            const $ = (0, $bDgLe.c)(2);
            let t0;
            if ($[0] !== props) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                    ...props,
                    color: iconColor
                });
                $[0] = props;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        } : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                ...props,
                color: iconColor
            });
        return {
            default: ColoredSkillIcon
        };
    };
    let coloredIconPromise;
    return ()=>coloredIconPromise ?? (coloredIconPromise = loadColoredIcon());
};
function $ad58f4ad7597918e$export$d76981760c7a9606(skills, options = {}) {
    const { onAction: onAction, categories: categories = [
        $ad58f4ad7597918e$var$DEFAULT_CATEGORY
    ], priority: priority, getLozenge: getLozenge, nodes: nodes, manifestTitle: manifestTitle = 'Rovo Skills', isHidden: isHidden } = options;
    const quickInsertModules = skills.map((skill)=>{
        const keywords = [
            skill.slug,
            skill.product,
            skill.name,
            'skill',
            'skills'
        ].filter((k)=>typeof k === 'string' && k.length > 0);
        const description = (0, $9DTaz.resolveSkillDisplayDescription)(skill.helpText, skill.description);
        const attribution = $ad58f4ad7597918e$var$getSkillAttribution(skill);
        const preview = attribution ? {
            attribution: attribution
        } : {};
        const isBeta = skill.tags?.some((tag)=>tag.toLowerCase() === 'beta') ?? false;
        const lozenge = getLozenge ? getLozenge(skill) : isBeta ? $ad58f4ad7597918e$var$DEFAULT_BETA_LOZENGE : undefined;
        return {
            key: skill.slug,
            ...isHidden && {
                isHidden: ()=>isHidden(skill)
            },
            title: skill.name,
            description: description,
            keywords: keywords,
            categories: categories,
            ...priority !== undefined && {
                priority: priority
            },
            icon: $ad58f4ad7597918e$export$8a18dddc0824814c(skill),
            ...lozenge != null && {
                lozenge: lozenge
            },
            preview: preview,
            // The inserted skill node stores the skill as its parameters.
            parameters: skill,
            action: async ()=>onAction?.(skill)
        };
    });
    return {
        title: manifestTitle,
        description: 'AI-powered skills from Rovo',
        type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
        key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
        icons: {
            '16': (0, $9MCKh.defaultIcon),
            '24': (0, $9MCKh.defaultIcon),
            '48': (0, $9MCKh.defaultIcon)
        },
        modules: {
            quickInsert: quickInsertModules,
            ...nodes && {
                nodes: nodes
            }
        }
    };
}
module.exports["buildLegacySkillsManifest"] = $ad58f4ad7597918e$export$a01f1ff56cba4b1c;
module.exports["buildSkillsManifest"] = $ad58f4ad7597918e$export$d76981760c7a9606;

});

parcelRegister("eFO72", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $7a41c4a098b40cd5$export$eab7e91d6eae906d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.assetsIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.assetsIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["AssetsAttributionIcon"] = $7a41c4a098b40cd5$export$eab7e91d6eae906d;

});

parcelRegister("77Mp1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $39d7754f75f501a2$export$eaefbf91173053e3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.feedbackIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.feedbackIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["FeedbackAttributionIcon"] = $39d7754f75f501a2$export$eaefbf91173053e3;

});

parcelRegister("4vTOw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $51057c117d6b3cf0$export$bb16d24a5f324787 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.focusIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.focusIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["FocusAttributionIcon"] = $51057c117d6b3cf0$export$bb16d24a5f324787;

});

parcelRegister("kf8A1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $ef9ef8e0b2966579$export$37a58834dc468642 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.jiraServiceManagementIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.jiraServiceManagementIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["JiraServiceManagementAttributionIcon"] = $ef9ef8e0b2966579$export$37a58834dc468642;

});

parcelRegister("kAKjI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $5a71999f39a60520$export$50579c1ab700a1c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.studioIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.studioIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["StudioAttributionIcon"] = $5a71999f39a60520$export$50579c1ab700a1c7;

});

parcelRegister("eC4ZY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $b8ceecf1eeb2f45c$export$b99e3c9c5f0fd3a9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.talentIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.talentIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["TalentAttributionIcon"] = $b8ceecf1eeb2f45c$export$b99e3c9c5f0fd3a9;

});

parcelRegister("4Y1Z5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $1305ea0307dfc20c$export$fb9cd815a9f94154 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.trelloIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.trelloIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["TrelloAttributionIcon"] = $1305ea0307dfc20c$export$fb9cd815a9f94154;

});

parcelRegister("i8aB6", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

const $89c606f0d1f4dfb4$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $cozmU.useRef)(new (0, $34VCg.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $cozmU.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $cozmU.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $cozmU.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $89c606f0d1f4dfb4$export$fade2d05a6320d49;

});

parcelRegister("kDDrf", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- fallback for insecure contexts where crypto.randomUUID is unavailable

var $03RpJ = parcelRequire("03RpJ");


var $3PJhM = parcelRequire("3PJhM");


var $irnO2 = parcelRequire("irnO2");


var $cvQra = parcelRequire("cvQra");


var $iBsvI = parcelRequire("iBsvI");


var $60x4y = parcelRequire("60x4y");

const $99e5a5c6ac11dcd8$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- fallback for insecure contexts where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $99e5a5c6ac11dcd8$var$SEND_MESSAGE_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).SEND_MESSAGE
]);
const $99e5a5c6ac11dcd8$var$CREATE_TERMINAL_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
    (0, $irnO2.ExperienceName).REMIX_INSERT
]);
const $99e5a5c6ac11dcd8$var$ROVO_SIDEBAR_HANDOFF_REASON = 'rovo_sidebar_handoff';
const $99e5a5c6ac11dcd8$var$IMAGE_GENERATION_SAFETY_ERROR_CODES = new Set([
    'ACCEPTABLE_USE_VIOLATIONS',
    'IMAGE_SAFETY_REJECTED',
    'SAFETY_VIOLATION'
]);
const $99e5a5c6ac11dcd8$var$toError = (error)=>error ?? new Error('aiMateSendMessage failed');
const $99e5a5c6ac11dcd8$var$getErrorCode = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return undefined;
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    if (typeof errorAttributes?.errorCode === 'string') return errorAttributes.errorCode;
    const detail = (0, $3PJhM.isRecord)(error.detail) ? error.detail : undefined;
    const message = (0, $3PJhM.isRecord)(detail?.message) ? detail.message : undefined;
    return typeof message?.message_template === 'string' ? message.message_template : undefined;
};
const $99e5a5c6ac11dcd8$var$getExpectedGenerationSuccessOutcome = (event)=>{
    const attributes = event.attributes;
    if (attributes?.isSafetyViolation === true) return 0, $60x4y.REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME;
    const error = 'error' in event ? event.error : undefined;
    const errorCode = $99e5a5c6ac11dcd8$var$getErrorCode(error) ?? attributes?.errorType;
    if (typeof errorCode === 'string' && $99e5a5c6ac11dcd8$var$IMAGE_GENERATION_SAFETY_ERROR_CODES.has(errorCode)) return 0, $60x4y.REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME;
    return undefined;
};
const $99e5a5c6ac11dcd8$var$withFeatureArea = (attributes, context)=>{
    const featureArea = context.featureArea ?? attributes?.featureArea;
    return {
        ...attributes,
        ...featureArea !== undefined && {
            featureArea: featureArea
        }
    };
};
let $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
const $99e5a5c6ac11dcd8$var$settleCreateContext = (context)=>{
    context.isCreateSettled = true;
    (0, $cvQra.remixCreateTerminalOwnership).release(context.remixCreateId);
};
const $99e5a5c6ac11dcd8$var$matchesTerminal = (event, context)=>{
    if (!$99e5a5c6ac11dcd8$var$CREATE_TERMINAL_EXPERIENCE_NAMES.has(event.name)) return false;
    const attributes = event.attributes;
    const eventRemixCreateId = attributes?.remixCreateId;
    if (context.remixCreateId && typeof eventRemixCreateId === 'string') return eventRemixCreateId === context.remixCreateId;
    const eventConversationId = attributes?.conversationId;
    if (context.conversationChannelId && typeof eventConversationId === 'string') return eventConversationId === context.conversationChannelId;
    return Boolean(context.allowCollectFallback);
};
const $99e5a5c6ac11dcd8$var$matchesSendMessageFailure = (event, context)=>{
    if (!$99e5a5c6ac11dcd8$var$SEND_MESSAGE_EXPERIENCE_NAMES.has(event.name) || event.action !== 'taskFail') return false;
    const attributes = event.attributes;
    if (attributes?.isRemixCreate !== true) return false;
    const requestConversationId = attributes?.conversationId;
    if (context.conversationChannelId && requestConversationId === context.conversationChannelId) return true;
    // If the event's conversationId is unavailable, fall back to the single-inflight
    // assumption (there is only one remix create stream at a time).
    return Boolean(context.allowCollectFallback);
};
const $99e5a5c6ac11dcd8$export$fce521e73e6e1f1e = (context)=>{
    let hasStopped = false;
    return (events, experience)=>{
        if (hasStopped || context.isCreateSettled) {
            hasStopped = true;
            return;
        }
        for (const event of events){
            // 1) Upstream generation-stream failure → succeed for a handled safety refusal,
            // otherwise fail the parent.
            if ($99e5a5c6ac11dcd8$var$matchesSendMessageFailure(event, context)) {
                hasStopped = true;
                $99e5a5c6ac11dcd8$var$settleCreateContext(context);
                const attributes = event.attributes;
                const successOutcome = $99e5a5c6ac11dcd8$var$getExpectedGenerationSuccessOutcome(event);
                if (successOutcome) {
                    experience.succeed({
                        attributes: {
                            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                            outcome: successOutcome,
                            succeededVia: event.name
                        }
                    });
                    return;
                }
                experience.fail({
                    error: $99e5a5c6ac11dcd8$var$toError(event.error),
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        failureSource: 'send_message_collect',
                        failureStage: 'request',
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            if (!$99e5a5c6ac11dcd8$var$matchesTerminal(event, context)) continue;
            const attributes = event.attributes;
            // 2) A terminal experience FAILED → succeed for a handled safety refusal,
            // otherwise fail the parent.
            if (event.action === 'taskFail') {
                hasStopped = true;
                $99e5a5c6ac11dcd8$var$settleCreateContext(context);
                const successOutcome = $99e5a5c6ac11dcd8$var$getExpectedGenerationSuccessOutcome(event);
                if (successOutcome) {
                    experience.succeed({
                        attributes: {
                            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                            outcome: successOutcome,
                            succeededVia: event.name
                        }
                    });
                    return;
                }
                experience.fail({
                    error: $99e5a5c6ac11dcd8$var$toError(event.error),
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        failureSource: 'terminal_collect',
                        failureStage: 'render',
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            // 3) A terminal experience ABORTED → abort the parent.
            if (event.action === 'taskAbort') {
                hasStopped = true;
                $99e5a5c6ac11dcd8$var$settleCreateContext(context);
                experience.abort({
                    reason: `terminal_${event.name}_aborted`,
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            // 4) A safety-marked terminal is a handled response, so succeed the reliability
            // parent with an explicit outcome.
            if (event.action === 'taskSuccess') {
                hasStopped = true;
                $99e5a5c6ac11dcd8$var$settleCreateContext(context);
                const successOutcome = $99e5a5c6ac11dcd8$var$getExpectedGenerationSuccessOutcome(event);
                if (successOutcome) {
                    experience.succeed({
                        attributes: {
                            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                            outcome: successOutcome,
                            succeededVia: event.name
                        }
                    });
                    return;
                }
                // An ordinary terminal success succeeds the parent immediately.
                experience.succeed({
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        succeededVia: event.name
                    }
                });
                return;
            }
        }
    };
};
const $99e5a5c6ac11dcd8$export$f53526ec87ae9eaf = ({ experienceTracker: experienceTracker, attributes: attributes, includeOpenMenuExperience: includeOpenMenuExperience = true })=>{
    const remixCreateId = $99e5a5c6ac11dcd8$var$randomId();
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: attributes?.remixType,
        existingFeatureArea: attributes?.featureArea
    });
    const startAttributes = {
        ...attributes,
        ...featureArea !== undefined && {
            featureArea: featureArea
        },
        remixCreateId: remixCreateId
    };
    const collectContext = {
        remixCreateId: remixCreateId,
        ...includeOpenMenuExperience && {
            openMenuAttributes: startAttributes
        },
        featureArea: featureArea,
        allowCollectFallback: true
    };
    $99e5a5c6ac11dcd8$var$activeCreateCollectContext = collectContext;
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        id: remixCreateId,
        attributes: startAttributes,
        collect: $99e5a5c6ac11dcd8$export$fce521e73e6e1f1e(collectContext)
    });
    if (includeOpenMenuExperience) experienceTracker.start({
        name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        id: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        attributes: startAttributes
    });
};
const $99e5a5c6ac11dcd8$export$8194201fd9adfb49 = ()=>$99e5a5c6ac11dcd8$var$activeCreateCollectContext?.isCreateSettled ? undefined : $99e5a5c6ac11dcd8$var$activeCreateCollectContext?.remixCreateId;
const $99e5a5c6ac11dcd8$export$701b0d2def6c3f0f = (experienceTracker)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context?.openMenuAttributes || context.isOpenMenuSettled) return;
    context.isOpenMenuSettled = true;
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        attributes: context.openMenuAttributes
    });
};
const $99e5a5c6ac11dcd8$export$257c90608280277d = (experienceTracker, error)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context?.openMenuAttributes || context.isOpenMenuSettled) return;
    context.isOpenMenuSettled = true;
    experienceTracker.fail({
        name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        error: error,
        attributes: context.openMenuAttributes
    });
};
const $99e5a5c6ac11dcd8$export$78cf909554bc5274 = (experienceTracker, attributes)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$settleCreateContext(context);
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            ...context.openMenuAttributes,
            ...attributes,
            succeededVia: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF
        }
    });
};
const $99e5a5c6ac11dcd8$export$c0ee5e8d253903d0 = (experienceTracker, isObjectSidebarPopup)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled || !isObjectSidebarPopup || context.openMenuAttributes?.entryPoint !== 'objectSidebar' || context.pendingSelectionAttributes?.remixType !== 'infographic') return;
    $99e5a5c6ac11dcd8$var$settleCreateContext(context);
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            ...context.openMenuAttributes,
            ...context.pendingSelectionAttributes,
            ...context.conversationChannelId && {
                conversationId: context.conversationChannelId
            },
            succeededVia: $99e5a5c6ac11dcd8$var$ROVO_SIDEBAR_HANDOFF_REASON
        }
    });
};
const $99e5a5c6ac11dcd8$export$f7f9deae8856cb4 = (experienceTracker)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$settleCreateContext(context);
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            ...context.openMenuAttributes,
            ...context.pendingSelectionAttributes,
            outcome: (0, $60x4y.REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME)
        }
    });
};
const $99e5a5c6ac11dcd8$export$3d7752ee631c9bec = (experienceTracker, error, attributes)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$settleCreateContext(context);
    experienceTracker.fail({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        error: error,
        attributes: {
            ...context.openMenuAttributes,
            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context)
        }
    });
};
const $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e = (experienceTracker, reason)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context) return;
    const attributes = {
        ...context.openMenuAttributes,
        ...context.pendingSelectionAttributes,
        reason: reason
    };
    if (context.openMenuAttributes && !context.isOpenMenuSettled) {
        context.isOpenMenuSettled = true;
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
            reason: reason,
            attributes: attributes
        });
    }
    if (!context.isCreateSettled && !(0, $cvQra.remixCreateTerminalOwnership).isOwnedByTerminal(context.remixCreateId)) {
        $99e5a5c6ac11dcd8$var$settleCreateContext(context);
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_CREATE,
            reason: reason,
            attributes: attributes
        });
    }
};
const $99e5a5c6ac11dcd8$export$c3cccc5477469a41 = (experienceTracker, hasCommitted, reason = 'User closed remix overlay')=>{
    if (!hasCommitted) $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e(experienceTracker, reason);
};
/**
 * Records a non-gating milestone sub-experience (select-option / show-loading) as
 * the flow advances: an instantaneous start-then-succeed. These are funnel
 * breadcrumbs; the parent's success is owned by the terminal experiences via
 * `collect`, not by these milestones.
 */ const $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone = (experienceTracker, name, attributes)=>{
    const remixCreateId = $99e5a5c6ac11dcd8$export$8194201fd9adfb49();
    const milestoneAttributes = {
        ...attributes,
        remixCreateId: remixCreateId
    };
    experienceTracker.start({
        name: name,
        id: name,
        attributes: milestoneAttributes
    });
    experienceTracker.succeed({
        name: name,
        attributes: milestoneAttributes
    });
};
const $99e5a5c6ac11dcd8$export$8ce0294ce28ac3ae = ({ remixType: remixType, remixSubtype: remixSubtype })=>{
    if (!$99e5a5c6ac11dcd8$var$activeCreateCollectContext || $99e5a5c6ac11dcd8$var$activeCreateCollectContext.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$activeCreateCollectContext.pendingSelectionAttributes = remixType === undefined && remixSubtype === undefined ? undefined : {
        remixType: remixType,
        remixSubtype: remixSubtype
    };
};
const $99e5a5c6ac11dcd8$export$88ef25856d821447 = ({ experienceTracker: experienceTracker, conversationId: conversationId, remixType: remixType, remixSubtype: remixSubtype, includesFreegenPrompt: includesFreegenPrompt })=>{
    if (conversationId) $99e5a5c6ac11dcd8$export$799e564bf3ca201c(experienceTracker, conversationId);
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: remixType,
        existingFeatureArea: $99e5a5c6ac11dcd8$var$activeCreateCollectContext?.featureArea
    });
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.featureArea = featureArea;
    const attributes = {
        remixType: remixType,
        remixSubtype: remixSubtype,
        includesFreegenPrompt: includesFreegenPrompt,
        ...featureArea !== undefined && {
            featureArea: featureArea
        }
    };
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.pendingSelectionAttributes = attributes;
    experienceTracker.updateAttributes({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: attributes
    });
    $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone(experienceTracker, (0, $irnO2.ExperienceName).REMIX_SELECT_OPTION, attributes);
    $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone(experienceTracker, (0, $irnO2.ExperienceName).REMIX_SHOW_LOADING, attributes);
};
const $99e5a5c6ac11dcd8$export$799e564bf3ca201c = (experienceTracker, conversationId)=>{
    experienceTracker.updateAttributes({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            conversationId: conversationId
        }
    });
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.conversationChannelId = conversationId;
};
module.exports["startRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$f53526ec87ae9eaf;
module.exports["getActiveRemixCreateId"] = $99e5a5c6ac11dcd8$export$8194201fd9adfb49;
module.exports["succeedRemixOpenMenuExperience"] = $99e5a5c6ac11dcd8$export$701b0d2def6c3f0f;
module.exports["failRemixOpenMenuExperience"] = $99e5a5c6ac11dcd8$export$257c90608280277d;
module.exports["succeedRemixCreateExperienceAtHandoff"] = $99e5a5c6ac11dcd8$export$78cf909554bc5274;
module.exports["succeedRemixCreateExperienceAtSidebarHandoff"] = $99e5a5c6ac11dcd8$export$c0ee5e8d253903d0;
module.exports["succeedRemixCreateExperienceForSafetyRefusal"] = $99e5a5c6ac11dcd8$export$f7f9deae8856cb4;
module.exports["failRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$3d7752ee631c9bec;
module.exports["abortRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e;
module.exports["abortRemixCreateExperienceIfNotCommitted"] = $99e5a5c6ac11dcd8$export$c3cccc5477469a41;
module.exports["updateRemixCreatePendingSelection"] = $99e5a5c6ac11dcd8$export$8ce0294ce28ac3ae;
module.exports["trackRemixCreateOptionSelected"] = $99e5a5c6ac11dcd8$export$88ef25856d821447;

});

parcelRegister("60x4y", function(module, exports) {
const $cb4dc77a42849518$export$c55fdf65d0c3a601 = 'image_generation_safety_violation';
module.exports["REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME"] = $cb4dc77a42849518$export$c55fdf65d0c3a601;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$9df55620e365effa = ()=>{
    const { isLoggedIn: isLoggedIn, hasConfluenceUser: hasConfluenceUser } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && !hasConfluenceUser;
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useIsAuthenticatedWithoutConfluenceUser"] = $30f02aa82d7102bc$export$9df55620e365effa;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("4tOXV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window?.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent ?? '';
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_4c065UFQfX _3iDTPbQ4SZ _0hPCNLDIqT",
    base: "_0bjKvDKxmn _4c065UFQfX _2Y7lL42ADO _3iDTPbvbI6 _2XsHFMFQfX _0adFHsFQfX",
    contentBefore: "_2XsHFM1Y8M _0adFHsPgdg",
    darkBackground: "_0KLXrueZ10",
    lightBackground: "_0KLXrumhAQ"
};
const $05ef07480c610d29$var$i18n = (0, $kSwu1.defineMessages)({
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $iMnC5.Box);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $w6R6I.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $cozmU.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("koEBx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $eJlpI = parcelRequire("eJlpI");

const $6173d76fe85d4dd6$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChromelessEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "chromeless",
            AppearanceComponent: (0, $eJlpI.default)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ChromelessEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $eJlpI.default)
    });
};
module.exports["ChromelessEditor"] = $6173d76fe85d4dd6$export$5252bd745392dcde;

});

parcelRegister("9EemN", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("k9wGn", function(module, exports) {
const $838c444502c02117$export$cc438a848c487501 = 'nativeEmbedDepth';
const $838c444502c02117$export$8de1a2f5887e1625 = 2;
const $838c444502c02117$export$5deb91d6dd3decbb = ()=>{
    if (typeof window === 'undefined') return 0;
    const raw = new URLSearchParams(window.location.search).get($838c444502c02117$export$cc438a848c487501);
    if (raw === null) return 0;
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed >= 0 ? Math.floor(parsed) : 0;
};
const $838c444502c02117$export$de0f33c023e33ebd = [
    'left',
    'center',
    'right',
    'wrap-left',
    'wrap-right'
];
const $838c444502c02117$export$11a9886c2819741 = 'center';
const $838c444502c02117$export$1770a45a9210903c = {
    url: undefined,
    alwaysShowTitle: false,
    alignment: $838c444502c02117$export$11a9886c2819741,
    borderColor: undefined,
    borderSize: undefined,
    displayText: undefined,
    height: 600,
    isMaxWidth: false,
    aspectRatio: 1,
    remixAppId: undefined,
    width: undefined
};
const $838c444502c02117$export$98d307a8fd081b69 = {
    ASK_ROVO: 'askRovo',
    REMIX: 'remix',
    REMIX_VARIANT: 'remixVariant',
    SUMMARISE: 'summarise',
    REFRESH: 'refresh',
    EDIT: 'edit',
    /** Opens unresolved comments or starts a whole-block comment draft. */ COMMENT: 'comment',
    EMBED: 'embed',
    BORDER: 'border',
    ALIGNMENT: 'alignment',
    OPEN_IN_NEW_WINDOW: 'openInNewWindow',
    /** Opens the embed's fullscreen preview dialog. */ EXPAND: 'expand',
    EDIT_URL: 'editUrl',
    ALWAYS_SHOW_TITLE: 'alwaysShowTitle',
    SET_EMBED_TYPE: 'setEmbedType',
    /**
	 * Copies the native-embed node to the clipboard.
	 */ COPY: 'copy',
    /**
	 * @private
	 * @deprecated Use `COPY` instead. `COPY_LINK` is a deprecated alias for `COPY` and will be removed in a future release.
	 */ COPY_LINK: 'copyLink',
    DELETE: 'delete',
    SEPARATOR: 'separator'
};
const $838c444502c02117$export$8637b4cdcb7cc177 = [
    'onAlignmentClick',
    'onAppearanceClick',
    'onAskRovoClick',
    'onSummariseClick',
    'onChangeBorderClick',
    'onCommentClick',
    'onCopyClick',
    'onCopyLinkClick',
    'onDeleteClick',
    'onEditClick',
    'onEditUrlClick',
    'onExpandClick',
    'onOpenInNewWindowClick',
    'onRefreshClick',
    'onSetEmbedTypeClick',
    'onShowTitleClick'
];
module.exports["EMBED_DEPTH_QUERY_PARAM"] = $838c444502c02117$export$cc438a848c487501;
module.exports["MAX_EMBED_DEPTH"] = $838c444502c02117$export$8de1a2f5887e1625;
module.exports["getCurrentEmbedDepth"] = $838c444502c02117$export$5deb91d6dd3decbb;
module.exports["ALIGNMENT_VALUES"] = $838c444502c02117$export$de0f33c023e33ebd;
module.exports["NATIVE_EMBED_PARAMETER_DEFAULTS"] = $838c444502c02117$export$1770a45a9210903c;
module.exports["BUILTIN_TOOLBAR_KEYS"] = $838c444502c02117$export$98d307a8fd081b69;
module.exports["EDITOR_TOOLBAR_HANDLER_KEYS"] = $838c444502c02117$export$8637b4cdcb7cc177;

});

parcelRegister("ljOiP", function(module, exports) {

var $k9wGn = parcelRequire("k9wGn");

const $a2a11cb02df7dc54$var$getMacroParamsRecord = (parameters)=>{
    if (!parameters?.macroParams || typeof parameters.macroParams !== 'object') return {};
    return parameters.macroParams;
};
const $a2a11cb02df7dc54$var$unwrapMacroParamValue = (macroParamValue)=>{
    if (macroParamValue && typeof macroParamValue === 'object' && 'value' in macroParamValue) return macroParamValue.value;
    return macroParamValue;
};
const $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS = {
    alignment: (value)=>(0, $k9wGn.ALIGNMENT_VALUES).includes(value)
};
/**
 * Explicitly declares the intended primitive type for each parameter key.
 * This is necessary for keys whose default value is `undefined` (e.g. `url`, `width`),
 * because `typeof undefined === 'undefined'` gives no type information for deserialization.
 */ const $a2a11cb02df7dc54$var$PARAMETER_TYPES = {
    alignment: 'string',
    alwaysShowTitle: 'boolean',
    aspectRatio: 'number',
    borderColor: 'string',
    borderSize: 'number',
    displayText: 'string',
    height: 'number',
    isMaxWidth: 'boolean',
    remixAppId: 'string',
    url: 'string',
    width: 'number'
};
const $a2a11cb02df7dc54$var$parseFromDefault = (defaultValue, value, explicitType)=>{
    const resolvedType = explicitType ?? typeof defaultValue;
    if (resolvedType === 'boolean') {
        if (typeof value === 'boolean') return value;
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
    if (resolvedType === 'number') {
        const parsed = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    // String-like values
    return typeof value === 'string' ? value : undefined;
};
const $a2a11cb02df7dc54$var$serializeParameterValue = (key, value)=>{
    const validator = $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS[key];
    if (validator && !validator(value)) return undefined;
    return value === undefined ? undefined : String(value);
};
const $a2a11cb02df7dc54$var$deserializeParameterValue = (key, value)=>{
    const parsedValue = $a2a11cb02df7dc54$var$parseFromDefault((0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key], value, $a2a11cb02df7dc54$var$PARAMETER_TYPES[key]);
    const validator = $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS[key];
    if (parsedValue === undefined) return undefined;
    if (validator && !validator(parsedValue)) return undefined;
    return parsedValue;
};
const $a2a11cb02df7dc54$export$c77521bc1ca83dcc = (parameters, key)=>{
    const macroParams = $a2a11cb02df7dc54$var$getMacroParamsRecord(parameters);
    if (!(key in macroParams)) return (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key];
    const value = $a2a11cb02df7dc54$var$unwrapMacroParamValue(macroParams[key]);
    const parsedValue = $a2a11cb02df7dc54$var$deserializeParameterValue(key, value);
    return parsedValue === undefined ? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key] : parsedValue;
};
/** Matches the version id embedded in a legacy `/remix/ui/{id}` embed URL. */ const $a2a11cb02df7dc54$var$REMIX_UI_ID_RE = /\/remix\/ui\/([\w-]+)/;
const $a2a11cb02df7dc54$export$1c0ae1ea8042d693 = ({ storedRemixAppId: storedRemixAppId, url: url })=>storedRemixAppId || (url ? url.match($a2a11cb02df7dc54$var$REMIX_UI_ID_RE)?.[1] ?? undefined : undefined);
function $a2a11cb02df7dc54$export$1d5e65f36fbcdb49(parameters, key) {
    if (key) return $a2a11cb02df7dc54$export$c77521bc1ca83dcc(parameters, key);
    return Object.fromEntries(Object.keys((0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)).map((defaultKey)=>[
            defaultKey,
            $a2a11cb02df7dc54$export$c77521bc1ca83dcc(parameters, defaultKey)
        ]));
}
const $a2a11cb02df7dc54$export$98091b65241a3a6 = (parameters, update)=>{
    return $a2a11cb02df7dc54$export$60752c4a8a24d484(parameters, update);
};
const $a2a11cb02df7dc54$export$60752c4a8a24d484 = (parameters, updates)=>{
    const currentParameters = parameters ?? {};
    const currentMacroParams = $a2a11cb02df7dc54$var$getMacroParamsRecord(parameters);
    const wrappedUpdates = Object.fromEntries(Object.entries(updates).map(([key, value])=>[
            key,
            $a2a11cb02df7dc54$var$serializeParameterValue(key, value)
        ]).filter(([, value])=>value !== undefined).map(([key, value])=>[
            key,
            {
                value: value
            }
        ]));
    return {
        ...currentParameters,
        macroParams: {
            ...currentMacroParams,
            ...wrappedUpdates
        }
    };
};
const $a2a11cb02df7dc54$export$46a0fc3fddbe8c3b = (config)=>config;
module.exports["getParameter"] = $a2a11cb02df7dc54$export$c77521bc1ca83dcc;
module.exports["resolveRemixVersionId"] = $a2a11cb02df7dc54$export$1c0ae1ea8042d693;
module.exports["getParameters"] = $a2a11cb02df7dc54$export$1d5e65f36fbcdb49;
module.exports["setParameter"] = $a2a11cb02df7dc54$export$98091b65241a3a6;
module.exports["setParameters"] = $a2a11cb02df7dc54$export$60752c4a8a24d484;
module.exports["createEditorToolbarActions"] = $a2a11cb02df7dc54$export$46a0fc3fddbe8c3b;

});

parcelRegister("c6zyu", function(module, exports) {

var $dfHaf = parcelRequire("dfHaf");

class $8e6c3e877675aabd$export$836557ee8d1dea33 {
    register(experienceId, enabled) {
        // Match the manifest registry: the first registration for an experience wins.
        if (this.capabilities.has(experienceId)) return;
        this.capabilities.set(experienceId, enabled);
        // Missing and explicitly disabled both resolve to false. Keep the snapshot stable.
        if (enabled) {
            this.snapshot = (0, $dfHaf.createNativeEmbedCommentSupport)(this.capabilities);
            this.listeners.forEach((listener)=>listener());
        }
    }
    constructor(){
        this.capabilities = new Map();
        this.snapshot = (0, $dfHaf.noNativeEmbedCommentSupport);
        this.listeners = new Set();
        this.getSnapshot = ()=>this.snapshot;
        this.subscribe = (listener)=>{
            this.listeners.add(listener);
            return ()=>{
                this.listeners.delete(listener);
            };
        };
    }
}
const $8e6c3e877675aabd$var$commentSupportStore = new $8e6c3e877675aabd$export$836557ee8d1dea33();
const $8e6c3e877675aabd$export$56ec1c299a522ea9 = ()=>$8e6c3e877675aabd$var$commentSupportStore;
module.exports["NativeEmbedCommentSupportStore"] = $8e6c3e877675aabd$export$836557ee8d1dea33;
module.exports["getNativeEmbedCommentSupportStore"] = $8e6c3e877675aabd$export$56ec1c299a522ea9;

});

parcelRegister("dfHaf", function(module, exports) {

var $2sp5n = parcelRequire("2sp5n");

const $4d8159fe49bf0947$export$1159198a8da29746 = ()=>false;
const $4d8159fe49bf0947$export$c100616865a311ef = (capabilities)=>{
    // Own the map so neither later registration nor caller mutation changes this snapshot.
    const snapshot = new Map(capabilities);
    return (node)=>{
        const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
        return node.type.name === 'extension' && extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && typeof extensionKey === 'string' && extensionKey.startsWith(`${(0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)}:`) && snapshot.get(extensionKey.slice((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY).length + 1)) === true;
    };
};
module.exports["noNativeEmbedCommentSupport"] = $4d8159fe49bf0947$export$1159198a8da29746;
module.exports["createNativeEmbedCommentSupport"] = $4d8159fe49bf0947$export$c100616865a311ef;

});

parcelRegister("bYNUA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6aaf5db72242d392e688c8c721d1e0da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b8c03b563f282f7$var$_react = $8b8c03b563f282f7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8b8c03b563f282f7$var$_iconNew = $8b8c03b563f282f7$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8b8c03b563f282f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/video-play-circle
 * Usage guidance:
 * Known uses: play video in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b8c03b563f282f7$var$VideoPlayCircleIcon = (props)=>/*#__PURE__*/ $8b8c03b563f282f7$var$_react.default.createElement($8b8c03b563f282f7$var$_iconNew.default, Object.assign({
        name: "VideoPlayCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5-2.694c0-.808.866-1.32 1.574-.931l4.958 2.722a1.062 1.062 0 0 1 0 1.862l-4.958 2.722A1.063 1.063 0 0 1 5 10.75zm1.5.74v3.965l3.611-1.983z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 10.01V6.046l3.611 1.983z"/>`
    }, props));
$8b8c03b563f282f7$var$VideoPlayCircleIcon.displayName = 'VideoPlayCircleIcon';
var $8b8c03b563f282f7$var$_default = module.exports.default = $8b8c03b563f282f7$var$VideoPlayCircleIcon;

});

parcelRegister("2Vug6", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");

const $e8ed4dc9830c4b79$export$c2c01e3edfc7c01f = '760 / 600';
const $e8ed4dc9830c4b79$export$b9d6ca739c42db77 = ({ manifest: manifest, width: width })=>width ?? manifest?.parameterDefaults?.width;
const $e8ed4dc9830c4b79$export$2dd05db6133b6a99 = ({ manifest: manifest, parameters: parameters, placeholderId: placeholderId })=>{
    const { alignment: alignment, aspectRatio: aspectRatio, height: height, width: width } = (0, $ljOiP.getParameters)(parameters);
    const effectiveWidth = $e8ed4dc9830c4b79$export$b9d6ca739c42db77({
        manifest: manifest,
        width: width
    });
    // `getParameters` always supplies default values, so inspect raw macroParams to distinguish
    // stored dimensions from package defaults. This prevents the default aspectRatio from affecting
    // older embeds that never persisted original dimensions.
    const macroParams = parameters?.macroParams;
    const heightExplicitlyStored = !!macroParams?.height;
    const aspectRatioExplicitlyStored = !!macroParams?.aspectRatio;
    const effectiveHeightRaw = heightExplicitlyStored ? height : manifest?.parameterDefaults?.height ?? null;
    const effectiveHeight = aspectRatioExplicitlyStored && aspectRatio != null && aspectRatio > 0 && effectiveWidth != null && !heightExplicitlyStored ? Math.round(effectiveWidth / aspectRatio) : effectiveHeightRaw ?? height;
    const lockAspectRatio = typeof manifest?.lockResizeAspectRatio === 'function' ? manifest.lockResizeAspectRatio() : manifest?.lockResizeAspectRatio ?? true;
    return {
        alignment: alignment,
        effectiveHeight: effectiveHeight,
        effectiveWidth: effectiveWidth,
        hasEmbedBorder: manifest?.uiConfig?.showBorder ?? true,
        lockAspectRatio: lockAspectRatio,
        placeholderId: placeholderId
    };
};
module.exports["NATIVE_EMBED_INITIAL_LAYOUT_FALLBACK_ASPECT_RATIO"] = $e8ed4dc9830c4b79$export$c2c01e3edfc7c01f;
module.exports["resolveNativeEmbedEffectiveWidth"] = $e8ed4dc9830c4b79$export$b9d6ca739c42db77;
module.exports["resolveNativeEmbedInitialLayout"] = $e8ed4dc9830c4b79$export$2dd05db6133b6a99;

});

parcelRegister("c2p9O", function(module, exports) {
/**
 * Injected by the extension UI via Global; also exported for consumers who inject styles elsewhere.
 */ /* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles -- Native embed placement must target renderer/editor ancestor wrappers that the embed component does not own. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Extension container override requires :has and !important

var $lOiVq = parcelRequire("lOiVq");

function $35959f819cab4a83$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $35959f819cab4a83$var$wrapGap = "var(--ds-space-150, 12px)";
const $35959f819cab4a83$var$noWrapGap = "var(--ds-space-300, 24px)";
const $35959f819cab4a83$export$4f468ea4dd4fc462 = /*#__PURE__*/ (0, $lOiVq.css)({
    // Remove margin on extension-overflow-wrapper when it contains a native embed to prevent width overflow.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target overflow wrapper by data attribute
    '.extension-overflow-wrapper:has([data-native-embed-alignment])': {
        margin: '0 !important'
    },
    // The renderer sets overflow-x:auto on .ak-renderer-extension-overflow-container, which clips a
    // pixel-resized native embed that is wider than the text column and prevents centering from
    // working (the scroll container also becomes the reference for the 50% offset). Override to
    // visible so the embed can break out symmetrically on both sides, exactly as images do.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target overflow container by data attribute
    '.ak-renderer-extension-overflow-container:has([data-native-embed-alignment])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- !important string requires type cast incompatible with the CSSProperties type
        overflowX: 'visible !important'
    },
    // For a center-aligned embed with an explicit pixel width, the outer .ak-renderer-extension
    // wrapper's width is set directly as an inline style by the native embed useEffect (to override
    // the renderer's own inline style="width:100%"). These CSS rules apply the centering transforms
    // on that same wrapper — now that it has the exact pixel width, margin-left:50% +
    // translateX(-50%) breaks it out symmetrically, exactly as MediaSingle does for images.
    // max-width:100cqw prevents overflow beyond the container while still allowing
    // the embed to break out of the narrow layout column (unlike 100% which would
    // clamp to the ~760px parent).
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target renderer extension wrapper by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="center"]):has([data-native-embed-width])': {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space -- geometric centering offset, not a spacing value
        marginLeft: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '100cqw'
    },
    // Before the async native embed UI mounts, no effect is available to size the renderer's outer
    // extension wrapper. Shrink-wrap it to the placeholder's persisted width so alignment and text
    // wrapping are correct on first paint. Top-level embeds may break out to the renderer container;
    // nested embeds clamp to their immediate layout/table/extension parent.
    // The renderer's inner wrapper is normally an inline-size query container. Inline-size containment
    // contributes zero intrinsic width, which collapses a fit-content extension wrapper to 0px. Turn
    // that containment off only while an explicit-width placeholder is mounted; the native embed UI
    // restores the normal renderer path once it loads and imperatively sizes the outer wrapper.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target the renderer-owned size container by the shared placeholder marker
    '.ak-renderer-extension-inner-wrapper:has([data-native-embed-initial-placeholder="true"][data-native-embed-width])': {
        containerType: 'normal'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target the renderer-owned wrapper by the shared native embed placeholder marker
    '.ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width])': {
        width: 'fit-content !important',
        maxWidth: '100cqw'
    },
    // The editor loading path intentionally keeps its outer extension container at 100% width.
    // Align the already-sized placeholder frame within that container until the native embed UI
    // mounts and takes ownership of the outer wrapper's persisted width.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target the editor loading frame through its shared placeholder metadata
    '[data-native-embed-initial-placeholder="true"][data-native-embed-alignment="center"] > [data-testid="native-embed-initial-placeholder"]': {
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target the editor loading frame through its shared placeholder metadata
    '[data-native-embed-initial-placeholder="true"][data-native-embed-alignment="right"] > [data-testid="native-embed-initial-placeholder"]': {
        marginLeft: 'auto'
    },
    // Some renderer variants omit data-top-level even for top-level extensions. Mirror the native
    // embed runtime's DOM nesting detection instead: table cells/headers, expands, layouts, enclosing
    // extensions, sync blocks, and panels clamp the placeholder to the immediate containing node.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Mirror native embed runtime nesting ancestors before its mounting effect is available
    'td .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), th .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), [data-node-type="expand"] .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), [data-layout-section] .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), .ak-renderer-extension .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), [data-bodied-sync-block] .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width]), .ak-editor-panel .ak-renderer-extension:has([data-native-embed-initial-placeholder="true"][data-native-embed-width])': {
        maxWidth: '100%'
    },
    // Width: 100% when no explicit width set; fit-content when data-native-embed-width is set.
    // Combined selectors cover both .extension-container (editor) and .ak-renderer-extension (renderer)
    // which use different wrapper class names for the same structural element.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment]):not(:has([data-native-embed-width])), .ak-renderer-extension:has([data-native-embed-alignment]):not(:has([data-native-embed-width]))': {
        width: '100% !important',
        marginLeft: '0 !important',
        marginRight: '0 !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Match editor/renderer wrapper clipping and selected-node ring to the native embed frame radius.
    // Borderless experiences keep the smaller core wrapper radius so their iframe content is not clipped
    // to a framed shape they do not visually own.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by the resolved showBorder value
    '.extension-container:has([data-native-embed-show-border="true"]), .ak-renderer-extension:has([data-native-embed-show-border="true"])': {
        borderRadius: "var(--ds-radius-xlarge, 12px)"
    },
    // In the editor, the --native-embed-width CSS variable is set on .extension-container by the
    // resize plugin. When the embed is nested inside another node (e.g. a table cell or expand),
    // data-native-embed-nested is present and we use maxWidth so the embed shrinks with the parent.
    // When the embed is top-level (not nested), we use width so it takes the exact pixel size.
    // In the renderer, width is set directly as an inline style on .ak-renderer-extension (overriding
    // the renderer's own inline style="width:100%"), so no CSS variable rule is needed for the renderer.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target nested extension container by data attribute on the container itself
    '.extension-container[data-native-embed-nested]:has([data-native-embed-alignment]):has([data-native-embed-width])': {
        maxWidth: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // The second selector adds an ID-level specificity bump so this rule also wins in full-width mode
    // (Confluence "wide" page width), where the editor applies `width: 100% !important` to
    // `.extension-container.block` via a rule scoped under
    // `.fabric-editor--full-width-mode:not(:has(#chromeless-editor))` with specificity (1, 3, 0).
    // Without the second selector, the native embed's (0, 3, 0) rule loses the cascade battle.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Second selector matches specificity of editor-core's full-width-mode rule; own ID won't work as our div is inside .extension-container, not an ancestor
    '.extension-container:not([data-native-embed-nested]):has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) .extension-container.block:not([data-native-embed-nested]):has([data-native-embed-alignment]):has([data-native-embed-width])': {
        width: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Layout column resizing can temporarily rebuild column content before the
    // native embed plugin re-syncs data-native-embed-nested. Fall back to the
    // actual layout-column DOM ancestry so an embed in a column still shrinks to
    // the column instead of taking its stored pixel width.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- DOM ancestry fallback for transient missing data-native-embed-nested
    '.ProseMirror [data-layout-column] .extension-container:has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) [data-layout-column] .extension-container.block:has([data-native-embed-alignment]):has([data-native-embed-width])': {
        width: 'auto !important',
        maxWidth: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Panel divider resizing can temporarily rebuild panel content before the
    // native embed plugin re-syncs data-native-embed-nested. Support both the
    // panel wrapper used by the old style and the content wrapper introduced by
    // the new style, but only while the native embed containment kill switch is off.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- DOM ancestry fallback for transient missing data-native-embed-nested
    '.ProseMirror .ak-editor-panel .extension-container:has([data-native-embed-panel-resize-containment="true"]):has([data-native-embed-alignment]):has([data-native-embed-width]), .ProseMirror .ak-editor-panel__content .extension-container:has([data-native-embed-panel-resize-containment="true"]):has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) .ak-editor-panel .extension-container.block:has([data-native-embed-panel-resize-containment="true"]):has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) .ak-editor-panel__content .extension-container.block:has([data-native-embed-panel-resize-containment="true"]):has([data-native-embed-alignment]):has([data-native-embed-width])': {
        width: 'auto !important',
        maxWidth: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Override the extension wrapper's width so alignment margins take effect.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="left"]), .ak-renderer-extension:has([data-native-embed-alignment="left"])': {
        margin: `${$35959f819cab4a83$var$noWrapGap} auto ${$35959f819cab4a83$var$noWrapGap} 0 !important`,
        overflow: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="center"]), .ak-renderer-extension:has([data-native-embed-alignment="center"])': {
        margin: `${$35959f819cab4a83$var$noWrapGap} 0 !important`,
        position: 'relative',
        left: '50%',
        transform: 'translateX(-50%)',
        marginLeft: '0 !important',
        marginRight: '0 !important'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="right"]), .ak-renderer-extension:has([data-native-embed-alignment="right"])': {
        margin: `${$35959f819cab4a83$var$noWrapGap} 0 ${$35959f819cab4a83$var$noWrapGap} auto !important`,
        overflow: 'auto'
    },
    // wrap-left / wrap-right: float + margin like MediaSingle so text wraps around the embed.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="wrap-left"])': {
        float: 'left',
        margin: `${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} auto !important`,
        maxWidth: `calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$35959f819cab4a83$var$wrapGap})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="wrap-left"])': {
        float: 'left',
        margin: `${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} auto !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="wrap-right"])': {
        float: 'right',
        margin: `${$35959f819cab4a83$var$wrapGap} auto ${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} !important`,
        maxWidth: `calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$35959f819cab4a83$var$wrapGap})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="wrap-right"])': {
        float: 'right',
        margin: `${$35959f819cab4a83$var$wrapGap} auto ${$35959f819cab4a83$var$wrapGap} ${$35959f819cab4a83$var$wrapGap} !important`
    },
    // Raised frames own their shadow and content clipping. The editor overflow wrapper and
    // left/right alignment containers must let that shadow paint outside the frame bounds.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target host wrappers only when the experience opts into a raised frame
    '.extension-overflow-wrapper:not(.with-body):has([data-native-embed-frame-elevation="raised"]), .extension-container:has([data-native-embed-frame-elevation="raised"]), .ak-renderer-extension:has([data-native-embed-frame-elevation="raised"])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Override editor-owned overflow styles regardless of injection order
        overflow: 'visible !important',
        borderRadius: "var(--ds-radius-large, 8px)"
    },
    // Suppress the hover box-shadow on the extension container for all native embeds.
    // Native embeds provide their own chrome so the generic extension hover ring is not appropriate.
    // The selection ring (from .ak-editor-selected-node) is also applied as a box-shadow,
    // and would be incorrectly hidden on hover without the :not() guard.
    // Using :not(.ak-editor-selected-node *) avoids coupling to the intermediate DOM structure.
    // In the renderer there is no selection ring so the :not() guard is not needed.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrapper hover by data attribute
    '.extension-container:has([data-native-embed-alignment]):not(.ak-editor-selected-node *):hover': {
        boxShadow: 'none !important'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target renderer extension wrapper hover by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment]):hover': {
        boxShadow: 'none !important'
    },
    // Suppress the selection ring (box-shadow from .ak-editor-selected-node) for database embeds.
    // Database embeds use appearance="minimal" with no content border, so the selection ring
    // creates a jarring visual effect around a borderless embed.
    // The box-shadow is applied by editor-core to `.extension-container` via the selector:
    //   `.extensionView-content-wrap.ak-editor-selected-node > span > .extension-container`
    // We target `.extension-container` directly using :has() to check for the experience attribute
    // on the inner div, matching regardless of the intermediate DOM structure.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension-container for database embeds when selected
    '.extension-container:has([data-native-embed-experience="database"])': {
        boxShadow: 'none !important'
    }
});
const $35959f819cab4a83$export$6eeb7d635d109e73 = {
    name: "1wyuj2l",
    styles: ".inline-extension-renderer:has(> [data-native-embed-experience=\"maui\"][data-native-embed-inline-width=\"true\"]:not([data-native-embed-width])){width:100%;margin-left:0;margin-right:0;}.inline-extension:has(> .extension-container.inline > [data-native-embed-experience=\"maui\"][data-native-embed-inline-width=\"true\"]:not([data-native-embed-width])){width:100%;}.extension-container.inline > [data-native-embed-experience=\"maui\"][data-native-embed-inline-width=\"true\"]:not([data-native-embed-width]){width:100%;}"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-important-styles */ 
module.exports["nativeEmbedAlignmentStyles"] = $35959f819cab4a83$export$4f468ea4dd4fc462;
module.exports["nativeEmbedInlineMauiWidthStyles"] = $35959f819cab4a83$export$6eeb7d635d109e73;

});

parcelRegister("7yhDb", function(module, exports) {
$parcel$export(module.exports, "resolveNativeEmbedInitialLayout", () => (parcelRequire("2Vug6")).resolveNativeEmbedInitialLayout);
/* initial-placeholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $2Vug6 = parcelRequire("2Vug6");


var $c2p9O = parcelRequire("c2p9O");

const $00899cff5c3558ef$var$placeholderFrameStyles = null;
const $00899cff5c3558ef$var$borderedPlaceholderFrameStyles = null;
const $00899cff5c3558ef$var$borderlessPlaceholderFrameStyles = null;
const $00899cff5c3558ef$export$608c5cf5128f3cea = ({ effectiveHeight: effectiveHeight, effectiveWidth: effectiveWidth, hasEmbedBorder: hasEmbedBorder = true, lockAspectRatio: lockAspectRatio, placeholderId: placeholderId, testId: testId = 'native-embed-initial-placeholder' })=>{
    const placeholderStyle = {
        width: effectiveWidth ? `${effectiveWidth}px` : '100%',
        height: lockAspectRatio ? 'auto' : `${effectiveHeight}px`,
        aspectRatio: lockAspectRatio ? effectiveWidth && effectiveHeight ? `${effectiveWidth} / ${effectiveHeight}` : (0, $2Vug6.NATIVE_EMBED_INITIAL_LAYOUT_FALLBACK_ASPECT_RATIO) : undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        ...placeholderId && {
            'data-ssr-placeholder': placeholderId
        },
        style: placeholderStyle,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _24h04i2Njc _1EqgXlN91d _0KLXrunmFW",
            hasEmbedBorder ? "_0bjKvDyzSk _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67" : "_0bjKvDKxmn"
        ])
    });
};
const $00899cff5c3558ef$export$5337b94b2c29c93 = ({ firstPaint: firstPaint = false, manifest: manifest, parameters: parameters, placeholderId: placeholderId, shouldFillInlineWidth: shouldFillInlineWidth = false, testId: testId })=>{
    const { alignment: alignment, effectiveHeight: effectiveHeight, effectiveWidth: effectiveWidth, hasEmbedBorder: hasEmbedBorder, lockAspectRatio: lockAspectRatio, placeholderId: resolvedPlaceholderId } = (0, $2Vug6.resolveNativeEmbedInitialLayout)({
        manifest: manifest,
        parameters: parameters,
        placeholderId: placeholderId
    });
    const fillInlineWidth = shouldFillInlineWidth && manifest?.id === 'maui' && effectiveWidth === undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-native-embed-alignment": alignment,
        "data-native-embed-experience": manifest?.id === 'maui' ? 'maui' : undefined,
        "data-native-embed-inline-width": fillInlineWidth ? 'true' : undefined,
        "data-native-embed-first-paint-placeholder": firstPaint ? 'true' : undefined,
        "data-native-embed-initial-placeholder": "true",
        "data-native-embed-width": effectiveWidth,
        "data-native-embed-show-border": hasEmbedBorder ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOiVq.Global), {
        styles: (0, $c2p9O.nativeEmbedAlignmentStyles)
    }), fillInlineWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOiVq.Global), {
        styles: (0, $c2p9O.nativeEmbedInlineMauiWidthStyles)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($00899cff5c3558ef$export$608c5cf5128f3cea, {
        effectiveHeight: effectiveHeight,
        effectiveWidth: effectiveWidth,
        hasEmbedBorder: hasEmbedBorder,
        lockAspectRatio: lockAspectRatio,
        placeholderId: resolvedPlaceholderId,
        testId: testId
    }));
};
module.exports["NativeEmbedInitialPlaceholderFrame"] = $00899cff5c3558ef$export$608c5cf5128f3cea;
module.exports["NativeEmbedInitialPlaceholder"] = $00899cff5c3558ef$export$5337b94b2c29c93;

});

parcelRegister("GqOIS", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * `ScribbleBar` - the single "redacted" visual primitive.
 *
 * Renders an inline hand-drawn scribble that stands in for redacted content.
 * The stored text/ADF is already masked by the backend; this component only
 * makes the mask look intentional, branded, and accessible.
 *
 * Behavior (goal state, from Jono's PoC + the shipped Rovo Chat token):
 *   - Several SVG wavy strokes drawn left-to-right on mount (pen-scribble motion).
 *   - Respects `prefers-reduced-motion`: strokes render statically, no animation.
 *   - On hover/focus the strokes recolor to `color.background.accent.gray.bolder`
 *     and a Guard icon fades in as an affordance that the span is an intentional
 *     redaction. The darker fill keeps the icon legible on top of the strokes.
 *   - Wrapped in a two-line tooltip: "Redacted by your organization. / Powered
 *     by Atlassian Guard."
 *   - Always carries an accessible label so screen readers announce it.
 *
 * Ported from the Rovo Chat redaction token. Tuning lives in `./params` and the
 * stroke geometry in `./geometry`.
 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $9Ha4j = parcelRequire("9Ha4j");


var $2sQTo = parcelRequire("2sQTo");


var $6oxxi = parcelRequire("6oxxi");


var $caEjt = parcelRequire("caEjt");

const $0859956edfd5b2de$var$styles = {
    container: "_30huDKYbGa _0bjKvDcjp5 _034jHtYbGa _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0KLXrujOvk _1UtDYzy7kJ _1mT5xdRAKS _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0jFU0VMmFU _3v5uP0RvL4 _1RrJLit2nV _0wOv4Q18ZR _20VacPYbGa _1ubuxonXvL _1NDpvb6wH8 _2wtOC9vc3e _34b3D2FQfX",
    svg: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdWVPG _2IhTonPgdg _4ApkO2Pgdg _0Bm75GPgdg _3OE6xYPgdg _1pp6NdYbGa _4e1TYv98eZ _3Z9K0wb8VS _1kOSYtKgXx _0qk6IKUtCU",
    svgActive: "_4e1TYvrxgm",
    icon: "_3iDTPbccYA _1mT5xdRAKS _42Yu6B7dHp _1VJPcaqBji _1YKVNsdnbC _3Z9K0wb8VS _1kOSYt9v2r _0qk6IKUtCU",
    iconActive: "_1YKVNs7dHp"
};
function $0859956edfd5b2de$var$prefersReducedMotion() {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
} /**
   * Measures the container and drives the sequential stroke draw animation.
   * Ported from the Rovo Chat redaction token.
   */ 
function $0859956edfd5b2de$var$useScribbleAnimationInternal(activationDelay) {
    const containerRef = (0, $cozmU.useRef)(null);
    const pathRefs = (0, $cozmU.useRef)([]);
    const [pathData, setPathData] = (0, $cozmU.useState)([]);
    const [svgDims, setSvgDims] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const rafId = requestAnimationFrame(()=>{
            const { width: width, height: height } = el.getBoundingClientRect();
            const w = width || el.offsetWidth;
            const h = height || el.offsetHeight;
            if (w > 0 && h > 0) {
                setSvgDims({
                    w: w,
                    h: h
                });
                setPathData((0, $6oxxi.generateStrokes)(w, h));
            }
        });
        return ()=>cancelAnimationFrame(rafId);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!pathData.length || !svgDims) return;
        const paths = pathRefs.current.filter((p)=>p !== null);
        if (!paths.length) return;
        const lengths = paths.map((p)=>p.getTotalLength()); // Reduced motion: render every stroke fully drawn, skip animation.
        if ($0859956edfd5b2de$var$prefersReducedMotion()) {
            paths.forEach((p)=>{
                p.style.strokeDasharray = 'none';
                p.style.strokeDashoffset = '0';
            });
            return;
        }
        paths.forEach((p, i)=>{
            p.style.strokeDasharray = String(lengths[i]);
            p.style.strokeDashoffset = String(lengths[i]);
        });
        let animRafId;
        const timerId = setTimeout(()=>{
            const strokeDuration = (0, $caEjt.PARAMS).duration / paths.length;
            const startTime = performance.now();
            const tick = (now)=>{
                const elapsed = now - startTime;
                let stillAnimating = false;
                paths.forEach((p, i)=>{
                    const strokeElapsed = elapsed - i * strokeDuration;
                    if (strokeElapsed < 0) {
                        p.style.strokeDashoffset = String(lengths[i]);
                        stillAnimating = true;
                    } else if (strokeElapsed >= strokeDuration) p.style.strokeDashoffset = '0';
                    else {
                        const localT = strokeElapsed / strokeDuration;
                        const progress = 1 - (1 - localT) ** 2;
                        p.style.strokeDashoffset = String(lengths[i] * (1 - progress));
                        stillAnimating = true;
                    }
                });
                if (stillAnimating) animRafId = requestAnimationFrame(tick);
            };
            animRafId = requestAnimationFrame(tick);
        }, activationDelay);
        return ()=>{
            clearTimeout(timerId); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- animRafId may be unset
            if (animRafId) cancelAnimationFrame(animRafId);
        };
    }, [
        pathData,
        svgDims,
        activationDelay
    ]);
    return {
        containerRef: containerRef,
        pathRefs: pathRefs,
        pathData: pathData,
        svgDims: svgDims
    };
}
const $0859956edfd5b2de$export$168ed64195daae62 = ({ label: label, delay: delay = (0, $caEjt.PARAMS).delay })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const accessibleLabel = label ?? formatMessage((0, $2sQTo.messages).redactedTokenA11y);
    const { containerRef: containerRef, pathRefs: pathRefs, pathData: pathData, svgDims: svgDims } = $0859956edfd5b2de$var$useScribbleAnimationInternal(delay); // Tracked separately: the editor reclaims focus after a click, and that blur
    // must not drop the hover state.
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const isActive = isHovered || isFocused;
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, formatMessage((0, $2sQTo.messages).redactedTooltipLine1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, formatMessage((0, $2sQTo.messages).redactedTooltipLine2)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipContent,
        position: "top"
    }, ({ ref: tooltipRef, onFocus: onTooltipFocus, onBlur: onTooltipBlur, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            ...tooltipProps,
            type: "button",
            ref: (node)=>{
                containerRef.current = node;
                tooltipRef(node); // A bar that mounts under the pointer gets no mouseenter.
                if (node?.matches(':hover')) setIsHovered(true);
            },
            // tooltip trigger: it is keyboard-focusable by default (no
            // `tabIndex` on a non-interactive node), so keyboard users can reach
            // the tooltip (redaction reason / "Powered by Atlassian Guard") and
            // the Guard-icon affordance that pointer users get on hover.
            "aria-label": accessibleLabel,
            "data-testid": "guard-scribble-bar",
            // hover ring and overlay. No effect outside the editor.
            "data-inline-extension-layout": "flow",
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false),
            onFocus: (event)=>{
                onTooltipFocus(event);
                setIsFocused(true);
            },
            onBlur: (event)=>{
                onTooltipBlur(event);
                setIsFocused(false);
            },
            className: (0, $hekY6.default)([
                $0859956edfd5b2de$var$styles.container
            ])
        }, svgDims && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: svgDims.w,
            height: svgDims.h,
            viewBox: `0 0 ${svgDims.w} ${svgDims.h}`,
            "data-testid": "guard-scribble-strokes",
            "aria-hidden": "true",
            focusable: "false",
            className: (0, $hekY6.default)([
                $0859956edfd5b2de$var$styles.svg,
                isActive && $0859956edfd5b2de$var$styles.svgActive
            ])
        }, pathData.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
                key: i,
                ref: (el)=>{
                    pathRefs.current[i] = el;
                },
                d: d,
                fill: "none",
                strokeLinecap: "round",
                strokeWidth: (0, $6oxxi.EFFECTIVE_STROKE_WIDTH)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $0859956edfd5b2de$var$styles.icon,
                isActive && $0859956edfd5b2de$var$styles.iconActive
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Ha4j.GuardIcon), {
            appearance: "brand",
            size: "xxsmall",
            label: ""
        }))));
}; /**
    * Legacy hook retained for backwards compatibility with the 0.2.x published API,
    * which exposed `useScribbleAnimation` returning an SVG `ref`. The draw
    * animation is now fully encapsulated inside {@link ScribbleBar} (see
    * `useScribbleAnimationInternal`), so this hook is no longer needed and new
    * call sites should not use it. It returns a stable `ref` so existing call sites
    * keep compiling; the ref is inert.
    */ 
const $0859956edfd5b2de$export$6cdf261c0c5add35 = ()=>{
    // useRef (not useMemo) guarantees a stable wrapper identity across renders.
    const wrapper = (0, $cozmU.useRef)({
        ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef()
    });
    return wrapper.current;
};
module.exports["ScribbleBar"] = $0859956edfd5b2de$export$168ed64195daae62;

});

parcelRegister("2sQTo", function(module, exports) {
/**
 * Centralised i18n descriptors for `@atlassian/guard-redaction-ui`.
 *
 * Consumers should not redefine these strings — they are shared across all
 * Guard redaction surfaces so a translation change lands in one place.
 */ 
var $kSwu1 = parcelRequire("kSwu1");

const $3ccfb95ec5aea942$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    redactedByOrganization: {
        id: "guard-redaction-ui.enforcement.redacted",
        defaultMessage: "Redacted by your organization"
    },
    blockedByOrganization: {
        id: "guard-redaction-ui.enforcement.blocked",
        defaultMessage: "Blocked by your organization"
    },
    blockedBodyGeneric: {
        id: "guard-redaction-ui.block.body.generic",
        defaultMessage: "This was blocked by your organization\u2019s data security policy."
    },
    blockedBodyResponse: {
        id: "guard-redaction-ui.block.body.response",
        defaultMessage: "The response was blocked by your organization\u2019s data security policy."
    },
    traceId: {
        id: "guard-redaction-ui.block.trace-id",
        defaultMessage: "Trace ID: {traceId}"
    },
    redactedTokenA11y: {
        id: "guard-redaction-ui.scribble.a11y",
        defaultMessage: "Redacted content"
    },
    redactedTooltipLine1: {
        id: "guard-redaction-ui.scribble.tooltip.line1",
        defaultMessage: "Redacted by your organization."
    },
    redactedTooltipLine2: {
        id: "guard-redaction-ui.scribble.tooltip.line2",
        defaultMessage: "Powered by Atlassian Guard."
    },
    flagTitle: {
        id: "guard-redaction-ui.flag.title",
        defaultMessage: "Redacted by your organization"
    },
    flagDescriptionSingular: {
        id: "guard-redaction-ui.flag.description.singular",
        defaultMessage: "Sensitive information was detected in the {location} and has been redacted."
    },
    flagDescriptionPlural: {
        id: "guard-redaction-ui.flag.description.plural",
        defaultMessage: "{count} sensitive items were detected in the {location} and have been redacted."
    },
    flagRemoveRedaction: {
        id: "guard-redaction-ui.flag.action.remove-redaction",
        defaultMessage: "Remove redaction"
    },
    flagRemoveRedactions: {
        id: "guard-redaction-ui.flag.action.remove-redactions",
        defaultMessage: "Remove redactions"
    },
    flagLearnMore: {
        id: "guard-redaction-ui.flag.action.learn-more",
        defaultMessage: "Learn more"
    },
    flagIconLabel: {
        id: "guard-redaction-ui.flag.icon.label",
        defaultMessage: "Atlassian Guard"
    },
    flagLocationPageBody: {
        id: "guard-redaction-ui.flag.location.page-body",
        defaultMessage: "page body"
    },
    flagLocationPageTitle: {
        id: "guard-redaction-ui.flag.location.page-title",
        defaultMessage: "page title"
    },
    flagLocationComment: {
        id: "guard-redaction-ui.flag.location.comment",
        defaultMessage: "comment"
    },
    flagLocationIssueDescription: {
        id: "guard-redaction-ui.flag.location.issue-description",
        defaultMessage: "description"
    },
    flagLocationIssueSummary: {
        id: "guard-redaction-ui.flag.location.issue-summary",
        defaultMessage: "summary"
    },
    flagLocationCustomField: {
        id: "guard-redaction-ui.flag.location.custom-field",
        defaultMessage: "custom field"
    }
});
module.exports["messages"] = $3ccfb95ec5aea942$export$defe85febe8b728c;

});

parcelRegister("6oxxi", function(module, exports) {
/**
 * Stroke geometry for the `ScribbleBar`: pure functions from the bar's size to
 * SVG path strings, kept out of the component so containment is unit testable.
 *
 * A cubic bezier stays within the convex hull of its control points, so keeping
 * every point half a stroke (plus wiggle) inside the per-edge insets keeps the
 * drawn ink inside them too.
 */ 
var $caEjt = parcelRequire("caEjt");

const $3a5557d9ea064e0e$export$a35b1a25efe697a5 = Math.max(20 * (0, $caEjt.PARAMS).strokeWidth, 6);
const $3a5557d9ea064e0e$var$HALF_STROKE = $3a5557d9ea064e0e$export$a35b1a25efe697a5 / 2;
const $3a5557d9ea064e0e$export$e6bd8832925633b8 = (0, $caEjt.PARAMS).insetTop + $3a5557d9ea064e0e$var$HALF_STROKE + (0, $caEjt.PARAMS).wiggle;
const $3a5557d9ea064e0e$export$2f878cc6c7c44381 = (0, $caEjt.PARAMS).insetBottom + $3a5557d9ea064e0e$var$HALF_STROKE + (0, $caEjt.PARAMS).wiggle;
const $3a5557d9ea064e0e$export$e0b66c24764c59ce = (0, $caEjt.PARAMS).insetX + $3a5557d9ea064e0e$var$HALF_STROKE;
const $3a5557d9ea064e0e$var$REFERENCE_LINE_HEIGHT = 20;
const $3a5557d9ea064e0e$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
const $3a5557d9ea064e0e$var$random = (amplitude)=>(Math.random() * 2 - 1) * amplitude;
const $3a5557d9ea064e0e$var$cubic = (p0, p1, p2, p3, t)=>{
    const u = 1 - t;
    return u * u * u * p0 + 3 * u * u * t * p1 + 3 * u * t * t * p2 + t * t * t * p3;
};
const $3a5557d9ea064e0e$export$59704e2c1673d200 = (s, x)=>{
    const leftToRight = s.x0 <= s.x3;
    const target = $3a5557d9ea064e0e$var$clamp(x, Math.min(s.x0, s.x3), Math.max(s.x0, s.x3));
    let lo = 0;
    let hi = 1;
    for(let i = 0; i < 24; i++){
        const mid = (lo + hi) / 2;
        const xm = $3a5557d9ea064e0e$var$cubic(s.x0, s.cx1x, s.cx2x, s.x3, mid);
        if (xm < target === leftToRight) lo = mid;
        else hi = mid;
    }
    const t = (lo + hi) / 2;
    return $3a5557d9ea064e0e$var$cubic(s.y, s.cx1y, s.cx2y, s.y, t);
};
const $3a5557d9ea064e0e$var$serialize = ({ x0: x0, y: y, cx1x: cx1x, cx1y: cx1y, cx2x: cx2x, cx2y: cx2y, x3: x3 }, dy)=>`M ${x0.toFixed(2)} ${(y + dy).toFixed(2)} C ${cx1x.toFixed(2)} ${(cx1y + dy).toFixed(2)} ${cx2x.toFixed(2)} ${(cx2y + dy).toFixed(2)} ${x3.toFixed(2)} ${(y + dy).toFixed(2)}`;
function $3a5557d9ea064e0e$export$d510b227ac2107c1(width, height) {
    const count = Math.max(Math.round((0, $caEjt.PARAMS).strokeCount * (height / $3a5557d9ea064e0e$var$REFERENCE_LINE_HEIGHT)), 1);
    // Allowed range for stroke center lines; collapses to the middle for tiny boxes.
    const bandTop = Math.min($3a5557d9ea064e0e$export$e6bd8832925633b8, height / 2);
    const bandBottom = Math.max(height - $3a5557d9ea064e0e$export$2f878cc6c7c44381, bandTop);
    const xStart = Math.min($3a5557d9ea064e0e$export$e0b66c24764c59ce, width / 2);
    const xEnd = Math.max(width - $3a5557d9ea064e0e$export$e0b66c24764c59ce, width / 2);
    const capJitter = Math.min((0, $caEjt.PARAMS).capJitter, (xEnd - xStart) / 4);
    const strokes = Array.from({
        length: count
    }, (_, i)=>{
        const t = count === 1 ? 0.5 : i / (count - 1);
        const yBase = bandTop + t * (bandBottom - bandTop);
        const isEdge = i === 0 || i === count - 1;
        const y = $3a5557d9ea064e0e$var$clamp(yBase + $3a5557d9ea064e0e$var$random(isEdge ? (0, $caEjt.PARAMS).edgeJitter : (0, $caEjt.PARAMS).jitter), bandTop, bandBottom);
        const cx1y = y + $3a5557d9ea064e0e$var$random((0, $caEjt.PARAMS).wiggle);
        const cx2y = y + $3a5557d9ea064e0e$var$random((0, $caEjt.PARAMS).wiggle);
        const left = xStart + Math.random() * capJitter;
        const right = xEnd - Math.random() * capJitter;
        const span = right - left;
        const leftToRight = i % 2 === 0;
        const x0 = leftToRight ? left : right;
        const x3 = leftToRight ? right : left;
        const nearX = left + span * (0.3 + $3a5557d9ea064e0e$var$random((0, $caEjt.PARAMS).drift));
        const farX = left + span * (0.7 + $3a5557d9ea064e0e$var$random((0, $caEjt.PARAMS).drift));
        const cx1x = leftToRight ? nearX : farX;
        const cx2x = leftToRight ? farX : nearX;
        return {
            x0: x0,
            y: y,
            cx1x: cx1x,
            cx1y: cx1y,
            cx2x: cx2x,
            cx2y: cx2y,
            x3: x3
        };
    });
    // Shift the stack so the ink above and below the Guard icon is centered on it.
    const iconHalf = Math.min((0, $caEjt.PARAMS).iconSize / 2, (xEnd - xStart) / 2);
    const samples = Array.from({
        length: 5
    }, (_, i)=>width / 2 - iconHalf + i * iconHalf / 2);
    const localYs = strokes.flatMap((s)=>samples.map((x)=>$3a5557d9ea064e0e$export$59704e2c1673d200(s, x)));
    const localCenter = (Math.min(...localYs) + Math.max(...localYs)) / 2;
    const wanted = height / 2 + (0, $caEjt.PARAMS).iconOffset - localCenter;
    // Clamp so the convex hull stays within the band.
    const hullYs = strokes.flatMap((s)=>[
            s.y,
            s.cx1y,
            s.cx2y
        ]);
    const minShift = bandTop - (0, $caEjt.PARAMS).wiggle - Math.min(...hullYs);
    const maxShift = bandBottom + (0, $caEjt.PARAMS).wiggle - Math.max(...hullYs);
    const dy = minShift <= maxShift ? $3a5557d9ea064e0e$var$clamp(wanted, minShift, maxShift) : (minShift + maxShift) / 2;
    return strokes.map((s)=>$3a5557d9ea064e0e$var$serialize(s, dy));
}
module.exports["EFFECTIVE_STROKE_WIDTH"] = $3a5557d9ea064e0e$export$a35b1a25efe697a5;
module.exports["generateStrokes"] = $3a5557d9ea064e0e$export$d510b227ac2107c1;

});

parcelRegister("caEjt", function(module, exports) {
/**
 * Tuning for the hand-drawn scribble; stroke geometry lives in `./geometry`.
 * Distances are px relative to the bar's box. The editor's inline extension
 * lozenge sits ~2.2px above the box top and ~0.7px above its bottom for 16px
 * body text, which is what the vertical insets are measured against.
 */ const $dafb46552dbcb184$export$f80c391eaed27b3 = {
    duration: 800,
    delay: 400,
    cascadeOffset: 10,
    strokeWidth: 0.4,
    strokeCount: 5,
    wiggle: 1.5,
    jitter: 1.5,
    edgeJitter: 0.5,
    drift: 0.08,
    capJitter: 1,
    insetX: 0,
    insetTop: -2.65,
    insetBottom: 0.2,
    iconSize: 12,
    iconOffset: -1.425
};
module.exports["PARAMS"] = $dafb46552dbcb184$export$f80c391eaed27b3;

});

parcelRegister("F4YLX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jsIIo = parcelRequire("jsIIo");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

const $87886bfe56e46f2e$export$8889efa109dce9d4 = ()=>// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('confluence_redaction_shared_scribble') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsIIo.RedactionPlaceholder), null) : null;

const $87886bfe56e46f2e$export$2e83ac12275e5b95 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "jDbpB",
    name: "TourableRedactionExtensionLoader",
    loader: async ()=>(await (parcelRequire("azBYg"))).TourableRedactionExtension,
    loading: $87886bfe56e46f2e$export$8889efa109dce9d4
});
module.exports["TourableRedactionExtensionLoader"] = $87886bfe56e46f2e$export$2e83ac12275e5b95;

});

parcelRegister("jsIIo", function(module, exports) {
/* placeholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * `RedactionPlaceholder` — a correctly-sized, inline stand-in rendered while the
 * redaction extension handler / `ScribbleBar` component is still resolving.
 *
 * The redaction node is rendered through the async extension pipeline
 * (`render: async () => RedactionMarker`), so there is a brief window before the
 * real `ScribbleBar` mounts. Without a sized placeholder the node collapses to
 * empty text (and can briefly wrap), then jumps to the final scribble width once
 * it mounts, producing a visible layout shift. This placeholder reserves the
 * exact inline footprint the `ScribbleBar` will occupy so the surrounding text
 * never moves; the scribble simply fades in over the reserved box.
 *
 * The box dimensions here MUST stay in sync with the `ScribbleBar` container in
 * `./index.tsx` (`height`, `aspectRatio`, `display`, `verticalAlign`,
 * `borderRadius`). Any change to the bar's size must be mirrored here.
 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $5955146ac6e17026$var$styles = {
    placeholder: "_0bjKvDcjp5 _3iDTPbccYA _0jFU0VMmFU _3v5uP0RvL4 _1RrJLit2nV _0KLXruDMqu _20VacPYbGa"
}; /**
    * Inline, non-interactive placeholder that reserves the `ScribbleBar` footprint
    * during load. Hidden from assistive tech since it carries no meaning on its own
    * (the mounted bar provides the accessible label).
    */ 
const $5955146ac6e17026$export$4ca97fdf3f5cdc9e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "guard-redaction-placeholder",
        "aria-hidden": "true",
        // extension chrome does not flash around the placeholder and then vanish when
        // the bar mounts.
        "data-inline-extension-layout": "flow",
        className: (0, $hekY6.default)([
            $5955146ac6e17026$var$styles.placeholder
        ])
    });
module.exports["RedactionPlaceholder"] = $5955146ac6e17026$export$4ca97fdf3f5cdc9e;

});

parcelRegister("azBYg", function(module, exports) {

let $7b2aa08692c09313$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7b2aa08692c09313$var$load("bAgF6"),
    $7b2aa08692c09313$var$load("hnpcA"),
    $7b2aa08692c09313$var$load("5AfWB")
]).then(()=>parcelRequire('jubPE'));

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $2OQaT = parcelRequire("2OQaT");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const personalization = (0, $cozmU.useContext)((0, $2OQaT.OnboardingPersonalizationContext));
    // Compare key values so inline arrays do not invalidate the filtered result on every render.
    const serializedKeys = (0, $cozmU.useMemo)(()=>JSON.stringify(Array.isArray(key) ? key : [
            key
        ]), [
        key
    ]);
    const keys = (0, $cozmU.useMemo)(()=>JSON.parse(serializedKeys), [
        serializedKeys
    ]);
    const hasPersonalization = !!personalization && keys.every((item)=>personalization.keys.includes(item));
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: hasPersonalization ? [
                ...personalization.keys
            ] : key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    const filteredData = (0, $cozmU.useMemo)(()=>data && hasPersonalization ? {
            onboardingState: data.onboardingState?.filter((item)=>keys.includes(item.key)) ?? null
        } : data, [
        data,
        hasPersonalization,
        keys
    ]);
    const refetchRequestedKeys = (0, $cozmU.useCallback)((vars)=>refetch({
            key: keys,
            ...vars
        }), [
        refetch,
        keys
    ]);
    return {
        data: filteredData,
        error: error,
        loading: loading,
        refetch: hasPersonalization ? refetchRequestedKeys : refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<2e96995cd41622171f58df93d4ef5369>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true,
        "throwOnFieldError": true
    },
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "da011c9ee7ee2f3537016ecf931bb29c";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("2OQaT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ba20d15733355e18$export$9bb9b7f6216e0638 = (0, $cozmU.createContext)(undefined);
module.exports["OnboardingPersonalizationContext"] = $ba20d15733355e18$export$9bb9b7f6216e0638;

});

parcelRegister("cbOce", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");




var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType, skip: skip })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip,
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<1341e8100a34db255d375a90f5c4a762>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "e5daa0845f1390f74a58e4fd57f9defb";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<48d9ee7fb5d606ab817066b5f7172f92>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "0a581f032f7c1b6232f4634d5c3d1376";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("4hCFw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $fNTq8 = parcelRequire("fNTq8");


var $cFVPs = parcelRequire("cFVPs");


var $bBIvl = parcelRequire("bBIvl");


var $5JhlM = parcelRequire("5JhlM");


var $d5gEx = parcelRequire("d5gEx");


var $gZFfs = parcelRequire("gZFfs");


var $i8aB6 = parcelRequire("i8aB6");


var $a7t2v = parcelRequire("a7t2v");


var $lgull = parcelRequire("lgull");


var $iTtzC = parcelRequire("iTtzC");

const $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $2795fb4dc781be1d$var$DEFAULT_MAX_LINES = 4;
const $2795fb4dc781be1d$var$styles = {
    container: "_2sNsIg7NXe"
};
const $2795fb4dc781be1d$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $2795fb4dc781be1d$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $2795fb4dc781be1d$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: $2795fb4dc781be1d$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$ac90160f7ae1e32f, props));
};
const $2795fb4dc781be1d$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $2795fb4dc781be1d$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $iTtzC.default));
    const isLoadingRef = (0, $cozmU.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $i8aB6.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $2795fb4dc781be1d$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $iDrrr.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($2795fb4dc781be1d$var$styles.container)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $cozmU.createElement((0, $lgull.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null))));
    return /*#__PURE__*/ $cozmU.createElement((0, $7akNQ.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $2795fb4dc781be1d$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $2795fb4dc781be1d$export$c9a07cebec67e951;

});

parcelRegister("fNTq8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $jLdbZ = parcelRequire("jLdbZ");

const $8a30b5a238fd1faa$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $jLdbZ.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $8a30b5a238fd1faa$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jU6s6.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8;

});

parcelRegister("bBIvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $7m1U4 = parcelRequire("7m1U4");

const $b089d8c6b56c64f6$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $b089d8c6b56c64f6$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $b089d8c6b56c64f6$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = titleMessage ?? $b089d8c6b56c64f6$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: padding,
        xcss: $b089d8c6b56c64f6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($b089d8c6b56c64f6$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $b089d8c6b56c64f6$export$47a62cbf3ee79fef;

});

parcelRegister("7m1U4", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $c344a4b7f3959518$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $c344a4b7f3959518$export$3709887a1be0e305;

});

parcelRegister("5JhlM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $2eafd2f31cb677aa$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2eafd2f31cb677aa$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2eafd2f31cb677aa$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $2eafd2f31cb677aa$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $cozmU.useContext)($2eafd2f31cb677aa$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $2eafd2f31cb677aa$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $2eafd2f31cb677aa$export$ff3deb4415ee32e3;

});

parcelRegister("a7t2v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $cXtTj = parcelRequire("cXtTj");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $cFVPs = parcelRequire("cFVPs");


var $cAiYt = parcelRequire("cAiYt");


var $aIn0d = parcelRequire("aIn0d");


var $cHkK6 = parcelRequire("cHkK6");


var $5GgqH = parcelRequire("5GgqH");

const $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $24521ba341a214c8$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $24521ba341a214c8$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $cozmU.useRef)(text);
    const isExperimentEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const handleLikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAiYt.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $24521ba341a214c8$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: handleLikeClicked,
        onDislikeClicked: handleDislikeClicked
    })));
};
module.exports["AISnippetContent"] = $24521ba341a214c8$export$3cf37822a11d3ff3;

});

parcelRegister("cAiYt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $etoPX = parcelRequire("etoPX");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $1kxSE = parcelRequire("1kxSE");

const $b6dbb4b671decd4a$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $b6dbb4b671decd4a$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $1kxSE.i18n).rovoAwarenessMessage,
        define: (0, $1kxSE.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b6dbb4b671decd4a$var$styles.text)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $etoPX.RovoIcon), {
        size: "xxsmall",
        appearance: "brand"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $b6dbb4b671decd4a$export$fde99ed387d90f1;

});

parcelRegister("1kxSE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c8fb6889a2026e6c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $c8fb6889a2026e6c$export$a7357cdd1f0b0168;

});

parcelRegister("cHkK6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2eX69 = parcelRequire("2eX69");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $5JhlM = parcelRequire("5JhlM");


var $gecH2 = parcelRequire("gecH2");

const $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $2e66c8b5b2928379$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $2e66c8b5b2928379$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.privacyPolicyLink));
const $2e66c8b5b2928379$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.researchGroupLink));
const $2e66c8b5b2928379$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2e66c8b5b2928379$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$PrivacyPolicyLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $2e66c8b5b2928379$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $iDrrr.fg)('product-terminology-refresh') ? $2e66c8b5b2928379$var$i18n.improveAtlassianTextAppify : $2e66c8b5b2928379$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$ResearchGroupLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $2e66c8b5b2928379$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $2e66c8b5b2928379$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $2e66c8b5b2928379$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const feedbackCollectorProperties = (0, $5JhlM.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($2e66c8b5b2928379$var$i18n.flagTitle),
            description: formatMessage($2e66c8b5b2928379$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2e66c8b5b2928379$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eX69.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($2e66c8b5b2928379$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $2e66c8b5b2928379$export$f9f34317e5bc3551;

});

parcelRegister("gecH2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $62e24cf344a5b8b1$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $62e24cf344a5b8b1$export$ec2ba0e929740f73;

});

parcelRegister("5GgqH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $44sV7 = parcelRequire("44sV7");

const $518681ac338b53b3$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $44sV7.useOnScreen)(ref);
    const dwellTimeRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $518681ac338b53b3$export$15dda63faa44a0df;

});

parcelRegister("44sV7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb;

});

parcelRegister("lgull", function(module, exports) {

var $iTtzC = parcelRequire("iTtzC");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $5JhlM = parcelRequire("5JhlM");


var $a7t2v = parcelRequire("a7t2v");

const $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $a1264e7348edcdb0$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iTtzC.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $iDrrr.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $a1264e7348edcdb0$export$f50b64530422ea99;

});

parcelRegister("iTtzC", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $34c51f4beec18331$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34c51f4beec18331$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $34c51f4beec18331$export$2e2bcd8739ae039 = $34c51f4beec18331$var$node;
module.exports["default"] = $34c51f4beec18331$export$2e2bcd8739ae039;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("7CNwI"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("7CNwI", function(module, exports) {

let $58d27ff903855c90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $58d27ff903855c90$var$load("gFeoL"),
    $58d27ff903855c90$var$load("6wr18"),
    $58d27ff903855c90$var$load("kwZ86"),
    $58d27ff903855c90$var$load("ffEVr"),
    $58d27ff903855c90$var$load("4Ldt2"),
    $58d27ff903855c90$var$load("3LYaV"),
    $58d27ff903855c90$var$load("20wSi"),
    $58d27ff903855c90$var$load("9LDVS"),
    $58d27ff903855c90$var$load("kiMHu"),
    $58d27ff903855c90$var$load("8OeKT"),
    $58d27ff903855c90$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});

parcelRegister("brsfB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $dt88A = parcelRequire("dt88A");


var $b6fxF = parcelRequire("b6fxF");


var $6mKj3 = parcelRequire("6mKj3");


var $9UKrO = parcelRequire("9UKrO");


var $jmjWc = parcelRequire("jmjWc");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $bQm3c = parcelRequire("bQm3c");

parcelRequire("eLV9q");
var $eWzPA = parcelRequire("eWzPA");


const $ce8c9e4f9afe9f9c$var$LazyAgentProfileCardWithTrigger = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0pqsy",
    name: "LazyAgentProfileCardWithTrigger",
    loader: async ()=>(await (parcelRequire("3QmmH"))).AgentProfileCardWithTrigger,
    loading: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
});
function $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c({ userId: userId, cloudId: cloudId, featureFlags: featureFlags }) {
    const intl = (0, $kSwu1.useIntl)();
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    const getNavigateToTeamsApp = (0, $eWzPA.useGetNavigateToTeamsApp)();
    const { orgId: orgId, userId: requestingUserId } = (0, $bQm3c.useSessionData)();
    const handleProfileCardActions = (0, $cozmU.useCallback)((loggedInUserId)=>(profileCardUserId)=>{
            const teamsAppPersonProfileUrl = getNavigateToTeamsApp({
                type: 'USER',
                payload: {
                    userId: profileCardUserId
                }
            }).href;
            const followed = !!(profileCardUserId && feedFollowData?.followedUsers?.includes(profileCardUserId));
            return [
                {
                    label: intl.formatMessage({
                        id: "view.profile"
                    }),
                    callback: undefined,
                    target: '_blank',
                    link: teamsAppPersonProfileUrl
                },
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
                        followed: followed
                    }),
                    id: 'feed-follow-user',
                    callback: feedFollowData.getToggleFollowUser(profileCardUserId, followed, 'editor'),
                    shouldRender: (userData)=>feedFollowData.renderFeedFollow && Boolean(profileCardUserId) && profileCardUserId !== loggedInUserId && userData?.status === 'active'
                }
            ];
        }, [
        feedFollowData,
        getNavigateToTeamsApp,
        intl
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const providerPromise = (0, $9UKrO.getProfileCardProvider)(cloudId, handleProfileCardActions(userId), featureFlags ?? {});
        const shouldRenderUserMentionCard = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true);
        const shouldRenderAgentMentionCard = (0, $4o0zT.isExperimentEnabled)('jira_browse_agent_modal_update');
        if (!shouldRenderUserMentionCard && !shouldRenderAgentMentionCard) return providerPromise;
        return providerPromise.then((provider)=>({
                ...provider,
                ...shouldRenderUserMentionCard && {
                    renderUserMentionCard: ({ userId: mentionUserId, cloudId: mentionCloudId, children: children, prefilledProfileData: prefilledProfileData, referenceElement: referenceElement, placement: placement, isReduced: isReduced })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6fxF.UserProfileCardForMention), {
                            userId: mentionUserId,
                            cloudId: mentionCloudId,
                            orgId: orgId ?? '',
                            viewerId: requestingUserId ?? '',
                            referenceElement: referenceElement,
                            prefilledProfileData: (0, $6mKj3.expVal)('cc_comments_accessible_mention_profilecard_names', 'isEnabled', false) ? prefilledProfileData : undefined,
                            placement: placement,
                            isReduced: isReduced,
                            agent: {
                                resourceClient: (0, $bumSD.getProfileClient)(mentionCloudId, featureFlags ?? {})
                            }
                        }, children)
                },
                ...shouldRenderAgentMentionCard && {
                    renderAgentMentionCard: ({ accountId: accountId, children: children, cloudId: mentionCloudId, isReadOnly: isReadOnly, onChatClick: onChatClick })=>children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ce8c9e4f9afe9f9c$var$LazyAgentProfileCardWithTrigger, {
                            identityAccountId: accountId,
                            cloudId: mentionCloudId,
                            trigger: "click",
                            hideConversationStarters: isReadOnly,
                            hideStarButton: isReadOnly,
                            onChatClick: onChatClick
                        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dt88A.AgentCard), {
                            accountId: accountId,
                            cloudId: mentionCloudId,
                            resourceClient: (0, $bumSD.getProfileClient)(mentionCloudId, featureFlags ?? {}),
                            hideConversationStarters: isReadOnly,
                            hideStarButton: isReadOnly,
                            onChatClick: onChatClick
                        })
                }
            }));
    }, [
        cloudId,
        handleProfileCardActions,
        userId,
        featureFlags,
        orgId,
        requestingUserId
    ]);
}
module.exports["useProfilecardProvider"] = $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c;

});

parcelRegister("bedVD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");

const $e4e11ee9fe4a88c9$var$i18n = (0, $kSwu1.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = (0, $cozmU.useMemo)(()=>followedUsersRaw?.map((id)=>id ?? null) ?? [], [
        followedUsersRaw
    ]);
    const getToggleFollowUser = (0, $cozmU.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $hMCZS.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $cozmU.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars($8facebd0ecb5e0ee$var$_temp);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("28WJb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $065389573511adac$export$5351114e92b31bc6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    let t0;
    if ($[0] !== context.setPanelWidth || $[1] !== context.state.panel || $[2] !== context.width) {
        t0 = {
            ...context.state.panel,
            width: context.width,
            setWidth: context.setPanelWidth
        };
        $[0] = context.setPanelWidth;
        $[1] = context.state.panel;
        $[2] = context.width;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $065389573511adac$export$5351114e92b31bc6;

});

parcelRegister("7ZL6d", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $96bd972ec1007d07$export$480e55f805d7990f = (0, $kSwu1.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    askRovoToolbarRemixAppTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.title",
        defaultMessage: "Edit"
    },
    askRovoToolbarImageTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.image.title",
        defaultMessage: "Edit image"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    askRovoToolbarRemixAppTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.tooltip.quickCommand",
        defaultMessage: "Edit {key}+'"
    },
    askRovoToolbarImageTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.image.tooltip.quickCommand",
        defaultMessage: "Edit image {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    rovoToolbarDropdownChevronLabel: {
        id: "fabric.editor.ai.toolbar.rovoDropdownChevron.label",
        defaultMessage: "More Ask Rovo options"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiPlannerTelepointer: {
        id: "fabric.editor.ai.telepointer.planner",
        defaultMessage: "Planner"
    },
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    },
    // On-paste menu messages
    pasteMenuActionsTitle: {
        id: "fabric.editor.ai.paste-menu.section-title",
        defaultMessage: "Actions"
    },
    // Block menu messages
    blockMenuNestedMenuTitle: {
        id: "fabric.editor.ai.config.item.blockMenuNestedMenu.title",
        defaultMessage: "View more actions"
    },
    // Smartlink action messages
    smartlinkListKeyTopics: {
        id: "fabric.editor.ai.smartlink.action.listKeyTopics",
        defaultMessage: "List key topics"
    },
    smartlinkListKeyThemes: {
        id: "fabric.editor.ai.smartlink.action.listKeyThemes",
        defaultMessage: "List key themes"
    },
    smartlinkExtractInsights: {
        id: "fabric.editor.ai.smartlink.action.extractInsights",
        defaultMessage: "Extract insights"
    },
    smartlinkExtractUserQuotes: {
        id: "fabric.editor.ai.smartlink.action.extractUserQuotes",
        defaultMessage: "Extract user quotes"
    },
    smartlinkAddDecisions: {
        id: "fabric.editor.ai.smartlink.action.addDecisions",
        defaultMessage: "Add decisions"
    },
    smartlinkDefineActionItems: {
        id: "fabric.editor.ai.smartlink.action.defineActionItems",
        defaultMessage: "Define action items"
    },
    smartlinkSummarizeChanges: {
        id: "fabric.editor.ai.smartlink.action.summarizeChanges",
        defaultMessage: "Summarize changes"
    },
    smartlinkAddRelatedWorkItems: {
        id: "fabric.editor.ai.smartlink.action.addRelatedWorkItems",
        defaultMessage: "Add related work items"
    },
    smartlinkListTodos: {
        id: "fabric.editor.ai.smartlink.action.listTodos",
        defaultMessage: "List to-dos"
    },
    smartlinkResolutionErrorDescription: {
        id: "fabric.editor.ai.smartlink.resolution-error.description",
        defaultMessage: "This link failed to resolve."
    }
});
module.exports["aiMessages"] = $96bd972ec1007d07$export$480e55f805d7990f;

});

parcelRegister("c5jT4", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $kSwu1 = parcelRequire("kSwu1");

const $fb80bfa16650ce97$export$21be832820f3e6e6 = (0, $kSwu1.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $fb80bfa16650ce97$export$21be832820f3e6e6;

});

parcelRegister("4o1RV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $1eD4P = parcelRequire("1eD4P");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $bDgLe.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $cozmU.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $cozmU.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dOBRD = parcelRequire("dOBRD");


var $f8dGE = parcelRequire("f8dGE");


var $7nEuU = parcelRequire("7nEuU");

var $bnFzS = parcelRequire("bnFzS");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $bDgLe.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $dOBRD.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $dOBRD.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $bnFzS.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $7nEuU.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $7m1pr = parcelRequire("7m1pr");


var $zXpxJ = parcelRequire("zXpxJ");


var $iffSy = parcelRequire("iffSy");


var $7q7rs = parcelRequire("7q7rs");


var $7M67g = parcelRequire("7M67g");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/**
 * Coerce an unknown thrown value into an ApolloErrorInterop, so a rejection carries Apollo's
 * `graphQLErrors` / `networkError` fields on both branches. Mirrors the helper in
 * `useLazyQueryInterop`.
 */ function $b847dc1d37d68706$var$toApolloError(err) {
    if ((0, $7m1pr.isRelayError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $7m1pr.RelayError)({
        networkError: networkError
    });
}
function $b847dc1d37d68706$export$dcf9d4e77de27956(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo(query, options);
}
const $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(13);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options) {
        t1 = options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        };
        $[2] = options;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = [
            t0,
            t1
        ];
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const [doQuery, t3] = (0, $7EPz1.useLazyQuery)(...t2);
    const { data: data, error: error } = t3;
    let t4;
    let t5;
    if ($[7] !== data || $[8] !== error) {
        t4 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t5 = [
            data,
            error
        ];
        $[7] = data;
        $[8] = error;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] !== doQuery) {
        t6 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[11] = doQuery;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function useLazyQueryPromiseInteropApollo(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ // Interop-only fetch policies must be translated or they reach Apollo untranslated and silently
    // degrade to its default cache behaviour. That matters for `'no-store'` specifically: Apollo's
    // `'no-cache'` is its exact equivalent, and without this mapping a query that is correct today
    // would start writing to the cache.
    const [doQuery, { data: data, error: error }] = (0, $7EPz1.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        }
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
function $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${(0, $7M67g.getRelayOperationName)(query) ?? 'unknown'}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    // Read through refs rather than closing over these directly, so the returned callback keeps a
    // `[environment, query]` dependency list. Every current caller drives it from a `useEffect`
    // dependency array, so a new identity per render would re-fire the query on each render.
    // `context` in particular is usually an inline object and would change identity every time.
    const latestOptionsRef = (0, $cozmU.useRef)(options);
    latestOptionsRef.current = options;
    const hookVariablesRef = (0, $cozmU.useRef)(hookVariables);
    hookVariablesRef.current = hookVariables;
    return (0, $cozmU.useCallback)((callOptions)=>{
        const hookOptions = latestOptionsRef.current;
        // Per-call options win over hook-level ones, and variables merge rather than replace —
        // matching Apollo, which merges the variables handed to its lazy `doQuery` over the ones
        // given to the hook.
        const variables = {
            ...hookVariablesRef.current,
            ...callOptions?.variables
        };
        // Shared with `queryInterop` so the fetch-policy mapping and the `noStore` derivation have
        // one home. `noStore` is load-bearing for this hook specifically: `PagePanelContentQuery`
        // runs through it and is one of the operations whose response carries two `Content` objects
        // sharing an id, so a missed flag reintroduces the record collision.
        return (0, $zXpxJ.executeRelayQuery)({
            environment: environment,
            query: query,
            variables: variables,
            fetchPolicy: callOptions?.fetchPolicy ?? hookOptions?.fetchPolicy,
            errorPolicy: callOptions?.errorPolicy ?? hookOptions?.errorPolicy ?? 'none',
            context: callOptions?.context ?? hookOptions?.context
        }).then((result)=>{
            // Diverges from `queryInterop`, which hands `{ data, error }` back: this hook mirrors
            // Apollo's promise, which rejects. Under `errorPolicy: 'all'` a result carries both
            // data and error, and Apollo's effect resolves before it rejects — a promise settles
            // once — so data being present means resolve.
            if (result.error && result.data === undefined) throw result.error;
            return result.data;
        }).catch((err)=>{
            // Reject with an ApolloErrorInterop on both branches, so callers can read
            // `graphQLErrors` / `networkError` without knowing which branch ran.
            throw $b847dc1d37d68706$var$toApolloError(err);
        });
    }, [
        environment,
        query
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("web-panel", (panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { panel: panel } = t0;
    let t1;
    if ($[0] !== panel.completeKey || $[1] !== panel.html) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
            panelId: panel.completeKey,
            html: panel.html,
            panelLocation: (0, $eSLr0.ATL_GENERAL)
        });
        $[0] = panel.completeKey;
        $[1] = panel.html;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}, (prevProps, nextProps)=>prevProps.panel.completeKey === nextProps.panel.completeKey);
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, error: error })=>{
        if (!renderWhenLoading) {
            if (error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        const shouldMemoizeAtlGeneralWebPanel = location === (0, $eSLr0.ATL_GENERAL);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return shouldMemoizeAtlGeneralWebPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel, {
                key: panel.completeKey,
                panel: panel
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html,
                panelLocation: location
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $gH1Fi = parcelRequire("gH1Fi");


var $ep3mz = parcelRequire("ep3mz");


var $eSLr0 = parcelRequire("eSLr0");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { html: html, panelId: panelId, panelLocation: panelLocation } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    const dimensionsRef = (0, $gH1Fi.useExtensionDimensions)(panelLocation === (0, $eSLr0.ATL_GENERAL) ? (0, $eSLr0.ATL_GENERAL) : undefined, panelId, contentId || spaceKey || "");
    let t2;
    if ($[0] !== dimensionsRef) {
        t2 = (element)=>{
            containerRef.current = element;
            dimensionsRef(element);
        };
        $[0] = dimensionsRef;
        $[1] = t2;
    } else t2 = $[1];
    const panelRef = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            (0, $brpfO.evalLegacyConnectInlineScripts)(container);
        };
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== html || $[4] !== panelId) {
        t4 = [
            html,
            panelId
        ];
        $[3] = html;
        $[4] = panelId;
        $[5] = t4;
    } else t4 = $[5];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[6] !== html) {
        t5 = {
            __html: html
        };
        $[6] = html;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== panelRef || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: panelRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: t5
        });
        $[8] = panelRef;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("gH1Fi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1P7Cq = parcelRequire("1P7Cq");


var $7W9kD = parcelRequire("7W9kD");

const $46bdebab359d4884$export$8adc0cb9461bf99f = (source, extensionId, contextKey)=>{
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const cleanup = (0, $cozmU.useRef)(undefined);
    // The observation belongs to this page context, even when React reuses its DOM node.
    const observationContext = (0, $cozmU.useMemo)(()=>({
            source: source,
            extensionId: extensionId,
            contextKey: contextKey
        }), [
        source,
        extensionId,
        contextKey
    ]);
    return (0, $cozmU.useCallback)((element)=>{
        const { source: source, extensionId: extensionId } = observationContext;
        cleanup.current?.();
        cleanup.current = undefined;
        if (!renderServerPlaceholder && element && source && extensionId) cleanup.current = (0, $7W9kD.observeExtensionDimensions)(element, source, extensionId);
    }, [
        observationContext,
        renderServerPlaceholder
    ]);
};
module.exports["useExtensionDimensions"] = $46bdebab359d4884$export$8adc0cb9461bf99f;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent, fullWidthTrigger: fullWidthTrigger })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = reportingLines.href;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }), [
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        getReportingLinesUserProfile(clickedUserId_0).onNavigate();
        return false;
    };
    if (// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        offset: offset,
        trigger: trigger,
        fullWidthTrigger: fullWidthTrigger,
        actions: [
            followUserActionNext
        ],
        isAgent: Boolean(agent),
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        ...disabledAriaAttributes ? {} : {
            ariaLabel: ariaLabel
        },
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $hMCZS.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("gj42z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("g8bbY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $bGjLa = parcelRequire("bGjLa");

const $ed6d952ef1a68788$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommentEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "comment",
            AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function CommentEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
    });
};
module.exports["CommentEditor"] = $ed6d952ef1a68788$export$4153d6fbc2386422;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    // Keep watching query for home route to avoid VC90 regression
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("7VJPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8jDil = parcelRequire("8jDil");

var $5FMVr = parcelRequire("5FMVr");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $8jDil.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $5FMVr.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("fXvmL"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("fXvmL", function(module, exports) {

let $b9e4b25aff8579ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9e4b25aff8579ec$var$load("jXx9i"),
    $b9e4b25aff8579ec$var$load("6wr18"),
    $b9e4b25aff8579ec$var$load("2xKrc"),
    $b9e4b25aff8579ec$var$load("4938u"),
    $b9e4b25aff8579ec$var$load("hhss7"),
    $b9e4b25aff8579ec$var$load("ffEVr"),
    $b9e4b25aff8579ec$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("hjUDQ", function(module, exports) {
var $3f94275ae089f93c$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $3f94275ae089f93c$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $3f94275ae089f93c$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $3f94275ae089f93c$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $3f94275ae089f93c$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $3f94275ae089f93c$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $3f94275ae089f93c$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $3f94275ae089f93c$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $3f94275ae089f93c$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $3f94275ae089f93c$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $3f94275ae089f93c$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $3f94275ae089f93c$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $3f94275ae089f93c$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $3f94275ae089f93c$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $3f94275ae089f93c$export$a6e645fda5339bf8;
module.exports["Height"] = $3f94275ae089f93c$export$8954cfac7c08d16a;
module.exports["Alignment"] = $3f94275ae089f93c$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $3f94275ae089f93c$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $3f94275ae089f93c$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $3f94275ae089f93c$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $3f94275ae089f93c$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $3f94275ae089f93c$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $3f94275ae089f93c$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $3f94275ae089f93c$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $3f94275ae089f93c$export$bf7ebf7fed6e7189;

});

parcelRegister("cfM7x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $090373eba5349880$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $cozmU.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isHelpHub: false,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $090373eba5349880$export$774887fcc3922763 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    let t1;
    if ($[3] !== defaultValue || $[4] !== props) {
        t1 = {
            ...defaultValue,
            ...props
        };
        $[3] = defaultValue;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const value = t1;
    let t2;
    if ($[6] !== children || $[7] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
            value: value
        }, children);
        $[6] = children;
        $[7] = value;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, ...props })=>{
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
const $090373eba5349880$export$8dcbb40932065737 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error("useProductDependencies must be used within ProductDependenciesProvider");
    return ctx;
} : function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
};
module.exports["ProductDependenciesContext"] = $090373eba5349880$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $090373eba5349880$export$8dcbb40932065737;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("lOeVN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $cozmU.useRef)();
    propsRef.current = props;
    return (0, $cozmU.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("5E8QK"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("5E8QK", function(module, exports) {

let $41c78d93fde5dc21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41c78d93fde5dc21$var$load("4nZ85"),
    $41c78d93fde5dc21$var$load("hhss7"),
    $41c78d93fde5dc21$var$load("kHXvF"),
    $41c78d93fde5dc21$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("bflGB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EemN = parcelRequire("9EemN");

parcelRequire("1syzX");


var $l65Bo = parcelRequire("l65Bo");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback = function(...[e, element, combo]) {
        // Prompt inputs such as Ask Rovo also use ProseMirror. Allow editor commands,
        // but let Mousetrap suppress shortcuts for characters being typed into them.
        const isTypingInEditor = 'isContentEditable' in element && element.isContentEditable === true && e.key?.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
        let allowedElements = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS);
        if (element.classList.contains((0, $1k6sE.PROSEMIRROR_FOCUSED_CLASS)) && isTypingInEditor && (0, $6mKj3.expVal)('cc_ai_growth_remix_prevent_shortcuts', 'isEnabled', false)) allowedElements = allowedElements.filter((className)=>className !== (0, $1k6sE.PROSEMIRROR_FOCUSED_CLASS));
        const isAllowed = allowedElements.some((className)=>element.classList.contains(className));
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("1syzX", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e = 'ProseMirror-focused';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e,
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["PROSEMIRROR_FOCUSED_CLASS"] = $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $kSwu1.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_2mHwu8FQfX _3iDTPbQ4SZ _0hPCNLDIqT"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 1000 * 60 * 60 * 24 * 7);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("1PPDm", function(module, exports) {
"use strict";
var $15629b4bdedac47d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $15629b4bdedac47d$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $15629b4bdedac47d$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $15629b4bdedac47d$var$catchError;
var $15629b4bdedac47d$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $15629b4bdedac47d$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $15629b4bdedac47d$var$CatchSubscriber = function(_super) {
    $15629b4bdedac47d$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($863V0.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=catchError.js.map

});

parcelRegister("1xJn2", function(module, exports) {
"use strict";
var $11fc112c79ff43c4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $11fc112c79ff43c4$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $11fc112c79ff43c4$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $11fc112c79ff43c4$var$distinctUntilChanged;
var $11fc112c79ff43c4$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber = function(_super) {
    $11fc112c79ff43c4$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $aRdp2.tryCatch(this.keySelector)(value);
            if (key === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $aRdp2.tryCatch(this.compare)(this.key, key);
            if (result === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=distinctUntilChanged.js.map

});

parcelRegister("ebEo2", function(module, exports) {
"use strict";
var $a5416bba69d7cff3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $a5416bba69d7cff3$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $a5416bba69d7cff3$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $a5416bba69d7cff3$var$skipWhile;
var $a5416bba69d7cff3$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5416bba69d7cff3$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5416bba69d7cff3$var$SkipWhileSubscriber = function(_super) {
    $a5416bba69d7cff3$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=skipWhile.js.map

});

parcelRegister("c7Xul", function(module, exports) {
"use strict";
var $8d4448aad9d90f95$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $8d4448aad9d90f95$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $8d4448aad9d90f95$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $8d4448aad9d90f95$var$switchMap;
var $8d4448aad9d90f95$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8d4448aad9d90f95$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8d4448aad9d90f95$var$SwitchMapSubscriber = function(_super) {
    $8d4448aad9d90f95$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $863V0.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=switchMap.js.map

});

parcelRegister("1mLOG", function(module, exports) {
"use strict";
var $0fecefdacae1f75b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

function $0fecefdacae1f75b$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $0fecefdacae1f75b$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $0fecefdacae1f75b$var$timeInterval;
var $0fecefdacae1f75b$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $0fecefdacae1f75b$var$TimeInterval;
var $0fecefdacae1f75b$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $0fecefdacae1f75b$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0fecefdacae1f75b$var$TimeIntervalSubscriber = function(_super) {
    $0fecefdacae1f75b$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $0fecefdacae1f75b$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=timeInterval.js.map

});

parcelRegister("cmyqT", function(module, exports) {
"use strict";
var $90023fbe608f4f3c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $a6ieS = parcelRequire("a6ieS");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $90023fbe608f4f3c$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteTimeout = $fEWBj.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $90023fbe608f4f3c$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $a6ieS.TimeoutError()));
    };
}
module.exports.timeout = $90023fbe608f4f3c$var$timeout;
var $90023fbe608f4f3c$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $90023fbe608f4f3c$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $90023fbe608f4f3c$var$TimeoutSubscriber = function(_super) {
    $90023fbe608f4f3c$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=timeout.js.map

});

parcelRegister("a6ieS", function(module, exports) {
"use strict";
var $75a89ccb17a412ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $75a89ccb17a412ff$var$TimeoutError = function(_super) {
    $75a89ccb17a412ff$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $75a89ccb17a412ff$var$TimeoutError; //# sourceMappingURL=TimeoutError.js.map

});

parcelRegister("4Otfs", function(module, exports) {
"use strict";
var $3812850d794e9fac$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $371EO = parcelRequire("371EO");

/**
 * @class BehaviorSubject<T>
 */ var $3812850d794e9fac$var$BehaviorSubject = function(_super) {
    $3812850d794e9fac$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $371EO.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($gGP9M.Subject);
module.exports.BehaviorSubject = $3812850d794e9fac$var$BehaviorSubject; //# sourceMappingURL=BehaviorSubject.js.map

});

parcelRegister("7EIq6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dd33Q = parcelRequire("dd33Q");


var $9Pmcg = parcelRequire("9Pmcg");


var $6SsN4 = parcelRequire("6SsN4");


var $jtuBN = parcelRequire("jtuBN");


var $idOQ2 = parcelRequire("idOQ2");

const $649b778bbd82b1bb$var$spaceEnabledContentTypesFragment = (0, $9Pmcg.default);
function $649b778bbd82b1bb$export$67a7293b6dfe9c76(spaceFragmentRef) {
    const $ = (0, $bDgLe.c)(2);
    const space = (0, $6SsN4.useFragment)($649b778bbd82b1bb$var$spaceEnabledContentTypesFragment, spaceFragmentRef);
    const t0 = space.spaceTypeSettings?.enabledContentTypes;
    let t1;
    if ($[0] !== t0) {
        t1 = $649b778bbd82b1bb$var$getEnabledContentTypes(t0, false);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}
const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $idOQ2.useDefaultSpacesForCreate)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, {
        ...spaceEnabledContentTypesQueryOptions,
        __callerPackage__: "create-blank-fabric-page"
    });
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    return $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, isDefaultSpaceKeyLoading || isAnyContentTypesLoading);
}
function $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, loading) {
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = loading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypesFragment"] = $649b778bbd82b1bb$export$67a7293b6dfe9c76;
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("9Pmcg", function(module, exports) {
/**
 * @generated SignedSource<<6a622c3ccbbe286fe0564af388855ebd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1a2866ab6e1d474$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSpaceEnabledContentTypes_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "SpaceTypeSettings",
            "kind": "LinkedField",
            "name": "spaceTypeSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "EnabledContentTypes",
                    "kind": "LinkedField",
                    "name": "enabledContentTypes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isBlogsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isDatabasesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEmbedsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isLivePagesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSlidesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isWhiteboardsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFoldersEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Space"
};
$e1a2866ab6e1d474$var$node.hash = "b4c0be9fdc8089ef19cf4d9ec776f16e";
var $e1a2866ab6e1d474$export$2e2bcd8739ae039 = $e1a2866ab6e1d474$var$node;
module.exports["default"] = $e1a2866ab6e1d474$export$2e2bcd8739ae039;

});

parcelRegister("idOQ2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $3l9Bn = parcelRequire("3l9Bn");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $6mKj3 = parcelRequire("6mKj3");


var $9HB34 = parcelRequire("9HB34");


var $dDAsV = parcelRequire("dDAsV");


var $iLgzu = parcelRequire("iLgzu");


var $ge2sX = parcelRequire("ge2sX");


var $bQm3c = parcelRequire("bQm3c");

// Reuse the same operation and fields for the create menu, selector, and template gallery.
const $ada51a459bf40037$var$defaultSpacesForCreateQuery = (0, $3l9Bn.default);
const $ada51a459bf40037$var$missingCloudIdError = new Error('Cannot load default spaces from AGG without a Confluence cloud ID');
const $ada51a459bf40037$var$unavailableDefaultSpacesError = new Error('AGG default spaces are unavailable; check the confluence_default_spaces_graphql gate');
const $ada51a459bf40037$var$toQueryVariables = (cloudId, variables)=>({
        cloudId: cloudId,
        promotedSpaceKeys: variables?.promotedSpaceKey ? [
            variables.promotedSpaceKey
        ] : [],
        promotedSpacesLimit: variables?.promotedSpacesLimit ?? 10,
        otherSpacesLimit: variables?.otherSpacesLimit ?? 10
    });
// Relay fetchQuery writes to the store, but network-only ensures no-cache callers receive fresh data.
const $ada51a459bf40037$var$toRelayFetchPolicy = (fetchPolicy)=>fetchPolicy === undefined || fetchPolicy === 'cache-first' ? 'store-or-network' : 'network-only';
const $ada51a459bf40037$var$toLegacySpace = ({ key: key, name: name })=>({
        id: key,
        text: name
    });
const $ada51a459bf40037$var$toLegacyData = (spaces)=>({
        experimentalPromotedSpaces: {
            nodes: [
                ...spaces.promotedSpaces.spaces,
                ...spaces.otherSpaces.spaces
            ].map($ada51a459bf40037$var$toLegacySpace),
            matchedPromotedSpaces: spaces.matchedPromotedSpaces.spaces.map($ada51a459bf40037$var$toLegacySpace),
            __typename: 'ExperimentalPromotedSpaces'
        }
    });
const $ada51a459bf40037$var$useAggDefaultSpaces = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { cloudId: cloudId, skip: skip, variables: variables, onError: onError, fetchPolicy: fetchPolicy } = t0;
    const promotedSpaceKey = variables?.promotedSpaceKey;
    const promotedSpacesLimit = variables?.promotedSpacesLimit;
    const otherSpacesLimit = variables?.otherSpacesLimit;
    let t1;
    if ($[0] !== cloudId || $[1] !== otherSpacesLimit || $[2] !== promotedSpaceKey || $[3] !== promotedSpacesLimit) {
        t1 = $ada51a459bf40037$var$toQueryVariables(cloudId, {
            promotedSpaceKey: promotedSpaceKey,
            promotedSpacesLimit: promotedSpacesLimit,
            otherSpacesLimit: otherSpacesLimit
        });
        $[0] = cloudId;
        $[1] = otherSpacesLimit;
        $[2] = promotedSpaceKey;
        $[3] = promotedSpacesLimit;
        $[4] = t1;
    } else t1 = $[4];
    const queryVariables = t1;
    let t2;
    if ($[5] !== fetchPolicy) {
        t2 = $ada51a459bf40037$var$toRelayFetchPolicy(fetchPolicy);
        $[5] = fetchPolicy;
        $[6] = t2;
    } else t2 = $[6];
    const relayFetchPolicy = t2;
    const [result, setResult] = (0, $cozmU.useState)();
    let t3;
    let t4;
    if ($[7] !== onError || $[8] !== queryVariables || $[9] !== relayFetchPolicy || $[10] !== skip) {
        t3 = ()=>{
            if (skip) return;
            const subscription = (0, $6SsN4.fetchQuery)((0, $9HB34.getRelayEnvironment)(), $ada51a459bf40037$var$defaultSpacesForCreateQuery, queryVariables, {
                fetchPolicy: relayFetchPolicy
            }).subscribe({
                next: (data)=>setResult({
                        variables: queryVariables,
                        fetchPolicy: relayFetchPolicy,
                        data: data
                    }),
                error: (error)=>{
                    setResult({
                        variables: queryVariables,
                        fetchPolicy: relayFetchPolicy,
                        error: error
                    });
                    onError?.(error);
                }
            });
            return ()=>subscription.unsubscribe();
        };
        t4 = [
            onError,
            queryVariables,
            relayFetchPolicy,
            skip
        ];
        $[7] = onError;
        $[8] = queryVariables;
        $[9] = relayFetchPolicy;
        $[10] = skip;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (skip) {
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                data: undefined,
                loading: false,
                error: undefined
            };
            $[13] = t5;
        } else t5 = $[13];
        return t5;
    }
    if (result?.variables !== queryVariables || result.fetchPolicy !== relayFetchPolicy) {
        let t5;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                data: undefined,
                loading: true,
                error: undefined
            };
            $[14] = t5;
        } else t5 = $[14];
        return t5;
    }
    let t5;
    if ($[15] !== result.data || $[16] !== result.error) {
        t5 = {
            data: result.data,
            loading: false,
            error: result.error
        };
        $[15] = result.data;
        $[16] = result.error;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
};
const $ada51a459bf40037$var$useDefaultSpacesForCreateWithExperiment = (isAggEnabled, t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const t1 = skip || !cloudId || !isAggEnabled;
    let t2;
    if ($[0] !== cloudId || $[1] !== fetchPolicy || $[2] !== onError || $[3] !== t1 || $[4] !== variables) {
        t2 = {
            cloudId: cloudId,
            skip: t1,
            variables: variables,
            onError: onError,
            fetchPolicy: fetchPolicy
        };
        $[0] = cloudId;
        $[1] = fetchPolicy;
        $[2] = onError;
        $[3] = t1;
        $[4] = variables;
        $[5] = t2;
    } else t2 = $[5];
    const aggResult = $ada51a459bf40037$var$useAggDefaultSpaces(t2);
    const t3 = skip || isAggEnabled;
    let t4;
    if ($[6] !== fetchPolicy || $[7] !== onError || $[8] !== t3 || $[9] !== variables) {
        t4 = {
            skip: t3,
            onError: onError,
            variables: variables,
            fetchPolicy: fetchPolicy
        };
        $[6] = fetchPolicy;
        $[7] = onError;
        $[8] = t3;
        $[9] = variables;
        $[10] = t4;
    } else t4 = $[10];
    const restResult = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t4);
    if (!isAggEnabled) return restResult;
    let t5;
    if ($[11] !== aggResult.data) {
        t5 = aggResult.data?.confluence_defaultSpaces ? $ada51a459bf40037$var$toLegacyData(aggResult.data.confluence_defaultSpaces) : undefined;
        $[11] = aggResult.data;
        $[12] = t5;
    } else t5 = $[12];
    const t6 = skip ? undefined : !cloudId ? $ada51a459bf40037$var$missingCloudIdError : aggResult.error ?? (aggResult.data?.confluence_defaultSpaces === null ? $ada51a459bf40037$var$unavailableDefaultSpacesError : undefined);
    let t7;
    if ($[13] !== aggResult.loading || $[14] !== t5 || $[15] !== t6) {
        t7 = {
            data: t5,
            loading: aggResult.loading,
            error: t6
        };
        $[13] = aggResult.loading;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
};
const $ada51a459bf40037$export$be8c223b5ba023bf = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const params = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_default_spaces_graphql", "isEnabled", true);
        $[2] = t2;
    } else t2 = $[2];
    return $ada51a459bf40037$var$useDefaultSpacesForCreateWithExperiment(t2, params);
};
const $ada51a459bf40037$export$bf59898fac256899 = async ({ variables: variables, fetchPolicy: fetchPolicy } = {})=>{
    if (!(0, $6mKj3.expValEquals)('confluence_default_spaces_graphql', 'isEnabled', true)) return (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: variables,
        fetchPolicy: fetchPolicy
    });
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    if (!cloudId) throw $ada51a459bf40037$var$missingCloudIdError;
    const data = await (0, $6SsN4.fetchQuery)((0, $9HB34.getRelayEnvironment)(), $ada51a459bf40037$var$defaultSpacesForCreateQuery, $ada51a459bf40037$var$toQueryVariables(cloudId, variables), {
        fetchPolicy: fetchPolicy === 'network-only' ? 'network-only' : 'store-or-network'
    }).toPromise();
    if (!data?.confluence_defaultSpaces) throw $ada51a459bf40037$var$unavailableDefaultSpacesError;
    return {
        data: $ada51a459bf40037$var$toLegacyData(data.confluence_defaultSpaces)
    };
};
module.exports["useDefaultSpacesForCreate"] = $ada51a459bf40037$export$be8c223b5ba023bf;
module.exports["getDefaultSpacesForCreate"] = $ada51a459bf40037$export$bf59898fac256899;

});

parcelRegister("3l9Bn", function(module, exports) {
/**
 * @generated SignedSource<<65aa05400383c7a5ee3f3d8425207095>>
 * @relayHash 7d06535456c9d2141ca210b8d25ff802
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 982f9fe2ba3699920aaf981e5dd43474fb140f73d247765e842e033acbc8a0d9
const $c5ca30d5a6d63d34$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherSpacesLimit"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "promotedSpaceKeys"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "promotedSpacesLimit"
    }, v4 = [
        {
            "concreteType": "ConfluenceDefaultSpace",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ], v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "otherSpacesLimit",
                    "variableName": "otherSpacesLimit"
                },
                {
                    "kind": "Variable",
                    "name": "promotedSpaceKeys",
                    "variableName": "promotedSpaceKeys"
                },
                {
                    "kind": "Variable",
                    "name": "promotedSpacesLimit",
                    "variableName": "promotedSpacesLimit"
                }
            ],
            "concreteType": "ConfluenceDefaultSpaces",
            "kind": "LinkedField",
            "name": "confluence_defaultSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDefaultSpaceResults",
                    "kind": "LinkedField",
                    "name": "matchedPromotedSpaces",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceDefaultSpaceResults",
                    "kind": "LinkedField",
                    "name": "promotedSpaces",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceDefaultSpaceResults",
                    "kind": "LinkedField",
                    "name": "otherSpaces",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "defaultSpacesForCreateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "defaultSpacesForCreateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "7d06535456c9d2141ca210b8d25ff802",
            "id": "982f9fe2ba3699920aaf981e5dd43474fb140f73d247765e842e033acbc8a0d9",
            "metadata": {},
            "name": "defaultSpacesForCreateQuery",
            "operationKind": "query",
            "text": "query defaultSpacesForCreateQuery($cloudId:ID!,$promotedSpaceKeys:[String],$promotedSpacesLimit:Int,$otherSpacesLimit:Int){confluence_defaultSpaces(cloudId:$cloudId,promotedSpaceKeys:$promotedSpaceKeys,promotedSpacesLimit:$promotedSpacesLimit,otherSpacesLimit:$otherSpacesLimit){matchedPromotedSpaces{spaces{id,key,name}},promotedSpaces{spaces{id,key,name}},otherSpaces{spaces{id,key,name}}}}"
        }
    };
}();
$c5ca30d5a6d63d34$var$node.hash = "051a6dfeb5ad1a6654485dc46ce9bab5";
var $c5ca30d5a6d63d34$export$2e2bcd8739ae039 = $c5ca30d5a6d63d34$var$node;
module.exports["default"] = $c5ca30d5a6d63d34$export$2e2bcd8739ae039;

});

parcelRegister("dDAsV", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $jaPWl = parcelRequire("jaPWl");

const $accffb80f429232b$export$bdbe5e70ac4420b8 = async ({ variables: variables, fetchPolicy: fetchPolicy })=>{
    const promotedSpacesLimit = variables && variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables && variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables && variables.promotedSpaceKey || '';
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        variables: variables || {},
        fetchPolicy: fetchPolicy,
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        }
    });
    return {
        data: result.data
    };
};
module.exports["experimentalPromotedSpacesQuery"] = $accffb80f429232b$export$bdbe5e70ac4420b8;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("bMPhU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dPlMJ", function(module, exports) {
/* ConnectEosBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $lvJqX = parcelRequire("lvJqX");


var $1VhsF = parcelRequire("1VhsF");


var $jtT80 = parcelRequire("jtT80");


var $7dBf8 = parcelRequire("7dBf8");


var $7OuPp = parcelRequire("7OuPp");


var $lEfEl = parcelRequire("lEfEl");

function $3d63ea7a98a3f43b$var$_defineProperty(e, r, t) {
    return (r = $3d63ea7a98a3f43b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3d63ea7a98a3f43b$var$_toPropertyKey(t) {
    var i = $3d63ea7a98a3f43b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3d63ea7a98a3f43b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $3d63ea7a98a3f43b$export$4f5b90a6ce229aa1 = 'customer-messaging-iframe-banner-dismiss-days';
const $3d63ea7a98a3f43b$export$5b9fb60c3fa87c1a = 'customer_messaging_apps_blocked_by_atlassian';
const $3d63ea7a98a3f43b$export$461103d5504d4d8b = 'connect-eos-banner_dismissed';
const $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS = 'SUCCESS';
const $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS = 'BLOCKED';
const $3d63ea7a98a3f43b$export$9d00c95780551685 = 30;
const $3d63ea7a98a3f43b$export$10cefe68e4bb6b44 = 86400000;
const $3d63ea7a98a3f43b$export$a916575f88d9889f = 'customer-messaging-iframe-banner-enabled';
const $3d63ea7a98a3f43b$export$35fbf2628e8debb2 = 'customer_messaging_iframes_phase_2';
const $3d63ea7a98a3f43b$export$61abdb4e3a264073 = 'customer_messaging_iframes_phase_3';
const $3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED = 'customer-messaging-is-dev-canary';
const $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL = 'https://developer.atlassian.com/cloud/jira/platform/developer-canary-program/';
const $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL = 'https://developer.atlassian.com/platform/forge/changelog/';
const $3d63ea7a98a3f43b$var$DEFAULT_LOCALE = 'en';
const $3d63ea7a98a3f43b$var$defaultIntlCache = (0, $kSwu1.createIntlCache)();
const $3d63ea7a98a3f43b$var$defaultIntl = (0, $kSwu1.createIntl)({
    locale: $3d63ea7a98a3f43b$var$DEFAULT_LOCALE
}, $3d63ea7a98a3f43b$var$defaultIntlCache);
const $3d63ea7a98a3f43b$var$containerStyles = {
    marginBottom: '8px'
};
const $3d63ea7a98a3f43b$var$devCanaryMessageStyles = null;
function $3d63ea7a98a3f43b$export$e6e73547b6ec2430(appKey) {
    return `${appKey}-${$3d63ea7a98a3f43b$export$461103d5504d4d8b}`;
}
class $3d63ea7a98a3f43b$var$ConnectEosBannerComponent extends $cozmU.PureComponent {
    _getDismissDurationMs() {
        const days = (0, $cXtTj.default).getExperiment($3d63ea7a98a3f43b$export$4f5b90a6ce229aa1, {
            fireExperimentExposure: false
        }).get('value', $3d63ea7a98a3f43b$export$9d00c95780551685);
        return (typeof days === 'number' && days > 0 ? days : $3d63ea7a98a3f43b$export$9d00c95780551685) * $3d63ea7a98a3f43b$export$10cefe68e4bb6b44;
    }
    _isDismissed() {
        if (typeof window === 'undefined') return false;
        const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey);
        const storedItem = (0, $7dBf8.AtlBrowserStorageLocal).getItem(dismissStorageKey);
        if (!storedItem) return false;
        let dismissedAt;
        try {
            const parsedItem = JSON.parse(storedItem);
            dismissedAt = parsedItem.value;
        } catch (e) {
            (0, $7OuPp.logger).warn('Failed to parse Connect EOS banner dismissal', {
                key: dismissStorageKey,
                error: e
            });
            return false;
        }
        if (!dismissedAt) return false;
        const dismissedTimestamp = Number(dismissedAt);
        if (isNaN(dismissedTimestamp)) return false;
        return Date.now() - dismissedTimestamp < this._getDismissDurationMs();
    }
    _shouldShowBanner() {
        // Don't show if the main feature gate is not enabled
        if (!(0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$export$a916575f88d9889f)) return false;
         // Don't show for system apps
        if (this.props.isSystemApp) return false;
        if (this._isBlockedByAtlassian()) return false;
        const phaseGate = this._getPhaseGate();
        if (phaseGate && !(0, $cXtTj.default).checkGate(phaseGate)) return false;
         // Don't show if previously dismissed (within configured dismiss duration)
        if (this.state.dismissed) return false;
        return true;
    }
    _getMigrationCohort() {
        const migration = this.props.connectToForgeMigration;
        if (!migration?.defined) return 'UNDECLARED';
        switch(migration.willMigrateToForgeBeforeEOS){
            case 'NO':
            case 'YES':
            case 'UNDECIDED':
                return migration.willMigrateToForgeBeforeEOS;
            default:
                return 'UNDECIDED';
        }
    }
    _getPhaseGate() {
        switch(this._getMigrationCohort()){
            case 'NO':
                return undefined;
            case 'YES':
                return $3d63ea7a98a3f43b$export$61abdb4e3a264073;
            case 'UNDECLARED':
            case 'UNDECIDED':
            default:
                return $3d63ea7a98a3f43b$export$35fbf2628e8debb2;
        }
    }
    _isBlockedByAtlassian() {
        const blockedAppKeys = (0, $cXtTj.default).getExperiment($3d63ea7a98a3f43b$export$5b9fb60c3fa87c1a, {
            fireExperimentExposure: false
        }).get('value', []);
        return Array.isArray(blockedAppKeys) && typeof this.props.appKey === 'string' && blockedAppKeys.includes(this.props.appKey);
    }
    _isProd() {
        if (typeof window === 'undefined') return false;
        return window.location.hostname.endsWith('.atlassian.net');
    }
    _isSiteAdmin() {
        return this.props.isSiteAdmin ?? false;
    }
    _isDevCanary() {
        return (0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED);
    }
    _getConnectedAppsUrl() {
        const cloudId = this.props.cloudId ?? (typeof document !== 'undefined' ? document.querySelector('meta[name="ajs-cloud-id"]')?.content : undefined) ?? undefined;
        const adminHost = this._isProd() ? 'admin.atlassian.com' : 'admin.stg.atlassian.com';
        if (!cloudId) return undefined;
        return `https://${adminHost}/s/${cloudId}/user-connected-apps/tab/installed`;
    }
    _getMessageBody() {
        const { appName: appName } = this.props;
        const isSiteAdmin = this._isSiteAdmin();
        const connectedAppsUrl = this._getConnectedAppsUrl();
        const migrationGuideUrl = this.props.connectToForgeMigration?.migrationGuideUrl?.trim();
        const cohort = this._getMigrationCohort();
        const messageCohort = cohort !== 'UNDECLARED' && !migrationGuideUrl ? 'UNDECLARED' : cohort;
        const messages = {
            UNDECLARED: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).undeclaredAdmin : (0, $lEfEl.connectEosBannerMessages).undeclaredNonAdmin,
            NO: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).noAdmin : (0, $lEfEl.connectEosBannerMessages).noNonAdmin,
            UNDECIDED: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).undecidedAdmin : (0, $lEfEl.connectEosBannerMessages).undecidedNonAdmin,
            YES: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).yesAdmin : (0, $lEfEl.connectEosBannerMessages).yesNonAdmin
        };
        const connectedApps = (chunks)=>/*#__PURE__*/ $cozmU.createElement("strong", null, connectedAppsUrl ? /*#__PURE__*/ $cozmU.createElement("a", {
                href: connectedAppsUrl
            }, chunks) : /*#__PURE__*/ $cozmU.createElement("span", null, chunks));
        const migrationGuide = (chunks)=>migrationGuideUrl ? /*#__PURE__*/ $cozmU.createElement("a", {
                href: migrationGuideUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks) : /*#__PURE__*/ $cozmU.createElement("span", null, chunks);
        const strong = (chunks)=>/*#__PURE__*/ $cozmU.createElement("strong", null, chunks);
        return /*#__PURE__*/ $cozmU.createElement("p", null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...messages[messageCohort],
            values: {
                appName: appName ?? '',
                hasAppName: Boolean(appName),
                strong: strong,
                connectedApps: connectedApps,
                migrationGuide: migrationGuide
            }
        }));
    }
    _getDevCanaryMessageBody() {
        if (!this._isDevCanary()) return null;
        const developerCanaryProgram = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        const forgeChangelog = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        return /*#__PURE__*/ $cozmU.createElement("p", {
            className: (0, $hekY6.default)([
                "_313842Pgdg"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $lEfEl.connectEosBannerMessages).devCanaryMessage,
            values: {
                developerCanaryProgram: developerCanaryProgram,
                forgeChangelog: forgeChangelog
            }
        }));
    }
    _getDismissAction() {
        return /*#__PURE__*/ $cozmU.createElement((0, $jtT80.default), {
            onClick: this._dismiss,
            key: "dismiss"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $lEfEl.connectEosBannerMessages).dismiss));
    }
    getSectionWarningBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-banner",
            style: $3d63ea7a98a3f43b$var$containerStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "warning"
        }, this._getMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    getInlineBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-v2-banner"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
            appearance: "warning",
            secondaryText: (this.props.intl ?? $3d63ea7a98a3f43b$var$defaultIntl).formatMessage((0, $lEfEl.connectEosBannerMessages).inlineSecondaryText)
        }, this._getMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    render() {
        if (!this._shouldShowBanner()) return null;
        const banner = this.props.moduleType === 'webPanels' ? this.getInlineBanner() : this.getSectionWarningBanner();
        if (!this.props.intl) return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.RawIntlProvider), {
            value: $3d63ea7a98a3f43b$var$defaultIntl
        }, banner);
        return banner;
    }
    constructor(props){
        super(props);
        $3d63ea7a98a3f43b$var$_defineProperty(this, "_dismiss", ()=>{
            const dismissedAt = Date.now();
            const storedItem = JSON.stringify({
                value: dismissedAt
            });
            const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey); // @browser-storage setter
            (0, $7dBf8.AtlBrowserStorageLocal).setItem(dismissStorageKey, storedItem).then((result)=>{
                if (result?.status && result.status !== $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS && result.status !== $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS) (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    result: result
                });
            }).catch((error)=>{
                (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    error: error
                });
            });
            this.setState({
                dismissed: true
            });
        });
        this.state = {
            dismissed: this._isDismissed()
        };
    }
}
$3d63ea7a98a3f43b$var$_defineProperty($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, "defaultProps", {
    isSystemApp: false,
    moduleType: ''
});
const $3d63ea7a98a3f43b$export$70b82b13309d5477 = (0, $kSwu1.injectIntl)($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, {
    enforceContext: false
});
module.exports["ConnectEosBanner"] = $3d63ea7a98a3f43b$export$70b82b13309d5477;

});

parcelRegister("7OuPp", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $jDYJM = parcelRequire("jDYJM");

class $8825011921e30ce8$var$LoggerController {
    isDebugEnabled() {
        return this.debugEnabled;
    }
    isInfoEnabled() {
        return this.infoEnabled;
    }
    constructor(){
        this.debugEnabled = false;
        this.infoEnabled = true;
    }
}
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */ class $8825011921e30ce8$var$LoggerAdaptor {
    /**
   * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
   */ registerLoggerAPI(loggerAPI) {
        this.loggerAPI = loggerAPI;
    }
    /**
   * Implementation of LoggerAPI#debug() for use by connect-module-core code.
   */ debug(message, ...optionalParams) {
        try {
            if (this.loggerController.isDebugEnabled()) this.loggerAPI.debug.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#info() for use by connect-module-core code.
   */ info(message, ...optionalParams) {
        try {
            if (this.loggerController.isInfoEnabled()) this.loggerAPI.info.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#warn() for use by connect-module-core code.
   */ warn(message, ...optionalParams) {
        try {
            this.loggerAPI.warn.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.warn || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    /**
   * Implementation of LoggerAPI#error() for use by connect-module-core code.
   */ error(message, ...optionalParams) {
        try {
            this.loggerAPI.error.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.error || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    constructor(){
        this.loggerController = void 0;
        this.loggerAPI = (0, $jDYJM.default);
        this.loggerController = new $8825011921e30ce8$var$LoggerController();
        window._loggerController = this.loggerController;
    }
}
const $8825011921e30ce8$export$af88d00dbe7f521 = new $8825011921e30ce8$var$LoggerAdaptor();
module.exports["logger"] = $8825011921e30ce8$export$af88d00dbe7f521;

});

parcelRegister("jDYJM", function(module, exports) {
$parcel$export(module.exports, "default", () => $14ab1827b564829e$export$2e2bcd8739ae039);
/* eslint-disable */ // @ts-nocheck
class $14ab1827b564829e$var$DefaultLoggerAPI {
    debug(message, ...optionalParams) {
        console.debug.apply(console, arguments);
    }
    info(message, ...optionalParams) {
        console.info.apply(console, arguments);
    }
    warn(message, ...optionalParams) {
        console.warn.apply(console, arguments);
    }
    error(message, ...optionalParams) {
        console.error.apply(console, arguments);
    }
}
var $14ab1827b564829e$export$2e2bcd8739ae039 = new $14ab1827b564829e$var$DefaultLoggerAPI();

});

parcelRegister("lEfEl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e33f058366d031a5$export$db71c19e7db05343 = (0, $kSwu1.defineMessages)({
    undeclaredAdmin: {
        id: "connect-module-core.modules.app.undeclaredAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    undeclaredNonAdmin: {
        id: "connect-module-core.modules.app.undeclaredNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. To explore your options, contact your site admin."
    },
    noAdmin: {
        id: "connect-module-core.modules.app.noAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027; after that, the vendor <migrationGuide><strong>will discontinue supporting it as well</strong></migrationGuide>. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    noNonAdmin: {
        id: "connect-module-core.modules.app.noNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. To explore your options, contact your site admin."
    },
    undecidedAdmin: {
        id: "connect-module-core.modules.app.undecidedAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. <migrationGuide><strong>Learn more</strong></migrationGuide> about the vendor's plans to migrate app users (including you). Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    undecidedNonAdmin: {
        id: "connect-module-core.modules.app.undecidedNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. <migrationGuide><strong>Learn more</strong></migrationGuide> about the vendor's plans to migrate app users (including you). To explore your options, contact your site admin."
    },
    yesAdmin: {
        id: "connect-module-core.modules.app.yesAdmin",
        defaultMessage: "{hasAppName, select, true {This version of <strong>{appName}</strong>} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. The app developer is creating a new version; read about their <migrationGuide>migration plans for app users</migrationGuide>."
    },
    yesNonAdmin: {
        id: "connect-module-core.modules.app.yesNonAdmin",
        defaultMessage: "{hasAppName, select, true {This version of <strong>{appName}</strong>} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. The app developer is creating a new version; read about their <migrationGuide>migration plans for app users</migrationGuide>."
    },
    devCanaryMessage: {
        id: "connect-module-core.eos.devCanaryMessage",
        defaultMessage: "You're seeing this message because your tenant is enrolled in the <developerCanaryProgram>Developer Canary Program</developerCanaryProgram>. For updates on when this goes live in production, watch the <forgeChangelog>Forge changelog</forgeChangelog>."
    },
    dismiss: {
        id: "connect-module-core.eos.dismiss",
        defaultMessage: "Dismiss"
    },
    inlineSecondaryText: {
        id: "connect-module-core.eos.inlineSecondaryText",
        defaultMessage: "This app might stop working soon"
    }
});
module.exports["connectEosBannerMessages"] = $e33f058366d031a5$export$db71c19e7db05343;

});

parcelRegister("jAI8J", function(module, exports) {
/**
 * Set of system app addon keys.
 * These are special built-in applications that are part of the system.
 */ const $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS = new Set([
    'jira-slack-integration',
    'com.atlassian.servicedesk.embedded',
    'com.atlassian.servicedesk.embedded.moderate',
    'stspg-jira-ops',
    'com.atlassian.jira.spreadsheets',
    'atlassian-outlook-integration',
    'com.codebarrel.addons.automation',
    'com.codebarrel.addons.automation.moderate',
    'opsgenie-jira-adapter',
    'opsgenie-jira-adapter.moderate',
    'halp.com',
    'halp.moderate.com',
    'msteams-jira',
    'com.atlassian.atlas.jira',
    'cello',
    'msteams-confluence',
    'opsgenie-incident-timeline-lab',
    'com.addonengine.analytics'
]);
function $252ad196ad9bae6b$export$4d755424ce1abae9(addonKey) {
    return $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS.has(addonKey);
}
module.exports["isSystemApp"] = $252ad196ad9bae6b$export$4d755424ce1abae9;

});

parcelRegister("kksmx", function(module, exports) {
const $e82f7a932bbd9bed$export$66373c7c22b9de3c = '__LEGACY_MACRO_SSRED__';
const $e82f7a932bbd9bed$export$583da28e18e772e3 = (macroOutput, macroData)=>{
    if (macroOutput) return 'ssr-new';
    else if (macroData) return 'ssr-exp';
    return 'ssr-legacy';
};
const $e82f7a932bbd9bed$export$90da570939dfebac = (macroId)=>window[$e82f7a932bbd9bed$export$66373c7c22b9de3c]?.[macroId];
const $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c = ({ macroId: macroId, renderType: renderType })=>{
    return null;
};
module.exports["getRenderType"] = $e82f7a932bbd9bed$export$583da28e18e772e3;
module.exports["getExtensionSSRMark"] = $e82f7a932bbd9bed$export$90da570939dfebac;
module.exports["ExtensionSSRMark"] = $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c;

});

parcelRegister("4JC0x", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $98c2a7811aa5a89d$export$fe853ff85807a350 = new Map();
let $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
const $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState = (0, $dOBRD.default)(()=>{
    const rootQueryList = window?.__APOLLO_STATE__?.ROOT_QUERY || {};
    return Object.keys(rootQueryList).filter((query)=>query.startsWith('macroBodyRenderer'));
});
function $98c2a7811aa5a89d$var$isMacroPreloaded(macroId) {
    const preloadedMacros = $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState();
    return preloadedMacros.some((preloaded)=>preloaded.includes(macroId));
}
const $98c2a7811aa5a89d$export$1441f92d09a5c3ee = ()=>window.__SSR_RENDERED__ && !!window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
function $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl() {
    const cacheMismatches = $98c2a7811aa5a89d$var$getPreloadCacheMismatches();
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (cacheMismatches.length == 0 && (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0)) return;
    const failedMacros = {};
    function addFailed(reason, macroId, extensionKey) {
        failedMacros[macroId] = {
            reason: reason,
            extensionKey: extensionKey
        };
    }
    Object.entries(reportedFails).forEach(([keyAndId, reason])=>{
        if (keyAndId === 'general') return;
        const [extensionKey, macroId] = keyAndId.split(':');
        if (reason === 'timeout') {
            if ($98c2a7811aa5a89d$var$isMacroPreloaded(macroId)) addFailed('falseTimeouts', macroId, extensionKey);
            else addFailed('trueTimeouts', macroId, extensionKey);
        } else addFailed(reason, macroId, extensionKey);
    });
    cacheMismatches.forEach(([macroId, extensionKey])=>addFailed('cacheMismatch', macroId, extensionKey));
    return failedMacros;
}
function $98c2a7811aa5a89d$export$622ff65a4d6eaaaf() {
    if (!$98c2a7811aa5a89d$export$576fafc5561e06f5) $98c2a7811aa5a89d$export$576fafc5561e06f5 = {
        value: $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl()
    };
    return $98c2a7811aa5a89d$export$576fafc5561e06f5.value;
}
function $98c2a7811aa5a89d$export$de5406af81980582() {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
}
function $98c2a7811aa5a89d$export$3288a79f0c713f52(macroId) {
    const failedMacros = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf();
    return failedMacros?.[macroId]?.reason;
}
function $98c2a7811aa5a89d$export$34734b475a3fd7b9() {
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0) return;
    return reportedFails?.['general'];
}
function $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd(macroId, extensionKey) {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
    $98c2a7811aa5a89d$export$fe853ff85807a350.set(macroId, extensionKey || '');
    window['__MISSING_DATA_MACROS__'] = window['__MISSING_DATA_MACROS__'] || [];
    window['__MISSING_DATA_MACROS__'].push(macroId);
}
function $98c2a7811aa5a89d$var$getPreloadCacheMismatches() {
    return [
        ...$98c2a7811aa5a89d$export$fe853ff85807a350
    ].filter(([macroId])=>$98c2a7811aa5a89d$var$isMacroPreloaded(macroId));
}
module.exports["macrosPreloadPerformed"] = $98c2a7811aa5a89d$export$1441f92d09a5c3ee;
module.exports["getPreloadFailedMacros"] = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf;
module.exports["getPreloadFailures"] = $98c2a7811aa5a89d$export$3288a79f0c713f52;
module.exports["getGeneralFailures"] = $98c2a7811aa5a89d$export$34734b475a3fd7b9;
module.exports["markMissingMacroData"] = $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd;

});

parcelRegister("bD3fd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57a3a98d1c0cdf17dca67c7ba0624f0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8775da7cfc706ac1$var$_react = $8775da7cfc706ac1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8775da7cfc706ac1$var$_iconNew = $8775da7cfc706ac1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8775da7cfc706ac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Jira".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/jira
 * Usage guidance:
 * Representing JIRA
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8775da7cfc706ac1$var$JiraIcon = (props)=>/*#__PURE__*/ $8775da7cfc706ac1$var$_react.default.createElement($8775da7cfc706ac1$var$_iconNew.default, Object.assign({
        name: "JiraIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.25A.75.75 0 0 1 7.75.5h7a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-1.625A2.6 2.6 0 0 1 12 8.747v3.003a.75.75 0 0 1-.75.75H9.625a2.6 2.6 0 0 1-1.125-.253v3.003a.75.75 0 0 1-.75.75H6.125A2.625 2.625 0 0 1 3.5 13.375V12.5h-.875A2.625 2.625 0 0 1 0 9.875V8.25a.75.75 0 0 1 .75-.75h3.003A2.6 2.6 0 0 1 3.5 6.375V4.75A.75.75 0 0 1 4.25 4h3.003A2.6 2.6 0 0 1 7 2.875zM9.625 4h1.625a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125H14V2H8.5v.875C8.5 3.496 9.004 4 9.625 4m.875 1.5H5v.875C5 6.996 5.504 7.5 6.125 7.5H7.75a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125h.875zM7 9H1.5v.875c0 .621.504 1.125 1.125 1.125H4.25a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125H7z" clip-rule="evenodd"/>`
    }, props));
$8775da7cfc706ac1$var$JiraIcon.displayName = 'JiraIcon';
var $8775da7cfc706ac1$var$_default = module.exports.default = $8775da7cfc706ac1$var$JiraIcon;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7zsi1 = parcelRequire("7zsi1");


var $arQY7 = parcelRequire("arQY7");


var $cJ0FD = parcelRequire("cJ0FD");


var $kkFbH = parcelRequire("kkFbH");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $hekY6.default)([
            "_4xdlr0chRC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $cozmU.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_0aNu0LYbGa",
    classIconStyles: "_0bjKvDzXzM",
    iconStyles: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $cozmU.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_2QcWTwbGuW _2SqxC464sR _2JgCDVNDbq",
            "_2QcWTwLoGj _2SqxC4BE2a _2JgCDVoynL",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0Of8r21Y8M _2fwxA5DIqT _0KLXrurxgm",
            "_2QcWTwbGuW _2SqxC464sR _2JgCDVNDbq",
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $kSwu1.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $dOBRD.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $dOBRD.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $dOBRD.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $dOBRD.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $dOBRD.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("4eJH6", function(module, exports) {
var $7dcc17f1ea6ba5ae$export$b573856c46cc9357 = /*#__PURE__*/ function(CalendarView) {
    CalendarView["dayGridMonth"] = "dayGridMonth";
    CalendarView["timeGridWeek"] = "timeGridWeek";
    CalendarView["listMonth"] = "listMonth";
    CalendarView["list"] = "list";
    CalendarView["timeline"] = "timeline";
    return CalendarView;
}({});
var $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8 = /*#__PURE__*/ function(CalendarViewPreference) {
    CalendarViewPreference["month"] = "month";
    CalendarViewPreference["agendaWeek"] = "agendaWeek";
    CalendarViewPreference["basicDay"] = "basicDay";
    CalendarViewPreference["timeline"] = "timeline";
    return CalendarViewPreference;
}({});
module.exports["CalendarView"] = $7dcc17f1ea6ba5ae$export$b573856c46cc9357;
module.exports["CalendarViewPreference"] = $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("ipqo7", function(module, exports) {

var $8VCvx = parcelRequire("8VCvx");

const $989e58fe30d54eff$var$backgroundColorMessages = (0, $8VCvx.backgroundPaletteTooltipMessages).light;
const $989e58fe30d54eff$var$createTabColorAppearance = ({ backgroundColor: backgroundColor, backgroundColorHovered: backgroundColorHovered, borderColor: borderColor, textColor: textColor, swatchBackgroundColor: swatchBackgroundColor = backgroundColor, labelMessage: labelMessage, activeBackgroundColor: activeBackgroundColor, activeBorderColor: activeBorderColor = borderColor, activeTextColor: activeTextColor })=>({
        swatch: {
            backgroundColor: swatchBackgroundColor,
            labelMessage: labelMessage
        },
        tabPill: {
            inactive: {
                backgroundColor: backgroundColor,
                backgroundColorHovered: backgroundColorHovered,
                borderColor: borderColor,
                textColor: textColor
            },
            active: {
                backgroundColor: activeBackgroundColor,
                borderColor: activeBorderColor,
                textColor: activeTextColor
            }
        }
    });
const $989e58fe30d54eff$export$15f93407aad64edb = {
    'blue-subtlest': {
        panelColor: '#DEEBFF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#DEEBFF'],
                backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue, #1558BC)",
                activeBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
                activeTextColor: "var(--ds-text-accent-blue-bolder, #123263)"
            })
        }
    },
    'blue-subtler': {
        panelColor: '#B3D4FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B3D4FF'],
                backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue, #1558BC)",
                activeBackgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
                activeTextColor: "var(--ds-text-accent-blue-bolder, #123263)"
            })
        }
    },
    'blue-subtle': {
        panelColor: '#ADCBFB',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ADCBFB'],
                backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue-bolder, #123263)",
                activeBackgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ADCBFB'],
                backgroundColor: "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue-bolder, #123263)",
                activeBackgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'teal-subtlest': {
        panelColor: '#E6FCFF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E6FCFF'],
                backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal, #206A83)",
                activeBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
                activeTextColor: "var(--ds-text-accent-teal-bolder, #164555)"
            })
        }
    },
    'teal-subtler': {
        panelColor: '#B3F5FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B3F5FF'],
                backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal, #206A83)",
                activeBackgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
                activeTextColor: "var(--ds-text-accent-teal-bolder, #164555)"
            })
        }
    },
    'teal-subtle': {
        panelColor: '#B1E4F7',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B1E4F7'],
                backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal-bolder, #164555)",
                activeBackgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B1E4F7'],
                backgroundColor: "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal-bolder, #164555)",
                activeBackgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'green-subtlest': {
        panelColor: '#E3FCEF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3FCEF'],
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green, #216E4E)",
                activeBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
                activeTextColor: "var(--ds-text-accent-green-bolder, #164B35)"
            })
        }
    },
    'green-subtler': {
        panelColor: '#ABF5D1',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ABF5D1'],
                backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green, #216E4E)",
                activeBackgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
                activeTextColor: "var(--ds-text-accent-green-bolder, #164B35)"
            })
        }
    },
    'green-subtle': {
        panelColor: '#97EDC9',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#97EDC9'],
                backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green-bolder, #164B35)",
                activeBackgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#97EDC9'],
                backgroundColor: "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green-bolder, #164B35)",
                activeBackgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'lime-subtlest': {
        panelColor: '#EFFFD6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFFFD6'],
                backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime, #4C6B1F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
                activeTextColor: "var(--ds-text-accent-lime-bolder, #37471F)"
            })
        }
    },
    'lime-subtler': {
        panelColor: '#D3F1A7',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#D3F1A7'],
                backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime, #4C6B1F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
                activeTextColor: "var(--ds-text-accent-lime-bolder, #37471F)"
            })
        }
    },
    'lime-subtle': {
        panelColor: '#BDE97C',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#BDE97C'],
                backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#BDE97C'],
                backgroundColor: "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'yellow-subtlest': {
        panelColor: '#FFFAE6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFFAE6'],
                backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow, #7F5F01)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
                activeTextColor: "var(--ds-text-accent-yellow-bolder, #533F04)"
            })
        }
    },
    'yellow-subtler': {
        panelColor: '#FFF0B3',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFF0B3'],
                backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow, #7F5F01)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
                activeTextColor: "var(--ds-text-accent-yellow-bolder, #533F04)"
            })
        }
    },
    'yellow-subtle': {
        panelColor: '#EFDD4E',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFDD4E'],
                backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFDD4E'],
                backgroundColor: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'orange-subtlest': {
        panelColor: '#FFF5DB',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFF5DB'],
                backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange, #9E4C00)",
                activeBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
                activeTextColor: "var(--ds-text-accent-orange-bolder, #693200)"
            })
        }
    },
    'orange-subtler': {
        panelColor: '#FCE4A6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCE4A6'],
                backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange, #9E4C00)",
                activeBackgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
                activeTextColor: "var(--ds-text-accent-orange-bolder, #693200)"
            })
        }
    },
    'orange-subtle': {
        panelColor: '#FBD779',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FBD779'],
                backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange-bolder, #693200)",
                activeBackgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FBD779'],
                backgroundColor: "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange-bolder, #693200)",
                activeBackgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'red-subtlest': {
        panelColor: '#FFEBE6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFEBE6'],
                backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red, #AE2E24)",
                activeBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                activeTextColor: "var(--ds-text-accent-red-bolder, #5D1F1A)"
            })
        }
    },
    'red-subtler': {
        panelColor: '#FFBDAD',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFBDAD'],
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red, #AE2E24)",
                activeBackgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
                activeTextColor: "var(--ds-text-accent-red-bolder, #5D1F1A)"
            })
        }
    },
    'red-subtle': {
        panelColor: '#FFB8B2',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFB8B2'],
                backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
                activeBackgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFB8B2'],
                backgroundColor: "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
                activeBackgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'magenta-subtlest': {
        panelColor: '#FFECF8',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFECF8'],
                backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta, #943D73)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
                activeTextColor: "var(--ds-text-accent-magenta-bolder, #50253F)"
            })
        }
    },
    'magenta-subtler': {
        panelColor: '#FDD0EC',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FDD0EC'],
                backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta, #943D73)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
                activeTextColor: "var(--ds-text-accent-magenta-bolder, #50253F)"
            })
        }
    },
    'magenta-subtle': {
        panelColor: '#FCB6E1',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCB6E1'],
                backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCB6E1'],
                backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'purple-subtlest': {
        panelColor: '#EAE6FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EAE6FF'],
                backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple, #803FA5)",
                activeBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
                activeTextColor: "var(--ds-text-accent-purple-bolder, #48245D)"
            })
        }
    },
    'purple-subtler': {
        panelColor: '#C0B6F2',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#C0B6F2'],
                backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple, #803FA5)",
                activeBackgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
                activeTextColor: "var(--ds-text-accent-purple-bolder, #48245D)"
            })
        }
    },
    'purple-subtle': {
        panelColor: '#E3BDFA',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3BDFA'],
                backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
                activeBackgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3BDFA'],
                backgroundColor: "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
                activeBackgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'gray-subtler': {
        panelColor: '#F4F5F7',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#F4F5F7'],
                backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray, #505258)",
                activeBackgroundColor: "var(--ds-background-accent-gray-subtle, #8C8F97)",
                activeTextColor: "var(--ds-text-accent-gray-bolder, #1E1F21)"
            })
        }
    },
    'gray-subtle': {
        panelColor: '#B7B9BE',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B7B9BE'],
                backgroundColor: "var(--ds-background-accent-gray-subtle, #8C8F97)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
                activeBackgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B7B9BE'],
                backgroundColor: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
                activeBackgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    }
};
const $989e58fe30d54eff$var$tabColorDefinitionsByKey = $989e58fe30d54eff$export$15f93407aad64edb;
const $989e58fe30d54eff$var$panelColorToTabColor = new Map(Object.entries($989e58fe30d54eff$export$15f93407aad64edb).map(([colorKey, definition])=>[
        definition.panelColor.toLowerCase(),
        colorKey
    ]));
const $989e58fe30d54eff$export$6cb7a3ac5d38a331 = (color, appearanceMode = 'legacy')=>{
    const appearances = $989e58fe30d54eff$export$15f93407aad64edb[color].appearances;
    return appearanceMode === 'legacy' ? appearances.legacy ?? appearances.standard : appearances.standard;
};
const $989e58fe30d54eff$export$f020e6c7ee6351cc = (color)=>{
    if (typeof color !== 'string') return undefined;
    return $989e58fe30d54eff$var$tabColorDefinitionsByKey[color]?.panelColor;
};
const $989e58fe30d54eff$export$dba9f85b52f8dfa0 = (panelColor)=>{
    if (typeof panelColor !== 'string') return undefined;
    return $989e58fe30d54eff$var$panelColorToTabColor.get(panelColor.toLowerCase());
};
module.exports["getTabColorAppearance"] = $989e58fe30d54eff$export$6cb7a3ac5d38a331;
module.exports["getPanelColorForTabColor"] = $989e58fe30d54eff$export$f020e6c7ee6351cc;
module.exports["getTabColorForPanelColor"] = $989e58fe30d54eff$export$dba9f85b52f8dfa0;

});

parcelRegister("j4RIK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cdc6aab464c1fae2$export$6122306715c85017 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qKe_8",
    name: "PageTreeMacroHandler",
    loader: async ()=>(await (parcelRequire("3ulyI"))).PageTreeMacroRenderer
});
module.exports["PageTreeMacroHandler"] = $cdc6aab464c1fae2$export$6122306715c85017;

});

parcelRegister("3ulyI", function(module, exports) {

let $28a4e5984aee5dd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $28a4e5984aee5dd3$var$load("kNMDB"),
    $28a4e5984aee5dd3$var$load("9TOep"),
    $28a4e5984aee5dd3$var$load("3PgFB")
]).then(()=>parcelRequire('hD0Hb'));

});

parcelRegister("dF6Hu", function(module, exports) {
const $c19c056402cab920$export$aacbed104b7824d = {
    version: 1,
    type: 'doc',
    content: []
};
const $c19c056402cab920$export$92be905df4143632 = (adf)=>({
        version: 1,
        type: 'doc',
        content: adf
    });
const $c19c056402cab920$export$d287f5fb15383464 = (adfString)=>{
    try {
        const parsed = JSON.parse(adfString ?? '');
        return Array.isArray(parsed.content) ? $c19c056402cab920$export$92be905df4143632(parsed.content) : $c19c056402cab920$export$aacbed104b7824d;
    } catch  {
        return $c19c056402cab920$export$aacbed104b7824d;
    }
};
const $c19c056402cab920$export$6952557fbb0fdd5b = (adf)=>({
        content: {
            nodes: [
                {
                    body: {
                        dynamic: {
                            representation: 'atlas_doc_format',
                            value: JSON.stringify({
                                content: adf,
                                type: 'doc'
                            })
                        }
                    }
                }
            ]
        }
    });
module.exports["createNestedAdfDocument"] = $c19c056402cab920$export$92be905df4143632;
module.exports["parseNestedAdfDocument"] = $c19c056402cab920$export$d287f5fb15383464;
module.exports["createNestedRendererData"] = $c19c056402cab920$export$6952557fbb0fdd5b;

});

parcelRegister("2w2Hu", function(module, exports) {
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ const $8cf96aaaf31dfd76$export$75ebf2388340a0ba = {
    ClassicRendererLoader: 'ClassicRendererLoader',
    ClassicEditorContextProviderLoader: 'ClassicEditorContextProviderLoader',
    NativeCollabLoader: 'NativeCollabLoader',
    FullPageEditorLoader: 'FullPageEditorLoader',
    ViewPageRouteComponentLoader: 'ViewPageRouteComponentLoader',
    LivePageComponentLoader: 'LivePageComponentLoader',
    EditorByLineArea: 'EditorByLineArea',
    TitleAreaContentComponents: 'TitleAreaContentComponents'
};
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("gIDv4"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("gIDv4", function(module, exports) {

let $c2bf65516d0474fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2bf65516d0474fe$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $8W4Gr = parcelRequire("8W4Gr");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    // Capture before onComplete or a deferred paint callback can start another interaction.
    const binding = props.metric ? (0, $8W4Gr.getPageSegmentUFOBinding)(props.metric) : undefined;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        const data = {
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        };
        // An imperative start has no embedded context; retain its captured key and owner.
        if (binding && (binding.key === prefixedKey || binding.key === resolvedKey)) // Preserve React end-mark timing; stopTime is metadata on this API.
        (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, {
            customData: data
        });
        else {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
            (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
            (0, $gXfti.addUFOCustomData)(data);
        }
    }, [
        binding,
        onComplete,
        prefixedKey,
        resolvedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("i5q1w"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("i5q1w", function(module, exports) {

let $d2ace15913764e0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d2ace15913764e0b$var$load("30b92"),
    $d2ace15913764e0b$var$load("kNMDB"),
    $d2ace15913764e0b$var$load("1GCFv"),
    $d2ace15913764e0b$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});

parcelRegister("jJli4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $f9KPY = parcelRequire("f9KPY");


const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("6sGvR"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});
module.exports["ExcerptIncludeLoader"] = $7549d063fe593b21$export$2800e3d415e59020;

});

parcelRegister("f9KPY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lOkIA = parcelRequire("lOkIA");


var $dhEYL = parcelRequire("dhEYL");

class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $cozmU.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}
module.exports["ExcerptIncludeComponentShadow"] = $747c563e4499b240$export$8f88facf076a2d46;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $cozmU.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _3OE6xY715P _2IhTon715P _42Yu6BgtVO"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("dhEYL", function(module, exports) {
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: `${"var(--ds-border-width, 1px)"} 0px 0px 0px`,
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #6B6E76)",
    paddingLeft: "var(--ds-space-050, 4px)"
};
module.exports["panel"] = $9b021e0aba5455d5$export$21f42ab9b6679f44;
module.exports["panelHeader"] = $9b021e0aba5455d5$export$92937d9937dc7ce9;
module.exports["panelBody"] = $9b021e0aba5455d5$export$d763905bda51ef54;
module.exports["panelHeaderExcerpt"] = $9b021e0aba5455d5$export$99e3f651fb62ec86;

});

parcelRegister("6sGvR", function(module, exports) {

let $4b4655c98ac849c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4b4655c98ac849c8$var$load("fWCBZ"),
    $4b4655c98ac849c8$var$load("45r7q"),
    $4b4655c98ac849c8$var$load("6wr18"),
    $4b4655c98ac849c8$var$load("5EJB0"),
    $4b4655c98ac849c8$var$load("ffEVr"),
    $4b4655c98ac849c8$var$load("9TOep"),
    $4b4655c98ac849c8$var$load("jXx9i"),
    $4b4655c98ac849c8$var$load("57TcR"),
    $4b4655c98ac849c8$var$load("9tNcH")
]).then(()=>parcelRequire('c6u22'));

});

parcelRegister("5LTS4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");


var $1xpoY = parcelRequire("1xpoY");


var $bF1aY = parcelRequire("bF1aY");


var $h8C1D = parcelRequire("h8C1D");


var $kksmx = parcelRequire("kksmx");

const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $1xpoY.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $cozmU.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $cozmU.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0,
            hydratable: window?.__HYDRATABLE__ || false,
            hydrationFailed: window?.__HYDRATION_FAILED__ || false
        };
        const metric = (0, $bF1aY.LEGACY_EXTENSION_LOADING_METRIC)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: markerRef
    });
};
module.exports["ExtensionLoadingComplete"] = $ebb4d303074e1a0c$export$64e91845ba744516;

});

parcelRegister("bF1aY", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});
module.exports["LEGACY_EXTENSION_LOADING_METRIC"] = $63112e910a0def69$export$841f5507db609445;

});

parcelRegister("h8C1D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $llqlc = parcelRequire("llqlc");


var $8pcS0 = parcelRequire("8pcS0");

const $028a91b33dee434b$export$7affafe0528b70b1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    indexes: new Map()
});
const $028a91b33dee434b$var$extractExtensions = (adf)=>(0, $llqlc.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $028a91b33dee434b$export$e4ac003417d6dace = 'UNKNOWN';
const $028a91b33dee434b$export$981cab9712b3b1a3 = ({ document: document, children: children })=>{
    const indexes = (0, $cozmU.useMemo)(()=>{
        const extensions = $028a91b33dee434b$var$extractExtensions(document);
        return new Map(extensions.map((node, idx)=>{
            window['unsupportedExtension'] = window['unsupportedExtension'] || {};
            if (node.attrs?.parameters?.nestedContent?.content && node.attrs.extensionKey === '__confluenceADFMigrationUnsupportedContentInternalExtension__') node.attrs.parameters.nestedContent.content.forEach((each)=>{
                window['unsupportedExtension'][each.attrs?.parameters?.macroMetadata?.macroId?.value] = idx;
            });
            return [
                node.attrs?.parameters?.macroMetadata?.macroId?.value,
                idx
            ];
        }));
    }, [
        document
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            indexes: indexes
        }), [
        indexes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($028a91b33dee434b$export$7affafe0528b70b1.Provider, {
        value: value
    }, children);
};
const $028a91b33dee434b$export$ea9830505fbaa6ad = (macroId)=>{
    const { indexes: indexes } = (0, $cozmU.useContext)($028a91b33dee434b$export$7affafe0528b70b1);
    let index = indexes.get(macroId);
    const unsupportedExtensions = window['unsupportedExtension'];
    let isUnsupportedExtension = false;
    if (unsupportedExtensions && unsupportedExtensions[macroId]) {
        index = unsupportedExtensions[macroId];
        isUnsupportedExtension = true;
    }
    return {
        extensionIndex: typeof index === 'number' ? index : $028a91b33dee434b$export$e4ac003417d6dace,
        isUnsupportedExtension: isUnsupportedExtension
    };
};
module.exports["UNKNOWN_INDEX"] = $028a91b33dee434b$export$e4ac003417d6dace;
module.exports["ExtrensionIndexProvider"] = $028a91b33dee434b$export$981cab9712b3b1a3;
module.exports["useExtensionIndex"] = $028a91b33dee434b$export$ea9830505fbaa6ad;

});

parcelRegister("7bpSh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9dee672aff5abe3d$export$c4ffab2abecc9a7c = (0, $cozmU.createContext)(null);
module.exports["ContentModeFragmentContext"] = $9dee672aff5abe3d$export$c4ffab2abecc9a7c;

});

parcelRegister("hX2PJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $26Yfd = parcelRequire("26Yfd");


var $8bGvp = parcelRequire("8bGvp");

function $4a4d540a0776d558$var$identity(value) {
    return value;
}
function $4a4d540a0776d558$export$b9f4f60a9d12fe91(key, fragmentNode, t0) {
    const $ = (0, $bDgLe.c)(11);
    const { contentId: contentId, skip: t1, mapData: mapData } = t0;
    const skip = t1 === undefined ? false : t1;
    const fragment = (0, $8bGvp.useEditorContentFragments)()[key];
    const isProvided = fragment.isProvided && fragment.contentId === contentId;
    const result = (0, $6SsN4.useFragment)(fragmentNode, isProvided && !skip ? fragment.ref : null);
    const isLoading = isProvided && !skip && fragment.isLoading;
    const stableMapData = (0, $26Yfd.useStableCallback)(mapData ?? $4a4d540a0776d558$var$identity);
    let t2;
    if ($[0] !== result || $[1] !== stableMapData) {
        t2 = result?.ok ? stableMapData(result.value) : undefined;
        $[0] = result;
        $[1] = stableMapData;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== fragmentNode || $[4] !== result) {
        t3 = result?.ok === false ? new Error(`${(0, $eqEJl.getFragment)(fragmentNode).name} field error`, {
            cause: result.errors
        }) : undefined;
        $[3] = fragmentNode;
        $[4] = result;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== isLoading || $[7] !== isProvided || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            isProvided: isProvided,
            isLoading: isLoading,
            data: t2,
            error: t3
        };
        $[6] = isLoading;
        $[7] = isProvided;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
}
module.exports["useEditorContentFragment"] = $4a4d540a0776d558$export$b9f4f60a9d12fe91;

});

parcelRegister("8bGvp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $69682d2fbc90456d$var$getNode = (data)=>data.content?.nodes?.[0];
// Where each fragment's ref is in the operation's data; adding a fragment to the query without a
// selector here fails to compile.
const $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS = {
    contentTypesHeaderFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentTypesHeaderFragment,
    emojiTitleFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.emojiTitleFragment,
    emojiEverSetPropertyFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.emojiEverSetPropertyFragment,
    contentAppearanceFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentAppearanceFragment,
    coverPictureFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.coverPictureFragment,
    titleContentPropertiesFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.titleContentPropertiesFragment,
    contentModeFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentModeFragment,
    shareAndRestrictButtonFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.shareAndRestrictButtonFragment,
    shareAndRestrictButtonPublicLinkFragment: (data)=>data.shareAndRestrictButtonPublicLinkFragment
};
const $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_KEYS = Object.keys($69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS);
function $69682d2fbc90456d$var$mapFragments(toFragment) {
    return Object.fromEntries($69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_KEYS.map((key)=>[
            key,
            toFragment(key)
        ]));
}
function $69682d2fbc90456d$export$56cbeadb27426f30(data, { contentId: contentId, isLoading: isLoading }) {
    return $69682d2fbc90456d$var$mapFragments((key)=>({
            isProvided: true,
            ref: $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS[key](data) ?? null,
            contentId: contentId,
            isLoading: isLoading
        }));
}
const $69682d2fbc90456d$var$NOT_PROVIDED_FRAGMENTS = $69682d2fbc90456d$var$mapFragments(()=>({
        isProvided: false
    }));
const $69682d2fbc90456d$export$faab0246835c7509 = (0, $cozmU.createContext)($69682d2fbc90456d$var$NOT_PROVIDED_FRAGMENTS);
function $69682d2fbc90456d$export$2e53e9edef0785f2() {
    return (0, $cozmU.useContext)($69682d2fbc90456d$export$faab0246835c7509);
}
module.exports["createEditorContentFragments"] = $69682d2fbc90456d$export$56cbeadb27426f30;
module.exports["EditorContentFragmentsContext"] = $69682d2fbc90456d$export$faab0246835c7509;
module.exports["useEditorContentFragments"] = $69682d2fbc90456d$export$2e53e9edef0785f2;

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("4zpl0"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("4zpl0", function(module, exports) {

let $353e15dfe839e515$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $353e15dfe839e515$var$load("efUj2"),
    $353e15dfe839e515$var$load("kNMDB"),
    $353e15dfe839e515$var$load("6wr18"),
    $353e15dfe839e515$var$load("ffEVr"),
    $353e15dfe839e515$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("7ClHr"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("7ClHr"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("7ClHr", function(module, exports) {

let $58bcea23e6263ea7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $58bcea23e6263ea7$var$load("6wr18"),
    $58bcea23e6263ea7$var$load("jYRaq"),
    $58bcea23e6263ea7$var$load("7G12e"),
    $58bcea23e6263ea7$var$load("io0qR"),
    $58bcea23e6263ea7$var$load("ffEVr"),
    $58bcea23e6263ea7$var$load("3LYaV"),
    $58bcea23e6263ea7$var$load("9TOep"),
    $58bcea23e6263ea7$var$load("bSSct"),
    $58bcea23e6263ea7$var$load("7EorR"),
    $58bcea23e6263ea7$var$load("hhss7"),
    $58bcea23e6263ea7$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("3KlQi"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("3KlQi"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("3KlQi", function(module, exports) {

let $2ba69c74aa1c6bb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2ba69c74aa1c6bb1$var$load("7Rf3l"),
    $2ba69c74aa1c6bb1$var$load("jNr09"),
    $2ba69c74aa1c6bb1$var$load("9xmQ5"),
    $2ba69c74aa1c6bb1$var$load("g7Yjk"),
    $2ba69c74aa1c6bb1$var$load("iYvvi"),
    $2ba69c74aa1c6bb1$var$load("eWXZF"),
    $2ba69c74aa1c6bb1$var$load("fWCBZ"),
    $2ba69c74aa1c6bb1$var$load("6wr18"),
    $2ba69c74aa1c6bb1$var$load("5EJB0"),
    $2ba69c74aa1c6bb1$var$load("bqdgP"),
    $2ba69c74aa1c6bb1$var$load("7oAXW"),
    $2ba69c74aa1c6bb1$var$load("DsM5z"),
    $2ba69c74aa1c6bb1$var$load("lyagC"),
    $2ba69c74aa1c6bb1$var$load("jXx9i"),
    $2ba69c74aa1c6bb1$var$load("8bEF3"),
    $2ba69c74aa1c6bb1$var$load("57TcR"),
    $2ba69c74aa1c6bb1$var$load("cGkFm"),
    $2ba69c74aa1c6bb1$var$load("2jERw"),
    $2ba69c74aa1c6bb1$var$load("b7144"),
    $2ba69c74aa1c6bb1$var$load("ffEVr"),
    $2ba69c74aa1c6bb1$var$load("f6ZVy"),
    $2ba69c74aa1c6bb1$var$load("20wSi"),
    $2ba69c74aa1c6bb1$var$load("9LDVS"),
    $2ba69c74aa1c6bb1$var$load("kiMHu"),
    $2ba69c74aa1c6bb1$var$load("7J1PC"),
    $2ba69c74aa1c6bb1$var$load("446Ip"),
    $2ba69c74aa1c6bb1$var$load("fwbNS"),
    $2ba69c74aa1c6bb1$var$load("ckGjo"),
    $2ba69c74aa1c6bb1$var$load("gFeoL"),
    $2ba69c74aa1c6bb1$var$load("45r7q"),
    $2ba69c74aa1c6bb1$var$load("hhss7"),
    $2ba69c74aa1c6bb1$var$load("aAWLw"),
    $2ba69c74aa1c6bb1$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("9rgEf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $730c064714609652$export$4842845a3bdb74f6 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $730c064714609652$export$aa899bf2529ccb2 = $730c064714609652$export$4842845a3bdb74f6.Provider;
module.exports["PageDocumentContext"] = $730c064714609652$export$4842845a3bdb74f6;
module.exports["PageDocumentProvider"] = $730c064714609652$export$aa899bf2529ccb2;

});

parcelRegister("202oG", function(module, exports) {

var $2lPWP = parcelRequire("2lPWP");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $2lPWP.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("iNIw3", function(module, exports) {
const $2008359fb3515e18$export$38c6526d67de94bb = 'xen:macro';
const $2008359fb3515e18$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $2008359fb3515e18$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $2008359fb3515e18$export$46fc26821adc3495 = 'connectAddon';
const $2008359fb3515e18$export$95077f102dafd025 = 'migratedServerP2Addon';
const $2008359fb3515e18$export$981e47da3e2dfc13 = 'bodiedExtension';
const $2008359fb3515e18$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $2008359fb3515e18$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $2008359fb3515e18$export$bf4c163a4c708db1 = 'forgeDocUpdated';
const $2008359fb3515e18$export$973a451c50b864fd = 'atlassianMacroOutputType';
const $2008359fb3515e18$export$3551f8d01dfac8f1 = 'atlassianForgeInlineBodied';
module.exports["MODULE_NAME"] = $2008359fb3515e18$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $2008359fb3515e18$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $2008359fb3515e18$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $2008359fb3515e18$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $2008359fb3515e18$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $2008359fb3515e18$export$bf4c163a4c708db1;
module.exports["MACRO_OUTPUT_TYPE_PARAM"] = $2008359fb3515e18$export$973a451c50b864fd;
module.exports["FORGE_INLINE_BODIED_PARAM"] = $2008359fb3515e18$export$3551f8d01dfac8f1;

});

parcelRegister("2igSQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUI0h = parcelRequire("dUI0h");


var $2xdp1 = parcelRequire("2xdp1");


var $kwjRd = parcelRequire("kwjRd");


var $idCCS = parcelRequire("idCCS");

const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};
module.exports["TemplateVariableInput"] = $f852cc0c808326c8$export$cdee65ffaf9b2fb7;

});

parcelRegister("2xdp1", function(module, exports) {

var $55ggG = parcelRequire("55ggG");

const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;
module.exports["defaultVariableName"] = $df54c7f294e74661$export$178c63c1bbc65458;
module.exports["TEXT_TYPE"] = $df54c7f294e74661$export$ae3b897442224943;
module.exports["MULTI_LINES_TYPE"] = $df54c7f294e74661$export$a43e313f04be91d7;
module.exports["LIST_TYPE"] = $df54c7f294e74661$export$22c50a44ec8aa5dd;
module.exports["ROWS_DEFAULT"] = $df54c7f294e74661$export$d1952e7dbe0fefc9;
module.exports["COLUMNS_DEFAULT"] = $df54c7f294e74661$export$777b44f8413b254e;

});

parcelRegister("55ggG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});
module.exports["i18n"] = $446fbea06bd2a31f$export$a7357cdd1f0b0168;

});

parcelRegister("kwjRd", function(module, exports) {
/* SharedComponents.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842B0rP _1DCdHi5zaO _1wydGWFQfX _3iDTPbvbI6",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEV9lr _0bjKvDXPZg _0KLXruVva3",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3W2Oc84hR5 _1UtDYzy7kJ _1kk5TkzUZr",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEV9lr _0bjKvD7Zry _1UtDYzKGUX _0KLXruVva3 _3W2Oc84hR5",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _1EqgXlN91d _1ANEUSzUZr",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _1EqgXlN91d _1mT5xdRAKS _1RrJLiBwqQ",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_25VRdPZqHV",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFMFQfX",
            __cmplp.className
        ])
    });
});
module.exports["TemplateVariableInputWrapper"] = $f809923cf8cfa046$export$4af78215734bfe2b;
module.exports["TemplateVariableNameWrapper"] = $f809923cf8cfa046$export$59d0bfd82baefce0;
module.exports["TemplateVariableName"] = $f809923cf8cfa046$export$8eff3c6bf5b8c758;
module.exports["TemplateVariableType"] = $f809923cf8cfa046$export$b4ff36272a61159f;
module.exports["TemplateVariableInputFieldWrapper"] = $f809923cf8cfa046$export$e3cad7a6d45ce703;
module.exports["TemplateVariableTextareaInputFieldWrapper"] = $f809923cf8cfa046$export$e9df20cb66227872;
module.exports["ButtonStyle"] = $f809923cf8cfa046$export$bdc3c19374266b98;
module.exports["DropDownInputWrapper"] = $f809923cf8cfa046$export$c996e1cc40266f34;

});

parcelRegister("idCCS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $3GNtk = parcelRequire("3GNtk");


var $5SGpQ = parcelRequire("5SGpQ");


var $lpNn5 = parcelRequire("lpNn5");


var $kwjRd = parcelRequire("kwjRd");


var $2xdp1 = parcelRequire("2xdp1");

const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $cozmU.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $cozmU.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        // eslint-disable-next-line @atlaskit/design-system/enforce-inline-styles-in-select
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        // eslint-disable-next-line @atlaskit/design-system/enforce-inline-styles-in-select
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};
module.exports["TemplateVariableInputComponent"] = $ab3c5e793706abd9$export$f57c870ff73570c7;

});

parcelRegister("d33vY", function(module, exports) {

var $9xhvY = parcelRequire("9xhvY");

const $b72a988e4c96b227$var$materialize = (intl, messages)=>Object.values(messages).reduce((keywords, descriptor)=>{
        const keyword = intl.formatMessage(descriptor);
        if (keyword.trim().length > 0) keywords.push(keyword);
        return keywords;
    }, []);
const $b72a988e4c96b227$export$9e9e689df24bb863 = (intl)=>$b72a988e4c96b227$var$materialize(intl, (0, $9xhvY.titleKeywordMessages));
const $b72a988e4c96b227$export$481c14b1f52fc674 = (intl)=>$b72a988e4c96b227$var$materialize(intl, (0, $9xhvY.contentKeywordMessages));
module.exports["getTitleKeywords"] = $b72a988e4c96b227$export$9e9e689df24bb863;
module.exports["getContentKeywords"] = $b72a988e4c96b227$export$481c14b1f52fc674;

});

parcelRegister("9xhvY", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ae3f7d6d0e7de18b$export$650dc367698d00c6 = (0, $kSwu1.defineMessages)({
    meeting: {
        id: "meeting-signal-instrumentation.title-keyword.meeting",
        defaultMessage: "meeting"
    },
    meetings: {
        id: "meeting-signal-instrumentation.title-keyword.meetings",
        defaultMessage: "meetings"
    },
    sync: {
        id: "meeting-signal-instrumentation.title-keyword.sync",
        defaultMessage: "sync"
    },
    standup: {
        id: "meeting-signal-instrumentation.title-keyword.standup",
        defaultMessage: "standup"
    },
    dailyStandup: {
        id: "meeting-signal-instrumentation.title-keyword.daily-standup",
        defaultMessage: "daily standup"
    },
    huddle: {
        id: "meeting-signal-instrumentation.title-keyword.huddle",
        defaultMessage: "huddle"
    },
    checkIn: {
        id: "meeting-signal-instrumentation.title-keyword.check-in",
        defaultMessage: "check-in"
    },
    oneOnOne: {
        id: "meeting-signal-instrumentation.title-keyword.one-on-one",
        defaultMessage: "1:1"
    },
    kickoff: {
        id: "meeting-signal-instrumentation.title-keyword.kickoff",
        defaultMessage: "kickoff"
    },
    review: {
        id: "meeting-signal-instrumentation.title-keyword.review",
        defaultMessage: "review"
    },
    demo: {
        id: "meeting-signal-instrumentation.title-keyword.demo",
        defaultMessage: "demo"
    },
    showcase: {
        id: "meeting-signal-instrumentation.title-keyword.showcase",
        defaultMessage: "showcase"
    },
    workingSession: {
        id: "meeting-signal-instrumentation.title-keyword.working-session",
        defaultMessage: "working session"
    },
    officeHours: {
        id: "meeting-signal-instrumentation.title-keyword.office-hours",
        defaultMessage: "office hours"
    },
    townHall: {
        id: "meeting-signal-instrumentation.title-keyword.town-hall",
        defaultMessage: "town hall"
    },
    allHands: {
        id: "meeting-signal-instrumentation.title-keyword.all-hands",
        defaultMessage: "all hands"
    },
    leadershipSync: {
        id: "meeting-signal-instrumentation.title-keyword.leadership-sync",
        defaultMessage: "leadership sync"
    },
    staffMeeting: {
        id: "meeting-signal-instrumentation.title-keyword.staff-meeting",
        defaultMessage: "staff meeting"
    },
    teamMeeting: {
        id: "meeting-signal-instrumentation.title-keyword.team-meeting",
        defaultMessage: "team meeting"
    },
    customerCall: {
        id: "meeting-signal-instrumentation.title-keyword.customer-call",
        defaultMessage: "customer call"
    },
    discoveryCall: {
        id: "meeting-signal-instrumentation.title-keyword.discovery-call",
        defaultMessage: "discovery call"
    },
    designReview: {
        id: "meeting-signal-instrumentation.title-keyword.design-review",
        defaultMessage: "design review"
    },
    architectureReview: {
        id: "meeting-signal-instrumentation.title-keyword.architecture-review",
        defaultMessage: "architecture review"
    },
    backlogRefinement: {
        id: "meeting-signal-instrumentation.title-keyword.backlog-refinement",
        defaultMessage: "backlog refinement"
    },
    agenda: {
        id: "meeting-signal-instrumentation.title-keyword.agenda",
        defaultMessage: "agenda"
    },
    meetingAgenda: {
        id: "meeting-signal-instrumentation.title-keyword.meeting-agenda",
        defaultMessage: "meeting agenda"
    },
    meetingNotes: {
        id: "meeting-signal-instrumentation.title-keyword.meeting-notes",
        defaultMessage: "meeting notes"
    },
    discussionTopics: {
        id: "meeting-signal-instrumentation.title-keyword.discussion-topics",
        defaultMessage: "discussion topics"
    },
    discussion: {
        id: "meeting-signal-instrumentation.title-keyword.discussion",
        defaultMessage: "discussion"
    },
    decisions: {
        id: "meeting-signal-instrumentation.title-keyword.decisions",
        defaultMessage: "decisions"
    },
    decisionLog: {
        id: "meeting-signal-instrumentation.title-keyword.decision-log",
        defaultMessage: "decision log"
    },
    attendees: {
        id: "meeting-signal-instrumentation.title-keyword.attendees",
        defaultMessage: "attendees"
    },
    participants: {
        id: "meeting-signal-instrumentation.title-keyword.participants",
        defaultMessage: "participants"
    },
    outcomes: {
        id: "meeting-signal-instrumentation.title-keyword.outcomes",
        defaultMessage: "outcomes"
    },
    parkingLot: {
        id: "meeting-signal-instrumentation.title-keyword.parking-lot",
        defaultMessage: "parking lot"
    }
});
const $ae3f7d6d0e7de18b$export$50c58b2d87c2deae = (0, $kSwu1.defineMessages)({
    letsSync: {
        id: "meeting-signal-instrumentation.content-keyword.lets-sync",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "let's sync"
    },
    letsDiscuss: {
        id: "meeting-signal-instrumentation.content-keyword.lets-discuss",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "let's discuss"
    },
    letsReview: {
        id: "meeting-signal-instrumentation.content-keyword.lets-review",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "let's review"
    },
    scheduleAMeeting: {
        id: "meeting-signal-instrumentation.content-keyword.schedule-a-meeting",
        defaultMessage: "schedule a meeting"
    },
    scheduleACall: {
        id: "meeting-signal-instrumentation.content-keyword.schedule-a-call",
        defaultMessage: "schedule a call"
    },
    bookTime: {
        id: "meeting-signal-instrumentation.content-keyword.book-time",
        defaultMessage: "book time"
    },
    findTime: {
        id: "meeting-signal-instrumentation.content-keyword.find-time",
        defaultMessage: "find time"
    },
    calendarInvite: {
        id: "meeting-signal-instrumentation.content-keyword.calendar-invite",
        defaultMessage: "calendar invite"
    },
    invite: {
        id: "meeting-signal-instrumentation.content-keyword.invite",
        defaultMessage: "invite"
    },
    joinTheMeeting: {
        id: "meeting-signal-instrumentation.content-keyword.join-the-meeting",
        defaultMessage: "join the meeting"
    },
    joinTheCall: {
        id: "meeting-signal-instrumentation.content-keyword.join-the-call",
        defaultMessage: "join the call"
    },
    zoom: {
        id: "meeting-signal-instrumentation.content-keyword.zoom",
        defaultMessage: "Zoom"
    },
    googleMeet: {
        id: "meeting-signal-instrumentation.content-keyword.google-meet",
        defaultMessage: "Google Meet"
    },
    microsoftTeams: {
        id: "meeting-signal-instrumentation.content-keyword.microsoft-teams",
        defaultMessage: "Microsoft Teams"
    },
    webex: {
        id: "meeting-signal-instrumentation.content-keyword.webex",
        defaultMessage: "Webex"
    },
    recap: {
        id: "meeting-signal-instrumentation.content-keyword.recap",
        defaultMessage: "recap"
    },
    meetingSummary: {
        id: "meeting-signal-instrumentation.content-keyword.meeting-summary",
        defaultMessage: "meeting summary"
    },
    summary: {
        id: "meeting-signal-instrumentation.content-keyword.summary",
        defaultMessage: "summary"
    },
    asDiscussed: {
        id: "meeting-signal-instrumentation.content-keyword.as-discussed",
        defaultMessage: "as discussed"
    },
    followUp: {
        id: "meeting-signal-instrumentation.content-keyword.follow-up",
        defaultMessage: "follow up"
    },
    followUpHyphenated: {
        id: "meeting-signal-instrumentation.content-keyword.follow-up-hyphenated",
        defaultMessage: "follow-up"
    },
    decisionsMade: {
        id: "meeting-signal-instrumentation.content-keyword.decisions-made",
        defaultMessage: "decisions made"
    },
    takeaways: {
        id: "meeting-signal-instrumentation.content-keyword.takeaways",
        defaultMessage: "takeaways"
    },
    owners: {
        id: "meeting-signal-instrumentation.content-keyword.owners",
        defaultMessage: "owners"
    },
    discussionNotes: {
        id: "meeting-signal-instrumentation.content-keyword.discussion-notes",
        defaultMessage: "discussion notes"
    }
});
module.exports["titleKeywordMessages"] = $ae3f7d6d0e7de18b$export$650dc367698d00c6;
module.exports["contentKeywordMessages"] = $ae3f7d6d0e7de18b$export$50c58b2d87c2deae;

});

parcelRegister("aLdKz", function(module, exports) {
const $86ad379a82c4233e$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $86ad379a82c4233e$var$BOUNDARY_START = '(?<![\\p{L}\\p{N}])';
const $86ad379a82c4233e$var$BOUNDARY_END = '(?![\\p{L}\\p{N}])';
const $86ad379a82c4233e$var$keywordRegExpCache = new WeakMap();
const $86ad379a82c4233e$var$buildKeywordPattern = (keyword)=>{
    const trimmed = keyword.trim();
    if (!trimmed) return null;
    return $86ad379a82c4233e$var$escapeRegExp(trimmed).replace(/\\?\s+/g, '\\s+');
};
const $86ad379a82c4233e$var$buildKeywordsRegExp = (keywords)=>{
    const cached = $86ad379a82c4233e$var$keywordRegExpCache.get(keywords);
    if (cached !== undefined) return cached;
    const patterns = keywords.reduce((result, keyword)=>{
        const pattern = $86ad379a82c4233e$var$buildKeywordPattern(keyword);
        if (pattern) result.push(pattern);
        return result;
    }, []);
    const regExp = patterns.length ? new RegExp(`${$86ad379a82c4233e$var$BOUNDARY_START}(?:${patterns.join('|')})${$86ad379a82c4233e$var$BOUNDARY_END}`, 'iu') : null;
    $86ad379a82c4233e$var$keywordRegExpCache.set(keywords, regExp);
    return regExp;
};
const $86ad379a82c4233e$export$f03a029d529b865c = (text, keywords)=>{
    if (!text || keywords.length === 0) return false;
    return $86ad379a82c4233e$var$buildKeywordsRegExp(keywords)?.test(text) ?? false;
};
module.exports["matchMeetingSignal"] = $86ad379a82c4233e$export$f03a029d529b865c;

});

parcelRegister("k6kVI", function(module, exports) {
/**
 * Template ID fragments for Confluence meeting templates.
 *
 * A template matches when its ID contains one of these fragments. The check ignores letter case.
 * Sprint Review is not in the list because Confluence has no matching template ID.
 */ const $643c77d21a6f0edd$var$MEETING_TEMPLATE_KEY_FRAGMENTS = [
    'meeting-notes',
    'recurring-meeting-minutes',
    '1-on-1-meeting',
    'daily-stand-up',
    'sprint-planning-meeting',
    'retrospective',
    'project-kickoff',
    'projectplan'
];
const $643c77d21a6f0edd$export$d5913fcea085e5c2 = (template)=>{
    const id = template?.id;
    if (!id) return false;
    const normalised = id.toLowerCase();
    return $643c77d21a6f0edd$var$MEETING_TEMPLATE_KEY_FRAGMENTS.some((fragment)=>normalised.includes(fragment));
};
module.exports["matchesMeetingTemplate"] = $643c77d21a6f0edd$export$d5913fcea085e5c2;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("hHZWk", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $cozmU.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("8cOoD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("euF5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("eDhGx", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

const $aebb4f1677ca9e0c$var$parseAdf = (adf)=>{
    if (!adf) return null;
    if (typeof adf === 'string') try {
        return JSON.parse(adf);
    } catch  {
        return null;
    }
    return adf;
};
const $aebb4f1677ca9e0c$export$dfcbbff917a117e2 = (adf)=>{
    const doc = $aebb4f1677ca9e0c$var$parseAdf(adf);
    if (!doc) return '';
    const text = (0, $4EPzQ.reduce)(// Best-effort: the parsed value is treated as an ADFEntity for traversal.
    doc, (acc, node)=>{
        if (node.type === 'text' && typeof node.text === 'string') return `${acc}${node.text} `;
        return acc;
    }, '');
    return text.replace(/\s+/g, ' ').trim();
};
module.exports["adfToPlainText"] = $aebb4f1677ca9e0c$export$dfcbbff917a117e2;

});

parcelRegister("hl0fg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $cozmU.useState)(getSize);
    (0, $cozmU.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("9FtrC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4962e1f9a762d77743dc0513d1a5d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $709ec86ec7839cbd$var$_react = $709ec86ec7839cbd$var$_interopRequireDefault((parcelRequire("cozmU")));

var $709ec86ec7839cbd$var$_iconNew = $709ec86ec7839cbd$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $709ec86ec7839cbd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignContentBottom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-content-bottom
 * Usage guidance:
 * Used for aligning bottom edges of content in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $709ec86ec7839cbd$var$AlignContentBottomIcon = (props)=>/*#__PURE__*/ $709ec86ec7839cbd$var$_react.default.createElement($709ec86ec7839cbd$var$_iconNew.default, Object.assign({
        name: "AlignContentBottomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 14.5h16V16H0zM4.38 13C3.62 13 3 12.38 3 11.63V2.38C3 1.62 3.62 1 4.38 1h1.5c.76 0 1.38.62 1.38 1.38v9.25c0 .76-.62 1.38-1.37 1.38zm.13-1.5h1.25v-9H4.5zm5.62 1.5c-.76 0-1.37-.62-1.37-1.37V7.38c0-.76.62-1.37 1.38-1.37h1.5C12.39 6 13 6.62 13 7.38v4.25c0 .76-.62 1.38-1.37 1.38zm.13-1.5h1.25v-4h-1.25z" clip-rule="evenodd"/>`
    }, props));
$709ec86ec7839cbd$var$AlignContentBottomIcon.displayName = 'AlignContentBottomIcon';
var $709ec86ec7839cbd$var$_default = module.exports.default = $709ec86ec7839cbd$var$AlignContentBottomIcon;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$a90803a9f656fd5f = 'showCreateWithRovo';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$57f29eb0a90c2092 = 'initial-background-style';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$bc2f90c007ecd529 = 'rovo';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["SHOW_CREATE_WITH_ROVO_QUERY_PARAM"] = $0037b6bfd6daf741$export$a90803a9f656fd5f;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["INITIAL_BACKGROUND_STYLE_QUERY_PARAM"] = $0037b6bfd6daf741$export$57f29eb0a90c2092;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["ROVO_PARENT_PRODUCT_QUERY_VALUE"] = $0037b6bfd6daf741$export$bc2f90c007ecd529;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("gY2jm"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("6Yc8q"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("gY2jm", function(module, exports) {

let $c5a40ae3a3816f81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c5a40ae3a3816f81$var$load("46Rej"),
    $c5a40ae3a3816f81$var$load("jNr09"),
    $c5a40ae3a3816f81$var$load("9xmQ5"),
    $c5a40ae3a3816f81$var$load("4PCFY"),
    $c5a40ae3a3816f81$var$load("2F69B"),
    $c5a40ae3a3816f81$var$load("Oocfq"),
    $c5a40ae3a3816f81$var$load("lKZDc"),
    $c5a40ae3a3816f81$var$load("bqdgP"),
    $c5a40ae3a3816f81$var$load("giX30"),
    $c5a40ae3a3816f81$var$load("lUYNi"),
    $c5a40ae3a3816f81$var$load("3UmlS"),
    $c5a40ae3a3816f81$var$load("7SteV"),
    $c5a40ae3a3816f81$var$load("jPAfq"),
    $c5a40ae3a3816f81$var$load("4aKct"),
    $c5a40ae3a3816f81$var$load("ennNB"),
    $c5a40ae3a3816f81$var$load("9Hr92"),
    $c5a40ae3a3816f81$var$load("eUsnQ"),
    $c5a40ae3a3816f81$var$load("khIi2"),
    $c5a40ae3a3816f81$var$load("eEjUf"),
    $c5a40ae3a3816f81$var$load("3pkSd"),
    $c5a40ae3a3816f81$var$load("5ax2I"),
    $c5a40ae3a3816f81$var$load("5KWjU"),
    $c5a40ae3a3816f81$var$load("dxcsb"),
    $c5a40ae3a3816f81$var$load("epyZS"),
    $c5a40ae3a3816f81$var$load("532dz"),
    $c5a40ae3a3816f81$var$load("DsM5z"),
    $c5a40ae3a3816f81$var$load("lyagC"),
    $c5a40ae3a3816f81$var$load("cGkFm"),
    $c5a40ae3a3816f81$var$load("2jERw"),
    $c5a40ae3a3816f81$var$load("b7144"),
    $c5a40ae3a3816f81$var$load("a7sEM"),
    $c5a40ae3a3816f81$var$load("caMoT"),
    $c5a40ae3a3816f81$var$load("a6kGP"),
    $c5a40ae3a3816f81$var$load("dB5kj"),
    $c5a40ae3a3816f81$var$load("ckVWI"),
    $c5a40ae3a3816f81$var$load("ihRIc"),
    $c5a40ae3a3816f81$var$load("9LDVS"),
    $c5a40ae3a3816f81$var$load("kiMHu"),
    $c5a40ae3a3816f81$var$load("7J1PC"),
    $c5a40ae3a3816f81$var$load("446Ip"),
    $c5a40ae3a3816f81$var$load("g7Yjk"),
    $c5a40ae3a3816f81$var$load("aqs28"),
    $c5a40ae3a3816f81$var$load("bJbqV"),
    $c5a40ae3a3816f81$var$load("hLB9K"),
    $c5a40ae3a3816f81$var$load("le1z7"),
    $c5a40ae3a3816f81$var$load("4xsdA"),
    $c5a40ae3a3816f81$var$load("ejk86"),
    $c5a40ae3a3816f81$var$load("9TOep"),
    $c5a40ae3a3816f81$var$load("bSSct"),
    $c5a40ae3a3816f81$var$load("lUBBr"),
    $c5a40ae3a3816f81$var$load("iYvvi"),
    $c5a40ae3a3816f81$var$load("eWXZF"),
    $c5a40ae3a3816f81$var$load("isVeA"),
    $c5a40ae3a3816f81$var$load("6wr18"),
    $c5a40ae3a3816f81$var$load("ffEVr"),
    $c5a40ae3a3816f81$var$load("7gPXS"),
    $c5a40ae3a3816f81$var$load("91v6x"),
    $c5a40ae3a3816f81$var$load("g5INx"),
    $c5a40ae3a3816f81$var$load("45r7q"),
    $c5a40ae3a3816f81$var$load("hhss7"),
    $c5a40ae3a3816f81$var$load("hEkNB"),
    $c5a40ae3a3816f81$var$load("dP7Qm"),
    $c5a40ae3a3816f81$var$load("aAWLw"),
    $c5a40ae3a3816f81$var$load("7EorR"),
    $c5a40ae3a3816f81$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("6Yc8q", function(module, exports) {

let $5131c26e7099b076$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5131c26e7099b076$var$load("57TcR"),
    $5131c26e7099b076$var$load("g5INx"),
    $5131c26e7099b076$var$load("j3lvX"),
    $5131c26e7099b076$var$load("bm0oR"),
    $5131c26e7099b076$var$load("30b92"),
    $5131c26e7099b076$var$load("giX30"),
    $5131c26e7099b076$var$load("lUYNi"),
    $5131c26e7099b076$var$load("le1z7"),
    $5131c26e7099b076$var$load("4xsdA"),
    $5131c26e7099b076$var$load("ea3NB"),
    $5131c26e7099b076$var$load("6wr18"),
    $5131c26e7099b076$var$load("59hV4"),
    $5131c26e7099b076$var$load("fuOfV"),
    $5131c26e7099b076$var$load("jL1Ke"),
    $5131c26e7099b076$var$load("5MQ0D"),
    $5131c26e7099b076$var$load("3LYaV"),
    $5131c26e7099b076$var$load("ffEVr"),
    $5131c26e7099b076$var$load("20wSi"),
    $5131c26e7099b076$var$load("7J1PC"),
    $5131c26e7099b076$var$load("446Ip"),
    $5131c26e7099b076$var$load("fwbNS"),
    $5131c26e7099b076$var$load("1T63O"),
    $5131c26e7099b076$var$load("h4Nf7"),
    $5131c26e7099b076$var$load("9TOep"),
    $5131c26e7099b076$var$load("fWCBZ"),
    $5131c26e7099b076$var$load("hhss7"),
    $5131c26e7099b076$var$load("7EorR"),
    $5131c26e7099b076$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("6m0us", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");

function $bc133074e939e7bd$var$clearStaticMacroStore(store) {
    store.html.clear();
    store.errors.clear();
    store.resultMetadata.clear();
    store.fullyLoaded = false;
    store.draftSyncCount = 0;
    store.lastMountDraftSyncCount.clear();
    store.presentAtLoad.clear();
    store.insertionRefetchStarted.clear();
    store.insertionRefetchGaveUp.clear();
    store.lastGuestParams.clear();
    store.pendingDraftSyncCallbacks.clear();
}
function $bc133074e939e7bd$var$createStaticMacroStore() {
    return {
        html: new Map(),
        errors: new Map(),
        resultMetadata: new Map(),
        nextResultVersion: 0,
        fullyLoaded: false,
        draftSyncCount: 0,
        lastMountDraftSyncCount: new Map(),
        presentAtLoad: new Set(),
        insertionRefetchStarted: new Set(),
        insertionRefetchGaveUp: new Set(),
        lastGuestParams: new Map(),
        pendingDraftSyncCallbacks: new Map(),
        draftSyncRequestScheduled: false
    };
}
/**
 * Builds two sets of extensionKeys by reading the preloaded extensions from
 * window.__SSR_FORGE_EXTENSIONS__:
 *  - staticKeys: keys that resolve to a Forge macro with staticView support
 *    (has a `static` property, e.g. `properties.static`).
 *  - knownKeys: every recognized/adopted key, static or not.
 *
 * Each extension contributes its own `key` (native/same-key adoption) plus any legacy
 * Connect macro keys listed in its `properties.migratedFrom` (alias-based adoption, where
 * the Forge module key differs from the original Connect macro key it replaces).
 *
 * This lets an untouched Connect-shaped node's legacy extensionKey resolve to eligibility
 * instantly via `knownKeys`/`staticKeys`, without waiting for the bulk staticMacros query.
 */ function $bc133074e939e7bd$var$buildExtensionKeySets() {
    const staticKeys = new Set();
    const knownKeys = new Set();
    try {
        const extensions = window.__SSR_FORGE_EXTENSIONS__?.['xen:macro']?.extensions ?? [];
        for (const ext of extensions){
            if (!ext?.key) continue;
            const isStatic = ext?.properties?.static != null;
            const migratedFrom = ext?.properties?.migratedFrom;
            const keysForExtension = [
                ext.key
            ];
            if (Array.isArray(migratedFrom)) {
                for (const legacyKey of migratedFrom)if (typeof legacyKey === 'string') keysForExtension.push(legacyKey);
            }
            for (const key of keysForExtension){
                knownKeys.add(key);
                if (isStatic) staticKeys.add(key);
            }
        }
    } catch  {
    // Defensive: if window access fails, return empty sets (all macros fall back to
    // waiting for the bulk query / iframe)
    }
    return {
        staticKeys: staticKeys,
        knownKeys: knownKeys
    };
}
const $bc133074e939e7bd$var$StaticMacroStoreContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
function $bc133074e939e7bd$export$fe63a9c79eca4b07({ children: children, contentId: contentId }) {
    const storeRef = (0, $cozmU.useRef)($bc133074e939e7bd$var$createStaticMacroStore());
    const storeContentIdRef = (0, $cozmU.useRef)(contentId);
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (contentId !== storeContentIdRef.current && (0, $9wGTI.fg)('conf_frontend_static_macro_perf')) {
        storeContentIdRef.current = contentId;
        $bc133074e939e7bd$var$clearStaticMacroStore(storeRef.current);
    }
    const listenersRef = (0, $cozmU.useRef)(new Map()); // localId -> listener callbacks
    const fullyLoadedListenersRef = (0, $cozmU.useRef)(new Set());
    const getExtensionKeySets = (0, $cozmU.useCallback)(()=>$bc133074e939e7bd$var$buildExtensionKeySets(), []);
    const subscribe = (0, $cozmU.useCallback)((localId, cb)=>{
        const listeners = listenersRef.current;
        if (!listeners.has(localId)) listeners.set(localId, new Set());
        listeners.get(localId).add(cb);
        fullyLoadedListenersRef.current.add(cb);
        return ()=>{
            listeners.get(localId)?.delete(cb);
            fullyLoadedListenersRef.current.delete(cb);
        };
    }, []);
    const register = (0, $cozmU.useCallback)((localId_0, html, options)=>{
        const store = storeRef.current;
        if (store.html.has(localId_0) && !options?.force) return;
        store.html.set(localId_0, html);
        // A forced (refetch) registration supersedes any previous error for this localId too.
        if (options?.force) store.errors.delete(localId_0);
        store.resultMetadata.set(localId_0, {
            attempt: options?.attempt ?? 'initial',
            version: store.nextResultVersion++
        });
        listenersRef.current.get(localId_0)?.forEach((cb_0)=>cb_0({
                type: 'static-macro-result'
            }));
    }, []);
    const registerError = (0, $cozmU.useCallback)((localId_1, errorCode, options_0)=>{
        const store_0 = storeRef.current;
        if (store_0.errors.has(localId_1) && !options_0?.force) return;
        store_0.errors.set(localId_1, errorCode);
        if (options_0?.force) store_0.html.delete(localId_1);
        store_0.resultMetadata.set(localId_1, {
            attempt: options_0?.attempt ?? 'initial',
            version: store_0.nextResultVersion++
        });
        listenersRef.current.get(localId_1)?.forEach((cb_1)=>cb_1({
                type: 'static-macro-result'
            }));
    }, []);
    const markFullyLoaded = (0, $cozmU.useCallback)(()=>{
        storeRef.current.fullyLoaded = true;
        fullyLoadedListenersRef.current.forEach((cb_2)=>cb_2({
                type: 'fully-loaded'
            }));
    }, []);
    const isStaticExtension = (0, $cozmU.useCallback)((extensionKey)=>getExtensionKeySets().staticKeys.has(extensionKey), [
        getExtensionKeySets
    ]);
    const isKnownExtension = (0, $cozmU.useCallback)((extensionKey_0)=>getExtensionKeySets().knownKeys.has(extensionKey_0), [
        getExtensionKeySets
    ]);
    const hasMountedBefore = (0, $cozmU.useCallback)((localId_2)=>storeRef.current.lastMountDraftSyncCount.has(localId_2), []);
    const markMounted = (0, $cozmU.useCallback)((localId_3)=>{
        const store_1 = storeRef.current;
        store_1.lastMountDraftSyncCount.set(localId_3, store_1.draftSyncCount);
    }, []);
    const hasDraftSyncedSinceLastMount = (0, $cozmU.useCallback)((localId_4)=>{
        const store_2 = storeRef.current;
        const countAtLastMount = store_2.lastMountDraftSyncCount.get(localId_4);
        return countAtLastMount !== undefined && store_2.draftSyncCount > countAtLastMount;
    }, []);
    const markPresentAtLoad = (0, $cozmU.useCallback)((localId_5)=>{
        storeRef.current.presentAtLoad.add(localId_5);
    }, []);
    const wasPresentAtLoad = (0, $cozmU.useCallback)((localId_6)=>storeRef.current.presentAtLoad.has(localId_6), []);
    const rememberGuestParams = (0, $cozmU.useCallback)((localId_7, serializedGuestParams)=>{
        const lastGuestParams = storeRef.current.lastGuestParams;
        const previous = lastGuestParams.get(localId_7);
        lastGuestParams.set(localId_7, serializedGuestParams);
        return previous;
    }, []);
    const notifyRefetchExhausted = (0, $cozmU.useCallback)((localId_8, attempt)=>{
        if (attempt === 'insertion') storeRef.current.insertionRefetchGaveUp.add(localId_8);
        listenersRef.current.get(localId_8)?.forEach((cb_3)=>cb_3({
                type: 'refetch-exhausted'
            }));
    }, []);
    const refetchTriggerRef = (0, $cozmU.useRef)(null);
    const triggerRefetch = (0, $cozmU.useCallback)((localId_9, attempt_0)=>{
        refetchTriggerRef.current?.(localId_9, attempt_0);
    }, []);
    const setRefetchTrigger = (0, $cozmU.useCallback)((fn)=>{
        refetchTriggerRef.current = fn;
    }, []);
    const draftSyncRequesterRef = (0, $cozmU.useRef)(null);
    const setDraftSyncRequester = (0, $cozmU.useCallback)((fn_0)=>{
        draftSyncRequesterRef.current = fn_0;
    }, []);
    const requestDraftSync = (0, $cozmU.useCallback)(()=>{
        const store_3 = storeRef.current;
        if (store_3.draftSyncRequestScheduled) return;
        store_3.draftSyncRequestScheduled = true;
        queueMicrotask(()=>{
            store_3.draftSyncRequestScheduled = false;
            draftSyncRequesterRef.current?.();
        });
    }, []);
    const deferUntilDraftSync = (0, $cozmU.useCallback)((localId_10, callback)=>{
        const callbacks = storeRef.current.pendingDraftSyncCallbacks;
        const pending = {
            callback: callback,
            registeredAt: performance.now()
        };
        callbacks.set(localId_10, pending);
        return ()=>{
            if (callbacks.get(localId_10) === pending) callbacks.delete(localId_10);
        };
    }, []);
    const notifyDraftSyncCompleted = (0, $cozmU.useCallback)((syncStartedAt)=>{
        const store_4 = storeRef.current;
        store_4.draftSyncCount++;
        const isSyncStartAware = syncStartedAt !== undefined && // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the gate for this change at the developer's request.
        (0, $9wGTI.fg)('forge_static_macros_ux_imp');
        const ready = [];
        store_4.pendingDraftSyncCallbacks.forEach(({ callback: callback_0, registeredAt: registeredAt }, localId_11)=>{
            if (isSyncStartAware && syncStartedAt < registeredAt) return;
            ready.push(callback_0);
            store_4.pendingDraftSyncCallbacks.delete(localId_11);
        });
        if (isSyncStartAware && store_4.pendingDraftSyncCallbacks.size > 0) requestDraftSync();
        ready.forEach((callback_1)=>callback_1());
    }, [
        requestDraftSync
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            storeRef: storeRef,
            subscribe: subscribe,
            register: register,
            registerError: registerError,
            markFullyLoaded: markFullyLoaded,
            isStaticExtension: isStaticExtension,
            isKnownExtension: isKnownExtension,
            hasMountedBefore: hasMountedBefore,
            markMounted: markMounted,
            hasDraftSyncedSinceLastMount: hasDraftSyncedSinceLastMount,
            markPresentAtLoad: markPresentAtLoad,
            wasPresentAtLoad: wasPresentAtLoad,
            rememberGuestParams: rememberGuestParams,
            triggerRefetch: triggerRefetch,
            notifyRefetchExhausted: notifyRefetchExhausted,
            deferUntilDraftSync: deferUntilDraftSync,
            notifyDraftSyncCompleted: notifyDraftSyncCompleted,
            setRefetchTrigger: setRefetchTrigger,
            requestDraftSync: requestDraftSync,
            setDraftSyncRequester: setDraftSyncRequester
        }), [
        storeRef,
        subscribe,
        register,
        registerError,
        markFullyLoaded,
        isStaticExtension,
        isKnownExtension,
        hasMountedBefore,
        markMounted,
        hasDraftSyncedSinceLastMount,
        markPresentAtLoad,
        wasPresentAtLoad,
        rememberGuestParams,
        triggerRefetch,
        notifyRefetchExhausted,
        deferUntilDraftSync,
        notifyDraftSyncCompleted,
        setRefetchTrigger,
        requestDraftSync,
        setDraftSyncRequester
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        value: (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp') ? contextValue : null
    }, children);
}
const $bc133074e939e7bd$export$ae4400d9e980652e = (0, $3u0dr.isReactCompilerActiveV2)() ? function useStaticMacroStoreContext() {
    return (0, $cozmU.useContext)($bc133074e939e7bd$var$StaticMacroStoreContext);
} : function useStaticMacroStoreContext() {
    return (0, $cozmU.useContext)($bc133074e939e7bd$var$StaticMacroStoreContext);
};
const $bc133074e939e7bd$export$519dc241c1a942d0 = (0, $3u0dr.isReactCompilerActiveV2)() ? function ResetStaticMacroStoreContext(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
            value: null
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function ResetStaticMacroStoreContext({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
        value: null
    }, children);
};
module.exports["StaticMacroStoreProvider"] = $bc133074e939e7bd$export$fe63a9c79eca4b07;
module.exports["useStaticMacroStoreContext"] = $bc133074e939e7bd$export$ae4400d9e980652e;
module.exports["ResetStaticMacroStoreContext"] = $bc133074e939e7bd$export$519dc241c1a942d0;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.scrollingElement || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.appendChild(el);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("3vuEo", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $kcIQr = parcelRequire("kcIQr");


var $lW5tg = parcelRequire("lW5tg");


var $ep3mz = parcelRequire("ep3mz");


var $1P7Cq = parcelRequire("1P7Cq");

const $e701977e7769884e$var$MeasuredForgeMacro = (0, $3u0dr.isReactCompilerActiveV2)() ? function MeasuredForgeMacro(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { extensionKey: extensionKey, children: children } = t0;
    const elementRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId } = t1;
    const isSSROrHydrating = (0, $1P7Cq.useIsSSROrHydrating)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    let t2;
    if ($[0] !== createEvent || $[1] !== extensionKey || $[2] !== isSSROrHydrating) {
        t2 = ()=>{
            const element = elementRef.current;
            if (!element || isSSROrHydrating) return;
            return (0, $lW5tg.observeContentMacroDimensions)(element, "forge", extensionKey, (t3)=>{
                const { height: height, width: width } = t3;
                createEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "forgeMacroRenderer",
                        action: "render",
                        actionSubject: "forgeMacro",
                        attributes: {
                            extensionKey: extensionKey,
                            height: height,
                            width: width
                        }
                    }
                }).fire();
            });
        };
        $[0] = createEvent;
        $[1] = extensionKey;
        $[2] = isSSROrHydrating;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== contentId || $[5] !== createEvent || $[6] !== extensionKey || $[7] !== isSSROrHydrating) {
        t3 = [
            contentId,
            extensionKey,
            isSSROrHydrating,
            createEvent
        ];
        $[4] = contentId;
        $[5] = createEvent;
        $[6] = extensionKey;
        $[7] = isSSROrHydrating;
        $[8] = t3;
    } else t3 = $[8];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: elementRef
        }, children);
        $[9] = children;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function MeasuredForgeMacro({ extensionKey: extensionKey, children: children }) {
    const elementRef = (0, $cozmU.useRef)(null);
    const [{ contentId: contentId }] = (0, $ep3mz.usePageState)();
    const isSSROrHydrating = (0, $1P7Cq.useIsSSROrHydrating)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || isSSROrHydrating) return;
        return (0, $lW5tg.observeContentMacroDimensions)(element, 'forge', extensionKey, ({ height: height, width: width })=>{
            createEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'forgeMacroRenderer',
                    action: 'render',
                    actionSubject: 'forgeMacro',
                    attributes: {
                        extensionKey: extensionKey,
                        height: height,
                        width: width
                    }
                }
            }).fire();
        });
    }, [
        contentId,
        extensionKey,
        isSSROrHydrating,
        createEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: elementRef
    }, children);
};
function $e701977e7769884e$export$8c6fe207fa6bd8f9(isEditing) {
    return !isEditing && (0, $lW5tg.getContentMacroMeasurementScope)().forge;
}
const $e701977e7769884e$export$7092560617ba9fd4 = (0, $3u0dr.isReactCompilerActiveV2)() ? function ForgeMacroMeasurements(props) {
    const $ = (0, $bDgLe.c)(4);
    if (props.nodeType !== "extension" && props.nodeType !== "bodiedExtension" || !props.extensionKey || !$e701977e7769884e$export$8c6fe207fa6bd8f9(props.isEditing)) {
        let t0;
        if ($[0] !== props.children) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
            $[0] = props.children;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e701977e7769884e$var$MeasuredForgeMacro, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : function ForgeMacroMeasurements(props) {
    if (props.nodeType !== 'extension' && props.nodeType !== 'bodiedExtension' || !props.extensionKey || !$e701977e7769884e$export$8c6fe207fa6bd8f9(props.isEditing)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e701977e7769884e$var$MeasuredForgeMacro, props);
};
module.exports["ForgeMacroMeasurements"] = $e701977e7769884e$export$7092560617ba9fd4;

});

parcelRegister("huSww", function(module, exports) {
/* ForgeMacro.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $9wGTI = parcelRequire("9wGTI");


var $1XIV5 = parcelRequire("1XIV5");


var $6m0us = parcelRequire("6m0us");

const $689e73fff1c3c213$var$spinnerWrapperStyles = null; // How long a newly inserted macro waits for its insertion to be saved before falling back to the iframe.
const $689e73fff1c3c213$export$2f424e2ddf9f9c81 = 30000;
const $689e73fff1c3c213$export$9b14103f777dfdef = 30000;
function $689e73fff1c3c213$var$getNestedMacroLocalIds(node) {
    const localIds = new Set();
    const visit = (nodes)=>{
        const childNodes = Array.isArray(nodes) ? nodes : typeof nodes === 'object' && nodes !== null && Array.isArray(nodes.content) ? nodes.content : [];
        childNodes.forEach((child)=>{
            const type = typeof child.type === 'string' ? child.type : child.type?.name;
            if ([
                'extension',
                'bodiedExtension',
                'inlineExtension'
            ].includes(type)) {
                const localId = child.localId ?? child.attrs?.localId ?? child.parameters?.localId ?? child.attrs?.parameters?.localId;
                if (localId) localIds.add(localId);
            }
            visit(child.content);
        });
    };
    visit(node?.content);
    return Array.from(localIds);
}
function $689e73fff1c3c213$export$7914a38f4e6c4db9(isEditing, isLivePage) {
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) return undefined;
    return (node, renderFn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689e73fff1c3c213$export$4dada8c8c9499dbf, {
            ...$689e73fff1c3c213$export$f7f0bb6d998169d8(node),
            renderIframe: ()=>renderFn({
                    references: []
                }),
            isEditing: isEditing,
            isLivePage: isLivePage
        });
} /** The `ForgeMacro` props derived from an ADF extension node, shared by every handler that renders it. */ 
function $689e73fff1c3c213$export$f7f0bb6d998169d8(node) {
    // Untouched Connect macros keep extensionType `com.atlassian.confluence.macro.core` and are
    // keyed in `confluence_staticMacros` by `parameters.macroMetadata.macroId`, not `localId`.
    const isConnectShapedNode = node?.extensionType === 'com.atlassian.confluence.macro.core';
    return {
        localId: isConnectShapedNode ? node?.parameters?.macroMetadata?.macroId?.value : node?.localId ?? node?.parameters?.localId,
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        extensionKey: node?.extensionKey?.split('/').at(-1),
        guestParams: node?.parameters?.guestParams || node?.parameters?.config,
        isConnectShapedNode: isConnectShapedNode,
        nestedMacroLocalIds: $689e73fff1c3c213$var$getNestedMacroLocalIds(node)
    };
}
function $689e73fff1c3c213$export$4dada8c8c9499dbf({ localId: localId, extensionKey: extensionKey, guestParams: guestParams, renderIframe: renderIframe, isEditing: isEditing, isLivePage: isLivePage, isConnectShapedNode: isConnectShapedNode, nestedMacroLocalIds: nestedMacroLocalIds = [], preloadedHtml: preloadedHtml }) {
    const ctx = (0, $6m0us.useStaticMacroStoreContext)();
    const store = ctx?.storeRef.current;
    const [, forceUpdate] = (0, $cozmU.useReducer)((n)=>n + 1, 0);
    const [isRefetching, setIsRefetching] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const readyEventEmittedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false); // Check if this extension supports staticView, based on preloaded extension data.
    // extensionsLoaded is true when __SSR_FORGE_EXTENSIONS__ has been populated.
    //
    // Native Forge extensions resolve via their own extensionKey (ctx.isStaticExtension).
    // Connect-shaped nodes resolve against the SAME preloaded data using their legacy
    // extensionKey — matched either via the adopted extension's own key (same-key adoption)
    // or its migratedFrom aliases (different-key adoption) — so a Connect-shaped node whose
    // adopted extension is confirmed non-static can fall back to the iframe immediately, once
    // extensions have loaded, without waiting for the bulk staticMacros query at all.
    //
    // If no match is found yet (extensions not loaded, or genuinely unrecognized), treat the
    // node as "maybe static" and rely on store.fullyLoaded below: a Connect-shaped node is
    // never newly inserted, so a missing static result once the bulk query completes means it
    // isn't static.
    const isKnownStaticExtension = !!extensionKey && !!ctx?.isStaticExtension(extensionKey);
    const isKnownNonStaticExtension = !!isConnectShapedNode && !!extensionKey && !!ctx?.isKnownExtension(extensionKey) && !isKnownStaticExtension;
    const hasStaticResult = !!localId && (!!store?.html.has(localId) || !!store?.errors.has(localId));
    const mightBeStaticConnectMacro = !!isConnectShapedNode && !isKnownNonStaticExtension && (!store?.fullyLoaded || hasStaticResult);
    const isStatic = isKnownStaticExtension || mightBeStaticConnectMacro;
    const extensionsLoaded = !!window.__SSR_FORGE_EXTENSIONS__?.['xen:macro']?.extensions?.length;
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId) return;
        const handleUpdate = ({ type: type })=>{
            // Only an update for this macro completes a refetch. Bulk-query completion must not end a
            // pending refetch started by a parameter change.
            if (type !== 'fully-loaded') setIsRefetching(false);
            forceUpdate();
        };
        const unsubscribe = ctx.subscribe(localId, handleUpdate); // Data may have already arrived before we subscribed — check immediately.
        if (store?.html.has(localId) || store?.errors.has(localId)) handleUpdate({
            type: 'static-macro-result'
        });
        else if (store?.fullyLoaded) handleUpdate({
            type: 'fully-loaded'
        });
        return unsubscribe;
    }, [
        ctx,
        localId,
        forceUpdate,
        store
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (ctx && localId && !ctx.storeRef.current?.fullyLoaded) ctx.markPresentAtLoad(localId);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // The bridge sends one request and, if it brings back no HTML, one retry. The spinner stops when
    // either returns a result or both come back empty.
    const startPostEditRefetch = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!ctx || !localId) return;
        setIsRefetching(true);
        ctx.triggerRefetch(localId, 'edit');
    }, [
        ctx,
        localId
    ]);
    const deferPostEditRefetchUntilDraftSync = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!ctx || !localId) return undefined;
        return ctx.deferUntilDraftSync(localId, startPostEditRefetch);
    }, [
        ctx,
        localId,
        startPostEditRefetch
    ]);
    const showSpinnerAndDeferRefetchUntilDraftSync = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!ctx || !localId) return undefined;
        setIsRefetching(true);
        const spinnerTimeoutId = setTimeout(()=>setIsRefetching(false), $689e73fff1c3c213$export$9b14103f777dfdef);
        const removeDeferredRefetch = ctx.deferUntilDraftSync(localId, ()=>{
            clearTimeout(spinnerTimeoutId);
            startPostEditRefetch();
        });
        ctx.requestDraftSync();
        return ()=>{
            removeDeferredRefetch();
            clearTimeout(spinnerTimeoutId);
        };
    }, [
        ctx,
        localId,
        startPostEditRefetch
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic) return undefined;
        if (!isEditing || !isLivePage) return undefined;
         // Editors can remount node views without any change, e.g. while loading. Only a remount after
        // a draft sync, such as finishing a body edit, means the macro may have changed.
        const isRemountAfterDraftSync = ctx.hasMountedBefore(localId) && ctx.hasDraftSyncedSinceLastMount(localId);
        ctx.markMounted(localId);
        if (!isRemountAfterDraftSync) return undefined;
        if (nestedMacroLocalIds.length > 0) {
            startPostEditRefetch();
            return undefined;
        }
        const removeDeferredRefetch = deferPostEditRefetchUntilDraftSync(); // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the gate for this change at the developer's request.
        if ((0, $9wGTI.fg)('forge_static_macros_ux_imp')) ctx.requestDraftSync();
        return removeDeferredRefetch; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const guestParamsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(undefined);
    const serializedGuestParams = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>JSON.stringify(guestParams ?? null), [
        guestParams
    ]);
    const errorCode = localId ? store?.errors.get(localId) : undefined;
    const html = (localId ? store?.html.get(localId) : undefined) ?? (localId && errorCode === undefined ? preloadedHtml : undefined);
    const resultMetadata = localId ? store?.resultMetadata.get(localId) : undefined;
    (0, $1XIV5.useStaticMacroRenderAnalytics)({
        html: html,
        errorCode: errorCode,
        result: resultMetadata,
        isEditing: Boolean(isEditing),
        isLivePage: Boolean(isLivePage)
    }); // Signal cc-puppeteer that this static macro has finished rendering.
    // cc-puppeteer's waitForAllExtensionReadyEvents() waits for EXTENSION_READY from every
    // Forge extension it finds in the ADF (regardless of emitsReadyEvent manifest declaration).
    // Without this signal, the full 10s timeout is consumed on every PDF export with a static macro.
    // Guarded by a ref so it only fires once per ForgeMacro instance.
    (0, $cozmU.useEffect)(()=>{
        if (html && localId && !readyEventEmittedRef.current) {
            readyEventEmittedRef.current = true;
            window.postMessage({
                source: 'forge-extension',
                type: 'EXTENSION_READY',
                localId: localId
            }, window.location.origin);
        }
    }, [
        html,
        localId
    ]); // When a config changes, we want to trigger a re-render.
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic || !isEditing) return undefined;
        const serialized = serializedGuestParams; // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the gate for this change at the developer's request.
        if ((0, $9wGTI.fg)('forge_static_macros_ux_imp')) {
            const prev = ctx.rememberGuestParams(localId, serialized); // Skip on first render for this macro instance — only refetch on subsequent changes.
            if (prev === undefined || prev === serialized) return undefined; // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- The rule only detects cleanups returned at the top level of the effect.
            return showSpinnerAndDeferRefetchUntilDraftSync();
        } else {
            const prev = guestParamsRef.current;
            guestParamsRef.current = serialized; // Skip on first render for this macro instance — only refetch on subsequent changes.
            if (prev === undefined || prev === serialized) return undefined; // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- The rule only detects cleanups returned at the top level of the effect.
            return deferPostEditRefetchUntilDraftSync();
        }
    }, [
        ctx,
        localId,
        isStatic,
        isEditing,
        serializedGuestParams,
        deferPostEditRefetchUntilDraftSync,
        showSpinnerAndDeferRefetchUntilDraftSync
    ]);
    const isFullyLoaded = !!store?.fullyLoaded;
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic || !isEditing) return undefined;
        if (!isFullyLoaded) return undefined;
        if (html !== undefined || errorCode !== undefined) return undefined; // Macros that were on the page when it loaded weren't inserted. Without a result, they're not static.
        if (ctx.wasPresentAtLoad(localId)) return undefined;
        const currentStore = ctx.storeRef.current;
        if (!currentStore || currentStore.insertionRefetchGaveUp.has(localId) || currentStore.insertionRefetchStarted.has(localId)) return undefined;
         // Don't request anything until the insertion has been saved. If the request and its retry come
        // back empty, the store marks the insertion as given up.
        const giveUpTimeoutId = setTimeout(()=>{
            currentStore.insertionRefetchGaveUp.add(localId);
            forceUpdate();
        }, $689e73fff1c3c213$export$2f424e2ddf9f9c81);
        const removeDeferredRefetch = ctx.deferUntilDraftSync(localId, ()=>{
            clearTimeout(giveUpTimeoutId);
            currentStore.insertionRefetchStarted.add(localId);
            ctx.triggerRefetch(localId, 'insertion');
        }); // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the gate for this change at the developer's request.
        if ((0, $9wGTI.fg)('forge_static_macros_ux_imp')) ctx.requestDraftSync();
        return ()=>{
            removeDeferredRefetch();
            clearTimeout(giveUpTimeoutId);
        };
    }, [
        ctx,
        localId,
        isStatic,
        isEditing,
        isFullyLoaded,
        html,
        errorCode,
        forceUpdate
    ]);
    if (!ctx || !localId || !store) return renderIframe();
    if (isRefetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }));
    if (html) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "forge-static-macro-content",
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
    if (errorCode) return renderIframe();
     // Once the query is fully loaded, any macro without html/error is not a static macro → iframe.
    // Also fall back immediately if we KNOW this extension doesn't support staticView —
    // only treat !isStatic as definitive when extensions have actually been loaded.
    // If extensions aren't loaded yet, show spinner and wait (preloader may still be in-flight).
    const isAwaitingInsertedContent = isStatic && isEditing && !ctx.wasPresentAtLoad(localId) && !store.insertionRefetchGaveUp.has(localId);
    if ((store.fullyLoaded || extensionsLoaded && !isStatic) && !isAwaitingInsertedContent) return renderIframe();
     // Extension supports staticView but data hasn't arrived yet — show spinner briefly.
    // Use the same testid as the iframe loader so cc-puppeteer waits for it to disappear.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "forge-app-loading-spinner",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }));
}
module.exports["createForgeMacroExtensionHandler"] = $689e73fff1c3c213$export$7914a38f4e6c4db9;
module.exports["ForgeMacro"] = $689e73fff1c3c213$export$4dada8c8c9499dbf;
module.exports["getForgeMacroNodeProps"] = $689e73fff1c3c213$export$f7f0bb6d998169d8;

});

parcelRegister("1XIV5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");

const $a0009ac6b88376d4$export$b3b7b4b4f7dc8ee9 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useStaticMacroRenderAnalytics(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { html: html, errorCode: errorCode, result: result, isEditing: isEditing, isLivePage: isLivePage } = t0;
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
    } else t1 = $[0];
    const reportedResultVersionsRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== createEvent || $[2] !== html || $[3] !== isEditing || $[4] !== isLivePage || $[5] !== result) {
        t2 = ()=>{
            if (!html || !result || reportedResultVersionsRef.current.has(result.version)) return;
            reportedResultVersionsRef.current.add(result.version);
            createEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "forgeStaticMacro",
                    action: "rendered",
                    actionSubject: "staticMacro",
                    attributes: {
                        attempt: result.attempt,
                        renderMode: "static",
                        isEditing: isEditing,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        t3 = [
            createEvent,
            html,
            isEditing,
            isLivePage,
            result
        ];
        $[1] = createEvent;
        $[2] = html;
        $[3] = isEditing;
        $[4] = isLivePage;
        $[5] = result;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== createEvent || $[9] !== errorCode || $[10] !== html || $[11] !== isEditing || $[12] !== isLivePage || $[13] !== result) {
        t4 = ()=>{
            if (!errorCode || html || !result || reportedResultVersionsRef.current.has(result.version)) return;
            reportedResultVersionsRef.current.add(result.version);
            createEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "forgeStaticMacro",
                    action: "failed",
                    actionSubject: "staticMacro",
                    attributes: {
                        attempt: result.attempt,
                        renderMode: "iframe-fallback",
                        errorCode: errorCode,
                        isEditing: isEditing,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        t5 = [
            createEvent,
            errorCode,
            html,
            isEditing,
            isLivePage,
            result
        ];
        $[8] = createEvent;
        $[9] = errorCode;
        $[10] = html;
        $[11] = isEditing;
        $[12] = isLivePage;
        $[13] = result;
        $[14] = t4;
        $[15] = t5;
    } else {
        t4 = $[14];
        t5 = $[15];
    }
    (0, $cozmU.useEffect)(t4, t5);
} : function useStaticMacroRenderAnalytics({ html: html, errorCode: errorCode, result: result, isEditing: isEditing, isLivePage: isLivePage }) {
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const reportedResultVersionsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!html || !result || reportedResultVersionsRef.current.has(result.version)) return;
        reportedResultVersionsRef.current.add(result.version);
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'forgeStaticMacro',
                action: 'rendered',
                actionSubject: 'staticMacro',
                attributes: {
                    attempt: result.attempt,
                    renderMode: 'static',
                    isEditing: isEditing,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        createEvent,
        html,
        isEditing,
        isLivePage,
        result
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!errorCode || html || !result || reportedResultVersionsRef.current.has(result.version)) return;
        reportedResultVersionsRef.current.add(result.version);
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'forgeStaticMacro',
                action: 'failed',
                actionSubject: 'staticMacro',
                attributes: {
                    attempt: result.attempt,
                    renderMode: 'iframe-fallback',
                    errorCode: errorCode,
                    isEditing: isEditing,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        createEvent,
        errorCode,
        html,
        isEditing,
        isLivePage,
        result
    ]);
};
module.exports["useStaticMacroRenderAnalytics"] = $a0009ac6b88376d4$export$b3b7b4b4f7dc8ee9;

});

parcelRegister("2HGN8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $g6QPm = parcelRequire("g6QPm");


var $6mKj3 = parcelRequire("6mKj3");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");


var $iWKHx = parcelRequire("iWKHx");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $cozmU.useState)();
    // Clear the override state when navigating to a different page
    (0, $cozmU.useEffect)(()=>{
        setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const editorWidth = metadata?.editorWidth;
            const widthValue = editorWidth?.value;
            const version = editorWidth?.version;
            if (widthValue && version !== undefined) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
  	Previous check was:
  	const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
  	which always returns contentAppearanceQuery
  */ const contentAppearanceFragmentResult = (0, $iWKHx.useContentAppearanceFragment)({
        contentId: contentId
    });
    const contentAppearanceQueryResult = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? (0, $g6QPm.createEditorContentUnifiedQueryVariables)({
            contentId: contentId
        }) : {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        skip: contentAppearanceFragmentResult.isProvided,
        __callerPackage__: "content-appearance"
    });
    // The query error is not read here, so a field error only reads as no data.
    const { data: initialContentAppearanceData } = contentAppearanceFragmentResult.isProvided ? contentAppearanceFragmentResult : contentAppearanceQueryResult;
    const initialContentAppearanceLoading = contentAppearanceFragmentResult.isLoading || contentAppearanceQueryResult.loading;
    const context = (0, $cozmU.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        // Under certain circumstances due to a previous bug with the content appearance during legacy editor autoconvert, an incorrect value may have been sent to collab service.
        // In this circumstance favour the initial content appearance value.
        const shouldUseInitial = contentAppearanceOverride && initialContentAppearance && contentAppearanceOverride.version === initialContentAppearance.version && contentAppearanceOverride.appearance !== initialContentAppearance.appearance;
        return {
            contentAppearance: shouldUseInitial ? initialContentAppearance : contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $cozmU.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("iWKHx", function(module, exports) {

var $du0Wl = parcelRequire("du0Wl");


var $hX2PJ = parcelRequire("hX2PJ");

// contentAppearanceQuery's selection for EditorContentUnifiedQuery; same fields and arguments, so
// both share the store records.
const $601c9a426bba81df$var$contentAppearanceFragmentNode = (0, $du0Wl.default);
function $601c9a426bba81df$export$b18453d9384e8a39({ contentId: contentId }) {
    return (0, $hX2PJ.useEditorContentFragment)('contentAppearanceFragment', $601c9a426bba81df$var$contentAppearanceFragmentNode, {
        contentId: contentId,
        mapData: (value)=>({
                content: {
                    nodes: [
                        value
                    ]
                }
            })
    });
}
module.exports["useContentAppearanceFragment"] = $601c9a426bba81df$export$b18453d9384e8a39;

});

parcelRegister("du0Wl", function(module, exports) {
/**
 * @generated SignedSource<<87be75ee1cfa743bf5cd7e035cd8d377>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a49da7a6e3bc95e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "catchTo": "RESULT"
        },
        "name": "useContentAppearanceFragment_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "appearanceDraft",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "content-appearance-draft"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(key:\"content-appearance-draft\")"
            }
        ],
        "type": "Content"
    };
}();
$2a49da7a6e3bc95e$var$node.hash = "c645e0efb6456131245a0289a6ac421a";
var $2a49da7a6e3bc95e$export$2e2bcd8739ae039 = $2a49da7a6e3bc95e$var$node;
module.exports["default"] = $2a49da7a6e3bc95e$export$2e2bcd8739ae039;

});

parcelRegister("2zdC2", function(module, exports) {
"use strict";
var $1de968d0bde0a175$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $1de968d0bde0a175$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $1de968d0bde0a175$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $1de968d0bde0a175$var$debounceTime;
var $1de968d0bde0a175$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1de968d0bde0a175$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1de968d0bde0a175$var$DebounceTimeSubscriber = function(_super) {
    $1de968d0bde0a175$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($1de968d0bde0a175$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($fNVRJ.Subscriber);
function $1de968d0bde0a175$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
} //# sourceMappingURL=debounceTime.js.map

});

parcelRegister("6O2BV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f497007dae01ffa$export$25fb473e92ff8332 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PT7yD",
    name: "ClassicEditorContextProviderLoader",
    loader: ()=>(parcelRequire("aMoQ6"))
});
module.exports["ClassicEditorContextProviderLoader"] = $4f497007dae01ffa$export$25fb473e92ff8332;

});

parcelRegister("aMoQ6", function(module, exports) {

let $7d91a7ad173d0529$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7d91a7ad173d0529$var$load("el1U6"),
    $7d91a7ad173d0529$var$load("2yyll"),
    $7d91a7ad173d0529$var$load("7I4uK"),
    $7d91a7ad173d0529$var$load("hUbK8"),
    $7d91a7ad173d0529$var$load("lOHjt"),
    $7d91a7ad173d0529$var$load("8N4VU"),
    $7d91a7ad173d0529$var$load("bqdgP"),
    $7d91a7ad173d0529$var$load("f7eY1"),
    $7d91a7ad173d0529$var$load("kedWY"),
    $7d91a7ad173d0529$var$load("9cVML"),
    $7d91a7ad173d0529$var$load("giX30"),
    $7d91a7ad173d0529$var$load("lUYNi"),
    $7d91a7ad173d0529$var$load("7SteV"),
    $7d91a7ad173d0529$var$load("ennNB"),
    $7d91a7ad173d0529$var$load("9Hr92"),
    $7d91a7ad173d0529$var$load("eUsnQ"),
    $7d91a7ad173d0529$var$load("khIi2"),
    $7d91a7ad173d0529$var$load("eEjUf"),
    $7d91a7ad173d0529$var$load("3pkSd"),
    $7d91a7ad173d0529$var$load("5ax2I"),
    $7d91a7ad173d0529$var$load("5KWjU"),
    $7d91a7ad173d0529$var$load("4WVf0"),
    $7d91a7ad173d0529$var$load("epyZS"),
    $7d91a7ad173d0529$var$load("532dz"),
    $7d91a7ad173d0529$var$load("DsM5z"),
    $7d91a7ad173d0529$var$load("lyagC"),
    $7d91a7ad173d0529$var$load("frgRG"),
    $7d91a7ad173d0529$var$load("cGkFm"),
    $7d91a7ad173d0529$var$load("2jERw"),
    $7d91a7ad173d0529$var$load("b7144"),
    $7d91a7ad173d0529$var$load("a7sEM"),
    $7d91a7ad173d0529$var$load("caMoT"),
    $7d91a7ad173d0529$var$load("a6kGP"),
    $7d91a7ad173d0529$var$load("dB5kj"),
    $7d91a7ad173d0529$var$load("jNr09"),
    $7d91a7ad173d0529$var$load("9xmQ5"),
    $7d91a7ad173d0529$var$load("ihRIc"),
    $7d91a7ad173d0529$var$load("9LDVS"),
    $7d91a7ad173d0529$var$load("kiMHu"),
    $7d91a7ad173d0529$var$load("7J1PC"),
    $7d91a7ad173d0529$var$load("446Ip"),
    $7d91a7ad173d0529$var$load("g7Yjk"),
    $7d91a7ad173d0529$var$load("aqs28"),
    $7d91a7ad173d0529$var$load("gFeoL"),
    $7d91a7ad173d0529$var$load("bJbqV"),
    $7d91a7ad173d0529$var$load("hLB9K"),
    $7d91a7ad173d0529$var$load("le1z7"),
    $7d91a7ad173d0529$var$load("4xsdA"),
    $7d91a7ad173d0529$var$load("ejk86"),
    $7d91a7ad173d0529$var$load("9TOep"),
    $7d91a7ad173d0529$var$load("bSSct"),
    $7d91a7ad173d0529$var$load("lUBBr"),
    $7d91a7ad173d0529$var$load("iYvvi"),
    $7d91a7ad173d0529$var$load("eWXZF"),
    $7d91a7ad173d0529$var$load("isVeA"),
    $7d91a7ad173d0529$var$load("6wr18"),
    $7d91a7ad173d0529$var$load("ffEVr"),
    $7d91a7ad173d0529$var$load("7gPXS"),
    $7d91a7ad173d0529$var$load("91v6x"),
    $7d91a7ad173d0529$var$load("g5INx"),
    $7d91a7ad173d0529$var$load("fWCBZ"),
    $7d91a7ad173d0529$var$load("45r7q"),
    $7d91a7ad173d0529$var$load("hhss7"),
    $7d91a7ad173d0529$var$load("hEkNB"),
    $7d91a7ad173d0529$var$load("dP7Qm"),
    $7d91a7ad173d0529$var$load("aAWLw"),
    $7d91a7ad173d0529$var$load("7EorR"),
    $7d91a7ad173d0529$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});

parcelRegister("dmKyV", function(module, exports) {
$parcel$export(module.exports, "WRM", () => (parcelRequire("1UB3e")).default);
$parcel$export(module.exports, "withWRMDependencies", () => (parcelRequire("6u5YI")).default);

var $1UB3e = parcelRequire("1UB3e");


var $6u5YI = parcelRequire("6u5YI");


});

parcelRegister("1UB3e", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 */ const $1647c2fd90c2cc68$var$WRM = {
    require (dependencies, callback) {
        return new Promise((resolve)=>{
            (0, $cpjd2.requireLegacyWRM)(dependencies, (modules)=>{
                resolve(modules);
                if (callback) callback(modules);
            }, ()=>{});
        });
    }
};
var $1647c2fd90c2cc68$export$2e2bcd8739ae039 = $1647c2fd90c2cc68$var$WRM;
module.exports["default"] = $1647c2fd90c2cc68$export$2e2bcd8739ae039;

});

parcelRegister("6u5YI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 *
 * withWRMDependencies is a decorator for loading WRM dependencies.
 *
 * It's a helper which besides loading dependencies will also hide the component
 * while the dependencies are not loaded avoiding FOUC and weird behaviours.
 *
 * usage:
 *
 * withWRMDependencies('wr!mypluginkey')(
 *  class MyComponent extends Component {}
 * )
 *
 * or
 *
 * withWRMDependencies(['wrc!myContext', 'wr!myWebResource'])(
 *  class MyComponent extends Component {}
 * )
 */ function $4b8a2e9a57493429$var$withWRMDependencies(dependencies, options) {
    const configs = {
        isBlocking: true,
        ...options
    };
    return (BaseComponent)=>{
        class WRMComponent extends (0, $cozmU.Component) {
            componentDidMount() {
                this.mounted = true;
                if (dependencies && dependencies.length > 0) (0, $cpjd2.requireLegacyWRM)(dependencies, this.markAsLoaded, ()=>{});
                else this.markAsLoaded();
            }
            componentWillUnmount() {
                this.mounted = false;
            }
            render() {
                const { dependenciesLoaded: dependenciesLoaded } = this.state;
                if (dependenciesLoaded || !configs.isBlocking) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BaseComponent, {
                    ...this.props,
                    wrmDependenciesLoaded: dependenciesLoaded
                });
                else return null;
            }
            constructor(...args){
                super(...args);
                this.state = {
                    dependenciesLoaded: false
                };
                this.markAsLoaded = ()=>{
                    if (this.mounted) this.setState({
                        dependenciesLoaded: true
                    });
                };
            }
        }
        WRMComponent.displayName = `WRMComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return WRMComponent;
    };
}
var $4b8a2e9a57493429$export$2e2bcd8739ae039 = $4b8a2e9a57493429$var$withWRMDependencies;
module.exports["default"] = $4b8a2e9a57493429$export$2e2bcd8739ae039;

});


//# sourceMappingURL=Renderer.661c2c8b.js.map
